//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ToastMessageOptions } from "primevue/toast"
import DialogContent, { openDialog, openLoginDialog } from "@/models"
import { appAuth } from "../src/auth/appAuth"
import { EventBus } from "@/eventBus"
import { oktaAuth } from "../src/auth/oktaAuth";
import { SystemToastOptions } from "@/composables/toaster";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiClientBase {
    /**
     * authorization token value
     */

    public token: string
    private static pendingRequests: Map<string, any> = new Map()
    private static isReAuthenticating = false

    constructor() {}

    protected transformOptions(options: any) {
        const token = localStorage.getItem("token")
        if (token) {
            options.headers["Authorization"] = "bearer " + token
        }
        options.headers["X-User-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone

        // Store the original request for potential retry
        const requestId = `${options.method || 'GET'}_${Date.now()}_${Math.random()}`
        options.requestId = requestId
        ApiClientBase.pendingRequests.set(requestId, { options, timestamp: Date.now() })

        EventBus.emit("IncrementApiCalls")

        return Promise.resolve(options).catch((err: any) => {
            console.log("Caught error:", err)
        })
    }

    protected async transformResult(url: string, response: any, processor: (response: Response) => any) {
        EventBus.emit("DecrementApiCalls")

        if (response.status != 200 && response.status != 204 && response.status != 409 && response.status != 401 && response.status != 400) {
            EventBus.emit("APIError", {
                status: response.status,
                message: response.statusText,
            })
            // let dialog = new DialogContent()
            // dialog.header = `${response.status}:${response.statusText}`
            // console.log("error response", response.request.responseText)
            // console.log("error", response)

            // dialog.content = `Please send a screenshot to support
            // ${response.request.responseURL}

            // `
            // openDialog(dialog)
        }

        if (response.status == 401) {
            // Check if we have user session data - if yes, they were logged in but token expired
            const hasUserSession = localStorage.getItem("PersonSessionData")
            
            if (!ApiClientBase.isReAuthenticating) {
                if (hasUserSession) {
                    // User was logged in but token is missing or expired - show re-auth modal
                    ApiClientBase.isReAuthenticating = true
                    
                    // Show the re-authentication modal
                    EventBus.emit("show-reauth-modal")
                    
                    // Listen for successful re-authentication
                    return new Promise((resolve, reject) => {
                        const handleReAuthComplete = () => {
                            ApiClientBase.isReAuthenticating = false
                            // Clean up old requests (older than 5 minutes)
                            const fiveMinutesAgo = Date.now() - 300000
                            for (const [key, value] of ApiClientBase.pendingRequests.entries()) {
                                if (value.timestamp < fiveMinutesAgo) {
                                    ApiClientBase.pendingRequests.delete(key)
                                }
                            }
                            EventBus.off('reauth-completed', handleReAuthComplete)
                            // Return a special response to trigger retry
                            resolve({ status: 401, retry: true })
                        }
                        
                        EventBus.on('reauth-completed', handleReAuthComplete)
                    })
                } else {
                    // No session at all - user needs to do full login
                    let options:ToastMessageOptions & { callback?: () => void } ={
                        summary: "Authentication Required",
                        detail: "Please log in to access this resource.",
                        severity: "error",
                        life: 60000,
                    }
                    
                    options.callback = () => {
                        sessionStorage.clear()
                        localStorage.removeItem("token")
                        localStorage.removeItem("PersonSessionData")
                        window.location.href = "/login"
                    }

                    EventBus.emit("systemToast", options)
                }
            }
        }
        return processor(response)
    }
}

export interface IAppSettingClient {
    /**
     * @return OK
     */
    getConsumerEndOfLifeWithOldLogic( cancelToken?: CancelToken): Promise<ProcessWaste[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    fixConsumerEndOfLifeWithOldLogic(body: ProcessWaste | undefined,  cancelToken?: CancelToken): Promise<ProcessWaste>;
    /**
     * @param projectId (optional) 
     * @param subProjectId (optional) 
     * @param assessmentId (optional) 
     * @param skillAreadId (optional) 
     * @return OK
     */
    fixAllProcessWaste(projectId: string | undefined, subProjectId: string | undefined, assessmentId: string | undefined, skillAreadId: string | undefined,  cancelToken?: CancelToken): Promise<ProcessWasteStatusStep[]>;
    /**
     * @param assessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @param region (optional) 
     * @return OK
     */
    populateProcessWasteProcess(assessmentId: string | undefined, generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, region: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param projectId (optional) 
     * @param subProjectId (optional) 
     * @param assessmentId (optional) 
     * @param skillAreadId (optional) 
     * @return OK
     */
    checkProcessWasteStatus(projectId: string | undefined, subProjectId: string | undefined, assessmentId: string | undefined, skillAreadId: string | undefined,  cancelToken?: CancelToken): Promise<ProcessWasteStatusStep[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    fixSingleIntermediate(body: FixSingleIntermediateFromUI | undefined,  cancelToken?: CancelToken): Promise<FixSingleIntermediateFromUI>;
    /**
     * @param body (optional) 
     * @return OK
     */
    fixTheIntermediate(body: IntermediateStatusStep[] | undefined,  cancelToken?: CancelToken): Promise<IntermediateStatusStep[]>;
    /**
     * @return OK
     */
    getAllUISettings( cancelToken?: CancelToken): Promise<TemplateUI[]>;
    /**
     * @return OK
     */
    getDefaultUISettings( cancelToken?: CancelToken): Promise<TemplateUI>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getOneUISettings(id: string | undefined,  cancelToken?: CancelToken): Promise<TemplateUI>;
    /**
     * @param body (optional) 
     * @return OK
     */
    setAllUISettings(body: TemplateUI | undefined,  cancelToken?: CancelToken): Promise<TemplateUI>;
    /**
     * @param projectId (optional) 
     * @param subProjectId (optional) 
     * @param assessmentId (optional) 
     * @param skillAreadId (optional) 
     * @return OK
     */
    checkIntermediateStatus(projectId: string | undefined, subProjectId: string | undefined, assessmentId: string | undefined, skillAreadId: string | undefined,  cancelToken?: CancelToken): Promise<IntermediateStatusStep[]>;
}

export class AppSettingClient extends ApiClientBase implements IAppSettingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getConsumerEndOfLifeWithOldLogic( cancelToken?: CancelToken): Promise<ProcessWaste[]> {
        let url_ = this.baseUrl + "/api/appSetting/getConsumerEndOfLifeWithOldLogic";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetConsumerEndOfLifeWithOldLogic(_response));
        });
    }

    protected processGetConsumerEndOfLifeWithOldLogic(response: AxiosResponse): Promise<ProcessWaste[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessWaste.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProcessWaste[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessWaste[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fixConsumerEndOfLifeWithOldLogic(body: ProcessWaste | undefined, cancelToken?: CancelToken): Promise<ProcessWaste> {
        let url_ = this.baseUrl + "/api/appSetting/fixConsumerEndOfLifeWithOldLogic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFixConsumerEndOfLifeWithOldLogic(_response));
        });
    }

    protected processFixConsumerEndOfLifeWithOldLogic(response: AxiosResponse): Promise<ProcessWaste> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessWaste.fromJS(resultData200);
            return Promise.resolve<ProcessWaste>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessWaste>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param subProjectId (optional) 
     * @param assessmentId (optional) 
     * @param skillAreadId (optional) 
     * @return OK
     */
    fixAllProcessWaste(projectId: string | undefined, subProjectId: string | undefined, assessmentId: string | undefined, skillAreadId: string | undefined, cancelToken?: CancelToken): Promise<ProcessWasteStatusStep[]> {
        let url_ = this.baseUrl + "/api/appSetting/fixAllProcessWaste?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (subProjectId === null)
            throw new globalThis.Error("The parameter 'subProjectId' cannot be null.");
        else if (subProjectId !== undefined)
            url_ += "subProjectId=" + encodeURIComponent("" + subProjectId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (skillAreadId === null)
            throw new globalThis.Error("The parameter 'skillAreadId' cannot be null.");
        else if (skillAreadId !== undefined)
            url_ += "skillAreadId=" + encodeURIComponent("" + skillAreadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFixAllProcessWaste(_response));
        });
    }

    protected processFixAllProcessWaste(response: AxiosResponse): Promise<ProcessWasteStatusStep[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessWasteStatusStep.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProcessWasteStatusStep[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessWasteStatusStep[]>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @param region (optional) 
     * @return OK
     */
    populateProcessWasteProcess(assessmentId: string | undefined, generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, region: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/appSetting/populateProcessWasteProcess?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPopulateProcessWasteProcess(_response));
        });
    }

    protected processPopulateProcessWasteProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param subProjectId (optional) 
     * @param assessmentId (optional) 
     * @param skillAreadId (optional) 
     * @return OK
     */
    checkProcessWasteStatus(projectId: string | undefined, subProjectId: string | undefined, assessmentId: string | undefined, skillAreadId: string | undefined, cancelToken?: CancelToken): Promise<ProcessWasteStatusStep[]> {
        let url_ = this.baseUrl + "/api/appSetting/checkProcessWasteStatus?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (subProjectId === null)
            throw new globalThis.Error("The parameter 'subProjectId' cannot be null.");
        else if (subProjectId !== undefined)
            url_ += "subProjectId=" + encodeURIComponent("" + subProjectId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (skillAreadId === null)
            throw new globalThis.Error("The parameter 'skillAreadId' cannot be null.");
        else if (skillAreadId !== undefined)
            url_ += "skillAreadId=" + encodeURIComponent("" + skillAreadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckProcessWasteStatus(_response));
        });
    }

    protected processCheckProcessWasteStatus(response: AxiosResponse): Promise<ProcessWasteStatusStep[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessWasteStatusStep.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProcessWasteStatusStep[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessWasteStatusStep[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fixSingleIntermediate(body: FixSingleIntermediateFromUI | undefined, cancelToken?: CancelToken): Promise<FixSingleIntermediateFromUI> {
        let url_ = this.baseUrl + "/api/appSetting/fixSingleIntermediate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFixSingleIntermediate(_response));
        });
    }

    protected processFixSingleIntermediate(response: AxiosResponse): Promise<FixSingleIntermediateFromUI> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FixSingleIntermediateFromUI.fromJS(resultData200);
            return Promise.resolve<FixSingleIntermediateFromUI>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FixSingleIntermediateFromUI>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fixTheIntermediate(body: IntermediateStatusStep[] | undefined, cancelToken?: CancelToken): Promise<IntermediateStatusStep[]> {
        let url_ = this.baseUrl + "/api/appSetting/fixTheIntermediate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFixTheIntermediate(_response));
        });
    }

    protected processFixTheIntermediate(response: AxiosResponse): Promise<IntermediateStatusStep[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntermediateStatusStep.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntermediateStatusStep[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediateStatusStep[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllUISettings( cancelToken?: CancelToken): Promise<TemplateUI[]> {
        let url_ = this.baseUrl + "/api/appSetting/getAllUISettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllUISettings(_response));
        });
    }

    protected processGetAllUISettings(response: AxiosResponse): Promise<TemplateUI[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateUI.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TemplateUI[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateUI[]>(null as any);
    }

    /**
     * @return OK
     */
    getDefaultUISettings( cancelToken?: CancelToken): Promise<TemplateUI> {
        let url_ = this.baseUrl + "/api/appSetting/getDefaultUISettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDefaultUISettings(_response));
        });
    }

    protected processGetDefaultUISettings(response: AxiosResponse): Promise<TemplateUI> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateUI.fromJS(resultData200);
            return Promise.resolve<TemplateUI>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateUI>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getOneUISettings(id: string | undefined, cancelToken?: CancelToken): Promise<TemplateUI> {
        let url_ = this.baseUrl + "/api/appSetting/getOneUISettings?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOneUISettings(_response));
        });
    }

    protected processGetOneUISettings(response: AxiosResponse): Promise<TemplateUI> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateUI.fromJS(resultData200);
            return Promise.resolve<TemplateUI>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateUI>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAllUISettings(body: TemplateUI | undefined, cancelToken?: CancelToken): Promise<TemplateUI> {
        let url_ = this.baseUrl + "/api/appSetting/setAllUISettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetAllUISettings(_response));
        });
    }

    protected processSetAllUISettings(response: AxiosResponse): Promise<TemplateUI> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateUI.fromJS(resultData200);
            return Promise.resolve<TemplateUI>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateUI>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param subProjectId (optional) 
     * @param assessmentId (optional) 
     * @param skillAreadId (optional) 
     * @return OK
     */
    checkIntermediateStatus(projectId: string | undefined, subProjectId: string | undefined, assessmentId: string | undefined, skillAreadId: string | undefined, cancelToken?: CancelToken): Promise<IntermediateStatusStep[]> {
        let url_ = this.baseUrl + "/api/appSetting/checkIntermediateStatus?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (subProjectId === null)
            throw new globalThis.Error("The parameter 'subProjectId' cannot be null.");
        else if (subProjectId !== undefined)
            url_ += "subProjectId=" + encodeURIComponent("" + subProjectId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (skillAreadId === null)
            throw new globalThis.Error("The parameter 'skillAreadId' cannot be null.");
        else if (skillAreadId !== undefined)
            url_ += "skillAreadId=" + encodeURIComponent("" + skillAreadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIntermediateStatus(_response));
        });
    }

    protected processCheckIntermediateStatus(response: AxiosResponse): Promise<IntermediateStatusStep[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntermediateStatusStep.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntermediateStatusStep[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediateStatusStep[]>(null as any);
    }
}

export interface IApiClient {
    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    updateAssessmentUpdatedByDate(assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @return OK
     */
    assessmentAll( cancelToken?: CancelToken): Promise<Assessment[]>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getSingleAssessmentById(id: string | undefined,  cancelToken?: CancelToken): Promise<Assessment>;
    /**
     * @return OK
     */
    getAssessmentWithProject(assessmentId: string,  cancelToken?: CancelToken): Promise<Assessment>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    allIntermediatesStatusPerGeneralInformationId(assessmentId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<IntermediateStatusStep[]>;
    /**
     * @param subProjectId (optional) 
     * @return OK
     */
    assessmentPerSubProject(subProjectId: string | undefined,  cancelToken?: CancelToken): Promise<Assessment[]>;
    /**
     * @param subProjectId (optional) 
     * @return OK
     */
    skillAreasInSubProject(subProjectId: string | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * @return OK
     */
    projectSubProjectAssessmentTree( cancelToken?: CancelToken): Promise<Project[]>;
    /**
     * @param subProjectId (optional) 
     * @return OK
     */
    getSelectedProjectBySubProject(subProjectId: string | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    checkDataInDestinationAssessmentSkillAreas(assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<SkillAreaStatus[]>;
    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    checkDataInAssessmentSkillAreas(assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<SkillAreaStatus[]>;
    /**
     * @param sourceAssessmentId (optional) 
     * @param destinationSubProjectId (optional) 
     * @param newAssessmentName (optional) 
     * @param developmentStageId (optional) 
     * @param isCopyToAssessment (optional) 
     * @param destinationAssessmentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    copyAssessmentToSubProject(sourceAssessmentId: string | undefined, destinationSubProjectId: string | undefined, newAssessmentName: string | undefined, developmentStageId: string | undefined, isCopyToAssessment: boolean | undefined, destinationAssessmentId: string | undefined, body: string[] | undefined,  cancelToken?: CancelToken): Promise<Assessment>;
    /**
     * @return OK
     */
    bookmarkedAssessmentList( cancelToken?: CancelToken): Promise<Assessment[]>;
    /**
     * @return OK
     */
    generateAssessmentNumber( cancelToken?: CancelToken): Promise<GeneratedAssessmentNumber>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postAssessmentCollaborators(body: AssessmentCollaboratorPut | undefined,  cancelToken?: CancelToken): Promise<Assessment>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postassessmentonly(body: Assessment | undefined,  cancelToken?: CancelToken): Promise<Assessment>;
    /**
     * @return OK
     */
    assessment(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @return OK
     */
    assessmentDelete(id: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param id (optional) 
     * @return OK
     */
    removeCollaboratorFromAssessment(id: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addCollaboratorInAssessment(body: AssessmentCollaborators | undefined,  cancelToken?: CancelToken): Promise<AssessmentCollaborators>;
    /**
     * @return OK
     */
    checkSingleUtilitiesMode(assessmentId: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param id (optional) 
     * @param isLock (optional) 
     * @return OK
     */
    assessmentLockUnlock(id: string | undefined, isLock: boolean | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @return OK
     */
    configurationVariable(id: string,  cancelToken?: CancelToken): Promise<ConfigurationVariable>;
    /**
     * @return OK
     */
    developmentStageAll( cancelToken?: CancelToken): Promise<DevelopmentStage[]>;
    /**
     * @return OK
     */
    developmentStageGet(id: string,  cancelToken?: CancelToken): Promise<DevelopmentStage>;
    /**
     * @param body (optional) 
     * @return OK
     */
    developmentStagePut(id: string, body: DevelopmentStage | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    developmentStageDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    developmentStagePost(body: DevelopmentStage | undefined,  cancelToken?: CancelToken): Promise<DevelopmentStage>;
    /**
     * @return OK
     */
    getDownstreamDistDropdowns( cancelToken?: CancelToken): Promise<DownstreamDistributionDropdowns>;
    /**
     * @param typeOfTransportId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getDownstreamDistDistributionDefaults(typeOfTransportId: string | undefined, stepId: string | undefined,  cancelToken?: CancelToken): Promise<DownstreamStep[]>;
    /**
     * @param stepId (optional) 
     * @return OK
     */
    getDownstreamDistDistribution(stepId: string | undefined,  cancelToken?: CancelToken): Promise<DownstreamStep[]>;
    /**
     * @param stepId (optional) 
     * @return OK
     */
    getDownstreamDistDistributionBasicInfo(stepId: string | undefined,  cancelToken?: CancelToken): Promise<Downstream>;
    /**
     * @param typeOfTransportId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    postDistributionDownstream(typeOfTransportId: string | undefined, stepId: string | undefined,  cancelToken?: CancelToken): Promise<Downstream>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postDistributionStepFromTable(body: DownstreamStep | undefined,  cancelToken?: CancelToken): Promise<DownstreamStep>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postDistributionTransportFromTable(body: DownstreamDistribution | undefined,  cancelToken?: CancelToken): Promise<DownstreamDistribution>;
    /**
     * @param id (optional) 
     * @return OK
     */
    deleteDistributionTransportFromTable(id: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadReportPackagingDistribution(screenName: string, body: ExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadReportOthers(screenId: string, body: ExportRequestOther | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return OK
     */
    getAllCountsByPersonId(id: string,  cancelToken?: CancelToken): Promise<PersonParticipationCount>;
    /**
     * @return OK
     */
    getFavoritesTreeByPersonId(id: string,  cancelToken?: CancelToken): Promise<TreeItem[]>;
    /**
     * @return OK
     */
    getFavoritesByPersonId(id: string,  cancelToken?: CancelToken): Promise<Favorites[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addRemoveAssessmentToFavoritesPerPersonId(body: Favorites | undefined,  cancelToken?: CancelToken): Promise<FavoriteStatus>;
    /**
     * @return OK
     */
    featureFlag(id: string,  cancelToken?: CancelToken): Promise<FeatureFlag>;
    /**
     * @param searchPerson (optional) 
     * @return OK
     */
    filterPersonForCollaborators(searchPerson: string | undefined,  cancelToken?: CancelToken): Promise<Person[]>;
    /**
     * @return OK
     */
    getdosesDropdowns( cancelToken?: CancelToken): Promise<DosesDropdowns>;
    /**
     * @return OK
     */
    getPackDropdowns( cancelToken?: CancelToken): Promise<PackDropdowns>;
    /**
     * @return OK
     */
    getDistDropdowns( cancelToken?: CancelToken): Promise<DistDropdowns>;
    /**
     * @return OK
     */
    getBioGeneralInfoDropdowns( cancelToken?: CancelToken): Promise<GeneralBioDropdowns>;
    /**
     * @return OK
     */
    getCommonAPIGeneralByAssessmentIdAndScreenId(assessmentId: string, screenId: string,  cancelToken?: CancelToken): Promise<GeneralInformation[]>;
    /**
     * @return OK
     */
    setGeneralInformationSelected(generalInformationId: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param generalInformationId (optional) 
     * @return OK
     */
    checkIfDeviceMaterialNeedToBeDisabled(generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param stepId (optional) 
     * @return OK
     */
    checkIfResultNeedToBeEnabled(stepId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    checkIfResultNeedToBeEnabledDistributionPackagingByAssessmentId(assessmentId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    checkIfGeneralInfoIsPresentForDistributionPackagingByAssessmentId(assessmentId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param operationId (optional) 
     * @return OK
     */
    getGeneralInformationById(generalInformationId: string, operationId: string | undefined,  cancelToken?: CancelToken): Promise<GeneralInformation>;
    /**
     * @return OK
     */
    getCommonAPISingleGeneralByAssessmentIdAndScreenId(assessmentId: string, screenId: string,  cancelToken?: CancelToken): Promise<GeneralInformation>;
    /**
     * @return OK
     */
    getCommonAPISingleGeneralByAssessmentIdAndScreenIdPP(assessmentId: string,  cancelToken?: CancelToken): Promise<GeneralInformation>;
    /**
     * @return OK
     */
    getStepByAssessmentIdScreenIdGeneralInfomationId(assessmentId: string, screenId: string, generalInformationId: string,  cancelToken?: CancelToken): Promise<Step[]>;
    /**
     * @return OK
     */
    getStepsAndIntermediates(assessmentId: string, screenId: string, generalInformationId: string,  cancelToken?: CancelToken): Promise<GeneralInformationData>;
    /**
     * @return OK
     */
    getUnitOperationByScreenAssessment(assessmentId: string, screenId: string,  cancelToken?: CancelToken): Promise<UnitOperation[]>;
    /**
     * @return OK
     */
    getCompOptions(compOptionId: string,  cancelToken?: CancelToken): Promise<CompOption[]>;
    /**
     * @return OK
     */
    getUnitOperationsByCompOptionName(compOptionName: string, screenId: string,  cancelToken?: CancelToken): Promise<UnitOperation[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateStepsOrder(body: Step[] | undefined,  cancelToken?: CancelToken): Promise<Step[]>;
    /**
     * @param stepid (optional) 
     * @param isGlobal (optional) 
     * @return OK
     */
    updatePPGlobalLocation(stepid: string | undefined, isGlobal: boolean | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param action (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateStepData(action: string | undefined, body: Step | undefined,  cancelToken?: CancelToken): Promise<Step>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postCommonAPIGeneralInformation(body: GeneralInformation | undefined,  cancelToken?: CancelToken): Promise<GeneralInformation>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @param body (optional) 
     * @return OK
     */
    postSaveStep(assessmentId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined, body: Step[] | undefined,  cancelToken?: CancelToken): Promise<Step[]>;
    /**
     * @return OK
     */
    getProductFormatIdFromProductProcess(assessmentId: string,  cancelToken?: CancelToken): Promise<GeneralInformation>;
    /**
     * @return OK
     */
    checkIfSubprojectHasProductProcessScreen(assessmentId: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateDevicePackagingFromProductProcess(body: UpdateDevicePackagingRequest | undefined,  cancelToken?: CancelToken): Promise<GeneralInformation[]>;
    /**
     * @return OK
     */
    softDeleteGeneralInformation(generalInformationId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getActiveGeneralInformationCount(assessmentId: string, screenId: string,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @return OK
     */
    helpPageAll( cancelToken?: CancelToken): Promise<HelpPage[]>;
    /**
     * @param helpPageName (optional) 
     * @return OK
     */
    getHelpPageByName(helpPageName: string | undefined,  cancelToken?: CancelToken): Promise<HelpPage>;
    /**
     * @return OK
     */
    helpGet(id: string,  cancelToken?: CancelToken): Promise<HelpPage>;
    /**
     * @param body (optional) 
     * @return OK
     */
    helpPut(id: string, body: HelpPage | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    helpDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    helpPost(body: HelpPage | undefined,  cancelToken?: CancelToken): Promise<HelpPage>;
    /**
     * @return OK
     */
    helpFieldAll( cancelToken?: CancelToken): Promise<HelpField[]>;
    /**
     * @param id (optional) 
     * @return OK
     */
    helpFieldAllbyPageid(id: string | undefined,  cancelToken?: CancelToken): Promise<HelpField[]>;
    /**
     * @return OK
     */
    helpFieldGet(id: string,  cancelToken?: CancelToken): Promise<HelpField>;
    /**
     * @param body (optional) 
     * @return OK
     */
    helpFieldPut(id: string, body: HelpField | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    helpFieldDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    helpFieldPost(body: HelpField | undefined,  cancelToken?: CancelToken): Promise<HelpField>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getHierarchyByTreeId(id: string | undefined,  cancelToken?: CancelToken): Promise<Hierarchy[]>;
    /**
     * @param treeId (optional) 
     * @return OK
     */
    getPrimeVueHierarchyByTreeId(treeId: string | undefined,  cancelToken?: CancelToken): Promise<PrimeVueHierarchy>;
    /**
     * @param treeName (optional) 
     * @return OK
     */
    getPrimeVueHierarchyByTreeName(treeName: string | undefined,  cancelToken?: CancelToken): Promise<PrimeVueHierarchy>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getHierarchyList(id: string | undefined,  cancelToken?: CancelToken): Promise<TreeItems[]>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeItemById(id: string | undefined,  cancelToken?: CancelToken): Promise<TreeItems>;
    /**
     * @return OK
     */
    knowledgeArticleAll( cancelToken?: CancelToken): Promise<KnowledgeArticle[]>;
    /**
     * @return OK
     */
    knowledgeArticleGet(id: string,  cancelToken?: CancelToken): Promise<KnowledgeArticle>;
    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeArticlePut(id: string, body: KnowledgeArticle | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    knowledgeArticleDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeArticlePost(body: KnowledgeArticle | undefined,  cancelToken?: CancelToken): Promise<KnowledgeArticle>;
    /**
     * @return OK
     */
    knowledgeCategoryAll( cancelToken?: CancelToken): Promise<KnowledgeCategory[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeArticleFeedback(body: KnowledgeArticleFeedback | undefined,  cancelToken?: CancelToken): Promise<KnowledgeArticleFeedback>;
    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeInfoRequest(body: KnowledgeInfoRequest | undefined,  cancelToken?: CancelToken): Promise<KnowledgeInfoRequest>;
    /**
     * @return OK
     */
    knowledgeTagAll( cancelToken?: CancelToken): Promise<KnowledgeTag[]>;
    /**
     * @param token (optional) 
     * @return OK
     */
    login(token: string | undefined,  cancelToken?: CancelToken): Promise<PersonSessionData>;
    /**
     * @return OK
     */
    logout( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getUnitByUnitTypeName(unitTypeName: string,  cancelToken?: CancelToken): Promise<Unit[]>;
    /**
     * @return OK
     */
    getAllUnitsWithType( cancelToken?: CancelToken): Promise<UnitWithTypeDto[]>;
    /**
     * @return OK
     */
    masterCategoryAll( cancelToken?: CancelToken): Promise<MasterCategory[]>;
    /**
     * @param id (optional) 
     * @return OK
     */
    masterDropdownByCategoryId(id: string | undefined,  cancelToken?: CancelToken): Promise<MasterDropdown[]>;
    /**
     * @param categoryKey (optional) 
     * @return OK
     */
    masterDropdownByCategoryKey(categoryKey: string | undefined,  cancelToken?: CancelToken): Promise<MasterDropdown[]>;
    /**
     * @param categoryKey (optional) 
     * @return OK
     */
    masterDropdownByCategoryKeyAll(categoryKey: string | undefined,  cancelToken?: CancelToken): Promise<MasterDropdown[]>;
    /**
     * @return OK
     */
    masterCategoryGet(id: string,  cancelToken?: CancelToken): Promise<MasterCategory>;
    /**
     * @return OK
     */
    masterCategoryDelete(id: string,  cancelToken?: CancelToken): Promise<MasterCategory>;
    /**
     * @param body (optional) 
     * @return OK
     */
    masterCategoryPut(id: string, body: MasterCategory | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    masterCategoryPost(body: MasterCategory | undefined,  cancelToken?: CancelToken): Promise<MasterCategory>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putTheMasterCategory(body: MasterCategory | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putTheDropdown(body: MasterDropdown | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveTheDropdownWithMasterCategoryKey(body: MasterDropdown | undefined,  cancelToken?: CancelToken): Promise<MasterDropdown>;
    /**
     * @return OK
     */
    newsAll( cancelToken?: CancelToken): Promise<any[]>;
    /**
     * @return OK
     */
    categoryAll( cancelToken?: CancelToken): Promise<NewsCategory[]>;
    /**
     * @return OK
     */
    newsFeed( cancelToken?: CancelToken): Promise<News[]>;
    /**
     * @param daysAgo (optional) 
     * @return OK
     */
    newsFeedAll(daysAgo: number | undefined,  cancelToken?: CancelToken): Promise<News[]>;
    /**
     * @return OK
     */
    newsGet(id: string,  cancelToken?: CancelToken): Promise<News>;
    /**
     * @return OK
     */
    newsDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @param newsDetails (optional) 
     * @param file (optional) 
     * @return OK
     */
    newsPut(id: string | undefined, newsDetails: string | undefined, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<News>;
    /**
     * @param newsDetails (optional) 
     * @param file (optional) 
     * @return OK
     */
    newsPost(newsDetails: string | undefined, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<News>;
    /**
     * @param newsId (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    deleteImageFile(newsId: string | undefined, fileName: string | undefined,  cancelToken?: CancelToken): Promise<News>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postNewsPersonData(body: NewsPersonLog | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    personTypeAll( cancelToken?: CancelToken): Promise<PersonType[]>;
    /**
     * @return OK
     */
    personTypeGet(id: string,  cancelToken?: CancelToken): Promise<PersonType>;
    /**
     * @param body (optional) 
     * @return OK
     */
    personTypePut(id: string, body: PersonType | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    personTypeDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    personTypePost(body: PersonType | undefined,  cancelToken?: CancelToken): Promise<PersonType>;
    /**
     * @param stepId (optional) 
     * @return OK
     */
    checkIfSiteLocationIsSelectedInRawMaterialsForSyntheticAPI(stepId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    checkIfEnableConsumerEndOfLifeTab(assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    generateBasicInfoForConsumerEolTab(assessmentId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<BasicInfoConsumerEolTab>;
    /**
     * @param processWasteId (optional) 
     * @param destinationMarket (optional) 
     * @param destinationSetting (optional) 
     * @return OK
     */
    putConsumerProcessWaste(processWasteId: string | undefined, destinationMarket: string | undefined, destinationSetting: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @return OK
     */
    getConsumerEndOfLifeDropdowns( cancelToken?: CancelToken): Promise<ConsumerEndOfLifeDropdowns>;
    /**
     * @param assessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @param action (optional) 
     * @param region (optional) 
     * @return OK
     */
    populateProcessWasteAndTable(assessmentId: string | undefined, generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, action: string | undefined, region: string | undefined,  cancelToken?: CancelToken): Promise<ProcessWasteLoading>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putProcessWasteBasicInfo(body: ProcessWaste | undefined,  cancelToken?: CancelToken): Promise<ProcessWaste>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putProcessWaste(body: ProcessWasteInput | undefined,  cancelToken?: CancelToken): Promise<ProcessWasteInput>;
    /**
     * @return OK
     */
    productFormat(id: string,  cancelToken?: CancelToken): Promise<ProductFormat>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getProductFormatSourceScreenId(assessmentId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getProxyByScreenAndAssessment(screenId: string | undefined, assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<ProductProcessProxy[]>;
    /**
     * @param action (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveProxyForProductProcess(action: string | undefined, body: DataToSave | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @return OK
     */
    projectAll( cancelToken?: CancelToken): Promise<Project[]>;
    /**
     * @return OK
     */
    getProjectsForTable( cancelToken?: CancelToken): Promise<ProjectForTable[]>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getSingleProjectById(id: string | undefined,  cancelToken?: CancelToken): Promise<Project>;
    /**
     * @param body (optional) 
     * @return OK
     */
    projectPost(body: ProjectCollaboratorPut | undefined,  cancelToken?: CancelToken): Promise<Project>;
    /**
     * @return OK
     */
    getTemplateProjects( cancelToken?: CancelToken): Promise<Project[]>;
    /**
     * @return OK
     */
    setTemplateProject(projectId: string, isTemplate: boolean,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    projectDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    uploadSpecificAssetData( cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delSingleMaterialFromTable(body: RawMaterialTableRow | undefined,  cancelToken?: CancelToken): Promise<RawMaterialTableRow>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteInboundFromTable(body: InboundTransportForMaterials | undefined,  cancelToken?: CancelToken): Promise<InboundTransportForMaterials>;
    /**
     * @param transportTableRowId (optional) 
     * @return OK
     */
    deleteInboundFromTableById(transportTableRowId: string | undefined,  cancelToken?: CancelToken): Promise<InboundTransportForMaterials>;
    /**
     * @param stepId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getTotalMassForDistribution(stepId: string | undefined, generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @param materialId (optional) 
     * @return OK
     */
    getClimateChangePerMaterialByMaterialId(materialId: string | undefined,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @param materialEntryId (optional) 
     * @return OK
     */
    getClimateChangeByMaterialEntryId(materialEntryId: string | undefined,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putSingleMaterialFromTable(body: RawMaterialTableRow | undefined,  cancelToken?: CancelToken): Promise<MaterialRecap>;
    /**
     * @param unitOperationId (optional) 
     * @return OK
     */
    deleteIfUnitOperationIsNotInUse(unitOperationId: string | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    removeAllTransportForMaterialsByTransportIds(body: string[] | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param stepId (optional) 
     * @return OK
     */
    removeAllTransportForMaterialsByStepId(stepId: string | undefined,  cancelToken?: CancelToken): Promise<InboundTransportForMaterials>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postSingleInboundTransportFromTable(body: InboundTransportForMaterials | undefined,  cancelToken?: CancelToken): Promise<InboundTransportForMaterials>;
    /**
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getRawMaterialsScreenContents(generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined,  cancelToken?: CancelToken): Promise<GlobalDataForLoading>;
    /**
     * @param materialId (optional) 
     * @param stepId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getMaterialsEntriesByGeneraInformationIdScreenId(materialId: string | undefined, stepId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<RawMaterialCompleteData>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putTheMaterialForm(body: RawMaterialGlobalData | undefined,  cancelToken?: CancelToken): Promise<RawMaterialGlobalData>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putTheMaterialFormOLD(body: RawMaterialGlobalData | undefined,  cancelToken?: CancelToken): Promise<RawMaterialGlobalData>;
    /**
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getBasicDataByGeneraInformationIdScreenId(generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined,  cancelToken?: CancelToken): Promise<GeneralInformation>;
    /**
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @param tabAndSubTabName (optional) 
     * @return OK
     */
    getRawMaterialsByGeneraInformationIdScreenIdStepId(generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, tabAndSubTabName: string | undefined,  cancelToken?: CancelToken): Promise<RawMaterial>;
    /**
     * @param generalInformationId (optional) 
     * @return OK
     */
    checkIfDeviceIsUsedInPackagingMaterialsDeviceMaterials(generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<CheckIfDeviceIsUsed>;
    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getRawMaterialsRelatedDropdowns(screenId: string | undefined, assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<RawMaterialsRelatedDropdowns>;
    /**
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getRawMaterialsRelatedDropdownsv2(screenId: string | undefined, generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<RawMaterialsRelatedDropdownsComplete>;
    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getRawMaterialsFiltering(screenId: string | undefined, assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<RawMaterialSelectionRow[]>;
    /**
     * @param generalInformationId (optional) 
     * @param body (optional) 
     * @return OK
     */
    getSingleMaterialReferenceQuantityForRawMaterialTable(generalInformationId: string | undefined, body: RawMaterialTableRow | undefined,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSingleMaterialEFForRawMaterialTable(body: RawMaterialTableRow | undefined,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @return OK
     */
    getDefaultTransport( cancelToken?: CancelToken): Promise<InboundTransportForMaterials[]>;
    /**
     * @param materialId (optional) 
     * @param stepId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getMaterialsEntriesByGeneraInformationIdScreenIdOLD(materialId: string | undefined, stepId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<RawMaterialTableRow[]>;
    /**
     * @param rawMaterialId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getMaterialsInboundTransportEntriesByGeneraInformationIdScreenId(rawMaterialId: string | undefined, stepId: string | undefined,  cancelToken?: CancelToken): Promise<InboundTransportForMaterials[]>;
    /**
     * @param stepId (optional) 
     * @return OK
     */
    rawMaterialExist(stepId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param materialId (optional) 
     * @return OK
     */
    requestDensityForMaterial(materialId: string | undefined,  cancelToken?: CancelToken): Promise<DensityRequestResponse>;
    /**
     * @return OK
     */
    relatableUnit(id: string,  cancelToken?: CancelToken): Promise<RelatableUnit>;
    /**
     * @return OK
     */
    reportConfigurationGet(assessmentId: string,  cancelToken?: CancelToken): Promise<ReportConfigurationReadModel>;
    /**
     * @param body (optional) 
     * @return OK
     */
    reportConfigurationPost(body: ReportConfigurationDto | undefined,  cancelToken?: CancelToken): Promise<ReportConfigurationDto>;
    /**
     * @return OK
     */
    reportConfigurationDelete(id: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @return OK
     */
    relatableUnits( cancelToken?: CancelToken): Promise<RelatableUnitReadModel[]>;
    /**
     * @param assessmentId (optional) 
     * @param packagingGeneralInformationId (optional) 
     * @return OK
     */
    checkIfDestinationMarketSelected(assessmentId: string | undefined, packagingGeneralInformationId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param id (optional) 
     * @param resultTab (optional) 
     * @param emissionFactorsToUse (optional) 
     * @param useWeightedEmissionFactors (optional) 
     * @param quantity (optional) 
     * @param resultFormatType (optional) 
     * @param generalInformationIdParam (optional) 
     * @return OK
     */
    getPackResults(id: string | undefined, resultTab: string | undefined, emissionFactorsToUse: string[] | undefined, useWeightedEmissionFactors: boolean | undefined, quantity: number | undefined, resultFormatType: string | undefined, generalInformationIdParam: string | undefined,  cancelToken?: CancelToken): Promise<FinalResult>;
    /**
     * @return OK
     */
    getFullSyntheticResults(generalInformationId: string,  cancelToken?: CancelToken): Promise<{ [key: string]: number; }>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getLifeCycleResultByGeneralInformationId(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<LifeCycleResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getResultsByStep(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<LifeCycleResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getResultsByMaterialComposition(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<MaterialCompositionResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getResultsByProcessWaste(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<CustomProcessWasteEOL[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSyntheticApiCalculationLog(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param emissionFactorsToUse (optional) 
     * @param useWeightedEmissionFactors (optional) 
     * @return OK
     */
    getDnpCalculationLog(generalInformationId: string, emissionFactorsToUse: string[] | undefined, useWeightedEmissionFactors: boolean | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param emissionFactorsToUse (optional) 
     * @param useWeightedEmissionFactors (optional) 
     * @return OK
     */
    getDistributionCalculationLog(generalInformationId: string, emissionFactorsToUse: string[] | undefined, useWeightedEmissionFactors: boolean | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return OK
     */
    getResultAll( cancelToken?: CancelToken): Promise<LifeCycleResultGraph>;
    /**
     * @return OK
     */
    getFullBiologicsResults(generalInformationId: string,  cancelToken?: CancelToken): Promise<{ [key: string]: number; }>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsLifeCycleResultByGeneralInformationId(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<BiologicsLifeCycleResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsResultsByStep(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<LifeCycleResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsResultsByMaterialComposition(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<MaterialCompositionResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsResultsByProcessWaste(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<CustomProcessWasteEOL[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsCalculationLog(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessLifeCycleResultByGeneralInformationId(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<ProductProcessLifeCycleResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessResultsByStep(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<LifeCycleResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessResultsByMaterialComposition(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<MaterialCompositionResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessResultsByProcessWaste(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<CustomProcessWasteEOL[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessCalculationLog(generalInformationId: string, body: CalculationOptions | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    checkIfLifeCycleSummaryCanBeCalculated(body: LifeCycleSummaryResultInput | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getLifeCycleSummaryResult(body: LifeCycleSummaryResultInput | undefined,  cancelToken?: CancelToken): Promise<ProductProcessLifeCycleResult[]>;
    /**
     * @return OK
     */
    getResultAll1( cancelToken?: CancelToken): Promise<LifeCycleSummaryResultGraph>;
    /**
     * @return OK
     */
    screenAll( cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @param findScreenName (optional) 
     * @return OK
     */
    screenForClient(findScreenName: string | undefined,  cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @return OK
     */
    getScreenByScreenName(screenName: string,  cancelToken?: CancelToken): Promise<Screen>;
    /**
     * @return OK
     */
    screenForClientAlls( cancelToken?: CancelToken): Promise<ScreenTabs[]>;
    /**
     * @return OK
     */
    screenForClientAllsByTabPosition( cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @return OK
     */
    screensWithProductFormats( cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @return OK
     */
    allClientScreensWithFormats( cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @return OK
     */
    screenGet(id: string,  cancelToken?: CancelToken): Promise<Screen>;
    /**
     * @return OK
     */
    screenDelete(id: string,  cancelToken?: CancelToken): Promise<Screen>;
    /**
     * @param body (optional) 
     * @return OK
     */
    screenPut(id: string, body: Screen | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    screenPost(body: Screen | undefined,  cancelToken?: CancelToken): Promise<UserTypeScreen>;
    /**
     * @return OK
     */
    getSelectedAssessmentByPersonId(id: string,  cancelToken?: CancelToken): Promise<History[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    logSelectedAssessmentPerPersonId(body: History | undefined,  cancelToken?: CancelToken): Promise<History>;
    /**
     * @param to (optional) 
     * @param subject (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendMailHelper(to: string | undefined, subject: string | undefined, body: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    siteLocationsAll( cancelToken?: CancelToken): Promise<SiteLocation[]>;
    /**
     * @return OK
     */
    siteLocationsGet(id: string,  cancelToken?: CancelToken): Promise<SiteLocation>;
    /**
     * @param body (optional) 
     * @return OK
     */
    siteLocationsPut(id: string, body: SiteLocation | undefined,  cancelToken?: CancelToken): Promise<SiteLocation>;
    /**
     * @return OK
     */
    siteLocationsDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    siteLocationsPost(body: SiteLocation | undefined,  cancelToken?: CancelToken): Promise<SiteLocation>;
    /**
     * @param sourceStepId (optional) 
     * @param destinationAssessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param newStepName (optional) 
     * @return OK
     */
    copyStepToAssessment(sourceStepId: string | undefined, destinationAssessmentId: string | undefined, generalInformationId: string | undefined, newStepName: string | undefined,  cancelToken?: CancelToken): Promise<Step>;
    /**
     * @param sourceStepId (optional) 
     * @param destinationAssessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param newStepName (optional) 
     * @param copyUpstreamSteps (optional) 
     * @param upstreamStepNamesJson (optional) 
     * @return OK
     */
    copyStepsWithUpstream(sourceStepId: string | undefined, destinationAssessmentId: string | undefined, generalInformationId: string | undefined, newStepName: string | undefined, copyUpstreamSteps: boolean | undefined, upstreamStepNamesJson: string | undefined,  cancelToken?: CancelToken): Promise<Step[]>;
    /**
     * @param sourceStepId (optional) 
     * @param destinationAssessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param newStepName (optional) 
     * @return OK
     */
    copyStepToAssessmentv1(sourceStepId: string | undefined, destinationAssessmentId: string | undefined, generalInformationId: string | undefined, newStepName: string | undefined,  cancelToken?: CancelToken): Promise<Step>;
    /**
     * @return OK
     */
    getUpstreamStepsList(stepId: string,  cancelToken?: CancelToken): Promise<Step[]>;
    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getActiveProjects(screenId: string | undefined, assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<Project[]>;
    /**
     * @param projectId (optional) 
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getActiveSubProjects(projectId: string | undefined, screenId: string | undefined, assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<SubProject[]>;
    /**
     * @param subProjectId (optional) 
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getActiveAssessments(subProjectId: string | undefined, screenId: string | undefined, assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<Assessment[]>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getActiveSteps(assessmentId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<Step[]>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getTheFirstStepByAssessmentIdScreenIdGeneralInformationId(assessmentId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<Step>;
    /**
     * @param stepId (optional) 
     * @param subTabName (optional) 
     * @param status (optional) 
     * @return OK
     */
    updateScreenStepStatus(stepId: string | undefined, subTabName: string | undefined, status: boolean | undefined,  cancelToken?: CancelToken): Promise<StepStatus>;
    /**
     * @return OK
     */
    step(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    subProjectSelectedScreens(assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    subProjectSelectedScreensIds(assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * @return OK
     */
    subProjectAll( cancelToken?: CancelToken): Promise<SubProject[]>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getSinglesubProjectById(id: string | undefined,  cancelToken?: CancelToken): Promise<SubProject>;
    /**
     * @param projectId (optional) 
     * @return OK
     */
    subProjectPerProject(projectId: string | undefined,  cancelToken?: CancelToken): Promise<SubProject[]>;
    /**
     * @param projectId (optional) 
     * @return OK
     */
    subProjectPerProjectTable(projectId: string | undefined,  cancelToken?: CancelToken): Promise<SubProjectForTable[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    subProjectPost(body: SubProjectCollaboratorPut | undefined,  cancelToken?: CancelToken): Promise<SubProject>;
    /**
     * @return OK
     */
    subProjectDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putUnitOperation(body: UnitOperation | undefined,  cancelToken?: CancelToken): Promise<UnitOperation>;
    /**
     * @param defaultKey (optional) 
     * @return OK
     */
    getDefaultEntries(defaultKey: string | undefined,  cancelToken?: CancelToken): Promise<AllDefaultValues>;
    /**
     * @return OK
     */
    getAllDefaultEntries( cancelToken?: CancelToken): Promise<AllDefaultValues[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putDefaultEntries(body: AllDefaultValues | undefined,  cancelToken?: CancelToken): Promise<AllDefaultValues>;
    /**
     * @return OK
     */
    treeItemAll( cancelToken?: CancelToken): Promise<TreeItems[]>;
    /**
     * @return OK
     */
    treeItemGet(id: string,  cancelToken?: CancelToken): Promise<TreeItems>;
    /**
     * @param body (optional) 
     * @return OK
     */
    treeItemPut(id: string, body: TreeItemVM | undefined,  cancelToken?: CancelToken): Promise<TreeItems>;
    /**
     * @return OK
     */
    treeItemDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    treeItemPost(body: TreeItems | undefined,  cancelToken?: CancelToken): Promise<TreeItems>;
    /**
     * @param keyword (optional) 
     * @param password (optional) 
     * @return OK
     */
    cleandemodata(keyword: string | undefined, password: string | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @return OK
     */
    personAll( cancelToken?: CancelToken): Promise<Person[]>;
    /**
     * @return OK
     */
    selectedColumnUserList( cancelToken?: CancelToken): Promise<any[]>;
    /**
     * @return OK
     */
    adminUserList( cancelToken?: CancelToken): Promise<any[]>;
    /**
     * @return OK
     */
    personAllNames( cancelToken?: CancelToken): Promise<any[]>;
    /**
     * @param searchPerson (optional) 
     * @return OK
     */
    filterPerson(searchPerson: string | undefined,  cancelToken?: CancelToken): Promise<Person[]>;
    /**
     * @return OK
     */
    userGet(id: string,  cancelToken?: CancelToken): Promise<Person>;
    /**
     * @param body (optional) 
     * @return OK
     */
    userPut(id: string, body: Person | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    userDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    insertSinglePersonComplete(body: AllSingleUserData | undefined,  cancelToken?: CancelToken): Promise<AllSingleUserData>;
    /**
     * @param body (optional) 
     * @return OK
     */
    userPost(body: Person | undefined,  cancelToken?: CancelToken): Promise<Person>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deactivateUser(id: string, body: DeactivateUserRequest | undefined,  cancelToken?: CancelToken): Promise<IdentityOperationResponse>;
    /**
     * @return OK
     */
    userTypeAll( cancelToken?: CancelToken): Promise<UserType[]>;
    /**
     * @return OK
     */
    userTypeGet(id: string,  cancelToken?: CancelToken): Promise<UserType>;
    /**
     * @param body (optional) 
     * @return OK
     */
    userTypePut(id: string, body: UserType | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    userTypeDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    userTypePost(body: UserType | undefined,  cancelToken?: CancelToken): Promise<UserType>;
    /**
     * @return OK
     */
    newUserType( cancelToken?: CancelToken): Promise<UserType>;
    /**
     * @return OK
     */
    userTypeScreenAll( cancelToken?: CancelToken): Promise<UserTypeScreen[]>;
    /**
     * @return OK
     */
    userTypeScreenGet(id: string,  cancelToken?: CancelToken): Promise<UserTypeScreen>;
    /**
     * @param body (optional) 
     * @return OK
     */
    userTypeScreenPut(id: string, body: UserTypeScreen | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    userTypeScreenDelete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    userTypeScreenPost(body: UserTypeScreen | undefined,  cancelToken?: CancelToken): Promise<UserTypeScreen>;
    /**
     * @return OK
     */
    userUserTypeAll( cancelToken?: CancelToken): Promise<UserUserType[]>;
    /**
     * @return OK
     */
    userUserTypeByUserId(id: string,  cancelToken?: CancelToken): Promise<UserUserType[]>;
    /**
     * @return OK
     */
    userUserType(id: string,  cancelToken?: CancelToken): Promise<UserUserType>;
    /**
     * @return OK
     */
    getSteamConsumptionDefault( cancelToken?: CancelToken): Promise<SteamConsumptionDefault[]>;
    /**
     * @return OK
     */
    getEnergyConsumptionDefault( cancelToken?: CancelToken): Promise<EnergyConsumptionDefault[]>;
    /**
     * @return OK
     */
    getWFIUnits( cancelToken?: CancelToken): Promise<Unit[]>;
    /**
     * @return OK
     */
    getWFISources( cancelToken?: CancelToken): Promise<WFISource[]>;
    /**
     * @return OK
     */
    getFacilityType( cancelToken?: CancelToken): Promise<ISOClassFacilityType[]>;
    /**
     * @param facilityTypeId (optional) 
     * @return OK
     */
    getCleanRoomClass(facilityTypeId: string | undefined,  cancelToken?: CancelToken): Promise<HVACClass[]>;
    /**
     * @return OK
     */
    getcoldStorageDropdowns( cancelToken?: CancelToken): Promise<ColdStorageDropdowns>;
    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @param unitOperationId (optional) 
     * @param roomSize (optional) 
     * @param duration (optional) 
     * @return OK
     */
    getProcessingCleaningCalculation(stepId: string, screenId: string | undefined, assessmentId: string | undefined, unitOperationId: string | undefined, roomSize: number | undefined, duration: number | undefined,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @param stepId (optional) 
     * @return OK
     */
    getWFISourceResults(stepId: string | undefined, wfiSourceId: string,  cancelToken?: CancelToken): Promise<WIFIResults[]>;
    /**
     * @return OK
     */
    getSteamConsumptionByStepId(stepId: string,  cancelToken?: CancelToken): Promise<UtilitiesSteamConsumption[]>;
    /**
     * @return OK
     */
    getEnergyConsumptionByStepId(stepId: string,  cancelToken?: CancelToken): Promise<UtilitiesEnergyConsumption[]>;
    /**
     * @return OK
     */
    getSteamConsumptionByUtilitiesId(utilitiesId: string,  cancelToken?: CancelToken): Promise<UtilitiesSteamConsumption[]>;
    /**
     * @return OK
     */
    getEnergyConsumptionByUtilitiesId(utilitiesId: string,  cancelToken?: CancelToken): Promise<UtilitiesEnergyConsumption[]>;
    /**
     * @return OK
     */
    getUtilitiesByStepId(stepId: string,  cancelToken?: CancelToken): Promise<Utilities>;
    /**
     * @return OK
     */
    getUtilitiesByStepIdAndGeneralInformationId(stepId: string, generalInformationId: string,  cancelToken?: CancelToken): Promise<Utilities>;
    /**
     * @return OK
     */
    getunitOperationUtilitiesByStepId(stepId: string,  cancelToken?: CancelToken): Promise<Step[]>;
    /**
     * @param generalInformationId (optional) 
     * @return OK
     */
    getRawMaterialUnitOperationByStepId(stepId: string, generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<RawMaterialUnitOperation[]>;
    /**
     * @param utilitiesId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateColdStorage(utilitiesId: string | undefined, body: ColdStorageData | undefined,  cancelToken?: CancelToken): Promise<ColdStorageData>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateHvacData(body: HvacUtilitiesData | undefined,  cancelToken?: CancelToken): Promise<HvacUtilitiesData>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateRawMaterialProcessingOperationTable(body: RawMaterialUnitOperation | undefined,  cancelToken?: CancelToken): Promise<RawMaterialUnitOperation>;
    /**
     * @param body (optional) 
     * @return OK
     */
    calculateProcessingOperationCF(body: ProcessingOperationCF | undefined,  cancelToken?: CancelToken): Promise<number>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateRawMaterialUnitOperation(body: RawMaterialUnitOperation | undefined,  cancelToken?: CancelToken): Promise<RawMaterialUnitOperation>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllRawMaterialUnitOperation(body: RawMaterialUnitOperation[] | undefined,  cancelToken?: CancelToken): Promise<RawMaterialUnitOperation[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateSteamConsumption(body: UtilitiesSteamConsumption | undefined,  cancelToken?: CancelToken): Promise<UtilitiesSteamConsumption>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateProcessingOperation(body: UtilitiesProcessingOperation[] | undefined,  cancelToken?: CancelToken): Promise<UtilitiesProcessingOperation[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateEnergyConsumption(body: UtilitiesEnergyConsumption | undefined,  cancelToken?: CancelToken): Promise<UtilitiesEnergyConsumption>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postUtilities(body: Utilities | undefined,  cancelToken?: CancelToken): Promise<Utilities>;
    /**
     * @param projectId (optional) 
     * @return OK
     */
    resetUtilitiesEnergyConsumptionToDefaults(projectId: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    validateResultMatrixByGeneralInformationId(generalInformationId: string,  cancelToken?: CancelToken): Promise<ValidationMessage[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    validateLifecycleSummaryResultMatrix(body: LifeCycleSummaryResultInput | undefined,  cancelToken?: CancelToken): Promise<string[]>;
}

export class ApiClient extends ApiClientBase implements IApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    updateAssessmentUpdatedByDate(assessmentId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/updateAssessmentUpdatedByDate?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAssessmentUpdatedByDate(_response));
        });
    }

    protected processUpdateAssessmentUpdatedByDate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    assessmentAll( cancelToken?: CancelToken): Promise<Assessment[]> {
        let url_ = this.baseUrl + "/api/assessmentAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssessmentAll(_response));
        });
    }

    protected processAssessmentAll(response: AxiosResponse): Promise<Assessment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assessment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Assessment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSingleAssessmentById(id: string | undefined, cancelToken?: CancelToken): Promise<Assessment> {
        let url_ = this.baseUrl + "/api/getSingleAssessmentById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingleAssessmentById(_response));
        });
    }

    protected processGetSingleAssessmentById(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * @return OK
     */
    getAssessmentWithProject(assessmentId: string, cancelToken?: CancelToken): Promise<Assessment> {
        let url_ = this.baseUrl + "/api/getAssessmentWithProject/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAssessmentWithProject(_response));
        });
    }

    protected processGetAssessmentWithProject(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    allIntermediatesStatusPerGeneralInformationId(assessmentId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<IntermediateStatusStep[]> {
        let url_ = this.baseUrl + "/api/allIntermediatesStatusPerGeneralInformationId?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAllIntermediatesStatusPerGeneralInformationId(_response));
        });
    }

    protected processAllIntermediatesStatusPerGeneralInformationId(response: AxiosResponse): Promise<IntermediateStatusStep[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntermediateStatusStep.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntermediateStatusStep[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediateStatusStep[]>(null as any);
    }

    /**
     * @param subProjectId (optional) 
     * @return OK
     */
    assessmentPerSubProject(subProjectId: string | undefined, cancelToken?: CancelToken): Promise<Assessment[]> {
        let url_ = this.baseUrl + "/api/assessmentPerSubProject?";
        if (subProjectId === null)
            throw new globalThis.Error("The parameter 'subProjectId' cannot be null.");
        else if (subProjectId !== undefined)
            url_ += "subProjectId=" + encodeURIComponent("" + subProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssessmentPerSubProject(_response));
        });
    }

    protected processAssessmentPerSubProject(response: AxiosResponse): Promise<Assessment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assessment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Assessment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment[]>(null as any);
    }

    /**
     * @param subProjectId (optional) 
     * @return OK
     */
    skillAreasInSubProject(subProjectId: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/skillAreasInSubProject?";
        if (subProjectId === null)
            throw new globalThis.Error("The parameter 'subProjectId' cannot be null.");
        else if (subProjectId !== undefined)
            url_ += "subProjectId=" + encodeURIComponent("" + subProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSkillAreasInSubProject(_response));
        });
    }

    protected processSkillAreasInSubProject(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    projectSubProjectAssessmentTree( cancelToken?: CancelToken): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/projectSubProjectAssessmentTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProjectSubProjectAssessmentTree(_response));
        });
    }

    protected processProjectSubProjectAssessmentTree(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * @param subProjectId (optional) 
     * @return OK
     */
    getSelectedProjectBySubProject(subProjectId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/getSelectedProjectBySubProject?";
        if (subProjectId === null)
            throw new globalThis.Error("The parameter 'subProjectId' cannot be null.");
        else if (subProjectId !== undefined)
            url_ += "subProjectId=" + encodeURIComponent("" + subProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSelectedProjectBySubProject(_response));
        });
    }

    protected processGetSelectedProjectBySubProject(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    checkDataInDestinationAssessmentSkillAreas(assessmentId: string | undefined, cancelToken?: CancelToken): Promise<SkillAreaStatus[]> {
        let url_ = this.baseUrl + "/api/checkDataInDestinationAssessmentSkillAreas?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckDataInDestinationAssessmentSkillAreas(_response));
        });
    }

    protected processCheckDataInDestinationAssessmentSkillAreas(response: AxiosResponse): Promise<SkillAreaStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SkillAreaStatus.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SkillAreaStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillAreaStatus[]>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    checkDataInAssessmentSkillAreas(assessmentId: string | undefined, cancelToken?: CancelToken): Promise<SkillAreaStatus[]> {
        let url_ = this.baseUrl + "/api/checkDataInAssessmentSkillAreas?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckDataInAssessmentSkillAreas(_response));
        });
    }

    protected processCheckDataInAssessmentSkillAreas(response: AxiosResponse): Promise<SkillAreaStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SkillAreaStatus.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SkillAreaStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillAreaStatus[]>(null as any);
    }

    /**
     * @param sourceAssessmentId (optional) 
     * @param destinationSubProjectId (optional) 
     * @param newAssessmentName (optional) 
     * @param developmentStageId (optional) 
     * @param isCopyToAssessment (optional) 
     * @param destinationAssessmentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    copyAssessmentToSubProject(sourceAssessmentId: string | undefined, destinationSubProjectId: string | undefined, newAssessmentName: string | undefined, developmentStageId: string | undefined, isCopyToAssessment: boolean | undefined, destinationAssessmentId: string | undefined, body: string[] | undefined, cancelToken?: CancelToken): Promise<Assessment> {
        let url_ = this.baseUrl + "/api/copyAssessmentToSubProject?";
        if (sourceAssessmentId === null)
            throw new globalThis.Error("The parameter 'sourceAssessmentId' cannot be null.");
        else if (sourceAssessmentId !== undefined)
            url_ += "sourceAssessmentId=" + encodeURIComponent("" + sourceAssessmentId) + "&";
        if (destinationSubProjectId === null)
            throw new globalThis.Error("The parameter 'destinationSubProjectId' cannot be null.");
        else if (destinationSubProjectId !== undefined)
            url_ += "destinationSubProjectId=" + encodeURIComponent("" + destinationSubProjectId) + "&";
        if (newAssessmentName === null)
            throw new globalThis.Error("The parameter 'newAssessmentName' cannot be null.");
        else if (newAssessmentName !== undefined)
            url_ += "newAssessmentName=" + encodeURIComponent("" + newAssessmentName) + "&";
        if (developmentStageId === null)
            throw new globalThis.Error("The parameter 'developmentStageId' cannot be null.");
        else if (developmentStageId !== undefined)
            url_ += "developmentStageId=" + encodeURIComponent("" + developmentStageId) + "&";
        if (isCopyToAssessment === null)
            throw new globalThis.Error("The parameter 'isCopyToAssessment' cannot be null.");
        else if (isCopyToAssessment !== undefined)
            url_ += "isCopyToAssessment=" + encodeURIComponent("" + isCopyToAssessment) + "&";
        if (destinationAssessmentId === null)
            throw new globalThis.Error("The parameter 'destinationAssessmentId' cannot be null.");
        else if (destinationAssessmentId !== undefined)
            url_ += "destinationAssessmentId=" + encodeURIComponent("" + destinationAssessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCopyAssessmentToSubProject(_response));
        });
    }

    protected processCopyAssessmentToSubProject(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * @return OK
     */
    bookmarkedAssessmentList( cancelToken?: CancelToken): Promise<Assessment[]> {
        let url_ = this.baseUrl + "/api/bookmarkedAssessmentList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBookmarkedAssessmentList(_response));
        });
    }

    protected processBookmarkedAssessmentList(response: AxiosResponse): Promise<Assessment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assessment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Assessment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment[]>(null as any);
    }

    /**
     * @return OK
     */
    generateAssessmentNumber( cancelToken?: CancelToken): Promise<GeneratedAssessmentNumber> {
        let url_ = this.baseUrl + "/api/generateAssessmentNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateAssessmentNumber(_response));
        });
    }

    protected processGenerateAssessmentNumber(response: AxiosResponse): Promise<GeneratedAssessmentNumber> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneratedAssessmentNumber.fromJS(resultData200);
            return Promise.resolve<GeneratedAssessmentNumber>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneratedAssessmentNumber>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postAssessmentCollaborators(body: AssessmentCollaboratorPut | undefined, cancelToken?: CancelToken): Promise<Assessment> {
        let url_ = this.baseUrl + "/api/postAssessmentCollaborators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostAssessmentCollaborators(_response));
        });
    }

    protected processPostAssessmentCollaborators(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postassessmentonly(body: Assessment | undefined, cancelToken?: CancelToken): Promise<Assessment> {
        let url_ = this.baseUrl + "/api/Postassessmentonly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostassessmentonly(_response));
        });
    }

    protected processPostassessmentonly(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * @return OK
     */
    assessment(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/assessment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssessment(_response));
        });
    }

    protected processAssessment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    assessmentDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessmentDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssessmentDelete(_response));
        });
    }

    protected processAssessmentDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    removeCollaboratorFromAssessment(id: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/removeCollaboratorFromAssessment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveCollaboratorFromAssessment(_response));
        });
    }

    protected processRemoveCollaboratorFromAssessment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addCollaboratorInAssessment(body: AssessmentCollaborators | undefined, cancelToken?: CancelToken): Promise<AssessmentCollaborators> {
        let url_ = this.baseUrl + "/api/addCollaboratorInAssessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddCollaboratorInAssessment(_response));
        });
    }

    protected processAddCollaboratorInAssessment(response: AxiosResponse): Promise<AssessmentCollaborators> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentCollaborators.fromJS(resultData200);
            return Promise.resolve<AssessmentCollaborators>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentCollaborators>(null as any);
    }

    /**
     * @return OK
     */
    checkSingleUtilitiesMode(assessmentId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkSingleUtilitiesMode/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckSingleUtilitiesMode(_response));
        });
    }

    protected processCheckSingleUtilitiesMode(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isLock (optional) 
     * @return OK
     */
    assessmentLockUnlock(id: string | undefined, isLock: boolean | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessmentLockUnlock?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isLock === null)
            throw new globalThis.Error("The parameter 'isLock' cannot be null.");
        else if (isLock !== undefined)
            url_ += "isLock=" + encodeURIComponent("" + isLock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssessmentLockUnlock(_response));
        });
    }

    protected processAssessmentLockUnlock(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    configurationVariable(id: string, cancelToken?: CancelToken): Promise<ConfigurationVariable> {
        let url_ = this.baseUrl + "/api/configurationVariable/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfigurationVariable(_response));
        });
    }

    protected processConfigurationVariable(response: AxiosResponse): Promise<ConfigurationVariable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationVariable.fromJS(resultData200);
            return Promise.resolve<ConfigurationVariable>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationVariable>(null as any);
    }

    /**
     * @return OK
     */
    developmentStageAll( cancelToken?: CancelToken): Promise<DevelopmentStage[]> {
        let url_ = this.baseUrl + "/api/developmentStageAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDevelopmentStageAll(_response));
        });
    }

    protected processDevelopmentStageAll(response: AxiosResponse): Promise<DevelopmentStage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DevelopmentStage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DevelopmentStage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DevelopmentStage[]>(null as any);
    }

    /**
     * @return OK
     */
    developmentStageGet(id: string, cancelToken?: CancelToken): Promise<DevelopmentStage> {
        let url_ = this.baseUrl + "/api/developmentStage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDevelopmentStageGet(_response));
        });
    }

    protected processDevelopmentStageGet(response: AxiosResponse): Promise<DevelopmentStage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DevelopmentStage.fromJS(resultData200);
            return Promise.resolve<DevelopmentStage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DevelopmentStage>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    developmentStagePut(id: string, body: DevelopmentStage | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/developmentStage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDevelopmentStagePut(_response));
        });
    }

    protected processDevelopmentStagePut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    developmentStageDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/developmentStage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDevelopmentStageDelete(_response));
        });
    }

    protected processDevelopmentStageDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    developmentStagePost(body: DevelopmentStage | undefined, cancelToken?: CancelToken): Promise<DevelopmentStage> {
        let url_ = this.baseUrl + "/api/developmentStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDevelopmentStagePost(_response));
        });
    }

    protected processDevelopmentStagePost(response: AxiosResponse): Promise<DevelopmentStage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DevelopmentStage.fromJS(resultData200);
            return Promise.resolve<DevelopmentStage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DevelopmentStage>(null as any);
    }

    /**
     * @return OK
     */
    getDownstreamDistDropdowns( cancelToken?: CancelToken): Promise<DownstreamDistributionDropdowns> {
        let url_ = this.baseUrl + "/api/getDownstreamDistDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownstreamDistDropdowns(_response));
        });
    }

    protected processGetDownstreamDistDropdowns(response: AxiosResponse): Promise<DownstreamDistributionDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownstreamDistributionDropdowns.fromJS(resultData200);
            return Promise.resolve<DownstreamDistributionDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownstreamDistributionDropdowns>(null as any);
    }

    /**
     * @param typeOfTransportId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getDownstreamDistDistributionDefaults(typeOfTransportId: string | undefined, stepId: string | undefined, cancelToken?: CancelToken): Promise<DownstreamStep[]> {
        let url_ = this.baseUrl + "/api/getDownstreamDistDistributionDefaults?";
        if (typeOfTransportId === null)
            throw new globalThis.Error("The parameter 'typeOfTransportId' cannot be null.");
        else if (typeOfTransportId !== undefined)
            url_ += "typeOfTransportId=" + encodeURIComponent("" + typeOfTransportId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownstreamDistDistributionDefaults(_response));
        });
    }

    protected processGetDownstreamDistDistributionDefaults(response: AxiosResponse): Promise<DownstreamStep[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DownstreamStep.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DownstreamStep[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownstreamStep[]>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return OK
     */
    getDownstreamDistDistribution(stepId: string | undefined, cancelToken?: CancelToken): Promise<DownstreamStep[]> {
        let url_ = this.baseUrl + "/api/getDownstreamDistDistribution?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownstreamDistDistribution(_response));
        });
    }

    protected processGetDownstreamDistDistribution(response: AxiosResponse): Promise<DownstreamStep[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DownstreamStep.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DownstreamStep[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownstreamStep[]>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return OK
     */
    getDownstreamDistDistributionBasicInfo(stepId: string | undefined, cancelToken?: CancelToken): Promise<Downstream> {
        let url_ = this.baseUrl + "/api/getDownstreamDistDistributionBasicInfo?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownstreamDistDistributionBasicInfo(_response));
        });
    }

    protected processGetDownstreamDistDistributionBasicInfo(response: AxiosResponse): Promise<Downstream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Downstream.fromJS(resultData200);
            return Promise.resolve<Downstream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Downstream>(null as any);
    }

    /**
     * @param typeOfTransportId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    postDistributionDownstream(typeOfTransportId: string | undefined, stepId: string | undefined, cancelToken?: CancelToken): Promise<Downstream> {
        let url_ = this.baseUrl + "/api/postDistributionDownstream?";
        if (typeOfTransportId === null)
            throw new globalThis.Error("The parameter 'typeOfTransportId' cannot be null.");
        else if (typeOfTransportId !== undefined)
            url_ += "typeOfTransportId=" + encodeURIComponent("" + typeOfTransportId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostDistributionDownstream(_response));
        });
    }

    protected processPostDistributionDownstream(response: AxiosResponse): Promise<Downstream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Downstream.fromJS(resultData200);
            return Promise.resolve<Downstream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Downstream>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postDistributionStepFromTable(body: DownstreamStep | undefined, cancelToken?: CancelToken): Promise<DownstreamStep> {
        let url_ = this.baseUrl + "/api/postDistributionStepFromTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostDistributionStepFromTable(_response));
        });
    }

    protected processPostDistributionStepFromTable(response: AxiosResponse): Promise<DownstreamStep> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownstreamStep.fromJS(resultData200);
            return Promise.resolve<DownstreamStep>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownstreamStep>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postDistributionTransportFromTable(body: DownstreamDistribution | undefined, cancelToken?: CancelToken): Promise<DownstreamDistribution> {
        let url_ = this.baseUrl + "/api/postDistributionTransportFromTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostDistributionTransportFromTable(_response));
        });
    }

    protected processPostDistributionTransportFromTable(response: AxiosResponse): Promise<DownstreamDistribution> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownstreamDistribution.fromJS(resultData200);
            return Promise.resolve<DownstreamDistribution>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownstreamDistribution>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteDistributionTransportFromTable(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/deleteDistributionTransportFromTable?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDistributionTransportFromTable(_response));
        });
    }

    protected processDeleteDistributionTransportFromTable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadReportPackagingDistribution(screenName: string, body: ExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/downloadReportPackagingDistribution/{screenName}";
        if (screenName === undefined || screenName === null)
            throw new globalThis.Error("The parameter 'screenName' must be defined.");
        url_ = url_.replace("{screenName}", encodeURIComponent("" + screenName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadReportPackagingDistribution(_response));
        });
    }

    protected processDownloadReportPackagingDistribution(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadReportOthers(screenId: string, body: ExportRequestOther | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/downloadReportOthers/{screenId}";
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadReportOthers(_response));
        });
    }

    protected processDownloadReportOthers(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAllCountsByPersonId(id: string, cancelToken?: CancelToken): Promise<PersonParticipationCount> {
        let url_ = this.baseUrl + "/api/getAllCountsByPersonId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllCountsByPersonId(_response));
        });
    }

    protected processGetAllCountsByPersonId(response: AxiosResponse): Promise<PersonParticipationCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonParticipationCount.fromJS(resultData200);
            return Promise.resolve<PersonParticipationCount>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonParticipationCount>(null as any);
    }

    /**
     * @return OK
     */
    getFavoritesTreeByPersonId(id: string, cancelToken?: CancelToken): Promise<TreeItem[]> {
        let url_ = this.baseUrl + "/api/getFavoritesTreeByPersonId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFavoritesTreeByPersonId(_response));
        });
    }

    protected processGetFavoritesTreeByPersonId(response: AxiosResponse): Promise<TreeItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TreeItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeItem[]>(null as any);
    }

    /**
     * @return OK
     */
    getFavoritesByPersonId(id: string, cancelToken?: CancelToken): Promise<Favorites[]> {
        let url_ = this.baseUrl + "/api/getFavoritesByPersonId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFavoritesByPersonId(_response));
        });
    }

    protected processGetFavoritesByPersonId(response: AxiosResponse): Promise<Favorites[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Favorites.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Favorites[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Favorites[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addRemoveAssessmentToFavoritesPerPersonId(body: Favorites | undefined, cancelToken?: CancelToken): Promise<FavoriteStatus> {
        let url_ = this.baseUrl + "/api/addRemoveAssessmentToFavoritesPerPersonId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddRemoveAssessmentToFavoritesPerPersonId(_response));
        });
    }

    protected processAddRemoveAssessmentToFavoritesPerPersonId(response: AxiosResponse): Promise<FavoriteStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FavoriteStatus.fromJS(resultData200);
            return Promise.resolve<FavoriteStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FavoriteStatus>(null as any);
    }

    /**
     * @return OK
     */
    featureFlag(id: string, cancelToken?: CancelToken): Promise<FeatureFlag> {
        let url_ = this.baseUrl + "/api/FeatureFlag/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFeatureFlag(_response));
        });
    }

    protected processFeatureFlag(response: AxiosResponse): Promise<FeatureFlag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeatureFlag.fromJS(resultData200);
            return Promise.resolve<FeatureFlag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureFlag>(null as any);
    }

    /**
     * @param searchPerson (optional) 
     * @return OK
     */
    filterPersonForCollaborators(searchPerson: string | undefined, cancelToken?: CancelToken): Promise<Person[]> {
        let url_ = this.baseUrl + "/api/filterPersonForCollaborators?";
        if (searchPerson === null)
            throw new globalThis.Error("The parameter 'searchPerson' cannot be null.");
        else if (searchPerson !== undefined)
            url_ += "searchPerson=" + encodeURIComponent("" + searchPerson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFilterPersonForCollaborators(_response));
        });
    }

    protected processFilterPersonForCollaborators(response: AxiosResponse): Promise<Person[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Person.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Person[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person[]>(null as any);
    }

    /**
     * @return OK
     */
    getdosesDropdowns( cancelToken?: CancelToken): Promise<DosesDropdowns> {
        let url_ = this.baseUrl + "/api/getdosesDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetdosesDropdowns(_response));
        });
    }

    protected processGetdosesDropdowns(response: AxiosResponse): Promise<DosesDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DosesDropdowns.fromJS(resultData200);
            return Promise.resolve<DosesDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DosesDropdowns>(null as any);
    }

    /**
     * @return OK
     */
    getPackDropdowns( cancelToken?: CancelToken): Promise<PackDropdowns> {
        let url_ = this.baseUrl + "/api/getPackDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPackDropdowns(_response));
        });
    }

    protected processGetPackDropdowns(response: AxiosResponse): Promise<PackDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PackDropdowns.fromJS(resultData200);
            return Promise.resolve<PackDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PackDropdowns>(null as any);
    }

    /**
     * @return OK
     */
    getDistDropdowns( cancelToken?: CancelToken): Promise<DistDropdowns> {
        let url_ = this.baseUrl + "/api/getDistDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDistDropdowns(_response));
        });
    }

    protected processGetDistDropdowns(response: AxiosResponse): Promise<DistDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DistDropdowns.fromJS(resultData200);
            return Promise.resolve<DistDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistDropdowns>(null as any);
    }

    /**
     * @return OK
     */
    getBioGeneralInfoDropdowns( cancelToken?: CancelToken): Promise<GeneralBioDropdowns> {
        let url_ = this.baseUrl + "/api/getBioGeneralInfoDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBioGeneralInfoDropdowns(_response));
        });
    }

    protected processGetBioGeneralInfoDropdowns(response: AxiosResponse): Promise<GeneralBioDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralBioDropdowns.fromJS(resultData200);
            return Promise.resolve<GeneralBioDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralBioDropdowns>(null as any);
    }

    /**
     * @return OK
     */
    getCommonAPIGeneralByAssessmentIdAndScreenId(assessmentId: string, screenId: string, cancelToken?: CancelToken): Promise<GeneralInformation[]> {
        let url_ = this.baseUrl + "/api/getCommonAPIGeneralByAssessmentIdAndScreenId/{assessmentId}/{screenId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCommonAPIGeneralByAssessmentIdAndScreenId(_response));
        });
    }

    protected processGetCommonAPIGeneralByAssessmentIdAndScreenId(response: AxiosResponse): Promise<GeneralInformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralInformation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GeneralInformation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation[]>(null as any);
    }

    /**
     * @return OK
     */
    setGeneralInformationSelected(generalInformationId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/setGeneralInformationSelected/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetGeneralInformationSelected(_response));
        });
    }

    protected processSetGeneralInformationSelected(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param generalInformationId (optional) 
     * @return OK
     */
    checkIfDeviceMaterialNeedToBeDisabled(generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfDeviceMaterialNeedToBeDisabled?";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfDeviceMaterialNeedToBeDisabled(_response));
        });
    }

    protected processCheckIfDeviceMaterialNeedToBeDisabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return OK
     */
    checkIfResultNeedToBeEnabled(stepId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfResultNeedToBeEnabled?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfResultNeedToBeEnabled(_response));
        });
    }

    protected processCheckIfResultNeedToBeEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    checkIfResultNeedToBeEnabledDistributionPackagingByAssessmentId(assessmentId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfResultNeedToBeEnabledDistributionPackagingByAssessmentId?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfResultNeedToBeEnabledDistributionPackagingByAssessmentId(_response));
        });
    }

    protected processCheckIfResultNeedToBeEnabledDistributionPackagingByAssessmentId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    checkIfGeneralInfoIsPresentForDistributionPackagingByAssessmentId(assessmentId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfGeneralInfoIsPresentForDistributionPackagingByAssessmentId?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfGeneralInfoIsPresentForDistributionPackagingByAssessmentId(_response));
        });
    }

    protected processCheckIfGeneralInfoIsPresentForDistributionPackagingByAssessmentId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param operationId (optional) 
     * @return OK
     */
    getGeneralInformationById(generalInformationId: string, operationId: string | undefined, cancelToken?: CancelToken): Promise<GeneralInformation> {
        let url_ = this.baseUrl + "/api/getGeneralInformationById/{generalInformationId}?";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGeneralInformationById(_response));
        });
    }

    protected processGetGeneralInformationById(response: AxiosResponse): Promise<GeneralInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInformation.fromJS(resultData200);
            return Promise.resolve<GeneralInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation>(null as any);
    }

    /**
     * @return OK
     */
    getCommonAPISingleGeneralByAssessmentIdAndScreenId(assessmentId: string, screenId: string, cancelToken?: CancelToken): Promise<GeneralInformation> {
        let url_ = this.baseUrl + "/api/getCommonAPISingleGeneralByAssessmentIdAndScreenId/{assessmentId}/{screenId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCommonAPISingleGeneralByAssessmentIdAndScreenId(_response));
        });
    }

    protected processGetCommonAPISingleGeneralByAssessmentIdAndScreenId(response: AxiosResponse): Promise<GeneralInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInformation.fromJS(resultData200);
            return Promise.resolve<GeneralInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation>(null as any);
    }

    /**
     * @return OK
     */
    getCommonAPISingleGeneralByAssessmentIdAndScreenIdPP(assessmentId: string, cancelToken?: CancelToken): Promise<GeneralInformation> {
        let url_ = this.baseUrl + "/api/getCommonAPISingleGeneralByAssessmentIdAndScreenIdPP/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCommonAPISingleGeneralByAssessmentIdAndScreenIdPP(_response));
        });
    }

    protected processGetCommonAPISingleGeneralByAssessmentIdAndScreenIdPP(response: AxiosResponse): Promise<GeneralInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInformation.fromJS(resultData200);
            return Promise.resolve<GeneralInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation>(null as any);
    }

    /**
     * @return OK
     */
    getStepByAssessmentIdScreenIdGeneralInfomationId(assessmentId: string, screenId: string, generalInformationId: string, cancelToken?: CancelToken): Promise<Step[]> {
        let url_ = this.baseUrl + "/api/getStepByAssessmentIdScreenIdGeneralInfomationId/{assessmentId}/{screenId}/{generalInformationId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStepByAssessmentIdScreenIdGeneralInfomationId(_response));
        });
    }

    protected processGetStepByAssessmentIdScreenIdGeneralInfomationId(response: AxiosResponse): Promise<Step[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Step.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Step[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step[]>(null as any);
    }

    /**
     * @return OK
     */
    getStepsAndIntermediates(assessmentId: string, screenId: string, generalInformationId: string, cancelToken?: CancelToken): Promise<GeneralInformationData> {
        let url_ = this.baseUrl + "/api/getStepsAndIntermediates/{assessmentId}/{screenId}/{generalInformationId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStepsAndIntermediates(_response));
        });
    }

    protected processGetStepsAndIntermediates(response: AxiosResponse): Promise<GeneralInformationData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInformationData.fromJS(resultData200);
            return Promise.resolve<GeneralInformationData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformationData>(null as any);
    }

    /**
     * @return OK
     */
    getUnitOperationByScreenAssessment(assessmentId: string, screenId: string, cancelToken?: CancelToken): Promise<UnitOperation[]> {
        let url_ = this.baseUrl + "/api/getUnitOperationByScreenAssessment/{assessmentId}/{screenId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitOperationByScreenAssessment(_response));
        });
    }

    protected processGetUnitOperationByScreenAssessment(response: AxiosResponse): Promise<UnitOperation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitOperation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnitOperation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitOperation[]>(null as any);
    }

    /**
     * @return OK
     */
    getCompOptions(compOptionId: string, cancelToken?: CancelToken): Promise<CompOption[]> {
        let url_ = this.baseUrl + "/api/getCompOptions/{compOptionId}";
        if (compOptionId === undefined || compOptionId === null)
            throw new globalThis.Error("The parameter 'compOptionId' must be defined.");
        url_ = url_.replace("{compOptionId}", encodeURIComponent("" + compOptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCompOptions(_response));
        });
    }

    protected processGetCompOptions(response: AxiosResponse): Promise<CompOption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompOption.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CompOption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompOption[]>(null as any);
    }

    /**
     * @return OK
     */
    getUnitOperationsByCompOptionName(compOptionName: string, screenId: string, cancelToken?: CancelToken): Promise<UnitOperation[]> {
        let url_ = this.baseUrl + "/api/getUnitOperationsByCompOptionName/{compOptionName}/{screenId}";
        if (compOptionName === undefined || compOptionName === null)
            throw new globalThis.Error("The parameter 'compOptionName' must be defined.");
        url_ = url_.replace("{compOptionName}", encodeURIComponent("" + compOptionName));
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitOperationsByCompOptionName(_response));
        });
    }

    protected processGetUnitOperationsByCompOptionName(response: AxiosResponse): Promise<UnitOperation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitOperation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnitOperation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitOperation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateStepsOrder(body: Step[] | undefined, cancelToken?: CancelToken): Promise<Step[]> {
        let url_ = this.baseUrl + "/api/updateStepsOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStepsOrder(_response));
        });
    }

    protected processUpdateStepsOrder(response: AxiosResponse): Promise<Step[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Step.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Step[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step[]>(null as any);
    }

    /**
     * @param stepid (optional) 
     * @param isGlobal (optional) 
     * @return OK
     */
    updatePPGlobalLocation(stepid: string | undefined, isGlobal: boolean | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/updatePPGlobalLocation?";
        if (stepid === null)
            throw new globalThis.Error("The parameter 'stepid' cannot be null.");
        else if (stepid !== undefined)
            url_ += "stepid=" + encodeURIComponent("" + stepid) + "&";
        if (isGlobal === null)
            throw new globalThis.Error("The parameter 'isGlobal' cannot be null.");
        else if (isGlobal !== undefined)
            url_ += "isGlobal=" + encodeURIComponent("" + isGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePPGlobalLocation(_response));
        });
    }

    protected processUpdatePPGlobalLocation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param action (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateStepData(action: string | undefined, body: Step | undefined, cancelToken?: CancelToken): Promise<Step> {
        let url_ = this.baseUrl + "/api/updateStepData?";
        if (action === null)
            throw new globalThis.Error("The parameter 'action' cannot be null.");
        else if (action !== undefined)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStepData(_response));
        });
    }

    protected processUpdateStepData(response: AxiosResponse): Promise<Step> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Step.fromJS(resultData200);
            return Promise.resolve<Step>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postCommonAPIGeneralInformation(body: GeneralInformation | undefined, cancelToken?: CancelToken): Promise<GeneralInformation> {
        let url_ = this.baseUrl + "/api/postCommonAPIGeneralInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostCommonAPIGeneralInformation(_response));
        });
    }

    protected processPostCommonAPIGeneralInformation(response: AxiosResponse): Promise<GeneralInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInformation.fromJS(resultData200);
            return Promise.resolve<GeneralInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @param body (optional) 
     * @return OK
     */
    postSaveStep(assessmentId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined, body: Step[] | undefined, cancelToken?: CancelToken): Promise<Step[]> {
        let url_ = this.baseUrl + "/api/postSaveStep?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostSaveStep(_response));
        });
    }

    protected processPostSaveStep(response: AxiosResponse): Promise<Step[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Step.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Step[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step[]>(null as any);
    }

    /**
     * @return OK
     */
    getProductFormatIdFromProductProcess(assessmentId: string, cancelToken?: CancelToken): Promise<GeneralInformation> {
        let url_ = this.baseUrl + "/api/getProductFormatIdFromProductProcess/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductFormatIdFromProductProcess(_response));
        });
    }

    protected processGetProductFormatIdFromProductProcess(response: AxiosResponse): Promise<GeneralInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInformation.fromJS(resultData200);
            return Promise.resolve<GeneralInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation>(null as any);
    }

    /**
     * @return OK
     */
    checkIfSubprojectHasProductProcessScreen(assessmentId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfSubprojectHasProductProcessScreen/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfSubprojectHasProductProcessScreen(_response));
        });
    }

    protected processCheckIfSubprojectHasProductProcessScreen(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDevicePackagingFromProductProcess(body: UpdateDevicePackagingRequest | undefined, cancelToken?: CancelToken): Promise<GeneralInformation[]> {
        let url_ = this.baseUrl + "/api/UpdateDevicePackagingFromProductProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDevicePackagingFromProductProcess(_response));
        });
    }

    protected processUpdateDevicePackagingFromProductProcess(response: AxiosResponse): Promise<GeneralInformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralInformation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GeneralInformation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation[]>(null as any);
    }

    /**
     * @return OK
     */
    softDeleteGeneralInformation(generalInformationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/softDeleteGeneralInformation/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSoftDeleteGeneralInformation(_response));
        });
    }

    protected processSoftDeleteGeneralInformation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getActiveGeneralInformationCount(assessmentId: string, screenId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/getActiveGeneralInformationCount/{assessmentId}/{screenId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveGeneralInformationCount(_response));
        });
    }

    protected processGetActiveGeneralInformationCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    helpPageAll( cancelToken?: CancelToken): Promise<HelpPage[]> {
        let url_ = this.baseUrl + "/api/helpPageAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpPageAll(_response));
        });
    }

    protected processHelpPageAll(response: AxiosResponse): Promise<HelpPage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HelpPage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HelpPage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpPage[]>(null as any);
    }

    /**
     * @param helpPageName (optional) 
     * @return OK
     */
    getHelpPageByName(helpPageName: string | undefined, cancelToken?: CancelToken): Promise<HelpPage> {
        let url_ = this.baseUrl + "/api/getHelpPageByName?";
        if (helpPageName === null)
            throw new globalThis.Error("The parameter 'helpPageName' cannot be null.");
        else if (helpPageName !== undefined)
            url_ += "helpPageName=" + encodeURIComponent("" + helpPageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHelpPageByName(_response));
        });
    }

    protected processGetHelpPageByName(response: AxiosResponse): Promise<HelpPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HelpPage.fromJS(resultData200);
            return Promise.resolve<HelpPage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpPage>(null as any);
    }

    /**
     * @return OK
     */
    helpGet(id: string, cancelToken?: CancelToken): Promise<HelpPage> {
        let url_ = this.baseUrl + "/api/help/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpGet(_response));
        });
    }

    protected processHelpGet(response: AxiosResponse): Promise<HelpPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HelpPage.fromJS(resultData200);
            return Promise.resolve<HelpPage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpPage>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    helpPut(id: string, body: HelpPage | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/help/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpPut(_response));
        });
    }

    protected processHelpPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    helpDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/help/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpDelete(_response));
        });
    }

    protected processHelpDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    helpPost(body: HelpPage | undefined, cancelToken?: CancelToken): Promise<HelpPage> {
        let url_ = this.baseUrl + "/api/help";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpPost(_response));
        });
    }

    protected processHelpPost(response: AxiosResponse): Promise<HelpPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HelpPage.fromJS(resultData200);
            return Promise.resolve<HelpPage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpPage>(null as any);
    }

    /**
     * @return OK
     */
    helpFieldAll( cancelToken?: CancelToken): Promise<HelpField[]> {
        let url_ = this.baseUrl + "/api/helpFieldAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpFieldAll(_response));
        });
    }

    protected processHelpFieldAll(response: AxiosResponse): Promise<HelpField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HelpField.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HelpField[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpField[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    helpFieldAllbyPageid(id: string | undefined, cancelToken?: CancelToken): Promise<HelpField[]> {
        let url_ = this.baseUrl + "/api/helpFieldAllbyPageid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpFieldAllbyPageid(_response));
        });
    }

    protected processHelpFieldAllbyPageid(response: AxiosResponse): Promise<HelpField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HelpField.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HelpField[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpField[]>(null as any);
    }

    /**
     * @return OK
     */
    helpFieldGet(id: string, cancelToken?: CancelToken): Promise<HelpField> {
        let url_ = this.baseUrl + "/api/helpField/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpFieldGet(_response));
        });
    }

    protected processHelpFieldGet(response: AxiosResponse): Promise<HelpField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HelpField.fromJS(resultData200);
            return Promise.resolve<HelpField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpField>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    helpFieldPut(id: string, body: HelpField | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/helpField/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpFieldPut(_response));
        });
    }

    protected processHelpFieldPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    helpFieldDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/helpField/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpFieldDelete(_response));
        });
    }

    protected processHelpFieldDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    helpFieldPost(body: HelpField | undefined, cancelToken?: CancelToken): Promise<HelpField> {
        let url_ = this.baseUrl + "/api/helpField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHelpFieldPost(_response));
        });
    }

    protected processHelpFieldPost(response: AxiosResponse): Promise<HelpField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HelpField.fromJS(resultData200);
            return Promise.resolve<HelpField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HelpField>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getHierarchyByTreeId(id: string | undefined, cancelToken?: CancelToken): Promise<Hierarchy[]> {
        let url_ = this.baseUrl + "/api/getHierarchyByTreeId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHierarchyByTreeId(_response));
        });
    }

    protected processGetHierarchyByTreeId(response: AxiosResponse): Promise<Hierarchy[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Hierarchy.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Hierarchy[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Hierarchy[]>(null as any);
    }

    /**
     * @param treeId (optional) 
     * @return OK
     */
    getPrimeVueHierarchyByTreeId(treeId: string | undefined, cancelToken?: CancelToken): Promise<PrimeVueHierarchy> {
        let url_ = this.baseUrl + "/api/getPrimeVueHierarchyByTreeId?";
        if (treeId === null)
            throw new globalThis.Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPrimeVueHierarchyByTreeId(_response));
        });
    }

    protected processGetPrimeVueHierarchyByTreeId(response: AxiosResponse): Promise<PrimeVueHierarchy> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrimeVueHierarchy.fromJS(resultData200);
            return Promise.resolve<PrimeVueHierarchy>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrimeVueHierarchy>(null as any);
    }

    /**
     * @param treeName (optional) 
     * @return OK
     */
    getPrimeVueHierarchyByTreeName(treeName: string | undefined, cancelToken?: CancelToken): Promise<PrimeVueHierarchy> {
        let url_ = this.baseUrl + "/api/getPrimeVueHierarchyByTreeName?";
        if (treeName === null)
            throw new globalThis.Error("The parameter 'treeName' cannot be null.");
        else if (treeName !== undefined)
            url_ += "treeName=" + encodeURIComponent("" + treeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPrimeVueHierarchyByTreeName(_response));
        });
    }

    protected processGetPrimeVueHierarchyByTreeName(response: AxiosResponse): Promise<PrimeVueHierarchy> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrimeVueHierarchy.fromJS(resultData200);
            return Promise.resolve<PrimeVueHierarchy>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrimeVueHierarchy>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getHierarchyList(id: string | undefined, cancelToken?: CancelToken): Promise<TreeItems[]> {
        let url_ = this.baseUrl + "/api/getHierarchyList?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHierarchyList(_response));
        });
    }

    protected processGetHierarchyList(response: AxiosResponse): Promise<TreeItems[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeItems.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TreeItems[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeItems[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeItemById(id: string | undefined, cancelToken?: CancelToken): Promise<TreeItems> {
        let url_ = this.baseUrl + "/api/getTreeItemById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTreeItemById(_response));
        });
    }

    protected processGetTreeItemById(response: AxiosResponse): Promise<TreeItems> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TreeItems.fromJS(resultData200);
            return Promise.resolve<TreeItems>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeItems>(null as any);
    }

    /**
     * @return OK
     */
    knowledgeArticleAll( cancelToken?: CancelToken): Promise<KnowledgeArticle[]> {
        let url_ = this.baseUrl + "/api/knowledgeArticleAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeArticleAll(_response));
        });
    }

    protected processKnowledgeArticleAll(response: AxiosResponse): Promise<KnowledgeArticle[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KnowledgeArticle.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<KnowledgeArticle[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticle[]>(null as any);
    }

    /**
     * @return OK
     */
    knowledgeArticleGet(id: string, cancelToken?: CancelToken): Promise<KnowledgeArticle> {
        let url_ = this.baseUrl + "/api/knowledgeArticle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeArticleGet(_response));
        });
    }

    protected processKnowledgeArticleGet(response: AxiosResponse): Promise<KnowledgeArticle> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeArticle.fromJS(resultData200);
            return Promise.resolve<KnowledgeArticle>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticle>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeArticlePut(id: string, body: KnowledgeArticle | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/knowledgeArticle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeArticlePut(_response));
        });
    }

    protected processKnowledgeArticlePut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    knowledgeArticleDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/knowledgeArticle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeArticleDelete(_response));
        });
    }

    protected processKnowledgeArticleDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeArticlePost(body: KnowledgeArticle | undefined, cancelToken?: CancelToken): Promise<KnowledgeArticle> {
        let url_ = this.baseUrl + "/api/knowledgeArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeArticlePost(_response));
        });
    }

    protected processKnowledgeArticlePost(response: AxiosResponse): Promise<KnowledgeArticle> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeArticle.fromJS(resultData200);
            return Promise.resolve<KnowledgeArticle>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticle>(null as any);
    }

    /**
     * @return OK
     */
    knowledgeCategoryAll( cancelToken?: CancelToken): Promise<KnowledgeCategory[]> {
        let url_ = this.baseUrl + "/api/knowledgeCategoryAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeCategoryAll(_response));
        });
    }

    protected processKnowledgeCategoryAll(response: AxiosResponse): Promise<KnowledgeCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KnowledgeCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<KnowledgeCategory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeCategory[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeArticleFeedback(body: KnowledgeArticleFeedback | undefined, cancelToken?: CancelToken): Promise<KnowledgeArticleFeedback> {
        let url_ = this.baseUrl + "/api/knowledgeArticleFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeArticleFeedback(_response));
        });
    }

    protected processKnowledgeArticleFeedback(response: AxiosResponse): Promise<KnowledgeArticleFeedback> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeArticleFeedback.fromJS(resultData200);
            return Promise.resolve<KnowledgeArticleFeedback>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleFeedback>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    knowledgeInfoRequest(body: KnowledgeInfoRequest | undefined, cancelToken?: CancelToken): Promise<KnowledgeInfoRequest> {
        let url_ = this.baseUrl + "/api/knowledgeInfoRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeInfoRequest(_response));
        });
    }

    protected processKnowledgeInfoRequest(response: AxiosResponse): Promise<KnowledgeInfoRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeInfoRequest.fromJS(resultData200);
            return Promise.resolve<KnowledgeInfoRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeInfoRequest>(null as any);
    }

    /**
     * @return OK
     */
    knowledgeTagAll( cancelToken?: CancelToken): Promise<KnowledgeTag[]> {
        let url_ = this.baseUrl + "/api/knowledgeTagAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processKnowledgeTagAll(_response));
        });
    }

    protected processKnowledgeTagAll(response: AxiosResponse): Promise<KnowledgeTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KnowledgeTag.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<KnowledgeTag[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeTag[]>(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    login(token: string | undefined, cancelToken?: CancelToken): Promise<PersonSessionData> {
        let url_ = this.baseUrl + "/api/login?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<PersonSessionData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonSessionData.fromJS(resultData200);
            return Promise.resolve<PersonSessionData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonSessionData>(null as any);
    }

    /**
     * @return OK
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogout(_response));
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getUnitByUnitTypeName(unitTypeName: string, cancelToken?: CancelToken): Promise<Unit[]> {
        let url_ = this.baseUrl + "/api/getUnitByUnitTypeName/{unitTypeName}";
        if (unitTypeName === undefined || unitTypeName === null)
            throw new globalThis.Error("The parameter 'unitTypeName' must be defined.");
        url_ = url_.replace("{unitTypeName}", encodeURIComponent("" + unitTypeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitByUnitTypeName(_response));
        });
    }

    protected processGetUnitByUnitTypeName(response: AxiosResponse): Promise<Unit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Unit.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Unit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllUnitsWithType( cancelToken?: CancelToken): Promise<UnitWithTypeDto[]> {
        let url_ = this.baseUrl + "/api/getAllUnitsWithType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllUnitsWithType(_response));
        });
    }

    protected processGetAllUnitsWithType(response: AxiosResponse): Promise<UnitWithTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitWithTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnitWithTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitWithTypeDto[]>(null as any);
    }

    /**
     * @return OK
     */
    masterCategoryAll( cancelToken?: CancelToken): Promise<MasterCategory[]> {
        let url_ = this.baseUrl + "/api/masterCategoryAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterCategoryAll(_response));
        });
    }

    protected processMasterCategoryAll(response: AxiosResponse): Promise<MasterCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MasterCategory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterCategory[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    masterDropdownByCategoryId(id: string | undefined, cancelToken?: CancelToken): Promise<MasterDropdown[]> {
        let url_ = this.baseUrl + "/api/masterDropdownByCategoryId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterDropdownByCategoryId(_response));
        });
    }

    protected processMasterDropdownByCategoryId(response: AxiosResponse): Promise<MasterDropdown[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MasterDropdown[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDropdown[]>(null as any);
    }

    /**
     * @param categoryKey (optional) 
     * @return OK
     */
    masterDropdownByCategoryKey(categoryKey: string | undefined, cancelToken?: CancelToken): Promise<MasterDropdown[]> {
        let url_ = this.baseUrl + "/api/masterDropdownByCategoryKey?";
        if (categoryKey === null)
            throw new globalThis.Error("The parameter 'categoryKey' cannot be null.");
        else if (categoryKey !== undefined)
            url_ += "categoryKey=" + encodeURIComponent("" + categoryKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterDropdownByCategoryKey(_response));
        });
    }

    protected processMasterDropdownByCategoryKey(response: AxiosResponse): Promise<MasterDropdown[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MasterDropdown[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDropdown[]>(null as any);
    }

    /**
     * @param categoryKey (optional) 
     * @return OK
     */
    masterDropdownByCategoryKeyAll(categoryKey: string | undefined, cancelToken?: CancelToken): Promise<MasterDropdown[]> {
        let url_ = this.baseUrl + "/api/masterDropdownByCategoryKeyAll?";
        if (categoryKey === null)
            throw new globalThis.Error("The parameter 'categoryKey' cannot be null.");
        else if (categoryKey !== undefined)
            url_ += "categoryKey=" + encodeURIComponent("" + categoryKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterDropdownByCategoryKeyAll(_response));
        });
    }

    protected processMasterDropdownByCategoryKeyAll(response: AxiosResponse): Promise<MasterDropdown[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MasterDropdown[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDropdown[]>(null as any);
    }

    /**
     * @return OK
     */
    masterCategoryGet(id: string, cancelToken?: CancelToken): Promise<MasterCategory> {
        let url_ = this.baseUrl + "/api/masterCategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterCategoryGet(_response));
        });
    }

    protected processMasterCategoryGet(response: AxiosResponse): Promise<MasterCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterCategory.fromJS(resultData200);
            return Promise.resolve<MasterCategory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterCategory>(null as any);
    }

    /**
     * @return OK
     */
    masterCategoryDelete(id: string, cancelToken?: CancelToken): Promise<MasterCategory> {
        let url_ = this.baseUrl + "/api/masterCategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterCategoryDelete(_response));
        });
    }

    protected processMasterCategoryDelete(response: AxiosResponse): Promise<MasterCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterCategory.fromJS(resultData200);
            return Promise.resolve<MasterCategory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterCategory>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    masterCategoryPut(id: string, body: MasterCategory | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/masterCategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterCategoryPut(_response));
        });
    }

    protected processMasterCategoryPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    masterCategoryPost(body: MasterCategory | undefined, cancelToken?: CancelToken): Promise<MasterCategory> {
        let url_ = this.baseUrl + "/api/masterCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMasterCategoryPost(_response));
        });
    }

    protected processMasterCategoryPost(response: AxiosResponse): Promise<MasterCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterCategory.fromJS(resultData200);
            return Promise.resolve<MasterCategory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterCategory>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putTheMasterCategory(body: MasterCategory | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/putTheMasterCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutTheMasterCategory(_response));
        });
    }

    protected processPutTheMasterCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putTheDropdown(body: MasterDropdown | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/putTheDropdown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutTheDropdown(_response));
        });
    }

    protected processPutTheDropdown(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveTheDropdownWithMasterCategoryKey(body: MasterDropdown | undefined, cancelToken?: CancelToken): Promise<MasterDropdown> {
        let url_ = this.baseUrl + "/api/saveTheDropdownWithMasterCategoryKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveTheDropdownWithMasterCategoryKey(_response));
        });
    }

    protected processSaveTheDropdownWithMasterCategoryKey(response: AxiosResponse): Promise<MasterDropdown> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterDropdown.fromJS(resultData200);
            return Promise.resolve<MasterDropdown>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDropdown>(null as any);
    }

    /**
     * @return OK
     */
    newsAll( cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/newsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewsAll(_response));
        });
    }

    protected processNewsAll(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return OK
     */
    categoryAll( cancelToken?: CancelToken): Promise<NewsCategory[]> {
        let url_ = this.baseUrl + "/api/categoryAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCategoryAll(_response));
        });
    }

    protected processCategoryAll(response: AxiosResponse): Promise<NewsCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewsCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<NewsCategory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsCategory[]>(null as any);
    }

    /**
     * @return OK
     */
    newsFeed( cancelToken?: CancelToken): Promise<News[]> {
        let url_ = this.baseUrl + "/api/newsFeed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewsFeed(_response));
        });
    }

    protected processNewsFeed(response: AxiosResponse): Promise<News[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(News.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<News[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News[]>(null as any);
    }

    /**
     * @param daysAgo (optional) 
     * @return OK
     */
    newsFeedAll(daysAgo: number | undefined, cancelToken?: CancelToken): Promise<News[]> {
        let url_ = this.baseUrl + "/api/newsFeedAll?";
        if (daysAgo === null)
            throw new globalThis.Error("The parameter 'daysAgo' cannot be null.");
        else if (daysAgo !== undefined)
            url_ += "daysAgo=" + encodeURIComponent("" + daysAgo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewsFeedAll(_response));
        });
    }

    protected processNewsFeedAll(response: AxiosResponse): Promise<News[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(News.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<News[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News[]>(null as any);
    }

    /**
     * @return OK
     */
    newsGet(id: string, cancelToken?: CancelToken): Promise<News> {
        let url_ = this.baseUrl + "/api/news/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewsGet(_response));
        });
    }

    protected processNewsGet(response: AxiosResponse): Promise<News> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = News.fromJS(resultData200);
            return Promise.resolve<News>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News>(null as any);
    }

    /**
     * @return OK
     */
    newsDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/news/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewsDelete(_response));
        });
    }

    protected processNewsDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param newsDetails (optional) 
     * @param file (optional) 
     * @return OK
     */
    newsPut(id: string | undefined, newsDetails: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<News> {
        let url_ = this.baseUrl + "/api/news?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newsDetails === null)
            throw new globalThis.Error("The parameter 'newsDetails' cannot be null.");
        else if (newsDetails !== undefined)
            url_ += "newsDetails=" + encodeURIComponent("" + newsDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewsPut(_response));
        });
    }

    protected processNewsPut(response: AxiosResponse): Promise<News> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = News.fromJS(resultData200);
            return Promise.resolve<News>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News>(null as any);
    }

    /**
     * @param newsDetails (optional) 
     * @param file (optional) 
     * @return OK
     */
    newsPost(newsDetails: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<News> {
        let url_ = this.baseUrl + "/api/news?";
        if (newsDetails === null)
            throw new globalThis.Error("The parameter 'newsDetails' cannot be null.");
        else if (newsDetails !== undefined)
            url_ += "newsDetails=" + encodeURIComponent("" + newsDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewsPost(_response));
        });
    }

    protected processNewsPost(response: AxiosResponse): Promise<News> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = News.fromJS(resultData200);
            return Promise.resolve<News>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News>(null as any);
    }

    /**
     * @param newsId (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    deleteImageFile(newsId: string | undefined, fileName: string | undefined, cancelToken?: CancelToken): Promise<News> {
        let url_ = this.baseUrl + "/api/deleteImageFile?";
        if (newsId === null)
            throw new globalThis.Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteImageFile(_response));
        });
    }

    protected processDeleteImageFile(response: AxiosResponse): Promise<News> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = News.fromJS(resultData200);
            return Promise.resolve<News>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postNewsPersonData(body: NewsPersonLog | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PostNewsPersonData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostNewsPersonData(_response));
        });
    }

    protected processPostNewsPersonData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    personTypeAll( cancelToken?: CancelToken): Promise<PersonType[]> {
        let url_ = this.baseUrl + "/api/personTypeAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPersonTypeAll(_response));
        });
    }

    protected processPersonTypeAll(response: AxiosResponse): Promise<PersonType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PersonType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonType[]>(null as any);
    }

    /**
     * @return OK
     */
    personTypeGet(id: string, cancelToken?: CancelToken): Promise<PersonType> {
        let url_ = this.baseUrl + "/api/personType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPersonTypeGet(_response));
        });
    }

    protected processPersonTypeGet(response: AxiosResponse): Promise<PersonType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonType.fromJS(resultData200);
            return Promise.resolve<PersonType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonType>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    personTypePut(id: string, body: PersonType | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/personType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPersonTypePut(_response));
        });
    }

    protected processPersonTypePut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    personTypeDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/personType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPersonTypeDelete(_response));
        });
    }

    protected processPersonTypeDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    personTypePost(body: PersonType | undefined, cancelToken?: CancelToken): Promise<PersonType> {
        let url_ = this.baseUrl + "/api/personType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPersonTypePost(_response));
        });
    }

    protected processPersonTypePost(response: AxiosResponse): Promise<PersonType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonType.fromJS(resultData200);
            return Promise.resolve<PersonType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonType>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return OK
     */
    checkIfSiteLocationIsSelectedInRawMaterialsForSyntheticAPI(stepId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfSiteLocationIsSelectedInRawMaterialsForSyntheticAPI?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfSiteLocationIsSelectedInRawMaterialsForSyntheticAPI(_response));
        });
    }

    protected processCheckIfSiteLocationIsSelectedInRawMaterialsForSyntheticAPI(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    checkIfEnableConsumerEndOfLifeTab(assessmentId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfEnableConsumerEndOfLifeTab?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfEnableConsumerEndOfLifeTab(_response));
        });
    }

    protected processCheckIfEnableConsumerEndOfLifeTab(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    generateBasicInfoForConsumerEolTab(assessmentId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<BasicInfoConsumerEolTab> {
        let url_ = this.baseUrl + "/api/generateBasicInfoForConsumerEolTab?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateBasicInfoForConsumerEolTab(_response));
        });
    }

    protected processGenerateBasicInfoForConsumerEolTab(response: AxiosResponse): Promise<BasicInfoConsumerEolTab> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BasicInfoConsumerEolTab.fromJS(resultData200);
            return Promise.resolve<BasicInfoConsumerEolTab>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicInfoConsumerEolTab>(null as any);
    }

    /**
     * @param processWasteId (optional) 
     * @param destinationMarket (optional) 
     * @param destinationSetting (optional) 
     * @return OK
     */
    putConsumerProcessWaste(processWasteId: string | undefined, destinationMarket: string | undefined, destinationSetting: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/putConsumerProcessWaste?";
        if (processWasteId === null)
            throw new globalThis.Error("The parameter 'processWasteId' cannot be null.");
        else if (processWasteId !== undefined)
            url_ += "processWasteId=" + encodeURIComponent("" + processWasteId) + "&";
        if (destinationMarket === null)
            throw new globalThis.Error("The parameter 'destinationMarket' cannot be null.");
        else if (destinationMarket !== undefined)
            url_ += "destinationMarket=" + encodeURIComponent("" + destinationMarket) + "&";
        if (destinationSetting === null)
            throw new globalThis.Error("The parameter 'destinationSetting' cannot be null.");
        else if (destinationSetting !== undefined)
            url_ += "destinationSetting=" + encodeURIComponent("" + destinationSetting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutConsumerProcessWaste(_response));
        });
    }

    protected processPutConsumerProcessWaste(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getConsumerEndOfLifeDropdowns( cancelToken?: CancelToken): Promise<ConsumerEndOfLifeDropdowns> {
        let url_ = this.baseUrl + "/api/getConsumerEndOfLifeDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetConsumerEndOfLifeDropdowns(_response));
        });
    }

    protected processGetConsumerEndOfLifeDropdowns(response: AxiosResponse): Promise<ConsumerEndOfLifeDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumerEndOfLifeDropdowns.fromJS(resultData200);
            return Promise.resolve<ConsumerEndOfLifeDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumerEndOfLifeDropdowns>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @param action (optional) 
     * @param region (optional) 
     * @return OK
     */
    populateProcessWasteAndTable(assessmentId: string | undefined, generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, action: string | undefined, region: string | undefined, cancelToken?: CancelToken): Promise<ProcessWasteLoading> {
        let url_ = this.baseUrl + "/api/populateProcessWasteAndTable?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (action === null)
            throw new globalThis.Error("The parameter 'action' cannot be null.");
        else if (action !== undefined)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPopulateProcessWasteAndTable(_response));
        });
    }

    protected processPopulateProcessWasteAndTable(response: AxiosResponse): Promise<ProcessWasteLoading> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessWasteLoading.fromJS(resultData200);
            return Promise.resolve<ProcessWasteLoading>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessWasteLoading>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putProcessWasteBasicInfo(body: ProcessWaste | undefined, cancelToken?: CancelToken): Promise<ProcessWaste> {
        let url_ = this.baseUrl + "/api/putProcessWasteBasicInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutProcessWasteBasicInfo(_response));
        });
    }

    protected processPutProcessWasteBasicInfo(response: AxiosResponse): Promise<ProcessWaste> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessWaste.fromJS(resultData200);
            return Promise.resolve<ProcessWaste>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessWaste>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putProcessWaste(body: ProcessWasteInput | undefined, cancelToken?: CancelToken): Promise<ProcessWasteInput> {
        let url_ = this.baseUrl + "/api/putProcessWaste";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutProcessWaste(_response));
        });
    }

    protected processPutProcessWaste(response: AxiosResponse): Promise<ProcessWasteInput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessWasteInput.fromJS(resultData200);
            return Promise.resolve<ProcessWasteInput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessWasteInput>(null as any);
    }

    /**
     * @return OK
     */
    productFormat(id: string, cancelToken?: CancelToken): Promise<ProductFormat> {
        let url_ = this.baseUrl + "/api/ProductFormat/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProductFormat(_response));
        });
    }

    protected processProductFormat(response: AxiosResponse): Promise<ProductFormat> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductFormat.fromJS(resultData200);
            return Promise.resolve<ProductFormat>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFormat>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getProductFormatSourceScreenId(assessmentId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/GetProductFormatSourceScreenId?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductFormatSourceScreenId(_response));
        });
    }

    protected processGetProductFormatSourceScreenId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getProxyByScreenAndAssessment(screenId: string | undefined, assessmentId: string | undefined, cancelToken?: CancelToken): Promise<ProductProcessProxy[]> {
        let url_ = this.baseUrl + "/api/getProxyByScreenAndAssessment?";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProxyByScreenAndAssessment(_response));
        });
    }

    protected processGetProxyByScreenAndAssessment(response: AxiosResponse): Promise<ProductProcessProxy[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductProcessProxy.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductProcessProxy[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductProcessProxy[]>(null as any);
    }

    /**
     * @param action (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveProxyForProductProcess(action: string | undefined, body: DataToSave | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/saveProxyForProductProcess?";
        if (action === null)
            throw new globalThis.Error("The parameter 'action' cannot be null.");
        else if (action !== undefined)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveProxyForProductProcess(_response));
        });
    }

    protected processSaveProxyForProductProcess(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    projectAll( cancelToken?: CancelToken): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/projectAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProjectAll(_response));
        });
    }

    protected processProjectAll(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * @return OK
     */
    getProjectsForTable( cancelToken?: CancelToken): Promise<ProjectForTable[]> {
        let url_ = this.baseUrl + "/api/getProjectsForTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProjectsForTable(_response));
        });
    }

    protected processGetProjectsForTable(response: AxiosResponse): Promise<ProjectForTable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectForTable.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProjectForTable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectForTable[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSingleProjectById(id: string | undefined, cancelToken?: CancelToken): Promise<Project> {
        let url_ = this.baseUrl + "/api/getSingleProjectById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingleProjectById(_response));
        });
    }

    protected processGetSingleProjectById(response: AxiosResponse): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Project.fromJS(resultData200);
            return Promise.resolve<Project>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    projectPost(body: ProjectCollaboratorPut | undefined, cancelToken?: CancelToken): Promise<Project> {
        let url_ = this.baseUrl + "/api/project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProjectPost(_response));
        });
    }

    protected processProjectPost(response: AxiosResponse): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Project.fromJS(resultData200);
            return Promise.resolve<Project>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project>(null as any);
    }

    /**
     * @return OK
     */
    getTemplateProjects( cancelToken?: CancelToken): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/getTemplateProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplateProjects(_response));
        });
    }

    protected processGetTemplateProjects(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * @return OK
     */
    setTemplateProject(projectId: string, isTemplate: boolean, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/setTemplateProject/{projectId}/{isTemplate}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (isTemplate === undefined || isTemplate === null)
            throw new globalThis.Error("The parameter 'isTemplate' must be defined.");
        url_ = url_.replace("{isTemplate}", encodeURIComponent("" + isTemplate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetTemplateProject(_response));
        });
    }

    protected processSetTemplateProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    projectDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/project/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProjectDelete(_response));
        });
    }

    protected processProjectDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    uploadSpecificAssetData( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/uploadSpecificAssetData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadSpecificAssetData(_response));
        });
    }

    protected processUploadSpecificAssetData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delSingleMaterialFromTable(body: RawMaterialTableRow | undefined, cancelToken?: CancelToken): Promise<RawMaterialTableRow> {
        let url_ = this.baseUrl + "/api/delSingleMaterialFromTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelSingleMaterialFromTable(_response));
        });
    }

    protected processDelSingleMaterialFromTable(response: AxiosResponse): Promise<RawMaterialTableRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialTableRow.fromJS(resultData200);
            return Promise.resolve<RawMaterialTableRow>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialTableRow>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteInboundFromTable(body: InboundTransportForMaterials | undefined, cancelToken?: CancelToken): Promise<InboundTransportForMaterials> {
        let url_ = this.baseUrl + "/api/deleteInboundFromTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteInboundFromTable(_response));
        });
    }

    protected processDeleteInboundFromTable(response: AxiosResponse): Promise<InboundTransportForMaterials> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InboundTransportForMaterials.fromJS(resultData200);
            return Promise.resolve<InboundTransportForMaterials>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InboundTransportForMaterials>(null as any);
    }

    /**
     * @param transportTableRowId (optional) 
     * @return OK
     */
    deleteInboundFromTableById(transportTableRowId: string | undefined, cancelToken?: CancelToken): Promise<InboundTransportForMaterials> {
        let url_ = this.baseUrl + "/api/deleteInboundFromTableById?";
        if (transportTableRowId === null)
            throw new globalThis.Error("The parameter 'transportTableRowId' cannot be null.");
        else if (transportTableRowId !== undefined)
            url_ += "transportTableRowId=" + encodeURIComponent("" + transportTableRowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteInboundFromTableById(_response));
        });
    }

    protected processDeleteInboundFromTableById(response: AxiosResponse): Promise<InboundTransportForMaterials> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InboundTransportForMaterials.fromJS(resultData200);
            return Promise.resolve<InboundTransportForMaterials>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InboundTransportForMaterials>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getTotalMassForDistribution(stepId: string | undefined, generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/getTotalMassForDistribution?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTotalMassForDistribution(_response));
        });
    }

    protected processGetTotalMassForDistribution(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @return OK
     */
    getClimateChangePerMaterialByMaterialId(materialId: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/getClimateChangePerMaterialByMaterialId?";
        if (materialId === null)
            throw new globalThis.Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClimateChangePerMaterialByMaterialId(_response));
        });
    }

    protected processGetClimateChangePerMaterialByMaterialId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param materialEntryId (optional) 
     * @return OK
     */
    getClimateChangeByMaterialEntryId(materialEntryId: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/getClimateChangeByMaterialEntryId?";
        if (materialEntryId === null)
            throw new globalThis.Error("The parameter 'materialEntryId' cannot be null.");
        else if (materialEntryId !== undefined)
            url_ += "materialEntryId=" + encodeURIComponent("" + materialEntryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClimateChangeByMaterialEntryId(_response));
        });
    }

    protected processGetClimateChangeByMaterialEntryId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putSingleMaterialFromTable(body: RawMaterialTableRow | undefined, cancelToken?: CancelToken): Promise<MaterialRecap> {
        let url_ = this.baseUrl + "/api/putSingleMaterialFromTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutSingleMaterialFromTable(_response));
        });
    }

    protected processPutSingleMaterialFromTable(response: AxiosResponse): Promise<MaterialRecap> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialRecap.fromJS(resultData200);
            return Promise.resolve<MaterialRecap>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialRecap>(null as any);
    }

    /**
     * @param unitOperationId (optional) 
     * @return OK
     */
    deleteIfUnitOperationIsNotInUse(unitOperationId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/deleteIfUnitOperationIsNotInUse?";
        if (unitOperationId === null)
            throw new globalThis.Error("The parameter 'unitOperationId' cannot be null.");
        else if (unitOperationId !== undefined)
            url_ += "unitOperationId=" + encodeURIComponent("" + unitOperationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteIfUnitOperationIsNotInUse(_response));
        });
    }

    protected processDeleteIfUnitOperationIsNotInUse(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    removeAllTransportForMaterialsByTransportIds(body: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/removeAllTransportForMaterialsByTransportIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveAllTransportForMaterialsByTransportIds(_response));
        });
    }

    protected processRemoveAllTransportForMaterialsByTransportIds(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return OK
     */
    removeAllTransportForMaterialsByStepId(stepId: string | undefined, cancelToken?: CancelToken): Promise<InboundTransportForMaterials> {
        let url_ = this.baseUrl + "/api/removeAllTransportForMaterialsByStepId?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveAllTransportForMaterialsByStepId(_response));
        });
    }

    protected processRemoveAllTransportForMaterialsByStepId(response: AxiosResponse): Promise<InboundTransportForMaterials> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InboundTransportForMaterials.fromJS(resultData200);
            return Promise.resolve<InboundTransportForMaterials>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InboundTransportForMaterials>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postSingleInboundTransportFromTable(body: InboundTransportForMaterials | undefined, cancelToken?: CancelToken): Promise<InboundTransportForMaterials> {
        let url_ = this.baseUrl + "/api/postSingleInboundTransportFromTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostSingleInboundTransportFromTable(_response));
        });
    }

    protected processPostSingleInboundTransportFromTable(response: AxiosResponse): Promise<InboundTransportForMaterials> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InboundTransportForMaterials.fromJS(resultData200);
            return Promise.resolve<InboundTransportForMaterials>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InboundTransportForMaterials>(null as any);
    }

    /**
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getRawMaterialsScreenContents(generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, cancelToken?: CancelToken): Promise<GlobalDataForLoading> {
        let url_ = this.baseUrl + "/api/getRawMaterialsScreenContents?";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRawMaterialsScreenContents(_response));
        });
    }

    protected processGetRawMaterialsScreenContents(response: AxiosResponse): Promise<GlobalDataForLoading> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GlobalDataForLoading.fromJS(resultData200);
            return Promise.resolve<GlobalDataForLoading>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GlobalDataForLoading>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @param stepId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getMaterialsEntriesByGeneraInformationIdScreenId(materialId: string | undefined, stepId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<RawMaterialCompleteData> {
        let url_ = this.baseUrl + "/api/getMaterialsEntriesByGeneraInformationIdScreenId?";
        if (materialId === null)
            throw new globalThis.Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMaterialsEntriesByGeneraInformationIdScreenId(_response));
        });
    }

    protected processGetMaterialsEntriesByGeneraInformationIdScreenId(response: AxiosResponse): Promise<RawMaterialCompleteData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialCompleteData.fromJS(resultData200);
            return Promise.resolve<RawMaterialCompleteData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialCompleteData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putTheMaterialForm(body: RawMaterialGlobalData | undefined, cancelToken?: CancelToken): Promise<RawMaterialGlobalData> {
        let url_ = this.baseUrl + "/api/putTheMaterialForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutTheMaterialForm(_response));
        });
    }

    protected processPutTheMaterialForm(response: AxiosResponse): Promise<RawMaterialGlobalData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialGlobalData.fromJS(resultData200);
            return Promise.resolve<RawMaterialGlobalData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialGlobalData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putTheMaterialFormOLD(body: RawMaterialGlobalData | undefined, cancelToken?: CancelToken): Promise<RawMaterialGlobalData> {
        let url_ = this.baseUrl + "/api/putTheMaterialFormOLD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutTheMaterialFormOLD(_response));
        });
    }

    protected processPutTheMaterialFormOLD(response: AxiosResponse): Promise<RawMaterialGlobalData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialGlobalData.fromJS(resultData200);
            return Promise.resolve<RawMaterialGlobalData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialGlobalData>(null as any);
    }

    /**
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getBasicDataByGeneraInformationIdScreenId(generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, cancelToken?: CancelToken): Promise<GeneralInformation> {
        let url_ = this.baseUrl + "/api/getBasicDataByGeneraInformationIdScreenId?";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBasicDataByGeneraInformationIdScreenId(_response));
        });
    }

    protected processGetBasicDataByGeneraInformationIdScreenId(response: AxiosResponse): Promise<GeneralInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInformation.fromJS(resultData200);
            return Promise.resolve<GeneralInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInformation>(null as any);
    }

    /**
     * @param generalInformationId (optional) 
     * @param screenId (optional) 
     * @param stepId (optional) 
     * @param tabAndSubTabName (optional) 
     * @return OK
     */
    getRawMaterialsByGeneraInformationIdScreenIdStepId(generalInformationId: string | undefined, screenId: string | undefined, stepId: string | undefined, tabAndSubTabName: string | undefined, cancelToken?: CancelToken): Promise<RawMaterial> {
        let url_ = this.baseUrl + "/api/getRawMaterialsByGeneraInformationIdScreenIdStepId?";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (tabAndSubTabName === null)
            throw new globalThis.Error("The parameter 'tabAndSubTabName' cannot be null.");
        else if (tabAndSubTabName !== undefined)
            url_ += "tabAndSubTabName=" + encodeURIComponent("" + tabAndSubTabName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRawMaterialsByGeneraInformationIdScreenIdStepId(_response));
        });
    }

    protected processGetRawMaterialsByGeneraInformationIdScreenIdStepId(response: AxiosResponse): Promise<RawMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterial.fromJS(resultData200);
            return Promise.resolve<RawMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterial>(null as any);
    }

    /**
     * @param generalInformationId (optional) 
     * @return OK
     */
    checkIfDeviceIsUsedInPackagingMaterialsDeviceMaterials(generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<CheckIfDeviceIsUsed> {
        let url_ = this.baseUrl + "/api/checkIfDeviceIsUsedInPackagingMaterialsDeviceMaterials?";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfDeviceIsUsedInPackagingMaterialsDeviceMaterials(_response));
        });
    }

    protected processCheckIfDeviceIsUsedInPackagingMaterialsDeviceMaterials(response: AxiosResponse): Promise<CheckIfDeviceIsUsed> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckIfDeviceIsUsed.fromJS(resultData200);
            return Promise.resolve<CheckIfDeviceIsUsed>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckIfDeviceIsUsed>(null as any);
    }

    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getRawMaterialsRelatedDropdowns(screenId: string | undefined, assessmentId: string | undefined, cancelToken?: CancelToken): Promise<RawMaterialsRelatedDropdowns> {
        let url_ = this.baseUrl + "/api/getRawMaterialsRelatedDropdowns?";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRawMaterialsRelatedDropdowns(_response));
        });
    }

    protected processGetRawMaterialsRelatedDropdowns(response: AxiosResponse): Promise<RawMaterialsRelatedDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialsRelatedDropdowns.fromJS(resultData200);
            return Promise.resolve<RawMaterialsRelatedDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialsRelatedDropdowns>(null as any);
    }

    /**
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getRawMaterialsRelatedDropdownsv2(screenId: string | undefined, generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<RawMaterialsRelatedDropdownsComplete> {
        let url_ = this.baseUrl + "/api/getRawMaterialsRelatedDropdownsv2?";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRawMaterialsRelatedDropdownsv2(_response));
        });
    }

    protected processGetRawMaterialsRelatedDropdownsv2(response: AxiosResponse): Promise<RawMaterialsRelatedDropdownsComplete> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialsRelatedDropdownsComplete.fromJS(resultData200);
            return Promise.resolve<RawMaterialsRelatedDropdownsComplete>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialsRelatedDropdownsComplete>(null as any);
    }

    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getRawMaterialsFiltering(screenId: string | undefined, assessmentId: string | undefined, cancelToken?: CancelToken): Promise<RawMaterialSelectionRow[]> {
        let url_ = this.baseUrl + "/api/getRawMaterialsFiltering?";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRawMaterialsFiltering(_response));
        });
    }

    protected processGetRawMaterialsFiltering(response: AxiosResponse): Promise<RawMaterialSelectionRow[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialSelectionRow.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RawMaterialSelectionRow[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialSelectionRow[]>(null as any);
    }

    /**
     * @param generalInformationId (optional) 
     * @param body (optional) 
     * @return OK
     */
    getSingleMaterialReferenceQuantityForRawMaterialTable(generalInformationId: string | undefined, body: RawMaterialTableRow | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/getSingleMaterialReferenceQuantityForRawMaterialTable?";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingleMaterialReferenceQuantityForRawMaterialTable(_response));
        });
    }

    protected processGetSingleMaterialReferenceQuantityForRawMaterialTable(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSingleMaterialEFForRawMaterialTable(body: RawMaterialTableRow | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/getSingleMaterialEFForRawMaterialTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingleMaterialEFForRawMaterialTable(_response));
        });
    }

    protected processGetSingleMaterialEFForRawMaterialTable(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    getDefaultTransport( cancelToken?: CancelToken): Promise<InboundTransportForMaterials[]> {
        let url_ = this.baseUrl + "/api/getDefaultTransport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDefaultTransport(_response));
        });
    }

    protected processGetDefaultTransport(response: AxiosResponse): Promise<InboundTransportForMaterials[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InboundTransportForMaterials.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<InboundTransportForMaterials[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InboundTransportForMaterials[]>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @param stepId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getMaterialsEntriesByGeneraInformationIdScreenIdOLD(materialId: string | undefined, stepId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<RawMaterialTableRow[]> {
        let url_ = this.baseUrl + "/api/getMaterialsEntriesByGeneraInformationIdScreenIdOLD?";
        if (materialId === null)
            throw new globalThis.Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMaterialsEntriesByGeneraInformationIdScreenIdOLD(_response));
        });
    }

    protected processGetMaterialsEntriesByGeneraInformationIdScreenIdOLD(response: AxiosResponse): Promise<RawMaterialTableRow[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialTableRow.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RawMaterialTableRow[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialTableRow[]>(null as any);
    }

    /**
     * @param rawMaterialId (optional) 
     * @param stepId (optional) 
     * @return OK
     */
    getMaterialsInboundTransportEntriesByGeneraInformationIdScreenId(rawMaterialId: string | undefined, stepId: string | undefined, cancelToken?: CancelToken): Promise<InboundTransportForMaterials[]> {
        let url_ = this.baseUrl + "/api/getMaterialsInboundTransportEntriesByGeneraInformationIdScreenId?";
        if (rawMaterialId === null)
            throw new globalThis.Error("The parameter 'rawMaterialId' cannot be null.");
        else if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMaterialsInboundTransportEntriesByGeneraInformationIdScreenId(_response));
        });
    }

    protected processGetMaterialsInboundTransportEntriesByGeneraInformationIdScreenId(response: AxiosResponse): Promise<InboundTransportForMaterials[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InboundTransportForMaterials.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<InboundTransportForMaterials[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InboundTransportForMaterials[]>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return OK
     */
    rawMaterialExist(stepId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/rawMaterialExist?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRawMaterialExist(_response));
        });
    }

    protected processRawMaterialExist(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @return OK
     */
    requestDensityForMaterial(materialId: string | undefined, cancelToken?: CancelToken): Promise<DensityRequestResponse> {
        let url_ = this.baseUrl + "/api/requestDensityForMaterial?";
        if (materialId === null)
            throw new globalThis.Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRequestDensityForMaterial(_response));
        });
    }

    protected processRequestDensityForMaterial(response: AxiosResponse): Promise<DensityRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DensityRequestResponse.fromJS(resultData200);
            return Promise.resolve<DensityRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DensityRequestResponse>(null as any);
    }

    /**
     * @return OK
     */
    relatableUnit(id: string, cancelToken?: CancelToken): Promise<RelatableUnit> {
        let url_ = this.baseUrl + "/api/RelatableUnit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRelatableUnit(_response));
        });
    }

    protected processRelatableUnit(response: AxiosResponse): Promise<RelatableUnit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RelatableUnit.fromJS(resultData200);
            return Promise.resolve<RelatableUnit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatableUnit>(null as any);
    }

    /**
     * @return OK
     */
    reportConfigurationGet(assessmentId: string, cancelToken?: CancelToken): Promise<ReportConfigurationReadModel> {
        let url_ = this.baseUrl + "/api/reportConfiguration/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReportConfigurationGet(_response));
        });
    }

    protected processReportConfigurationGet(response: AxiosResponse): Promise<ReportConfigurationReadModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportConfigurationReadModel.fromJS(resultData200);
            return Promise.resolve<ReportConfigurationReadModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportConfigurationReadModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportConfigurationPost(body: ReportConfigurationDto | undefined, cancelToken?: CancelToken): Promise<ReportConfigurationDto> {
        let url_ = this.baseUrl + "/api/reportConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReportConfigurationPost(_response));
        });
    }

    protected processReportConfigurationPost(response: AxiosResponse): Promise<ReportConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportConfigurationDto.fromJS(resultData200);
            return Promise.resolve<ReportConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportConfigurationDto>(null as any);
    }

    /**
     * @return OK
     */
    reportConfigurationDelete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/reportConfiguration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReportConfigurationDelete(_response));
        });
    }

    protected processReportConfigurationDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    relatableUnits( cancelToken?: CancelToken): Promise<RelatableUnitReadModel[]> {
        let url_ = this.baseUrl + "/api/relatableUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRelatableUnits(_response));
        });
    }

    protected processRelatableUnits(response: AxiosResponse): Promise<RelatableUnitReadModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RelatableUnitReadModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RelatableUnitReadModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatableUnitReadModel[]>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param packagingGeneralInformationId (optional) 
     * @return OK
     */
    checkIfDestinationMarketSelected(assessmentId: string | undefined, packagingGeneralInformationId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/checkIfDestinationMarketSelected?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (packagingGeneralInformationId === null)
            throw new globalThis.Error("The parameter 'packagingGeneralInformationId' cannot be null.");
        else if (packagingGeneralInformationId !== undefined)
            url_ += "packagingGeneralInformationId=" + encodeURIComponent("" + packagingGeneralInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfDestinationMarketSelected(_response));
        });
    }

    protected processCheckIfDestinationMarketSelected(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param resultTab (optional) 
     * @param emissionFactorsToUse (optional) 
     * @param useWeightedEmissionFactors (optional) 
     * @param quantity (optional) 
     * @param resultFormatType (optional) 
     * @param generalInformationIdParam (optional) 
     * @return OK
     */
    getPackResults(id: string | undefined, resultTab: string | undefined, emissionFactorsToUse: string[] | undefined, useWeightedEmissionFactors: boolean | undefined, quantity: number | undefined, resultFormatType: string | undefined, generalInformationIdParam: string | undefined, cancelToken?: CancelToken): Promise<FinalResult> {
        let url_ = this.baseUrl + "/api/getPackResults?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (resultTab === null)
            throw new globalThis.Error("The parameter 'resultTab' cannot be null.");
        else if (resultTab !== undefined)
            url_ += "resultTab=" + encodeURIComponent("" + resultTab) + "&";
        if (emissionFactorsToUse === null)
            throw new globalThis.Error("The parameter 'emissionFactorsToUse' cannot be null.");
        else if (emissionFactorsToUse !== undefined)
            emissionFactorsToUse && emissionFactorsToUse.forEach(item => { url_ += "emissionFactorsToUse=" + encodeURIComponent("" + item) + "&"; });
        if (useWeightedEmissionFactors === null)
            throw new globalThis.Error("The parameter 'useWeightedEmissionFactors' cannot be null.");
        else if (useWeightedEmissionFactors !== undefined)
            url_ += "useWeightedEmissionFactors=" + encodeURIComponent("" + useWeightedEmissionFactors) + "&";
        if (quantity === null)
            throw new globalThis.Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (resultFormatType === null)
            throw new globalThis.Error("The parameter 'resultFormatType' cannot be null.");
        else if (resultFormatType !== undefined)
            url_ += "resultFormatType=" + encodeURIComponent("" + resultFormatType) + "&";
        if (generalInformationIdParam === null)
            throw new globalThis.Error("The parameter 'generalInformationIdParam' cannot be null.");
        else if (generalInformationIdParam !== undefined)
            url_ += "generalInformationIdParam=" + encodeURIComponent("" + generalInformationIdParam) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPackResults(_response));
        });
    }

    protected processGetPackResults(response: AxiosResponse): Promise<FinalResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FinalResult.fromJS(resultData200);
            return Promise.resolve<FinalResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinalResult>(null as any);
    }

    /**
     * @return OK
     */
    getFullSyntheticResults(generalInformationId: string, cancelToken?: CancelToken): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/getFullSyntheticResults/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFullSyntheticResults(_response));
        });
    }

    protected processGetFullSyntheticResults(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getLifeCycleResultByGeneralInformationId(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<LifeCycleResult[]> {
        let url_ = this.baseUrl + "/api/getLifeCycleResultByGeneralInformationId/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetLifeCycleResultByGeneralInformationId(_response));
        });
    }

    protected processGetLifeCycleResultByGeneralInformationId(response: AxiosResponse): Promise<LifeCycleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LifeCycleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LifeCycleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifeCycleResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getResultsByStep(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<LifeCycleResult[]> {
        let url_ = this.baseUrl + "/api/getResultsByStep/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResultsByStep(_response));
        });
    }

    protected processGetResultsByStep(response: AxiosResponse): Promise<LifeCycleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LifeCycleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LifeCycleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifeCycleResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getResultsByMaterialComposition(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<MaterialCompositionResult[]> {
        let url_ = this.baseUrl + "/api/getResultsByMaterialComposition/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResultsByMaterialComposition(_response));
        });
    }

    protected processGetResultsByMaterialComposition(response: AxiosResponse): Promise<MaterialCompositionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialCompositionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialCompositionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialCompositionResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getResultsByProcessWaste(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<CustomProcessWasteEOL[]> {
        let url_ = this.baseUrl + "/api/getResultsByProcessWaste/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResultsByProcessWaste(_response));
        });
    }

    protected processGetResultsByProcessWaste(response: AxiosResponse): Promise<CustomProcessWasteEOL[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomProcessWasteEOL.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomProcessWasteEOL[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomProcessWasteEOL[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSyntheticApiCalculationLog(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/getSyntheticApiCalculationLog/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSyntheticApiCalculationLog(_response));
        });
    }

    protected processGetSyntheticApiCalculationLog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param emissionFactorsToUse (optional) 
     * @param useWeightedEmissionFactors (optional) 
     * @return OK
     */
    getDnpCalculationLog(generalInformationId: string, emissionFactorsToUse: string[] | undefined, useWeightedEmissionFactors: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/getDnpCalculationLog/{generalInformationId}?";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        if (emissionFactorsToUse === null)
            throw new globalThis.Error("The parameter 'emissionFactorsToUse' cannot be null.");
        else if (emissionFactorsToUse !== undefined)
            emissionFactorsToUse && emissionFactorsToUse.forEach(item => { url_ += "emissionFactorsToUse=" + encodeURIComponent("" + item) + "&"; });
        if (useWeightedEmissionFactors === null)
            throw new globalThis.Error("The parameter 'useWeightedEmissionFactors' cannot be null.");
        else if (useWeightedEmissionFactors !== undefined)
            url_ += "useWeightedEmissionFactors=" + encodeURIComponent("" + useWeightedEmissionFactors) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDnpCalculationLog(_response));
        });
    }

    protected processGetDnpCalculationLog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param emissionFactorsToUse (optional) 
     * @param useWeightedEmissionFactors (optional) 
     * @return OK
     */
    getDistributionCalculationLog(generalInformationId: string, emissionFactorsToUse: string[] | undefined, useWeightedEmissionFactors: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/getDistributionCalculationLog/{generalInformationId}?";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        if (emissionFactorsToUse === null)
            throw new globalThis.Error("The parameter 'emissionFactorsToUse' cannot be null.");
        else if (emissionFactorsToUse !== undefined)
            emissionFactorsToUse && emissionFactorsToUse.forEach(item => { url_ += "emissionFactorsToUse=" + encodeURIComponent("" + item) + "&"; });
        if (useWeightedEmissionFactors === null)
            throw new globalThis.Error("The parameter 'useWeightedEmissionFactors' cannot be null.");
        else if (useWeightedEmissionFactors !== undefined)
            url_ += "useWeightedEmissionFactors=" + encodeURIComponent("" + useWeightedEmissionFactors) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDistributionCalculationLog(_response));
        });
    }

    protected processGetDistributionCalculationLog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getResultAll( cancelToken?: CancelToken): Promise<LifeCycleResultGraph> {
        let url_ = this.baseUrl + "/api/getResultAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResultAll(_response));
        });
    }

    protected processGetResultAll(response: AxiosResponse): Promise<LifeCycleResultGraph> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LifeCycleResultGraph.fromJS(resultData200);
            return Promise.resolve<LifeCycleResultGraph>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifeCycleResultGraph>(null as any);
    }

    /**
     * @return OK
     */
    getFullBiologicsResults(generalInformationId: string, cancelToken?: CancelToken): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/getFullBiologicsResults/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFullBiologicsResults(_response));
        });
    }

    protected processGetFullBiologicsResults(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsLifeCycleResultByGeneralInformationId(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<BiologicsLifeCycleResult[]> {
        let url_ = this.baseUrl + "/api/getBiologicsLifeCycleResultByGeneralInformationId/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBiologicsLifeCycleResultByGeneralInformationId(_response));
        });
    }

    protected processGetBiologicsLifeCycleResultByGeneralInformationId(response: AxiosResponse): Promise<BiologicsLifeCycleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BiologicsLifeCycleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BiologicsLifeCycleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BiologicsLifeCycleResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsResultsByStep(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<LifeCycleResult[]> {
        let url_ = this.baseUrl + "/api/getBiologicsResultsByStep/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBiologicsResultsByStep(_response));
        });
    }

    protected processGetBiologicsResultsByStep(response: AxiosResponse): Promise<LifeCycleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LifeCycleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LifeCycleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifeCycleResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsResultsByMaterialComposition(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<MaterialCompositionResult[]> {
        let url_ = this.baseUrl + "/api/getBiologicsResultsByMaterialComposition/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBiologicsResultsByMaterialComposition(_response));
        });
    }

    protected processGetBiologicsResultsByMaterialComposition(response: AxiosResponse): Promise<MaterialCompositionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialCompositionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialCompositionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialCompositionResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsResultsByProcessWaste(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<CustomProcessWasteEOL[]> {
        let url_ = this.baseUrl + "/api/getBiologicsResultsByProcessWaste/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBiologicsResultsByProcessWaste(_response));
        });
    }

    protected processGetBiologicsResultsByProcessWaste(response: AxiosResponse): Promise<CustomProcessWasteEOL[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomProcessWasteEOL.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomProcessWasteEOL[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomProcessWasteEOL[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBiologicsCalculationLog(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/getBiologicsCalculationLog/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBiologicsCalculationLog(_response));
        });
    }

    protected processGetBiologicsCalculationLog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessLifeCycleResultByGeneralInformationId(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<ProductProcessLifeCycleResult[]> {
        let url_ = this.baseUrl + "/api/getProductProcessLifeCycleResultByGeneralInformationId/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductProcessLifeCycleResultByGeneralInformationId(_response));
        });
    }

    protected processGetProductProcessLifeCycleResultByGeneralInformationId(response: AxiosResponse): Promise<ProductProcessLifeCycleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductProcessLifeCycleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductProcessLifeCycleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductProcessLifeCycleResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessResultsByStep(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<LifeCycleResult[]> {
        let url_ = this.baseUrl + "/api/getProductProcessResultsByStep/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductProcessResultsByStep(_response));
        });
    }

    protected processGetProductProcessResultsByStep(response: AxiosResponse): Promise<LifeCycleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LifeCycleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LifeCycleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifeCycleResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessResultsByMaterialComposition(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<MaterialCompositionResult[]> {
        let url_ = this.baseUrl + "/api/getProductProcessResultsByMaterialComposition/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductProcessResultsByMaterialComposition(_response));
        });
    }

    protected processGetProductProcessResultsByMaterialComposition(response: AxiosResponse): Promise<MaterialCompositionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialCompositionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialCompositionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialCompositionResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessResultsByProcessWaste(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<CustomProcessWasteEOL[]> {
        let url_ = this.baseUrl + "/api/getProductProcessResultsByProcessWaste/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductProcessResultsByProcessWaste(_response));
        });
    }

    protected processGetProductProcessResultsByProcessWaste(response: AxiosResponse): Promise<CustomProcessWasteEOL[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomProcessWasteEOL.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomProcessWasteEOL[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomProcessWasteEOL[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductProcessCalculationLog(generalInformationId: string, body: CalculationOptions | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/getProductProcessCalculationLog/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductProcessCalculationLog(_response));
        });
    }

    protected processGetProductProcessCalculationLog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkIfLifeCycleSummaryCanBeCalculated(body: LifeCycleSummaryResultInput | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/checkIfLifeCycleSummaryCanBeCalculated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckIfLifeCycleSummaryCanBeCalculated(_response));
        });
    }

    protected processCheckIfLifeCycleSummaryCanBeCalculated(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getLifeCycleSummaryResult(body: LifeCycleSummaryResultInput | undefined, cancelToken?: CancelToken): Promise<ProductProcessLifeCycleResult[]> {
        let url_ = this.baseUrl + "/api/getLifeCycleSummaryResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetLifeCycleSummaryResult(_response));
        });
    }

    protected processGetLifeCycleSummaryResult(response: AxiosResponse): Promise<ProductProcessLifeCycleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductProcessLifeCycleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductProcessLifeCycleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductProcessLifeCycleResult[]>(null as any);
    }

    /**
     * @return OK
     */
    getResultAll1( cancelToken?: CancelToken): Promise<LifeCycleSummaryResultGraph> {
        let url_ = this.baseUrl + "/api/getResultAll1";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResultAll1(_response));
        });
    }

    protected processGetResultAll1(response: AxiosResponse): Promise<LifeCycleSummaryResultGraph> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LifeCycleSummaryResultGraph.fromJS(resultData200);
            return Promise.resolve<LifeCycleSummaryResultGraph>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifeCycleSummaryResultGraph>(null as any);
    }

    /**
     * @return OK
     */
    screenAll( cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/screenAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenAll(_response));
        });
    }

    protected processScreenAll(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @param findScreenName (optional) 
     * @return OK
     */
    screenForClient(findScreenName: string | undefined, cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/screenForClient?";
        if (findScreenName === null)
            throw new globalThis.Error("The parameter 'findScreenName' cannot be null.");
        else if (findScreenName !== undefined)
            url_ += "findScreenName=" + encodeURIComponent("" + findScreenName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenForClient(_response));
        });
    }

    protected processScreenForClient(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @return OK
     */
    getScreenByScreenName(screenName: string, cancelToken?: CancelToken): Promise<Screen> {
        let url_ = this.baseUrl + "/api/getScreenByScreenName/{screenName}";
        if (screenName === undefined || screenName === null)
            throw new globalThis.Error("The parameter 'screenName' must be defined.");
        url_ = url_.replace("{screenName}", encodeURIComponent("" + screenName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScreenByScreenName(_response));
        });
    }

    protected processGetScreenByScreenName(response: AxiosResponse): Promise<Screen> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Screen.fromJS(resultData200);
            return Promise.resolve<Screen>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen>(null as any);
    }

    /**
     * @return OK
     */
    screenForClientAlls( cancelToken?: CancelToken): Promise<ScreenTabs[]> {
        let url_ = this.baseUrl + "/api/screenForClientAlls";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenForClientAlls(_response));
        });
    }

    protected processScreenForClientAlls(response: AxiosResponse): Promise<ScreenTabs[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScreenTabs.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScreenTabs[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScreenTabs[]>(null as any);
    }

    /**
     * @return OK
     */
    screenForClientAllsByTabPosition( cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/screenForClientAllsByTabPosition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenForClientAllsByTabPosition(_response));
        });
    }

    protected processScreenForClientAllsByTabPosition(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @return OK
     */
    screensWithProductFormats( cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/screensWithProductFormats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreensWithProductFormats(_response));
        });
    }

    protected processScreensWithProductFormats(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @return OK
     */
    allClientScreensWithFormats( cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/allClientScreensWithFormats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAllClientScreensWithFormats(_response));
        });
    }

    protected processAllClientScreensWithFormats(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @return OK
     */
    screenGet(id: string, cancelToken?: CancelToken): Promise<Screen> {
        let url_ = this.baseUrl + "/api/screen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenGet(_response));
        });
    }

    protected processScreenGet(response: AxiosResponse): Promise<Screen> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Screen.fromJS(resultData200);
            return Promise.resolve<Screen>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen>(null as any);
    }

    /**
     * @return OK
     */
    screenDelete(id: string, cancelToken?: CancelToken): Promise<Screen> {
        let url_ = this.baseUrl + "/api/screen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenDelete(_response));
        });
    }

    protected processScreenDelete(response: AxiosResponse): Promise<Screen> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Screen.fromJS(resultData200);
            return Promise.resolve<Screen>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    screenPut(id: string, body: Screen | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/screen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenPut(_response));
        });
    }

    protected processScreenPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    screenPost(body: Screen | undefined, cancelToken?: CancelToken): Promise<UserTypeScreen> {
        let url_ = this.baseUrl + "/api/screen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreenPost(_response));
        });
    }

    protected processScreenPost(response: AxiosResponse): Promise<UserTypeScreen> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTypeScreen.fromJS(resultData200);
            return Promise.resolve<UserTypeScreen>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTypeScreen>(null as any);
    }

    /**
     * @return OK
     */
    getSelectedAssessmentByPersonId(id: string, cancelToken?: CancelToken): Promise<History[]> {
        let url_ = this.baseUrl + "/api/getSelectedAssessmentByPersonId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSelectedAssessmentByPersonId(_response));
        });
    }

    protected processGetSelectedAssessmentByPersonId(response: AxiosResponse): Promise<History[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(History.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<History[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<History[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    logSelectedAssessmentPerPersonId(body: History | undefined, cancelToken?: CancelToken): Promise<History> {
        let url_ = this.baseUrl + "/api/logSelectedAssessmentPerPersonId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogSelectedAssessmentPerPersonId(_response));
        });
    }

    protected processLogSelectedAssessmentPerPersonId(response: AxiosResponse): Promise<History> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = History.fromJS(resultData200);
            return Promise.resolve<History>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<History>(null as any);
    }

    /**
     * @param to (optional) 
     * @param subject (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendMailHelper(to: string | undefined, subject: string | undefined, body: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/SendMailHelper?";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (subject === null)
            throw new globalThis.Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (body === null)
            throw new globalThis.Error("The parameter 'body' cannot be null.");
        else if (body !== undefined)
            url_ += "body=" + encodeURIComponent("" + body) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMailHelper(_response));
        });
    }

    protected processSendMailHelper(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    siteLocationsAll( cancelToken?: CancelToken): Promise<SiteLocation[]> {
        let url_ = this.baseUrl + "/api/siteLocationsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSiteLocationsAll(_response));
        });
    }

    protected processSiteLocationsAll(response: AxiosResponse): Promise<SiteLocation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteLocation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SiteLocation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteLocation[]>(null as any);
    }

    /**
     * @return OK
     */
    siteLocationsGet(id: string, cancelToken?: CancelToken): Promise<SiteLocation> {
        let url_ = this.baseUrl + "/api/siteLocations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSiteLocationsGet(_response));
        });
    }

    protected processSiteLocationsGet(response: AxiosResponse): Promise<SiteLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteLocation.fromJS(resultData200);
            return Promise.resolve<SiteLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteLocation>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    siteLocationsPut(id: string, body: SiteLocation | undefined, cancelToken?: CancelToken): Promise<SiteLocation> {
        let url_ = this.baseUrl + "/api/siteLocations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSiteLocationsPut(_response));
        });
    }

    protected processSiteLocationsPut(response: AxiosResponse): Promise<SiteLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteLocation.fromJS(resultData200);
            return Promise.resolve<SiteLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteLocation>(null as any);
    }

    /**
     * @return OK
     */
    siteLocationsDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/siteLocations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSiteLocationsDelete(_response));
        });
    }

    protected processSiteLocationsDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    siteLocationsPost(body: SiteLocation | undefined, cancelToken?: CancelToken): Promise<SiteLocation> {
        let url_ = this.baseUrl + "/api/siteLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSiteLocationsPost(_response));
        });
    }

    protected processSiteLocationsPost(response: AxiosResponse): Promise<SiteLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteLocation.fromJS(resultData200);
            return Promise.resolve<SiteLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteLocation>(null as any);
    }

    /**
     * @param sourceStepId (optional) 
     * @param destinationAssessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param newStepName (optional) 
     * @return OK
     */
    copyStepToAssessment(sourceStepId: string | undefined, destinationAssessmentId: string | undefined, generalInformationId: string | undefined, newStepName: string | undefined, cancelToken?: CancelToken): Promise<Step> {
        let url_ = this.baseUrl + "/api/copyStepToAssessment?";
        if (sourceStepId === null)
            throw new globalThis.Error("The parameter 'sourceStepId' cannot be null.");
        else if (sourceStepId !== undefined)
            url_ += "sourceStepId=" + encodeURIComponent("" + sourceStepId) + "&";
        if (destinationAssessmentId === null)
            throw new globalThis.Error("The parameter 'destinationAssessmentId' cannot be null.");
        else if (destinationAssessmentId !== undefined)
            url_ += "destinationAssessmentId=" + encodeURIComponent("" + destinationAssessmentId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (newStepName === null)
            throw new globalThis.Error("The parameter 'newStepName' cannot be null.");
        else if (newStepName !== undefined)
            url_ += "newStepName=" + encodeURIComponent("" + newStepName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCopyStepToAssessment(_response));
        });
    }

    protected processCopyStepToAssessment(response: AxiosResponse): Promise<Step> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Step.fromJS(resultData200);
            return Promise.resolve<Step>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step>(null as any);
    }

    /**
     * @param sourceStepId (optional) 
     * @param destinationAssessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param newStepName (optional) 
     * @param copyUpstreamSteps (optional) 
     * @param upstreamStepNamesJson (optional) 
     * @return OK
     */
    copyStepsWithUpstream(sourceStepId: string | undefined, destinationAssessmentId: string | undefined, generalInformationId: string | undefined, newStepName: string | undefined, copyUpstreamSteps: boolean | undefined, upstreamStepNamesJson: string | undefined, cancelToken?: CancelToken): Promise<Step[]> {
        let url_ = this.baseUrl + "/api/copyStepsWithUpstream?";
        if (sourceStepId === null)
            throw new globalThis.Error("The parameter 'sourceStepId' cannot be null.");
        else if (sourceStepId !== undefined)
            url_ += "sourceStepId=" + encodeURIComponent("" + sourceStepId) + "&";
        if (destinationAssessmentId === null)
            throw new globalThis.Error("The parameter 'destinationAssessmentId' cannot be null.");
        else if (destinationAssessmentId !== undefined)
            url_ += "destinationAssessmentId=" + encodeURIComponent("" + destinationAssessmentId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (newStepName === null)
            throw new globalThis.Error("The parameter 'newStepName' cannot be null.");
        else if (newStepName !== undefined)
            url_ += "newStepName=" + encodeURIComponent("" + newStepName) + "&";
        if (copyUpstreamSteps === null)
            throw new globalThis.Error("The parameter 'copyUpstreamSteps' cannot be null.");
        else if (copyUpstreamSteps !== undefined)
            url_ += "copyUpstreamSteps=" + encodeURIComponent("" + copyUpstreamSteps) + "&";
        if (upstreamStepNamesJson === null)
            throw new globalThis.Error("The parameter 'upstreamStepNamesJson' cannot be null.");
        else if (upstreamStepNamesJson !== undefined)
            url_ += "upstreamStepNamesJson=" + encodeURIComponent("" + upstreamStepNamesJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCopyStepsWithUpstream(_response));
        });
    }

    protected processCopyStepsWithUpstream(response: AxiosResponse): Promise<Step[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Step.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Step[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step[]>(null as any);
    }

    /**
     * @param sourceStepId (optional) 
     * @param destinationAssessmentId (optional) 
     * @param generalInformationId (optional) 
     * @param newStepName (optional) 
     * @return OK
     */
    copyStepToAssessmentv1(sourceStepId: string | undefined, destinationAssessmentId: string | undefined, generalInformationId: string | undefined, newStepName: string | undefined, cancelToken?: CancelToken): Promise<Step> {
        let url_ = this.baseUrl + "/api/copyStepToAssessmentv1?";
        if (sourceStepId === null)
            throw new globalThis.Error("The parameter 'sourceStepId' cannot be null.");
        else if (sourceStepId !== undefined)
            url_ += "sourceStepId=" + encodeURIComponent("" + sourceStepId) + "&";
        if (destinationAssessmentId === null)
            throw new globalThis.Error("The parameter 'destinationAssessmentId' cannot be null.");
        else if (destinationAssessmentId !== undefined)
            url_ += "destinationAssessmentId=" + encodeURIComponent("" + destinationAssessmentId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        if (newStepName === null)
            throw new globalThis.Error("The parameter 'newStepName' cannot be null.");
        else if (newStepName !== undefined)
            url_ += "newStepName=" + encodeURIComponent("" + newStepName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCopyStepToAssessmentv1(_response));
        });
    }

    protected processCopyStepToAssessmentv1(response: AxiosResponse): Promise<Step> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Step.fromJS(resultData200);
            return Promise.resolve<Step>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step>(null as any);
    }

    /**
     * @return OK
     */
    getUpstreamStepsList(stepId: string, cancelToken?: CancelToken): Promise<Step[]> {
        let url_ = this.baseUrl + "/api/getUpstreamStepsList/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUpstreamStepsList(_response));
        });
    }

    protected processGetUpstreamStepsList(response: AxiosResponse): Promise<Step[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Step.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Step[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step[]>(null as any);
    }

    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getActiveProjects(screenId: string | undefined, assessmentId: string | undefined, cancelToken?: CancelToken): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/getActiveProjects?";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveProjects(_response));
        });
    }

    protected processGetActiveProjects(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getActiveSubProjects(projectId: string | undefined, screenId: string | undefined, assessmentId: string | undefined, cancelToken?: CancelToken): Promise<SubProject[]> {
        let url_ = this.baseUrl + "/api/getActiveSubProjects?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveSubProjects(_response));
        });
    }

    protected processGetActiveSubProjects(response: AxiosResponse): Promise<SubProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SubProject[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubProject[]>(null as any);
    }

    /**
     * @param subProjectId (optional) 
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getActiveAssessments(subProjectId: string | undefined, screenId: string | undefined, assessmentId: string | undefined, cancelToken?: CancelToken): Promise<Assessment[]> {
        let url_ = this.baseUrl + "/api/getActiveAssessments?";
        if (subProjectId === null)
            throw new globalThis.Error("The parameter 'subProjectId' cannot be null.");
        else if (subProjectId !== undefined)
            url_ += "subProjectId=" + encodeURIComponent("" + subProjectId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveAssessments(_response));
        });
    }

    protected processGetActiveAssessments(response: AxiosResponse): Promise<Assessment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assessment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Assessment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment[]>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getActiveSteps(assessmentId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<Step[]> {
        let url_ = this.baseUrl + "/api/getActiveSteps?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveSteps(_response));
        });
    }

    protected processGetActiveSteps(response: AxiosResponse): Promise<Step[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Step.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Step[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step[]>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getTheFirstStepByAssessmentIdScreenIdGeneralInformationId(assessmentId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<Step> {
        let url_ = this.baseUrl + "/api/getTheFirstStepByAssessmentIdScreenIdGeneralInformationId?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTheFirstStepByAssessmentIdScreenIdGeneralInformationId(_response));
        });
    }

    protected processGetTheFirstStepByAssessmentIdScreenIdGeneralInformationId(response: AxiosResponse): Promise<Step> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Step.fromJS(resultData200);
            return Promise.resolve<Step>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @param subTabName (optional) 
     * @param status (optional) 
     * @return OK
     */
    updateScreenStepStatus(stepId: string | undefined, subTabName: string | undefined, status: boolean | undefined, cancelToken?: CancelToken): Promise<StepStatus> {
        let url_ = this.baseUrl + "/api/updateScreenStepStatus?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (subTabName === null)
            throw new globalThis.Error("The parameter 'subTabName' cannot be null.");
        else if (subTabName !== undefined)
            url_ += "subTabName=" + encodeURIComponent("" + subTabName) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateScreenStepStatus(_response));
        });
    }

    protected processUpdateScreenStepStatus(response: AxiosResponse): Promise<StepStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StepStatus.fromJS(resultData200);
            return Promise.resolve<StepStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StepStatus>(null as any);
    }

    /**
     * @return OK
     */
    step(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/step/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStep(_response));
        });
    }

    protected processStep(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    subProjectSelectedScreens(assessmentId: string | undefined, cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/subProjectSelectedScreens?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubProjectSelectedScreens(_response));
        });
    }

    protected processSubProjectSelectedScreens(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @return OK
     */
    subProjectSelectedScreensIds(assessmentId: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/subProjectSelectedScreensIds?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubProjectSelectedScreensIds(_response));
        });
    }

    protected processSubProjectSelectedScreensIds(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    subProjectAll( cancelToken?: CancelToken): Promise<SubProject[]> {
        let url_ = this.baseUrl + "/api/subProjectAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubProjectAll(_response));
        });
    }

    protected processSubProjectAll(response: AxiosResponse): Promise<SubProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SubProject[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubProject[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSinglesubProjectById(id: string | undefined, cancelToken?: CancelToken): Promise<SubProject> {
        let url_ = this.baseUrl + "/api/getSinglesubProjectById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSinglesubProjectById(_response));
        });
    }

    protected processGetSinglesubProjectById(response: AxiosResponse): Promise<SubProject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubProject.fromJS(resultData200);
            return Promise.resolve<SubProject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubProject>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    subProjectPerProject(projectId: string | undefined, cancelToken?: CancelToken): Promise<SubProject[]> {
        let url_ = this.baseUrl + "/api/subProjectPerProject?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubProjectPerProject(_response));
        });
    }

    protected processSubProjectPerProject(response: AxiosResponse): Promise<SubProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SubProject[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubProject[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    subProjectPerProjectTable(projectId: string | undefined, cancelToken?: CancelToken): Promise<SubProjectForTable[]> {
        let url_ = this.baseUrl + "/api/subProjectPerProjectTable?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubProjectPerProjectTable(_response));
        });
    }

    protected processSubProjectPerProjectTable(response: AxiosResponse): Promise<SubProjectForTable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubProjectForTable.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SubProjectForTable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubProjectForTable[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subProjectPost(body: SubProjectCollaboratorPut | undefined, cancelToken?: CancelToken): Promise<SubProject> {
        let url_ = this.baseUrl + "/api/subProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubProjectPost(_response));
        });
    }

    protected processSubProjectPost(response: AxiosResponse): Promise<SubProject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubProject.fromJS(resultData200);
            return Promise.resolve<SubProject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubProject>(null as any);
    }

    /**
     * @return OK
     */
    subProjectDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/subProject/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubProjectDelete(_response));
        });
    }

    protected processSubProjectDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putUnitOperation(body: UnitOperation | undefined, cancelToken?: CancelToken): Promise<UnitOperation> {
        let url_ = this.baseUrl + "/api/putUnitOperation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutUnitOperation(_response));
        });
    }

    protected processPutUnitOperation(response: AxiosResponse): Promise<UnitOperation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnitOperation.fromJS(resultData200);
            return Promise.resolve<UnitOperation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitOperation>(null as any);
    }

    /**
     * @param defaultKey (optional) 
     * @return OK
     */
    getDefaultEntries(defaultKey: string | undefined, cancelToken?: CancelToken): Promise<AllDefaultValues> {
        let url_ = this.baseUrl + "/api/getDefaultEntries?";
        if (defaultKey === null)
            throw new globalThis.Error("The parameter 'defaultKey' cannot be null.");
        else if (defaultKey !== undefined)
            url_ += "defaultKey=" + encodeURIComponent("" + defaultKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDefaultEntries(_response));
        });
    }

    protected processGetDefaultEntries(response: AxiosResponse): Promise<AllDefaultValues> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllDefaultValues.fromJS(resultData200);
            return Promise.resolve<AllDefaultValues>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllDefaultValues>(null as any);
    }

    /**
     * @return OK
     */
    getAllDefaultEntries( cancelToken?: CancelToken): Promise<AllDefaultValues[]> {
        let url_ = this.baseUrl + "/api/getAllDefaultEntries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllDefaultEntries(_response));
        });
    }

    protected processGetAllDefaultEntries(response: AxiosResponse): Promise<AllDefaultValues[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllDefaultValues.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AllDefaultValues[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllDefaultValues[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putDefaultEntries(body: AllDefaultValues | undefined, cancelToken?: CancelToken): Promise<AllDefaultValues> {
        let url_ = this.baseUrl + "/api/putDefaultEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutDefaultEntries(_response));
        });
    }

    protected processPutDefaultEntries(response: AxiosResponse): Promise<AllDefaultValues> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllDefaultValues.fromJS(resultData200);
            return Promise.resolve<AllDefaultValues>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllDefaultValues>(null as any);
    }

    /**
     * @return OK
     */
    treeItemAll( cancelToken?: CancelToken): Promise<TreeItems[]> {
        let url_ = this.baseUrl + "/api/treeItemAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTreeItemAll(_response));
        });
    }

    protected processTreeItemAll(response: AxiosResponse): Promise<TreeItems[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeItems.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TreeItems[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeItems[]>(null as any);
    }

    /**
     * @return OK
     */
    treeItemGet(id: string, cancelToken?: CancelToken): Promise<TreeItems> {
        let url_ = this.baseUrl + "/api/treeItem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTreeItemGet(_response));
        });
    }

    protected processTreeItemGet(response: AxiosResponse): Promise<TreeItems> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TreeItems.fromJS(resultData200);
            return Promise.resolve<TreeItems>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeItems>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    treeItemPut(id: string, body: TreeItemVM | undefined, cancelToken?: CancelToken): Promise<TreeItems> {
        let url_ = this.baseUrl + "/api/treeItem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTreeItemPut(_response));
        });
    }

    protected processTreeItemPut(response: AxiosResponse): Promise<TreeItems> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TreeItems.fromJS(resultData200);
            return Promise.resolve<TreeItems>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeItems>(null as any);
    }

    /**
     * @return OK
     */
    treeItemDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/treeItem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTreeItemDelete(_response));
        });
    }

    protected processTreeItemDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    treeItemPost(body: TreeItems | undefined, cancelToken?: CancelToken): Promise<TreeItems> {
        let url_ = this.baseUrl + "/api/treeItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTreeItemPost(_response));
        });
    }

    protected processTreeItemPost(response: AxiosResponse): Promise<TreeItems> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TreeItems.fromJS(resultData200);
            return Promise.resolve<TreeItems>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeItems>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param password (optional) 
     * @return OK
     */
    cleandemodata(keyword: string | undefined, password: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/cleandemodata?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCleandemodata(_response));
        });
    }

    protected processCleandemodata(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    personAll( cancelToken?: CancelToken): Promise<Person[]> {
        let url_ = this.baseUrl + "/api/personAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPersonAll(_response));
        });
    }

    protected processPersonAll(response: AxiosResponse): Promise<Person[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Person.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Person[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person[]>(null as any);
    }

    /**
     * @return OK
     */
    selectedColumnUserList( cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/selectedColumnUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSelectedColumnUserList(_response));
        });
    }

    protected processSelectedColumnUserList(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return OK
     */
    adminUserList( cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/adminUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAdminUserList(_response));
        });
    }

    protected processAdminUserList(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return OK
     */
    personAllNames( cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/personAllNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPersonAllNames(_response));
        });
    }

    protected processPersonAllNames(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @param searchPerson (optional) 
     * @return OK
     */
    filterPerson(searchPerson: string | undefined, cancelToken?: CancelToken): Promise<Person[]> {
        let url_ = this.baseUrl + "/api/filterPerson?";
        if (searchPerson === null)
            throw new globalThis.Error("The parameter 'searchPerson' cannot be null.");
        else if (searchPerson !== undefined)
            url_ += "searchPerson=" + encodeURIComponent("" + searchPerson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFilterPerson(_response));
        });
    }

    protected processFilterPerson(response: AxiosResponse): Promise<Person[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Person.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Person[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person[]>(null as any);
    }

    /**
     * @return OK
     */
    userGet(id: string, cancelToken?: CancelToken): Promise<Person> {
        let url_ = this.baseUrl + "/api/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserGet(_response));
        });
    }

    protected processUserGet(response: AxiosResponse): Promise<Person> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Person.fromJS(resultData200);
            return Promise.resolve<Person>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userPut(id: string, body: Person | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserPut(_response));
        });
    }

    protected processUserPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    userDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserDelete(_response));
        });
    }

    protected processUserDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    insertSinglePersonComplete(body: AllSingleUserData | undefined, cancelToken?: CancelToken): Promise<AllSingleUserData> {
        let url_ = this.baseUrl + "/api/insertSinglePersonComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInsertSinglePersonComplete(_response));
        });
    }

    protected processInsertSinglePersonComplete(response: AxiosResponse): Promise<AllSingleUserData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllSingleUserData.fromJS(resultData200);
            return Promise.resolve<AllSingleUserData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllSingleUserData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userPost(body: Person | undefined, cancelToken?: CancelToken): Promise<Person> {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserPost(_response));
        });
    }

    protected processUserPost(response: AxiosResponse): Promise<Person> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Person.fromJS(resultData200);
            return Promise.resolve<Person>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deactivateUser(id: string, body: DeactivateUserRequest | undefined, cancelToken?: CancelToken): Promise<IdentityOperationResponse> {
        let url_ = this.baseUrl + "/api/deactivateUser/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeactivateUser(_response));
        });
    }

    protected processDeactivateUser(response: AxiosResponse): Promise<IdentityOperationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityOperationResponse.fromJS(resultData200);
            return Promise.resolve<IdentityOperationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityOperationResponse>(null as any);
    }

    /**
     * @return OK
     */
    userTypeAll( cancelToken?: CancelToken): Promise<UserType[]> {
        let url_ = this.baseUrl + "/api/userTypeAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeAll(_response));
        });
    }

    protected processUserTypeAll(response: AxiosResponse): Promise<UserType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserType[]>(null as any);
    }

    /**
     * @return OK
     */
    userTypeGet(id: string, cancelToken?: CancelToken): Promise<UserType> {
        let url_ = this.baseUrl + "/api/userType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeGet(_response));
        });
    }

    protected processUserTypeGet(response: AxiosResponse): Promise<UserType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserType.fromJS(resultData200);
            return Promise.resolve<UserType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserType>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userTypePut(id: string, body: UserType | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/userType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypePut(_response));
        });
    }

    protected processUserTypePut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    userTypeDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/userType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeDelete(_response));
        });
    }

    protected processUserTypeDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userTypePost(body: UserType | undefined, cancelToken?: CancelToken): Promise<UserType> {
        let url_ = this.baseUrl + "/api/userType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypePost(_response));
        });
    }

    protected processUserTypePost(response: AxiosResponse): Promise<UserType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserType.fromJS(resultData200);
            return Promise.resolve<UserType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserType>(null as any);
    }

    /**
     * @return OK
     */
    newUserType( cancelToken?: CancelToken): Promise<UserType> {
        let url_ = this.baseUrl + "/api/newUserType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNewUserType(_response));
        });
    }

    protected processNewUserType(response: AxiosResponse): Promise<UserType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserType.fromJS(resultData200);
            return Promise.resolve<UserType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserType>(null as any);
    }

    /**
     * @return OK
     */
    userTypeScreenAll( cancelToken?: CancelToken): Promise<UserTypeScreen[]> {
        let url_ = this.baseUrl + "/api/userTypeScreenAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeScreenAll(_response));
        });
    }

    protected processUserTypeScreenAll(response: AxiosResponse): Promise<UserTypeScreen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTypeScreen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserTypeScreen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTypeScreen[]>(null as any);
    }

    /**
     * @return OK
     */
    userTypeScreenGet(id: string, cancelToken?: CancelToken): Promise<UserTypeScreen> {
        let url_ = this.baseUrl + "/api/userTypeScreen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeScreenGet(_response));
        });
    }

    protected processUserTypeScreenGet(response: AxiosResponse): Promise<UserTypeScreen> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTypeScreen.fromJS(resultData200);
            return Promise.resolve<UserTypeScreen>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTypeScreen>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userTypeScreenPut(id: string, body: UserTypeScreen | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/userTypeScreen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeScreenPut(_response));
        });
    }

    protected processUserTypeScreenPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    userTypeScreenDelete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/userTypeScreen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeScreenDelete(_response));
        });
    }

    protected processUserTypeScreenDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userTypeScreenPost(body: UserTypeScreen | undefined, cancelToken?: CancelToken): Promise<UserTypeScreen> {
        let url_ = this.baseUrl + "/api/userTypeScreen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserTypeScreenPost(_response));
        });
    }

    protected processUserTypeScreenPost(response: AxiosResponse): Promise<UserTypeScreen> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTypeScreen.fromJS(resultData200);
            return Promise.resolve<UserTypeScreen>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTypeScreen>(null as any);
    }

    /**
     * @return OK
     */
    userUserTypeAll( cancelToken?: CancelToken): Promise<UserUserType[]> {
        let url_ = this.baseUrl + "/api/userUserTypeAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserUserTypeAll(_response));
        });
    }

    protected processUserUserTypeAll(response: AxiosResponse): Promise<UserUserType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserUserType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserUserType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserUserType[]>(null as any);
    }

    /**
     * @return OK
     */
    userUserTypeByUserId(id: string, cancelToken?: CancelToken): Promise<UserUserType[]> {
        let url_ = this.baseUrl + "/api/userUserTypeByUserId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserUserTypeByUserId(_response));
        });
    }

    protected processUserUserTypeByUserId(response: AxiosResponse): Promise<UserUserType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserUserType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserUserType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserUserType[]>(null as any);
    }

    /**
     * @return OK
     */
    userUserType(id: string, cancelToken?: CancelToken): Promise<UserUserType> {
        let url_ = this.baseUrl + "/api/userUserType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserUserType(_response));
        });
    }

    protected processUserUserType(response: AxiosResponse): Promise<UserUserType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserUserType.fromJS(resultData200);
            return Promise.resolve<UserUserType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserUserType>(null as any);
    }

    /**
     * @return OK
     */
    getSteamConsumptionDefault( cancelToken?: CancelToken): Promise<SteamConsumptionDefault[]> {
        let url_ = this.baseUrl + "/api/getSteamConsumptionDefault";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSteamConsumptionDefault(_response));
        });
    }

    protected processGetSteamConsumptionDefault(response: AxiosResponse): Promise<SteamConsumptionDefault[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SteamConsumptionDefault.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SteamConsumptionDefault[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SteamConsumptionDefault[]>(null as any);
    }

    /**
     * @return OK
     */
    getEnergyConsumptionDefault( cancelToken?: CancelToken): Promise<EnergyConsumptionDefault[]> {
        let url_ = this.baseUrl + "/api/getEnergyConsumptionDefault";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnergyConsumptionDefault(_response));
        });
    }

    protected processGetEnergyConsumptionDefault(response: AxiosResponse): Promise<EnergyConsumptionDefault[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyConsumptionDefault.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyConsumptionDefault[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyConsumptionDefault[]>(null as any);
    }

    /**
     * @return OK
     */
    getWFIUnits( cancelToken?: CancelToken): Promise<Unit[]> {
        let url_ = this.baseUrl + "/api/getWFIUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetWFIUnits(_response));
        });
    }

    protected processGetWFIUnits(response: AxiosResponse): Promise<Unit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Unit.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Unit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit[]>(null as any);
    }

    /**
     * @return OK
     */
    getWFISources( cancelToken?: CancelToken): Promise<WFISource[]> {
        let url_ = this.baseUrl + "/api/getWFISources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetWFISources(_response));
        });
    }

    protected processGetWFISources(response: AxiosResponse): Promise<WFISource[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WFISource.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WFISource[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WFISource[]>(null as any);
    }

    /**
     * @return OK
     */
    getFacilityType( cancelToken?: CancelToken): Promise<ISOClassFacilityType[]> {
        let url_ = this.baseUrl + "/api/getFacilityType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFacilityType(_response));
        });
    }

    protected processGetFacilityType(response: AxiosResponse): Promise<ISOClassFacilityType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ISOClassFacilityType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ISOClassFacilityType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ISOClassFacilityType[]>(null as any);
    }

    /**
     * @param facilityTypeId (optional) 
     * @return OK
     */
    getCleanRoomClass(facilityTypeId: string | undefined, cancelToken?: CancelToken): Promise<HVACClass[]> {
        let url_ = this.baseUrl + "/api/getCleanRoomClass?";
        if (facilityTypeId === null)
            throw new globalThis.Error("The parameter 'facilityTypeId' cannot be null.");
        else if (facilityTypeId !== undefined)
            url_ += "facilityTypeId=" + encodeURIComponent("" + facilityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCleanRoomClass(_response));
        });
    }

    protected processGetCleanRoomClass(response: AxiosResponse): Promise<HVACClass[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HVACClass.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HVACClass[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HVACClass[]>(null as any);
    }

    /**
     * @return OK
     */
    getcoldStorageDropdowns( cancelToken?: CancelToken): Promise<ColdStorageDropdowns> {
        let url_ = this.baseUrl + "/api/getcoldStorageDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetcoldStorageDropdowns(_response));
        });
    }

    protected processGetcoldStorageDropdowns(response: AxiosResponse): Promise<ColdStorageDropdowns> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ColdStorageDropdowns.fromJS(resultData200);
            return Promise.resolve<ColdStorageDropdowns>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ColdStorageDropdowns>(null as any);
    }

    /**
     * @param screenId (optional) 
     * @param assessmentId (optional) 
     * @param unitOperationId (optional) 
     * @param roomSize (optional) 
     * @param duration (optional) 
     * @return OK
     */
    getProcessingCleaningCalculation(stepId: string, screenId: string | undefined, assessmentId: string | undefined, unitOperationId: string | undefined, roomSize: number | undefined, duration: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/getProcessingCleaningCalculation/{stepId}?";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (unitOperationId === null)
            throw new globalThis.Error("The parameter 'unitOperationId' cannot be null.");
        else if (unitOperationId !== undefined)
            url_ += "unitOperationId=" + encodeURIComponent("" + unitOperationId) + "&";
        if (roomSize === null)
            throw new globalThis.Error("The parameter 'roomSize' cannot be null.");
        else if (roomSize !== undefined)
            url_ += "roomSize=" + encodeURIComponent("" + roomSize) + "&";
        if (duration === null)
            throw new globalThis.Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProcessingCleaningCalculation(_response));
        });
    }

    protected processGetProcessingCleaningCalculation(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return OK
     */
    getWFISourceResults(stepId: string | undefined, wfiSourceId: string, cancelToken?: CancelToken): Promise<WIFIResults[]> {
        let url_ = this.baseUrl + "/api/getWFISourceResults/{wfiSourceId}?";
        if (wfiSourceId === undefined || wfiSourceId === null)
            throw new globalThis.Error("The parameter 'wfiSourceId' must be defined.");
        url_ = url_.replace("{wfiSourceId}", encodeURIComponent("" + wfiSourceId));
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetWFISourceResults(_response));
        });
    }

    protected processGetWFISourceResults(response: AxiosResponse): Promise<WIFIResults[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WIFIResults.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WIFIResults[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WIFIResults[]>(null as any);
    }

    /**
     * @return OK
     */
    getSteamConsumptionByStepId(stepId: string, cancelToken?: CancelToken): Promise<UtilitiesSteamConsumption[]> {
        let url_ = this.baseUrl + "/api/getSteamConsumptionByStepId/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSteamConsumptionByStepId(_response));
        });
    }

    protected processGetSteamConsumptionByStepId(response: AxiosResponse): Promise<UtilitiesSteamConsumption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtilitiesSteamConsumption.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UtilitiesSteamConsumption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UtilitiesSteamConsumption[]>(null as any);
    }

    /**
     * @return OK
     */
    getEnergyConsumptionByStepId(stepId: string, cancelToken?: CancelToken): Promise<UtilitiesEnergyConsumption[]> {
        let url_ = this.baseUrl + "/api/getEnergyConsumptionByStepId/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnergyConsumptionByStepId(_response));
        });
    }

    protected processGetEnergyConsumptionByStepId(response: AxiosResponse): Promise<UtilitiesEnergyConsumption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtilitiesEnergyConsumption.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UtilitiesEnergyConsumption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UtilitiesEnergyConsumption[]>(null as any);
    }

    /**
     * @return OK
     */
    getSteamConsumptionByUtilitiesId(utilitiesId: string, cancelToken?: CancelToken): Promise<UtilitiesSteamConsumption[]> {
        let url_ = this.baseUrl + "/api/getSteamConsumptionByUtilitiesId/{utilitiesId}";
        if (utilitiesId === undefined || utilitiesId === null)
            throw new globalThis.Error("The parameter 'utilitiesId' must be defined.");
        url_ = url_.replace("{utilitiesId}", encodeURIComponent("" + utilitiesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSteamConsumptionByUtilitiesId(_response));
        });
    }

    protected processGetSteamConsumptionByUtilitiesId(response: AxiosResponse): Promise<UtilitiesSteamConsumption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtilitiesSteamConsumption.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UtilitiesSteamConsumption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UtilitiesSteamConsumption[]>(null as any);
    }

    /**
     * @return OK
     */
    getEnergyConsumptionByUtilitiesId(utilitiesId: string, cancelToken?: CancelToken): Promise<UtilitiesEnergyConsumption[]> {
        let url_ = this.baseUrl + "/api/getEnergyConsumptionByUtilitiesId/{utilitiesId}";
        if (utilitiesId === undefined || utilitiesId === null)
            throw new globalThis.Error("The parameter 'utilitiesId' must be defined.");
        url_ = url_.replace("{utilitiesId}", encodeURIComponent("" + utilitiesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnergyConsumptionByUtilitiesId(_response));
        });
    }

    protected processGetEnergyConsumptionByUtilitiesId(response: AxiosResponse): Promise<UtilitiesEnergyConsumption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtilitiesEnergyConsumption.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UtilitiesEnergyConsumption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UtilitiesEnergyConsumption[]>(null as any);
    }

    /**
     * @return OK
     */
    getUtilitiesByStepId(stepId: string, cancelToken?: CancelToken): Promise<Utilities> {
        let url_ = this.baseUrl + "/api/getUtilitiesByStepId/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUtilitiesByStepId(_response));
        });
    }

    protected processGetUtilitiesByStepId(response: AxiosResponse): Promise<Utilities> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Utilities.fromJS(resultData200);
            return Promise.resolve<Utilities>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Utilities>(null as any);
    }

    /**
     * @return OK
     */
    getUtilitiesByStepIdAndGeneralInformationId(stepId: string, generalInformationId: string, cancelToken?: CancelToken): Promise<Utilities> {
        let url_ = this.baseUrl + "/api/getUtilitiesByStepIdAndGeneralInformationId/{stepId}/{generalInformationId}";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUtilitiesByStepIdAndGeneralInformationId(_response));
        });
    }

    protected processGetUtilitiesByStepIdAndGeneralInformationId(response: AxiosResponse): Promise<Utilities> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Utilities.fromJS(resultData200);
            return Promise.resolve<Utilities>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Utilities>(null as any);
    }

    /**
     * @return OK
     */
    getunitOperationUtilitiesByStepId(stepId: string, cancelToken?: CancelToken): Promise<Step[]> {
        let url_ = this.baseUrl + "/api/getunitOperationUtilitiesByStepId/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetunitOperationUtilitiesByStepId(_response));
        });
    }

    protected processGetunitOperationUtilitiesByStepId(response: AxiosResponse): Promise<Step[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Step.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Step[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Step[]>(null as any);
    }

    /**
     * @param generalInformationId (optional) 
     * @return OK
     */
    getRawMaterialUnitOperationByStepId(stepId: string, generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<RawMaterialUnitOperation[]> {
        let url_ = this.baseUrl + "/api/getRawMaterialUnitOperationByStepId/{stepId}?";
        if (stepId === undefined || stepId === null)
            throw new globalThis.Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRawMaterialUnitOperationByStepId(_response));
        });
    }

    protected processGetRawMaterialUnitOperationByStepId(response: AxiosResponse): Promise<RawMaterialUnitOperation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialUnitOperation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RawMaterialUnitOperation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialUnitOperation[]>(null as any);
    }

    /**
     * @param utilitiesId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateColdStorage(utilitiesId: string | undefined, body: ColdStorageData | undefined, cancelToken?: CancelToken): Promise<ColdStorageData> {
        let url_ = this.baseUrl + "/api/updateColdStorage?";
        if (utilitiesId === null)
            throw new globalThis.Error("The parameter 'utilitiesId' cannot be null.");
        else if (utilitiesId !== undefined)
            url_ += "utilitiesId=" + encodeURIComponent("" + utilitiesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateColdStorage(_response));
        });
    }

    protected processUpdateColdStorage(response: AxiosResponse): Promise<ColdStorageData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ColdStorageData.fromJS(resultData200);
            return Promise.resolve<ColdStorageData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ColdStorageData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateHvacData(body: HvacUtilitiesData | undefined, cancelToken?: CancelToken): Promise<HvacUtilitiesData> {
        let url_ = this.baseUrl + "/api/updateHvacData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateHvacData(_response));
        });
    }

    protected processUpdateHvacData(response: AxiosResponse): Promise<HvacUtilitiesData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HvacUtilitiesData.fromJS(resultData200);
            return Promise.resolve<HvacUtilitiesData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HvacUtilitiesData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRawMaterialProcessingOperationTable(body: RawMaterialUnitOperation | undefined, cancelToken?: CancelToken): Promise<RawMaterialUnitOperation> {
        let url_ = this.baseUrl + "/api/updateRawMaterialProcessingOperationTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateRawMaterialProcessingOperationTable(_response));
        });
    }

    protected processUpdateRawMaterialProcessingOperationTable(response: AxiosResponse): Promise<RawMaterialUnitOperation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialUnitOperation.fromJS(resultData200);
            return Promise.resolve<RawMaterialUnitOperation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialUnitOperation>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateProcessingOperationCF(body: ProcessingOperationCF | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/calculateProcessingOperationCF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCalculateProcessingOperationCF(_response));
        });
    }

    protected processCalculateProcessingOperationCF(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRawMaterialUnitOperation(body: RawMaterialUnitOperation | undefined, cancelToken?: CancelToken): Promise<RawMaterialUnitOperation> {
        let url_ = this.baseUrl + "/api/updateRawMaterialUnitOperation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateRawMaterialUnitOperation(_response));
        });
    }

    protected processUpdateRawMaterialUnitOperation(response: AxiosResponse): Promise<RawMaterialUnitOperation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialUnitOperation.fromJS(resultData200);
            return Promise.resolve<RawMaterialUnitOperation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialUnitOperation>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllRawMaterialUnitOperation(body: RawMaterialUnitOperation[] | undefined, cancelToken?: CancelToken): Promise<RawMaterialUnitOperation[]> {
        let url_ = this.baseUrl + "/api/updateAllRawMaterialUnitOperation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAllRawMaterialUnitOperation(_response));
        });
    }

    protected processUpdateAllRawMaterialUnitOperation(response: AxiosResponse): Promise<RawMaterialUnitOperation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialUnitOperation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RawMaterialUnitOperation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialUnitOperation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSteamConsumption(body: UtilitiesSteamConsumption | undefined, cancelToken?: CancelToken): Promise<UtilitiesSteamConsumption> {
        let url_ = this.baseUrl + "/api/updateSteamConsumption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateSteamConsumption(_response));
        });
    }

    protected processUpdateSteamConsumption(response: AxiosResponse): Promise<UtilitiesSteamConsumption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UtilitiesSteamConsumption.fromJS(resultData200);
            return Promise.resolve<UtilitiesSteamConsumption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UtilitiesSteamConsumption>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProcessingOperation(body: UtilitiesProcessingOperation[] | undefined, cancelToken?: CancelToken): Promise<UtilitiesProcessingOperation[]> {
        let url_ = this.baseUrl + "/api/updateProcessingOperation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProcessingOperation(_response));
        });
    }

    protected processUpdateProcessingOperation(response: AxiosResponse): Promise<UtilitiesProcessingOperation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtilitiesProcessingOperation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UtilitiesProcessingOperation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UtilitiesProcessingOperation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEnergyConsumption(body: UtilitiesEnergyConsumption | undefined, cancelToken?: CancelToken): Promise<UtilitiesEnergyConsumption> {
        let url_ = this.baseUrl + "/api/updateEnergyConsumption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEnergyConsumption(_response));
        });
    }

    protected processUpdateEnergyConsumption(response: AxiosResponse): Promise<UtilitiesEnergyConsumption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UtilitiesEnergyConsumption.fromJS(resultData200);
            return Promise.resolve<UtilitiesEnergyConsumption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UtilitiesEnergyConsumption>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postUtilities(body: Utilities | undefined, cancelToken?: CancelToken): Promise<Utilities> {
        let url_ = this.baseUrl + "/api/postUtilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostUtilities(_response));
        });
    }

    protected processPostUtilities(response: AxiosResponse): Promise<Utilities> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Utilities.fromJS(resultData200);
            return Promise.resolve<Utilities>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Utilities>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    resetUtilitiesEnergyConsumptionToDefaults(projectId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/resetUtilitiesEnergyConsumptionToDefaults?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetUtilitiesEnergyConsumptionToDefaults(_response));
        });
    }

    protected processResetUtilitiesEnergyConsumptionToDefaults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    validateResultMatrixByGeneralInformationId(generalInformationId: string, cancelToken?: CancelToken): Promise<ValidationMessage[]> {
        let url_ = this.baseUrl + "/api/validateResultMatrixByGeneralInformationId/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidateResultMatrixByGeneralInformationId(_response));
        });
    }

    protected processValidateResultMatrixByGeneralInformationId(response: AxiosResponse): Promise<ValidationMessage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValidationMessage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ValidationMessage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationMessage[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateLifecycleSummaryResultMatrix(body: LifeCycleSummaryResultInput | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/validateLifecycleSummaryResultMatrix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidateLifecycleSummaryResultMatrix(_response));
        });
    }

    protected processValidateLifecycleSummaryResultMatrix(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IConfigurationVariableClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<ConfigurationVariableWithDisplay[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: ConfigurationVariable | undefined,  cancelToken?: CancelToken): Promise<ConfigurationVariable>;
    /**
     * @return OK
     */
    delete(id: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @return OK
     */
    getByName(variableName: string,  cancelToken?: CancelToken): Promise<ConfigurationVariable>;
    /**
     * @return OK
     */
    getValue(variableName: string,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @return OK
     */
    getActiveReferenceTables( cancelToken?: CancelToken): Promise<ReferenceTable[]>;
    /**
     * @return OK
     */
    getReferenceTableDataById(referenceTableId: string,  cancelToken?: CancelToken): Promise<any[]>;
    /**
     * @return OK
     */
    getReferenceTableData(tableName: string,  cancelToken?: CancelToken): Promise<any[]>;
}

export class ConfigurationVariableClient extends ApiClientBase implements IConfigurationVariableClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<ConfigurationVariableWithDisplay[]> {
        let url_ = this.baseUrl + "/api/configurationVariable/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<ConfigurationVariableWithDisplay[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigurationVariableWithDisplay.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ConfigurationVariableWithDisplay[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationVariableWithDisplay[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: ConfigurationVariable | undefined, cancelToken?: CancelToken): Promise<ConfigurationVariable> {
        let url_ = this.baseUrl + "/api/configurationVariable/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<ConfigurationVariable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationVariable.fromJS(resultData200);
            return Promise.resolve<ConfigurationVariable>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationVariable>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/configurationVariable/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getByName(variableName: string, cancelToken?: CancelToken): Promise<ConfigurationVariable> {
        let url_ = this.baseUrl + "/api/configurationVariable/GetByName/{variableName}";
        if (variableName === undefined || variableName === null)
            throw new globalThis.Error("The parameter 'variableName' must be defined.");
        url_ = url_.replace("{variableName}", encodeURIComponent("" + variableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByName(_response));
        });
    }

    protected processGetByName(response: AxiosResponse): Promise<ConfigurationVariable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationVariable.fromJS(resultData200);
            return Promise.resolve<ConfigurationVariable>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationVariable>(null as any);
    }

    /**
     * @return OK
     */
    getValue(variableName: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/configurationVariable/GetValue/{variableName}";
        if (variableName === undefined || variableName === null)
            throw new globalThis.Error("The parameter 'variableName' must be defined.");
        url_ = url_.replace("{variableName}", encodeURIComponent("" + variableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetValue(_response));
        });
    }

    protected processGetValue(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getActiveReferenceTables( cancelToken?: CancelToken): Promise<ReferenceTable[]> {
        let url_ = this.baseUrl + "/api/configurationVariable/GetActiveReferenceTables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveReferenceTables(_response));
        });
    }

    protected processGetActiveReferenceTables(response: AxiosResponse): Promise<ReferenceTable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferenceTable.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ReferenceTable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferenceTable[]>(null as any);
    }

    /**
     * @return OK
     */
    getReferenceTableDataById(referenceTableId: string, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/configurationVariable/GetReferenceTableDataById/{referenceTableId}";
        if (referenceTableId === undefined || referenceTableId === null)
            throw new globalThis.Error("The parameter 'referenceTableId' must be defined.");
        url_ = url_.replace("{referenceTableId}", encodeURIComponent("" + referenceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReferenceTableDataById(_response));
        });
    }

    protected processGetReferenceTableDataById(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return OK
     */
    getReferenceTableData(tableName: string, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/configurationVariable/GetReferenceTableData/{tableName}";
        if (tableName === undefined || tableName === null)
            throw new globalThis.Error("The parameter 'tableName' must be defined.");
        url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReferenceTableData(_response));
        });
    }

    protected processGetReferenceTableData(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }
}

export interface IConsumerEolMaterialDefaultClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<ConsumerEolMaterialDefault[]>;
    /**
     * @return OK
     */
    regionList( cancelToken?: CancelToken): Promise<MasterDropdown[]>;
    /**
     * @return OK
     */
    materialList( cancelToken?: CancelToken): Promise<Material[]>;
    /**
     * @return OK
     */
    wasteTypeList( cancelToken?: CancelToken): Promise<WasteType[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: ConsumerEolMaterialDefault | undefined,  cancelToken?: CancelToken): Promise<ConsumerEolMaterialDefault>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: ConsumerEolMaterialDefault | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class ConsumerEolMaterialDefaultClient extends ApiClientBase implements IConsumerEolMaterialDefaultClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<ConsumerEolMaterialDefault[]> {
        let url_ = this.baseUrl + "/api/consumerEolMaterialDefault/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<ConsumerEolMaterialDefault[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumerEolMaterialDefault.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ConsumerEolMaterialDefault[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumerEolMaterialDefault[]>(null as any);
    }

    /**
     * @return OK
     */
    regionList( cancelToken?: CancelToken): Promise<MasterDropdown[]> {
        let url_ = this.baseUrl + "/api/consumerEolMaterialDefault/RegionList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegionList(_response));
        });
    }

    protected processRegionList(response: AxiosResponse): Promise<MasterDropdown[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MasterDropdown[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDropdown[]>(null as any);
    }

    /**
     * @return OK
     */
    materialList( cancelToken?: CancelToken): Promise<Material[]> {
        let url_ = this.baseUrl + "/api/consumerEolMaterialDefault/MaterialList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMaterialList(_response));
        });
    }

    protected processMaterialList(response: AxiosResponse): Promise<Material[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Material.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Material[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Material[]>(null as any);
    }

    /**
     * @return OK
     */
    wasteTypeList( cancelToken?: CancelToken): Promise<WasteType[]> {
        let url_ = this.baseUrl + "/api/consumerEolMaterialDefault/WasteTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWasteTypeList(_response));
        });
    }

    protected processWasteTypeList(response: AxiosResponse): Promise<WasteType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WasteType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WasteType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WasteType[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: ConsumerEolMaterialDefault | undefined, cancelToken?: CancelToken): Promise<ConsumerEolMaterialDefault> {
        let url_ = this.baseUrl + "/api/consumerEolMaterialDefault/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<ConsumerEolMaterialDefault> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumerEolMaterialDefault.fromJS(resultData200);
            return Promise.resolve<ConsumerEolMaterialDefault>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumerEolMaterialDefault>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: ConsumerEolMaterialDefault | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/consumerEolMaterialDefault/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IDemoManagementClient {
    /**
     * @param protectedDomains (optional) 
     * @return OK
     */
    cleanupPreview(protectedDomains: string[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    cleanup(body: string[] | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class DemoManagementClient extends ApiClientBase implements IDemoManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param protectedDomains (optional) 
     * @return OK
     */
    cleanupPreview(protectedDomains: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/demoManagement/cleanupPreview?";
        if (protectedDomains === null)
            throw new globalThis.Error("The parameter 'protectedDomains' cannot be null.");
        else if (protectedDomains !== undefined)
            protectedDomains && protectedDomains.forEach(item => { url_ += "protectedDomains=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCleanupPreview(_response));
        });
    }

    protected processCleanupPreview(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cleanup(body: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/demoManagement/cleanup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCleanup(_response));
        });
    }

    protected processCleanup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEmissionFactorClient {
    /**
     * @return OK
     */
    single( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<EmissionFactors[]>;
    /**
     * @return OK
     */
    emissionFactorTypeList( cancelToken?: CancelToken): Promise<EmissionFactorTypes[]>;
    /**
     * @return OK
     */
    materialEmissionFactorTypes( cancelToken?: CancelToken): Promise<EmissionFactorTypes[]>;
    /**
     * @return OK
     */
    wasteDisposalRouteList( cancelToken?: CancelToken): Promise<WasteDisposalRoute[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EmissionFactors | undefined,  cancelToken?: CancelToken): Promise<EmissionFactors>;
    /**
     * @return OK
     */
    delete(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    wasteDisposalTypeList( cancelToken?: CancelToken): Promise<WasteDisposalType[]>;
    /**
     * @param emissionFactorTypeId (optional) 
     * @return OK
     */
    materialEmissionFactors(materialId: string, emissionFactorTypeId: string | undefined,  cancelToken?: CancelToken): Promise<MaterialEmissionFactor[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveMaterialEmissionFactor(body: MaterialEmissionFactor | undefined,  cancelToken?: CancelToken): Promise<MaterialEmissionFactor>;
    /**
     * @return OK
     */
    deleteMaterialEmissionFactor(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class EmissionFactorClient extends ApiClientBase implements IEmissionFactorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    single( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/emissionFactor/Single";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSingle(_response));
        });
    }

    protected processSingle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<EmissionFactors[]> {
        let url_ = this.baseUrl + "/api/emissionFactor/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<EmissionFactors[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmissionFactors.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmissionFactors[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmissionFactors[]>(null as any);
    }

    /**
     * @return OK
     */
    emissionFactorTypeList( cancelToken?: CancelToken): Promise<EmissionFactorTypes[]> {
        let url_ = this.baseUrl + "/api/emissionFactor/EmissionFactorTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEmissionFactorTypeList(_response));
        });
    }

    protected processEmissionFactorTypeList(response: AxiosResponse): Promise<EmissionFactorTypes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmissionFactorTypes.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmissionFactorTypes[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmissionFactorTypes[]>(null as any);
    }

    /**
     * @return OK
     */
    materialEmissionFactorTypes( cancelToken?: CancelToken): Promise<EmissionFactorTypes[]> {
        let url_ = this.baseUrl + "/api/emissionFactor/MaterialEmissionFactorTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMaterialEmissionFactorTypes(_response));
        });
    }

    protected processMaterialEmissionFactorTypes(response: AxiosResponse): Promise<EmissionFactorTypes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmissionFactorTypes.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmissionFactorTypes[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmissionFactorTypes[]>(null as any);
    }

    /**
     * @return OK
     */
    wasteDisposalRouteList( cancelToken?: CancelToken): Promise<WasteDisposalRoute[]> {
        let url_ = this.baseUrl + "/api/emissionFactor/WasteDisposalRouteList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWasteDisposalRouteList(_response));
        });
    }

    protected processWasteDisposalRouteList(response: AxiosResponse): Promise<WasteDisposalRoute[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WasteDisposalRoute.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WasteDisposalRoute[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WasteDisposalRoute[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EmissionFactors | undefined, cancelToken?: CancelToken): Promise<EmissionFactors> {
        let url_ = this.baseUrl + "/api/emissionFactor/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<EmissionFactors> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmissionFactors.fromJS(resultData200);
            return Promise.resolve<EmissionFactors>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmissionFactors>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/emissionFactor/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    wasteDisposalTypeList( cancelToken?: CancelToken): Promise<WasteDisposalType[]> {
        let url_ = this.baseUrl + "/api/emissionFactor/WasteDisposalTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWasteDisposalTypeList(_response));
        });
    }

    protected processWasteDisposalTypeList(response: AxiosResponse): Promise<WasteDisposalType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WasteDisposalType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WasteDisposalType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WasteDisposalType[]>(null as any);
    }

    /**
     * @param emissionFactorTypeId (optional) 
     * @return OK
     */
    materialEmissionFactors(materialId: string, emissionFactorTypeId: string | undefined, cancelToken?: CancelToken): Promise<MaterialEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/emissionFactor/MaterialEmissionFactors/{materialId}?";
        if (materialId === undefined || materialId === null)
            throw new globalThis.Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        if (emissionFactorTypeId === null)
            throw new globalThis.Error("The parameter 'emissionFactorTypeId' cannot be null.");
        else if (emissionFactorTypeId !== undefined)
            url_ += "emissionFactorTypeId=" + encodeURIComponent("" + emissionFactorTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMaterialEmissionFactors(_response));
        });
    }

    protected processMaterialEmissionFactors(response: AxiosResponse): Promise<MaterialEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialEmissionFactor[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveMaterialEmissionFactor(body: MaterialEmissionFactor | undefined, cancelToken?: CancelToken): Promise<MaterialEmissionFactor> {
        let url_ = this.baseUrl + "/api/emissionFactor/SaveMaterialEmissionFactor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveMaterialEmissionFactor(_response));
        });
    }

    protected processSaveMaterialEmissionFactor(response: AxiosResponse): Promise<MaterialEmissionFactor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialEmissionFactor.fromJS(resultData200);
            return Promise.resolve<MaterialEmissionFactor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialEmissionFactor>(null as any);
    }

    /**
     * @return OK
     */
    deleteMaterialEmissionFactor(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/emissionFactor/DeleteMaterialEmissionFactor/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteMaterialEmissionFactor(_response));
        });
    }

    protected processDeleteMaterialEmissionFactor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEnergyClient {
    /**
     * @param includeInactive (optional) 
     * @return OK
     */
    list(includeInactive: boolean | undefined,  cancelToken?: CancelToken): Promise<Energy[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: Energy | undefined,  cancelToken?: CancelToken): Promise<Energy>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: Energy | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class EnergyClient extends ApiClientBase implements IEnergyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param includeInactive (optional) 
     * @return OK
     */
    list(includeInactive: boolean | undefined, cancelToken?: CancelToken): Promise<Energy[]> {
        let url_ = this.baseUrl + "/api/energy/List?";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<Energy[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Energy.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Energy[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Energy[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: Energy | undefined, cancelToken?: CancelToken): Promise<Energy> {
        let url_ = this.baseUrl + "/api/energy/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<Energy> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Energy.fromJS(resultData200);
            return Promise.resolve<Energy>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Energy>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: Energy | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/energy/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IEnergyEmissionFactorClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]>;
    /**
     * @return OK
     */
    byEnergySource(energySourceId: string,  cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]>;
    /**
     * @return OK
     */
    byEnergy(energyId: string,  cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]>;
    /**
     * @return OK
     */
    bySiteLocation(siteLocationId: string,  cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EnergyEmissionFactor | undefined,  cancelToken?: CancelToken): Promise<EnergyEmissionFactor>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: EnergyEmissionFactor | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class EnergyEmissionFactorClient extends ApiClientBase implements IEnergyEmissionFactorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/energyEmissionFactor/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<EnergyEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyEmissionFactor[]>(null as any);
    }

    /**
     * @return OK
     */
    byEnergySource(energySourceId: string, cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/energyEmissionFactor/ByEnergySource/{energySourceId}";
        if (energySourceId === undefined || energySourceId === null)
            throw new globalThis.Error("The parameter 'energySourceId' must be defined.");
        url_ = url_.replace("{energySourceId}", encodeURIComponent("" + energySourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processByEnergySource(_response));
        });
    }

    protected processByEnergySource(response: AxiosResponse): Promise<EnergyEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyEmissionFactor[]>(null as any);
    }

    /**
     * @return OK
     */
    byEnergy(energyId: string, cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/energyEmissionFactor/ByEnergy/{energyId}";
        if (energyId === undefined || energyId === null)
            throw new globalThis.Error("The parameter 'energyId' must be defined.");
        url_ = url_.replace("{energyId}", encodeURIComponent("" + energyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processByEnergy(_response));
        });
    }

    protected processByEnergy(response: AxiosResponse): Promise<EnergyEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyEmissionFactor[]>(null as any);
    }

    /**
     * @return OK
     */
    bySiteLocation(siteLocationId: string, cancelToken?: CancelToken): Promise<EnergyEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/energyEmissionFactor/BySiteLocation/{siteLocationId}";
        if (siteLocationId === undefined || siteLocationId === null)
            throw new globalThis.Error("The parameter 'siteLocationId' must be defined.");
        url_ = url_.replace("{siteLocationId}", encodeURIComponent("" + siteLocationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBySiteLocation(_response));
        });
    }

    protected processBySiteLocation(response: AxiosResponse): Promise<EnergyEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyEmissionFactor[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EnergyEmissionFactor | undefined, cancelToken?: CancelToken): Promise<EnergyEmissionFactor> {
        let url_ = this.baseUrl + "/api/energyEmissionFactor/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<EnergyEmissionFactor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyEmissionFactor.fromJS(resultData200);
            return Promise.resolve<EnergyEmissionFactor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyEmissionFactor>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: EnergyEmissionFactor | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/energyEmissionFactor/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IEnergyMultipliersClient {
    /**
     * @param projectId (optional) 
     * @return OK
     */
    list(projectId: string | undefined,  cancelToken?: CancelToken): Promise<EnergyMultipliers[]>;
    /**
     * @param moduleScreenId (optional) 
     * @param productFormatSourceScreenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    listFiltered(moduleScreenId: string | undefined, productFormatSourceScreenId: string | undefined, assessmentId: string | undefined,  cancelToken?: CancelToken): Promise<EnergyMultipliers[]>;
    /**
     * @return OK
     */
    energySources( cancelToken?: CancelToken): Promise<Energy[]>;
    /**
     * @param forAPI (optional) 
     * @return OK
     */
    screens(forAPI: boolean | undefined,  cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EnergyMultipliers[] | undefined,  cancelToken?: CancelToken): Promise<EnergyMultipliers[]>;
    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class EnergyMultipliersClient extends ApiClientBase implements IEnergyMultipliersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    list(projectId: string | undefined, cancelToken?: CancelToken): Promise<EnergyMultipliers[]> {
        let url_ = this.baseUrl + "/api/energyMultipliers/List?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<EnergyMultipliers[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyMultipliers.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyMultipliers[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyMultipliers[]>(null as any);
    }

    /**
     * @param moduleScreenId (optional) 
     * @param productFormatSourceScreenId (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    listFiltered(moduleScreenId: string | undefined, productFormatSourceScreenId: string | undefined, assessmentId: string | undefined, cancelToken?: CancelToken): Promise<EnergyMultipliers[]> {
        let url_ = this.baseUrl + "/api/energyMultipliers/ListFiltered?";
        if (moduleScreenId === null)
            throw new globalThis.Error("The parameter 'moduleScreenId' cannot be null.");
        else if (moduleScreenId !== undefined)
            url_ += "moduleScreenId=" + encodeURIComponent("" + moduleScreenId) + "&";
        if (productFormatSourceScreenId === null)
            throw new globalThis.Error("The parameter 'productFormatSourceScreenId' cannot be null.");
        else if (productFormatSourceScreenId !== undefined)
            url_ += "productFormatSourceScreenId=" + encodeURIComponent("" + productFormatSourceScreenId) + "&";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListFiltered(_response));
        });
    }

    protected processListFiltered(response: AxiosResponse): Promise<EnergyMultipliers[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyMultipliers.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyMultipliers[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyMultipliers[]>(null as any);
    }

    /**
     * @return OK
     */
    energySources( cancelToken?: CancelToken): Promise<Energy[]> {
        let url_ = this.baseUrl + "/api/energyMultipliers/EnergySources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnergySources(_response));
        });
    }

    protected processEnergySources(response: AxiosResponse): Promise<Energy[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Energy.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Energy[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Energy[]>(null as any);
    }

    /**
     * @param forAPI (optional) 
     * @return OK
     */
    screens(forAPI: boolean | undefined, cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/energyMultipliers/Screens?";
        if (forAPI === null)
            throw new globalThis.Error("The parameter 'forAPI' cannot be null.");
        else if (forAPI !== undefined)
            url_ += "forAPI=" + encodeURIComponent("" + forAPI) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processScreens(_response));
        });
    }

    protected processScreens(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EnergyMultipliers[] | undefined, cancelToken?: CancelToken): Promise<EnergyMultipliers[]> {
        let url_ = this.baseUrl + "/api/energyMultipliers/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<EnergyMultipliers[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyMultipliers.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergyMultipliers[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyMultipliers[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/energyMultipliers/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEnergySourceClient {
    /**
     * @param includeInactive (optional) 
     * @return OK
     */
    list(includeInactive: boolean | undefined,  cancelToken?: CancelToken): Promise<EnergySource[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EnergySource | undefined,  cancelToken?: CancelToken): Promise<EnergySource>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: EnergySource | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    energyEmissionFactorTemplate(emptyTemplate: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importEnergyEmissionFactorData(file: FileParameter | undefined, uploadSessionId: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadUploadResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class EnergySourceClient extends ApiClientBase implements IEnergySourceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param includeInactive (optional) 
     * @return OK
     */
    list(includeInactive: boolean | undefined, cancelToken?: CancelToken): Promise<EnergySource[]> {
        let url_ = this.baseUrl + "/api/energySource/List?";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<EnergySource[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergySource.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EnergySource[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergySource[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: EnergySource | undefined, cancelToken?: CancelToken): Promise<EnergySource> {
        let url_ = this.baseUrl + "/api/energySource/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<EnergySource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergySource.fromJS(resultData200);
            return Promise.resolve<EnergySource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergySource>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: EnergySource | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/energySource/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    energyEmissionFactorTemplate(emptyTemplate: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/energySource/EnergyEmissionFactorTemplate?";
        if (emptyTemplate === null)
            throw new globalThis.Error("The parameter 'emptyTemplate' cannot be null.");
        else if (emptyTemplate !== undefined)
            url_ += "emptyTemplate=" + encodeURIComponent("" + emptyTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnergyEmissionFactorTemplate(_response));
        });
    }

    protected processEnergyEmissionFactorTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importEnergyEmissionFactorData(file: FileParameter | undefined, uploadSessionId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/energySource/ImportEnergyEmissionFactorData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (uploadSessionId === null || uploadSessionId === undefined)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else
            content_.append("uploadSessionId", uploadSessionId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportEnergyEmissionFactorData(_response));
        });
    }

    protected processImportEnergyEmissionFactorData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadUploadResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/energySource/DownloadUploadResults?";
        if (uploadSessionId === null)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else if (uploadSessionId !== undefined)
            url_ += "uploadSessionId=" + encodeURIComponent("" + uploadSessionId) + "&";
        if (errorsOnly === null)
            throw new globalThis.Error("The parameter 'errorsOnly' cannot be null.");
        else if (errorsOnly !== undefined)
            url_ += "errorsOnly=" + encodeURIComponent("" + errorsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadUploadResults(_response));
        });
    }

    protected processDownloadUploadResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFeatureFlagClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<FeatureFlag[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: FeatureFlag | undefined,  cancelToken?: CancelToken): Promise<FeatureFlag>;
    /**
     * @return OK
     */
    getByName(flagName: string,  cancelToken?: CancelToken): Promise<FeatureFlag>;
    /**
     * @return OK
     */
    isEnabled(flagName: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @return OK
     */
    isFlagEnabled(flagName: string,  cancelToken?: CancelToken): Promise<boolean>;
}

export class FeatureFlagClient extends ApiClientBase implements IFeatureFlagClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<FeatureFlag[]> {
        let url_ = this.baseUrl + "/api/FeatureFlag/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<FeatureFlag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureFlag.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FeatureFlag[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureFlag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: FeatureFlag | undefined, cancelToken?: CancelToken): Promise<FeatureFlag> {
        let url_ = this.baseUrl + "/api/FeatureFlag/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<FeatureFlag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeatureFlag.fromJS(resultData200);
            return Promise.resolve<FeatureFlag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureFlag>(null as any);
    }

    /**
     * @return OK
     */
    getByName(flagName: string, cancelToken?: CancelToken): Promise<FeatureFlag> {
        let url_ = this.baseUrl + "/api/FeatureFlag/GetByName/{flagName}";
        if (flagName === undefined || flagName === null)
            throw new globalThis.Error("The parameter 'flagName' must be defined.");
        url_ = url_.replace("{flagName}", encodeURIComponent("" + flagName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByName(_response));
        });
    }

    protected processGetByName(response: AxiosResponse): Promise<FeatureFlag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeatureFlag.fromJS(resultData200);
            return Promise.resolve<FeatureFlag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureFlag>(null as any);
    }

    /**
     * @return OK
     */
    isEnabled(flagName: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FeatureFlag/IsEnabled/{flagName}";
        if (flagName === undefined || flagName === null)
            throw new globalThis.Error("The parameter 'flagName' must be defined.");
        url_ = url_.replace("{flagName}", encodeURIComponent("" + flagName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsEnabled(_response));
        });
    }

    protected processIsEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    isFlagEnabled(flagName: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FeatureFlag/IsFlagEnabled/{flagName}";
        if (flagName === undefined || flagName === null)
            throw new globalThis.Error("The parameter 'flagName' must be defined.");
        url_ = url_.replace("{flagName}", encodeURIComponent("" + flagName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsFlagEnabled(_response));
        });
    }

    protected processIsFlagEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IGeneralInformationClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    calculateWetWeight(body: WetWeightCalculationRequest | undefined,  cancelToken?: CancelToken): Promise<WetWeightCalculationResponse>;
    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getProductFormatSourceScreenId(assessmentId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @return OK
     */
    getCompOptionTreeStructure( cancelToken?: CancelToken): Promise<any[]>;
    /**
     * @return OK
     */
    getProductFormatComplianceCheck( cancelToken?: CancelToken): Promise<ProductFormatComplianceCheckResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateProductFormatField(body: UpdateProductFormatFieldRequest | undefined,  cancelToken?: CancelToken): Promise<UpdateProductFormatFieldResponse>;
    /**
     * @param allowMultiOptionScreens (optional) 
     * @return OK
     */
    checkDuplicates(allowMultiOptionScreens: boolean | undefined,  cancelToken?: CancelToken): Promise<DuplicateGeneralInformationCheckResult>;
    /**
     * @return OK
     */
    delete(generalInformationId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    copy(body: CopyGeneralInformationRequest | undefined,  cancelToken?: CancelToken): Promise<CopyGeneralInformationResponse>;
    /**
     * @return OK
     */
    graphPositionsGet(generalInformationId: string,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    graphPositionsPost(generalInformationId: string, body: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class GeneralInformationClient extends ApiClientBase implements IGeneralInformationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateWetWeight(body: WetWeightCalculationRequest | undefined, cancelToken?: CancelToken): Promise<WetWeightCalculationResponse> {
        let url_ = this.baseUrl + "/api/generalInformation/CalculateWetWeight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCalculateWetWeight(_response));
        });
    }

    protected processCalculateWetWeight(response: AxiosResponse): Promise<WetWeightCalculationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WetWeightCalculationResponse.fromJS(resultData200);
            return Promise.resolve<WetWeightCalculationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WetWeightCalculationResponse>(null as any);
    }

    /**
     * @param assessmentId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    getProductFormatSourceScreenId(assessmentId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/generalInformation/GetProductFormatSourceScreenId?";
        if (assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductFormatSourceScreenId(_response));
        });
    }

    protected processGetProductFormatSourceScreenId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getCompOptionTreeStructure( cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/generalInformation/GetCompOptionTreeStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCompOptionTreeStructure(_response));
        });
    }

    protected processGetCompOptionTreeStructure(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return OK
     */
    getProductFormatComplianceCheck( cancelToken?: CancelToken): Promise<ProductFormatComplianceCheckResponse> {
        let url_ = this.baseUrl + "/api/generalInformation/GetProductFormatComplianceCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProductFormatComplianceCheck(_response));
        });
    }

    protected processGetProductFormatComplianceCheck(response: AxiosResponse): Promise<ProductFormatComplianceCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductFormatComplianceCheckResponse.fromJS(resultData200);
            return Promise.resolve<ProductFormatComplianceCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFormatComplianceCheckResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProductFormatField(body: UpdateProductFormatFieldRequest | undefined, cancelToken?: CancelToken): Promise<UpdateProductFormatFieldResponse> {
        let url_ = this.baseUrl + "/api/generalInformation/UpdateProductFormatField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProductFormatField(_response));
        });
    }

    protected processUpdateProductFormatField(response: AxiosResponse): Promise<UpdateProductFormatFieldResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateProductFormatFieldResponse.fromJS(resultData200);
            return Promise.resolve<UpdateProductFormatFieldResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateProductFormatFieldResponse>(null as any);
    }

    /**
     * @param allowMultiOptionScreens (optional) 
     * @return OK
     */
    checkDuplicates(allowMultiOptionScreens: boolean | undefined, cancelToken?: CancelToken): Promise<DuplicateGeneralInformationCheckResult> {
        let url_ = this.baseUrl + "/api/generalInformation/checkDuplicates?";
        if (allowMultiOptionScreens === null)
            throw new globalThis.Error("The parameter 'allowMultiOptionScreens' cannot be null.");
        else if (allowMultiOptionScreens !== undefined)
            url_ += "allowMultiOptionScreens=" + encodeURIComponent("" + allowMultiOptionScreens) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckDuplicates(_response));
        });
    }

    protected processCheckDuplicates(response: AxiosResponse): Promise<DuplicateGeneralInformationCheckResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DuplicateGeneralInformationCheckResult.fromJS(resultData200);
            return Promise.resolve<DuplicateGeneralInformationCheckResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DuplicateGeneralInformationCheckResult>(null as any);
    }

    /**
     * @return OK
     */
    delete(generalInformationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/generalInformation/delete/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    copy(body: CopyGeneralInformationRequest | undefined, cancelToken?: CancelToken): Promise<CopyGeneralInformationResponse> {
        let url_ = this.baseUrl + "/api/generalInformation/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCopy(_response));
        });
    }

    protected processCopy(response: AxiosResponse): Promise<CopyGeneralInformationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyGeneralInformationResponse.fromJS(resultData200);
            return Promise.resolve<CopyGeneralInformationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyGeneralInformationResponse>(null as any);
    }

    /**
     * @return OK
     */
    graphPositionsGet(generalInformationId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/generalInformation/graphPositions/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGraphPositionsGet(_response));
        });
    }

    protected processGraphPositionsGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    graphPositionsPost(generalInformationId: string, body: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/generalInformation/graphPositions/{generalInformationId}";
        if (generalInformationId === undefined || generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' must be defined.");
        url_ = url_.replace("{generalInformationId}", encodeURIComponent("" + generalInformationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGraphPositionsPost(_response));
        });
    }

    protected processGraphPositionsPost(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IHVACClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<HVAC[]>;
    /**
     * @return OK
     */
    hVACClassList( cancelToken?: CancelToken): Promise<HVACClass[]>;
    /**
     * @return OK
     */
    facilityTypeList( cancelToken?: CancelToken): Promise<ISOClassFacilityType[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: HVAC | undefined,  cancelToken?: CancelToken): Promise<HVAC>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: HVAC | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class HVACClient extends ApiClientBase implements IHVACClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<HVAC[]> {
        let url_ = this.baseUrl + "/api/HVAC/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<HVAC[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HVAC.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HVAC[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HVAC[]>(null as any);
    }

    /**
     * @return OK
     */
    hVACClassList( cancelToken?: CancelToken): Promise<HVACClass[]> {
        let url_ = this.baseUrl + "/api/HVAC/HVACClassList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHVACClassList(_response));
        });
    }

    protected processHVACClassList(response: AxiosResponse): Promise<HVACClass[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HVACClass.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HVACClass[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HVACClass[]>(null as any);
    }

    /**
     * @return OK
     */
    facilityTypeList( cancelToken?: CancelToken): Promise<ISOClassFacilityType[]> {
        let url_ = this.baseUrl + "/api/HVAC/FacilityTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFacilityTypeList(_response));
        });
    }

    protected processFacilityTypeList(response: AxiosResponse): Promise<ISOClassFacilityType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ISOClassFacilityType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ISOClassFacilityType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ISOClassFacilityType[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: HVAC | undefined, cancelToken?: CancelToken): Promise<HVAC> {
        let url_ = this.baseUrl + "/api/HVAC/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<HVAC> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HVAC.fromJS(resultData200);
            return Promise.resolve<HVAC>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HVAC>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: HVAC | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/HVAC/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IImageConversionClient {
    /**
     * @param imageFile (optional) 
     * @return OK
     */
    extractColors(imageFile: FileParameter | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * @param imageFile (optional) 
     * @param colorMappings (optional) 
     * @return OK
     */
    convertToColorSvg(imageFile: FileParameter | undefined, colorMappings: string | undefined,  cancelToken?: CancelToken): Promise<string>;
}

export class ImageConversionClient extends ApiClientBase implements IImageConversionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param imageFile (optional) 
     * @return OK
     */
    extractColors(imageFile: FileParameter | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/imageConversion/extractColors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile === null || imageFile === undefined)
            throw new globalThis.Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExtractColors(_response));
        });
    }

    protected processExtractColors(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param imageFile (optional) 
     * @param colorMappings (optional) 
     * @return OK
     */
    convertToColorSvg(imageFile: FileParameter | undefined, colorMappings: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/imageConversion/convertToColorSvg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile === null || imageFile === undefined)
            throw new globalThis.Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");
        if (colorMappings === null || colorMappings === undefined)
            throw new globalThis.Error("The parameter 'colorMappings' cannot be null.");
        else
            content_.append("colorMappings", colorMappings.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConvertToColorSvg(_response));
        });
    }

    protected processConvertToColorSvg(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IKnowledgeArticleClient {
    /**
     * @return OK
     */
    feedback(articleId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    tags(articleId: string, body: string[] | undefined,  cancelToken?: CancelToken): Promise<KnowledgeTag[]>;
}

export class KnowledgeArticleClient extends ApiClientBase implements IKnowledgeArticleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    feedback(articleId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/knowledgeArticle/{articleId}/feedback";
        if (articleId === undefined || articleId === null)
            throw new globalThis.Error("The parameter 'articleId' must be defined.");
        url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFeedback(_response));
        });
    }

    protected processFeedback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tags(articleId: string, body: string[] | undefined, cancelToken?: CancelToken): Promise<KnowledgeTag[]> {
        let url_ = this.baseUrl + "/api/knowledgeArticle/{articleId}/tags";
        if (articleId === undefined || articleId === null)
            throw new globalThis.Error("The parameter 'articleId' must be defined.");
        url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTags(_response));
        });
    }

    protected processTags(response: AxiosResponse): Promise<KnowledgeTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KnowledgeTag.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<KnowledgeTag[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeTag[]>(null as any);
    }
}

export interface ILogoutClient {
    /**
     * @return OK
     */
    callback( cancelToken?: CancelToken): Promise<void>;
}

export class LogoutClient extends ApiClientBase implements ILogoutClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    callback( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/logout/callback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCallback(_response));
        });
    }

    protected processCallback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMasterDataManagementClient {
    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    materialEmissionFactorTemplate(emptyTemplate: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importMaterialEmissionFactorData(file: FileParameter | undefined, uploadSessionId: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadUploadResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class MasterDataManagementClient extends ApiClientBase implements IMasterDataManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    materialEmissionFactorTemplate(emptyTemplate: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MasterDataManagement/MaterialEmissionFactorTemplate?";
        if (emptyTemplate === null)
            throw new globalThis.Error("The parameter 'emptyTemplate' cannot be null.");
        else if (emptyTemplate !== undefined)
            url_ += "emptyTemplate=" + encodeURIComponent("" + emptyTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMaterialEmissionFactorTemplate(_response));
        });
    }

    protected processMaterialEmissionFactorTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importMaterialEmissionFactorData(file: FileParameter | undefined, uploadSessionId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MasterDataManagement/ImportMaterialEmissionFactorData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (uploadSessionId === null || uploadSessionId === undefined)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else
            content_.append("uploadSessionId", uploadSessionId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportMaterialEmissionFactorData(_response));
        });
    }

    protected processImportMaterialEmissionFactorData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadUploadResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MasterDataManagement/DownloadUploadResults?";
        if (uploadSessionId === null)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else if (uploadSessionId !== undefined)
            url_ += "uploadSessionId=" + encodeURIComponent("" + uploadSessionId) + "&";
        if (errorsOnly === null)
            throw new globalThis.Error("The parameter 'errorsOnly' cannot be null.");
        else if (errorsOnly !== undefined)
            url_ += "errorsOnly=" + encodeURIComponent("" + errorsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadUploadResults(_response));
        });
    }

    protected processDownloadUploadResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMasterDropdownClient {
    /**
     * @return OK
     */
    single(id: string,  cancelToken?: CancelToken): Promise<MasterDropdown>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: MasterDropdown | undefined,  cancelToken?: CancelToken): Promise<MasterDropdown>;
    /**
     * @return OK
     */
    dropdownCategoryList( cancelToken?: CancelToken): Promise<MasterCategory[]>;
    /**
     * @param categoryKey (optional) 
     * @return OK
     */
    listByCategoryKey(categoryKey: string | undefined,  cancelToken?: CancelToken): Promise<any[]>;
}

export class MasterDropdownClient extends ApiClientBase implements IMasterDropdownClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    single(id: string, cancelToken?: CancelToken): Promise<MasterDropdown> {
        let url_ = this.baseUrl + "/api/masterDropdown/Single/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSingle(_response));
        });
    }

    protected processSingle(response: AxiosResponse): Promise<MasterDropdown> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterDropdown.fromJS(resultData200);
            return Promise.resolve<MasterDropdown>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDropdown>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: MasterDropdown | undefined, cancelToken?: CancelToken): Promise<MasterDropdown> {
        let url_ = this.baseUrl + "/api/masterDropdown/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<MasterDropdown> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterDropdown.fromJS(resultData200);
            return Promise.resolve<MasterDropdown>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDropdown>(null as any);
    }

    /**
     * @return OK
     */
    dropdownCategoryList( cancelToken?: CancelToken): Promise<MasterCategory[]> {
        let url_ = this.baseUrl + "/api/masterDropdown/DropdownCategoryList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDropdownCategoryList(_response));
        });
    }

    protected processDropdownCategoryList(response: AxiosResponse): Promise<MasterCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MasterCategory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterCategory[]>(null as any);
    }

    /**
     * @param categoryKey (optional) 
     * @return OK
     */
    listByCategoryKey(categoryKey: string | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/masterDropdown/ListByCategoryKey?";
        if (categoryKey === null)
            throw new globalThis.Error("The parameter 'categoryKey' cannot be null.");
        else if (categoryKey !== undefined)
            url_ += "categoryKey=" + encodeURIComponent("" + categoryKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListByCategoryKey(_response));
        });
    }

    protected processListByCategoryKey(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }
}

export interface IMaterialDataClient {
    /**
     * @return OK
     */
    getMaterialData( cancelToken?: CancelToken): Promise<MaterialDataBrowseItem[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    compareMaterials(body: string[] | undefined,  cancelToken?: CancelToken): Promise<MaterialCompareItem[]>;
}

export class MaterialDataClient extends ApiClientBase implements IMaterialDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getMaterialData( cancelToken?: CancelToken): Promise<MaterialDataBrowseItem[]> {
        let url_ = this.baseUrl + "/api/materialData/GetMaterialData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMaterialData(_response));
        });
    }

    protected processGetMaterialData(response: AxiosResponse): Promise<MaterialDataBrowseItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialDataBrowseItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialDataBrowseItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialDataBrowseItem[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    compareMaterials(body: string[] | undefined, cancelToken?: CancelToken): Promise<MaterialCompareItem[]> {
        let url_ = this.baseUrl + "/api/materialData/CompareMaterials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompareMaterials(_response));
        });
    }

    protected processCompareMaterials(response: AxiosResponse): Promise<MaterialCompareItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialCompareItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialCompareItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialCompareItem[]>(null as any);
    }
}

export interface IMaterialScreenConsistencyClient {
    /**
     * @return OK
     */
    check( cancelToken?: CancelToken): Promise<MaterialScreenInconsistencyResponse>;
    /**
     * @return OK
     */
    delete(materialScreenId: string,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param materialTypeId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    addScreenToMaterialType(materialTypeId: string | undefined, screenId: string | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @return OK
     */
    checkDuplicates( cancelToken?: CancelToken): Promise<DuplicateCheckResponse>;
    /**
     * @return OK
     */
    deleteDuplicates( cancelToken?: CancelToken): Promise<DuplicateDeleteResult>;
    /**
     * @return OK
     */
    autoFix( cancelToken?: CancelToken): Promise<AutoFixResult>;
}

export class MaterialScreenConsistencyClient extends ApiClientBase implements IMaterialScreenConsistencyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    check( cancelToken?: CancelToken): Promise<MaterialScreenInconsistencyResponse> {
        let url_ = this.baseUrl + "/api/materialScreenConsistency/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheck(_response));
        });
    }

    protected processCheck(response: AxiosResponse): Promise<MaterialScreenInconsistencyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialScreenInconsistencyResponse.fromJS(resultData200);
            return Promise.resolve<MaterialScreenInconsistencyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialScreenInconsistencyResponse>(null as any);
    }

    /**
     * @return OK
     */
    delete(materialScreenId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/materialScreenConsistency/delete/{materialScreenId}";
        if (materialScreenId === undefined || materialScreenId === null)
            throw new globalThis.Error("The parameter 'materialScreenId' must be defined.");
        url_ = url_.replace("{materialScreenId}", encodeURIComponent("" + materialScreenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param materialTypeId (optional) 
     * @param screenId (optional) 
     * @return OK
     */
    addScreenToMaterialType(materialTypeId: string | undefined, screenId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/materialScreenConsistency/addScreenToMaterialType?";
        if (materialTypeId === null)
            throw new globalThis.Error("The parameter 'materialTypeId' cannot be null.");
        else if (materialTypeId !== undefined)
            url_ += "materialTypeId=" + encodeURIComponent("" + materialTypeId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddScreenToMaterialType(_response));
        });
    }

    protected processAddScreenToMaterialType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    checkDuplicates( cancelToken?: CancelToken): Promise<DuplicateCheckResponse> {
        let url_ = this.baseUrl + "/api/materialScreenConsistency/checkDuplicates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckDuplicates(_response));
        });
    }

    protected processCheckDuplicates(response: AxiosResponse): Promise<DuplicateCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DuplicateCheckResponse.fromJS(resultData200);
            return Promise.resolve<DuplicateCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DuplicateCheckResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteDuplicates( cancelToken?: CancelToken): Promise<DuplicateDeleteResult> {
        let url_ = this.baseUrl + "/api/materialScreenConsistency/deleteDuplicates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDuplicates(_response));
        });
    }

    protected processDeleteDuplicates(response: AxiosResponse): Promise<DuplicateDeleteResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DuplicateDeleteResult.fromJS(resultData200);
            return Promise.resolve<DuplicateDeleteResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DuplicateDeleteResult>(null as any);
    }

    /**
     * @return OK
     */
    autoFix( cancelToken?: CancelToken): Promise<AutoFixResult> {
        let url_ = this.baseUrl + "/api/materialScreenConsistency/autoFix";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAutoFix(_response));
        });
    }

    protected processAutoFix(response: AxiosResponse): Promise<AutoFixResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AutoFixResult.fromJS(resultData200);
            return Promise.resolve<AutoFixResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutoFixResult>(null as any);
    }
}

export interface IMgmRawMaterialsClient {
    /**
     * @param materialId (optional) 
     * @return OK
     */
    single(materialId: string | undefined,  cancelToken?: CancelToken): Promise<Material>;
    /**
     * @return OK
     */
    mgmGetAllMaterialsVersion( cancelToken?: CancelToken): Promise<RawMaterialVersion[]>;
    /**
     * @param screenId (optional) 
     * @return OK
     */
    mgmGetAllSubMaterialsByScreen(screenId: string | undefined,  cancelToken?: CancelToken): Promise<MaterialSubType[]>;
    /**
     * @return OK
     */
    mgmGetQualityRatingsColors( cancelToken?: CancelToken): Promise<DataQualityRating[]>;
    /**
     * @param versionId (optional) 
     * @return OK
     */
    mgmGetRawMaterialsTreeByVersion(versionId: string | undefined,  cancelToken?: CancelToken): Promise<TreeForMaterialMgm[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    mgmDeleteUndeleteMaterialType(body: MaterialType | undefined,  cancelToken?: CancelToken): Promise<MaterialType>;
    /**
     * @param body (optional) 
     * @return OK
     */
    mgmCheckIfMaterialCanBeRemoved(body: MaterialListForTable | undefined,  cancelToken?: CancelToken): Promise<MaterialCheckOnSave>;
    /**
     * @param body (optional) 
     * @return OK
     */
    mgmCheckIfMaterialCanBeSaved(body: RawMaterialsEolEF | undefined,  cancelToken?: CancelToken): Promise<MaterialCheckOnSave>;
    /**
     * @param deleteMaterial (optional) 
     * @param body (optional) 
     * @return OK
     */
    mgmDeleteUndeleteMaterial(deleteMaterial: boolean | undefined, body: MaterialListForTable[] | undefined,  cancelToken?: CancelToken): Promise<MaterialListForTable[]>;
    /**
     * @param active (optional) 
     * @return OK
     */
    mgmGetAllRawMaterials(active: boolean | undefined,  cancelToken?: CancelToken): Promise<MaterialListForTable[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    mgmSaveMaterial(body: RawMaterialsEolEF | undefined,  cancelToken?: CancelToken): Promise<RawMaterialsEolEF>;
    /**
     * @param body (optional) 
     * @return OK
     */
    mgmSaveTheMaterialType(body: MaterialTypeMgm | undefined,  cancelToken?: CancelToken): Promise<MaterialTypeMgm>;
    /**
     * @return OK
     */
    mgmRawMaterialsAll( cancelToken?: CancelToken): Promise<Material[]>;
    /**
     * @return OK
     */
    disposalType( cancelToken?: CancelToken): Promise<WasteDisposalRoute[]>;
    /**
     * @param materialTypeId (optional) 
     * @return OK
     */
    getSkillAreaPerMaterialType(materialTypeId: string | undefined,  cancelToken?: CancelToken): Promise<MaterialTypeScreen[]>;
    /**
     * @return OK
     */
    mgmGetAllSkillArea( cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @return OK
     */
    mgmMaterialTypesAll( cancelToken?: CancelToken): Promise<MaterialType[]>;
    /**
     * @return OK
     */
    mgmMaterialSubTypesAll( cancelToken?: CancelToken): Promise<MaterialSubType[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    mgmMaterialSubTypesPerScreen(body: Screen[] | undefined,  cancelToken?: CancelToken): Promise<MaterialSubType[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    mgmSaveMaterialSubType(body: MaterialSubType | undefined,  cancelToken?: CancelToken): Promise<MaterialSubType>;
    /**
     * @param materialSubTypeId (optional) 
     * @return OK
     */
    mgmDeleteMaterialSubType(materialSubTypeId: string | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class MgmRawMaterialsClient extends ApiClientBase implements IMgmRawMaterialsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param materialId (optional) 
     * @return OK
     */
    single(materialId: string | undefined, cancelToken?: CancelToken): Promise<Material> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/single?";
        if (materialId === null)
            throw new globalThis.Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSingle(_response));
        });
    }

    protected processSingle(response: AxiosResponse): Promise<Material> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Material.fromJS(resultData200);
            return Promise.resolve<Material>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Material>(null as any);
    }

    /**
     * @return OK
     */
    mgmGetAllMaterialsVersion( cancelToken?: CancelToken): Promise<RawMaterialVersion[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmGetAllMaterialsVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmGetAllMaterialsVersion(_response));
        });
    }

    protected processMgmGetAllMaterialsVersion(response: AxiosResponse): Promise<RawMaterialVersion[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialVersion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RawMaterialVersion[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialVersion[]>(null as any);
    }

    /**
     * @param screenId (optional) 
     * @return OK
     */
    mgmGetAllSubMaterialsByScreen(screenId: string | undefined, cancelToken?: CancelToken): Promise<MaterialSubType[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmGetAllSubMaterialsByScreen?";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmGetAllSubMaterialsByScreen(_response));
        });
    }

    protected processMgmGetAllSubMaterialsByScreen(response: AxiosResponse): Promise<MaterialSubType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialSubType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialSubType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialSubType[]>(null as any);
    }

    /**
     * @return OK
     */
    mgmGetQualityRatingsColors( cancelToken?: CancelToken): Promise<DataQualityRating[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmGetQualityRatingsColors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmGetQualityRatingsColors(_response));
        });
    }

    protected processMgmGetQualityRatingsColors(response: AxiosResponse): Promise<DataQualityRating[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataQualityRating.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DataQualityRating[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataQualityRating[]>(null as any);
    }

    /**
     * @param versionId (optional) 
     * @return OK
     */
    mgmGetRawMaterialsTreeByVersion(versionId: string | undefined, cancelToken?: CancelToken): Promise<TreeForMaterialMgm[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmGetRawMaterialsTreeByVersion?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmGetRawMaterialsTreeByVersion(_response));
        });
    }

    protected processMgmGetRawMaterialsTreeByVersion(response: AxiosResponse): Promise<TreeForMaterialMgm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeForMaterialMgm.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TreeForMaterialMgm[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeForMaterialMgm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mgmDeleteUndeleteMaterialType(body: MaterialType | undefined, cancelToken?: CancelToken): Promise<MaterialType> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmDeleteUndeleteMaterialType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmDeleteUndeleteMaterialType(_response));
        });
    }

    protected processMgmDeleteUndeleteMaterialType(response: AxiosResponse): Promise<MaterialType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialType.fromJS(resultData200);
            return Promise.resolve<MaterialType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialType>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mgmCheckIfMaterialCanBeRemoved(body: MaterialListForTable | undefined, cancelToken?: CancelToken): Promise<MaterialCheckOnSave> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmCheckIfMaterialCanBeRemoved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmCheckIfMaterialCanBeRemoved(_response));
        });
    }

    protected processMgmCheckIfMaterialCanBeRemoved(response: AxiosResponse): Promise<MaterialCheckOnSave> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialCheckOnSave.fromJS(resultData200);
            return Promise.resolve<MaterialCheckOnSave>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialCheckOnSave>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mgmCheckIfMaterialCanBeSaved(body: RawMaterialsEolEF | undefined, cancelToken?: CancelToken): Promise<MaterialCheckOnSave> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmCheckIfMaterialCanBeSaved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmCheckIfMaterialCanBeSaved(_response));
        });
    }

    protected processMgmCheckIfMaterialCanBeSaved(response: AxiosResponse): Promise<MaterialCheckOnSave> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialCheckOnSave.fromJS(resultData200);
            return Promise.resolve<MaterialCheckOnSave>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialCheckOnSave>(null as any);
    }

    /**
     * @param deleteMaterial (optional) 
     * @param body (optional) 
     * @return OK
     */
    mgmDeleteUndeleteMaterial(deleteMaterial: boolean | undefined, body: MaterialListForTable[] | undefined, cancelToken?: CancelToken): Promise<MaterialListForTable[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmDeleteUndeleteMaterial?";
        if (deleteMaterial === null)
            throw new globalThis.Error("The parameter 'deleteMaterial' cannot be null.");
        else if (deleteMaterial !== undefined)
            url_ += "deleteMaterial=" + encodeURIComponent("" + deleteMaterial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmDeleteUndeleteMaterial(_response));
        });
    }

    protected processMgmDeleteUndeleteMaterial(response: AxiosResponse): Promise<MaterialListForTable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialListForTable.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialListForTable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialListForTable[]>(null as any);
    }

    /**
     * @param active (optional) 
     * @return OK
     */
    mgmGetAllRawMaterials(active: boolean | undefined, cancelToken?: CancelToken): Promise<MaterialListForTable[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmGetAllRawMaterials?";
        if (active === null)
            throw new globalThis.Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmGetAllRawMaterials(_response));
        });
    }

    protected processMgmGetAllRawMaterials(response: AxiosResponse): Promise<MaterialListForTable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialListForTable.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialListForTable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialListForTable[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mgmSaveMaterial(body: RawMaterialsEolEF | undefined, cancelToken?: CancelToken): Promise<RawMaterialsEolEF> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmSaveMaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmSaveMaterial(_response));
        });
    }

    protected processMgmSaveMaterial(response: AxiosResponse): Promise<RawMaterialsEolEF> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialsEolEF.fromJS(resultData200);
            return Promise.resolve<RawMaterialsEolEF>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialsEolEF>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mgmSaveTheMaterialType(body: MaterialTypeMgm | undefined, cancelToken?: CancelToken): Promise<MaterialTypeMgm> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmSaveTheMaterialType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmSaveTheMaterialType(_response));
        });
    }

    protected processMgmSaveTheMaterialType(response: AxiosResponse): Promise<MaterialTypeMgm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialTypeMgm.fromJS(resultData200);
            return Promise.resolve<MaterialTypeMgm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialTypeMgm>(null as any);
    }

    /**
     * @return OK
     */
    mgmRawMaterialsAll( cancelToken?: CancelToken): Promise<Material[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmRawMaterialsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmRawMaterialsAll(_response));
        });
    }

    protected processMgmRawMaterialsAll(response: AxiosResponse): Promise<Material[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Material.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Material[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Material[]>(null as any);
    }

    /**
     * @return OK
     */
    disposalType( cancelToken?: CancelToken): Promise<WasteDisposalRoute[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/disposalType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDisposalType(_response));
        });
    }

    protected processDisposalType(response: AxiosResponse): Promise<WasteDisposalRoute[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WasteDisposalRoute.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WasteDisposalRoute[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WasteDisposalRoute[]>(null as any);
    }

    /**
     * @param materialTypeId (optional) 
     * @return OK
     */
    getSkillAreaPerMaterialType(materialTypeId: string | undefined, cancelToken?: CancelToken): Promise<MaterialTypeScreen[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/getSkillAreaPerMaterialType?";
        if (materialTypeId === null)
            throw new globalThis.Error("The parameter 'materialTypeId' cannot be null.");
        else if (materialTypeId !== undefined)
            url_ += "materialTypeId=" + encodeURIComponent("" + materialTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSkillAreaPerMaterialType(_response));
        });
    }

    protected processGetSkillAreaPerMaterialType(response: AxiosResponse): Promise<MaterialTypeScreen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialTypeScreen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialTypeScreen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialTypeScreen[]>(null as any);
    }

    /**
     * @return OK
     */
    mgmGetAllSkillArea( cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmGetAllSkillArea";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmGetAllSkillArea(_response));
        });
    }

    protected processMgmGetAllSkillArea(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @return OK
     */
    mgmMaterialTypesAll( cancelToken?: CancelToken): Promise<MaterialType[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmMaterialTypesAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmMaterialTypesAll(_response));
        });
    }

    protected processMgmMaterialTypesAll(response: AxiosResponse): Promise<MaterialType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialType[]>(null as any);
    }

    /**
     * @return OK
     */
    mgmMaterialSubTypesAll( cancelToken?: CancelToken): Promise<MaterialSubType[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmMaterialSubTypesAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmMaterialSubTypesAll(_response));
        });
    }

    protected processMgmMaterialSubTypesAll(response: AxiosResponse): Promise<MaterialSubType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialSubType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialSubType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialSubType[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mgmMaterialSubTypesPerScreen(body: Screen[] | undefined, cancelToken?: CancelToken): Promise<MaterialSubType[]> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmMaterialSubTypesPerScreen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmMaterialSubTypesPerScreen(_response));
        });
    }

    protected processMgmMaterialSubTypesPerScreen(response: AxiosResponse): Promise<MaterialSubType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialSubType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaterialSubType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialSubType[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mgmSaveMaterialSubType(body: MaterialSubType | undefined, cancelToken?: CancelToken): Promise<MaterialSubType> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmSaveMaterialSubType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmSaveMaterialSubType(_response));
        });
    }

    protected processMgmSaveMaterialSubType(response: AxiosResponse): Promise<MaterialSubType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialSubType.fromJS(resultData200);
            return Promise.resolve<MaterialSubType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialSubType>(null as any);
    }

    /**
     * @param materialSubTypeId (optional) 
     * @return OK
     */
    mgmDeleteMaterialSubType(materialSubTypeId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/mgmRawMaterials/mgmDeleteMaterialSubType?";
        if (materialSubTypeId === null)
            throw new globalThis.Error("The parameter 'materialSubTypeId' cannot be null.");
        else if (materialSubTypeId !== undefined)
            url_ += "materialSubTypeId=" + encodeURIComponent("" + materialSubTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMgmDeleteMaterialSubType(_response));
        });
    }

    protected processMgmDeleteMaterialSubType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IProductFormatClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<ProductFormat[]>;
    /**
     * @return OK
     */
    getByScreenId(screenId: string,  cancelToken?: CancelToken): Promise<ProductFormat[]>;
    /**
     * @return OK
     */
    getTreeStructure( cancelToken?: CancelToken): Promise<any[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: ProductFormat | undefined,  cancelToken?: CancelToken): Promise<ProductFormat>;
    /**
     * @return OK
     */
    checkUsage(id: string,  cancelToken?: CancelToken): Promise<ProductFormatUsageCheckResponse>;
    /**
     * @return OK
     */
    delete(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class ProductFormatClient extends ApiClientBase implements IProductFormatClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<ProductFormat[]> {
        let url_ = this.baseUrl + "/api/ProductFormat/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<ProductFormat[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductFormat.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductFormat[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFormat[]>(null as any);
    }

    /**
     * @return OK
     */
    getByScreenId(screenId: string, cancelToken?: CancelToken): Promise<ProductFormat[]> {
        let url_ = this.baseUrl + "/api/ProductFormat/GetByScreenId/{screenId}";
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByScreenId(_response));
        });
    }

    protected processGetByScreenId(response: AxiosResponse): Promise<ProductFormat[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductFormat.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductFormat[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFormat[]>(null as any);
    }

    /**
     * @return OK
     */
    getTreeStructure( cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/ProductFormat/GetTreeStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTreeStructure(_response));
        });
    }

    protected processGetTreeStructure(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: ProductFormat | undefined, cancelToken?: CancelToken): Promise<ProductFormat> {
        let url_ = this.baseUrl + "/api/ProductFormat/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<ProductFormat> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductFormat.fromJS(resultData200);
            return Promise.resolve<ProductFormat>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFormat>(null as any);
    }

    /**
     * @return OK
     */
    checkUsage(id: string, cancelToken?: CancelToken): Promise<ProductFormatUsageCheckResponse> {
        let url_ = this.baseUrl + "/api/ProductFormat/CheckUsage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckUsage(_response));
        });
    }

    protected processCheckUsage(response: AxiosResponse): Promise<ProductFormatUsageCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductFormatUsageCheckResponse.fromJS(resultData200);
            return Promise.resolve<ProductFormatUsageCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFormatUsageCheckResponse>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ProductFormat/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProjectClient {
    /**
     * @return OK
     */
    isProjectMultiStepUtilities(assessmentId: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    setSingleUtilitiesChecked(body: string[] | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class ProjectClient extends ApiClientBase implements IProjectClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    isProjectMultiStepUtilities(assessmentId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/project/isProjectMultiStepUtilities/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsProjectMultiStepUtilities(_response));
        });
    }

    protected processIsProjectMultiStepUtilities(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setSingleUtilitiesChecked(body: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/project/SetSingleUtilitiesChecked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetSingleUtilitiesChecked(_response));
        });
    }

    protected processSetSingleUtilitiesChecked(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRawMaterialFormRefactorClient {
    /**
     * @param materialId (optional) 
     * @param stepId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getMaterialsByScreenId(materialId: string | undefined, stepId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class RawMaterialFormRefactorClient extends ApiClientBase implements IRawMaterialFormRefactorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param materialId (optional) 
     * @param stepId (optional) 
     * @param screenId (optional) 
     * @param generalInformationId (optional) 
     * @return OK
     */
    getMaterialsByScreenId(materialId: string | undefined, stepId: string | undefined, screenId: string | undefined, generalInformationId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/rawMaterialFormRefactor/getMaterialsByScreenId?";
        if (materialId === null)
            throw new globalThis.Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (screenId === null)
            throw new globalThis.Error("The parameter 'screenId' cannot be null.");
        else if (screenId !== undefined)
            url_ += "screenId=" + encodeURIComponent("" + screenId) + "&";
        if (generalInformationId === null)
            throw new globalThis.Error("The parameter 'generalInformationId' cannot be null.");
        else if (generalInformationId !== undefined)
            url_ += "generalInformationId=" + encodeURIComponent("" + generalInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMaterialsByScreenId(_response));
        });
    }

    protected processGetMaterialsByScreenId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRelatableUnitClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<RelatableUnit[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: RelatableUnit | undefined,  cancelToken?: CancelToken): Promise<RelatableUnit>;
    /**
     * @return OK
     */
    delete(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class RelatableUnitClient extends ApiClientBase implements IRelatableUnitClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<RelatableUnit[]> {
        let url_ = this.baseUrl + "/api/RelatableUnit/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<RelatableUnit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RelatableUnit.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RelatableUnit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatableUnit[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: RelatableUnit | undefined, cancelToken?: CancelToken): Promise<RelatableUnit> {
        let url_ = this.baseUrl + "/api/RelatableUnit/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<RelatableUnit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RelatableUnit.fromJS(resultData200);
            return Promise.resolve<RelatableUnit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatableUnit>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/RelatableUnit/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAdminClient {
    /**
     * @return OK
     */
    relatableUnitsGet( cancelToken?: CancelToken): Promise<RelatableUnitAdminReadModel[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    relatableUnitsPost(body: RelatableUnitSaveRequest | undefined,  cancelToken?: CancelToken): Promise<RelatableUnitAdminReadModel>;
    /**
     * @param body (optional) 
     * @return OK
     */
    relatableUnitsPut(id: string, body: RelatableUnitSaveRequest | undefined,  cancelToken?: CancelToken): Promise<RelatableUnitAdminReadModel>;
    /**
     * @return OK
     */
    relatableUnitsDelete(id: string,  cancelToken?: CancelToken): Promise<boolean>;
}

export class AdminClient extends ApiClientBase implements IAdminClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    relatableUnitsGet( cancelToken?: CancelToken): Promise<RelatableUnitAdminReadModel[]> {
        let url_ = this.baseUrl + "/api/admin/relatableUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRelatableUnitsGet(_response));
        });
    }

    protected processRelatableUnitsGet(response: AxiosResponse): Promise<RelatableUnitAdminReadModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RelatableUnitAdminReadModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RelatableUnitAdminReadModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatableUnitAdminReadModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    relatableUnitsPost(body: RelatableUnitSaveRequest | undefined, cancelToken?: CancelToken): Promise<RelatableUnitAdminReadModel> {
        let url_ = this.baseUrl + "/api/admin/relatableUnits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRelatableUnitsPost(_response));
        });
    }

    protected processRelatableUnitsPost(response: AxiosResponse): Promise<RelatableUnitAdminReadModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RelatableUnitAdminReadModel.fromJS(resultData200);
            return Promise.resolve<RelatableUnitAdminReadModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatableUnitAdminReadModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    relatableUnitsPut(id: string, body: RelatableUnitSaveRequest | undefined, cancelToken?: CancelToken): Promise<RelatableUnitAdminReadModel> {
        let url_ = this.baseUrl + "/api/admin/relatableUnits/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRelatableUnitsPut(_response));
        });
    }

    protected processRelatableUnitsPut(response: AxiosResponse): Promise<RelatableUnitAdminReadModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RelatableUnitAdminReadModel.fromJS(resultData200);
            return Promise.resolve<RelatableUnitAdminReadModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatableUnitAdminReadModel>(null as any);
    }

    /**
     * @return OK
     */
    relatableUnitsDelete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/admin/relatableUnits/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRelatableUnitsDelete(_response));
        });
    }

    protected processRelatableUnitsDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IReportExportClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    powerpoint(body: ReportExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    powerpointViva(body: PptVivaExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    word(body: ReportExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    pdf(body: ReportExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    powerpointV2(body: ReportExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    preview(body: ReportExportRequest | undefined,  cancelToken?: CancelToken): Promise<ReportPreviewDto>;
}

export class ReportExportClient extends ApiClientBase implements IReportExportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    powerpoint(body: ReportExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reportExport/powerpoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPowerpoint(_response));
        });
    }

    protected processPowerpoint(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    powerpointViva(body: PptVivaExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reportExport/powerpointViva";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPowerpointViva(_response));
        });
    }

    protected processPowerpointViva(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    word(body: ReportExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reportExport/word";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWord(_response));
        });
    }

    protected processWord(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pdf(body: ReportExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reportExport/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPdf(_response));
        });
    }

    protected processPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    powerpointV2(body: ReportExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reportExport/powerpointV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPowerpointV2(_response));
        });
    }

    protected processPowerpointV2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    preview(body: ReportExportRequest | undefined, cancelToken?: CancelToken): Promise<ReportPreviewDto> {
        let url_ = this.baseUrl + "/api/reportExport/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPreview(_response));
        });
    }

    protected processPreview(response: AxiosResponse): Promise<ReportPreviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportPreviewDto.fromJS(resultData200);
            return Promise.resolve<ReportPreviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPreviewDto>(null as any);
    }
}

export interface ISiteLocationsClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<SiteLocation[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: SiteLocation | undefined,  cancelToken?: CancelToken): Promise<SiteLocation>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: SiteLocation | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class SiteLocationsClient extends ApiClientBase implements ISiteLocationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<SiteLocation[]> {
        let url_ = this.baseUrl + "/api/siteLocations/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<SiteLocation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteLocation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SiteLocation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteLocation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: SiteLocation | undefined, cancelToken?: CancelToken): Promise<SiteLocation> {
        let url_ = this.baseUrl + "/api/siteLocations/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<SiteLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteLocation.fromJS(resultData200);
            return Promise.resolve<SiteLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteLocation>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: SiteLocation | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/siteLocations/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IStatisticsClient {
    /**
     * @return OK
     */
    general( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    users( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    projects( cancelToken?: CancelToken): Promise<void>;
    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    activity(from: Date | undefined, to: Date | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class StatisticsClient extends ApiClientBase implements IStatisticsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    general( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/statistics/general";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeneral(_response));
        });
    }

    protected processGeneral(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    users( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/statistics/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUsers(_response));
        });
    }

    protected processUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    projects( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/statistics/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProjects(_response));
        });
    }

    protected processProjects(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    activity(from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/statistics/activity?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processActivity(_response));
        });
    }

    protected processActivity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IExportClient {
    /**
     * @return OK
     */
    general( cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return OK
     */
    users( cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return OK
     */
    projects( cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    activity(body: ActivityExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class ExportClient extends ApiClientBase implements IExportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    general( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/statistics/export/general";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeneral(_response));
        });
    }

    protected processGeneral(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    users( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/statistics/export/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUsers(_response));
        });
    }

    protected processUsers(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    projects( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/statistics/export/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProjects(_response));
        });
    }

    protected processProjects(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activity(body: ActivityExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/statistics/export/activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processActivity(_response));
        });
    }

    protected processActivity(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITableManagementClient {
    /**
     * @return OK
     */
    unitOperationDistinctScreens( cancelToken?: CancelToken): Promise<Screen[]>;
    /**
     * @return OK
     */
    unitOperationMetadata(unitOperationId: string,  cancelToken?: CancelToken): Promise<UnitOperationMetadataDto>;
    /**
     * @return OK
     */
    unitOperationUsage(unitOperationId: string,  cancelToken?: CancelToken): Promise<UnitOperationAssessmentUsage[]>;
    /**
     * @return OK
     */
    unitOperationUsageExcel(unitOperationId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    unitOperation(unitOperationId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param showDeleted (optional) 
     * @return OK
     */
    unitOperationsByScreen(screenId: string, showDeleted: boolean | undefined,  cancelToken?: CancelToken): Promise<UnitOperation[]>;
}

export class TableManagementClient extends ApiClientBase implements ITableManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    unitOperationDistinctScreens( cancelToken?: CancelToken): Promise<Screen[]> {
        let url_ = this.baseUrl + "/api/tableManagement/UnitOperationDistinctScreens";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnitOperationDistinctScreens(_response));
        });
    }

    protected processUnitOperationDistinctScreens(response: AxiosResponse): Promise<Screen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Screen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Screen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Screen[]>(null as any);
    }

    /**
     * @return OK
     */
    unitOperationMetadata(unitOperationId: string, cancelToken?: CancelToken): Promise<UnitOperationMetadataDto> {
        let url_ = this.baseUrl + "/api/tableManagement/UnitOperationMetadata/{unitOperationId}";
        if (unitOperationId === undefined || unitOperationId === null)
            throw new globalThis.Error("The parameter 'unitOperationId' must be defined.");
        url_ = url_.replace("{unitOperationId}", encodeURIComponent("" + unitOperationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnitOperationMetadata(_response));
        });
    }

    protected processUnitOperationMetadata(response: AxiosResponse): Promise<UnitOperationMetadataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnitOperationMetadataDto.fromJS(resultData200);
            return Promise.resolve<UnitOperationMetadataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitOperationMetadataDto>(null as any);
    }

    /**
     * @return OK
     */
    unitOperationUsage(unitOperationId: string, cancelToken?: CancelToken): Promise<UnitOperationAssessmentUsage[]> {
        let url_ = this.baseUrl + "/api/tableManagement/UnitOperationUsage/{unitOperationId}";
        if (unitOperationId === undefined || unitOperationId === null)
            throw new globalThis.Error("The parameter 'unitOperationId' must be defined.");
        url_ = url_.replace("{unitOperationId}", encodeURIComponent("" + unitOperationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnitOperationUsage(_response));
        });
    }

    protected processUnitOperationUsage(response: AxiosResponse): Promise<UnitOperationAssessmentUsage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitOperationAssessmentUsage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnitOperationAssessmentUsage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitOperationAssessmentUsage[]>(null as any);
    }

    /**
     * @return OK
     */
    unitOperationUsageExcel(unitOperationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/tableManagement/UnitOperationUsageExcel/{unitOperationId}";
        if (unitOperationId === undefined || unitOperationId === null)
            throw new globalThis.Error("The parameter 'unitOperationId' must be defined.");
        url_ = url_.replace("{unitOperationId}", encodeURIComponent("" + unitOperationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnitOperationUsageExcel(_response));
        });
    }

    protected processUnitOperationUsageExcel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    unitOperation(unitOperationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/tableManagement/UnitOperation/{unitOperationId}";
        if (unitOperationId === undefined || unitOperationId === null)
            throw new globalThis.Error("The parameter 'unitOperationId' must be defined.");
        url_ = url_.replace("{unitOperationId}", encodeURIComponent("" + unitOperationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnitOperation(_response));
        });
    }

    protected processUnitOperation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param showDeleted (optional) 
     * @return OK
     */
    unitOperationsByScreen(screenId: string, showDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<UnitOperation[]> {
        let url_ = this.baseUrl + "/api/tableManagement/UnitOperationsByScreen/{screenId}?";
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        if (showDeleted === null)
            throw new globalThis.Error("The parameter 'showDeleted' cannot be null.");
        else if (showDeleted !== undefined)
            url_ += "showDeleted=" + encodeURIComponent("" + showDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnitOperationsByScreen(_response));
        });
    }

    protected processUnitOperationsByScreen(response: AxiosResponse): Promise<UnitOperation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitOperation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnitOperation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitOperation[]>(null as any);
    }
}

export interface IThemeMgmClient {
    /**
     * @return OK
     */
    getAllThemes( cancelToken?: CancelToken): Promise<TemplateUI[]>;
    /**
     * @return OK
     */
    getDefaultTheme( cancelToken?: CancelToken): Promise<ThemeState>;
    /**
     * @param themeId (optional) 
     * @return OK
     */
    getCompleteThemeSetting(themeId: string | undefined,  cancelToken?: CancelToken): Promise<ThemeState>;
    /**
     * @param themeId (optional) 
     * @return OK
     */
    getOneThemeSettings(themeId: string | undefined,  cancelToken?: CancelToken): Promise<ThemeTemplate>;
    /**
     * @param imageType (optional) 
     * @param themeId (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadImage(imageType: string | undefined, themeId: string | undefined, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getImage(themeId: string, imageType: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompleteThemeSettings(body: ThemeState | undefined,  cancelToken?: CancelToken): Promise<ThemeState>;
    /**
     * @param themeId (optional) 
     * @return OK
     */
    deleteTheme(themeId: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    exportTheme(themeId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param themeId (optional) 
     * @param themeName (optional) 
     * @return OK
     */
    updateThemeName(themeId: string | undefined, themeName: string | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param file (optional) 
     * @return OK
     */
    importTheme(themeId: string, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class ThemeMgmClient extends ApiClientBase implements IThemeMgmClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAllThemes( cancelToken?: CancelToken): Promise<TemplateUI[]> {
        let url_ = this.baseUrl + "/api/themeMgm/getAllThemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllThemes(_response));
        });
    }

    protected processGetAllThemes(response: AxiosResponse): Promise<TemplateUI[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateUI.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TemplateUI[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateUI[]>(null as any);
    }

    /**
     * @return OK
     */
    getDefaultTheme( cancelToken?: CancelToken): Promise<ThemeState> {
        let url_ = this.baseUrl + "/api/themeMgm/getDefaultTheme";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDefaultTheme(_response));
        });
    }

    protected processGetDefaultTheme(response: AxiosResponse): Promise<ThemeState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThemeState.fromJS(resultData200);
            return Promise.resolve<ThemeState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThemeState>(null as any);
    }

    /**
     * @param themeId (optional) 
     * @return OK
     */
    getCompleteThemeSetting(themeId: string | undefined, cancelToken?: CancelToken): Promise<ThemeState> {
        let url_ = this.baseUrl + "/api/themeMgm/getCompleteThemeSetting?";
        if (themeId === null)
            throw new globalThis.Error("The parameter 'themeId' cannot be null.");
        else if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCompleteThemeSetting(_response));
        });
    }

    protected processGetCompleteThemeSetting(response: AxiosResponse): Promise<ThemeState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThemeState.fromJS(resultData200);
            return Promise.resolve<ThemeState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThemeState>(null as any);
    }

    /**
     * @param themeId (optional) 
     * @return OK
     */
    getOneThemeSettings(themeId: string | undefined, cancelToken?: CancelToken): Promise<ThemeTemplate> {
        let url_ = this.baseUrl + "/api/themeMgm/getOneThemeSettings?";
        if (themeId === null)
            throw new globalThis.Error("The parameter 'themeId' cannot be null.");
        else if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOneThemeSettings(_response));
        });
    }

    protected processGetOneThemeSettings(response: AxiosResponse): Promise<ThemeTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThemeTemplate.fromJS(resultData200);
            return Promise.resolve<ThemeTemplate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThemeTemplate>(null as any);
    }

    /**
     * @param imageType (optional) 
     * @param themeId (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadImage(imageType: string | undefined, themeId: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/themeMgm/uploadImage?";
        if (imageType === null)
            throw new globalThis.Error("The parameter 'imageType' cannot be null.");
        else if (imageType !== undefined)
            url_ += "imageType=" + encodeURIComponent("" + imageType) + "&";
        if (themeId === null)
            throw new globalThis.Error("The parameter 'themeId' cannot be null.");
        else if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadImage(_response));
        });
    }

    protected processUploadImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getImage(themeId: string, imageType: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/themeMgm/getImage/{themeId}/{imageType}";
        if (themeId === undefined || themeId === null)
            throw new globalThis.Error("The parameter 'themeId' must be defined.");
        url_ = url_.replace("{themeId}", encodeURIComponent("" + themeId));
        if (imageType === undefined || imageType === null)
            throw new globalThis.Error("The parameter 'imageType' must be defined.");
        url_ = url_.replace("{imageType}", encodeURIComponent("" + imageType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompleteThemeSettings(body: ThemeState | undefined, cancelToken?: CancelToken): Promise<ThemeState> {
        let url_ = this.baseUrl + "/api/themeMgm/saveCompleteThemeSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCompleteThemeSettings(_response));
        });
    }

    protected processSaveCompleteThemeSettings(response: AxiosResponse): Promise<ThemeState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThemeState.fromJS(resultData200);
            return Promise.resolve<ThemeState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThemeState>(null as any);
    }

    /**
     * @param themeId (optional) 
     * @return OK
     */
    deleteTheme(themeId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/themeMgm/deleteTheme?";
        if (themeId === null)
            throw new globalThis.Error("The parameter 'themeId' cannot be null.");
        else if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTheme(_response));
        });
    }

    protected processDeleteTheme(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    exportTheme(themeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/themeMgm/exportTheme/{themeId}";
        if (themeId === undefined || themeId === null)
            throw new globalThis.Error("The parameter 'themeId' must be defined.");
        url_ = url_.replace("{themeId}", encodeURIComponent("" + themeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportTheme(_response));
        });
    }

    protected processExportTheme(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param themeId (optional) 
     * @param themeName (optional) 
     * @return OK
     */
    updateThemeName(themeId: string | undefined, themeName: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/themeMgm/updateThemeName?";
        if (themeId === null)
            throw new globalThis.Error("The parameter 'themeId' cannot be null.");
        else if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&";
        if (themeName === null)
            throw new globalThis.Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateThemeName(_response));
        });
    }

    protected processUpdateThemeName(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    importTheme(themeId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/themeMgm/importTheme/{themeId}";
        if (themeId === undefined || themeId === null)
            throw new globalThis.Error("The parameter 'themeId' must be defined.");
        url_ = url_.replace("{themeId}", encodeURIComponent("" + themeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportTheme(_response));
        });
    }

    protected processImportTheme(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITransportAdministrationClient {
    /**
     * @return OK
     */
    getTransportList( cancelToken?: CancelToken): Promise<TransportListItem[]>;
    /**
     * @return OK
     */
    getTransportModeList( cancelToken?: CancelToken): Promise<TransportMode[]>;
    /**
     * @return OK
     */
    getUnitList( cancelToken?: CancelToken): Promise<Unit[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createTransport(body: Transport | undefined,  cancelToken?: CancelToken): Promise<Transport>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateTransport(body: Transport | undefined,  cancelToken?: CancelToken): Promise<Transport>;
    /**
     * @return OK
     */
    deleteTransport(id: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    transportTemplate(emptyTemplate: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importTransportData(file: FileParameter | undefined, uploadSessionId: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadTransportImportResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class TransportAdministrationClient extends ApiClientBase implements ITransportAdministrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getTransportList( cancelToken?: CancelToken): Promise<TransportListItem[]> {
        let url_ = this.baseUrl + "/api/transportAdministration/GetTransportList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTransportList(_response));
        });
    }

    protected processGetTransportList(response: AxiosResponse): Promise<TransportListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TransportListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransportListItem[]>(null as any);
    }

    /**
     * @return OK
     */
    getTransportModeList( cancelToken?: CancelToken): Promise<TransportMode[]> {
        let url_ = this.baseUrl + "/api/transportAdministration/GetTransportModeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTransportModeList(_response));
        });
    }

    protected processGetTransportModeList(response: AxiosResponse): Promise<TransportMode[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportMode.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TransportMode[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransportMode[]>(null as any);
    }

    /**
     * @return OK
     */
    getUnitList( cancelToken?: CancelToken): Promise<Unit[]> {
        let url_ = this.baseUrl + "/api/transportAdministration/GetUnitList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitList(_response));
        });
    }

    protected processGetUnitList(response: AxiosResponse): Promise<Unit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Unit.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Unit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTransport(body: Transport | undefined, cancelToken?: CancelToken): Promise<Transport> {
        let url_ = this.baseUrl + "/api/transportAdministration/CreateTransport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTransport(_response));
        });
    }

    protected processCreateTransport(response: AxiosResponse): Promise<Transport> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Transport.fromJS(resultData200);
            return Promise.resolve<Transport>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Transport>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTransport(body: Transport | undefined, cancelToken?: CancelToken): Promise<Transport> {
        let url_ = this.baseUrl + "/api/transportAdministration/UpdateTransport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTransport(_response));
        });
    }

    protected processUpdateTransport(response: AxiosResponse): Promise<Transport> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Transport.fromJS(resultData200);
            return Promise.resolve<Transport>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Transport>(null as any);
    }

    /**
     * @return OK
     */
    deleteTransport(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/transportAdministration/DeleteTransport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTransport(_response));
        });
    }

    protected processDeleteTransport(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    transportTemplate(emptyTemplate: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/transportAdministration/TransportTemplate?";
        if (emptyTemplate === null)
            throw new globalThis.Error("The parameter 'emptyTemplate' cannot be null.");
        else if (emptyTemplate !== undefined)
            url_ += "emptyTemplate=" + encodeURIComponent("" + emptyTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTransportTemplate(_response));
        });
    }

    protected processTransportTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importTransportData(file: FileParameter | undefined, uploadSessionId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/transportAdministration/ImportTransportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (uploadSessionId === null || uploadSessionId === undefined)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else
            content_.append("uploadSessionId", uploadSessionId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportTransportData(_response));
        });
    }

    protected processImportTransportData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadTransportImportResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/transportAdministration/DownloadTransportImportResults?";
        if (uploadSessionId === null)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else if (uploadSessionId !== undefined)
            url_ += "uploadSessionId=" + encodeURIComponent("" + uploadSessionId) + "&";
        if (errorsOnly === null)
            throw new globalThis.Error("The parameter 'errorsOnly' cannot be null.");
        else if (errorsOnly !== undefined)
            url_ += "errorsOnly=" + encodeURIComponent("" + errorsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadTransportImportResults(_response));
        });
    }

    protected processDownloadTransportImportResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITransportEmissionFactorClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<TransportEmissionFactor[]>;
    /**
     * @return OK
     */
    byTransport(transportId: string,  cancelToken?: CancelToken): Promise<TransportEmissionFactor[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: TransportEmissionFactor | undefined,  cancelToken?: CancelToken): Promise<TransportEmissionFactor>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: TransportEmissionFactor | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class TransportEmissionFactorClient extends ApiClientBase implements ITransportEmissionFactorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<TransportEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/transportEmissionFactor/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<TransportEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TransportEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransportEmissionFactor[]>(null as any);
    }

    /**
     * @return OK
     */
    byTransport(transportId: string, cancelToken?: CancelToken): Promise<TransportEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/transportEmissionFactor/ByTransport/{transportId}";
        if (transportId === undefined || transportId === null)
            throw new globalThis.Error("The parameter 'transportId' must be defined.");
        url_ = url_.replace("{transportId}", encodeURIComponent("" + transportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processByTransport(_response));
        });
    }

    protected processByTransport(response: AxiosResponse): Promise<TransportEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TransportEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransportEmissionFactor[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: TransportEmissionFactor | undefined, cancelToken?: CancelToken): Promise<TransportEmissionFactor> {
        let url_ = this.baseUrl + "/api/transportEmissionFactor/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<TransportEmissionFactor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransportEmissionFactor.fromJS(resultData200);
            return Promise.resolve<TransportEmissionFactor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransportEmissionFactor>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: TransportEmissionFactor | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/transportEmissionFactor/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IUnitOfMeasureClient {
    /**
     * @return OK
     */
    getUnitTypes( cancelToken?: CancelToken): Promise<UnitType[]>;
    /**
     * @return OK
     */
    getUnitsByType(unitTypeId: string,  cancelToken?: CancelToken): Promise<Unit[]>;
    /**
     * @return OK
     */
    getUnitsByTypeName(unitTypeName: string,  cancelToken?: CancelToken): Promise<Unit[]>;
}

export class UnitOfMeasureClient extends ApiClientBase implements IUnitOfMeasureClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getUnitTypes( cancelToken?: CancelToken): Promise<UnitType[]> {
        let url_ = this.baseUrl + "/api/unitOfMeasure/GetUnitTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitTypes(_response));
        });
    }

    protected processGetUnitTypes(response: AxiosResponse): Promise<UnitType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnitType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitType[]>(null as any);
    }

    /**
     * @return OK
     */
    getUnitsByType(unitTypeId: string, cancelToken?: CancelToken): Promise<Unit[]> {
        let url_ = this.baseUrl + "/api/unitOfMeasure/GetUnitsByType/{unitTypeId}";
        if (unitTypeId === undefined || unitTypeId === null)
            throw new globalThis.Error("The parameter 'unitTypeId' must be defined.");
        url_ = url_.replace("{unitTypeId}", encodeURIComponent("" + unitTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitsByType(_response));
        });
    }

    protected processGetUnitsByType(response: AxiosResponse): Promise<Unit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Unit.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Unit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit[]>(null as any);
    }

    /**
     * @return OK
     */
    getUnitsByTypeName(unitTypeName: string, cancelToken?: CancelToken): Promise<Unit[]> {
        let url_ = this.baseUrl + "/api/unitOfMeasure/GetUnitsByTypeName/{unitTypeName}";
        if (unitTypeName === undefined || unitTypeName === null)
            throw new globalThis.Error("The parameter 'unitTypeName' must be defined.");
        url_ = url_.replace("{unitTypeName}", encodeURIComponent("" + unitTypeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitsByTypeName(_response));
        });
    }

    protected processGetUnitsByTypeName(response: AxiosResponse): Promise<Unit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Unit.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Unit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit[]>(null as any);
    }
}

export interface IUserClient {
    /**
     * @return OK
     */
    identityProvider( cancelToken?: CancelToken): Promise<void>;
    /**
     * @param showOnlyInactiveUsers (optional) 
     * @param showOnlyIdentityProviderUsers (optional) 
     * @return OK
     */
    export(showOnlyInactiveUsers: boolean | undefined, showOnlyIdentityProviderUsers: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createWithIdentityProvider(body: AllSingleUserData | undefined,  cancelToken?: CancelToken): Promise<IdentityOperationResponse>;
    /**
     * @return OK
     */
    linkToIdentityProvider(personId: string,  cancelToken?: CancelToken): Promise<IdentityOperationResponse>;
    /**
     * @return OK
     */
    resendInvitation(id: string,  cancelToken?: CancelToken): Promise<IdentityOperationResponse>;
    /**
     * @return OK
     */
    identityStatus(id: string,  cancelToken?: CancelToken): Promise<OktaUserStatusResponse>;
    /**
     * @param email (optional) 
     * @return OK
     */
    testOktaLookup(email: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    syncWithIdentityProvider( cancelToken?: CancelToken): Promise<OktaSyncResponse>;
    /**
     * @return OK
     */
    importTemplate( cancelToken?: CancelToken): Promise<void>;
    /**
     * @param file (optional) 
     * @return OK
     */
    import(file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<UserImportResponse>;
    /**
     * @return OK
     */
    providerHealthCheck( cancelToken?: CancelToken): Promise<ProviderHealthCheckResponse>;
}

export class UserClient extends ApiClientBase implements IUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    identityProvider( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user/identityProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIdentityProvider(_response));
        });
    }

    protected processIdentityProvider(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param showOnlyInactiveUsers (optional) 
     * @param showOnlyIdentityProviderUsers (optional) 
     * @return OK
     */
    export(showOnlyInactiveUsers: boolean | undefined, showOnlyIdentityProviderUsers: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user/export?";
        if (showOnlyInactiveUsers === null)
            throw new globalThis.Error("The parameter 'showOnlyInactiveUsers' cannot be null.");
        else if (showOnlyInactiveUsers !== undefined)
            url_ += "showOnlyInactiveUsers=" + encodeURIComponent("" + showOnlyInactiveUsers) + "&";
        if (showOnlyIdentityProviderUsers === null)
            throw new globalThis.Error("The parameter 'showOnlyIdentityProviderUsers' cannot be null.");
        else if (showOnlyIdentityProviderUsers !== undefined)
            url_ += "showOnlyIdentityProviderUsers=" + encodeURIComponent("" + showOnlyIdentityProviderUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExport(_response));
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createWithIdentityProvider(body: AllSingleUserData | undefined, cancelToken?: CancelToken): Promise<IdentityOperationResponse> {
        let url_ = this.baseUrl + "/api/user/createWithIdentityProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateWithIdentityProvider(_response));
        });
    }

    protected processCreateWithIdentityProvider(response: AxiosResponse): Promise<IdentityOperationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityOperationResponse.fromJS(resultData200);
            return Promise.resolve<IdentityOperationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityOperationResponse>(null as any);
    }

    /**
     * @return OK
     */
    linkToIdentityProvider(personId: string, cancelToken?: CancelToken): Promise<IdentityOperationResponse> {
        let url_ = this.baseUrl + "/api/user/{personId}/linkToIdentityProvider";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLinkToIdentityProvider(_response));
        });
    }

    protected processLinkToIdentityProvider(response: AxiosResponse): Promise<IdentityOperationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityOperationResponse.fromJS(resultData200);
            return Promise.resolve<IdentityOperationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityOperationResponse>(null as any);
    }

    /**
     * @return OK
     */
    resendInvitation(id: string, cancelToken?: CancelToken): Promise<IdentityOperationResponse> {
        let url_ = this.baseUrl + "/api/user/{id}/resendInvitation";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResendInvitation(_response));
        });
    }

    protected processResendInvitation(response: AxiosResponse): Promise<IdentityOperationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityOperationResponse.fromJS(resultData200);
            return Promise.resolve<IdentityOperationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityOperationResponse>(null as any);
    }

    /**
     * @return OK
     */
    identityStatus(id: string, cancelToken?: CancelToken): Promise<OktaUserStatusResponse> {
        let url_ = this.baseUrl + "/api/user/identityStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIdentityStatus(_response));
        });
    }

    protected processIdentityStatus(response: AxiosResponse): Promise<OktaUserStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OktaUserStatusResponse.fromJS(resultData200);
            return Promise.resolve<OktaUserStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OktaUserStatusResponse>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    testOktaLookup(email: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user/testOktaLookup?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTestOktaLookup(_response));
        });
    }

    protected processTestOktaLookup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    syncWithIdentityProvider( cancelToken?: CancelToken): Promise<OktaSyncResponse> {
        let url_ = this.baseUrl + "/api/user/syncWithIdentityProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSyncWithIdentityProvider(_response));
        });
    }

    protected processSyncWithIdentityProvider(response: AxiosResponse): Promise<OktaSyncResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OktaSyncResponse.fromJS(resultData200);
            return Promise.resolve<OktaSyncResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OktaSyncResponse>(null as any);
    }

    /**
     * @return OK
     */
    importTemplate( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user/importTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportTemplate(_response));
        });
    }

    protected processImportTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    import(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UserImportResponse> {
        let url_ = this.baseUrl + "/api/user/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImport(_response));
        });
    }

    protected processImport(response: AxiosResponse): Promise<UserImportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserImportResponse.fromJS(resultData200);
            return Promise.resolve<UserImportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserImportResponse>(null as any);
    }

    /**
     * @return OK
     */
    providerHealthCheck( cancelToken?: CancelToken): Promise<ProviderHealthCheckResponse> {
        let url_ = this.baseUrl + "/api/user/ProviderHealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProviderHealthCheck(_response));
        });
    }

    protected processProviderHealthCheck(response: AxiosResponse): Promise<ProviderHealthCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProviderHealthCheckResponse.fromJS(resultData200);
            return Promise.resolve<ProviderHealthCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderHealthCheckResponse>(null as any);
    }
}

export interface IImportClient {
    /**
     * @param file (optional) 
     * @return OK
     */
    preview(file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<UserImportPreviewResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    execute(body: UserImportExecuteRequest | undefined,  cancelToken?: CancelToken): Promise<UserImportExecuteResponse>;
}

export class ImportClient extends ApiClientBase implements IImportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param file (optional) 
     * @return OK
     */
    preview(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UserImportPreviewResponse> {
        let url_ = this.baseUrl + "/api/user/import/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPreview(_response));
        });
    }

    protected processPreview(response: AxiosResponse): Promise<UserImportPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserImportPreviewResponse.fromJS(resultData200);
            return Promise.resolve<UserImportPreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserImportPreviewResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    execute(body: UserImportExecuteRequest | undefined, cancelToken?: CancelToken): Promise<UserImportExecuteResponse> {
        let url_ = this.baseUrl + "/api/user/import/execute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExecute(_response));
        });
    }

    protected processExecute(response: AxiosResponse): Promise<UserImportExecuteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserImportExecuteResponse.fromJS(resultData200);
            return Promise.resolve<UserImportExecuteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserImportExecuteResponse>(null as any);
    }
}

export interface IUserSyncClient {
    /**
     * @return OK
     */
    currentProvider( cancelToken?: CancelToken): Promise<CurrentProviderResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    validateCredentials(body: ExternalProviderCredentials | undefined,  cancelToken?: CancelToken): Promise<ValidateCredentialsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    fetchUsers(body: ExternalProviderCredentials | undefined,  cancelToken?: CancelToken): Promise<ExternalProviderUsersResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    fetchLocalUsers(body: ExternalProviderCredentials | undefined,  cancelToken?: CancelToken): Promise<ExternalProviderUsersResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    execute(body: UserSyncExecuteRequest | undefined,  cancelToken?: CancelToken): Promise<UserSyncExecuteResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    exportResults(body: UserSyncExecuteResponse | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class UserSyncClient extends ApiClientBase implements IUserSyncClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    currentProvider( cancelToken?: CancelToken): Promise<CurrentProviderResponse> {
        let url_ = this.baseUrl + "/api/UserSync/currentProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCurrentProvider(_response));
        });
    }

    protected processCurrentProvider(response: AxiosResponse): Promise<CurrentProviderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentProviderResponse.fromJS(resultData200);
            return Promise.resolve<CurrentProviderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentProviderResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateCredentials(body: ExternalProviderCredentials | undefined, cancelToken?: CancelToken): Promise<ValidateCredentialsResponse> {
        let url_ = this.baseUrl + "/api/UserSync/validateCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidateCredentials(_response));
        });
    }

    protected processValidateCredentials(response: AxiosResponse): Promise<ValidateCredentialsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateCredentialsResponse.fromJS(resultData200);
            return Promise.resolve<ValidateCredentialsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateCredentialsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fetchUsers(body: ExternalProviderCredentials | undefined, cancelToken?: CancelToken): Promise<ExternalProviderUsersResponse> {
        let url_ = this.baseUrl + "/api/UserSync/fetchUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFetchUsers(_response));
        });
    }

    protected processFetchUsers(response: AxiosResponse): Promise<ExternalProviderUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalProviderUsersResponse.fromJS(resultData200);
            return Promise.resolve<ExternalProviderUsersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalProviderUsersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fetchLocalUsers(body: ExternalProviderCredentials | undefined, cancelToken?: CancelToken): Promise<ExternalProviderUsersResponse> {
        let url_ = this.baseUrl + "/api/UserSync/fetchLocalUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFetchLocalUsers(_response));
        });
    }

    protected processFetchLocalUsers(response: AxiosResponse): Promise<ExternalProviderUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalProviderUsersResponse.fromJS(resultData200);
            return Promise.resolve<ExternalProviderUsersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalProviderUsersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    execute(body: UserSyncExecuteRequest | undefined, cancelToken?: CancelToken): Promise<UserSyncExecuteResponse> {
        let url_ = this.baseUrl + "/api/UserSync/execute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExecute(_response));
        });
    }

    protected processExecute(response: AxiosResponse): Promise<UserSyncExecuteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSyncExecuteResponse.fromJS(resultData200);
            return Promise.resolve<UserSyncExecuteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSyncExecuteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportResults(body: UserSyncExecuteResponse | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserSync/exportResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportResults(_response));
        });
    }

    protected processExportResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUserThemeSelectionClient {
    /**
     * @return OK
     */
    getCurrentUserTheme( cancelToken?: CancelToken): Promise<ThemeState>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveUserThemeSelection(body: string | undefined,  cancelToken?: CancelToken): Promise<UserThemeSelection>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserThemeSelection(body: string | undefined,  cancelToken?: CancelToken): Promise<UserThemeSelection>;
    /**
     * @return OK
     */
    getAvailableThemes( cancelToken?: CancelToken): Promise<TemplateUI[]>;
    /**
     * @return OK
     */
    removeUserThemeSelection( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getUserThemeSelectionRecord( cancelToken?: CancelToken): Promise<UserThemeSelection>;
}

export class UserThemeSelectionClient extends ApiClientBase implements IUserThemeSelectionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getCurrentUserTheme( cancelToken?: CancelToken): Promise<ThemeState> {
        let url_ = this.baseUrl + "/api/userThemeSelection/getCurrentUserTheme";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentUserTheme(_response));
        });
    }

    protected processGetCurrentUserTheme(response: AxiosResponse): Promise<ThemeState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThemeState.fromJS(resultData200);
            return Promise.resolve<ThemeState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThemeState>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveUserThemeSelection(body: string | undefined, cancelToken?: CancelToken): Promise<UserThemeSelection> {
        let url_ = this.baseUrl + "/api/userThemeSelection/saveUserThemeSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUserThemeSelection(_response));
        });
    }

    protected processSaveUserThemeSelection(response: AxiosResponse): Promise<UserThemeSelection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserThemeSelection.fromJS(resultData200);
            return Promise.resolve<UserThemeSelection>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserThemeSelection>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserThemeSelection(body: string | undefined, cancelToken?: CancelToken): Promise<UserThemeSelection> {
        let url_ = this.baseUrl + "/api/userThemeSelection/updateUserThemeSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUserThemeSelection(_response));
        });
    }

    protected processUpdateUserThemeSelection(response: AxiosResponse): Promise<UserThemeSelection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserThemeSelection.fromJS(resultData200);
            return Promise.resolve<UserThemeSelection>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserThemeSelection>(null as any);
    }

    /**
     * @return OK
     */
    getAvailableThemes( cancelToken?: CancelToken): Promise<TemplateUI[]> {
        let url_ = this.baseUrl + "/api/userThemeSelection/getAvailableThemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailableThemes(_response));
        });
    }

    protected processGetAvailableThemes(response: AxiosResponse): Promise<TemplateUI[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateUI.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TemplateUI[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateUI[]>(null as any);
    }

    /**
     * @return OK
     */
    removeUserThemeSelection( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/userThemeSelection/removeUserThemeSelection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveUserThemeSelection(_response));
        });
    }

    protected processRemoveUserThemeSelection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getUserThemeSelectionRecord( cancelToken?: CancelToken): Promise<UserThemeSelection> {
        let url_ = this.baseUrl + "/api/userThemeSelection/getUserThemeSelectionRecord";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserThemeSelectionRecord(_response));
        });
    }

    protected processGetUserThemeSelectionRecord(response: AxiosResponse): Promise<UserThemeSelection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserThemeSelection.fromJS(resultData200);
            return Promise.resolve<UserThemeSelection>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserThemeSelection>(null as any);
    }
}

export interface IVersionClient {
    /**
     * @return OK
     */
    getVersion( cancelToken?: CancelToken): Promise<VersionResponse>;
}

export class VersionClient extends ApiClientBase implements IVersionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getVersion( cancelToken?: CancelToken): Promise<VersionResponse> {
        let url_ = this.baseUrl + "/api/version/api/version/getVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVersion(_response));
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<VersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VersionResponse.fromJS(resultData200);
            return Promise.resolve<VersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VersionResponse>(null as any);
    }
}

export interface IWasteTypeEmissionFactorClient {
    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<WasteTypeEmissionFactor[]>;
    /**
     * @return OK
     */
    wasteTypeList( cancelToken?: CancelToken): Promise<WasteTypeWithScreen[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: WasteTypeEmissionFactor | undefined,  cancelToken?: CancelToken): Promise<WasteTypeEmissionFactor>;
    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: WasteTypeEmissionFactor | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    wasteEmissionFactorTemplate(emptyTemplate: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importWasteEmissionFactorData(file: FileParameter | undefined, uploadSessionId: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadWasteEmissionFactorResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class WasteTypeEmissionFactorClient extends ApiClientBase implements IWasteTypeEmissionFactorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    list( cancelToken?: CancelToken): Promise<WasteTypeEmissionFactor[]> {
        let url_ = this.baseUrl + "/api/wasteTypeEmissionFactor/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<WasteTypeEmissionFactor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WasteTypeEmissionFactor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WasteTypeEmissionFactor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WasteTypeEmissionFactor[]>(null as any);
    }

    /**
     * @return OK
     */
    wasteTypeList( cancelToken?: CancelToken): Promise<WasteTypeWithScreen[]> {
        let url_ = this.baseUrl + "/api/wasteTypeEmissionFactor/WasteTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWasteTypeList(_response));
        });
    }

    protected processWasteTypeList(response: AxiosResponse): Promise<WasteTypeWithScreen[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WasteTypeWithScreen.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WasteTypeWithScreen[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WasteTypeWithScreen[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: WasteTypeEmissionFactor | undefined, cancelToken?: CancelToken): Promise<WasteTypeEmissionFactor> {
        let url_ = this.baseUrl + "/api/wasteTypeEmissionFactor/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<WasteTypeEmissionFactor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WasteTypeEmissionFactor.fromJS(resultData200);
            return Promise.resolve<WasteTypeEmissionFactor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WasteTypeEmissionFactor>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body: WasteTypeEmissionFactor | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/wasteTypeEmissionFactor/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param emptyTemplate (optional) 
     * @return OK
     */
    wasteEmissionFactorTemplate(emptyTemplate: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/wasteTypeEmissionFactor/WasteEmissionFactorTemplate?";
        if (emptyTemplate === null)
            throw new globalThis.Error("The parameter 'emptyTemplate' cannot be null.");
        else if (emptyTemplate !== undefined)
            url_ += "emptyTemplate=" + encodeURIComponent("" + emptyTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWasteEmissionFactorTemplate(_response));
        });
    }

    protected processWasteEmissionFactorTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @param uploadSessionId (optional) 
     * @return OK
     */
    importWasteEmissionFactorData(file: FileParameter | undefined, uploadSessionId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/wasteTypeEmissionFactor/ImportWasteEmissionFactorData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (uploadSessionId === null || uploadSessionId === undefined)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else
            content_.append("uploadSessionId", uploadSessionId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportWasteEmissionFactorData(_response));
        });
    }

    protected processImportWasteEmissionFactorData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param uploadSessionId (optional) 
     * @param errorsOnly (optional) 
     * @return OK
     */
    downloadWasteEmissionFactorResults(uploadSessionId: string | undefined, errorsOnly: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/wasteTypeEmissionFactor/DownloadWasteEmissionFactorResults?";
        if (uploadSessionId === null)
            throw new globalThis.Error("The parameter 'uploadSessionId' cannot be null.");
        else if (uploadSessionId !== undefined)
            url_ += "uploadSessionId=" + encodeURIComponent("" + uploadSessionId) + "&";
        if (errorsOnly === null)
            throw new globalThis.Error("The parameter 'errorsOnly' cannot be null.");
        else if (errorsOnly !== undefined)
            url_ += "errorsOnly=" + encodeURIComponent("" + errorsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadWasteEmissionFactorResults(_response));
        });
    }

    protected processDownloadWasteEmissionFactorResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class APIProxyDetails implements IAPIProxyDetails {
    assessment?: Assessment;
    lastUpdate?: Date;
    updatedPerson?: Person;
    assessmentPath?: string | undefined;
    materialComments?: string | undefined;

    constructor(data?: IAPIProxyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : undefined as any;
            this.updatedPerson = _data["updatedPerson"] ? Person.fromJS(_data["updatedPerson"]) : undefined as any;
            this.assessmentPath = _data["assessmentPath"];
            this.materialComments = _data["materialComments"];
        }
    }

    static fromJS(data: any): APIProxyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new APIProxyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : undefined as any;
        data["updatedPerson"] = this.updatedPerson ? this.updatedPerson.toJSON() : undefined as any;
        data["assessmentPath"] = this.assessmentPath;
        data["materialComments"] = this.materialComments;
        return data;
    }
}

export interface IAPIProxyDetails {
    assessment?: Assessment;
    lastUpdate?: Date;
    updatedPerson?: Person;
    assessmentPath?: string | undefined;
    materialComments?: string | undefined;
}

export class ActiveBar implements IActiveBar {
    background?: string | undefined;

    constructor(data?: IActiveBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
        }
    }

    static fromJS(data: any): ActiveBar {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveBar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        return data;
    }
}

export interface IActiveBar {
    background?: string | undefined;
}

export class ActivityExportRequest implements IActivityExportRequest {
    from?: string | undefined;
    to?: string | undefined;
    metrics?: string[] | undefined;

    constructor(data?: IActivityExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            if (Array.isArray(_data["metrics"])) {
                this.metrics = [] as any;
                for (let item of _data["metrics"])
                    this.metrics!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        if (Array.isArray(this.metrics)) {
            data["metrics"] = [];
            for (let item of this.metrics)
                data["metrics"].push(item);
        }
        return data;
    }
}

export interface IActivityExportRequest {
    from?: string | undefined;
    to?: string | undefined;
    metrics?: string[] | undefined;
}

export class AutoFixResult implements IAutoFixResult {
    inconsistentMaterialScreensDeleted?: number;
    duplicateMaterialScreensDeleted?: number;
    duplicateMaterialTypeScreensDeleted?: number;
    totalDeleted?: number;

    constructor(data?: IAutoFixResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inconsistentMaterialScreensDeleted = _data["inconsistentMaterialScreensDeleted"];
            this.duplicateMaterialScreensDeleted = _data["duplicateMaterialScreensDeleted"];
            this.duplicateMaterialTypeScreensDeleted = _data["duplicateMaterialTypeScreensDeleted"];
            this.totalDeleted = _data["totalDeleted"];
        }
    }

    static fromJS(data: any): AutoFixResult {
        data = typeof data === 'object' ? data : {};
        let result = new AutoFixResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inconsistentMaterialScreensDeleted"] = this.inconsistentMaterialScreensDeleted;
        data["duplicateMaterialScreensDeleted"] = this.duplicateMaterialScreensDeleted;
        data["duplicateMaterialTypeScreensDeleted"] = this.duplicateMaterialTypeScreensDeleted;
        data["totalDeleted"] = this.totalDeleted;
        return data;
    }
}

export interface IAutoFixResult {
    inconsistentMaterialScreensDeleted?: number;
    duplicateMaterialScreensDeleted?: number;
    duplicateMaterialTypeScreensDeleted?: number;
    totalDeleted?: number;
}

export class Breadcrumb implements IBreadcrumb {
    colorScheme?: ColorSchemeBreadcrumb;

    constructor(data?: IBreadcrumb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeBreadcrumb.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Breadcrumb {
        data = typeof data === 'object' ? data : {};
        let result = new Breadcrumb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IBreadcrumb {
    colorScheme?: ColorSchemeBreadcrumb;
}

export class BreadcrumbIcon implements IBreadcrumbIcon {
    color?: string | undefined;

    constructor(data?: IBreadcrumbIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): BreadcrumbIcon {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbIcon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface IBreadcrumbIcon {
    color?: string | undefined;
}

export class BreadcrumbItem implements IBreadcrumbItem {
    color?: string | undefined;
    icon?: BreadcrumbIcon;

    constructor(data?: IBreadcrumbItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
            this.icon = _data["icon"] ? BreadcrumbIcon.fromJS(_data["icon"]) : undefined as any;
        }
    }

    static fromJS(data: any): BreadcrumbItem {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["icon"] = this.icon ? this.icon.toJSON() : undefined as any;
        return data;
    }
}

export interface IBreadcrumbItem {
    color?: string | undefined;
    icon?: BreadcrumbIcon;
}

export class BreadcrumbRoot implements IBreadcrumbRoot {
    background?: string | undefined;
    borderColor?: string | undefined;

    constructor(data?: IBreadcrumbRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
            this.borderColor = _data["borderColor"];
        }
    }

    static fromJS(data: any): BreadcrumbRoot {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        data["borderColor"] = this.borderColor;
        return data;
    }
}

export interface IBreadcrumbRoot {
    background?: string | undefined;
    borderColor?: string | undefined;
}

export class BreadcrumbState implements IBreadcrumbState {
    item?: BreadcrumbItem;
    root?: BreadcrumbRoot;

    constructor(data?: IBreadcrumbState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? BreadcrumbItem.fromJS(_data["item"]) : undefined as any;
            this.root = _data["root"] ? BreadcrumbRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): BreadcrumbState {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : undefined as any;
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface IBreadcrumbState {
    item?: BreadcrumbItem;
    root?: BreadcrumbRoot;
}

export class Button implements IButton {
    colorScheme?: ColorSchemeButton;

    constructor(data?: IButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeButton.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Button {
        data = typeof data === 'object' ? data : {};
        let result = new Button();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IButton {
    colorScheme?: ColorSchemeButton;
}

export class ButtonRoot implements IButtonRoot {
    primary?: ButtonType;
    secondary?: ButtonType;
    success?: ButtonType;
    info?: ButtonType;
    warning?: ButtonType;
    danger?: ButtonType;

    constructor(data?: IButtonRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primary = _data["primary"] ? ButtonType.fromJS(_data["primary"]) : undefined as any;
            this.secondary = _data["secondary"] ? ButtonType.fromJS(_data["secondary"]) : undefined as any;
            this.success = _data["success"] ? ButtonType.fromJS(_data["success"]) : undefined as any;
            this.info = _data["info"] ? ButtonType.fromJS(_data["info"]) : undefined as any;
            this.warning = _data["warning"] ? ButtonType.fromJS(_data["warning"]) : undefined as any;
            this.danger = _data["danger"] ? ButtonType.fromJS(_data["danger"]) : undefined as any;
        }
    }

    static fromJS(data: any): ButtonRoot {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primary"] = this.primary ? this.primary.toJSON() : undefined as any;
        data["secondary"] = this.secondary ? this.secondary.toJSON() : undefined as any;
        data["success"] = this.success ? this.success.toJSON() : undefined as any;
        data["info"] = this.info ? this.info.toJSON() : undefined as any;
        data["warning"] = this.warning ? this.warning.toJSON() : undefined as any;
        data["danger"] = this.danger ? this.danger.toJSON() : undefined as any;
        return data;
    }
}

export interface IButtonRoot {
    primary?: ButtonType;
    secondary?: ButtonType;
    success?: ButtonType;
    info?: ButtonType;
    warning?: ButtonType;
    danger?: ButtonType;
}

export class ButtonState implements IButtonState {
    root?: ButtonRoot;

    constructor(data?: IButtonState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? ButtonRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): ButtonState {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface IButtonState {
    root?: ButtonRoot;
}

export class ButtonType implements IButtonType {
    color?: string | undefined;
    contrastColor?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    hoverBorderColor?: string | undefined;
    focusRing?: FocusRing;
    borderColor?: string | undefined;
    activeColor?: string | undefined;
    activeBackground?: string | undefined;
    disabledBackground?: string | undefined;
    disabledColor?: string | undefined;
    disabledBorderColor?: string | undefined;

    constructor(data?: IButtonType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
            this.contrastColor = _data["contrastColor"];
            this.background = _data["background"];
            this.hoverBackground = _data["hoverBackground"];
            this.hoverColor = _data["hoverColor"];
            this.hoverBorderColor = _data["hoverBorderColor"];
            this.focusRing = _data["focusRing"] ? FocusRing.fromJS(_data["focusRing"]) : undefined as any;
            this.borderColor = _data["borderColor"];
            this.activeColor = _data["activeColor"];
            this.activeBackground = _data["activeBackground"];
            this.disabledBackground = _data["disabledBackground"];
            this.disabledColor = _data["disabledColor"];
            this.disabledBorderColor = _data["disabledBorderColor"];
        }
    }

    static fromJS(data: any): ButtonType {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["contrastColor"] = this.contrastColor;
        data["background"] = this.background;
        data["hoverBackground"] = this.hoverBackground;
        data["hoverColor"] = this.hoverColor;
        data["hoverBorderColor"] = this.hoverBorderColor;
        data["focusRing"] = this.focusRing ? this.focusRing.toJSON() : undefined as any;
        data["borderColor"] = this.borderColor;
        data["activeColor"] = this.activeColor;
        data["activeBackground"] = this.activeBackground;
        data["disabledBackground"] = this.disabledBackground;
        data["disabledColor"] = this.disabledColor;
        data["disabledBorderColor"] = this.disabledBorderColor;
        return data;
    }
}

export interface IButtonType {
    color?: string | undefined;
    contrastColor?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    hoverBorderColor?: string | undefined;
    focusRing?: FocusRing;
    borderColor?: string | undefined;
    activeColor?: string | undefined;
    activeBackground?: string | undefined;
    disabledBackground?: string | undefined;
    disabledColor?: string | undefined;
    disabledBorderColor?: string | undefined;
}

export class CalculationOptions implements ICalculationOptions {
    emissionFactorsToUse?: string[] | undefined;
    useWeightedEmissionFactors?: boolean;
    outputQuantity?: number | undefined;
    selectedUnitId?: string | undefined;
    selectedStepId?: string | undefined;

    constructor(data?: ICalculationOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emissionFactorsToUse"])) {
                this.emissionFactorsToUse = [] as any;
                for (let item of _data["emissionFactorsToUse"])
                    this.emissionFactorsToUse!.push(item);
            }
            this.useWeightedEmissionFactors = _data["useWeightedEmissionFactors"];
            this.outputQuantity = _data["outputQuantity"];
            this.selectedUnitId = _data["selectedUnitId"];
            this.selectedStepId = _data["selectedStepId"];
        }
    }

    static fromJS(data: any): CalculationOptions {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emissionFactorsToUse)) {
            data["emissionFactorsToUse"] = [];
            for (let item of this.emissionFactorsToUse)
                data["emissionFactorsToUse"].push(item);
        }
        data["useWeightedEmissionFactors"] = this.useWeightedEmissionFactors;
        data["outputQuantity"] = this.outputQuantity;
        data["selectedUnitId"] = this.selectedUnitId;
        data["selectedStepId"] = this.selectedStepId;
        return data;
    }
}

export interface ICalculationOptions {
    emissionFactorsToUse?: string[] | undefined;
    useWeightedEmissionFactors?: boolean;
    outputQuantity?: number | undefined;
    selectedUnitId?: string | undefined;
    selectedStepId?: string | undefined;
}

export class Card implements ICard {
    colorScheme?: ColorSchemeCard;

    constructor(data?: ICard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeCard.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Card {
        data = typeof data === 'object' ? data : {};
        let result = new Card();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface ICard {
    colorScheme?: ColorSchemeCard;
}

export class CardRoot implements ICardRoot {
    background?: string | undefined;
    color?: string | undefined;
    borderColor?: string | undefined;
    shadow?: Shadow;

    constructor(data?: ICardRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
            this.color = _data["color"];
            this.borderColor = _data["borderColor"];
            this.shadow = _data["shadow"] ? Shadow.fromJS(_data["shadow"]) : undefined as any;
        }
    }

    static fromJS(data: any): CardRoot {
        data = typeof data === 'object' ? data : {};
        let result = new CardRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        data["color"] = this.color;
        data["borderColor"] = this.borderColor;
        data["shadow"] = this.shadow ? this.shadow.toJSON() : undefined as any;
        return data;
    }
}

export interface ICardRoot {
    background?: string | undefined;
    color?: string | undefined;
    borderColor?: string | undefined;
    shadow?: Shadow;
}

export class CardState implements ICardState {
    root?: CardRoot;

    constructor(data?: ICardState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? CardRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): CardState {
        data = typeof data === 'object' ? data : {};
        let result = new CardState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface ICardState {
    root?: CardRoot;
}

export class Checkbox implements ICheckbox {
    colorScheme?: ColorSchemeCheckbox;

    constructor(data?: ICheckbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeCheckbox.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Checkbox {
        data = typeof data === 'object' ? data : {};
        let result = new Checkbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckbox {
    colorScheme?: ColorSchemeCheckbox;
}

export class CheckboxRoot implements ICheckboxRoot {
    checkedBackground?: string | undefined;
    checkedColor?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;

    constructor(data?: ICheckboxRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkedBackground = _data["checkedBackground"];
            this.checkedColor = _data["checkedColor"];
            this.background = _data["background"];
            this.hoverBackground = _data["hoverBackground"];
        }
    }

    static fromJS(data: any): CheckboxRoot {
        data = typeof data === 'object' ? data : {};
        let result = new CheckboxRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkedBackground"] = this.checkedBackground;
        data["checkedColor"] = this.checkedColor;
        data["background"] = this.background;
        data["hoverBackground"] = this.hoverBackground;
        return data;
    }
}

export interface ICheckboxRoot {
    checkedBackground?: string | undefined;
    checkedColor?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;
}

export class CheckboxState implements ICheckboxState {
    root?: CheckboxRoot;

    constructor(data?: ICheckboxState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? CheckboxRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckboxState {
        data = typeof data === 'object' ? data : {};
        let result = new CheckboxState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckboxState {
    root?: CheckboxRoot;
}

export class Chip implements IChip {
    colorScheme?: ColorSchemeChip;

    constructor(data?: IChip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeChip.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Chip {
        data = typeof data === 'object' ? data : {};
        let result = new Chip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IChip {
    colorScheme?: ColorSchemeChip;
}

export class ChipRoot implements IChipRoot {
    background?: string | undefined;
    color?: string | undefined;
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    iconColor?: string | undefined;
    borderColor?: string | undefined;

    constructor(data?: IChipRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
            this.color = _data["color"];
            this.hoverBackground = _data["hoverBackground"];
            this.hoverColor = _data["hoverColor"];
            this.iconColor = _data["iconColor"];
            this.borderColor = _data["borderColor"];
        }
    }

    static fromJS(data: any): ChipRoot {
        data = typeof data === 'object' ? data : {};
        let result = new ChipRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        data["color"] = this.color;
        data["hoverBackground"] = this.hoverBackground;
        data["hoverColor"] = this.hoverColor;
        data["iconColor"] = this.iconColor;
        data["borderColor"] = this.borderColor;
        return data;
    }
}

export interface IChipRoot {
    background?: string | undefined;
    color?: string | undefined;
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    iconColor?: string | undefined;
    borderColor?: string | undefined;
}

export class ChipState implements IChipState {
    root?: ChipRoot;

    constructor(data?: IChipState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? ChipRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChipState {
        data = typeof data === 'object' ? data : {};
        let result = new ChipState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface IChipState {
    root?: ChipRoot;
}

export class ColorMain implements IColorMain {
    color?: string | undefined;

    constructor(data?: IColorMain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ColorMain {
        data = typeof data === 'object' ? data : {};
        let result = new ColorMain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface IColorMain {
    color?: string | undefined;
}

export class ColorScheme implements IColorScheme {
    light?: ColorSchemeRoot;
    dark?: ColorSchemeRoot;

    constructor(data?: IColorScheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? ColorSchemeRoot.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? ColorSchemeRoot.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorScheme {
        data = typeof data === 'object' ? data : {};
        let result = new ColorScheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorScheme {
    light?: ColorSchemeRoot;
    dark?: ColorSchemeRoot;
}

export class ColorSchemeBreadcrumb implements IColorSchemeBreadcrumb {
    light?: BreadcrumbState;
    dark?: BreadcrumbState;

    constructor(data?: IColorSchemeBreadcrumb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? BreadcrumbState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? BreadcrumbState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeBreadcrumb {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeBreadcrumb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeBreadcrumb {
    light?: BreadcrumbState;
    dark?: BreadcrumbState;
}

export class ColorSchemeButton implements IColorSchemeButton {
    light?: ButtonState;
    dark?: ButtonState;

    constructor(data?: IColorSchemeButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? ButtonState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? ButtonState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeButton {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeButton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeButton {
    light?: ButtonState;
    dark?: ButtonState;
}

export class ColorSchemeCard implements IColorSchemeCard {
    light?: CardState;
    dark?: CardState;

    constructor(data?: IColorSchemeCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? CardState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? CardState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeCard {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeCard {
    light?: CardState;
    dark?: CardState;
}

export class ColorSchemeCheckbox implements IColorSchemeCheckbox {
    light?: CheckboxState;
    dark?: CheckboxState;

    constructor(data?: IColorSchemeCheckbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? CheckboxState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? CheckboxState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeCheckbox {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeCheckbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeCheckbox {
    light?: CheckboxState;
    dark?: CheckboxState;
}

export class ColorSchemeChip implements IColorSchemeChip {
    light?: ChipState;
    dark?: ChipState;

    constructor(data?: IColorSchemeChip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? ChipState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? ChipState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeChip {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeChip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeChip {
    light?: ChipState;
    dark?: ChipState;
}

export class ColorSchemeDatatable implements IColorSchemeDatatable {
    light?: DatatableState;
    dark?: DatatableState;

    constructor(data?: IColorSchemeDatatable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? DatatableState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? DatatableState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeDatatable {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeDatatable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeDatatable {
    light?: DatatableState;
    dark?: DatatableState;
}

export class ColorSchemeListbox implements IColorSchemeListbox {
    light?: SelectState;
    dark?: SelectState;

    constructor(data?: IColorSchemeListbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? SelectState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? SelectState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeListbox {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeListbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeListbox {
    light?: SelectState;
    dark?: SelectState;
}

export class ColorSchemeMain implements IColorSchemeMain {
    light?: SeverityMain;
    dark?: SeverityMain;

    constructor(data?: IColorSchemeMain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? SeverityMain.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? SeverityMain.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeMain {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeMain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeMain {
    light?: SeverityMain;
    dark?: SeverityMain;
}

export class ColorSchemeMessage implements IColorSchemeMessage {
    light?: MessageState;
    dark?: MessageState;

    constructor(data?: IColorSchemeMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? MessageState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? MessageState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeMessage {
    light?: MessageState;
    dark?: MessageState;
}

export class ColorSchemeMultiselect implements IColorSchemeMultiselect {
    light?: SelectState;
    dark?: SelectState;

    constructor(data?: IColorSchemeMultiselect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? SelectState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? SelectState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeMultiselect {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeMultiselect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeMultiselect {
    light?: SelectState;
    dark?: SelectState;
}

export class ColorSchemeProgressbar implements IColorSchemeProgressbar {
    light?: ProgressbarState;
    dark?: ProgressbarState;

    constructor(data?: IColorSchemeProgressbar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? ProgressbarState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? ProgressbarState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeProgressbar {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeProgressbar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeProgressbar {
    light?: ProgressbarState;
    dark?: ProgressbarState;
}

export class ColorSchemeRadiobutton implements IColorSchemeRadiobutton {
    light?: RadiobuttonState;
    dark?: RadiobuttonState;

    constructor(data?: IColorSchemeRadiobutton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? RadiobuttonState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? RadiobuttonState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeRadiobutton {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeRadiobutton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeRadiobutton {
    light?: RadiobuttonState;
    dark?: RadiobuttonState;
}

export class ColorSchemeRoot implements IColorSchemeRoot {
    root?: ToastState;

    constructor(data?: IColorSchemeRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? ToastState.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeRoot {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeRoot {
    root?: ToastState;
}

export class ColorSchemeSelect implements IColorSchemeSelect {
    light?: SelectState;
    dark?: SelectState;

    constructor(data?: IColorSchemeSelect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? SelectState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? SelectState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeSelect {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeSelect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeSelect {
    light?: SelectState;
    dark?: SelectState;
}

export class ColorSchemeSplitbutton implements IColorSchemeSplitbutton {
    light?: SplitbuttonState;
    dark?: SplitbuttonState;

    constructor(data?: IColorSchemeSplitbutton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? SplitbuttonState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? SplitbuttonState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeSplitbutton {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeSplitbutton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeSplitbutton {
    light?: SplitbuttonState;
    dark?: SplitbuttonState;
}

export class ColorSchemeTabs implements IColorSchemeTabs {
    light?: TabsLight;
    dark?: TabsDark;

    constructor(data?: IColorSchemeTabs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? TabsLight.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? TabsDark.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeTabs {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeTabs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeTabs {
    light?: TabsLight;
    dark?: TabsDark;
}

export class ColorSchemeToggleswitch implements IColorSchemeToggleswitch {
    light?: ToggleswitchState;
    dark?: ToggleswitchState;

    constructor(data?: IColorSchemeToggleswitch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? ToggleswitchState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? ToggleswitchState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeToggleswitch {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeToggleswitch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeToggleswitch {
    light?: ToggleswitchState;
    dark?: ToggleswitchState;
}

export class ColorSchemeTreetable implements IColorSchemeTreetable {
    light?: TreetableState;
    dark?: TreetableState;

    constructor(data?: IColorSchemeTreetable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.light = _data["light"] ? TreetableState.fromJS(_data["light"]) : undefined as any;
            this.dark = _data["dark"] ? TreetableState.fromJS(_data["dark"]) : undefined as any;
        }
    }

    static fromJS(data: any): ColorSchemeTreetable {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSchemeTreetable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["light"] = this.light ? this.light.toJSON() : undefined as any;
        data["dark"] = this.dark ? this.dark.toJSON() : undefined as any;
        return data;
    }
}

export interface IColorSchemeTreetable {
    light?: TreetableState;
    dark?: TreetableState;
}

export class Components implements IComponents {
    toast?: Toast;
    tabs?: Tabs;
    button?: Button;
    select?: Select;
    listbox?: Listbox;
    checkbox?: Checkbox;
    splitbutton?: Splitbutton;
    datatable?: Datatable;
    treetable?: Treetable;
    progressbar?: Progressbar;
    breadcrumb?: Breadcrumb;
    chip?: Chip;
    multiselect?: Multiselect;
    radiobutton?: Radiobutton;
    toggleswitch?: Toggleswitch;
    message?: Message;
    card?: Card;

    constructor(data?: IComponents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toast = _data["toast"] ? Toast.fromJS(_data["toast"]) : undefined as any;
            this.tabs = _data["tabs"] ? Tabs.fromJS(_data["tabs"]) : undefined as any;
            this.button = _data["button"] ? Button.fromJS(_data["button"]) : undefined as any;
            this.select = _data["select"] ? Select.fromJS(_data["select"]) : undefined as any;
            this.listbox = _data["listbox"] ? Listbox.fromJS(_data["listbox"]) : undefined as any;
            this.checkbox = _data["checkbox"] ? Checkbox.fromJS(_data["checkbox"]) : undefined as any;
            this.splitbutton = _data["splitbutton"] ? Splitbutton.fromJS(_data["splitbutton"]) : undefined as any;
            this.datatable = _data["datatable"] ? Datatable.fromJS(_data["datatable"]) : undefined as any;
            this.treetable = _data["treetable"] ? Treetable.fromJS(_data["treetable"]) : undefined as any;
            this.progressbar = _data["progressbar"] ? Progressbar.fromJS(_data["progressbar"]) : undefined as any;
            this.breadcrumb = _data["breadcrumb"] ? Breadcrumb.fromJS(_data["breadcrumb"]) : undefined as any;
            this.chip = _data["chip"] ? Chip.fromJS(_data["chip"]) : undefined as any;
            this.multiselect = _data["multiselect"] ? Multiselect.fromJS(_data["multiselect"]) : undefined as any;
            this.radiobutton = _data["radiobutton"] ? Radiobutton.fromJS(_data["radiobutton"]) : undefined as any;
            this.toggleswitch = _data["toggleswitch"] ? Toggleswitch.fromJS(_data["toggleswitch"]) : undefined as any;
            this.message = _data["message"] ? Message.fromJS(_data["message"]) : undefined as any;
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
        }
    }

    static fromJS(data: any): Components {
        data = typeof data === 'object' ? data : {};
        let result = new Components();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toast"] = this.toast ? this.toast.toJSON() : undefined as any;
        data["tabs"] = this.tabs ? this.tabs.toJSON() : undefined as any;
        data["button"] = this.button ? this.button.toJSON() : undefined as any;
        data["select"] = this.select ? this.select.toJSON() : undefined as any;
        data["listbox"] = this.listbox ? this.listbox.toJSON() : undefined as any;
        data["checkbox"] = this.checkbox ? this.checkbox.toJSON() : undefined as any;
        data["splitbutton"] = this.splitbutton ? this.splitbutton.toJSON() : undefined as any;
        data["datatable"] = this.datatable ? this.datatable.toJSON() : undefined as any;
        data["treetable"] = this.treetable ? this.treetable.toJSON() : undefined as any;
        data["progressbar"] = this.progressbar ? this.progressbar.toJSON() : undefined as any;
        data["breadcrumb"] = this.breadcrumb ? this.breadcrumb.toJSON() : undefined as any;
        data["chip"] = this.chip ? this.chip.toJSON() : undefined as any;
        data["multiselect"] = this.multiselect ? this.multiselect.toJSON() : undefined as any;
        data["radiobutton"] = this.radiobutton ? this.radiobutton.toJSON() : undefined as any;
        data["toggleswitch"] = this.toggleswitch ? this.toggleswitch.toJSON() : undefined as any;
        data["message"] = this.message ? this.message.toJSON() : undefined as any;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }
}

export interface IComponents {
    toast?: Toast;
    tabs?: Tabs;
    button?: Button;
    select?: Select;
    listbox?: Listbox;
    checkbox?: Checkbox;
    splitbutton?: Splitbutton;
    datatable?: Datatable;
    treetable?: Treetable;
    progressbar?: Progressbar;
    breadcrumb?: Breadcrumb;
    chip?: Chip;
    multiselect?: Multiselect;
    radiobutton?: Radiobutton;
    toggleswitch?: Toggleswitch;
    message?: Message;
    card?: Card;
}

export class ConfigurationVariableWithDisplay implements IConfigurationVariableWithDisplay {
    id?: string;
    variableName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    valueType?: string | undefined;
    referenceTableId?: string | undefined;
    variableValue?: string | undefined;
    displayValue?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    referenceTable?: ReferenceTable;

    constructor(data?: IConfigurationVariableWithDisplay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.variableName = _data["variableName"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.valueType = _data["valueType"];
            this.referenceTableId = _data["referenceTableId"];
            this.variableValue = _data["variableValue"];
            this.displayValue = _data["displayValue"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.referenceTable = _data["referenceTable"] ? ReferenceTable.fromJS(_data["referenceTable"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConfigurationVariableWithDisplay {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationVariableWithDisplay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["variableName"] = this.variableName;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["valueType"] = this.valueType;
        data["referenceTableId"] = this.referenceTableId;
        data["variableValue"] = this.variableValue;
        data["displayValue"] = this.displayValue;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["referenceTable"] = this.referenceTable ? this.referenceTable.toJSON() : undefined as any;
        return data;
    }
}

export interface IConfigurationVariableWithDisplay {
    id?: string;
    variableName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    valueType?: string | undefined;
    referenceTableId?: string | undefined;
    variableValue?: string | undefined;
    displayValue?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    referenceTable?: ReferenceTable;
}

export class CopyGeneralInformationRequest implements ICopyGeneralInformationRequest {
    sourceGeneralInformationId?: string;
    newName?: string | undefined;

    constructor(data?: ICopyGeneralInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceGeneralInformationId = _data["sourceGeneralInformationId"];
            this.newName = _data["newName"];
        }
    }

    static fromJS(data: any): CopyGeneralInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyGeneralInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceGeneralInformationId"] = this.sourceGeneralInformationId;
        data["newName"] = this.newName;
        return data;
    }
}

export interface ICopyGeneralInformationRequest {
    sourceGeneralInformationId?: string;
    newName?: string | undefined;
}

export class CopyGeneralInformationResponse implements ICopyGeneralInformationResponse {
    newGeneralInformationId?: string;
    message?: string | undefined;

    constructor(data?: ICopyGeneralInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newGeneralInformationId = _data["newGeneralInformationId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CopyGeneralInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyGeneralInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newGeneralInformationId"] = this.newGeneralInformationId;
        data["message"] = this.message;
        return data;
    }
}

export interface ICopyGeneralInformationResponse {
    newGeneralInformationId?: string;
    message?: string | undefined;
}

export class CurrentProviderResponse implements ICurrentProviderResponse {
    currentProvider?: string | undefined;
    targetProvider?: string | undefined;

    constructor(data?: ICurrentProviderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentProvider = _data["currentProvider"];
            this.targetProvider = _data["targetProvider"];
        }
    }

    static fromJS(data: any): CurrentProviderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentProviderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentProvider"] = this.currentProvider;
        data["targetProvider"] = this.targetProvider;
        return data;
    }
}

export interface ICurrentProviderResponse {
    currentProvider?: string | undefined;
    targetProvider?: string | undefined;
}

export class Datatable implements IDatatable {
    colorScheme?: ColorSchemeDatatable;

    constructor(data?: IDatatable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeDatatable.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Datatable {
        data = typeof data === 'object' ? data : {};
        let result = new Datatable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IDatatable {
    colorScheme?: ColorSchemeDatatable;
}

export class DatatableBodyCell implements IDatatableBodyCell {
    borderColor?: string | undefined;

    constructor(data?: IDatatableBodyCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borderColor = _data["borderColor"];
        }
    }

    static fromJS(data: any): DatatableBodyCell {
        data = typeof data === 'object' ? data : {};
        let result = new DatatableBodyCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borderColor"] = this.borderColor;
        return data;
    }
}

export interface IDatatableBodyCell {
    borderColor?: string | undefined;
}

export class DatatableHeaderCell implements IDatatableHeaderCell {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    borderColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;

    constructor(data?: IDatatableHeaderCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoverBackground = _data["hoverBackground"];
            this.hoverColor = _data["hoverColor"];
            this.borderColor = _data["borderColor"];
            this.background = _data["background"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): DatatableHeaderCell {
        data = typeof data === 'object' ? data : {};
        let result = new DatatableHeaderCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hoverBackground"] = this.hoverBackground;
        data["hoverColor"] = this.hoverColor;
        data["borderColor"] = this.borderColor;
        data["background"] = this.background;
        data["color"] = this.color;
        return data;
    }
}

export interface IDatatableHeaderCell {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    borderColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;
}

export class DatatableRoot implements IDatatableRoot {
    borderColor?: string | undefined;
    borderRadius?: string | undefined;
    row?: DatatableRow;

    constructor(data?: IDatatableRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borderColor = _data["borderColor"];
            this.borderRadius = _data["borderRadius"];
            this.row = _data["row"] ? DatatableRow.fromJS(_data["row"]) : undefined as any;
        }
    }

    static fromJS(data: any): DatatableRoot {
        data = typeof data === 'object' ? data : {};
        let result = new DatatableRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borderColor"] = this.borderColor;
        data["borderRadius"] = this.borderRadius;
        data["row"] = this.row ? this.row.toJSON() : undefined as any;
        return data;
    }
}

export interface IDatatableRoot {
    borderColor?: string | undefined;
    borderRadius?: string | undefined;
    row?: DatatableRow;
}

export class DatatableRow implements IDatatableRow {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;
    selectedBackground?: string | undefined;
    selectedColor?: string | undefined;

    constructor(data?: IDatatableRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoverBackground = _data["hoverBackground"];
            this.hoverColor = _data["hoverColor"];
            this.background = _data["background"];
            this.color = _data["color"];
            this.selectedBackground = _data["selectedBackground"];
            this.selectedColor = _data["selectedColor"];
        }
    }

    static fromJS(data: any): DatatableRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatatableRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hoverBackground"] = this.hoverBackground;
        data["hoverColor"] = this.hoverColor;
        data["background"] = this.background;
        data["color"] = this.color;
        data["selectedBackground"] = this.selectedBackground;
        data["selectedColor"] = this.selectedColor;
        return data;
    }
}

export interface IDatatableRow {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;
    selectedBackground?: string | undefined;
    selectedColor?: string | undefined;
}

export class DatatableState implements IDatatableState {
    root?: DatatableRoot;
    headerCell?: DatatableHeaderCell;
    row?: DatatableRow;
    bodyCell?: DatatableBodyCell;

    constructor(data?: IDatatableState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? DatatableRoot.fromJS(_data["root"]) : undefined as any;
            this.headerCell = _data["headerCell"] ? DatatableHeaderCell.fromJS(_data["headerCell"]) : undefined as any;
            this.row = _data["row"] ? DatatableRow.fromJS(_data["row"]) : undefined as any;
            this.bodyCell = _data["bodyCell"] ? DatatableBodyCell.fromJS(_data["bodyCell"]) : undefined as any;
        }
    }

    static fromJS(data: any): DatatableState {
        data = typeof data === 'object' ? data : {};
        let result = new DatatableState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        data["headerCell"] = this.headerCell ? this.headerCell.toJSON() : undefined as any;
        data["row"] = this.row ? this.row.toJSON() : undefined as any;
        data["bodyCell"] = this.bodyCell ? this.bodyCell.toJSON() : undefined as any;
        return data;
    }
}

export interface IDatatableState {
    root?: DatatableRoot;
    headerCell?: DatatableHeaderCell;
    row?: DatatableRow;
    bodyCell?: DatatableBodyCell;
}

export class DeactivateUserRequest implements IDeactivateUserRequest {
    personId?: string;
    deactivateInOkta?: boolean;

    constructor(data?: IDeactivateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.deactivateInOkta = _data["deactivateInOkta"];
        }
    }

    static fromJS(data: any): DeactivateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["deactivateInOkta"] = this.deactivateInOkta;
        return data;
    }
}

export interface IDeactivateUserRequest {
    personId?: string;
    deactivateInOkta?: boolean;
}

export class DensityRequestResponse implements IDensityRequestResponse {
    success?: boolean;
    message?: string | undefined;
    emailsSent?: number | undefined;
    errors?: string[] | undefined;

    constructor(data?: IDensityRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.emailsSent = _data["emailsSent"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): DensityRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DensityRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["emailsSent"] = this.emailsSent;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IDensityRequestResponse {
    success?: boolean;
    message?: string | undefined;
    emailsSent?: number | undefined;
    errors?: string[] | undefined;
}

export class DownstreamDistributionTable implements IDownstreamDistributionTable {
    stepField?: TableField;
    stepRow?: TableField;
    transportGroup?: TableField;
    wharehousingGroup?: TableField;
    actionField?: TableField;

    constructor(data?: IDownstreamDistributionTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepField = _data["stepField"] ? TableField.fromJS(_data["stepField"]) : undefined as any;
            this.stepRow = _data["stepRow"] ? TableField.fromJS(_data["stepRow"]) : undefined as any;
            this.transportGroup = _data["transportGroup"] ? TableField.fromJS(_data["transportGroup"]) : undefined as any;
            this.wharehousingGroup = _data["wharehousingGroup"] ? TableField.fromJS(_data["wharehousingGroup"]) : undefined as any;
            this.actionField = _data["actionField"] ? TableField.fromJS(_data["actionField"]) : undefined as any;
        }
    }

    static fromJS(data: any): DownstreamDistributionTable {
        data = typeof data === 'object' ? data : {};
        let result = new DownstreamDistributionTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepField"] = this.stepField ? this.stepField.toJSON() : undefined as any;
        data["stepRow"] = this.stepRow ? this.stepRow.toJSON() : undefined as any;
        data["transportGroup"] = this.transportGroup ? this.transportGroup.toJSON() : undefined as any;
        data["wharehousingGroup"] = this.wharehousingGroup ? this.wharehousingGroup.toJSON() : undefined as any;
        data["actionField"] = this.actionField ? this.actionField.toJSON() : undefined as any;
        return data;
    }
}

export interface IDownstreamDistributionTable {
    stepField?: TableField;
    stepRow?: TableField;
    transportGroup?: TableField;
    wharehousingGroup?: TableField;
    actionField?: TableField;
}

export class DuplicateCheckResponse implements IDuplicateCheckResponse {
    materialScreenDuplicates?: number;
    materialTypeScreenDuplicates?: number;
    materialScreenDuplicateRecords?: DuplicateRecord[] | undefined;
    materialTypeScreenDuplicateRecords?: DuplicateRecord[] | undefined;

    constructor(data?: IDuplicateCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialScreenDuplicates = _data["materialScreenDuplicates"];
            this.materialTypeScreenDuplicates = _data["materialTypeScreenDuplicates"];
            if (Array.isArray(_data["materialScreenDuplicateRecords"])) {
                this.materialScreenDuplicateRecords = [] as any;
                for (let item of _data["materialScreenDuplicateRecords"])
                    this.materialScreenDuplicateRecords!.push(DuplicateRecord.fromJS(item));
            }
            if (Array.isArray(_data["materialTypeScreenDuplicateRecords"])) {
                this.materialTypeScreenDuplicateRecords = [] as any;
                for (let item of _data["materialTypeScreenDuplicateRecords"])
                    this.materialTypeScreenDuplicateRecords!.push(DuplicateRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DuplicateCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialScreenDuplicates"] = this.materialScreenDuplicates;
        data["materialTypeScreenDuplicates"] = this.materialTypeScreenDuplicates;
        if (Array.isArray(this.materialScreenDuplicateRecords)) {
            data["materialScreenDuplicateRecords"] = [];
            for (let item of this.materialScreenDuplicateRecords)
                data["materialScreenDuplicateRecords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialTypeScreenDuplicateRecords)) {
            data["materialTypeScreenDuplicateRecords"] = [];
            for (let item of this.materialTypeScreenDuplicateRecords)
                data["materialTypeScreenDuplicateRecords"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDuplicateCheckResponse {
    materialScreenDuplicates?: number;
    materialTypeScreenDuplicates?: number;
    materialScreenDuplicateRecords?: DuplicateRecord[] | undefined;
    materialTypeScreenDuplicateRecords?: DuplicateRecord[] | undefined;
}

export class DuplicateDeleteResult implements IDuplicateDeleteResult {
    materialScreenDeleted?: number;
    materialTypeScreenDeleted?: number;

    constructor(data?: IDuplicateDeleteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialScreenDeleted = _data["materialScreenDeleted"];
            this.materialTypeScreenDeleted = _data["materialTypeScreenDeleted"];
        }
    }

    static fromJS(data: any): DuplicateDeleteResult {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateDeleteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialScreenDeleted"] = this.materialScreenDeleted;
        data["materialTypeScreenDeleted"] = this.materialTypeScreenDeleted;
        return data;
    }
}

export interface IDuplicateDeleteResult {
    materialScreenDeleted?: number;
    materialTypeScreenDeleted?: number;
}

export class DuplicateGeneralInformationCheckResult implements IDuplicateGeneralInformationCheckResult {
    records?: DuplicateGeneralInformationRecord[] | undefined;
    totalRecords?: number;
    recordsWithIssues?: number;

    constructor(data?: IDuplicateGeneralInformationCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(DuplicateGeneralInformationRecord.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.recordsWithIssues = _data["recordsWithIssues"];
        }
    }

    static fromJS(data: any): DuplicateGeneralInformationCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateGeneralInformationCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecords"] = this.totalRecords;
        data["recordsWithIssues"] = this.recordsWithIssues;
        return data;
    }
}

export interface IDuplicateGeneralInformationCheckResult {
    records?: DuplicateGeneralInformationRecord[] | undefined;
    totalRecords?: number;
    recordsWithIssues?: number;
}

export class DuplicateGeneralInformationRecord implements IDuplicateGeneralInformationRecord {
    projectId?: string | undefined;
    projectName?: string | undefined;
    subProjectId?: string | undefined;
    subProjectName?: string | undefined;
    assessmentId?: string | undefined;
    assessmentName?: string | undefined;
    screenId?: string | undefined;
    screenName?: string | undefined;
    generalInformationRecords?: GeneralInformationDetail[] | undefined;
    hasIssue?: boolean;
    recommendedAction?: string | undefined;

    constructor(data?: IDuplicateGeneralInformationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.subProjectId = _data["subProjectId"];
            this.subProjectName = _data["subProjectName"];
            this.assessmentId = _data["assessmentId"];
            this.assessmentName = _data["assessmentName"];
            this.screenId = _data["screenId"];
            this.screenName = _data["screenName"];
            if (Array.isArray(_data["generalInformationRecords"])) {
                this.generalInformationRecords = [] as any;
                for (let item of _data["generalInformationRecords"])
                    this.generalInformationRecords!.push(GeneralInformationDetail.fromJS(item));
            }
            this.hasIssue = _data["hasIssue"];
            this.recommendedAction = _data["recommendedAction"];
        }
    }

    static fromJS(data: any): DuplicateGeneralInformationRecord {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateGeneralInformationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["subProjectId"] = this.subProjectId;
        data["subProjectName"] = this.subProjectName;
        data["assessmentId"] = this.assessmentId;
        data["assessmentName"] = this.assessmentName;
        data["screenId"] = this.screenId;
        data["screenName"] = this.screenName;
        if (Array.isArray(this.generalInformationRecords)) {
            data["generalInformationRecords"] = [];
            for (let item of this.generalInformationRecords)
                data["generalInformationRecords"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasIssue"] = this.hasIssue;
        data["recommendedAction"] = this.recommendedAction;
        return data;
    }
}

export interface IDuplicateGeneralInformationRecord {
    projectId?: string | undefined;
    projectName?: string | undefined;
    subProjectId?: string | undefined;
    subProjectName?: string | undefined;
    assessmentId?: string | undefined;
    assessmentName?: string | undefined;
    screenId?: string | undefined;
    screenName?: string | undefined;
    generalInformationRecords?: GeneralInformationDetail[] | undefined;
    hasIssue?: boolean;
    recommendedAction?: string | undefined;
}

export class DuplicateRecord implements IDuplicateRecord {
    key?: string | undefined;
    count?: number;
    duplicateIds?: string[] | undefined;
    description?: string | undefined;

    constructor(data?: IDuplicateRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.count = _data["count"];
            if (Array.isArray(_data["duplicateIds"])) {
                this.duplicateIds = [] as any;
                for (let item of _data["duplicateIds"])
                    this.duplicateIds!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DuplicateRecord {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["count"] = this.count;
        if (Array.isArray(this.duplicateIds)) {
            data["duplicateIds"] = [];
            for (let item of this.duplicateIds)
                data["duplicateIds"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IDuplicateRecord {
    key?: string | undefined;
    count?: number;
    duplicateIds?: string[] | undefined;
    description?: string | undefined;
}

export class ExportRequest implements IExportRequest {
    finalResult?: FinalResult;
    emissionFactorNames?: string[] | undefined;
    isWeighted?: boolean;
    generalInformationId?: string;
    assessmentId?: string | undefined;
    quantity?: number | undefined;
    formatType?: string | undefined;

    constructor(data?: IExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalResult = _data["finalResult"] ? FinalResult.fromJS(_data["finalResult"]) : undefined as any;
            if (Array.isArray(_data["emissionFactorNames"])) {
                this.emissionFactorNames = [] as any;
                for (let item of _data["emissionFactorNames"])
                    this.emissionFactorNames!.push(item);
            }
            this.isWeighted = _data["isWeighted"];
            this.generalInformationId = _data["generalInformationId"];
            this.assessmentId = _data["assessmentId"];
            this.quantity = _data["quantity"];
            this.formatType = _data["formatType"];
        }
    }

    static fromJS(data: any): ExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalResult"] = this.finalResult ? this.finalResult.toJSON() : undefined as any;
        if (Array.isArray(this.emissionFactorNames)) {
            data["emissionFactorNames"] = [];
            for (let item of this.emissionFactorNames)
                data["emissionFactorNames"].push(item);
        }
        data["isWeighted"] = this.isWeighted;
        data["generalInformationId"] = this.generalInformationId;
        data["assessmentId"] = this.assessmentId;
        data["quantity"] = this.quantity;
        data["formatType"] = this.formatType;
        return data;
    }
}

export interface IExportRequest {
    finalResult?: FinalResult;
    emissionFactorNames?: string[] | undefined;
    isWeighted?: boolean;
    generalInformationId?: string;
    assessmentId?: string | undefined;
    quantity?: number | undefined;
    formatType?: string | undefined;
}

export class ExportRequestOther implements IExportRequestOther {
    allResults?: AllResultsOther;
    emissionFactorNames?: string[] | undefined;
    isWeighted?: boolean;
    assessmentId?: string;
    generalInformationId?: string | undefined;
    packagingGeneralInformationId?: string | undefined;
    distributionGeneralInformationId?: string | undefined;

    constructor(data?: IExportRequestOther) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allResults = _data["allResults"] ? AllResultsOther.fromJS(_data["allResults"]) : undefined as any;
            if (Array.isArray(_data["emissionFactorNames"])) {
                this.emissionFactorNames = [] as any;
                for (let item of _data["emissionFactorNames"])
                    this.emissionFactorNames!.push(item);
            }
            this.isWeighted = _data["isWeighted"];
            this.assessmentId = _data["assessmentId"];
            this.generalInformationId = _data["generalInformationId"];
            this.packagingGeneralInformationId = _data["packagingGeneralInformationId"];
            this.distributionGeneralInformationId = _data["distributionGeneralInformationId"];
        }
    }

    static fromJS(data: any): ExportRequestOther {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequestOther();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allResults"] = this.allResults ? this.allResults.toJSON() : undefined as any;
        if (Array.isArray(this.emissionFactorNames)) {
            data["emissionFactorNames"] = [];
            for (let item of this.emissionFactorNames)
                data["emissionFactorNames"].push(item);
        }
        data["isWeighted"] = this.isWeighted;
        data["assessmentId"] = this.assessmentId;
        data["generalInformationId"] = this.generalInformationId;
        data["packagingGeneralInformationId"] = this.packagingGeneralInformationId;
        data["distributionGeneralInformationId"] = this.distributionGeneralInformationId;
        return data;
    }
}

export interface IExportRequestOther {
    allResults?: AllResultsOther;
    emissionFactorNames?: string[] | undefined;
    isWeighted?: boolean;
    assessmentId?: string;
    generalInformationId?: string | undefined;
    packagingGeneralInformationId?: string | undefined;
    distributionGeneralInformationId?: string | undefined;
}

export class ExternalProviderCredentials implements IExternalProviderCredentials {
    providerType?: string | undefined;
    oktaDomain?: string | undefined;
    oktaApiToken?: string | undefined;
    auth0Domain?: string | undefined;
    auth0ClientId?: string | undefined;
    auth0ClientSecret?: string | undefined;

    constructor(data?: IExternalProviderCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerType = _data["providerType"];
            this.oktaDomain = _data["oktaDomain"];
            this.oktaApiToken = _data["oktaApiToken"];
            this.auth0Domain = _data["auth0Domain"];
            this.auth0ClientId = _data["auth0ClientId"];
            this.auth0ClientSecret = _data["auth0ClientSecret"];
        }
    }

    static fromJS(data: any): ExternalProviderCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalProviderCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerType"] = this.providerType;
        data["oktaDomain"] = this.oktaDomain;
        data["oktaApiToken"] = this.oktaApiToken;
        data["auth0Domain"] = this.auth0Domain;
        data["auth0ClientId"] = this.auth0ClientId;
        data["auth0ClientSecret"] = this.auth0ClientSecret;
        return data;
    }
}

export interface IExternalProviderCredentials {
    providerType?: string | undefined;
    oktaDomain?: string | undefined;
    oktaApiToken?: string | undefined;
    auth0Domain?: string | undefined;
    auth0ClientId?: string | undefined;
    auth0ClientSecret?: string | undefined;
}

export class ExternalProviderUser implements IExternalProviderUser {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: string | undefined;
    provider?: string | undefined;
    createdAt?: Date | undefined;
    lastLogin?: Date | undefined;
    existsInTargetProvider?: boolean;
    existsInLocalDatabase?: boolean;

    constructor(data?: IExternalProviderUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.provider = _data["provider"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.existsInTargetProvider = _data["existsInTargetProvider"];
            this.existsInLocalDatabase = _data["existsInLocalDatabase"];
        }
    }

    static fromJS(data: any): ExternalProviderUser {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalProviderUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["provider"] = this.provider;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["existsInTargetProvider"] = this.existsInTargetProvider;
        data["existsInLocalDatabase"] = this.existsInLocalDatabase;
        return data;
    }
}

export interface IExternalProviderUser {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: string | undefined;
    provider?: string | undefined;
    createdAt?: Date | undefined;
    lastLogin?: Date | undefined;
    existsInTargetProvider?: boolean;
    existsInLocalDatabase?: boolean;
}

export class ExternalProviderUsersResponse implements IExternalProviderUsersResponse {
    success?: boolean;
    message?: string | undefined;
    users?: ExternalProviderUser[] | undefined;
    totalCount?: number;
    sourceProvider?: string | undefined;
    targetProvider?: string | undefined;
    errors?: string[] | undefined;

    constructor(data?: IExternalProviderUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ExternalProviderUser.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.sourceProvider = _data["sourceProvider"];
            this.targetProvider = _data["targetProvider"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalProviderUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalProviderUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["sourceProvider"] = this.sourceProvider;
        data["targetProvider"] = this.targetProvider;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IExternalProviderUsersResponse {
    success?: boolean;
    message?: string | undefined;
    users?: ExternalProviderUser[] | undefined;
    totalCount?: number;
    sourceProvider?: string | undefined;
    targetProvider?: string | undefined;
    errors?: string[] | undefined;
}

export class FinalResult implements IFinalResult {
    id?: number;
    outputMaterials?: OutputMaterials[] | undefined;
    outputEolCF?: OutputEolCF[] | undefined;
    resultByLifeCycleStage?: ResultByLifeCycleStage[] | undefined;
    resultByLifeCycleStageGraph1?: ResultByLifeCycleStageGraph1[] | undefined;
    resultByPackagingType?: ResultByPackagingType[] | undefined;
    resultByMaterialComposition?: ResultByMaterialComposition[] | undefined;
    resultByEol?: ResultByEol[] | undefined;
    outputOutDistribution?: OutputOutDistribution[] | undefined;
    module?: string | undefined;

    constructor(data?: IFinalResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["outputMaterials"])) {
                this.outputMaterials = [] as any;
                for (let item of _data["outputMaterials"])
                    this.outputMaterials!.push(OutputMaterials.fromJS(item));
            }
            if (Array.isArray(_data["outputEolCF"])) {
                this.outputEolCF = [] as any;
                for (let item of _data["outputEolCF"])
                    this.outputEolCF!.push(OutputEolCF.fromJS(item));
            }
            if (Array.isArray(_data["resultByLifeCycleStage"])) {
                this.resultByLifeCycleStage = [] as any;
                for (let item of _data["resultByLifeCycleStage"])
                    this.resultByLifeCycleStage!.push(ResultByLifeCycleStage.fromJS(item));
            }
            if (Array.isArray(_data["resultByLifeCycleStageGraph1"])) {
                this.resultByLifeCycleStageGraph1 = [] as any;
                for (let item of _data["resultByLifeCycleStageGraph1"])
                    this.resultByLifeCycleStageGraph1!.push(ResultByLifeCycleStageGraph1.fromJS(item));
            }
            if (Array.isArray(_data["resultByPackagingType"])) {
                this.resultByPackagingType = [] as any;
                for (let item of _data["resultByPackagingType"])
                    this.resultByPackagingType!.push(ResultByPackagingType.fromJS(item));
            }
            if (Array.isArray(_data["resultByMaterialComposition"])) {
                this.resultByMaterialComposition = [] as any;
                for (let item of _data["resultByMaterialComposition"])
                    this.resultByMaterialComposition!.push(ResultByMaterialComposition.fromJS(item));
            }
            if (Array.isArray(_data["resultByEol"])) {
                this.resultByEol = [] as any;
                for (let item of _data["resultByEol"])
                    this.resultByEol!.push(ResultByEol.fromJS(item));
            }
            if (Array.isArray(_data["outputOutDistribution"])) {
                this.outputOutDistribution = [] as any;
                for (let item of _data["outputOutDistribution"])
                    this.outputOutDistribution!.push(OutputOutDistribution.fromJS(item));
            }
            this.module = _data["module"];
        }
    }

    static fromJS(data: any): FinalResult {
        data = typeof data === 'object' ? data : {};
        let result = new FinalResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.outputMaterials)) {
            data["outputMaterials"] = [];
            for (let item of this.outputMaterials)
                data["outputMaterials"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outputEolCF)) {
            data["outputEolCF"] = [];
            for (let item of this.outputEolCF)
                data["outputEolCF"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultByLifeCycleStage)) {
            data["resultByLifeCycleStage"] = [];
            for (let item of this.resultByLifeCycleStage)
                data["resultByLifeCycleStage"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultByLifeCycleStageGraph1)) {
            data["resultByLifeCycleStageGraph1"] = [];
            for (let item of this.resultByLifeCycleStageGraph1)
                data["resultByLifeCycleStageGraph1"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultByPackagingType)) {
            data["resultByPackagingType"] = [];
            for (let item of this.resultByPackagingType)
                data["resultByPackagingType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultByMaterialComposition)) {
            data["resultByMaterialComposition"] = [];
            for (let item of this.resultByMaterialComposition)
                data["resultByMaterialComposition"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultByEol)) {
            data["resultByEol"] = [];
            for (let item of this.resultByEol)
                data["resultByEol"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outputOutDistribution)) {
            data["outputOutDistribution"] = [];
            for (let item of this.outputOutDistribution)
                data["outputOutDistribution"].push(item ? item.toJSON() : undefined as any);
        }
        data["module"] = this.module;
        return data;
    }
}

export interface IFinalResult {
    id?: number;
    outputMaterials?: OutputMaterials[] | undefined;
    outputEolCF?: OutputEolCF[] | undefined;
    resultByLifeCycleStage?: ResultByLifeCycleStage[] | undefined;
    resultByLifeCycleStageGraph1?: ResultByLifeCycleStageGraph1[] | undefined;
    resultByPackagingType?: ResultByPackagingType[] | undefined;
    resultByMaterialComposition?: ResultByMaterialComposition[] | undefined;
    resultByEol?: ResultByEol[] | undefined;
    outputOutDistribution?: OutputOutDistribution[] | undefined;
    module?: string | undefined;
}

export class FocusRing implements IFocusRing {
    color?: string | undefined;

    constructor(data?: IFocusRing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): FocusRing {
        data = typeof data === 'object' ? data : {};
        let result = new FocusRing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface IFocusRing {
    color?: string | undefined;
}

export class GeneralInformationData implements IGeneralInformationData {
    steps?: Step[] | undefined;
    intermediateSteps?: IntermediateStep[] | undefined;
    materialEntryCount?: { [key: string]: number; } | undefined;

    constructor(data?: IGeneralInformationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(Step.fromJS(item));
            }
            if (Array.isArray(_data["intermediateSteps"])) {
                this.intermediateSteps = [] as any;
                for (let item of _data["intermediateSteps"])
                    this.intermediateSteps!.push(IntermediateStep.fromJS(item));
            }
            if (_data["materialEntryCount"]) {
                this.materialEntryCount = {} as any;
                for (let key in _data["materialEntryCount"]) {
                    if (_data["materialEntryCount"].hasOwnProperty(key))
                        (this.materialEntryCount as any)![key] = _data["materialEntryCount"][key];
                }
            }
        }
    }

    static fromJS(data: any): GeneralInformationData {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInformationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.intermediateSteps)) {
            data["intermediateSteps"] = [];
            for (let item of this.intermediateSteps)
                data["intermediateSteps"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.materialEntryCount) {
            data["materialEntryCount"] = {};
            for (let key in this.materialEntryCount) {
                if (this.materialEntryCount.hasOwnProperty(key))
                    (data["materialEntryCount"] as any)[key] = (this.materialEntryCount as any)[key];
            }
        }
        return data;
    }
}

export interface IGeneralInformationData {
    steps?: Step[] | undefined;
    intermediateSteps?: IntermediateStep[] | undefined;
    materialEntryCount?: { [key: string]: number; } | undefined;
}

export class GeneralInformationDetail implements IGeneralInformationDetail {
    generalInformationId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    stepCount?: number;
    rawMaterialCount?: number;
    totalReferences?: number;
    hasSteps?: boolean;
    hasData?: boolean;
    shouldKeep?: boolean;
    shouldDelete?: boolean;
    steps?: StepDetail[] | undefined;

    constructor(data?: IGeneralInformationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalInformationId = _data["generalInformationId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.stepCount = _data["stepCount"];
            this.rawMaterialCount = _data["rawMaterialCount"];
            this.totalReferences = _data["totalReferences"];
            this.hasSteps = _data["hasSteps"];
            this.hasData = _data["hasData"];
            this.shouldKeep = _data["shouldKeep"];
            this.shouldDelete = _data["shouldDelete"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(StepDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralInformationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInformationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalInformationId"] = this.generalInformationId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["stepCount"] = this.stepCount;
        data["rawMaterialCount"] = this.rawMaterialCount;
        data["totalReferences"] = this.totalReferences;
        data["hasSteps"] = this.hasSteps;
        data["hasData"] = this.hasData;
        data["shouldKeep"] = this.shouldKeep;
        data["shouldDelete"] = this.shouldDelete;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGeneralInformationDetail {
    generalInformationId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    stepCount?: number;
    rawMaterialCount?: number;
    totalReferences?: number;
    hasSteps?: boolean;
    hasData?: boolean;
    shouldKeep?: boolean;
    shouldDelete?: boolean;
    steps?: StepDetail[] | undefined;
}

export class HVAC implements IHVAC {
    id?: string;
    facilityId?: string | undefined;
    hvacClassId?: string | undefined;
    power?: number | undefined;
    comment?: string | undefined;
    source?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    hvacClass?: HVACClass;
    facility?: ISOClassFacilityType;

    constructor(data?: IHVAC) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.facilityId = _data["facilityId"];
            this.hvacClassId = _data["hvacClassId"];
            this.power = _data["power"];
            this.comment = _data["comment"];
            this.source = _data["source"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.hvacClass = _data["hvacClass"] ? HVACClass.fromJS(_data["hvacClass"]) : undefined as any;
            this.facility = _data["facility"] ? ISOClassFacilityType.fromJS(_data["facility"]) : undefined as any;
        }
    }

    static fromJS(data: any): HVAC {
        data = typeof data === 'object' ? data : {};
        let result = new HVAC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facilityId"] = this.facilityId;
        data["hvacClassId"] = this.hvacClassId;
        data["power"] = this.power;
        data["comment"] = this.comment;
        data["source"] = this.source;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["hvacClass"] = this.hvacClass ? this.hvacClass.toJSON() : undefined as any;
        data["facility"] = this.facility ? this.facility.toJSON() : undefined as any;
        return data;
    }
}

export interface IHVAC {
    id?: string;
    facilityId?: string | undefined;
    hvacClassId?: string | undefined;
    power?: number | undefined;
    comment?: string | undefined;
    source?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    hvacClass?: HVACClass;
    facility?: ISOClassFacilityType;
}

export class HVACClass implements IHVACClass {
    id?: string;
    hvacClassName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    hvac?: HVAC[] | undefined;
    utilities?: Utilities[] | undefined;

    constructor(data?: IHVACClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hvacClassName = _data["hvacClassName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            if (Array.isArray(_data["hvac"])) {
                this.hvac = [] as any;
                for (let item of _data["hvac"])
                    this.hvac!.push(HVAC.fromJS(item));
            }
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(Utilities.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HVACClass {
        data = typeof data === 'object' ? data : {};
        let result = new HVACClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hvacClassName"] = this.hvacClassName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        if (Array.isArray(this.hvac)) {
            data["hvac"] = [];
            for (let item of this.hvac)
                data["hvac"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHVACClass {
    id?: string;
    hvacClassName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    hvac?: HVAC[] | undefined;
    utilities?: Utilities[] | undefined;
}

export class Hierarchy implements IHierarchy {
    id?: string;
    treeItemName?: string | undefined;
    treeId?: string;
    treePathString?: string | undefined;
    treeLevel?: number;
    countOfDirectChildren?: number;
    countOfAllChildren?: number;

    constructor(data?: IHierarchy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeItemName = _data["treeItemName"];
            this.treeId = _data["treeId"];
            this.treePathString = _data["treePathString"];
            this.treeLevel = _data["treeLevel"];
            this.countOfDirectChildren = _data["countOfDirectChildren"];
            this.countOfAllChildren = _data["countOfAllChildren"];
        }
    }

    static fromJS(data: any): Hierarchy {
        data = typeof data === 'object' ? data : {};
        let result = new Hierarchy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeItemName"] = this.treeItemName;
        data["treeId"] = this.treeId;
        data["treePathString"] = this.treePathString;
        data["treeLevel"] = this.treeLevel;
        data["countOfDirectChildren"] = this.countOfDirectChildren;
        data["countOfAllChildren"] = this.countOfAllChildren;
        return data;
    }
}

export interface IHierarchy {
    id?: string;
    treeItemName?: string | undefined;
    treeId?: string;
    treePathString?: string | undefined;
    treeLevel?: number;
    countOfDirectChildren?: number;
    countOfAllChildren?: number;
}

export class HierarchyId implements IHierarchyId {

    constructor(data?: IHierarchyId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): HierarchyId {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IHierarchyId {
}

export class ISOClassFacilityType implements IISOClassFacilityType {
    id?: string;
    isoClassFacilityTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    hvac?: HVAC[] | undefined;
    utilities?: Utilities[] | undefined;

    constructor(data?: IISOClassFacilityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isoClassFacilityTypeName = _data["isoClassFacilityTypeName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            if (Array.isArray(_data["hvac"])) {
                this.hvac = [] as any;
                for (let item of _data["hvac"])
                    this.hvac!.push(HVAC.fromJS(item));
            }
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(Utilities.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ISOClassFacilityType {
        data = typeof data === 'object' ? data : {};
        let result = new ISOClassFacilityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isoClassFacilityTypeName"] = this.isoClassFacilityTypeName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        if (Array.isArray(this.hvac)) {
            data["hvac"] = [];
            for (let item of this.hvac)
                data["hvac"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IISOClassFacilityType {
    id?: string;
    isoClassFacilityTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    hvac?: HVAC[] | undefined;
    utilities?: Utilities[] | undefined;
}

export class IdentityOperationResponse implements IIdentityOperationResponse {
    success?: boolean;
    message?: string | undefined;
    identityUserId?: string | undefined;
    identityStatus?: string | undefined;
    provider?: string | undefined;
    errors?: string[] | undefined;
    additionalData?: { [key: string]: any; } | undefined;

    constructor(data?: IIdentityOperationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.identityUserId = _data["identityUserId"];
            this.identityStatus = _data["identityStatus"];
            this.provider = _data["provider"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): IdentityOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityOperationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["identityUserId"] = this.identityUserId;
        data["identityStatus"] = this.identityStatus;
        data["provider"] = this.provider;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        return data;
    }
}

export interface IIdentityOperationResponse {
    success?: boolean;
    message?: string | undefined;
    identityUserId?: string | undefined;
    identityStatus?: string | undefined;
    provider?: string | undefined;
    errors?: string[] | undefined;
    additionalData?: { [key: string]: any; } | undefined;
}

export class LandingpageUtilitiesButtons implements ILandingpageUtilitiesButtons {
    backgroundColor?: string | undefined;
    backgroundColorHover?: string | undefined;
    textColor?: string | undefined;
    textColorHover?: string | undefined;
    textProjectFigures?: string | undefined;

    constructor(data?: ILandingpageUtilitiesButtons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.backgroundColorHover = _data["backgroundColorHover"];
            this.textColor = _data["textColor"];
            this.textColorHover = _data["textColorHover"];
            this.textProjectFigures = _data["textProjectFigures"];
        }
    }

    static fromJS(data: any): LandingpageUtilitiesButtons {
        data = typeof data === 'object' ? data : {};
        let result = new LandingpageUtilitiesButtons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["backgroundColorHover"] = this.backgroundColorHover;
        data["textColor"] = this.textColor;
        data["textColorHover"] = this.textColorHover;
        data["textProjectFigures"] = this.textProjectFigures;
        return data;
    }
}

export interface ILandingpageUtilitiesButtons {
    backgroundColor?: string | undefined;
    backgroundColorHover?: string | undefined;
    textColor?: string | undefined;
    textColorHover?: string | undefined;
    textProjectFigures?: string | undefined;
}

export class Listbox implements IListbox {
    colorScheme?: ColorSchemeListbox;

    constructor(data?: IListbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeListbox.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Listbox {
        data = typeof data === 'object' ? data : {};
        let result = new Listbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IListbox {
    colorScheme?: ColorSchemeListbox;
}

export class LoginBackground implements ILoginBackground {
    color?: string | undefined;

    constructor(data?: ILoginBackground) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): LoginBackground {
        data = typeof data === 'object' ? data : {};
        let result = new LoginBackground();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface ILoginBackground {
    color?: string | undefined;
}

export class LoginButton implements ILoginButton {
    backgroundColor?: string | undefined;
    backgroundColorHover?: string | undefined;
    textColor?: string | undefined;

    constructor(data?: ILoginButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.backgroundColorHover = _data["backgroundColorHover"];
            this.textColor = _data["textColor"];
        }
    }

    static fromJS(data: any): LoginButton {
        data = typeof data === 'object' ? data : {};
        let result = new LoginButton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["backgroundColorHover"] = this.backgroundColorHover;
        data["textColor"] = this.textColor;
        return data;
    }
}

export interface ILoginButton {
    backgroundColor?: string | undefined;
    backgroundColorHover?: string | undefined;
    textColor?: string | undefined;
}

export class LoginScreen implements ILoginScreen {
    loginButton?: LoginButton;
    loginBackground?: LoginBackground;
    loginSignin?: LoginSignin;
    loginText?: LoginText;
    textColor?: string | undefined;

    constructor(data?: ILoginScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginButton = _data["loginButton"] ? LoginButton.fromJS(_data["loginButton"]) : undefined as any;
            this.loginBackground = _data["loginBackground"] ? LoginBackground.fromJS(_data["loginBackground"]) : undefined as any;
            this.loginSignin = _data["loginSignin"] ? LoginSignin.fromJS(_data["loginSignin"]) : undefined as any;
            this.loginText = _data["loginText"] ? LoginText.fromJS(_data["loginText"]) : undefined as any;
            this.textColor = _data["textColor"];
        }
    }

    static fromJS(data: any): LoginScreen {
        data = typeof data === 'object' ? data : {};
        let result = new LoginScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginButton"] = this.loginButton ? this.loginButton.toJSON() : undefined as any;
        data["loginBackground"] = this.loginBackground ? this.loginBackground.toJSON() : undefined as any;
        data["loginSignin"] = this.loginSignin ? this.loginSignin.toJSON() : undefined as any;
        data["loginText"] = this.loginText ? this.loginText.toJSON() : undefined as any;
        data["textColor"] = this.textColor;
        return data;
    }
}

export interface ILoginScreen {
    loginButton?: LoginButton;
    loginBackground?: LoginBackground;
    loginSignin?: LoginSignin;
    loginText?: LoginText;
    textColor?: string | undefined;
}

export class LoginSignin implements ILoginSignin {
    color?: string | undefined;

    constructor(data?: ILoginSignin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): LoginSignin {
        data = typeof data === 'object' ? data : {};
        let result = new LoginSignin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface ILoginSignin {
    color?: string | undefined;
}

export class LoginText implements ILoginText {
    color?: string | undefined;

    constructor(data?: ILoginText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): LoginText {
        data = typeof data === 'object' ? data : {};
        let result = new LoginText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface ILoginText {
    color?: string | undefined;
}

export class MaterialCompareItem implements IMaterialCompareItem {
    id?: string;
    materialName?: string | undefined;
    primaryDataset?: string | undefined;
    climateChange?: number | undefined;
    waterFreshWaterConsumption?: number | undefined;

    constructor(data?: IMaterialCompareItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialName = _data["materialName"];
            this.primaryDataset = _data["primaryDataset"];
            this.climateChange = _data["climateChange"];
            this.waterFreshWaterConsumption = _data["waterFreshWaterConsumption"];
        }
    }

    static fromJS(data: any): MaterialCompareItem {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCompareItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialName"] = this.materialName;
        data["primaryDataset"] = this.primaryDataset;
        data["climateChange"] = this.climateChange;
        data["waterFreshWaterConsumption"] = this.waterFreshWaterConsumption;
        return data;
    }
}

export interface IMaterialCompareItem {
    id?: string;
    materialName?: string | undefined;
    primaryDataset?: string | undefined;
    climateChange?: number | undefined;
    waterFreshWaterConsumption?: number | undefined;
}

export class MaterialDataBrowseItem implements IMaterialDataBrowseItem {
    id?: string;
    materialTypeName?: string | undefined;
    materialName?: string | undefined;
    cas?: string | undefined;
    primaryDataset?: string | undefined;
    dataQualityScore?: number | undefined;

    constructor(data?: IMaterialDataBrowseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialTypeName = _data["materialTypeName"];
            this.materialName = _data["materialName"];
            this.cas = _data["cas"];
            this.primaryDataset = _data["primaryDataset"];
            this.dataQualityScore = _data["dataQualityScore"];
        }
    }

    static fromJS(data: any): MaterialDataBrowseItem {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDataBrowseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialTypeName"] = this.materialTypeName;
        data["materialName"] = this.materialName;
        data["cas"] = this.cas;
        data["primaryDataset"] = this.primaryDataset;
        data["dataQualityScore"] = this.dataQualityScore;
        return data;
    }
}

export interface IMaterialDataBrowseItem {
    id?: string;
    materialTypeName?: string | undefined;
    materialName?: string | undefined;
    cas?: string | undefined;
    primaryDataset?: string | undefined;
    dataQualityScore?: number | undefined;
}

export class MaterialScreenInconsistencyRecord implements IMaterialScreenInconsistencyRecord {
    materialScreenId?: string;
    materialId?: string;
    materialName?: string | undefined;
    materialTypeId?: string;
    materialTypeName?: string | undefined;
    screenId?: string;
    screenName?: string | undefined;
    isAllowedByMaterialType?: boolean;
    allowedScreensForMaterialType?: string[] | undefined;
    hasIssue?: boolean;
    recommendedAction?: string | undefined;

    constructor(data?: IMaterialScreenInconsistencyRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialScreenId = _data["materialScreenId"];
            this.materialId = _data["materialId"];
            this.materialName = _data["materialName"];
            this.materialTypeId = _data["materialTypeId"];
            this.materialTypeName = _data["materialTypeName"];
            this.screenId = _data["screenId"];
            this.screenName = _data["screenName"];
            this.isAllowedByMaterialType = _data["isAllowedByMaterialType"];
            if (Array.isArray(_data["allowedScreensForMaterialType"])) {
                this.allowedScreensForMaterialType = [] as any;
                for (let item of _data["allowedScreensForMaterialType"])
                    this.allowedScreensForMaterialType!.push(item);
            }
            this.hasIssue = _data["hasIssue"];
            this.recommendedAction = _data["recommendedAction"];
        }
    }

    static fromJS(data: any): MaterialScreenInconsistencyRecord {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialScreenInconsistencyRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialScreenId"] = this.materialScreenId;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialTypeId"] = this.materialTypeId;
        data["materialTypeName"] = this.materialTypeName;
        data["screenId"] = this.screenId;
        data["screenName"] = this.screenName;
        data["isAllowedByMaterialType"] = this.isAllowedByMaterialType;
        if (Array.isArray(this.allowedScreensForMaterialType)) {
            data["allowedScreensForMaterialType"] = [];
            for (let item of this.allowedScreensForMaterialType)
                data["allowedScreensForMaterialType"].push(item);
        }
        data["hasIssue"] = this.hasIssue;
        data["recommendedAction"] = this.recommendedAction;
        return data;
    }
}

export interface IMaterialScreenInconsistencyRecord {
    materialScreenId?: string;
    materialId?: string;
    materialName?: string | undefined;
    materialTypeId?: string;
    materialTypeName?: string | undefined;
    screenId?: string;
    screenName?: string | undefined;
    isAllowedByMaterialType?: boolean;
    allowedScreensForMaterialType?: string[] | undefined;
    hasIssue?: boolean;
    recommendedAction?: string | undefined;
}

export class MaterialScreenInconsistencyResponse implements IMaterialScreenInconsistencyResponse {
    totalRecords?: number;
    recordsWithIssues?: number;
    records?: MaterialScreenInconsistencyRecord[] | undefined;

    constructor(data?: IMaterialScreenInconsistencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            this.recordsWithIssues = _data["recordsWithIssues"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(MaterialScreenInconsistencyRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialScreenInconsistencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialScreenInconsistencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        data["recordsWithIssues"] = this.recordsWithIssues;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMaterialScreenInconsistencyResponse {
    totalRecords?: number;
    recordsWithIssues?: number;
    records?: MaterialScreenInconsistencyRecord[] | undefined;
}

export class MenuUp implements IMenuUp {
    backgroundColor?: string | undefined;
    borderBottom?: string | undefined;
    textColor?: string | undefined;
    buttonColor?: string | undefined;
    buttonColorHover?: string | undefined;

    constructor(data?: IMenuUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.borderBottom = _data["borderBottom"];
            this.textColor = _data["textColor"];
            this.buttonColor = _data["buttonColor"];
            this.buttonColorHover = _data["buttonColorHover"];
        }
    }

    static fromJS(data: any): MenuUp {
        data = typeof data === 'object' ? data : {};
        let result = new MenuUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["borderBottom"] = this.borderBottom;
        data["textColor"] = this.textColor;
        data["buttonColor"] = this.buttonColor;
        data["buttonColorHover"] = this.buttonColorHover;
        return data;
    }
}

export interface IMenuUp {
    backgroundColor?: string | undefined;
    borderBottom?: string | undefined;
    textColor?: string | undefined;
    buttonColor?: string | undefined;
    buttonColorHover?: string | undefined;
}

export class Message implements IMessage {
    colorScheme?: ColorSchemeMessage;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeMessage.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IMessage {
    colorScheme?: ColorSchemeMessage;
}

export class MessageSeverity implements IMessageSeverity {
    background?: string | undefined;
    color?: string | undefined;
    borderColor?: string | undefined;

    constructor(data?: IMessageSeverity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
            this.color = _data["color"];
            this.borderColor = _data["borderColor"];
        }
    }

    static fromJS(data: any): MessageSeverity {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSeverity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        data["color"] = this.color;
        data["borderColor"] = this.borderColor;
        return data;
    }
}

export interface IMessageSeverity {
    background?: string | undefined;
    color?: string | undefined;
    borderColor?: string | undefined;
}

export class MessageState implements IMessageState {
    info?: MessageSeverity;
    success?: MessageSeverity;
    warn?: MessageSeverity;
    error?: MessageSeverity;

    constructor(data?: IMessageState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] ? MessageSeverity.fromJS(_data["info"]) : undefined as any;
            this.success = _data["success"] ? MessageSeverity.fromJS(_data["success"]) : undefined as any;
            this.warn = _data["warn"] ? MessageSeverity.fromJS(_data["warn"]) : undefined as any;
            this.error = _data["error"] ? MessageSeverity.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): MessageState {
        data = typeof data === 'object' ? data : {};
        let result = new MessageState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info ? this.info.toJSON() : undefined as any;
        data["success"] = this.success ? this.success.toJSON() : undefined as any;
        data["warn"] = this.warn ? this.warn.toJSON() : undefined as any;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IMessageState {
    info?: MessageSeverity;
    success?: MessageSeverity;
    warn?: MessageSeverity;
    error?: MessageSeverity;
}

export class Multiselect implements IMultiselect {
    colorScheme?: ColorSchemeMultiselect;

    constructor(data?: IMultiselect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeMultiselect.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Multiselect {
        data = typeof data === 'object' ? data : {};
        let result = new Multiselect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IMultiselect {
    colorScheme?: ColorSchemeMultiselect;
}

export class OktaSyncResponse implements IOktaSyncResponse {
    success?: boolean;
    message?: string | undefined;
    totalUsers?: number;
    usersFound?: number;
    usersNotFound?: number;
    usersUpdated?: number;
    usersCreated?: number;
    errors?: string[] | undefined;

    constructor(data?: IOktaSyncResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.totalUsers = _data["totalUsers"];
            this.usersFound = _data["usersFound"];
            this.usersNotFound = _data["usersNotFound"];
            this.usersUpdated = _data["usersUpdated"];
            this.usersCreated = _data["usersCreated"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): OktaSyncResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OktaSyncResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["totalUsers"] = this.totalUsers;
        data["usersFound"] = this.usersFound;
        data["usersNotFound"] = this.usersNotFound;
        data["usersUpdated"] = this.usersUpdated;
        data["usersCreated"] = this.usersCreated;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IOktaSyncResponse {
    success?: boolean;
    message?: string | undefined;
    totalUsers?: number;
    usersFound?: number;
    usersNotFound?: number;
    usersUpdated?: number;
    usersCreated?: number;
    errors?: string[] | undefined;
}

export class OktaUserStatusResponse implements IOktaUserStatusResponse {
    personId?: string;
    oktaUserId?: string | undefined;
    oktaStatus?: string | undefined;
    lastSyncTimestamp?: Date | undefined;
    invitationSentTimestamp?: Date | undefined;
    isInOkta?: boolean;

    constructor(data?: IOktaUserStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.oktaUserId = _data["oktaUserId"];
            this.oktaStatus = _data["oktaStatus"];
            this.lastSyncTimestamp = _data["lastSyncTimestamp"] ? new Date(_data["lastSyncTimestamp"].toString()) : undefined as any;
            this.invitationSentTimestamp = _data["invitationSentTimestamp"] ? new Date(_data["invitationSentTimestamp"].toString()) : undefined as any;
            this.isInOkta = _data["isInOkta"];
        }
    }

    static fromJS(data: any): OktaUserStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OktaUserStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["oktaUserId"] = this.oktaUserId;
        data["oktaStatus"] = this.oktaStatus;
        data["lastSyncTimestamp"] = this.lastSyncTimestamp ? this.lastSyncTimestamp.toISOString() : undefined as any;
        data["invitationSentTimestamp"] = this.invitationSentTimestamp ? this.invitationSentTimestamp.toISOString() : undefined as any;
        data["isInOkta"] = this.isInOkta;
        return data;
    }
}

export interface IOktaUserStatusResponse {
    personId?: string;
    oktaUserId?: string | undefined;
    oktaStatus?: string | undefined;
    lastSyncTimestamp?: Date | undefined;
    invitationSentTimestamp?: Date | undefined;
    isInOkta?: boolean;
}

export class Option implements IOption {
    selectedFocusBackground?: string | undefined;
    selectedFocusColor?: string | undefined;
    selectedBackground?: string | undefined;
    selectedColor?: string | undefined;
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;

    constructor(data?: IOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedFocusBackground = _data["selectedFocusBackground"];
            this.selectedFocusColor = _data["selectedFocusColor"];
            this.selectedBackground = _data["selectedBackground"];
            this.selectedColor = _data["selectedColor"];
            this.hoverBackground = _data["hoverBackground"];
            this.hoverColor = _data["hoverColor"];
        }
    }

    static fromJS(data: any): Option {
        data = typeof data === 'object' ? data : {};
        let result = new Option();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedFocusBackground"] = this.selectedFocusBackground;
        data["selectedFocusColor"] = this.selectedFocusColor;
        data["selectedBackground"] = this.selectedBackground;
        data["selectedColor"] = this.selectedColor;
        data["hoverBackground"] = this.hoverBackground;
        data["hoverColor"] = this.hoverColor;
        return data;
    }
}

export interface IOption {
    selectedFocusBackground?: string | undefined;
    selectedFocusColor?: string | undefined;
    selectedBackground?: string | undefined;
    selectedColor?: string | undefined;
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
}

export class OutputEolCF implements IOutputEolCF {
    id?: number;
    materialId?: string | undefined;
    processWasteDetailName?: string | undefined;
    materialName?: string | undefined;
    referenceQuantity?: number;
    totalMass?: number;
    sterilizationBeforeDisposal?: boolean;
    sterilizationImpact?: number | undefined;
    hazardWasteIncineration?: number | undefined;
    landfill?: number;
    recycling?: number;
    wasteIncinerationEnergyRecovery?: number;
    wasteIncinerationNoEnergyRecovery?: number | undefined;
    totalWaste?: number | undefined;
    sterilizationImpactW?: number | undefined;
    hazardWasteIncinerationW?: number | undefined;
    landfillW?: number;
    recyclingW?: number;
    wasteIncinerationEnergyRecoveryW?: number;
    wasteIncinerationNoEnergyRecoveryW?: number | undefined;
    totalWasteW?: number | undefined;
    sterilizationImpactCG?: number | undefined;
    hazardWasteIncinerationCG?: number | undefined;
    landfillCG?: number;
    recyclingCG?: number;
    wasteIncinerationEnergyRecoveryCG?: number;
    wasteIncinerationNoEnergyRecoveryCG?: number | undefined;
    totalWasteCG?: number | undefined;

    constructor(data?: IOutputEolCF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialId = _data["materialId"];
            this.processWasteDetailName = _data["processWasteDetailName"];
            this.materialName = _data["materialName"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.totalMass = _data["totalMass"];
            this.sterilizationBeforeDisposal = _data["sterilizationBeforeDisposal"];
            this.sterilizationImpact = _data["sterilizationImpact"];
            this.hazardWasteIncineration = _data["hazardWasteIncineration"];
            this.landfill = _data["landfill"];
            this.recycling = _data["recycling"];
            this.wasteIncinerationEnergyRecovery = _data["wasteIncinerationEnergyRecovery"];
            this.wasteIncinerationNoEnergyRecovery = _data["wasteIncinerationNoEnergyRecovery"];
            this.totalWaste = _data["totalWaste"];
            this.sterilizationImpactW = _data["sterilizationImpactW"];
            this.hazardWasteIncinerationW = _data["hazardWasteIncinerationW"];
            this.landfillW = _data["landfillW"];
            this.recyclingW = _data["recyclingW"];
            this.wasteIncinerationEnergyRecoveryW = _data["wasteIncinerationEnergyRecoveryW"];
            this.wasteIncinerationNoEnergyRecoveryW = _data["wasteIncinerationNoEnergyRecoveryW"];
            this.totalWasteW = _data["totalWasteW"];
            this.sterilizationImpactCG = _data["sterilizationImpactCG"];
            this.hazardWasteIncinerationCG = _data["hazardWasteIncinerationCG"];
            this.landfillCG = _data["landfillCG"];
            this.recyclingCG = _data["recyclingCG"];
            this.wasteIncinerationEnergyRecoveryCG = _data["wasteIncinerationEnergyRecoveryCG"];
            this.wasteIncinerationNoEnergyRecoveryCG = _data["wasteIncinerationNoEnergyRecoveryCG"];
            this.totalWasteCG = _data["totalWasteCG"];
        }
    }

    static fromJS(data: any): OutputEolCF {
        data = typeof data === 'object' ? data : {};
        let result = new OutputEolCF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["processWasteDetailName"] = this.processWasteDetailName;
        data["materialName"] = this.materialName;
        data["referenceQuantity"] = this.referenceQuantity;
        data["totalMass"] = this.totalMass;
        data["sterilizationBeforeDisposal"] = this.sterilizationBeforeDisposal;
        data["sterilizationImpact"] = this.sterilizationImpact;
        data["hazardWasteIncineration"] = this.hazardWasteIncineration;
        data["landfill"] = this.landfill;
        data["recycling"] = this.recycling;
        data["wasteIncinerationEnergyRecovery"] = this.wasteIncinerationEnergyRecovery;
        data["wasteIncinerationNoEnergyRecovery"] = this.wasteIncinerationNoEnergyRecovery;
        data["totalWaste"] = this.totalWaste;
        data["sterilizationImpactW"] = this.sterilizationImpactW;
        data["hazardWasteIncinerationW"] = this.hazardWasteIncinerationW;
        data["landfillW"] = this.landfillW;
        data["recyclingW"] = this.recyclingW;
        data["wasteIncinerationEnergyRecoveryW"] = this.wasteIncinerationEnergyRecoveryW;
        data["wasteIncinerationNoEnergyRecoveryW"] = this.wasteIncinerationNoEnergyRecoveryW;
        data["totalWasteW"] = this.totalWasteW;
        data["sterilizationImpactCG"] = this.sterilizationImpactCG;
        data["hazardWasteIncinerationCG"] = this.hazardWasteIncinerationCG;
        data["landfillCG"] = this.landfillCG;
        data["recyclingCG"] = this.recyclingCG;
        data["wasteIncinerationEnergyRecoveryCG"] = this.wasteIncinerationEnergyRecoveryCG;
        data["wasteIncinerationNoEnergyRecoveryCG"] = this.wasteIncinerationNoEnergyRecoveryCG;
        data["totalWasteCG"] = this.totalWasteCG;
        return data;
    }
}

export interface IOutputEolCF {
    id?: number;
    materialId?: string | undefined;
    processWasteDetailName?: string | undefined;
    materialName?: string | undefined;
    referenceQuantity?: number;
    totalMass?: number;
    sterilizationBeforeDisposal?: boolean;
    sterilizationImpact?: number | undefined;
    hazardWasteIncineration?: number | undefined;
    landfill?: number;
    recycling?: number;
    wasteIncinerationEnergyRecovery?: number;
    wasteIncinerationNoEnergyRecovery?: number | undefined;
    totalWaste?: number | undefined;
    sterilizationImpactW?: number | undefined;
    hazardWasteIncinerationW?: number | undefined;
    landfillW?: number;
    recyclingW?: number;
    wasteIncinerationEnergyRecoveryW?: number;
    wasteIncinerationNoEnergyRecoveryW?: number | undefined;
    totalWasteW?: number | undefined;
    sterilizationImpactCG?: number | undefined;
    hazardWasteIncinerationCG?: number | undefined;
    landfillCG?: number;
    recyclingCG?: number;
    wasteIncinerationEnergyRecoveryCG?: number;
    wasteIncinerationNoEnergyRecoveryCG?: number | undefined;
    totalWasteCG?: number | undefined;
}

export class OutputMaterials implements IOutputMaterials {
    id?: number;
    rawMaterialType?: string | undefined;
    typeOfCalculation?: string | undefined;
    materialId?: string;
    materialName?: string | undefined;
    componentName?: string | undefined;
    materialCarbonfootprint?: number | undefined;
    referenceQuantity?: number;
    packagingType?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    total?: number | undefined;

    constructor(data?: IOutputMaterials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rawMaterialType = _data["rawMaterialType"];
            this.typeOfCalculation = _data["typeOfCalculation"];
            this.materialId = _data["materialId"];
            this.materialName = _data["materialName"];
            this.componentName = _data["componentName"];
            this.materialCarbonfootprint = _data["materialCarbonfootprint"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.packagingType = _data["packagingType"];
            this.carbonFootPrint = _data["carbonFootPrint"];
            this.waterConsumption = _data["waterConsumption"];
            this.costOfGoods = _data["costOfGoods"];
            this.pmi = _data["pmi"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): OutputMaterials {
        data = typeof data === 'object' ? data : {};
        let result = new OutputMaterials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rawMaterialType"] = this.rawMaterialType;
        data["typeOfCalculation"] = this.typeOfCalculation;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["componentName"] = this.componentName;
        data["materialCarbonfootprint"] = this.materialCarbonfootprint;
        data["referenceQuantity"] = this.referenceQuantity;
        data["packagingType"] = this.packagingType;
        data["carbonFootPrint"] = this.carbonFootPrint;
        data["waterConsumption"] = this.waterConsumption;
        data["costOfGoods"] = this.costOfGoods;
        data["pmi"] = this.pmi;
        data["total"] = this.total;
        return data;
    }
}

export interface IOutputMaterials {
    id?: number;
    rawMaterialType?: string | undefined;
    typeOfCalculation?: string | undefined;
    materialId?: string;
    materialName?: string | undefined;
    componentName?: string | undefined;
    materialCarbonfootprint?: number | undefined;
    referenceQuantity?: number;
    packagingType?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    total?: number | undefined;
}

export class OutputOutDistribution implements IOutputOutDistribution {
    id?: number;
    distanceInKm?: number;
    storageTime?: number;
    coldStorageEle?: number | undefined;
    cfpOutboundTransport?: number | undefined;
    waterConsumptionTransport?: number;
    costOfGoodTransport?: number;
    cfpWarehousing?: number;
    waterConsumptionWarehousing?: number | undefined;
    costOfGoodsWarehousing?: number | undefined;

    constructor(data?: IOutputOutDistribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.distanceInKm = _data["distanceInKm"];
            this.storageTime = _data["storageTime"];
            this.coldStorageEle = _data["coldStorageEle"];
            this.cfpOutboundTransport = _data["cfpOutboundTransport"];
            this.waterConsumptionTransport = _data["waterConsumptionTransport"];
            this.costOfGoodTransport = _data["costOfGoodTransport"];
            this.cfpWarehousing = _data["cfpWarehousing"];
            this.waterConsumptionWarehousing = _data["waterConsumptionWarehousing"];
            this.costOfGoodsWarehousing = _data["costOfGoodsWarehousing"];
        }
    }

    static fromJS(data: any): OutputOutDistribution {
        data = typeof data === 'object' ? data : {};
        let result = new OutputOutDistribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["distanceInKm"] = this.distanceInKm;
        data["storageTime"] = this.storageTime;
        data["coldStorageEle"] = this.coldStorageEle;
        data["cfpOutboundTransport"] = this.cfpOutboundTransport;
        data["waterConsumptionTransport"] = this.waterConsumptionTransport;
        data["costOfGoodTransport"] = this.costOfGoodTransport;
        data["cfpWarehousing"] = this.cfpWarehousing;
        data["waterConsumptionWarehousing"] = this.waterConsumptionWarehousing;
        data["costOfGoodsWarehousing"] = this.costOfGoodsWarehousing;
        return data;
    }
}

export interface IOutputOutDistribution {
    id?: number;
    distanceInKm?: number;
    storageTime?: number;
    coldStorageEle?: number | undefined;
    cfpOutboundTransport?: number | undefined;
    waterConsumptionTransport?: number;
    costOfGoodTransport?: number;
    cfpWarehousing?: number;
    waterConsumptionWarehousing?: number | undefined;
    costOfGoodsWarehousing?: number | undefined;
}

export class Overlay implements IOverlay {
    color?: string | undefined;
    background?: string | undefined;

    constructor(data?: IOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
            this.background = _data["background"];
        }
    }

    static fromJS(data: any): Overlay {
        data = typeof data === 'object' ? data : {};
        let result = new Overlay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["background"] = this.background;
        return data;
    }
}

export interface IOverlay {
    color?: string | undefined;
    background?: string | undefined;
}

export class PersonSessionData implements IPersonSessionData {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    screens?: UserTypeScreen[] | undefined;
    screenAccess?: FinalAccessStatus[] | undefined;
    role?: string | undefined;

    constructor(data?: IPersonSessionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.isAdmin = _data["isAdmin"];
            if (Array.isArray(_data["screens"])) {
                this.screens = [] as any;
                for (let item of _data["screens"])
                    this.screens!.push(UserTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["screenAccess"])) {
                this.screenAccess = [] as any;
                for (let item of _data["screenAccess"])
                    this.screenAccess!.push(FinalAccessStatus.fromJS(item));
            }
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): PersonSessionData {
        data = typeof data === 'object' ? data : {};
        let result = new PersonSessionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["isAdmin"] = this.isAdmin;
        if (Array.isArray(this.screens)) {
            data["screens"] = [];
            for (let item of this.screens)
                data["screens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenAccess)) {
            data["screenAccess"] = [];
            for (let item of this.screenAccess)
                data["screenAccess"].push(item ? item.toJSON() : undefined as any);
        }
        data["role"] = this.role;
        return data;
    }
}

export interface IPersonSessionData {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    screens?: UserTypeScreen[] | undefined;
    screenAccess?: FinalAccessStatus[] | undefined;
    role?: string | undefined;
}

export class PptVivaExportRequest implements IPptVivaExportRequest {
    reportConfigurationId?: string;
    includeDashboard?: boolean;
    includeRadarChart?: boolean;
    includeRelatableImpact?: boolean;
    includeImpactCategory?: boolean;
    includePackagingEfficiency?: boolean;
    includeLifecycleSections?: boolean;
    includeLifecycleCharts?: boolean;
    includeLifecycleTables?: boolean;

    constructor(data?: IPptVivaExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportConfigurationId = _data["reportConfigurationId"];
            this.includeDashboard = _data["includeDashboard"];
            this.includeRadarChart = _data["includeRadarChart"];
            this.includeRelatableImpact = _data["includeRelatableImpact"];
            this.includeImpactCategory = _data["includeImpactCategory"];
            this.includePackagingEfficiency = _data["includePackagingEfficiency"];
            this.includeLifecycleSections = _data["includeLifecycleSections"];
            this.includeLifecycleCharts = _data["includeLifecycleCharts"];
            this.includeLifecycleTables = _data["includeLifecycleTables"];
        }
    }

    static fromJS(data: any): PptVivaExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PptVivaExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportConfigurationId"] = this.reportConfigurationId;
        data["includeDashboard"] = this.includeDashboard;
        data["includeRadarChart"] = this.includeRadarChart;
        data["includeRelatableImpact"] = this.includeRelatableImpact;
        data["includeImpactCategory"] = this.includeImpactCategory;
        data["includePackagingEfficiency"] = this.includePackagingEfficiency;
        data["includeLifecycleSections"] = this.includeLifecycleSections;
        data["includeLifecycleCharts"] = this.includeLifecycleCharts;
        data["includeLifecycleTables"] = this.includeLifecycleTables;
        return data;
    }
}

export interface IPptVivaExportRequest {
    reportConfigurationId?: string;
    includeDashboard?: boolean;
    includeRadarChart?: boolean;
    includeRelatableImpact?: boolean;
    includeImpactCategory?: boolean;
    includePackagingEfficiency?: boolean;
    includeLifecycleSections?: boolean;
    includeLifecycleCharts?: boolean;
    includeLifecycleTables?: boolean;
}

export class PreviewAlternativeDto implements IPreviewAlternativeDto {
    label?: string | undefined;
    formatName?: string | undefined;

    constructor(data?: IPreviewAlternativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.formatName = _data["formatName"];
        }
    }

    static fromJS(data: any): PreviewAlternativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewAlternativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["formatName"] = this.formatName;
        return data;
    }
}

export interface IPreviewAlternativeDto {
    label?: string | undefined;
    formatName?: string | undefined;
}

export class PreviewImpactCategoryRowDto implements IPreviewImpactCategoryRowDto {
    categoryName?: string | undefined;
    unit?: string | undefined;
    values?: number[] | undefined;
    diffFromBaseline?: number[] | undefined;
    percentDiff?: number[] | undefined;
    bestIndex?: number;
    lowerIsBetter?: boolean;

    constructor(data?: IPreviewImpactCategoryRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            this.unit = _data["unit"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["diffFromBaseline"])) {
                this.diffFromBaseline = [] as any;
                for (let item of _data["diffFromBaseline"])
                    this.diffFromBaseline!.push(item);
            }
            if (Array.isArray(_data["percentDiff"])) {
                this.percentDiff = [] as any;
                for (let item of _data["percentDiff"])
                    this.percentDiff!.push(item);
            }
            this.bestIndex = _data["bestIndex"];
            this.lowerIsBetter = _data["lowerIsBetter"];
        }
    }

    static fromJS(data: any): PreviewImpactCategoryRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewImpactCategoryRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["unit"] = this.unit;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.diffFromBaseline)) {
            data["diffFromBaseline"] = [];
            for (let item of this.diffFromBaseline)
                data["diffFromBaseline"].push(item);
        }
        if (Array.isArray(this.percentDiff)) {
            data["percentDiff"] = [];
            for (let item of this.percentDiff)
                data["percentDiff"].push(item);
        }
        data["bestIndex"] = this.bestIndex;
        data["lowerIsBetter"] = this.lowerIsBetter;
        return data;
    }
}

export interface IPreviewImpactCategoryRowDto {
    categoryName?: string | undefined;
    unit?: string | undefined;
    values?: number[] | undefined;
    diffFromBaseline?: number[] | undefined;
    percentDiff?: number[] | undefined;
    bestIndex?: number;
    lowerIsBetter?: boolean;
}

export class PreviewLifecycleSectionDto implements IPreviewLifecycleSectionDto {
    title?: string | undefined;
    unit?: string | undefined;
    categoryLabels?: string[] | undefined;
    optionLabels?: string[] | undefined;
    values?: number[][] | undefined;
    comparisonRows?: PreviewImpactCategoryRowDto[] | undefined;

    constructor(data?: IPreviewLifecycleSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.unit = _data["unit"];
            if (Array.isArray(_data["categoryLabels"])) {
                this.categoryLabels = [] as any;
                for (let item of _data["categoryLabels"])
                    this.categoryLabels!.push(item);
            }
            if (Array.isArray(_data["optionLabels"])) {
                this.optionLabels = [] as any;
                for (let item of _data["optionLabels"])
                    this.optionLabels!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["comparisonRows"])) {
                this.comparisonRows = [] as any;
                for (let item of _data["comparisonRows"])
                    this.comparisonRows!.push(PreviewImpactCategoryRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreviewLifecycleSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewLifecycleSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["unit"] = this.unit;
        if (Array.isArray(this.categoryLabels)) {
            data["categoryLabels"] = [];
            for (let item of this.categoryLabels)
                data["categoryLabels"].push(item);
        }
        if (Array.isArray(this.optionLabels)) {
            data["optionLabels"] = [];
            for (let item of this.optionLabels)
                data["optionLabels"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.comparisonRows)) {
            data["comparisonRows"] = [];
            for (let item of this.comparisonRows)
                data["comparisonRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPreviewLifecycleSectionDto {
    title?: string | undefined;
    unit?: string | undefined;
    categoryLabels?: string[] | undefined;
    optionLabels?: string[] | undefined;
    values?: number[][] | undefined;
    comparisonRows?: PreviewImpactCategoryRowDto[] | undefined;
}

export class PreviewPackagingEfficiencyRowDto implements IPreviewPackagingEfficiencyRowDto {
    metricName?: string | undefined;
    values?: number[] | undefined;
    bestIndex?: number;

    constructor(data?: IPreviewPackagingEfficiencyRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricName = _data["metricName"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.bestIndex = _data["bestIndex"];
        }
    }

    static fromJS(data: any): PreviewPackagingEfficiencyRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewPackagingEfficiencyRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricName"] = this.metricName;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["bestIndex"] = this.bestIndex;
        return data;
    }
}

export interface IPreviewPackagingEfficiencyRowDto {
    metricName?: string | undefined;
    values?: number[] | undefined;
    bestIndex?: number;
}

export class PreviewRadarChartDto implements IPreviewRadarChartDto {
    labels?: string[] | undefined;
    series?: PreviewRadarSeriesDto[] | undefined;

    constructor(data?: IPreviewRadarChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(PreviewRadarSeriesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreviewRadarChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewRadarChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPreviewRadarChartDto {
    labels?: string[] | undefined;
    series?: PreviewRadarSeriesDto[] | undefined;
}

export class PreviewRadarSeriesDto implements IPreviewRadarSeriesDto {
    label?: string | undefined;
    normalizedValues?: number[] | undefined;

    constructor(data?: IPreviewRadarSeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            if (Array.isArray(_data["normalizedValues"])) {
                this.normalizedValues = [] as any;
                for (let item of _data["normalizedValues"])
                    this.normalizedValues!.push(item);
            }
        }
    }

    static fromJS(data: any): PreviewRadarSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewRadarSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (Array.isArray(this.normalizedValues)) {
            data["normalizedValues"] = [];
            for (let item of this.normalizedValues)
                data["normalizedValues"].push(item);
        }
        return data;
    }
}

export interface IPreviewRadarSeriesDto {
    label?: string | undefined;
    normalizedValues?: number[] | undefined;
}

export class PreviewReductionHighlightDto implements IPreviewReductionHighlightDto {
    label?: string | undefined;
    icon?: string | undefined;
    value?: number;
    bestAlternativeLabel?: string | undefined;

    constructor(data?: IPreviewReductionHighlightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.icon = _data["icon"];
            this.value = _data["value"];
            this.bestAlternativeLabel = _data["bestAlternativeLabel"];
        }
    }

    static fromJS(data: any): PreviewReductionHighlightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewReductionHighlightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["icon"] = this.icon;
        data["value"] = this.value;
        data["bestAlternativeLabel"] = this.bestAlternativeLabel;
        return data;
    }
}

export interface IPreviewReductionHighlightDto {
    label?: string | undefined;
    icon?: string | undefined;
    value?: number;
    bestAlternativeLabel?: string | undefined;
}

export class PreviewRelatableUnitRowDto implements IPreviewRelatableUnitRowDto {
    emissionFactorName?: string | undefined;
    referenceActivity?: string | undefined;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    convertedValues?: number[] | undefined;
    bestIndex?: number;

    constructor(data?: IPreviewRelatableUnitRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emissionFactorName = _data["emissionFactorName"];
            this.referenceActivity = _data["referenceActivity"];
            this.referenceUnitLabel = _data["referenceUnitLabel"];
            this.iconName = _data["iconName"];
            if (Array.isArray(_data["convertedValues"])) {
                this.convertedValues = [] as any;
                for (let item of _data["convertedValues"])
                    this.convertedValues!.push(item);
            }
            this.bestIndex = _data["bestIndex"];
        }
    }

    static fromJS(data: any): PreviewRelatableUnitRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewRelatableUnitRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emissionFactorName"] = this.emissionFactorName;
        data["referenceActivity"] = this.referenceActivity;
        data["referenceUnitLabel"] = this.referenceUnitLabel;
        data["iconName"] = this.iconName;
        if (Array.isArray(this.convertedValues)) {
            data["convertedValues"] = [];
            for (let item of this.convertedValues)
                data["convertedValues"].push(item);
        }
        data["bestIndex"] = this.bestIndex;
        return data;
    }
}

export interface IPreviewRelatableUnitRowDto {
    emissionFactorName?: string | undefined;
    referenceActivity?: string | undefined;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    convertedValues?: number[] | undefined;
    bestIndex?: number;
}

export class ProcessWasteInput implements IProcessWasteInput {
    waste?: ProcessWaste;
    details?: ProcessWasteRowInTable[] | undefined;

    constructor(data?: IProcessWasteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waste = _data["waste"] ? ProcessWaste.fromJS(_data["waste"]) : undefined as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ProcessWasteRowInTable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessWasteInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWasteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waste"] = this.waste ? this.waste.toJSON() : undefined as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProcessWasteInput {
    waste?: ProcessWaste;
    details?: ProcessWasteRowInTable[] | undefined;
}

export class ProcessWasteLoading implements IProcessWasteLoading {
    waste?: ProcessWaste;
    rawMaterial?: RawMaterial;
    generalInformation?: GeneralInformation;
    allWasteRows?: ProcessWasteRowInTable[] | undefined;
    warnings?: string[] | undefined;

    constructor(data?: IProcessWasteLoading) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waste = _data["waste"] ? ProcessWaste.fromJS(_data["waste"]) : undefined as any;
            this.rawMaterial = _data["rawMaterial"] ? RawMaterial.fromJS(_data["rawMaterial"]) : undefined as any;
            this.generalInformation = _data["generalInformation"] ? GeneralInformation.fromJS(_data["generalInformation"]) : undefined as any;
            if (Array.isArray(_data["allWasteRows"])) {
                this.allWasteRows = [] as any;
                for (let item of _data["allWasteRows"])
                    this.allWasteRows!.push(ProcessWasteRowInTable.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessWasteLoading {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWasteLoading();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waste"] = this.waste ? this.waste.toJSON() : undefined as any;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : undefined as any;
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : undefined as any;
        if (Array.isArray(this.allWasteRows)) {
            data["allWasteRows"] = [];
            for (let item of this.allWasteRows)
                data["allWasteRows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface IProcessWasteLoading {
    waste?: ProcessWaste;
    rawMaterial?: RawMaterial;
    generalInformation?: GeneralInformation;
    allWasteRows?: ProcessWasteRowInTable[] | undefined;
    warnings?: string[] | undefined;
}

export class ProcessingOperationCF implements IProcessingOperationCF {
    stepId?: string;
    utilitiesId?: string;
    rawMaterialUnitOperation?: RawMaterialUnitOperation;
    steamConsumptionList?: UtilitiesSteamConsumption;
    energyConsumptionList?: UtilitiesEnergyConsumption;

    constructor(data?: IProcessingOperationCF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.utilitiesId = _data["utilitiesId"];
            this.rawMaterialUnitOperation = _data["rawMaterialUnitOperation"] ? RawMaterialUnitOperation.fromJS(_data["rawMaterialUnitOperation"]) : undefined as any;
            this.steamConsumptionList = _data["steamConsumptionList"] ? UtilitiesSteamConsumption.fromJS(_data["steamConsumptionList"]) : undefined as any;
            this.energyConsumptionList = _data["energyConsumptionList"] ? UtilitiesEnergyConsumption.fromJS(_data["energyConsumptionList"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessingOperationCF {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingOperationCF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["utilitiesId"] = this.utilitiesId;
        data["rawMaterialUnitOperation"] = this.rawMaterialUnitOperation ? this.rawMaterialUnitOperation.toJSON() : undefined as any;
        data["steamConsumptionList"] = this.steamConsumptionList ? this.steamConsumptionList.toJSON() : undefined as any;
        data["energyConsumptionList"] = this.energyConsumptionList ? this.energyConsumptionList.toJSON() : undefined as any;
        return data;
    }
}

export interface IProcessingOperationCF {
    stepId?: string;
    utilitiesId?: string;
    rawMaterialUnitOperation?: RawMaterialUnitOperation;
    steamConsumptionList?: UtilitiesSteamConsumption;
    energyConsumptionList?: UtilitiesEnergyConsumption;
}

export class ProductFormatComplianceCheckResponse implements IProductFormatComplianceCheckResponse {
    records?: ProductFormatComplianceRecord[] | undefined;
    totalRecords?: number;
    compliantRecords?: number;
    nonCompliantRecords?: number;

    constructor(data?: IProductFormatComplianceCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(ProductFormatComplianceRecord.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.compliantRecords = _data["compliantRecords"];
            this.nonCompliantRecords = _data["nonCompliantRecords"];
        }
    }

    static fromJS(data: any): ProductFormatComplianceCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFormatComplianceCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecords"] = this.totalRecords;
        data["compliantRecords"] = this.compliantRecords;
        data["nonCompliantRecords"] = this.nonCompliantRecords;
        return data;
    }
}

export interface IProductFormatComplianceCheckResponse {
    records?: ProductFormatComplianceRecord[] | undefined;
    totalRecords?: number;
    compliantRecords?: number;
    nonCompliantRecords?: number;
}

export class ProductFormatComplianceRecord implements IProductFormatComplianceRecord {
    generalInformationId?: string;
    projectName?: string | undefined;
    subProjectName?: string | undefined;
    assessmentName?: string | undefined;
    stepName?: string | undefined;
    productFormatId?: string | undefined;
    productFormatName?: string | undefined;
    massPerProductFormat?: number | undefined;
    massPerProductFormatUnitId?: string | undefined;
    massPerProductFormatUnitName?: string | undefined;
    isCompliant?: boolean;
    screenName?: string | undefined;
    screenId?: string | undefined;
    assessmentId?: string | undefined;
    subProjectId?: string;
    projectId?: string;

    constructor(data?: IProductFormatComplianceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalInformationId = _data["generalInformationId"];
            this.projectName = _data["projectName"];
            this.subProjectName = _data["subProjectName"];
            this.assessmentName = _data["assessmentName"];
            this.stepName = _data["stepName"];
            this.productFormatId = _data["productFormatId"];
            this.productFormatName = _data["productFormatName"];
            this.massPerProductFormat = _data["massPerProductFormat"];
            this.massPerProductFormatUnitId = _data["massPerProductFormatUnitId"];
            this.massPerProductFormatUnitName = _data["massPerProductFormatUnitName"];
            this.isCompliant = _data["isCompliant"];
            this.screenName = _data["screenName"];
            this.screenId = _data["screenId"];
            this.assessmentId = _data["assessmentId"];
            this.subProjectId = _data["subProjectId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProductFormatComplianceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFormatComplianceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalInformationId"] = this.generalInformationId;
        data["projectName"] = this.projectName;
        data["subProjectName"] = this.subProjectName;
        data["assessmentName"] = this.assessmentName;
        data["stepName"] = this.stepName;
        data["productFormatId"] = this.productFormatId;
        data["productFormatName"] = this.productFormatName;
        data["massPerProductFormat"] = this.massPerProductFormat;
        data["massPerProductFormatUnitId"] = this.massPerProductFormatUnitId;
        data["massPerProductFormatUnitName"] = this.massPerProductFormatUnitName;
        data["isCompliant"] = this.isCompliant;
        data["screenName"] = this.screenName;
        data["screenId"] = this.screenId;
        data["assessmentId"] = this.assessmentId;
        data["subProjectId"] = this.subProjectId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProductFormatComplianceRecord {
    generalInformationId?: string;
    projectName?: string | undefined;
    subProjectName?: string | undefined;
    assessmentName?: string | undefined;
    stepName?: string | undefined;
    productFormatId?: string | undefined;
    productFormatName?: string | undefined;
    massPerProductFormat?: number | undefined;
    massPerProductFormatUnitId?: string | undefined;
    massPerProductFormatUnitName?: string | undefined;
    isCompliant?: boolean;
    screenName?: string | undefined;
    screenId?: string | undefined;
    assessmentId?: string | undefined;
    subProjectId?: string;
    projectId?: string;
}

export class ProductFormatUsageCheckResponse implements IProductFormatUsageCheckResponse {
    isInUse?: boolean;
    usageCount?: number;
    formatName?: string | undefined;

    constructor(data?: IProductFormatUsageCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInUse = _data["isInUse"];
            this.usageCount = _data["usageCount"];
            this.formatName = _data["formatName"];
        }
    }

    static fromJS(data: any): ProductFormatUsageCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFormatUsageCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInUse"] = this.isInUse;
        data["usageCount"] = this.usageCount;
        data["formatName"] = this.formatName;
        return data;
    }
}

export interface IProductFormatUsageCheckResponse {
    isInUse?: boolean;
    usageCount?: number;
    formatName?: string | undefined;
}

export class Progressbar implements IProgressbar {
    colorScheme?: ColorSchemeProgressbar;

    constructor(data?: IProgressbar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeProgressbar.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Progressbar {
        data = typeof data === 'object' ? data : {};
        let result = new Progressbar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IProgressbar {
    colorScheme?: ColorSchemeProgressbar;
}

export class ProgressbarState implements IProgressbarState {
    background?: string | undefined;
    value?: ProgressbarValue;

    constructor(data?: IProgressbarState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
            this.value = _data["value"] ? ProgressbarValue.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProgressbarState {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressbarState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProgressbarState {
    background?: string | undefined;
    value?: ProgressbarValue;
}

export class ProgressbarValue implements IProgressbarValue {
    background?: string | undefined;

    constructor(data?: IProgressbarValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
        }
    }

    static fromJS(data: any): ProgressbarValue {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressbarValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        return data;
    }
}

export interface IProgressbarValue {
    background?: string | undefined;
}

export class ProviderHealthCheckResponse implements IProviderHealthCheckResponse {
    connected?: boolean;
    provider?: string | undefined;
    message?: string | undefined;

    constructor(data?: IProviderHealthCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connected = _data["connected"];
            this.provider = _data["provider"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ProviderHealthCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderHealthCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connected"] = this.connected;
        data["provider"] = this.provider;
        data["message"] = this.message;
        return data;
    }
}

export interface IProviderHealthCheckResponse {
    connected?: boolean;
    provider?: string | undefined;
    message?: string | undefined;
}

export class Radiobutton implements IRadiobutton {
    colorScheme?: ColorSchemeRadiobutton;

    constructor(data?: IRadiobutton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeRadiobutton.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Radiobutton {
        data = typeof data === 'object' ? data : {};
        let result = new Radiobutton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IRadiobutton {
    colorScheme?: ColorSchemeRadiobutton;
}

export class RadiobuttonRoot implements IRadiobuttonRoot {
    checkedBackground?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;
    borderColor?: string | undefined;
    checkedBorderColor?: string | undefined;

    constructor(data?: IRadiobuttonRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkedBackground = _data["checkedBackground"];
            this.background = _data["background"];
            this.hoverBackground = _data["hoverBackground"];
            this.borderColor = _data["borderColor"];
            this.checkedBorderColor = _data["checkedBorderColor"];
        }
    }

    static fromJS(data: any): RadiobuttonRoot {
        data = typeof data === 'object' ? data : {};
        let result = new RadiobuttonRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkedBackground"] = this.checkedBackground;
        data["background"] = this.background;
        data["hoverBackground"] = this.hoverBackground;
        data["borderColor"] = this.borderColor;
        data["checkedBorderColor"] = this.checkedBorderColor;
        return data;
    }
}

export interface IRadiobuttonRoot {
    checkedBackground?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;
    borderColor?: string | undefined;
    checkedBorderColor?: string | undefined;
}

export class RadiobuttonState implements IRadiobuttonState {
    root?: RadiobuttonRoot;

    constructor(data?: IRadiobuttonState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? RadiobuttonRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): RadiobuttonState {
        data = typeof data === 'object' ? data : {};
        let result = new RadiobuttonState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface IRadiobuttonState {
    root?: RadiobuttonRoot;
}

export class RelatableUnitAdminReadModel implements IRelatableUnitAdminReadModel {
    id?: string;
    emissionFactorId?: string;
    emissionFactorName?: string | undefined;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IRelatableUnitAdminReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.emissionFactorName = _data["emissionFactorName"];
            this.referenceActivity = _data["referenceActivity"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.referenceUnitLabel = _data["referenceUnitLabel"];
            this.iconName = _data["iconName"];
            this.thresholdLow = _data["thresholdLow"];
            this.thresholdHigh = _data["thresholdHigh"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RelatableUnitAdminReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new RelatableUnitAdminReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emissionFactorId"] = this.emissionFactorId;
        data["emissionFactorName"] = this.emissionFactorName;
        data["referenceActivity"] = this.referenceActivity;
        data["referenceQuantity"] = this.referenceQuantity;
        data["referenceUnitLabel"] = this.referenceUnitLabel;
        data["iconName"] = this.iconName;
        data["thresholdLow"] = this.thresholdLow;
        data["thresholdHigh"] = this.thresholdHigh;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRelatableUnitAdminReadModel {
    id?: string;
    emissionFactorId?: string;
    emissionFactorName?: string | undefined;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;
}

export class RelatableUnitReadModel implements IRelatableUnitReadModel {
    id?: string;
    emissionFactorId?: string;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IRelatableUnitReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.referenceActivity = _data["referenceActivity"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.referenceUnitLabel = _data["referenceUnitLabel"];
            this.iconName = _data["iconName"];
            this.thresholdLow = _data["thresholdLow"];
            this.thresholdHigh = _data["thresholdHigh"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RelatableUnitReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new RelatableUnitReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emissionFactorId"] = this.emissionFactorId;
        data["referenceActivity"] = this.referenceActivity;
        data["referenceQuantity"] = this.referenceQuantity;
        data["referenceUnitLabel"] = this.referenceUnitLabel;
        data["iconName"] = this.iconName;
        data["thresholdLow"] = this.thresholdLow;
        data["thresholdHigh"] = this.thresholdHigh;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRelatableUnitReadModel {
    id?: string;
    emissionFactorId?: string;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;
}

export class RelatableUnitSaveRequest implements IRelatableUnitSaveRequest {
    id?: string;
    emissionFactorId?: string;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IRelatableUnitSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.referenceActivity = _data["referenceActivity"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.referenceUnitLabel = _data["referenceUnitLabel"];
            this.iconName = _data["iconName"];
            this.thresholdLow = _data["thresholdLow"];
            this.thresholdHigh = _data["thresholdHigh"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RelatableUnitSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RelatableUnitSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emissionFactorId"] = this.emissionFactorId;
        data["referenceActivity"] = this.referenceActivity;
        data["referenceQuantity"] = this.referenceQuantity;
        data["referenceUnitLabel"] = this.referenceUnitLabel;
        data["iconName"] = this.iconName;
        data["thresholdLow"] = this.thresholdLow;
        data["thresholdHigh"] = this.thresholdHigh;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRelatableUnitSaveRequest {
    id?: string;
    emissionFactorId?: string;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;
}

export class ReportAlternativeDto implements IReportAlternativeDto {
    id?: string | undefined;
    packagingGIId?: string | undefined;
    distributionGIId?: string | undefined;
    amount?: number | undefined;
    scaling?: string | undefined;
    sortOrder?: number;

    constructor(data?: IReportAlternativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packagingGIId = _data["packagingGIId"];
            this.distributionGIId = _data["distributionGIId"];
            this.amount = _data["amount"];
            this.scaling = _data["scaling"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ReportAlternativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAlternativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packagingGIId"] = this.packagingGIId;
        data["distributionGIId"] = this.distributionGIId;
        data["amount"] = this.amount;
        data["scaling"] = this.scaling;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IReportAlternativeDto {
    id?: string | undefined;
    packagingGIId?: string | undefined;
    distributionGIId?: string | undefined;
    amount?: number | undefined;
    scaling?: string | undefined;
    sortOrder?: number;
}

export class ReportAlternativeReadModel implements IReportAlternativeReadModel {
    id?: string;
    reportConfigurationId?: string;
    packagingGIId?: string | undefined;
    distributionGIId?: string | undefined;
    amount?: number | undefined;
    scaling?: string | undefined;
    sortOrder?: number;

    constructor(data?: IReportAlternativeReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportConfigurationId = _data["reportConfigurationId"];
            this.packagingGIId = _data["packagingGIId"];
            this.distributionGIId = _data["distributionGIId"];
            this.amount = _data["amount"];
            this.scaling = _data["scaling"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ReportAlternativeReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAlternativeReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportConfigurationId"] = this.reportConfigurationId;
        data["packagingGIId"] = this.packagingGIId;
        data["distributionGIId"] = this.distributionGIId;
        data["amount"] = this.amount;
        data["scaling"] = this.scaling;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IReportAlternativeReadModel {
    id?: string;
    reportConfigurationId?: string;
    packagingGIId?: string | undefined;
    distributionGIId?: string | undefined;
    amount?: number | undefined;
    scaling?: string | undefined;
    sortOrder?: number;
}

export class ReportConfigurationDto implements IReportConfigurationDto {
    id?: string | undefined;
    assessmentId?: string;
    description?: string | undefined;
    baselinePackagingGIId?: string | undefined;
    baselineDistributionGIId?: string | undefined;
    baselineAmount?: number | undefined;
    baselineScaling?: string | undefined;
    reductionFocus?: string | undefined;
    alternatives?: ReportAlternativeDto[] | undefined;
    selectedIndicators?: ReportSelectedIndicatorDto[] | undefined;

    constructor(data?: IReportConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentId = _data["assessmentId"];
            this.description = _data["description"];
            this.baselinePackagingGIId = _data["baselinePackagingGIId"];
            this.baselineDistributionGIId = _data["baselineDistributionGIId"];
            this.baselineAmount = _data["baselineAmount"];
            this.baselineScaling = _data["baselineScaling"];
            this.reductionFocus = _data["reductionFocus"];
            if (Array.isArray(_data["alternatives"])) {
                this.alternatives = [] as any;
                for (let item of _data["alternatives"])
                    this.alternatives!.push(ReportAlternativeDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedIndicators"])) {
                this.selectedIndicators = [] as any;
                for (let item of _data["selectedIndicators"])
                    this.selectedIndicators!.push(ReportSelectedIndicatorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentId"] = this.assessmentId;
        data["description"] = this.description;
        data["baselinePackagingGIId"] = this.baselinePackagingGIId;
        data["baselineDistributionGIId"] = this.baselineDistributionGIId;
        data["baselineAmount"] = this.baselineAmount;
        data["baselineScaling"] = this.baselineScaling;
        data["reductionFocus"] = this.reductionFocus;
        if (Array.isArray(this.alternatives)) {
            data["alternatives"] = [];
            for (let item of this.alternatives)
                data["alternatives"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.selectedIndicators)) {
            data["selectedIndicators"] = [];
            for (let item of this.selectedIndicators)
                data["selectedIndicators"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportConfigurationDto {
    id?: string | undefined;
    assessmentId?: string;
    description?: string | undefined;
    baselinePackagingGIId?: string | undefined;
    baselineDistributionGIId?: string | undefined;
    baselineAmount?: number | undefined;
    baselineScaling?: string | undefined;
    reductionFocus?: string | undefined;
    alternatives?: ReportAlternativeDto[] | undefined;
    selectedIndicators?: ReportSelectedIndicatorDto[] | undefined;
}

export class ReportConfigurationReadModel implements IReportConfigurationReadModel {
    id?: string;
    assessmentId?: string;
    description?: string | undefined;
    baselinePackagingGIId?: string | undefined;
    baselineDistributionGIId?: string | undefined;
    baselineAmount?: number | undefined;
    baselineScaling?: string | undefined;
    reductionFocus?: string | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    alternatives?: ReportAlternativeReadModel[] | undefined;
    selectedIndicators?: ReportSelectedIndicatorReadModel[] | undefined;

    constructor(data?: IReportConfigurationReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentId = _data["assessmentId"];
            this.description = _data["description"];
            this.baselinePackagingGIId = _data["baselinePackagingGIId"];
            this.baselineDistributionGIId = _data["baselineDistributionGIId"];
            this.baselineAmount = _data["baselineAmount"];
            this.baselineScaling = _data["baselineScaling"];
            this.reductionFocus = _data["reductionFocus"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            if (Array.isArray(_data["alternatives"])) {
                this.alternatives = [] as any;
                for (let item of _data["alternatives"])
                    this.alternatives!.push(ReportAlternativeReadModel.fromJS(item));
            }
            if (Array.isArray(_data["selectedIndicators"])) {
                this.selectedIndicators = [] as any;
                for (let item of _data["selectedIndicators"])
                    this.selectedIndicators!.push(ReportSelectedIndicatorReadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportConfigurationReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportConfigurationReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentId"] = this.assessmentId;
        data["description"] = this.description;
        data["baselinePackagingGIId"] = this.baselinePackagingGIId;
        data["baselineDistributionGIId"] = this.baselineDistributionGIId;
        data["baselineAmount"] = this.baselineAmount;
        data["baselineScaling"] = this.baselineScaling;
        data["reductionFocus"] = this.reductionFocus;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        if (Array.isArray(this.alternatives)) {
            data["alternatives"] = [];
            for (let item of this.alternatives)
                data["alternatives"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.selectedIndicators)) {
            data["selectedIndicators"] = [];
            for (let item of this.selectedIndicators)
                data["selectedIndicators"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportConfigurationReadModel {
    id?: string;
    assessmentId?: string;
    description?: string | undefined;
    baselinePackagingGIId?: string | undefined;
    baselineDistributionGIId?: string | undefined;
    baselineAmount?: number | undefined;
    baselineScaling?: string | undefined;
    reductionFocus?: string | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    alternatives?: ReportAlternativeReadModel[] | undefined;
    selectedIndicators?: ReportSelectedIndicatorReadModel[] | undefined;
}

export class ReportExportRequest implements IReportExportRequest {
    reportConfigurationId?: string;

    constructor(data?: IReportExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportConfigurationId = _data["reportConfigurationId"];
        }
    }

    static fromJS(data: any): ReportExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportConfigurationId"] = this.reportConfigurationId;
        return data;
    }
}

export interface IReportExportRequest {
    reportConfigurationId?: string;
}

export class ReportPreviewDto implements IReportPreviewDto {
    assessmentName?: string | undefined;
    contactPerson?: string | undefined;
    description?: string | undefined;
    date?: string | undefined;
    baselineLabel?: string | undefined;
    baselineFormatName?: string | undefined;
    alternatives?: PreviewAlternativeDto[] | undefined;
    reductionHighlights?: PreviewReductionHighlightDto[] | undefined;
    radarChart?: PreviewRadarChartDto;
    impactCategoryComparison?: PreviewImpactCategoryRowDto[] | undefined;
    packagingEfficiencyComparison?: PreviewPackagingEfficiencyRowDto[] | undefined;
    relatableUnits?: PreviewRelatableUnitRowDto[] | undefined;
    lifecycleSections?: PreviewLifecycleSectionDto[] | undefined;

    constructor(data?: IReportPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentName = _data["assessmentName"];
            this.contactPerson = _data["contactPerson"];
            this.description = _data["description"];
            this.date = _data["date"];
            this.baselineLabel = _data["baselineLabel"];
            this.baselineFormatName = _data["baselineFormatName"];
            if (Array.isArray(_data["alternatives"])) {
                this.alternatives = [] as any;
                for (let item of _data["alternatives"])
                    this.alternatives!.push(PreviewAlternativeDto.fromJS(item));
            }
            if (Array.isArray(_data["reductionHighlights"])) {
                this.reductionHighlights = [] as any;
                for (let item of _data["reductionHighlights"])
                    this.reductionHighlights!.push(PreviewReductionHighlightDto.fromJS(item));
            }
            this.radarChart = _data["radarChart"] ? PreviewRadarChartDto.fromJS(_data["radarChart"]) : undefined as any;
            if (Array.isArray(_data["impactCategoryComparison"])) {
                this.impactCategoryComparison = [] as any;
                for (let item of _data["impactCategoryComparison"])
                    this.impactCategoryComparison!.push(PreviewImpactCategoryRowDto.fromJS(item));
            }
            if (Array.isArray(_data["packagingEfficiencyComparison"])) {
                this.packagingEfficiencyComparison = [] as any;
                for (let item of _data["packagingEfficiencyComparison"])
                    this.packagingEfficiencyComparison!.push(PreviewPackagingEfficiencyRowDto.fromJS(item));
            }
            if (Array.isArray(_data["relatableUnits"])) {
                this.relatableUnits = [] as any;
                for (let item of _data["relatableUnits"])
                    this.relatableUnits!.push(PreviewRelatableUnitRowDto.fromJS(item));
            }
            if (Array.isArray(_data["lifecycleSections"])) {
                this.lifecycleSections = [] as any;
                for (let item of _data["lifecycleSections"])
                    this.lifecycleSections!.push(PreviewLifecycleSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentName"] = this.assessmentName;
        data["contactPerson"] = this.contactPerson;
        data["description"] = this.description;
        data["date"] = this.date;
        data["baselineLabel"] = this.baselineLabel;
        data["baselineFormatName"] = this.baselineFormatName;
        if (Array.isArray(this.alternatives)) {
            data["alternatives"] = [];
            for (let item of this.alternatives)
                data["alternatives"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reductionHighlights)) {
            data["reductionHighlights"] = [];
            for (let item of this.reductionHighlights)
                data["reductionHighlights"].push(item ? item.toJSON() : undefined as any);
        }
        data["radarChart"] = this.radarChart ? this.radarChart.toJSON() : undefined as any;
        if (Array.isArray(this.impactCategoryComparison)) {
            data["impactCategoryComparison"] = [];
            for (let item of this.impactCategoryComparison)
                data["impactCategoryComparison"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.packagingEfficiencyComparison)) {
            data["packagingEfficiencyComparison"] = [];
            for (let item of this.packagingEfficiencyComparison)
                data["packagingEfficiencyComparison"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relatableUnits)) {
            data["relatableUnits"] = [];
            for (let item of this.relatableUnits)
                data["relatableUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lifecycleSections)) {
            data["lifecycleSections"] = [];
            for (let item of this.lifecycleSections)
                data["lifecycleSections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportPreviewDto {
    assessmentName?: string | undefined;
    contactPerson?: string | undefined;
    description?: string | undefined;
    date?: string | undefined;
    baselineLabel?: string | undefined;
    baselineFormatName?: string | undefined;
    alternatives?: PreviewAlternativeDto[] | undefined;
    reductionHighlights?: PreviewReductionHighlightDto[] | undefined;
    radarChart?: PreviewRadarChartDto;
    impactCategoryComparison?: PreviewImpactCategoryRowDto[] | undefined;
    packagingEfficiencyComparison?: PreviewPackagingEfficiencyRowDto[] | undefined;
    relatableUnits?: PreviewRelatableUnitRowDto[] | undefined;
    lifecycleSections?: PreviewLifecycleSectionDto[] | undefined;
}

export class ReportSelectedIndicatorDto implements IReportSelectedIndicatorDto {
    emissionFactorId?: string;

    constructor(data?: IReportSelectedIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emissionFactorId = _data["emissionFactorId"];
        }
    }

    static fromJS(data: any): ReportSelectedIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectedIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emissionFactorId"] = this.emissionFactorId;
        return data;
    }
}

export interface IReportSelectedIndicatorDto {
    emissionFactorId?: string;
}

export class ReportSelectedIndicatorReadModel implements IReportSelectedIndicatorReadModel {
    id?: string;
    reportConfigurationId?: string;
    emissionFactorId?: string;

    constructor(data?: IReportSelectedIndicatorReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportConfigurationId = _data["reportConfigurationId"];
            this.emissionFactorId = _data["emissionFactorId"];
        }
    }

    static fromJS(data: any): ReportSelectedIndicatorReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectedIndicatorReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportConfigurationId"] = this.reportConfigurationId;
        data["emissionFactorId"] = this.emissionFactorId;
        return data;
    }
}

export interface IReportSelectedIndicatorReadModel {
    id?: string;
    reportConfigurationId?: string;
    emissionFactorId?: string;
}

export class ResultByEol implements IResultByEol {
    id?: number;
    materialId?: string | undefined;
    materialName?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;

    constructor(data?: IResultByEol) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialId = _data["materialId"];
            this.materialName = _data["materialName"];
            this.carbonFootPrint = _data["carbonFootPrint"];
            this.waterConsumption = _data["waterConsumption"];
            this.costOfGoods = _data["costOfGoods"];
            this.totalWeightedScore = _data["totalWeightedScore"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResultByEol {
        data = typeof data === 'object' ? data : {};
        let result = new ResultByEol();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["carbonFootPrint"] = this.carbonFootPrint;
        data["waterConsumption"] = this.waterConsumption;
        data["costOfGoods"] = this.costOfGoods;
        data["totalWeightedScore"] = this.totalWeightedScore;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        return data;
    }
}

export interface IResultByEol {
    id?: number;
    materialId?: string | undefined;
    materialName?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
}

export class ResultByLifeCycleStage implements IResultByLifeCycleStage {
    id?: number;
    stageName?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;

    constructor(data?: IResultByLifeCycleStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stageName = _data["stageName"];
            this.carbonFootPrint = _data["carbonFootPrint"];
            this.waterConsumption = _data["waterConsumption"];
            this.costOfGoods = _data["costOfGoods"];
            this.pmi = _data["pmi"];
            this.totalWeightedScore = _data["totalWeightedScore"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResultByLifeCycleStage {
        data = typeof data === 'object' ? data : {};
        let result = new ResultByLifeCycleStage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stageName"] = this.stageName;
        data["carbonFootPrint"] = this.carbonFootPrint;
        data["waterConsumption"] = this.waterConsumption;
        data["costOfGoods"] = this.costOfGoods;
        data["pmi"] = this.pmi;
        data["totalWeightedScore"] = this.totalWeightedScore;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        return data;
    }
}

export interface IResultByLifeCycleStage {
    id?: number;
    stageName?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
}

export class ResultByLifeCycleStageGraph1 implements IResultByLifeCycleStageGraph1 {
    id?: number;
    impactCategory?: string | undefined;
    materialsPercentage?: number;
    materialsValue?: number;
    transportPercentage?: number;
    transportValue?: number;
    transportOutboundPercentage?: number;
    transportOutboundValue?: number;
    energyWharehousePercentage?: number;
    energyWharehouseValue?: number;
    endOfLifePercentage?: number;
    endOfLifeValue?: number;

    constructor(data?: IResultByLifeCycleStageGraph1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.impactCategory = _data["impactCategory"];
            this.materialsPercentage = _data["materialsPercentage"];
            this.materialsValue = _data["materialsValue"];
            this.transportPercentage = _data["transportPercentage"];
            this.transportValue = _data["transportValue"];
            this.transportOutboundPercentage = _data["transportOutboundPercentage"];
            this.transportOutboundValue = _data["transportOutboundValue"];
            this.energyWharehousePercentage = _data["energyWharehousePercentage"];
            this.energyWharehouseValue = _data["energyWharehouseValue"];
            this.endOfLifePercentage = _data["endOfLifePercentage"];
            this.endOfLifeValue = _data["endOfLifeValue"];
        }
    }

    static fromJS(data: any): ResultByLifeCycleStageGraph1 {
        data = typeof data === 'object' ? data : {};
        let result = new ResultByLifeCycleStageGraph1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["impactCategory"] = this.impactCategory;
        data["materialsPercentage"] = this.materialsPercentage;
        data["materialsValue"] = this.materialsValue;
        data["transportPercentage"] = this.transportPercentage;
        data["transportValue"] = this.transportValue;
        data["transportOutboundPercentage"] = this.transportOutboundPercentage;
        data["transportOutboundValue"] = this.transportOutboundValue;
        data["energyWharehousePercentage"] = this.energyWharehousePercentage;
        data["energyWharehouseValue"] = this.energyWharehouseValue;
        data["endOfLifePercentage"] = this.endOfLifePercentage;
        data["endOfLifeValue"] = this.endOfLifeValue;
        return data;
    }
}

export interface IResultByLifeCycleStageGraph1 {
    id?: number;
    impactCategory?: string | undefined;
    materialsPercentage?: number;
    materialsValue?: number;
    transportPercentage?: number;
    transportValue?: number;
    transportOutboundPercentage?: number;
    transportOutboundValue?: number;
    energyWharehousePercentage?: number;
    energyWharehouseValue?: number;
    endOfLifePercentage?: number;
    endOfLifeValue?: number;
}

export class ResultByMaterialComposition implements IResultByMaterialComposition {
    id?: number;
    materialName?: string | undefined;
    materialSubTypeName?: string | undefined;
    mass?: number;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;

    constructor(data?: IResultByMaterialComposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialName = _data["materialName"];
            this.materialSubTypeName = _data["materialSubTypeName"];
            this.mass = _data["mass"];
            this.carbonFootPrint = _data["carbonFootPrint"];
            this.waterConsumption = _data["waterConsumption"];
            this.costOfGoods = _data["costOfGoods"];
            this.pmi = _data["pmi"];
            this.totalWeightedScore = _data["totalWeightedScore"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResultByMaterialComposition {
        data = typeof data === 'object' ? data : {};
        let result = new ResultByMaterialComposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialName"] = this.materialName;
        data["materialSubTypeName"] = this.materialSubTypeName;
        data["mass"] = this.mass;
        data["carbonFootPrint"] = this.carbonFootPrint;
        data["waterConsumption"] = this.waterConsumption;
        data["costOfGoods"] = this.costOfGoods;
        data["pmi"] = this.pmi;
        data["totalWeightedScore"] = this.totalWeightedScore;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        return data;
    }
}

export interface IResultByMaterialComposition {
    id?: number;
    materialName?: string | undefined;
    materialSubTypeName?: string | undefined;
    mass?: number;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
}

export class ResultByPackagingType implements IResultByPackagingType {
    id?: number;
    stepName?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;

    constructor(data?: IResultByPackagingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepName = _data["stepName"];
            this.carbonFootPrint = _data["carbonFootPrint"];
            this.waterConsumption = _data["waterConsumption"];
            this.costOfGoods = _data["costOfGoods"];
            this.pmi = _data["pmi"];
            this.totalWeightedScore = _data["totalWeightedScore"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResultByPackagingType {
        data = typeof data === 'object' ? data : {};
        let result = new ResultByPackagingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepName"] = this.stepName;
        data["carbonFootPrint"] = this.carbonFootPrint;
        data["waterConsumption"] = this.waterConsumption;
        data["costOfGoods"] = this.costOfGoods;
        data["pmi"] = this.pmi;
        data["totalWeightedScore"] = this.totalWeightedScore;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        return data;
    }
}

export interface IResultByPackagingType {
    id?: number;
    stepName?: string | undefined;
    carbonFootPrint?: number;
    waterConsumption?: number;
    costOfGoods?: number;
    pmi?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
}

export class Select implements ISelect {
    colorScheme?: ColorSchemeSelect;

    constructor(data?: ISelect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeSelect.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Select {
        data = typeof data === 'object' ? data : {};
        let result = new Select();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface ISelect {
    colorScheme?: ColorSchemeSelect;
}

export class SelectState implements ISelectState {
    option?: Option;
    overlay?: Overlay;

    constructor(data?: ISelectState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.option = _data["option"] ? Option.fromJS(_data["option"]) : undefined as any;
            this.overlay = _data["overlay"] ? Overlay.fromJS(_data["overlay"]) : undefined as any;
        }
    }

    static fromJS(data: any): SelectState {
        data = typeof data === 'object' ? data : {};
        let result = new SelectState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["option"] = this.option ? this.option.toJSON() : undefined as any;
        data["overlay"] = this.overlay ? this.overlay.toJSON() : undefined as any;
        return data;
    }
}

export interface ISelectState {
    option?: Option;
    overlay?: Overlay;
}

export class Semantic implements ISemantic {
    primary?: ColorMain;
    secondary?: ColorMain;
    accent?: ColorMain;
    severity?: Severity;
    ermbrand?: any | undefined;
    customPalette?: any | undefined;
    redSignal?: string | undefined;
    yellowSignal?: string | undefined;
    greenSignal?: string | undefined;
    loginScreen?: LoginScreen;
    textNormal?: TextNormal;
    landingpageUtilitiesButtons?: LandingpageUtilitiesButtons;
    menuUp?: MenuUp;
    sidebar?: Sidebar;
    downstreamDistributionTable?: DownstreamDistributionTable;
    colorScheme?: ColorSchemeMain;

    constructor(data?: ISemantic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primary = _data["primary"] ? ColorMain.fromJS(_data["primary"]) : undefined as any;
            this.secondary = _data["secondary"] ? ColorMain.fromJS(_data["secondary"]) : undefined as any;
            this.accent = _data["accent"] ? ColorMain.fromJS(_data["accent"]) : undefined as any;
            this.severity = _data["severity"] ? Severity.fromJS(_data["severity"]) : undefined as any;
            this.ermbrand = _data["ermbrand"];
            this.customPalette = _data["customPalette"];
            this.redSignal = _data["redSignal"];
            this.yellowSignal = _data["yellowSignal"];
            this.greenSignal = _data["greenSignal"];
            this.loginScreen = _data["loginScreen"] ? LoginScreen.fromJS(_data["loginScreen"]) : undefined as any;
            this.textNormal = _data["textNormal"] ? TextNormal.fromJS(_data["textNormal"]) : undefined as any;
            this.landingpageUtilitiesButtons = _data["landingpageUtilitiesButtons"] ? LandingpageUtilitiesButtons.fromJS(_data["landingpageUtilitiesButtons"]) : undefined as any;
            this.menuUp = _data["menuUp"] ? MenuUp.fromJS(_data["menuUp"]) : undefined as any;
            this.sidebar = _data["sidebar"] ? Sidebar.fromJS(_data["sidebar"]) : undefined as any;
            this.downstreamDistributionTable = _data["downstreamDistributionTable"] ? DownstreamDistributionTable.fromJS(_data["downstreamDistributionTable"]) : undefined as any;
            this.colorScheme = _data["colorScheme"] ? ColorSchemeMain.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Semantic {
        data = typeof data === 'object' ? data : {};
        let result = new Semantic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primary"] = this.primary ? this.primary.toJSON() : undefined as any;
        data["secondary"] = this.secondary ? this.secondary.toJSON() : undefined as any;
        data["accent"] = this.accent ? this.accent.toJSON() : undefined as any;
        data["severity"] = this.severity ? this.severity.toJSON() : undefined as any;
        data["ermbrand"] = this.ermbrand;
        data["customPalette"] = this.customPalette;
        data["redSignal"] = this.redSignal;
        data["yellowSignal"] = this.yellowSignal;
        data["greenSignal"] = this.greenSignal;
        data["loginScreen"] = this.loginScreen ? this.loginScreen.toJSON() : undefined as any;
        data["textNormal"] = this.textNormal ? this.textNormal.toJSON() : undefined as any;
        data["landingpageUtilitiesButtons"] = this.landingpageUtilitiesButtons ? this.landingpageUtilitiesButtons.toJSON() : undefined as any;
        data["menuUp"] = this.menuUp ? this.menuUp.toJSON() : undefined as any;
        data["sidebar"] = this.sidebar ? this.sidebar.toJSON() : undefined as any;
        data["downstreamDistributionTable"] = this.downstreamDistributionTable ? this.downstreamDistributionTable.toJSON() : undefined as any;
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface ISemantic {
    primary?: ColorMain;
    secondary?: ColorMain;
    accent?: ColorMain;
    severity?: Severity;
    ermbrand?: any | undefined;
    customPalette?: any | undefined;
    redSignal?: string | undefined;
    yellowSignal?: string | undefined;
    greenSignal?: string | undefined;
    loginScreen?: LoginScreen;
    textNormal?: TextNormal;
    landingpageUtilitiesButtons?: LandingpageUtilitiesButtons;
    menuUp?: MenuUp;
    sidebar?: Sidebar;
    downstreamDistributionTable?: DownstreamDistributionTable;
    colorScheme?: ColorSchemeMain;
}

export class Severity implements ISeverity {
    primary?: string | undefined;
    secondary?: string | undefined;
    success?: string | undefined;
    info?: string | undefined;
    warning?: string | undefined;
    danger?: string | undefined;

    constructor(data?: ISeverity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primary = _data["primary"];
            this.secondary = _data["secondary"];
            this.success = _data["success"];
            this.info = _data["info"];
            this.warning = _data["warning"];
            this.danger = _data["danger"];
        }
    }

    static fromJS(data: any): Severity {
        data = typeof data === 'object' ? data : {};
        let result = new Severity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primary"] = this.primary;
        data["secondary"] = this.secondary;
        data["success"] = this.success;
        data["info"] = this.info;
        data["warning"] = this.warning;
        data["danger"] = this.danger;
        return data;
    }
}

export interface ISeverity {
    primary?: string | undefined;
    secondary?: string | undefined;
    success?: string | undefined;
    info?: string | undefined;
    warning?: string | undefined;
    danger?: string | undefined;
}

export class SeverityMain implements ISeverityMain {
    primary?: string | undefined;
    secondary?: string | undefined;
    accent?: string | undefined;
    primaryGradations?: any | undefined;
    secondaryGradations?: any | undefined;
    accentGradations?: any | undefined;

    constructor(data?: ISeverityMain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primary = _data["primary"];
            this.secondary = _data["secondary"];
            this.accent = _data["accent"];
            this.primaryGradations = _data["primaryGradations"];
            this.secondaryGradations = _data["secondaryGradations"];
            this.accentGradations = _data["accentGradations"];
        }
    }

    static fromJS(data: any): SeverityMain {
        data = typeof data === 'object' ? data : {};
        let result = new SeverityMain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primary"] = this.primary;
        data["secondary"] = this.secondary;
        data["accent"] = this.accent;
        data["primaryGradations"] = this.primaryGradations;
        data["secondaryGradations"] = this.secondaryGradations;
        data["accentGradations"] = this.accentGradations;
        return data;
    }
}

export interface ISeverityMain {
    primary?: string | undefined;
    secondary?: string | undefined;
    accent?: string | undefined;
    primaryGradations?: any | undefined;
    secondaryGradations?: any | undefined;
    accentGradations?: any | undefined;
}

export class Shadow implements IShadow {
    color?: string | undefined;

    constructor(data?: IShadow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Shadow {
        data = typeof data === 'object' ? data : {};
        let result = new Shadow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface IShadow {
    color?: string | undefined;
}

export class Sidebar implements ISidebar {
    backgroundColor?: string | undefined;
    textColor?: string | undefined;

    constructor(data?: ISidebar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.textColor = _data["textColor"];
        }
    }

    static fromJS(data: any): Sidebar {
        data = typeof data === 'object' ? data : {};
        let result = new Sidebar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["textColor"] = this.textColor;
        return data;
    }
}

export interface ISidebar {
    backgroundColor?: string | undefined;
    textColor?: string | undefined;
}

export class SimpleFontSettings implements ISimpleFontSettings {
    fontFamily?: string | undefined;
    fontSize?: number;
    fontWeight?: string | undefined;
    lineHeight?: number;
    letterSpacing?: number;
    fontStyle?: string | undefined;
    textDecoration?: string | undefined;
    textTransform?: string | undefined;
    color?: string | undefined;
    isDefault?: boolean;

    constructor(data?: ISimpleFontSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fontFamily = _data["fontFamily"];
            this.fontSize = _data["fontSize"];
            this.fontWeight = _data["fontWeight"];
            this.lineHeight = _data["lineHeight"];
            this.letterSpacing = _data["letterSpacing"];
            this.fontStyle = _data["fontStyle"];
            this.textDecoration = _data["textDecoration"];
            this.textTransform = _data["textTransform"];
            this.color = _data["color"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): SimpleFontSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleFontSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fontFamily"] = this.fontFamily;
        data["fontSize"] = this.fontSize;
        data["fontWeight"] = this.fontWeight;
        data["lineHeight"] = this.lineHeight;
        data["letterSpacing"] = this.letterSpacing;
        data["fontStyle"] = this.fontStyle;
        data["textDecoration"] = this.textDecoration;
        data["textTransform"] = this.textTransform;
        data["color"] = this.color;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ISimpleFontSettings {
    fontFamily?: string | undefined;
    fontSize?: number;
    fontWeight?: string | undefined;
    lineHeight?: number;
    letterSpacing?: number;
    fontStyle?: string | undefined;
    textDecoration?: string | undefined;
    textTransform?: string | undefined;
    color?: string | undefined;
    isDefault?: boolean;
}

export class Splitbutton implements ISplitbutton {
    colorScheme?: ColorSchemeSplitbutton;

    constructor(data?: ISplitbutton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeSplitbutton.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Splitbutton {
        data = typeof data === 'object' ? data : {};
        let result = new Splitbutton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface ISplitbutton {
    colorScheme?: ColorSchemeSplitbutton;
}

export class SplitbuttonRoot implements ISplitbuttonRoot {
    raisedShadow?: string | undefined;
    roundedBorderRadius?: string | undefined;
    borderRadius?: string | undefined;

    constructor(data?: ISplitbuttonRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.raisedShadow = _data["raisedShadow"];
            this.roundedBorderRadius = _data["roundedBorderRadius"];
            this.borderRadius = _data["borderRadius"];
        }
    }

    static fromJS(data: any): SplitbuttonRoot {
        data = typeof data === 'object' ? data : {};
        let result = new SplitbuttonRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["raisedShadow"] = this.raisedShadow;
        data["roundedBorderRadius"] = this.roundedBorderRadius;
        data["borderRadius"] = this.borderRadius;
        return data;
    }
}

export interface ISplitbuttonRoot {
    raisedShadow?: string | undefined;
    roundedBorderRadius?: string | undefined;
    borderRadius?: string | undefined;
}

export class SplitbuttonState implements ISplitbuttonState {
    root?: SplitbuttonRoot;

    constructor(data?: ISplitbuttonState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? SplitbuttonRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): SplitbuttonState {
        data = typeof data === 'object' ? data : {};
        let result = new SplitbuttonState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface ISplitbuttonState {
    root?: SplitbuttonRoot;
}

export class StepDetail implements IStepDetail {
    stepId?: string | undefined;
    stepName?: string | undefined;
    stepNumber?: number;
    createdTimeStamp?: Date | undefined;
    rawMaterialEntryCount?: number;
    utilitiesCount?: number;
    processWasteCount?: number;
    materialNames?: string[] | undefined;

    constructor(data?: IStepDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.stepName = _data["stepName"];
            this.stepNumber = _data["stepNumber"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.rawMaterialEntryCount = _data["rawMaterialEntryCount"];
            this.utilitiesCount = _data["utilitiesCount"];
            this.processWasteCount = _data["processWasteCount"];
            if (Array.isArray(_data["materialNames"])) {
                this.materialNames = [] as any;
                for (let item of _data["materialNames"])
                    this.materialNames!.push(item);
            }
        }
    }

    static fromJS(data: any): StepDetail {
        data = typeof data === 'object' ? data : {};
        let result = new StepDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["stepName"] = this.stepName;
        data["stepNumber"] = this.stepNumber;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["rawMaterialEntryCount"] = this.rawMaterialEntryCount;
        data["utilitiesCount"] = this.utilitiesCount;
        data["processWasteCount"] = this.processWasteCount;
        if (Array.isArray(this.materialNames)) {
            data["materialNames"] = [];
            for (let item of this.materialNames)
                data["materialNames"].push(item);
        }
        return data;
    }
}

export interface IStepDetail {
    stepId?: string | undefined;
    stepName?: string | undefined;
    stepNumber?: number;
    createdTimeStamp?: Date | undefined;
    rawMaterialEntryCount?: number;
    utilitiesCount?: number;
    processWasteCount?: number;
    materialNames?: string[] | undefined;
}

export class Tab implements ITab {
    focusRing?: FocusRing;
    activeBorderColor?: string | undefined;
    activeBackground?: string | undefined;
    activeColor?: string | undefined;
    activeBar?: string | undefined;

    constructor(data?: ITab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.focusRing = _data["focusRing"] ? FocusRing.fromJS(_data["focusRing"]) : undefined as any;
            this.activeBorderColor = _data["activeBorderColor"];
            this.activeBackground = _data["activeBackground"];
            this.activeColor = _data["activeColor"];
            this.activeBar = _data["activeBar"];
        }
    }

    static fromJS(data: any): Tab {
        data = typeof data === 'object' ? data : {};
        let result = new Tab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["focusRing"] = this.focusRing ? this.focusRing.toJSON() : undefined as any;
        data["activeBorderColor"] = this.activeBorderColor;
        data["activeBackground"] = this.activeBackground;
        data["activeColor"] = this.activeColor;
        data["activeBar"] = this.activeBar;
        return data;
    }
}

export interface ITab {
    focusRing?: FocusRing;
    activeBorderColor?: string | undefined;
    activeBackground?: string | undefined;
    activeColor?: string | undefined;
    activeBar?: string | undefined;
}

export class TableField implements ITableField {
    textColor?: string | undefined;
    backgroundColor?: string | undefined;

    constructor(data?: ITableField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textColor = _data["textColor"];
            this.backgroundColor = _data["backgroundColor"];
        }
    }

    static fromJS(data: any): TableField {
        data = typeof data === 'object' ? data : {};
        let result = new TableField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textColor"] = this.textColor;
        data["backgroundColor"] = this.backgroundColor;
        return data;
    }
}

export interface ITableField {
    textColor?: string | undefined;
    backgroundColor?: string | undefined;
}

export class Tabs implements ITabs {
    colorScheme?: ColorSchemeTabs;

    constructor(data?: ITabs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeTabs.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Tabs {
        data = typeof data === 'object' ? data : {};
        let result = new Tabs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface ITabs {
    colorScheme?: ColorSchemeTabs;
}

export class TabsDark implements ITabsDark {
    activeBar?: ActiveBar;
    tab?: Tab;

    constructor(data?: ITabsDark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeBar = _data["activeBar"] ? ActiveBar.fromJS(_data["activeBar"]) : undefined as any;
            this.tab = _data["tab"] ? Tab.fromJS(_data["tab"]) : undefined as any;
        }
    }

    static fromJS(data: any): TabsDark {
        data = typeof data === 'object' ? data : {};
        let result = new TabsDark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeBar"] = this.activeBar ? this.activeBar.toJSON() : undefined as any;
        data["tab"] = this.tab ? this.tab.toJSON() : undefined as any;
        return data;
    }
}

export interface ITabsDark {
    activeBar?: ActiveBar;
    tab?: Tab;
}

export class TabsLight implements ITabsLight {
    root?: TabsRoot;

    constructor(data?: ITabsLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? TabsRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): TabsLight {
        data = typeof data === 'object' ? data : {};
        let result = new TabsLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface ITabsLight {
    root?: TabsRoot;
}

export class TabsRoot implements ITabsRoot {
    activeBar?: ActiveBar;
    tab?: Tab;

    constructor(data?: ITabsRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeBar = _data["activeBar"] ? ActiveBar.fromJS(_data["activeBar"]) : undefined as any;
            this.tab = _data["tab"] ? Tab.fromJS(_data["tab"]) : undefined as any;
        }
    }

    static fromJS(data: any): TabsRoot {
        data = typeof data === 'object' ? data : {};
        let result = new TabsRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeBar"] = this.activeBar ? this.activeBar.toJSON() : undefined as any;
        data["tab"] = this.tab ? this.tab.toJSON() : undefined as any;
        return data;
    }
}

export interface ITabsRoot {
    activeBar?: ActiveBar;
    tab?: Tab;
}

export class TextNormal implements ITextNormal {
    color?: string | undefined;

    constructor(data?: ITextNormal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TextNormal {
        data = typeof data === 'object' ? data : {};
        let result = new TextNormal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface ITextNormal {
    color?: string | undefined;
}

export class Toast implements IToast {
    colorScheme?: ColorScheme;

    constructor(data?: IToast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorScheme.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Toast {
        data = typeof data === 'object' ? data : {};
        let result = new Toast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IToast {
    colorScheme?: ColorScheme;
}

export class ToastState implements IToastState {
    success?: ToastType;
    error?: ToastType;
    warning?: ToastType;
    info?: ToastType;

    constructor(data?: IToastState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] ? ToastType.fromJS(_data["success"]) : undefined as any;
            this.error = _data["error"] ? ToastType.fromJS(_data["error"]) : undefined as any;
            this.warning = _data["warning"] ? ToastType.fromJS(_data["warning"]) : undefined as any;
            this.info = _data["info"] ? ToastType.fromJS(_data["info"]) : undefined as any;
        }
    }

    static fromJS(data: any): ToastState {
        data = typeof data === 'object' ? data : {};
        let result = new ToastState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success ? this.success.toJSON() : undefined as any;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        data["warning"] = this.warning ? this.warning.toJSON() : undefined as any;
        data["info"] = this.info ? this.info.toJSON() : undefined as any;
        return data;
    }
}

export interface IToastState {
    success?: ToastType;
    error?: ToastType;
    warning?: ToastType;
    info?: ToastType;
}

export class ToastType implements IToastType {
    background?: string | undefined;
    activeBackground?: string | undefined;
    color?: string | undefined;
    borderColor?: string | undefined;
    shadow?: Shadow;
    raisedShadow?: Shadow;
    activeColor?: string | undefined;

    constructor(data?: IToastType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
            this.activeBackground = _data["activeBackground"];
            this.color = _data["color"];
            this.borderColor = _data["borderColor"];
            this.shadow = _data["shadow"] ? Shadow.fromJS(_data["shadow"]) : undefined as any;
            this.raisedShadow = _data["raisedShadow"] ? Shadow.fromJS(_data["raisedShadow"]) : undefined as any;
            this.activeColor = _data["activeColor"];
        }
    }

    static fromJS(data: any): ToastType {
        data = typeof data === 'object' ? data : {};
        let result = new ToastType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        data["activeBackground"] = this.activeBackground;
        data["color"] = this.color;
        data["borderColor"] = this.borderColor;
        data["shadow"] = this.shadow ? this.shadow.toJSON() : undefined as any;
        data["raisedShadow"] = this.raisedShadow ? this.raisedShadow.toJSON() : undefined as any;
        data["activeColor"] = this.activeColor;
        return data;
    }
}

export interface IToastType {
    background?: string | undefined;
    activeBackground?: string | undefined;
    color?: string | undefined;
    borderColor?: string | undefined;
    shadow?: Shadow;
    raisedShadow?: Shadow;
    activeColor?: string | undefined;
}

export class Toggleswitch implements IToggleswitch {
    colorScheme?: ColorSchemeToggleswitch;

    constructor(data?: IToggleswitch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeToggleswitch.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Toggleswitch {
        data = typeof data === 'object' ? data : {};
        let result = new Toggleswitch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface IToggleswitch {
    colorScheme?: ColorSchemeToggleswitch;
}

export class ToggleswitchHandle implements IToggleswitchHandle {
    background?: string | undefined;
    hoverBackground?: string | undefined;
    checkedBackground?: string | undefined;
    checkedHoverBackground?: string | undefined;

    constructor(data?: IToggleswitchHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.background = _data["background"];
            this.hoverBackground = _data["hoverBackground"];
            this.checkedBackground = _data["checkedBackground"];
            this.checkedHoverBackground = _data["checkedHoverBackground"];
        }
    }

    static fromJS(data: any): ToggleswitchHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleswitchHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["background"] = this.background;
        data["hoverBackground"] = this.hoverBackground;
        data["checkedBackground"] = this.checkedBackground;
        data["checkedHoverBackground"] = this.checkedHoverBackground;
        return data;
    }
}

export interface IToggleswitchHandle {
    background?: string | undefined;
    hoverBackground?: string | undefined;
    checkedBackground?: string | undefined;
    checkedHoverBackground?: string | undefined;
}

export class ToggleswitchRoot implements IToggleswitchRoot {
    checkedBackground?: string | undefined;
    checkedHoverBackground?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;
    borderColor?: string | undefined;
    checkedBorderColor?: string | undefined;
    handle?: ToggleswitchHandle;

    constructor(data?: IToggleswitchRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkedBackground = _data["checkedBackground"];
            this.checkedHoverBackground = _data["checkedHoverBackground"];
            this.background = _data["background"];
            this.hoverBackground = _data["hoverBackground"];
            this.borderColor = _data["borderColor"];
            this.checkedBorderColor = _data["checkedBorderColor"];
            this.handle = _data["handle"] ? ToggleswitchHandle.fromJS(_data["handle"]) : undefined as any;
        }
    }

    static fromJS(data: any): ToggleswitchRoot {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleswitchRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkedBackground"] = this.checkedBackground;
        data["checkedHoverBackground"] = this.checkedHoverBackground;
        data["background"] = this.background;
        data["hoverBackground"] = this.hoverBackground;
        data["borderColor"] = this.borderColor;
        data["checkedBorderColor"] = this.checkedBorderColor;
        data["handle"] = this.handle ? this.handle.toJSON() : undefined as any;
        return data;
    }
}

export interface IToggleswitchRoot {
    checkedBackground?: string | undefined;
    checkedHoverBackground?: string | undefined;
    background?: string | undefined;
    hoverBackground?: string | undefined;
    borderColor?: string | undefined;
    checkedBorderColor?: string | undefined;
    handle?: ToggleswitchHandle;
}

export class ToggleswitchState implements IToggleswitchState {
    root?: ToggleswitchRoot;

    constructor(data?: IToggleswitchState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? ToggleswitchRoot.fromJS(_data["root"]) : undefined as any;
        }
    }

    static fromJS(data: any): ToggleswitchState {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleswitchState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        return data;
    }
}

export interface IToggleswitchState {
    root?: ToggleswitchRoot;
}

export class TransportListItem implements ITransportListItem {
    id?: string;
    transportName?: string | undefined;
    transportModeId?: string;
    transportModeName?: string | undefined;
    distance?: number;
    unitId?: string;
    unitName?: string | undefined;
    isDefault?: boolean | undefined;
    isActive?: boolean | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;

    constructor(data?: ITransportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transportName = _data["transportName"];
            this.transportModeId = _data["transportModeId"];
            this.transportModeName = _data["transportModeName"];
            this.distance = _data["distance"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TransportListItem {
        data = typeof data === 'object' ? data : {};
        let result = new TransportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transportName"] = this.transportName;
        data["transportModeId"] = this.transportModeId;
        data["transportModeName"] = this.transportModeName;
        data["distance"] = this.distance;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        return data;
    }
}

export interface ITransportListItem {
    id?: string;
    transportName?: string | undefined;
    transportModeId?: string;
    transportModeName?: string | undefined;
    distance?: number;
    unitId?: string;
    unitName?: string | undefined;
    isDefault?: boolean | undefined;
    isActive?: boolean | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;
}

export class Treetable implements ITreetable {
    colorScheme?: ColorSchemeTreetable;

    constructor(data?: ITreetable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScheme = _data["colorScheme"] ? ColorSchemeTreetable.fromJS(_data["colorScheme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Treetable {
        data = typeof data === 'object' ? data : {};
        let result = new Treetable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : undefined as any;
        return data;
    }
}

export interface ITreetable {
    colorScheme?: ColorSchemeTreetable;
}

export class TreetableBodyCell implements ITreetableBodyCell {
    borderColor?: string | undefined;

    constructor(data?: ITreetableBodyCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borderColor = _data["borderColor"];
        }
    }

    static fromJS(data: any): TreetableBodyCell {
        data = typeof data === 'object' ? data : {};
        let result = new TreetableBodyCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borderColor"] = this.borderColor;
        return data;
    }
}

export interface ITreetableBodyCell {
    borderColor?: string | undefined;
}

export class TreetableHeaderCell implements ITreetableHeaderCell {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    borderColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;

    constructor(data?: ITreetableHeaderCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoverBackground = _data["hoverBackground"];
            this.hoverColor = _data["hoverColor"];
            this.borderColor = _data["borderColor"];
            this.background = _data["background"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TreetableHeaderCell {
        data = typeof data === 'object' ? data : {};
        let result = new TreetableHeaderCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hoverBackground"] = this.hoverBackground;
        data["hoverColor"] = this.hoverColor;
        data["borderColor"] = this.borderColor;
        data["background"] = this.background;
        data["color"] = this.color;
        return data;
    }
}

export interface ITreetableHeaderCell {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    borderColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;
}

export class TreetableRoot implements ITreetableRoot {
    borderColor?: string | undefined;

    constructor(data?: ITreetableRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borderColor = _data["borderColor"];
        }
    }

    static fromJS(data: any): TreetableRoot {
        data = typeof data === 'object' ? data : {};
        let result = new TreetableRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borderColor"] = this.borderColor;
        return data;
    }
}

export interface ITreetableRoot {
    borderColor?: string | undefined;
}

export class TreetableRow implements ITreetableRow {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;

    constructor(data?: ITreetableRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoverBackground = _data["hoverBackground"];
            this.hoverColor = _data["hoverColor"];
            this.background = _data["background"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TreetableRow {
        data = typeof data === 'object' ? data : {};
        let result = new TreetableRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hoverBackground"] = this.hoverBackground;
        data["hoverColor"] = this.hoverColor;
        data["background"] = this.background;
        data["color"] = this.color;
        return data;
    }
}

export interface ITreetableRow {
    hoverBackground?: string | undefined;
    hoverColor?: string | undefined;
    background?: string | undefined;
    color?: string | undefined;
}

export class TreetableState implements ITreetableState {
    root?: TreetableRoot;
    headerCell?: TreetableHeaderCell;
    row?: TreetableRow;
    bodyCell?: TreetableBodyCell;

    constructor(data?: ITreetableState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? TreetableRoot.fromJS(_data["root"]) : undefined as any;
            this.headerCell = _data["headerCell"] ? TreetableHeaderCell.fromJS(_data["headerCell"]) : undefined as any;
            this.row = _data["row"] ? TreetableRow.fromJS(_data["row"]) : undefined as any;
            this.bodyCell = _data["bodyCell"] ? TreetableBodyCell.fromJS(_data["bodyCell"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreetableState {
        data = typeof data === 'object' ? data : {};
        let result = new TreetableState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        data["headerCell"] = this.headerCell ? this.headerCell.toJSON() : undefined as any;
        data["row"] = this.row ? this.row.toJSON() : undefined as any;
        data["bodyCell"] = this.bodyCell ? this.bodyCell.toJSON() : undefined as any;
        return data;
    }
}

export interface ITreetableState {
    root?: TreetableRoot;
    headerCell?: TreetableHeaderCell;
    row?: TreetableRow;
    bodyCell?: TreetableBodyCell;
}

export class UnitOperationAssessmentUsage implements IUnitOperationAssessmentUsage {
    assessmentId?: string;
    assessmentName?: string | undefined;
    subProjectName?: string | undefined;
    projectName?: string | undefined;

    constructor(data?: IUnitOperationAssessmentUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.assessmentName = _data["assessmentName"];
            this.subProjectName = _data["subProjectName"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): UnitOperationAssessmentUsage {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOperationAssessmentUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["assessmentName"] = this.assessmentName;
        data["subProjectName"] = this.subProjectName;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IUnitOperationAssessmentUsage {
    assessmentId?: string;
    assessmentName?: string | undefined;
    subProjectName?: string | undefined;
    projectName?: string | undefined;
}

export class UnitOperationMetadataDto implements IUnitOperationMetadataDto {
    id?: string;
    isNew?: boolean | undefined;
    createdTimeStamp?: Date | undefined;
    createdByUserName?: string | undefined;
    projectName?: string | undefined;
    subProjectName?: string | undefined;
    assessmentName?: string | undefined;

    constructor(data?: IUnitOperationMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isNew = _data["isNew"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.createdByUserName = _data["createdByUserName"];
            this.projectName = _data["projectName"];
            this.subProjectName = _data["subProjectName"];
            this.assessmentName = _data["assessmentName"];
        }
    }

    static fromJS(data: any): UnitOperationMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOperationMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isNew"] = this.isNew;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["createdByUserName"] = this.createdByUserName;
        data["projectName"] = this.projectName;
        data["subProjectName"] = this.subProjectName;
        data["assessmentName"] = this.assessmentName;
        return data;
    }
}

export interface IUnitOperationMetadataDto {
    id?: string;
    isNew?: boolean | undefined;
    createdTimeStamp?: Date | undefined;
    createdByUserName?: string | undefined;
    projectName?: string | undefined;
    subProjectName?: string | undefined;
    assessmentName?: string | undefined;
}

export class UnitWithTypeDto implements IUnitWithTypeDto {
    unitName?: string | undefined;
    unitTypeName?: string | undefined;

    constructor(data?: IUnitWithTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitName = _data["unitName"];
            this.unitTypeName = _data["unitTypeName"];
        }
    }

    static fromJS(data: any): UnitWithTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWithTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitName"] = this.unitName;
        data["unitTypeName"] = this.unitTypeName;
        return data;
    }
}

export interface IUnitWithTypeDto {
    unitName?: string | undefined;
    unitTypeName?: string | undefined;
}

export class UpdateDevicePackagingRequest implements IUpdateDevicePackagingRequest {
    assessmentId?: string;
    productFormatId?: string | undefined;
    massPerProductFormat?: number | undefined;
    massPerProductFormatUnitId?: string | undefined;

    constructor(data?: IUpdateDevicePackagingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.productFormatId = _data["productFormatId"];
            this.massPerProductFormat = _data["massPerProductFormat"];
            this.massPerProductFormatUnitId = _data["massPerProductFormatUnitId"];
        }
    }

    static fromJS(data: any): UpdateDevicePackagingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDevicePackagingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["productFormatId"] = this.productFormatId;
        data["massPerProductFormat"] = this.massPerProductFormat;
        data["massPerProductFormatUnitId"] = this.massPerProductFormatUnitId;
        return data;
    }
}

export interface IUpdateDevicePackagingRequest {
    assessmentId?: string;
    productFormatId?: string | undefined;
    massPerProductFormat?: number | undefined;
    massPerProductFormatUnitId?: string | undefined;
}

export class UpdateProductFormatFieldRequest implements IUpdateProductFormatFieldRequest {
    generalInformationId?: string;
    fieldName?: string | undefined;
    fieldValue?: any | undefined;

    constructor(data?: IUpdateProductFormatFieldRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalInformationId = _data["generalInformationId"];
            this.fieldName = _data["fieldName"];
            this.fieldValue = _data["fieldValue"];
        }
    }

    static fromJS(data: any): UpdateProductFormatFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductFormatFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalInformationId"] = this.generalInformationId;
        data["fieldName"] = this.fieldName;
        data["fieldValue"] = this.fieldValue;
        return data;
    }
}

export interface IUpdateProductFormatFieldRequest {
    generalInformationId?: string;
    fieldName?: string | undefined;
    fieldValue?: any | undefined;
}

export class UpdateProductFormatFieldResponse implements IUpdateProductFormatFieldResponse {
    success?: boolean;
    message?: string | undefined;
    updatedRecord?: ProductFormatComplianceRecord;

    constructor(data?: IUpdateProductFormatFieldResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.updatedRecord = _data["updatedRecord"] ? ProductFormatComplianceRecord.fromJS(_data["updatedRecord"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProductFormatFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductFormatFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["updatedRecord"] = this.updatedRecord ? this.updatedRecord.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateProductFormatFieldResponse {
    success?: boolean;
    message?: string | undefined;
    updatedRecord?: ProductFormatComplianceRecord;
}

export class UserImportExecuteRequest implements IUserImportExecuteRequest {
    rows?: UserImportExecuteRow[] | undefined;
    createInProvider?: boolean;

    constructor(data?: IUserImportExecuteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UserImportExecuteRow.fromJS(item));
            }
            this.createInProvider = _data["createInProvider"];
        }
    }

    static fromJS(data: any): UserImportExecuteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportExecuteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        data["createInProvider"] = this.createInProvider;
        return data;
    }
}

export interface IUserImportExecuteRequest {
    rows?: UserImportExecuteRow[] | undefined;
    createInProvider?: boolean;
}

export class UserImportExecuteResponse implements IUserImportExecuteResponse {
    success?: boolean;
    message?: string | undefined;
    totalProcessed?: number;
    usersCreated?: number;
    providerUsersCreated?: number;
    errors?: number;
    results?: UserImportExecuteRowResult[] | undefined;

    constructor(data?: IUserImportExecuteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.totalProcessed = _data["totalProcessed"];
            this.usersCreated = _data["usersCreated"];
            this.providerUsersCreated = _data["providerUsersCreated"];
            this.errors = _data["errors"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserImportExecuteRowResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserImportExecuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportExecuteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["totalProcessed"] = this.totalProcessed;
        data["usersCreated"] = this.usersCreated;
        data["providerUsersCreated"] = this.providerUsersCreated;
        data["errors"] = this.errors;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserImportExecuteResponse {
    success?: boolean;
    message?: string | undefined;
    totalProcessed?: number;
    usersCreated?: number;
    providerUsersCreated?: number;
    errors?: number;
    results?: UserImportExecuteRowResult[] | undefined;
}

export class UserImportExecuteRow implements IUserImportExecuteRow {
    rowNumber?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userTypeId?: string | undefined;
    userTypeIds?: string[] | undefined;
    importUser?: boolean;
    createProviderOnly?: boolean;
    existingUserId?: string | undefined;

    constructor(data?: IUserImportExecuteRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.userTypeId = _data["userTypeId"];
            if (Array.isArray(_data["userTypeIds"])) {
                this.userTypeIds = [] as any;
                for (let item of _data["userTypeIds"])
                    this.userTypeIds!.push(item);
            }
            this.importUser = _data["importUser"];
            this.createProviderOnly = _data["createProviderOnly"];
            this.existingUserId = _data["existingUserId"];
        }
    }

    static fromJS(data: any): UserImportExecuteRow {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportExecuteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["userTypeId"] = this.userTypeId;
        if (Array.isArray(this.userTypeIds)) {
            data["userTypeIds"] = [];
            for (let item of this.userTypeIds)
                data["userTypeIds"].push(item);
        }
        data["importUser"] = this.importUser;
        data["createProviderOnly"] = this.createProviderOnly;
        data["existingUserId"] = this.existingUserId;
        return data;
    }
}

export interface IUserImportExecuteRow {
    rowNumber?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userTypeId?: string | undefined;
    userTypeIds?: string[] | undefined;
    importUser?: boolean;
    createProviderOnly?: boolean;
    existingUserId?: string | undefined;
}

export class UserImportExecuteRowResult implements IUserImportExecuteRowResult {
    rowNumber?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    createdInDatabase?: boolean;
    createdInProvider?: boolean;
    providerStatus?: string | undefined;
    providerError?: string | undefined;
    personId?: string | undefined;

    constructor(data?: IUserImportExecuteRowResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.createdInDatabase = _data["createdInDatabase"];
            this.createdInProvider = _data["createdInProvider"];
            this.providerStatus = _data["providerStatus"];
            this.providerError = _data["providerError"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UserImportExecuteRowResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportExecuteRowResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["message"] = this.message;
        data["createdInDatabase"] = this.createdInDatabase;
        data["createdInProvider"] = this.createdInProvider;
        data["providerStatus"] = this.providerStatus;
        data["providerError"] = this.providerError;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUserImportExecuteRowResult {
    rowNumber?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    createdInDatabase?: boolean;
    createdInProvider?: boolean;
    providerStatus?: string | undefined;
    providerError?: string | undefined;
    personId?: string | undefined;
}

export class UserImportPreviewResponse implements IUserImportPreviewResponse {
    success?: boolean;
    message?: string | undefined;
    totalRows?: number;
    importableRows?: number;
    alreadyExistRows?: number;
    existsNoProviderRows?: number;
    errorRows?: number;
    rows?: UserImportPreviewRow[] | undefined;
    availableUserTypes?: UserTypeOption[] | undefined;

    constructor(data?: IUserImportPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.totalRows = _data["totalRows"];
            this.importableRows = _data["importableRows"];
            this.alreadyExistRows = _data["alreadyExistRows"];
            this.existsNoProviderRows = _data["existsNoProviderRows"];
            this.errorRows = _data["errorRows"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UserImportPreviewRow.fromJS(item));
            }
            if (Array.isArray(_data["availableUserTypes"])) {
                this.availableUserTypes = [] as any;
                for (let item of _data["availableUserTypes"])
                    this.availableUserTypes!.push(UserTypeOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserImportPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["totalRows"] = this.totalRows;
        data["importableRows"] = this.importableRows;
        data["alreadyExistRows"] = this.alreadyExistRows;
        data["existsNoProviderRows"] = this.existsNoProviderRows;
        data["errorRows"] = this.errorRows;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.availableUserTypes)) {
            data["availableUserTypes"] = [];
            for (let item of this.availableUserTypes)
                data["availableUserTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserImportPreviewResponse {
    success?: boolean;
    message?: string | undefined;
    totalRows?: number;
    importableRows?: number;
    alreadyExistRows?: number;
    existsNoProviderRows?: number;
    errorRows?: number;
    rows?: UserImportPreviewRow[] | undefined;
    availableUserTypes?: UserTypeOption[] | undefined;
}

export class UserImportPreviewRow implements IUserImportPreviewRow {
    rowNumber?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userTypeId?: string | undefined;
    userTypeName?: string | undefined;
    status?: string | undefined;
    userStatus?: string | undefined;
    message?: string | undefined;
    isSelectable?: boolean;
    isSelectableForProviderOnly?: boolean;
    existingUserId?: string | undefined;
    providerStatus?: string | undefined;
    validationErrors?: string[] | undefined;
    existingUserTypeIds?: string[] | undefined;

    constructor(data?: IUserImportPreviewRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.userTypeId = _data["userTypeId"];
            this.userTypeName = _data["userTypeName"];
            this.status = _data["status"];
            this.userStatus = _data["userStatus"];
            this.message = _data["message"];
            this.isSelectable = _data["isSelectable"];
            this.isSelectableForProviderOnly = _data["isSelectableForProviderOnly"];
            this.existingUserId = _data["existingUserId"];
            this.providerStatus = _data["providerStatus"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            if (Array.isArray(_data["existingUserTypeIds"])) {
                this.existingUserTypeIds = [] as any;
                for (let item of _data["existingUserTypeIds"])
                    this.existingUserTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserImportPreviewRow {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportPreviewRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["userTypeId"] = this.userTypeId;
        data["userTypeName"] = this.userTypeName;
        data["status"] = this.status;
        data["userStatus"] = this.userStatus;
        data["message"] = this.message;
        data["isSelectable"] = this.isSelectable;
        data["isSelectableForProviderOnly"] = this.isSelectableForProviderOnly;
        data["existingUserId"] = this.existingUserId;
        data["providerStatus"] = this.providerStatus;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        if (Array.isArray(this.existingUserTypeIds)) {
            data["existingUserTypeIds"] = [];
            for (let item of this.existingUserTypeIds)
                data["existingUserTypeIds"].push(item);
        }
        return data;
    }
}

export interface IUserImportPreviewRow {
    rowNumber?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userTypeId?: string | undefined;
    userTypeName?: string | undefined;
    status?: string | undefined;
    userStatus?: string | undefined;
    message?: string | undefined;
    isSelectable?: boolean;
    isSelectableForProviderOnly?: boolean;
    existingUserId?: string | undefined;
    providerStatus?: string | undefined;
    validationErrors?: string[] | undefined;
    existingUserTypeIds?: string[] | undefined;
}

export class UserImportResponse implements IUserImportResponse {
    success?: boolean;
    message?: string | undefined;
    totalRows?: number;
    usersCreated?: number;
    usersSkipped?: number;
    usersWithErrors?: number;
    providerUsersCreated?: number;
    results?: UserImportRowResult[] | undefined;
    errors?: string[] | undefined;

    constructor(data?: IUserImportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.totalRows = _data["totalRows"];
            this.usersCreated = _data["usersCreated"];
            this.usersSkipped = _data["usersSkipped"];
            this.usersWithErrors = _data["usersWithErrors"];
            this.providerUsersCreated = _data["providerUsersCreated"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserImportRowResult.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): UserImportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["totalRows"] = this.totalRows;
        data["usersCreated"] = this.usersCreated;
        data["usersSkipped"] = this.usersSkipped;
        data["usersWithErrors"] = this.usersWithErrors;
        data["providerUsersCreated"] = this.providerUsersCreated;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IUserImportResponse {
    success?: boolean;
    message?: string | undefined;
    totalRows?: number;
    usersCreated?: number;
    usersSkipped?: number;
    usersWithErrors?: number;
    providerUsersCreated?: number;
    results?: UserImportRowResult[] | undefined;
    errors?: string[] | undefined;
}

export class UserImportRowResult implements IUserImportRowResult {
    rowNumber?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    createdInDatabase?: boolean;
    createdInProvider?: boolean;
    alreadyExisted?: boolean;
    providerStatus?: string | undefined;

    constructor(data?: IUserImportRowResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.createdInDatabase = _data["createdInDatabase"];
            this.createdInProvider = _data["createdInProvider"];
            this.alreadyExisted = _data["alreadyExisted"];
            this.providerStatus = _data["providerStatus"];
        }
    }

    static fromJS(data: any): UserImportRowResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportRowResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["message"] = this.message;
        data["createdInDatabase"] = this.createdInDatabase;
        data["createdInProvider"] = this.createdInProvider;
        data["alreadyExisted"] = this.alreadyExisted;
        data["providerStatus"] = this.providerStatus;
        return data;
    }
}

export interface IUserImportRowResult {
    rowNumber?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    createdInDatabase?: boolean;
    createdInProvider?: boolean;
    alreadyExisted?: boolean;
    providerStatus?: string | undefined;
}

export class UserSyncExecuteRequest implements IUserSyncExecuteRequest {
    targetCredentials?: ExternalProviderCredentials;
    userIds?: string[] | undefined;
    createInTargetProvider?: boolean;
    updateLocalDatabase?: boolean;

    constructor(data?: IUserSyncExecuteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetCredentials = _data["targetCredentials"] ? ExternalProviderCredentials.fromJS(_data["targetCredentials"]) : undefined as any;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.createInTargetProvider = _data["createInTargetProvider"];
            this.updateLocalDatabase = _data["updateLocalDatabase"];
        }
    }

    static fromJS(data: any): UserSyncExecuteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserSyncExecuteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetCredentials"] = this.targetCredentials ? this.targetCredentials.toJSON() : undefined as any;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["createInTargetProvider"] = this.createInTargetProvider;
        data["updateLocalDatabase"] = this.updateLocalDatabase;
        return data;
    }
}

export interface IUserSyncExecuteRequest {
    targetCredentials?: ExternalProviderCredentials;
    userIds?: string[] | undefined;
    createInTargetProvider?: boolean;
    updateLocalDatabase?: boolean;
}

export class UserSyncExecuteResponse implements IUserSyncExecuteResponse {
    success?: boolean;
    message?: string | undefined;
    totalProcessed?: number;
    usersCreated?: number;
    usersUpdated?: number;
    usersSkipped?: number;
    usersFailed?: number;
    results?: UserSyncResult[] | undefined;
    errors?: string[] | undefined;
    sourceProvider?: string | undefined;
    targetProvider?: string | undefined;
    startTime?: Date;
    endTime?: Date;

    constructor(data?: IUserSyncExecuteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.totalProcessed = _data["totalProcessed"];
            this.usersCreated = _data["usersCreated"];
            this.usersUpdated = _data["usersUpdated"];
            this.usersSkipped = _data["usersSkipped"];
            this.usersFailed = _data["usersFailed"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserSyncResult.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.sourceProvider = _data["sourceProvider"];
            this.targetProvider = _data["targetProvider"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserSyncExecuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSyncExecuteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["totalProcessed"] = this.totalProcessed;
        data["usersCreated"] = this.usersCreated;
        data["usersUpdated"] = this.usersUpdated;
        data["usersSkipped"] = this.usersSkipped;
        data["usersFailed"] = this.usersFailed;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["sourceProvider"] = this.sourceProvider;
        data["targetProvider"] = this.targetProvider;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserSyncExecuteResponse {
    success?: boolean;
    message?: string | undefined;
    totalProcessed?: number;
    usersCreated?: number;
    usersUpdated?: number;
    usersSkipped?: number;
    usersFailed?: number;
    results?: UserSyncResult[] | undefined;
    errors?: string[] | undefined;
    sourceProvider?: string | undefined;
    targetProvider?: string | undefined;
    startTime?: Date;
    endTime?: Date;
}

export class UserSyncResult implements IUserSyncResult {
    sourceUserId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sourceStatus?: string | undefined;
    targetStatus?: string | undefined;
    success?: boolean;
    syncAction?: string | undefined;
    errorMessage?: string | undefined;
    syncTimestamp?: Date;
    createdInDatabase?: boolean;
    createdInTargetProvider?: boolean;

    constructor(data?: IUserSyncResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceUserId = _data["sourceUserId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sourceStatus = _data["sourceStatus"];
            this.targetStatus = _data["targetStatus"];
            this.success = _data["success"];
            this.syncAction = _data["syncAction"];
            this.errorMessage = _data["errorMessage"];
            this.syncTimestamp = _data["syncTimestamp"] ? new Date(_data["syncTimestamp"].toString()) : undefined as any;
            this.createdInDatabase = _data["createdInDatabase"];
            this.createdInTargetProvider = _data["createdInTargetProvider"];
        }
    }

    static fromJS(data: any): UserSyncResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserSyncResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceUserId"] = this.sourceUserId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sourceStatus"] = this.sourceStatus;
        data["targetStatus"] = this.targetStatus;
        data["success"] = this.success;
        data["syncAction"] = this.syncAction;
        data["errorMessage"] = this.errorMessage;
        data["syncTimestamp"] = this.syncTimestamp ? this.syncTimestamp.toISOString() : undefined as any;
        data["createdInDatabase"] = this.createdInDatabase;
        data["createdInTargetProvider"] = this.createdInTargetProvider;
        return data;
    }
}

export interface IUserSyncResult {
    sourceUserId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sourceStatus?: string | undefined;
    targetStatus?: string | undefined;
    success?: boolean;
    syncAction?: string | undefined;
    errorMessage?: string | undefined;
    syncTimestamp?: Date;
    createdInDatabase?: boolean;
    createdInTargetProvider?: boolean;
}

export class UserTypeOption implements IUserTypeOption {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUserTypeOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserTypeOption {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserTypeOption {
    id?: string | undefined;
    name?: string | undefined;
}

export class ValidateCredentialsResponse implements IValidateCredentialsResponse {
    success?: boolean;
    message?: string | undefined;
    providerName?: string | undefined;
    userCount?: number;
    errors?: string[] | undefined;

    constructor(data?: IValidateCredentialsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.providerName = _data["providerName"];
            this.userCount = _data["userCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateCredentialsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCredentialsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["providerName"] = this.providerName;
        data["userCount"] = this.userCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IValidateCredentialsResponse {
    success?: boolean;
    message?: string | undefined;
    providerName?: string | undefined;
    userCount?: number;
    errors?: string[] | undefined;
}

export class ValidationMessage implements IValidationMessage {
    messageType?: string | undefined;
    messageText?: string | undefined;

    constructor(data?: IValidationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.messageText = _data["messageText"];
        }
    }

    static fromJS(data: any): ValidationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["messageText"] = this.messageText;
        return data;
    }
}

export interface IValidationMessage {
    messageType?: string | undefined;
    messageText?: string | undefined;
}

export class VersionResponse implements IVersionResponse {
    version?: string | undefined;

    constructor(data?: IVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): VersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        return data;
    }
}

export interface IVersionResponse {
    version?: string | undefined;
}

export class WFICleanSteamGeneration implements IWFICleanSteamGeneration {
    id?: string;
    wfiCleanSteamSource?: string | undefined;
    unitId?: string;
    quantity?: number;
    comments?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    unit?: Unit;
    updatedByPerson?: Person;

    constructor(data?: IWFICleanSteamGeneration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wfiCleanSteamSource = _data["wfiCleanSteamSource"];
            this.unitId = _data["unitId"];
            this.quantity = _data["quantity"];
            this.comments = _data["comments"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): WFICleanSteamGeneration {
        data = typeof data === 'object' ? data : {};
        let result = new WFICleanSteamGeneration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wfiCleanSteamSource"] = this.wfiCleanSteamSource;
        data["unitId"] = this.unitId;
        data["quantity"] = this.quantity;
        data["comments"] = this.comments;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IWFICleanSteamGeneration {
    id?: string;
    wfiCleanSteamSource?: string | undefined;
    unitId?: string;
    quantity?: number;
    comments?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    unit?: Unit;
    updatedByPerson?: Person;
}

export class WFISource implements IWFISource {
    id?: string;
    wfiSourceName?: string | undefined;
    electricityConsumption?: number;
    energyUnitId?: string;
    steamConsumption?: number;
    steamUnitId?: string;
    waterConsumption?: number;
    waterUnitId?: string;
    comments?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    energyUnit?: Unit;
    steamUnit?: Unit;
    updatedByPerson?: Person;
    waterUnit?: Unit;

    constructor(data?: IWFISource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wfiSourceName = _data["wfiSourceName"];
            this.electricityConsumption = _data["electricityConsumption"];
            this.energyUnitId = _data["energyUnitId"];
            this.steamConsumption = _data["steamConsumption"];
            this.steamUnitId = _data["steamUnitId"];
            this.waterConsumption = _data["waterConsumption"];
            this.waterUnitId = _data["waterUnitId"];
            this.comments = _data["comments"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.energyUnit = _data["energyUnit"] ? Unit.fromJS(_data["energyUnit"]) : undefined as any;
            this.steamUnit = _data["steamUnit"] ? Unit.fromJS(_data["steamUnit"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.waterUnit = _data["waterUnit"] ? Unit.fromJS(_data["waterUnit"]) : undefined as any;
        }
    }

    static fromJS(data: any): WFISource {
        data = typeof data === 'object' ? data : {};
        let result = new WFISource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wfiSourceName"] = this.wfiSourceName;
        data["electricityConsumption"] = this.electricityConsumption;
        data["energyUnitId"] = this.energyUnitId;
        data["steamConsumption"] = this.steamConsumption;
        data["steamUnitId"] = this.steamUnitId;
        data["waterConsumption"] = this.waterConsumption;
        data["waterUnitId"] = this.waterUnitId;
        data["comments"] = this.comments;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["energyUnit"] = this.energyUnit ? this.energyUnit.toJSON() : undefined as any;
        data["steamUnit"] = this.steamUnit ? this.steamUnit.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["waterUnit"] = this.waterUnit ? this.waterUnit.toJSON() : undefined as any;
        return data;
    }
}

export interface IWFISource {
    id?: string;
    wfiSourceName?: string | undefined;
    electricityConsumption?: number;
    energyUnitId?: string;
    steamConsumption?: number;
    steamUnitId?: string;
    waterConsumption?: number;
    waterUnitId?: string;
    comments?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    energyUnit?: Unit;
    steamUnit?: Unit;
    updatedByPerson?: Person;
    waterUnit?: Unit;
}

export class WIFIResults implements IWIFIResults {
    fakeId?: string | undefined;
    text?: string | undefined;
    quantity?: number;
    unit?: string | undefined;
    isTitle?: boolean;

    constructor(data?: IWIFIResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fakeId = _data["fakeId"];
            this.text = _data["text"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.isTitle = _data["isTitle"];
        }
    }

    static fromJS(data: any): WIFIResults {
        data = typeof data === 'object' ? data : {};
        let result = new WIFIResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fakeId"] = this.fakeId;
        data["text"] = this.text;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["isTitle"] = this.isTitle;
        return data;
    }
}

export interface IWIFIResults {
    fakeId?: string | undefined;
    text?: string | undefined;
    quantity?: number;
    unit?: string | undefined;
    isTitle?: boolean;
}

export class WasteTypeWithScreen implements IWasteTypeWithScreen {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean | undefined;
    screenId?: string | undefined;
    screenName?: string | undefined;
    orderBy?: number | undefined;

    constructor(data?: IWasteTypeWithScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wasteTypeName = _data["wasteTypeName"];
            this.isActive = _data["isActive"];
            this.screenId = _data["screenId"];
            this.screenName = _data["screenName"];
            this.orderBy = _data["orderBy"];
        }
    }

    static fromJS(data: any): WasteTypeWithScreen {
        data = typeof data === 'object' ? data : {};
        let result = new WasteTypeWithScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wasteTypeName"] = this.wasteTypeName;
        data["isActive"] = this.isActive;
        data["screenId"] = this.screenId;
        data["screenName"] = this.screenName;
        data["orderBy"] = this.orderBy;
        return data;
    }
}

export interface IWasteTypeWithScreen {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean | undefined;
    screenId?: string | undefined;
    screenName?: string | undefined;
    orderBy?: number | undefined;
}

export class WetWeightCalculationRequest implements IWetWeightCalculationRequest {
    generalInformationId?: string;
    dryWeight?: number | undefined;
    concentration?: number | undefined;
    dryWeightUnitId?: string | undefined;
    concentrationUnitId?: string | undefined;
    screenId?: string;
    assessmentId?: string;
    versionNumber?: number;
    versionName?: string | undefined;

    constructor(data?: IWetWeightCalculationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalInformationId = _data["generalInformationId"];
            this.dryWeight = _data["dryWeight"];
            this.concentration = _data["concentration"];
            this.dryWeightUnitId = _data["dryWeightUnitId"];
            this.concentrationUnitId = _data["concentrationUnitId"];
            this.screenId = _data["screenId"];
            this.assessmentId = _data["assessmentId"];
            this.versionNumber = _data["versionNumber"];
            this.versionName = _data["versionName"];
        }
    }

    static fromJS(data: any): WetWeightCalculationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WetWeightCalculationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalInformationId"] = this.generalInformationId;
        data["dryWeight"] = this.dryWeight;
        data["concentration"] = this.concentration;
        data["dryWeightUnitId"] = this.dryWeightUnitId;
        data["concentrationUnitId"] = this.concentrationUnitId;
        data["screenId"] = this.screenId;
        data["assessmentId"] = this.assessmentId;
        data["versionNumber"] = this.versionNumber;
        data["versionName"] = this.versionName;
        return data;
    }
}

export interface IWetWeightCalculationRequest {
    generalInformationId?: string;
    dryWeight?: number | undefined;
    concentration?: number | undefined;
    dryWeightUnitId?: string | undefined;
    concentrationUnitId?: string | undefined;
    screenId?: string;
    assessmentId?: string;
    versionNumber?: number;
    versionName?: string | undefined;
}

export class WetWeightCalculationResponse implements IWetWeightCalculationResponse {
    wetWeight?: number | undefined;

    constructor(data?: IWetWeightCalculationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wetWeight = _data["wetWeight"];
        }
    }

    static fromJS(data: any): WetWeightCalculationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WetWeightCalculationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wetWeight"] = this.wetWeight;
        return data;
    }
}

export interface IWetWeightCalculationResponse {
    wetWeight?: number | undefined;
}

export class AllDefaultValues implements IAllDefaultValues {
    id?: string;
    defaultKey?: string | undefined;
    defaultJsonData?: string | undefined;
    allDefaultValuesName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAllDefaultValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.defaultKey = _data["defaultKey"];
            this.defaultJsonData = _data["defaultJsonData"];
            this.allDefaultValuesName = _data["allDefaultValuesName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AllDefaultValues {
        data = typeof data === 'object' ? data : {};
        let result = new AllDefaultValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["defaultKey"] = this.defaultKey;
        data["defaultJsonData"] = this.defaultJsonData;
        data["allDefaultValuesName"] = this.allDefaultValuesName;
        data["description"] = this.description;
        return data;
    }
}

export interface IAllDefaultValues {
    id?: string;
    defaultKey?: string | undefined;
    defaultJsonData?: string | undefined;
    allDefaultValuesName?: string | undefined;
    description?: string | undefined;
}

export class AllResultsOther implements IAllResultsOther {
    lifeCycleResults?: LifeCycleResult[] | undefined;
    materialCompositionResults?: MaterialCompositionResult[] | undefined;
    customProcessWasteEOLs?: CustomProcessWasteEOL[] | undefined;
    lifeCycleResultsByStep?: LifeCycleResult[] | undefined;
    productProcessLifeCycleResults?: ProductProcessLifeCycleResult[] | undefined;

    constructor(data?: IAllResultsOther) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lifeCycleResults"])) {
                this.lifeCycleResults = [] as any;
                for (let item of _data["lifeCycleResults"])
                    this.lifeCycleResults!.push(LifeCycleResult.fromJS(item));
            }
            if (Array.isArray(_data["materialCompositionResults"])) {
                this.materialCompositionResults = [] as any;
                for (let item of _data["materialCompositionResults"])
                    this.materialCompositionResults!.push(MaterialCompositionResult.fromJS(item));
            }
            if (Array.isArray(_data["customProcessWasteEOLs"])) {
                this.customProcessWasteEOLs = [] as any;
                for (let item of _data["customProcessWasteEOLs"])
                    this.customProcessWasteEOLs!.push(CustomProcessWasteEOL.fromJS(item));
            }
            if (Array.isArray(_data["lifeCycleResultsByStep"])) {
                this.lifeCycleResultsByStep = [] as any;
                for (let item of _data["lifeCycleResultsByStep"])
                    this.lifeCycleResultsByStep!.push(LifeCycleResult.fromJS(item));
            }
            if (Array.isArray(_data["productProcessLifeCycleResults"])) {
                this.productProcessLifeCycleResults = [] as any;
                for (let item of _data["productProcessLifeCycleResults"])
                    this.productProcessLifeCycleResults!.push(ProductProcessLifeCycleResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllResultsOther {
        data = typeof data === 'object' ? data : {};
        let result = new AllResultsOther();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lifeCycleResults)) {
            data["lifeCycleResults"] = [];
            for (let item of this.lifeCycleResults)
                data["lifeCycleResults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialCompositionResults)) {
            data["materialCompositionResults"] = [];
            for (let item of this.materialCompositionResults)
                data["materialCompositionResults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customProcessWasteEOLs)) {
            data["customProcessWasteEOLs"] = [];
            for (let item of this.customProcessWasteEOLs)
                data["customProcessWasteEOLs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lifeCycleResultsByStep)) {
            data["lifeCycleResultsByStep"] = [];
            for (let item of this.lifeCycleResultsByStep)
                data["lifeCycleResultsByStep"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessLifeCycleResults)) {
            data["productProcessLifeCycleResults"] = [];
            for (let item of this.productProcessLifeCycleResults)
                data["productProcessLifeCycleResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAllResultsOther {
    lifeCycleResults?: LifeCycleResult[] | undefined;
    materialCompositionResults?: MaterialCompositionResult[] | undefined;
    customProcessWasteEOLs?: CustomProcessWasteEOL[] | undefined;
    lifeCycleResultsByStep?: LifeCycleResult[] | undefined;
    productProcessLifeCycleResults?: ProductProcessLifeCycleResult[] | undefined;
}

export class AllSingleUserData implements IAllSingleUserData {
    person?: Person;
    clients?: Client[] | undefined;
    userTypes?: UserType[] | undefined;

    constructor(data?: IAllSingleUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(Client.fromJS(item));
            }
            if (Array.isArray(_data["userTypes"])) {
                this.userTypes = [] as any;
                for (let item of _data["userTypes"])
                    this.userTypes!.push(UserType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllSingleUserData {
        data = typeof data === 'object' ? data : {};
        let result = new AllSingleUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userTypes)) {
            data["userTypes"] = [];
            for (let item of this.userTypes)
                data["userTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAllSingleUserData {
    person?: Person;
    clients?: Client[] | undefined;
    userTypes?: UserType[] | undefined;
}

export class Assessment implements IAssessment {
    id?: string;
    assessmentName?: string | undefined;
    assessmentNumber?: number | undefined;
    subProjectId?: string;
    developmentStageId?: string;
    electronicLabNumber?: string | undefined;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    productNameId?: string | undefined;
    isBookmarked?: boolean | undefined;
    asessementIncrementalNumber?: number | undefined;
    isLocked?: boolean | undefined;
    lockedByPersonId?: string | undefined;
    assessmentCollaborators?: AssessmentCollaborators[] | undefined;
    createdByPerson?: Person;
    developmentStage?: MasterDropdown;
    energyMultipliers?: EnergyMultipliers[] | undefined;
    favorites?: Favorites[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    history?: History[] | undefined;
    intermediateStep?: IntermediateStep[] | undefined;
    lockedByPerson?: Person;
    productName?: MasterDropdown;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    reportConfiguration?: ReportConfiguration[] | undefined;
    step?: Step[] | undefined;
    subProject?: SubProject;
    updatedByPerson?: Person;

    constructor(data?: IAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentName = _data["assessmentName"];
            this.assessmentNumber = _data["assessmentNumber"];
            this.subProjectId = _data["subProjectId"];
            this.developmentStageId = _data["developmentStageId"];
            this.electronicLabNumber = _data["electronicLabNumber"];
            this.comments = _data["comments"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.productNameId = _data["productNameId"];
            this.isBookmarked = _data["isBookmarked"];
            this.asessementIncrementalNumber = _data["asessementIncrementalNumber"];
            this.isLocked = _data["isLocked"];
            this.lockedByPersonId = _data["lockedByPersonId"];
            if (Array.isArray(_data["assessmentCollaborators"])) {
                this.assessmentCollaborators = [] as any;
                for (let item of _data["assessmentCollaborators"])
                    this.assessmentCollaborators!.push(AssessmentCollaborators.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.developmentStage = _data["developmentStage"] ? MasterDropdown.fromJS(_data["developmentStage"]) : undefined as any;
            if (Array.isArray(_data["energyMultipliers"])) {
                this.energyMultipliers = [] as any;
                for (let item of _data["energyMultipliers"])
                    this.energyMultipliers!.push(EnergyMultipliers.fromJS(item));
            }
            if (Array.isArray(_data["favorites"])) {
                this.favorites = [] as any;
                for (let item of _data["favorites"])
                    this.favorites!.push(Favorites.fromJS(item));
            }
            if (Array.isArray(_data["generalInformation"])) {
                this.generalInformation = [] as any;
                for (let item of _data["generalInformation"])
                    this.generalInformation!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(History.fromJS(item));
            }
            if (Array.isArray(_data["intermediateStep"])) {
                this.intermediateStep = [] as any;
                for (let item of _data["intermediateStep"])
                    this.intermediateStep!.push(IntermediateStep.fromJS(item));
            }
            this.lockedByPerson = _data["lockedByPerson"] ? Person.fromJS(_data["lockedByPerson"]) : undefined as any;
            this.productName = _data["productName"] ? MasterDropdown.fromJS(_data["productName"]) : undefined as any;
            if (Array.isArray(_data["productProcessProxy"])) {
                this.productProcessProxy = [] as any;
                for (let item of _data["productProcessProxy"])
                    this.productProcessProxy!.push(ProductProcessProxy.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEntry"])) {
                this.productProcessProxyEntry = [] as any;
                for (let item of _data["productProcessProxyEntry"])
                    this.productProcessProxyEntry!.push(ProductProcessProxyEntry.fromJS(item));
            }
            if (Array.isArray(_data["reportConfiguration"])) {
                this.reportConfiguration = [] as any;
                for (let item of _data["reportConfiguration"])
                    this.reportConfiguration!.push(ReportConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["step"])) {
                this.step = [] as any;
                for (let item of _data["step"])
                    this.step!.push(Step.fromJS(item));
            }
            this.subProject = _data["subProject"] ? SubProject.fromJS(_data["subProject"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): Assessment {
        data = typeof data === 'object' ? data : {};
        let result = new Assessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentName"] = this.assessmentName;
        data["assessmentNumber"] = this.assessmentNumber;
        data["subProjectId"] = this.subProjectId;
        data["developmentStageId"] = this.developmentStageId;
        data["electronicLabNumber"] = this.electronicLabNumber;
        data["comments"] = this.comments;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["productNameId"] = this.productNameId;
        data["isBookmarked"] = this.isBookmarked;
        data["asessementIncrementalNumber"] = this.asessementIncrementalNumber;
        data["isLocked"] = this.isLocked;
        data["lockedByPersonId"] = this.lockedByPersonId;
        if (Array.isArray(this.assessmentCollaborators)) {
            data["assessmentCollaborators"] = [];
            for (let item of this.assessmentCollaborators)
                data["assessmentCollaborators"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["developmentStage"] = this.developmentStage ? this.developmentStage.toJSON() : undefined as any;
        if (Array.isArray(this.energyMultipliers)) {
            data["energyMultipliers"] = [];
            for (let item of this.energyMultipliers)
                data["energyMultipliers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.favorites)) {
            data["favorites"] = [];
            for (let item of this.favorites)
                data["favorites"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformation)) {
            data["generalInformation"] = [];
            for (let item of this.generalInformation)
                data["generalInformation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.intermediateStep)) {
            data["intermediateStep"] = [];
            for (let item of this.intermediateStep)
                data["intermediateStep"].push(item ? item.toJSON() : undefined as any);
        }
        data["lockedByPerson"] = this.lockedByPerson ? this.lockedByPerson.toJSON() : undefined as any;
        data["productName"] = this.productName ? this.productName.toJSON() : undefined as any;
        if (Array.isArray(this.productProcessProxy)) {
            data["productProcessProxy"] = [];
            for (let item of this.productProcessProxy)
                data["productProcessProxy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEntry)) {
            data["productProcessProxyEntry"] = [];
            for (let item of this.productProcessProxyEntry)
                data["productProcessProxyEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportConfiguration)) {
            data["reportConfiguration"] = [];
            for (let item of this.reportConfiguration)
                data["reportConfiguration"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.step)) {
            data["step"] = [];
            for (let item of this.step)
                data["step"].push(item ? item.toJSON() : undefined as any);
        }
        data["subProject"] = this.subProject ? this.subProject.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssessment {
    id?: string;
    assessmentName?: string | undefined;
    assessmentNumber?: number | undefined;
    subProjectId?: string;
    developmentStageId?: string;
    electronicLabNumber?: string | undefined;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    productNameId?: string | undefined;
    isBookmarked?: boolean | undefined;
    asessementIncrementalNumber?: number | undefined;
    isLocked?: boolean | undefined;
    lockedByPersonId?: string | undefined;
    assessmentCollaborators?: AssessmentCollaborators[] | undefined;
    createdByPerson?: Person;
    developmentStage?: MasterDropdown;
    energyMultipliers?: EnergyMultipliers[] | undefined;
    favorites?: Favorites[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    history?: History[] | undefined;
    intermediateStep?: IntermediateStep[] | undefined;
    lockedByPerson?: Person;
    productName?: MasterDropdown;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    reportConfiguration?: ReportConfiguration[] | undefined;
    step?: Step[] | undefined;
    subProject?: SubProject;
    updatedByPerson?: Person;
}

export class AssessmentCollaboratorPut implements IAssessmentCollaboratorPut {
    assessment?: Assessment;
    collaborators?: Person[] | undefined;

    constructor(data?: IAssessmentCollaboratorPut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            if (Array.isArray(_data["collaborators"])) {
                this.collaborators = [] as any;
                for (let item of _data["collaborators"])
                    this.collaborators!.push(Person.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentCollaboratorPut {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentCollaboratorPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        if (Array.isArray(this.collaborators)) {
            data["collaborators"] = [];
            for (let item of this.collaborators)
                data["collaborators"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssessmentCollaboratorPut {
    assessment?: Assessment;
    collaborators?: Person[] | undefined;
}

export class AssessmentCollaborators implements IAssessmentCollaborators {
    id?: string;
    personId?: string;
    assessmentId?: string;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    person?: Person;
    updatedByPerson?: Person;

    constructor(data?: IAssessmentCollaborators) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.assessmentId = _data["assessmentId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssessmentCollaborators {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentCollaborators();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["assessmentId"] = this.assessmentId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssessmentCollaborators {
    id?: string;
    personId?: string;
    assessmentId?: string;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    person?: Person;
    updatedByPerson?: Person;
}

export class BasicInfoConsumerEolTab implements IBasicInfoConsumerEolTab {
    step?: Step;
    generalInformation?: GeneralInformation;
    storedProcessWaste?: ProcessWaste;

    constructor(data?: IBasicInfoConsumerEolTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.generalInformation = _data["generalInformation"] ? GeneralInformation.fromJS(_data["generalInformation"]) : undefined as any;
            this.storedProcessWaste = _data["storedProcessWaste"] ? ProcessWaste.fromJS(_data["storedProcessWaste"]) : undefined as any;
        }
    }

    static fromJS(data: any): BasicInfoConsumerEolTab {
        data = typeof data === 'object' ? data : {};
        let result = new BasicInfoConsumerEolTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : undefined as any;
        data["storedProcessWaste"] = this.storedProcessWaste ? this.storedProcessWaste.toJSON() : undefined as any;
        return data;
    }
}

export interface IBasicInfoConsumerEolTab {
    step?: Step;
    generalInformation?: GeneralInformation;
    storedProcessWaste?: ProcessWaste;
}

export class BiologicsLifeCycleResult implements IBiologicsLifeCycleResult {
    name?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;

    constructor(data?: IBiologicsLifeCycleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.climateChange = _data["climateChange"];
            this.waterConsumption = _data["waterConsumption"];
            this.costofGoods = _data["costofGoods"];
            this.water = _data["water"];
            this.solvent = _data["solvent"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
            this.total = _data["total"];
            this.totalWeightedScore = _data["totalWeightedScore"];
        }
    }

    static fromJS(data: any): BiologicsLifeCycleResult {
        data = typeof data === 'object' ? data : {};
        let result = new BiologicsLifeCycleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["climateChange"] = this.climateChange;
        data["waterConsumption"] = this.waterConsumption;
        data["costofGoods"] = this.costofGoods;
        data["water"] = this.water;
        data["solvent"] = this.solvent;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        data["total"] = this.total;
        data["totalWeightedScore"] = this.totalWeightedScore;
        return data;
    }
}

export interface IBiologicsLifeCycleResult {
    name?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;
}

export class CheckIfDeviceIsUsed implements ICheckIfDeviceIsUsed {
    used?: boolean;
    packUsed?: boolean;
    deviceUsed?: boolean;

    constructor(data?: ICheckIfDeviceIsUsed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.used = _data["used"];
            this.packUsed = _data["packUsed"];
            this.deviceUsed = _data["deviceUsed"];
        }
    }

    static fromJS(data: any): CheckIfDeviceIsUsed {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIfDeviceIsUsed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["used"] = this.used;
        data["packUsed"] = this.packUsed;
        data["deviceUsed"] = this.deviceUsed;
        return data;
    }
}

export interface ICheckIfDeviceIsUsed {
    used?: boolean;
    packUsed?: boolean;
    deviceUsed?: boolean;
}

export class Client implements IClient {
    id?: string;
    clientName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;
    readonly userClient?: UserClientEntity[] | undefined;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientName = _data["clientName"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["userClient"])) {
                (this as any).userClient = [] as any;
                for (let item of _data["userClient"])
                    (this as any).userClient!.push(UserClientEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientName"] = this.clientName;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.userClient)) {
            data["userClient"] = [];
            for (let item of this.userClient)
                data["userClient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClient {
    id?: string;
    clientName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;
    userClient?: UserClientEntity[] | undefined;
}

export class ColdStorage implements IColdStorage {
    id?: string;
    temperatureRequirement?: string | undefined;
    electricityForDistribution?: number;
    electricityForProductProcess?: number;
    source?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    downstreamDistribution?: DownstreamDistribution[] | undefined;

    constructor(data?: IColdStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.temperatureRequirement = _data["temperatureRequirement"];
            this.electricityForDistribution = _data["electricityForDistribution"];
            this.electricityForProductProcess = _data["electricityForProductProcess"];
            this.source = _data["source"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            if (Array.isArray(_data["downstreamDistribution"])) {
                this.downstreamDistribution = [] as any;
                for (let item of _data["downstreamDistribution"])
                    this.downstreamDistribution!.push(DownstreamDistribution.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ColdStorage {
        data = typeof data === 'object' ? data : {};
        let result = new ColdStorage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["temperatureRequirement"] = this.temperatureRequirement;
        data["electricityForDistribution"] = this.electricityForDistribution;
        data["electricityForProductProcess"] = this.electricityForProductProcess;
        data["source"] = this.source;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        if (Array.isArray(this.downstreamDistribution)) {
            data["downstreamDistribution"] = [];
            for (let item of this.downstreamDistribution)
                data["downstreamDistribution"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IColdStorage {
    id?: string;
    temperatureRequirement?: string | undefined;
    electricityForDistribution?: number;
    electricityForProductProcess?: number;
    source?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    downstreamDistribution?: DownstreamDistribution[] | undefined;
}

export class ColdStorageData implements IColdStorageData {
    coldStorageRequired?: boolean;
    coldStorageId?: string | undefined;
    coldStorageLocationId?: string | undefined;
    coldSorageTime?: number;
    coldStorageUnit?: string | undefined;

    constructor(data?: IColdStorageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coldStorageRequired = _data["coldStorageRequired"];
            this.coldStorageId = _data["coldStorageId"];
            this.coldStorageLocationId = _data["coldStorageLocationId"];
            this.coldSorageTime = _data["coldSorageTime"];
            this.coldStorageUnit = _data["coldStorageUnit"];
        }
    }

    static fromJS(data: any): ColdStorageData {
        data = typeof data === 'object' ? data : {};
        let result = new ColdStorageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coldStorageRequired"] = this.coldStorageRequired;
        data["coldStorageId"] = this.coldStorageId;
        data["coldStorageLocationId"] = this.coldStorageLocationId;
        data["coldSorageTime"] = this.coldSorageTime;
        data["coldStorageUnit"] = this.coldStorageUnit;
        return data;
    }
}

export interface IColdStorageData {
    coldStorageRequired?: boolean;
    coldStorageId?: string | undefined;
    coldStorageLocationId?: string | undefined;
    coldSorageTime?: number;
    coldStorageUnit?: string | undefined;
}

export class ColdStorageDropdowns implements IColdStorageDropdowns {
    tempRequirements?: ColdStorage[] | undefined;
    siteLocations?: SiteLocation[] | undefined;
    unitsDistance?: Unit[] | undefined;

    constructor(data?: IColdStorageDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tempRequirements"])) {
                this.tempRequirements = [] as any;
                for (let item of _data["tempRequirements"])
                    this.tempRequirements!.push(ColdStorage.fromJS(item));
            }
            if (Array.isArray(_data["siteLocations"])) {
                this.siteLocations = [] as any;
                for (let item of _data["siteLocations"])
                    this.siteLocations!.push(SiteLocation.fromJS(item));
            }
            if (Array.isArray(_data["unitsDistance"])) {
                this.unitsDistance = [] as any;
                for (let item of _data["unitsDistance"])
                    this.unitsDistance!.push(Unit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ColdStorageDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new ColdStorageDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tempRequirements)) {
            data["tempRequirements"] = [];
            for (let item of this.tempRequirements)
                data["tempRequirements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.siteLocations)) {
            data["siteLocations"] = [];
            for (let item of this.siteLocations)
                data["siteLocations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitsDistance)) {
            data["unitsDistance"] = [];
            for (let item of this.unitsDistance)
                data["unitsDistance"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IColdStorageDropdowns {
    tempRequirements?: ColdStorage[] | undefined;
    siteLocations?: SiteLocation[] | undefined;
    unitsDistance?: Unit[] | undefined;
}

export class CompOption implements ICompOption {
    id?: string;
    optionName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    unitOperation?: UnitOperation[] | undefined;

    constructor(data?: ICompOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.optionName = _data["optionName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            if (Array.isArray(_data["generalInformation"])) {
                this.generalInformation = [] as any;
                for (let item of _data["generalInformation"])
                    this.generalInformation!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["unitOperation"])) {
                this.unitOperation = [] as any;
                for (let item of _data["unitOperation"])
                    this.unitOperation!.push(UnitOperation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompOption {
        data = typeof data === 'object' ? data : {};
        let result = new CompOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["optionName"] = this.optionName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        if (Array.isArray(this.generalInformation)) {
            data["generalInformation"] = [];
            for (let item of this.generalInformation)
                data["generalInformation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperation)) {
            data["unitOperation"] = [];
            for (let item of this.unitOperation)
                data["unitOperation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompOption {
    id?: string;
    optionName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    unitOperation?: UnitOperation[] | undefined;
}

export class ConfigurationVariable implements IConfigurationVariable {
    id?: string;
    variableName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    valueType?: string | undefined;
    referenceTableId?: string | undefined;
    variableValue?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    createdByPerson?: Person;
    referenceTable?: ReferenceTable;
    updatedByPerson?: Person;

    constructor(data?: IConfigurationVariable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.variableName = _data["variableName"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.valueType = _data["valueType"];
            this.referenceTableId = _data["referenceTableId"];
            this.variableValue = _data["variableValue"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.referenceTable = _data["referenceTable"] ? ReferenceTable.fromJS(_data["referenceTable"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConfigurationVariable {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationVariable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["variableName"] = this.variableName;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["valueType"] = this.valueType;
        data["referenceTableId"] = this.referenceTableId;
        data["variableValue"] = this.variableValue;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["referenceTable"] = this.referenceTable ? this.referenceTable.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IConfigurationVariable {
    id?: string;
    variableName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    valueType?: string | undefined;
    referenceTableId?: string | undefined;
    variableValue?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    createdByPerson?: Person;
    referenceTable?: ReferenceTable;
    updatedByPerson?: Person;
}

export class ConsumerEndOfLifeDropdowns implements IConsumerEndOfLifeDropdowns {
    destinationMarkets?: MasterDropdown[] | undefined;
    destinationSettings?: MasterDropdown[] | undefined;

    constructor(data?: IConsumerEndOfLifeDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["destinationMarkets"])) {
                this.destinationMarkets = [] as any;
                for (let item of _data["destinationMarkets"])
                    this.destinationMarkets!.push(MasterDropdown.fromJS(item));
            }
            if (Array.isArray(_data["destinationSettings"])) {
                this.destinationSettings = [] as any;
                for (let item of _data["destinationSettings"])
                    this.destinationSettings!.push(MasterDropdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsumerEndOfLifeDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerEndOfLifeDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinationMarkets)) {
            data["destinationMarkets"] = [];
            for (let item of this.destinationMarkets)
                data["destinationMarkets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.destinationSettings)) {
            data["destinationSettings"] = [];
            for (let item of this.destinationSettings)
                data["destinationSettings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConsumerEndOfLifeDropdowns {
    destinationMarkets?: MasterDropdown[] | undefined;
    destinationSettings?: MasterDropdown[] | undefined;
}

export class ConsumerEolMaterialDefault implements IConsumerEolMaterialDefault {
    id?: string;
    regionId?: string | undefined;
    materialId?: string | undefined;
    wasteTypeId?: string | undefined;
    sterilizationBeforeDisposal?: boolean | undefined;
    hazardWasteIncineration?: number | undefined;
    landfill?: number | undefined;
    recycling?: number | undefined;
    wasteIncinerationEnergyRecovery?: number | undefined;
    wasteIncinerationNoEnergyRecovery?: number | undefined;
    municipalWaste?: number | undefined;
    source?: string | undefined;
    comment?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    material?: Material;
    region?: MasterDropdown;
    updatedByPerson?: Person;
    wasteType?: WasteType;

    constructor(data?: IConsumerEolMaterialDefault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.materialId = _data["materialId"];
            this.wasteTypeId = _data["wasteTypeId"];
            this.sterilizationBeforeDisposal = _data["sterilizationBeforeDisposal"];
            this.hazardWasteIncineration = _data["hazardWasteIncineration"];
            this.landfill = _data["landfill"];
            this.recycling = _data["recycling"];
            this.wasteIncinerationEnergyRecovery = _data["wasteIncinerationEnergyRecovery"];
            this.wasteIncinerationNoEnergyRecovery = _data["wasteIncinerationNoEnergyRecovery"];
            this.municipalWaste = _data["municipalWaste"];
            this.source = _data["source"];
            this.comment = _data["comment"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : undefined as any;
            this.region = _data["region"] ? MasterDropdown.fromJS(_data["region"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.wasteType = _data["wasteType"] ? WasteType.fromJS(_data["wasteType"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConsumerEolMaterialDefault {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerEolMaterialDefault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["materialId"] = this.materialId;
        data["wasteTypeId"] = this.wasteTypeId;
        data["sterilizationBeforeDisposal"] = this.sterilizationBeforeDisposal;
        data["hazardWasteIncineration"] = this.hazardWasteIncineration;
        data["landfill"] = this.landfill;
        data["recycling"] = this.recycling;
        data["wasteIncinerationEnergyRecovery"] = this.wasteIncinerationEnergyRecovery;
        data["wasteIncinerationNoEnergyRecovery"] = this.wasteIncinerationNoEnergyRecovery;
        data["municipalWaste"] = this.municipalWaste;
        data["source"] = this.source;
        data["comment"] = this.comment;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["material"] = this.material ? this.material.toJSON() : undefined as any;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["wasteType"] = this.wasteType ? this.wasteType.toJSON() : undefined as any;
        return data;
    }
}

export interface IConsumerEolMaterialDefault {
    id?: string;
    regionId?: string | undefined;
    materialId?: string | undefined;
    wasteTypeId?: string | undefined;
    sterilizationBeforeDisposal?: boolean | undefined;
    hazardWasteIncineration?: number | undefined;
    landfill?: number | undefined;
    recycling?: number | undefined;
    wasteIncinerationEnergyRecovery?: number | undefined;
    wasteIncinerationNoEnergyRecovery?: number | undefined;
    municipalWaste?: number | undefined;
    source?: string | undefined;
    comment?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    material?: Material;
    region?: MasterDropdown;
    updatedByPerson?: Person;
    wasteType?: WasteType;
}

export class CustomProcessWasteEOL implements ICustomProcessWasteEOL {
    id?: string;
    stepId?: string;
    stepNumber?: number;
    processWasteDetailName?: string | undefined;
    materialTypeName?: string | undefined;
    materialName?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;

    constructor(data?: ICustomProcessWasteEOL) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.stepNumber = _data["stepNumber"];
            this.processWasteDetailName = _data["processWasteDetailName"];
            this.materialTypeName = _data["materialTypeName"];
            this.materialName = _data["materialName"];
            this.climateChange = _data["climateChange"];
            this.waterConsumption = _data["waterConsumption"];
            this.costofGoods = _data["costofGoods"];
            this.totalWeightedScore = _data["totalWeightedScore"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
        }
    }

    static fromJS(data: any): CustomProcessWasteEOL {
        data = typeof data === 'object' ? data : {};
        let result = new CustomProcessWasteEOL();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["stepNumber"] = this.stepNumber;
        data["processWasteDetailName"] = this.processWasteDetailName;
        data["materialTypeName"] = this.materialTypeName;
        data["materialName"] = this.materialName;
        data["climateChange"] = this.climateChange;
        data["waterConsumption"] = this.waterConsumption;
        data["costofGoods"] = this.costofGoods;
        data["totalWeightedScore"] = this.totalWeightedScore;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        return data;
    }
}

export interface ICustomProcessWasteEOL {
    id?: string;
    stepId?: string;
    stepNumber?: number;
    processWasteDetailName?: string | undefined;
    materialTypeName?: string | undefined;
    materialName?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
}

export class DataQualityRating implements IDataQualityRating {
    id?: string;
    dataQualityRatingId?: string | undefined;
    color?: string | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;

    constructor(data?: IDataQualityRating) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataQualityRatingId = _data["dataQualityRatingId"];
            this.color = _data["color"];
            if (Array.isArray(_data["rawMaterialEntry"])) {
                this.rawMaterialEntry = [] as any;
                for (let item of _data["rawMaterialEntry"])
                    this.rawMaterialEntry!.push(RawMaterialEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataQualityRating {
        data = typeof data === 'object' ? data : {};
        let result = new DataQualityRating();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataQualityRatingId"] = this.dataQualityRatingId;
        data["color"] = this.color;
        if (Array.isArray(this.rawMaterialEntry)) {
            data["rawMaterialEntry"] = [];
            for (let item of this.rawMaterialEntry)
                data["rawMaterialEntry"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataQualityRating {
    id?: string;
    dataQualityRatingId?: string | undefined;
    color?: string | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
}

export class DataToSave implements IDataToSave {
    assessmentId?: string;
    screenId?: string;
    materialName?: string | undefined;
    materialDescription?: string | undefined;
    climateChange?: number;
    water?: number;
    costOfGoods?: number;
    waterConsumption?: number;
    solvent?: number;
    pmi?: number;
    emissionFactors?: { [key: string]: number; } | undefined;
    comments?: string | undefined;

    constructor(data?: IDataToSave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.screenId = _data["screenId"];
            this.materialName = _data["materialName"];
            this.materialDescription = _data["materialDescription"];
            this.climateChange = _data["climateChange"];
            this.water = _data["water"];
            this.costOfGoods = _data["costOfGoods"];
            this.waterConsumption = _data["waterConsumption"];
            this.solvent = _data["solvent"];
            this.pmi = _data["pmi"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DataToSave {
        data = typeof data === 'object' ? data : {};
        let result = new DataToSave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["screenId"] = this.screenId;
        data["materialName"] = this.materialName;
        data["materialDescription"] = this.materialDescription;
        data["climateChange"] = this.climateChange;
        data["water"] = this.water;
        data["costOfGoods"] = this.costOfGoods;
        data["waterConsumption"] = this.waterConsumption;
        data["solvent"] = this.solvent;
        data["pmi"] = this.pmi;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDataToSave {
    assessmentId?: string;
    screenId?: string;
    materialName?: string | undefined;
    materialDescription?: string | undefined;
    climateChange?: number;
    water?: number;
    costOfGoods?: number;
    waterConsumption?: number;
    solvent?: number;
    pmi?: number;
    emissionFactors?: { [key: string]: number; } | undefined;
    comments?: string | undefined;
}

export class DevelopmentStage implements IDevelopmentStage {
    id?: string;
    developmentStageName?: string | undefined;
    definition?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;

    constructor(data?: IDevelopmentStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.developmentStageName = _data["developmentStageName"];
            this.definition = _data["definition"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): DevelopmentStage {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentStage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["developmentStageName"] = this.developmentStageName;
        data["definition"] = this.definition;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IDevelopmentStage {
    id?: string;
    developmentStageName?: string | undefined;
    definition?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;
}

export class DistDropdowns implements IDistDropdowns {
    weightUnits?: Unit[] | undefined;

    constructor(data?: IDistDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weightUnits"])) {
                this.weightUnits = [] as any;
                for (let item of _data["weightUnits"])
                    this.weightUnits!.push(Unit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new DistDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weightUnits)) {
            data["weightUnits"] = [];
            for (let item of this.weightUnits)
                data["weightUnits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDistDropdowns {
    weightUnits?: Unit[] | undefined;
}

export class DosesDropdowns implements IDosesDropdowns {
    compOptions?: CompOption[] | undefined;
    unitOperations?: UnitOperation[] | undefined;

    constructor(data?: IDosesDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["compOptions"])) {
                this.compOptions = [] as any;
                for (let item of _data["compOptions"])
                    this.compOptions!.push(CompOption.fromJS(item));
            }
            if (Array.isArray(_data["unitOperations"])) {
                this.unitOperations = [] as any;
                for (let item of _data["unitOperations"])
                    this.unitOperations!.push(UnitOperation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DosesDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new DosesDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.compOptions)) {
            data["compOptions"] = [];
            for (let item of this.compOptions)
                data["compOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperations)) {
            data["unitOperations"] = [];
            for (let item of this.unitOperations)
                data["unitOperations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDosesDropdowns {
    compOptions?: CompOption[] | undefined;
    unitOperations?: UnitOperation[] | undefined;
}

export class Downstream implements IDownstream {
    id?: string;
    typeOfTransportId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    stepId?: string | undefined;
    createdByPerson?: Person;
    step?: Step;
    typeOfTransport?: MasterDropdown;
    updatedByPerson?: Person;

    constructor(data?: IDownstream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeOfTransportId = _data["typeOfTransportId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.stepId = _data["stepId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.typeOfTransport = _data["typeOfTransport"] ? MasterDropdown.fromJS(_data["typeOfTransport"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): Downstream {
        data = typeof data === 'object' ? data : {};
        let result = new Downstream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeOfTransportId"] = this.typeOfTransportId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["stepId"] = this.stepId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["typeOfTransport"] = this.typeOfTransport ? this.typeOfTransport.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IDownstream {
    id?: string;
    typeOfTransportId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    stepId?: string | undefined;
    createdByPerson?: Person;
    step?: Step;
    typeOfTransport?: MasterDropdown;
    updatedByPerson?: Person;
}

export class DownstreamDistribution implements IDownstreamDistribution {
    id?: string;
    downstreamStepId?: string | undefined;
    modeOfTransport?: string | undefined;
    distance?: number | undefined;
    modeOfTransportUnit?: string | undefined;
    tempRequirements?: string | undefined;
    tempStorageTime?: number | undefined;
    tempStorageLocation?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    tempStorageTimeUnitId?: string | undefined;
    createdByPerson?: Person;
    downstreamStep?: DownstreamStep;
    modeOfTransportNavigation?: Transport;
    modeOfTransportUnitNavigation?: Unit;
    tempRequirementsNavigation?: ColdStorage;
    tempStorageLocationNavigation?: SiteLocation;
    tempStorageTimeUnit?: Unit;
    updatedByPerson?: Person;

    constructor(data?: IDownstreamDistribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.downstreamStepId = _data["downstreamStepId"];
            this.modeOfTransport = _data["modeOfTransport"];
            this.distance = _data["distance"];
            this.modeOfTransportUnit = _data["modeOfTransportUnit"];
            this.tempRequirements = _data["tempRequirements"];
            this.tempStorageTime = _data["tempStorageTime"];
            this.tempStorageLocation = _data["tempStorageLocation"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.tempStorageTimeUnitId = _data["tempStorageTimeUnitId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.downstreamStep = _data["downstreamStep"] ? DownstreamStep.fromJS(_data["downstreamStep"]) : undefined as any;
            this.modeOfTransportNavigation = _data["modeOfTransportNavigation"] ? Transport.fromJS(_data["modeOfTransportNavigation"]) : undefined as any;
            this.modeOfTransportUnitNavigation = _data["modeOfTransportUnitNavigation"] ? Unit.fromJS(_data["modeOfTransportUnitNavigation"]) : undefined as any;
            this.tempRequirementsNavigation = _data["tempRequirementsNavigation"] ? ColdStorage.fromJS(_data["tempRequirementsNavigation"]) : undefined as any;
            this.tempStorageLocationNavigation = _data["tempStorageLocationNavigation"] ? SiteLocation.fromJS(_data["tempStorageLocationNavigation"]) : undefined as any;
            this.tempStorageTimeUnit = _data["tempStorageTimeUnit"] ? Unit.fromJS(_data["tempStorageTimeUnit"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): DownstreamDistribution {
        data = typeof data === 'object' ? data : {};
        let result = new DownstreamDistribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["downstreamStepId"] = this.downstreamStepId;
        data["modeOfTransport"] = this.modeOfTransport;
        data["distance"] = this.distance;
        data["modeOfTransportUnit"] = this.modeOfTransportUnit;
        data["tempRequirements"] = this.tempRequirements;
        data["tempStorageTime"] = this.tempStorageTime;
        data["tempStorageLocation"] = this.tempStorageLocation;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["tempStorageTimeUnitId"] = this.tempStorageTimeUnitId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["downstreamStep"] = this.downstreamStep ? this.downstreamStep.toJSON() : undefined as any;
        data["modeOfTransportNavigation"] = this.modeOfTransportNavigation ? this.modeOfTransportNavigation.toJSON() : undefined as any;
        data["modeOfTransportUnitNavigation"] = this.modeOfTransportUnitNavigation ? this.modeOfTransportUnitNavigation.toJSON() : undefined as any;
        data["tempRequirementsNavigation"] = this.tempRequirementsNavigation ? this.tempRequirementsNavigation.toJSON() : undefined as any;
        data["tempStorageLocationNavigation"] = this.tempStorageLocationNavigation ? this.tempStorageLocationNavigation.toJSON() : undefined as any;
        data["tempStorageTimeUnit"] = this.tempStorageTimeUnit ? this.tempStorageTimeUnit.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IDownstreamDistribution {
    id?: string;
    downstreamStepId?: string | undefined;
    modeOfTransport?: string | undefined;
    distance?: number | undefined;
    modeOfTransportUnit?: string | undefined;
    tempRequirements?: string | undefined;
    tempStorageTime?: number | undefined;
    tempStorageLocation?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    tempStorageTimeUnitId?: string | undefined;
    createdByPerson?: Person;
    downstreamStep?: DownstreamStep;
    modeOfTransportNavigation?: Transport;
    modeOfTransportUnitNavigation?: Unit;
    tempRequirementsNavigation?: ColdStorage;
    tempStorageLocationNavigation?: SiteLocation;
    tempStorageTimeUnit?: Unit;
    updatedByPerson?: Person;
}

export class DownstreamDistributionDropdowns implements IDownstreamDistributionDropdowns {
    modeOfTransport?: Transport[] | undefined;
    transportUnit?: Unit[] | undefined;
    tempRequirement?: ColdStorage[] | undefined;
    tempReqUnit?: Unit[] | undefined;
    siteLocation?: SiteLocation[] | undefined;
    typeOfTransport?: MasterDropdown[] | undefined;

    constructor(data?: IDownstreamDistributionDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modeOfTransport"])) {
                this.modeOfTransport = [] as any;
                for (let item of _data["modeOfTransport"])
                    this.modeOfTransport!.push(Transport.fromJS(item));
            }
            if (Array.isArray(_data["transportUnit"])) {
                this.transportUnit = [] as any;
                for (let item of _data["transportUnit"])
                    this.transportUnit!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["tempRequirement"])) {
                this.tempRequirement = [] as any;
                for (let item of _data["tempRequirement"])
                    this.tempRequirement!.push(ColdStorage.fromJS(item));
            }
            if (Array.isArray(_data["tempReqUnit"])) {
                this.tempReqUnit = [] as any;
                for (let item of _data["tempReqUnit"])
                    this.tempReqUnit!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["siteLocation"])) {
                this.siteLocation = [] as any;
                for (let item of _data["siteLocation"])
                    this.siteLocation!.push(SiteLocation.fromJS(item));
            }
            if (Array.isArray(_data["typeOfTransport"])) {
                this.typeOfTransport = [] as any;
                for (let item of _data["typeOfTransport"])
                    this.typeOfTransport!.push(MasterDropdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownstreamDistributionDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new DownstreamDistributionDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modeOfTransport)) {
            data["modeOfTransport"] = [];
            for (let item of this.modeOfTransport)
                data["modeOfTransport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportUnit)) {
            data["transportUnit"] = [];
            for (let item of this.transportUnit)
                data["transportUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tempRequirement)) {
            data["tempRequirement"] = [];
            for (let item of this.tempRequirement)
                data["tempRequirement"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tempReqUnit)) {
            data["tempReqUnit"] = [];
            for (let item of this.tempReqUnit)
                data["tempReqUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.siteLocation)) {
            data["siteLocation"] = [];
            for (let item of this.siteLocation)
                data["siteLocation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.typeOfTransport)) {
            data["typeOfTransport"] = [];
            for (let item of this.typeOfTransport)
                data["typeOfTransport"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDownstreamDistributionDropdowns {
    modeOfTransport?: Transport[] | undefined;
    transportUnit?: Unit[] | undefined;
    tempRequirement?: ColdStorage[] | undefined;
    tempReqUnit?: Unit[] | undefined;
    siteLocation?: SiteLocation[] | undefined;
    typeOfTransport?: MasterDropdown[] | undefined;
}

export class DownstreamStep implements IDownstreamStep {
    id?: string;
    downstreamStepName?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    stepId?: string | undefined;
    createdByPerson?: Person;
    downstreamDistribution?: DownstreamDistribution[] | undefined;
    step?: Step;
    updatedByPerson?: Person;

    constructor(data?: IDownstreamStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.downstreamStepName = _data["downstreamStepName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.stepId = _data["stepId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["downstreamDistribution"])) {
                this.downstreamDistribution = [] as any;
                for (let item of _data["downstreamDistribution"])
                    this.downstreamDistribution!.push(DownstreamDistribution.fromJS(item));
            }
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): DownstreamStep {
        data = typeof data === 'object' ? data : {};
        let result = new DownstreamStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["downstreamStepName"] = this.downstreamStepName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["stepId"] = this.stepId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.downstreamDistribution)) {
            data["downstreamDistribution"] = [];
            for (let item of this.downstreamDistribution)
                data["downstreamDistribution"].push(item ? item.toJSON() : undefined as any);
        }
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IDownstreamStep {
    id?: string;
    downstreamStepName?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    stepId?: string | undefined;
    createdByPerson?: Person;
    downstreamDistribution?: DownstreamDistribution[] | undefined;
    step?: Step;
    updatedByPerson?: Person;
}

export class EmissionFactorTypes implements IEmissionFactorTypes {
    id?: string;
    emissionFactorType?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    createdByPerson?: Person;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IEmissionFactorTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emissionFactorType = _data["emissionFactorType"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["materialEmissionFactor"])) {
                this.materialEmissionFactor = [] as any;
                for (let item of _data["materialEmissionFactor"])
                    this.materialEmissionFactor!.push(MaterialEmissionFactor.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): EmissionFactorTypes {
        data = typeof data === 'object' ? data : {};
        let result = new EmissionFactorTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emissionFactorType"] = this.emissionFactorType;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.materialEmissionFactor)) {
            data["materialEmissionFactor"] = [];
            for (let item of this.materialEmissionFactor)
                data["materialEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IEmissionFactorTypes {
    id?: string;
    emissionFactorType?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    createdByPerson?: Person;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    updatedByPerson?: Person;
}

export class EmissionFactors implements IEmissionFactors {
    id?: string;
    emissionFactorName?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    inactive?: boolean;
    unitOfMeasureTypeId?: string | undefined;
    defaultUnitOfMeasureId?: string | undefined;
    isSelectedByDefault?: boolean;
    weightingMultiplier?: number | undefined;
    selectableForResults?: boolean;
    excludeWfiDuringCalculations?: boolean;
    createdByPerson?: Person;
    defaultUnitOfMeasure?: Unit;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    productProcessProxyEmissionFactor?: ProductProcessProxyEmissionFactor[] | undefined;
    relatableUnit?: RelatableUnit[] | undefined;
    reportSelectedIndicator?: ReportSelectedIndicator[] | undefined;
    transportEmissionFactor?: TransportEmissionFactor[] | undefined;
    unitOfMeasureType?: UnitType;
    updatedByPerson?: Person;
    wasteTypeEmissionFactor?: WasteTypeEmissionFactor[] | undefined;

    constructor(data?: IEmissionFactors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emissionFactorName = _data["emissionFactorName"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.inactive = _data["inactive"];
            this.unitOfMeasureTypeId = _data["unitOfMeasureTypeId"];
            this.defaultUnitOfMeasureId = _data["defaultUnitOfMeasureId"];
            this.isSelectedByDefault = _data["isSelectedByDefault"];
            this.weightingMultiplier = _data["weightingMultiplier"];
            this.selectableForResults = _data["selectableForResults"];
            this.excludeWfiDuringCalculations = _data["excludeWfiDuringCalculations"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.defaultUnitOfMeasure = _data["defaultUnitOfMeasure"] ? Unit.fromJS(_data["defaultUnitOfMeasure"]) : undefined as any;
            if (Array.isArray(_data["energyEmissionFactor"])) {
                this.energyEmissionFactor = [] as any;
                for (let item of _data["energyEmissionFactor"])
                    this.energyEmissionFactor!.push(EnergyEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["materialEmissionFactor"])) {
                this.materialEmissionFactor = [] as any;
                for (let item of _data["materialEmissionFactor"])
                    this.materialEmissionFactor!.push(MaterialEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEmissionFactor"])) {
                this.productProcessProxyEmissionFactor = [] as any;
                for (let item of _data["productProcessProxyEmissionFactor"])
                    this.productProcessProxyEmissionFactor!.push(ProductProcessProxyEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["relatableUnit"])) {
                this.relatableUnit = [] as any;
                for (let item of _data["relatableUnit"])
                    this.relatableUnit!.push(RelatableUnit.fromJS(item));
            }
            if (Array.isArray(_data["reportSelectedIndicator"])) {
                this.reportSelectedIndicator = [] as any;
                for (let item of _data["reportSelectedIndicator"])
                    this.reportSelectedIndicator!.push(ReportSelectedIndicator.fromJS(item));
            }
            if (Array.isArray(_data["transportEmissionFactor"])) {
                this.transportEmissionFactor = [] as any;
                for (let item of _data["transportEmissionFactor"])
                    this.transportEmissionFactor!.push(TransportEmissionFactor.fromJS(item));
            }
            this.unitOfMeasureType = _data["unitOfMeasureType"] ? UnitType.fromJS(_data["unitOfMeasureType"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["wasteTypeEmissionFactor"])) {
                this.wasteTypeEmissionFactor = [] as any;
                for (let item of _data["wasteTypeEmissionFactor"])
                    this.wasteTypeEmissionFactor!.push(WasteTypeEmissionFactor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmissionFactors {
        data = typeof data === 'object' ? data : {};
        let result = new EmissionFactors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emissionFactorName"] = this.emissionFactorName;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["inactive"] = this.inactive;
        data["unitOfMeasureTypeId"] = this.unitOfMeasureTypeId;
        data["defaultUnitOfMeasureId"] = this.defaultUnitOfMeasureId;
        data["isSelectedByDefault"] = this.isSelectedByDefault;
        data["weightingMultiplier"] = this.weightingMultiplier;
        data["selectableForResults"] = this.selectableForResults;
        data["excludeWfiDuringCalculations"] = this.excludeWfiDuringCalculations;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["defaultUnitOfMeasure"] = this.defaultUnitOfMeasure ? this.defaultUnitOfMeasure.toJSON() : undefined as any;
        if (Array.isArray(this.energyEmissionFactor)) {
            data["energyEmissionFactor"] = [];
            for (let item of this.energyEmissionFactor)
                data["energyEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialEmissionFactor)) {
            data["materialEmissionFactor"] = [];
            for (let item of this.materialEmissionFactor)
                data["materialEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEmissionFactor)) {
            data["productProcessProxyEmissionFactor"] = [];
            for (let item of this.productProcessProxyEmissionFactor)
                data["productProcessProxyEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relatableUnit)) {
            data["relatableUnit"] = [];
            for (let item of this.relatableUnit)
                data["relatableUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportSelectedIndicator)) {
            data["reportSelectedIndicator"] = [];
            for (let item of this.reportSelectedIndicator)
                data["reportSelectedIndicator"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportEmissionFactor)) {
            data["transportEmissionFactor"] = [];
            for (let item of this.transportEmissionFactor)
                data["transportEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        data["unitOfMeasureType"] = this.unitOfMeasureType ? this.unitOfMeasureType.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.wasteTypeEmissionFactor)) {
            data["wasteTypeEmissionFactor"] = [];
            for (let item of this.wasteTypeEmissionFactor)
                data["wasteTypeEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmissionFactors {
    id?: string;
    emissionFactorName?: string | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    inactive?: boolean;
    unitOfMeasureTypeId?: string | undefined;
    defaultUnitOfMeasureId?: string | undefined;
    isSelectedByDefault?: boolean;
    weightingMultiplier?: number | undefined;
    selectableForResults?: boolean;
    excludeWfiDuringCalculations?: boolean;
    createdByPerson?: Person;
    defaultUnitOfMeasure?: Unit;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    productProcessProxyEmissionFactor?: ProductProcessProxyEmissionFactor[] | undefined;
    relatableUnit?: RelatableUnit[] | undefined;
    reportSelectedIndicator?: ReportSelectedIndicator[] | undefined;
    transportEmissionFactor?: TransportEmissionFactor[] | undefined;
    unitOfMeasureType?: UnitType;
    updatedByPerson?: Person;
    wasteTypeEmissionFactor?: WasteTypeEmissionFactor[] | undefined;
}

export class Energy implements IEnergy {
    id?: string;
    energyName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    dataSource?: string | undefined;
    dataSourceNotes?: string | undefined;
    energyEF?: EnergyEF[] | undefined;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;
    energyMultipliers?: EnergyMultipliers[] | undefined;

    constructor(data?: IEnergy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.energyName = _data["energyName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.dataSource = _data["dataSource"];
            this.dataSourceNotes = _data["dataSourceNotes"];
            if (Array.isArray(_data["energyEF"])) {
                this.energyEF = [] as any;
                for (let item of _data["energyEF"])
                    this.energyEF!.push(EnergyEF.fromJS(item));
            }
            if (Array.isArray(_data["energyEmissionFactor"])) {
                this.energyEmissionFactor = [] as any;
                for (let item of _data["energyEmissionFactor"])
                    this.energyEmissionFactor!.push(EnergyEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["energyMultipliers"])) {
                this.energyMultipliers = [] as any;
                for (let item of _data["energyMultipliers"])
                    this.energyMultipliers!.push(EnergyMultipliers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Energy {
        data = typeof data === 'object' ? data : {};
        let result = new Energy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["energyName"] = this.energyName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["dataSource"] = this.dataSource;
        data["dataSourceNotes"] = this.dataSourceNotes;
        if (Array.isArray(this.energyEF)) {
            data["energyEF"] = [];
            for (let item of this.energyEF)
                data["energyEF"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyEmissionFactor)) {
            data["energyEmissionFactor"] = [];
            for (let item of this.energyEmissionFactor)
                data["energyEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyMultipliers)) {
            data["energyMultipliers"] = [];
            for (let item of this.energyMultipliers)
                data["energyMultipliers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnergy {
    id?: string;
    energyName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    dataSource?: string | undefined;
    dataSourceNotes?: string | undefined;
    energyEF?: EnergyEF[] | undefined;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;
    energyMultipliers?: EnergyMultipliers[] | undefined;
}

export class EnergyConsumptionDefault implements IEnergyConsumptionDefault {
    id?: string;
    gridAverageMix?: number;
    gridGreenTariff?: number;
    solar?: number;
    wind?: number;
    onSiteHydro?: number;
    onSiteBiomass?: number;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    gridRenewable?: number;

    constructor(data?: IEnergyConsumptionDefault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gridAverageMix = _data["gridAverageMix"];
            this.gridGreenTariff = _data["gridGreenTariff"];
            this.solar = _data["solar"];
            this.wind = _data["wind"];
            this.onSiteHydro = _data["onSiteHydro"];
            this.onSiteBiomass = _data["onSiteBiomass"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.gridRenewable = _data["gridRenewable"];
        }
    }

    static fromJS(data: any): EnergyConsumptionDefault {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyConsumptionDefault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gridAverageMix"] = this.gridAverageMix;
        data["gridGreenTariff"] = this.gridGreenTariff;
        data["solar"] = this.solar;
        data["wind"] = this.wind;
        data["onSiteHydro"] = this.onSiteHydro;
        data["onSiteBiomass"] = this.onSiteBiomass;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["gridRenewable"] = this.gridRenewable;
        return data;
    }
}

export interface IEnergyConsumptionDefault {
    id?: string;
    gridAverageMix?: number;
    gridGreenTariff?: number;
    solar?: number;
    wind?: number;
    onSiteHydro?: number;
    onSiteBiomass?: number;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    gridRenewable?: number;
}

export class EnergyEF implements IEnergyEF {
    id?: string;
    energyId?: string;
    energySourceId?: string | undefined;
    climateChange?: number | undefined;
    waterFreshWaterConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityScore?: number | undefined;
    siteLocationId?: string | undefined;
    energy?: Energy;
    energySource?: EnergySource;
    siteLocation?: SiteLocation;

    constructor(data?: IEnergyEF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.energyId = _data["energyId"];
            this.energySourceId = _data["energySourceId"];
            this.climateChange = _data["climateChange"];
            this.waterFreshWaterConsumption = _data["waterFreshWaterConsumption"];
            this.goodsCost = _data["goodsCost"];
            this.pmi = _data["pmi"];
            this.dataQualityScore = _data["dataQualityScore"];
            this.siteLocationId = _data["siteLocationId"];
            this.energy = _data["energy"] ? Energy.fromJS(_data["energy"]) : undefined as any;
            this.energySource = _data["energySource"] ? EnergySource.fromJS(_data["energySource"]) : undefined as any;
            this.siteLocation = _data["siteLocation"] ? SiteLocation.fromJS(_data["siteLocation"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnergyEF {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyEF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["energyId"] = this.energyId;
        data["energySourceId"] = this.energySourceId;
        data["climateChange"] = this.climateChange;
        data["waterFreshWaterConsumption"] = this.waterFreshWaterConsumption;
        data["goodsCost"] = this.goodsCost;
        data["pmi"] = this.pmi;
        data["dataQualityScore"] = this.dataQualityScore;
        data["siteLocationId"] = this.siteLocationId;
        data["energy"] = this.energy ? this.energy.toJSON() : undefined as any;
        data["energySource"] = this.energySource ? this.energySource.toJSON() : undefined as any;
        data["siteLocation"] = this.siteLocation ? this.siteLocation.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnergyEF {
    id?: string;
    energyId?: string;
    energySourceId?: string | undefined;
    climateChange?: number | undefined;
    waterFreshWaterConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityScore?: number | undefined;
    siteLocationId?: string | undefined;
    energy?: Energy;
    energySource?: EnergySource;
    siteLocation?: SiteLocation;
}

export class EnergyEmissionFactor implements IEnergyEmissionFactor {
    id?: string;
    energySourceId?: string;
    emissionFactorId?: string;
    siteLocationId?: string;
    factor?: number;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    energyId?: string;
    emissionFactor?: EmissionFactors;
    energy?: Energy;
    energySource?: EnergySource;
    siteLocation?: SiteLocation;

    constructor(data?: IEnergyEmissionFactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.energySourceId = _data["energySourceId"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.siteLocationId = _data["siteLocationId"];
            this.factor = _data["factor"];
            this.dataQualityScore = _data["dataQualityScore"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.energyId = _data["energyId"];
            this.emissionFactor = _data["emissionFactor"] ? EmissionFactors.fromJS(_data["emissionFactor"]) : undefined as any;
            this.energy = _data["energy"] ? Energy.fromJS(_data["energy"]) : undefined as any;
            this.energySource = _data["energySource"] ? EnergySource.fromJS(_data["energySource"]) : undefined as any;
            this.siteLocation = _data["siteLocation"] ? SiteLocation.fromJS(_data["siteLocation"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnergyEmissionFactor {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyEmissionFactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["energySourceId"] = this.energySourceId;
        data["emissionFactorId"] = this.emissionFactorId;
        data["siteLocationId"] = this.siteLocationId;
        data["factor"] = this.factor;
        data["dataQualityScore"] = this.dataQualityScore;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["energyId"] = this.energyId;
        data["emissionFactor"] = this.emissionFactor ? this.emissionFactor.toJSON() : undefined as any;
        data["energy"] = this.energy ? this.energy.toJSON() : undefined as any;
        data["energySource"] = this.energySource ? this.energySource.toJSON() : undefined as any;
        data["siteLocation"] = this.siteLocation ? this.siteLocation.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnergyEmissionFactor {
    id?: string;
    energySourceId?: string;
    emissionFactorId?: string;
    siteLocationId?: string;
    factor?: number;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    energyId?: string;
    emissionFactor?: EmissionFactors;
    energy?: Energy;
    energySource?: EnergySource;
    siteLocation?: SiteLocation;
}

export class EnergyMultipliers implements IEnergyMultipliers {
    id?: string;
    energyId?: string;
    moduleScreenId?: string;
    assessmentId?: string | undefined;
    value?: number;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    productFormatSourceScreenId?: string | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    energy?: Energy;
    moduleScreen?: Screen;
    productFormatSourceScreen?: Screen;
    updatedByPerson?: Person;

    constructor(data?: IEnergyMultipliers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.energyId = _data["energyId"];
            this.moduleScreenId = _data["moduleScreenId"];
            this.assessmentId = _data["assessmentId"];
            this.value = _data["value"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.productFormatSourceScreenId = _data["productFormatSourceScreenId"];
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.energy = _data["energy"] ? Energy.fromJS(_data["energy"]) : undefined as any;
            this.moduleScreen = _data["moduleScreen"] ? Screen.fromJS(_data["moduleScreen"]) : undefined as any;
            this.productFormatSourceScreen = _data["productFormatSourceScreen"] ? Screen.fromJS(_data["productFormatSourceScreen"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnergyMultipliers {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyMultipliers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["energyId"] = this.energyId;
        data["moduleScreenId"] = this.moduleScreenId;
        data["assessmentId"] = this.assessmentId;
        data["value"] = this.value;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["productFormatSourceScreenId"] = this.productFormatSourceScreenId;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["energy"] = this.energy ? this.energy.toJSON() : undefined as any;
        data["moduleScreen"] = this.moduleScreen ? this.moduleScreen.toJSON() : undefined as any;
        data["productFormatSourceScreen"] = this.productFormatSourceScreen ? this.productFormatSourceScreen.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnergyMultipliers {
    id?: string;
    energyId?: string;
    moduleScreenId?: string;
    assessmentId?: string | undefined;
    value?: number;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    productFormatSourceScreenId?: string | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    energy?: Energy;
    moduleScreen?: Screen;
    productFormatSourceScreen?: Screen;
    updatedByPerson?: Person;
}

export class EnergySource implements IEnergySource {
    id?: string;
    energySourceName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    energyEF?: EnergyEF[] | undefined;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;

    constructor(data?: IEnergySource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.energySourceName = _data["energySourceName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            if (Array.isArray(_data["energyEF"])) {
                this.energyEF = [] as any;
                for (let item of _data["energyEF"])
                    this.energyEF!.push(EnergyEF.fromJS(item));
            }
            if (Array.isArray(_data["energyEmissionFactor"])) {
                this.energyEmissionFactor = [] as any;
                for (let item of _data["energyEmissionFactor"])
                    this.energyEmissionFactor!.push(EnergyEmissionFactor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnergySource {
        data = typeof data === 'object' ? data : {};
        let result = new EnergySource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["energySourceName"] = this.energySourceName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        if (Array.isArray(this.energyEF)) {
            data["energyEF"] = [];
            for (let item of this.energyEF)
                data["energyEF"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyEmissionFactor)) {
            data["energyEmissionFactor"] = [];
            for (let item of this.energyEmissionFactor)
                data["energyEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnergySource {
    id?: string;
    energySourceName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    energyEF?: EnergyEF[] | undefined;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;
}

export class FavoriteStatus implements IFavoriteStatus {
    actionResult?: string | undefined;
    theFavorite?: Favorites;

    constructor(data?: IFavoriteStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionResult = _data["actionResult"];
            this.theFavorite = _data["theFavorite"] ? Favorites.fromJS(_data["theFavorite"]) : undefined as any;
        }
    }

    static fromJS(data: any): FavoriteStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionResult"] = this.actionResult;
        data["theFavorite"] = this.theFavorite ? this.theFavorite.toJSON() : undefined as any;
        return data;
    }
}

export interface IFavoriteStatus {
    actionResult?: string | undefined;
    theFavorite?: Favorites;
}

export class Favorites implements IFavorites {
    id?: string;
    personId?: string | undefined;
    assessmentId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    person?: Person;

    constructor(data?: IFavorites) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.assessmentId = _data["assessmentId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
        }
    }

    static fromJS(data: any): Favorites {
        data = typeof data === 'object' ? data : {};
        let result = new Favorites();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["assessmentId"] = this.assessmentId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        return data;
    }
}

export interface IFavorites {
    id?: string;
    personId?: string | undefined;
    assessmentId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    person?: Person;
}

export class FeatureFlag implements IFeatureFlag {
    id?: string;
    featureFlagName?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;
    targetEnvironments?: string | undefined;
    conditions?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    rolloutPercentage?: number | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    notes?: string | undefined;
    isActive?: boolean;
    createdByPerson?: Person;
    updatedByPerson?: Person;

    constructor(data?: IFeatureFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.featureFlagName = _data["featureFlagName"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.targetEnvironments = _data["targetEnvironments"];
            this.conditions = _data["conditions"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.rolloutPercentage = _data["rolloutPercentage"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.isActive = _data["isActive"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): FeatureFlag {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["featureFlagName"] = this.featureFlagName;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["targetEnvironments"] = this.targetEnvironments;
        data["conditions"] = this.conditions;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["rolloutPercentage"] = this.rolloutPercentage;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["isActive"] = this.isActive;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IFeatureFlag {
    id?: string;
    featureFlagName?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;
    targetEnvironments?: string | undefined;
    conditions?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    rolloutPercentage?: number | undefined;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    notes?: string | undefined;
    isActive?: boolean;
    createdByPerson?: Person;
    updatedByPerson?: Person;
}

export class FinalAccessStatus implements IFinalAccessStatus {
    screenId?: string;
    screenName?: string | undefined;
    accessType?: string | undefined;
    userTypeWon?: string | undefined;

    constructor(data?: IFinalAccessStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenId = _data["screenId"];
            this.screenName = _data["screenName"];
            this.accessType = _data["accessType"];
            this.userTypeWon = _data["userTypeWon"];
        }
    }

    static fromJS(data: any): FinalAccessStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FinalAccessStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenId"] = this.screenId;
        data["screenName"] = this.screenName;
        data["accessType"] = this.accessType;
        data["userTypeWon"] = this.userTypeWon;
        return data;
    }
}

export interface IFinalAccessStatus {
    screenId?: string;
    screenName?: string | undefined;
    accessType?: string | undefined;
    userTypeWon?: string | undefined;
}

export class FixSingleIntermediateFromUI implements IFixSingleIntermediateFromUI {
    action?: string | undefined;
    sourceStepId?: string;
    wrongIntermediateId?: string;
    rightIntermediateId?: string;

    constructor(data?: IFixSingleIntermediateFromUI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.sourceStepId = _data["sourceStepId"];
            this.wrongIntermediateId = _data["wrongIntermediateId"];
            this.rightIntermediateId = _data["rightIntermediateId"];
        }
    }

    static fromJS(data: any): FixSingleIntermediateFromUI {
        data = typeof data === 'object' ? data : {};
        let result = new FixSingleIntermediateFromUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["sourceStepId"] = this.sourceStepId;
        data["wrongIntermediateId"] = this.wrongIntermediateId;
        data["rightIntermediateId"] = this.rightIntermediateId;
        return data;
    }
}

export interface IFixSingleIntermediateFromUI {
    action?: string | undefined;
    sourceStepId?: string;
    wrongIntermediateId?: string;
    rightIntermediateId?: string;
}

export class GeneralBioDropdowns implements IGeneralBioDropdowns {
    weightUnits?: Unit[] | undefined;
    concentrationUnits?: Unit[] | undefined;
    locations?: SiteLocation[] | undefined;

    constructor(data?: IGeneralBioDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weightUnits"])) {
                this.weightUnits = [] as any;
                for (let item of _data["weightUnits"])
                    this.weightUnits!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["concentrationUnits"])) {
                this.concentrationUnits = [] as any;
                for (let item of _data["concentrationUnits"])
                    this.concentrationUnits!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(SiteLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralBioDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralBioDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weightUnits)) {
            data["weightUnits"] = [];
            for (let item of this.weightUnits)
                data["weightUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.concentrationUnits)) {
            data["concentrationUnits"] = [];
            for (let item of this.concentrationUnits)
                data["concentrationUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGeneralBioDropdowns {
    weightUnits?: Unit[] | undefined;
    concentrationUnits?: Unit[] | undefined;
    locations?: SiteLocation[] | undefined;
}

export class GeneralInformation implements IGeneralInformation {
    id?: string;
    assessmentId?: string;
    notes?: string | undefined;
    screenId?: string;
    versionName?: string | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;
    doseFromId?: string | undefined;
    isDefaultLoaction?: boolean | undefined;
    versionNumber?: number | undefined;
    doseStrength?: string | undefined;
    doseUnitId?: string | undefined;
    proteinMassOutput?: number | undefined;
    proteinMOUnitId?: string | undefined;
    concProteinMassProdOutput?: number | undefined;
    concentrationUnitId?: string | undefined;
    siteLocationId?: string | undefined;
    compOptionId?: string | undefined;
    packReferenceUnitId?: string | undefined;
    packDoseStrength?: string | undefined;
    packDoseUnit?: string | undefined;
    packRefUnitPerPPack?: number | undefined;
    packPriPacksPerSecPack?: number | undefined;
    packSecPacksPerTerPack?: number | undefined;
    packTerPacksPerPallet?: number | undefined;
    packDeviceUsed?: boolean | undefined;
    packLifetimeRefUnitsPerDevice?: number | undefined;
    packDevicePerDevSecPack?: number | undefined;
    packDevSecPerDevTer?: number | undefined;
    packDevTerPerDevPallet?: number | undefined;
    distDrugProductMass?: number | undefined;
    distDosesPerPallet?: number | undefined;
    distTotalMassOfPallet?: number | undefined;
    distDrugProductMassUnitId?: string | undefined;
    distDosesPerPalletUnitId?: string | undefined;
    distTotalMassOfPalletUnitId?: string | undefined;
    productFormatId?: string | undefined;
    massPerProductFormat?: number | undefined;
    massPerProductFormatUnitId?: string | undefined;
    wetWeightOutput?: number | undefined;
    generalInformationName?: string | undefined;
    wasSelected?: boolean;
    isActive?: boolean;
    graphNodePositionsJson?: string | undefined;
    assessment?: Assessment;
    compOption?: CompOption;
    concentrationUnit?: Unit;
    createdByPerson?: Person;
    distDosesPerPalletUnit?: Unit;
    distDrugProductMassUnit?: Unit;
    distTotalMassOfPalletUnit?: Unit;
    doseUnit?: Unit;
    massPerProductFormatUnit?: Unit;
    packReferenceUnit?: MasterDropdown;
    productFormat?: ProductFormat;
    proteinMOUnit?: Unit;
    rawMaterial?: RawMaterial[] | undefined;
    reportAlternativedistributionGI?: ReportAlternative[] | undefined;
    reportAlternativepackagingGI?: ReportAlternative[] | undefined;
    reportConfigurationbaselineDistributionGI?: ReportConfiguration[] | undefined;
    reportConfigurationbaselinePackagingGI?: ReportConfiguration[] | undefined;
    screen?: Screen;
    siteLocation?: SiteLocation;
    step?: Step[] | undefined;
    updatedByPerson?: Person;
    utilities?: Utilities[] | undefined;

    constructor(data?: IGeneralInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentId = _data["assessmentId"];
            this.notes = _data["notes"];
            this.screenId = _data["screenId"];
            this.versionName = _data["versionName"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.doseFromId = _data["doseFromId"];
            this.isDefaultLoaction = _data["isDefaultLoaction"];
            this.versionNumber = _data["versionNumber"];
            this.doseStrength = _data["doseStrength"];
            this.doseUnitId = _data["doseUnitId"];
            this.proteinMassOutput = _data["proteinMassOutput"];
            this.proteinMOUnitId = _data["proteinMOUnitId"];
            this.concProteinMassProdOutput = _data["concProteinMassProdOutput"];
            this.concentrationUnitId = _data["concentrationUnitId"];
            this.siteLocationId = _data["siteLocationId"];
            this.compOptionId = _data["compOptionId"];
            this.packReferenceUnitId = _data["packReferenceUnitId"];
            this.packDoseStrength = _data["packDoseStrength"];
            this.packDoseUnit = _data["packDoseUnit"];
            this.packRefUnitPerPPack = _data["packRefUnitPerPPack"];
            this.packPriPacksPerSecPack = _data["packPriPacksPerSecPack"];
            this.packSecPacksPerTerPack = _data["packSecPacksPerTerPack"];
            this.packTerPacksPerPallet = _data["packTerPacksPerPallet"];
            this.packDeviceUsed = _data["packDeviceUsed"];
            this.packLifetimeRefUnitsPerDevice = _data["packLifetimeRefUnitsPerDevice"];
            this.packDevicePerDevSecPack = _data["packDevicePerDevSecPack"];
            this.packDevSecPerDevTer = _data["packDevSecPerDevTer"];
            this.packDevTerPerDevPallet = _data["packDevTerPerDevPallet"];
            this.distDrugProductMass = _data["distDrugProductMass"];
            this.distDosesPerPallet = _data["distDosesPerPallet"];
            this.distTotalMassOfPallet = _data["distTotalMassOfPallet"];
            this.distDrugProductMassUnitId = _data["distDrugProductMassUnitId"];
            this.distDosesPerPalletUnitId = _data["distDosesPerPalletUnitId"];
            this.distTotalMassOfPalletUnitId = _data["distTotalMassOfPalletUnitId"];
            this.productFormatId = _data["productFormatId"];
            this.massPerProductFormat = _data["massPerProductFormat"];
            this.massPerProductFormatUnitId = _data["massPerProductFormatUnitId"];
            this.wetWeightOutput = _data["wetWeightOutput"];
            this.generalInformationName = _data["generalInformationName"];
            this.wasSelected = _data["wasSelected"];
            this.isActive = _data["isActive"];
            this.graphNodePositionsJson = _data["graphNodePositionsJson"];
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.compOption = _data["compOption"] ? CompOption.fromJS(_data["compOption"]) : undefined as any;
            this.concentrationUnit = _data["concentrationUnit"] ? Unit.fromJS(_data["concentrationUnit"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.distDosesPerPalletUnit = _data["distDosesPerPalletUnit"] ? Unit.fromJS(_data["distDosesPerPalletUnit"]) : undefined as any;
            this.distDrugProductMassUnit = _data["distDrugProductMassUnit"] ? Unit.fromJS(_data["distDrugProductMassUnit"]) : undefined as any;
            this.distTotalMassOfPalletUnit = _data["distTotalMassOfPalletUnit"] ? Unit.fromJS(_data["distTotalMassOfPalletUnit"]) : undefined as any;
            this.doseUnit = _data["doseUnit"] ? Unit.fromJS(_data["doseUnit"]) : undefined as any;
            this.massPerProductFormatUnit = _data["massPerProductFormatUnit"] ? Unit.fromJS(_data["massPerProductFormatUnit"]) : undefined as any;
            this.packReferenceUnit = _data["packReferenceUnit"] ? MasterDropdown.fromJS(_data["packReferenceUnit"]) : undefined as any;
            this.productFormat = _data["productFormat"] ? ProductFormat.fromJS(_data["productFormat"]) : undefined as any;
            this.proteinMOUnit = _data["proteinMOUnit"] ? Unit.fromJS(_data["proteinMOUnit"]) : undefined as any;
            if (Array.isArray(_data["rawMaterial"])) {
                this.rawMaterial = [] as any;
                for (let item of _data["rawMaterial"])
                    this.rawMaterial!.push(RawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["reportAlternativedistributionGI"])) {
                this.reportAlternativedistributionGI = [] as any;
                for (let item of _data["reportAlternativedistributionGI"])
                    this.reportAlternativedistributionGI!.push(ReportAlternative.fromJS(item));
            }
            if (Array.isArray(_data["reportAlternativepackagingGI"])) {
                this.reportAlternativepackagingGI = [] as any;
                for (let item of _data["reportAlternativepackagingGI"])
                    this.reportAlternativepackagingGI!.push(ReportAlternative.fromJS(item));
            }
            if (Array.isArray(_data["reportConfigurationbaselineDistributionGI"])) {
                this.reportConfigurationbaselineDistributionGI = [] as any;
                for (let item of _data["reportConfigurationbaselineDistributionGI"])
                    this.reportConfigurationbaselineDistributionGI!.push(ReportConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["reportConfigurationbaselinePackagingGI"])) {
                this.reportConfigurationbaselinePackagingGI = [] as any;
                for (let item of _data["reportConfigurationbaselinePackagingGI"])
                    this.reportConfigurationbaselinePackagingGI!.push(ReportConfiguration.fromJS(item));
            }
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.siteLocation = _data["siteLocation"] ? SiteLocation.fromJS(_data["siteLocation"]) : undefined as any;
            if (Array.isArray(_data["step"])) {
                this.step = [] as any;
                for (let item of _data["step"])
                    this.step!.push(Step.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(Utilities.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralInformation {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentId"] = this.assessmentId;
        data["notes"] = this.notes;
        data["screenId"] = this.screenId;
        data["versionName"] = this.versionName;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["doseFromId"] = this.doseFromId;
        data["isDefaultLoaction"] = this.isDefaultLoaction;
        data["versionNumber"] = this.versionNumber;
        data["doseStrength"] = this.doseStrength;
        data["doseUnitId"] = this.doseUnitId;
        data["proteinMassOutput"] = this.proteinMassOutput;
        data["proteinMOUnitId"] = this.proteinMOUnitId;
        data["concProteinMassProdOutput"] = this.concProteinMassProdOutput;
        data["concentrationUnitId"] = this.concentrationUnitId;
        data["siteLocationId"] = this.siteLocationId;
        data["compOptionId"] = this.compOptionId;
        data["packReferenceUnitId"] = this.packReferenceUnitId;
        data["packDoseStrength"] = this.packDoseStrength;
        data["packDoseUnit"] = this.packDoseUnit;
        data["packRefUnitPerPPack"] = this.packRefUnitPerPPack;
        data["packPriPacksPerSecPack"] = this.packPriPacksPerSecPack;
        data["packSecPacksPerTerPack"] = this.packSecPacksPerTerPack;
        data["packTerPacksPerPallet"] = this.packTerPacksPerPallet;
        data["packDeviceUsed"] = this.packDeviceUsed;
        data["packLifetimeRefUnitsPerDevice"] = this.packLifetimeRefUnitsPerDevice;
        data["packDevicePerDevSecPack"] = this.packDevicePerDevSecPack;
        data["packDevSecPerDevTer"] = this.packDevSecPerDevTer;
        data["packDevTerPerDevPallet"] = this.packDevTerPerDevPallet;
        data["distDrugProductMass"] = this.distDrugProductMass;
        data["distDosesPerPallet"] = this.distDosesPerPallet;
        data["distTotalMassOfPallet"] = this.distTotalMassOfPallet;
        data["distDrugProductMassUnitId"] = this.distDrugProductMassUnitId;
        data["distDosesPerPalletUnitId"] = this.distDosesPerPalletUnitId;
        data["distTotalMassOfPalletUnitId"] = this.distTotalMassOfPalletUnitId;
        data["productFormatId"] = this.productFormatId;
        data["massPerProductFormat"] = this.massPerProductFormat;
        data["massPerProductFormatUnitId"] = this.massPerProductFormatUnitId;
        data["wetWeightOutput"] = this.wetWeightOutput;
        data["generalInformationName"] = this.generalInformationName;
        data["wasSelected"] = this.wasSelected;
        data["isActive"] = this.isActive;
        data["graphNodePositionsJson"] = this.graphNodePositionsJson;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["compOption"] = this.compOption ? this.compOption.toJSON() : undefined as any;
        data["concentrationUnit"] = this.concentrationUnit ? this.concentrationUnit.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["distDosesPerPalletUnit"] = this.distDosesPerPalletUnit ? this.distDosesPerPalletUnit.toJSON() : undefined as any;
        data["distDrugProductMassUnit"] = this.distDrugProductMassUnit ? this.distDrugProductMassUnit.toJSON() : undefined as any;
        data["distTotalMassOfPalletUnit"] = this.distTotalMassOfPalletUnit ? this.distTotalMassOfPalletUnit.toJSON() : undefined as any;
        data["doseUnit"] = this.doseUnit ? this.doseUnit.toJSON() : undefined as any;
        data["massPerProductFormatUnit"] = this.massPerProductFormatUnit ? this.massPerProductFormatUnit.toJSON() : undefined as any;
        data["packReferenceUnit"] = this.packReferenceUnit ? this.packReferenceUnit.toJSON() : undefined as any;
        data["productFormat"] = this.productFormat ? this.productFormat.toJSON() : undefined as any;
        data["proteinMOUnit"] = this.proteinMOUnit ? this.proteinMOUnit.toJSON() : undefined as any;
        if (Array.isArray(this.rawMaterial)) {
            data["rawMaterial"] = [];
            for (let item of this.rawMaterial)
                data["rawMaterial"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportAlternativedistributionGI)) {
            data["reportAlternativedistributionGI"] = [];
            for (let item of this.reportAlternativedistributionGI)
                data["reportAlternativedistributionGI"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportAlternativepackagingGI)) {
            data["reportAlternativepackagingGI"] = [];
            for (let item of this.reportAlternativepackagingGI)
                data["reportAlternativepackagingGI"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportConfigurationbaselineDistributionGI)) {
            data["reportConfigurationbaselineDistributionGI"] = [];
            for (let item of this.reportConfigurationbaselineDistributionGI)
                data["reportConfigurationbaselineDistributionGI"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportConfigurationbaselinePackagingGI)) {
            data["reportConfigurationbaselinePackagingGI"] = [];
            for (let item of this.reportConfigurationbaselinePackagingGI)
                data["reportConfigurationbaselinePackagingGI"].push(item ? item.toJSON() : undefined as any);
        }
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["siteLocation"] = this.siteLocation ? this.siteLocation.toJSON() : undefined as any;
        if (Array.isArray(this.step)) {
            data["step"] = [];
            for (let item of this.step)
                data["step"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGeneralInformation {
    id?: string;
    assessmentId?: string;
    notes?: string | undefined;
    screenId?: string;
    versionName?: string | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;
    doseFromId?: string | undefined;
    isDefaultLoaction?: boolean | undefined;
    versionNumber?: number | undefined;
    doseStrength?: string | undefined;
    doseUnitId?: string | undefined;
    proteinMassOutput?: number | undefined;
    proteinMOUnitId?: string | undefined;
    concProteinMassProdOutput?: number | undefined;
    concentrationUnitId?: string | undefined;
    siteLocationId?: string | undefined;
    compOptionId?: string | undefined;
    packReferenceUnitId?: string | undefined;
    packDoseStrength?: string | undefined;
    packDoseUnit?: string | undefined;
    packRefUnitPerPPack?: number | undefined;
    packPriPacksPerSecPack?: number | undefined;
    packSecPacksPerTerPack?: number | undefined;
    packTerPacksPerPallet?: number | undefined;
    packDeviceUsed?: boolean | undefined;
    packLifetimeRefUnitsPerDevice?: number | undefined;
    packDevicePerDevSecPack?: number | undefined;
    packDevSecPerDevTer?: number | undefined;
    packDevTerPerDevPallet?: number | undefined;
    distDrugProductMass?: number | undefined;
    distDosesPerPallet?: number | undefined;
    distTotalMassOfPallet?: number | undefined;
    distDrugProductMassUnitId?: string | undefined;
    distDosesPerPalletUnitId?: string | undefined;
    distTotalMassOfPalletUnitId?: string | undefined;
    productFormatId?: string | undefined;
    massPerProductFormat?: number | undefined;
    massPerProductFormatUnitId?: string | undefined;
    wetWeightOutput?: number | undefined;
    generalInformationName?: string | undefined;
    wasSelected?: boolean;
    isActive?: boolean;
    graphNodePositionsJson?: string | undefined;
    assessment?: Assessment;
    compOption?: CompOption;
    concentrationUnit?: Unit;
    createdByPerson?: Person;
    distDosesPerPalletUnit?: Unit;
    distDrugProductMassUnit?: Unit;
    distTotalMassOfPalletUnit?: Unit;
    doseUnit?: Unit;
    massPerProductFormatUnit?: Unit;
    packReferenceUnit?: MasterDropdown;
    productFormat?: ProductFormat;
    proteinMOUnit?: Unit;
    rawMaterial?: RawMaterial[] | undefined;
    reportAlternativedistributionGI?: ReportAlternative[] | undefined;
    reportAlternativepackagingGI?: ReportAlternative[] | undefined;
    reportConfigurationbaselineDistributionGI?: ReportConfiguration[] | undefined;
    reportConfigurationbaselinePackagingGI?: ReportConfiguration[] | undefined;
    screen?: Screen;
    siteLocation?: SiteLocation;
    step?: Step[] | undefined;
    updatedByPerson?: Person;
    utilities?: Utilities[] | undefined;
}

export class GeneratedAssessmentNumber implements IGeneratedAssessmentNumber {
    assessmentNumber?: number;
    error?: boolean;

    constructor(data?: IGeneratedAssessmentNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentNumber = _data["assessmentNumber"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GeneratedAssessmentNumber {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratedAssessmentNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentNumber"] = this.assessmentNumber;
        data["error"] = this.error;
        return data;
    }
}

export interface IGeneratedAssessmentNumber {
    assessmentNumber?: number;
    error?: boolean;
}

export class GlobalDataForLoading implements IGlobalDataForLoading {
    rawMaterial?: RawMaterial;
    rawMaterialCompleteData?: RawMaterialCompleteData;

    constructor(data?: IGlobalDataForLoading) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawMaterial = _data["rawMaterial"] ? RawMaterial.fromJS(_data["rawMaterial"]) : undefined as any;
            this.rawMaterialCompleteData = _data["rawMaterialCompleteData"] ? RawMaterialCompleteData.fromJS(_data["rawMaterialCompleteData"]) : undefined as any;
        }
    }

    static fromJS(data: any): GlobalDataForLoading {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalDataForLoading();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : undefined as any;
        data["rawMaterialCompleteData"] = this.rawMaterialCompleteData ? this.rawMaterialCompleteData.toJSON() : undefined as any;
        return data;
    }
}

export interface IGlobalDataForLoading {
    rawMaterial?: RawMaterial;
    rawMaterialCompleteData?: RawMaterialCompleteData;
}

export class HelpField implements IHelpField {
    id?: string;
    elementName?: string | undefined;
    userFriendlyName?: string | undefined;
    helpTextShort?: string | undefined;
    helpTextLong?: string | undefined;
    helpPageId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    helpPage?: HelpPage;
    updatedByPerson?: Person;

    constructor(data?: IHelpField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.elementName = _data["elementName"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.helpTextShort = _data["helpTextShort"];
            this.helpTextLong = _data["helpTextLong"];
            this.helpPageId = _data["helpPageId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.helpPage = _data["helpPage"] ? HelpPage.fromJS(_data["helpPage"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): HelpField {
        data = typeof data === 'object' ? data : {};
        let result = new HelpField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["elementName"] = this.elementName;
        data["userFriendlyName"] = this.userFriendlyName;
        data["helpTextShort"] = this.helpTextShort;
        data["helpTextLong"] = this.helpTextLong;
        data["helpPageId"] = this.helpPageId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["helpPage"] = this.helpPage ? this.helpPage.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IHelpField {
    id?: string;
    elementName?: string | undefined;
    userFriendlyName?: string | undefined;
    helpTextShort?: string | undefined;
    helpTextLong?: string | undefined;
    helpPageId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    helpPage?: HelpPage;
    updatedByPerson?: Person;
}

export class HelpPage implements IHelpPage {
    id?: string;
    helpPageName?: string | undefined;
    helpContent?: string | undefined;
    userFriendlyName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    helpField?: HelpField[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IHelpPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.helpPageName = _data["helpPageName"];
            this.helpContent = _data["helpContent"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["helpField"])) {
                this.helpField = [] as any;
                for (let item of _data["helpField"])
                    this.helpField!.push(HelpField.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): HelpPage {
        data = typeof data === 'object' ? data : {};
        let result = new HelpPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["helpPageName"] = this.helpPageName;
        data["helpContent"] = this.helpContent;
        data["userFriendlyName"] = this.userFriendlyName;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.helpField)) {
            data["helpField"] = [];
            for (let item of this.helpField)
                data["helpField"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IHelpPage {
    id?: string;
    helpPageName?: string | undefined;
    helpContent?: string | undefined;
    userFriendlyName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    helpField?: HelpField[] | undefined;
    updatedByPerson?: Person;
}

export class History implements IHistory {
    id?: string;
    personId?: string | undefined;
    assessmentId?: string | undefined;
    lastAccessTimeStamp?: Date | undefined;
    assessment?: Assessment;
    person?: Person;

    constructor(data?: IHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.assessmentId = _data["assessmentId"];
            this.lastAccessTimeStamp = _data["lastAccessTimeStamp"] ? new Date(_data["lastAccessTimeStamp"].toString()) : undefined as any;
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
        }
    }

    static fromJS(data: any): History {
        data = typeof data === 'object' ? data : {};
        let result = new History();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["assessmentId"] = this.assessmentId;
        data["lastAccessTimeStamp"] = this.lastAccessTimeStamp ? this.lastAccessTimeStamp.toISOString() : undefined as any;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        return data;
    }
}

export interface IHistory {
    id?: string;
    personId?: string | undefined;
    assessmentId?: string | undefined;
    lastAccessTimeStamp?: Date | undefined;
    assessment?: Assessment;
    person?: Person;
}

export class HvacUtilitiesData implements IHvacUtilitiesData {
    utilitiesId?: string;
    hvacRequired?: boolean;
    facility?: string | undefined;
    cleanRoomClass?: string | undefined;
    roomArea?: number | undefined;
    totalStep?: number | undefined;

    constructor(data?: IHvacUtilitiesData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilitiesId = _data["utilitiesId"];
            this.hvacRequired = _data["hvacRequired"];
            this.facility = _data["facility"];
            this.cleanRoomClass = _data["cleanRoomClass"];
            this.roomArea = _data["roomArea"];
            this.totalStep = _data["totalStep"];
        }
    }

    static fromJS(data: any): HvacUtilitiesData {
        data = typeof data === 'object' ? data : {};
        let result = new HvacUtilitiesData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilitiesId"] = this.utilitiesId;
        data["hvacRequired"] = this.hvacRequired;
        data["facility"] = this.facility;
        data["cleanRoomClass"] = this.cleanRoomClass;
        data["roomArea"] = this.roomArea;
        data["totalStep"] = this.totalStep;
        return data;
    }
}

export interface IHvacUtilitiesData {
    utilitiesId?: string;
    hvacRequired?: boolean;
    facility?: string | undefined;
    cleanRoomClass?: string | undefined;
    roomArea?: number | undefined;
    totalStep?: number | undefined;
}

export class IdentityProviderStatus implements IIdentityProviderStatus {
    id?: string;
    statusCode?: string | undefined;
    statusName?: string | undefined;
    description?: string | undefined;
    colorRgb?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    createdTimestamp?: Date;
    updatedTimestamp?: Date | undefined;
    personIdentityStatus?: PersonIdentityStatus[] | undefined;

    constructor(data?: IIdentityProviderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.description = _data["description"];
            this.colorRgb = _data["colorRgb"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            if (Array.isArray(_data["personIdentityStatus"])) {
                this.personIdentityStatus = [] as any;
                for (let item of _data["personIdentityStatus"])
                    this.personIdentityStatus!.push(PersonIdentityStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityProviderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityProviderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["description"] = this.description;
        data["colorRgb"] = this.colorRgb;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        if (Array.isArray(this.personIdentityStatus)) {
            data["personIdentityStatus"] = [];
            for (let item of this.personIdentityStatus)
                data["personIdentityStatus"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIdentityProviderStatus {
    id?: string;
    statusCode?: string | undefined;
    statusName?: string | undefined;
    description?: string | undefined;
    colorRgb?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    createdTimestamp?: Date;
    updatedTimestamp?: Date | undefined;
    personIdentityStatus?: PersonIdentityStatus[] | undefined;
}

export class InboundTransportForMaterials implements IInboundTransportForMaterials {
    id?: string | undefined;
    stepId?: string | undefined;
    materialId?: string | undefined;
    materialRowId?: string | undefined;
    rawMaterialId?: string | undefined;
    intermediateStepId?: string | undefined;
    materialName?: string | undefined;
    modeOfTransportId?: string | undefined;
    modeOfTransport?: string | undefined;
    distance?: number | undefined;
    unitId?: string | undefined;
    unitName?: string | undefined;
    isNew?: boolean | undefined;
    isEditable?: boolean | undefined;
    isIntermediate?: boolean | undefined;
    lastOne?: boolean | undefined;
    isTitle?: boolean | undefined;
    isAPIProxy?: boolean | undefined;
    productProcessProxyId?: string | undefined;
    productProcessProxyEntryId?: string | undefined;

    constructor(data?: IInboundTransportForMaterials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.materialId = _data["materialId"];
            this.materialRowId = _data["materialRowId"];
            this.rawMaterialId = _data["rawMaterialId"];
            this.intermediateStepId = _data["intermediateStepId"];
            this.materialName = _data["materialName"];
            this.modeOfTransportId = _data["modeOfTransportId"];
            this.modeOfTransport = _data["modeOfTransport"];
            this.distance = _data["distance"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            this.isNew = _data["isNew"];
            this.isEditable = _data["isEditable"];
            this.isIntermediate = _data["isIntermediate"];
            this.lastOne = _data["lastOne"];
            this.isTitle = _data["isTitle"];
            this.isAPIProxy = _data["isAPIProxy"];
            this.productProcessProxyId = _data["productProcessProxyId"];
            this.productProcessProxyEntryId = _data["productProcessProxyEntryId"];
        }
    }

    static fromJS(data: any): InboundTransportForMaterials {
        data = typeof data === 'object' ? data : {};
        let result = new InboundTransportForMaterials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["materialId"] = this.materialId;
        data["materialRowId"] = this.materialRowId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["intermediateStepId"] = this.intermediateStepId;
        data["materialName"] = this.materialName;
        data["modeOfTransportId"] = this.modeOfTransportId;
        data["modeOfTransport"] = this.modeOfTransport;
        data["distance"] = this.distance;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        data["isNew"] = this.isNew;
        data["isEditable"] = this.isEditable;
        data["isIntermediate"] = this.isIntermediate;
        data["lastOne"] = this.lastOne;
        data["isTitle"] = this.isTitle;
        data["isAPIProxy"] = this.isAPIProxy;
        data["productProcessProxyId"] = this.productProcessProxyId;
        data["productProcessProxyEntryId"] = this.productProcessProxyEntryId;
        return data;
    }
}

export interface IInboundTransportForMaterials {
    id?: string | undefined;
    stepId?: string | undefined;
    materialId?: string | undefined;
    materialRowId?: string | undefined;
    rawMaterialId?: string | undefined;
    intermediateStepId?: string | undefined;
    materialName?: string | undefined;
    modeOfTransportId?: string | undefined;
    modeOfTransport?: string | undefined;
    distance?: number | undefined;
    unitId?: string | undefined;
    unitName?: string | undefined;
    isNew?: boolean | undefined;
    isEditable?: boolean | undefined;
    isIntermediate?: boolean | undefined;
    lastOne?: boolean | undefined;
    isTitle?: boolean | undefined;
    isAPIProxy?: boolean | undefined;
    productProcessProxyId?: string | undefined;
    productProcessProxyEntryId?: string | undefined;
}

export class IntermediateStatus implements IIntermediateStatus {
    wrongOriginalAssessmentName?: string | undefined;
    wrongOriginalAssessmentId?: string | undefined;
    wrongIntermediateId?: string | undefined;
    wrongIntermediateName?: string | undefined;
    possibleRightIntermediateId?: string | undefined;
    possibleRightIntermediateName?: string | undefined;
    isDeleted?: boolean;
    deletedStepName?: string | undefined;
    isWrong?: boolean;
    isPossibleRightIntermediatePresent?: boolean;
    isImpossible?: boolean;

    constructor(data?: IIntermediateStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wrongOriginalAssessmentName = _data["wrongOriginalAssessmentName"];
            this.wrongOriginalAssessmentId = _data["wrongOriginalAssessmentId"];
            this.wrongIntermediateId = _data["wrongIntermediateId"];
            this.wrongIntermediateName = _data["wrongIntermediateName"];
            this.possibleRightIntermediateId = _data["possibleRightIntermediateId"];
            this.possibleRightIntermediateName = _data["possibleRightIntermediateName"];
            this.isDeleted = _data["isDeleted"];
            this.deletedStepName = _data["deletedStepName"];
            this.isWrong = _data["isWrong"];
            this.isPossibleRightIntermediatePresent = _data["isPossibleRightIntermediatePresent"];
            this.isImpossible = _data["isImpossible"];
        }
    }

    static fromJS(data: any): IntermediateStatus {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediateStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wrongOriginalAssessmentName"] = this.wrongOriginalAssessmentName;
        data["wrongOriginalAssessmentId"] = this.wrongOriginalAssessmentId;
        data["wrongIntermediateId"] = this.wrongIntermediateId;
        data["wrongIntermediateName"] = this.wrongIntermediateName;
        data["possibleRightIntermediateId"] = this.possibleRightIntermediateId;
        data["possibleRightIntermediateName"] = this.possibleRightIntermediateName;
        data["isDeleted"] = this.isDeleted;
        data["deletedStepName"] = this.deletedStepName;
        data["isWrong"] = this.isWrong;
        data["isPossibleRightIntermediatePresent"] = this.isPossibleRightIntermediatePresent;
        data["isImpossible"] = this.isImpossible;
        return data;
    }
}

export interface IIntermediateStatus {
    wrongOriginalAssessmentName?: string | undefined;
    wrongOriginalAssessmentId?: string | undefined;
    wrongIntermediateId?: string | undefined;
    wrongIntermediateName?: string | undefined;
    possibleRightIntermediateId?: string | undefined;
    possibleRightIntermediateName?: string | undefined;
    isDeleted?: boolean;
    deletedStepName?: string | undefined;
    isWrong?: boolean;
    isPossibleRightIntermediatePresent?: boolean;
    isImpossible?: boolean;
}

export class IntermediateStatusStep implements IIntermediateStatusStep {
    stepId?: string | undefined;
    stepName?: string | undefined;
    stepNumber?: number | undefined;
    theProject?: Project;
    theSubProject?: SubProject;
    theAssessment?: Assessment;
    theSkillArea?: Screen;
    numErrors?: number;
    intermediates?: IntermediateStatus[] | undefined;
    steps?: Step[] | undefined;

    constructor(data?: IIntermediateStatusStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.stepName = _data["stepName"];
            this.stepNumber = _data["stepNumber"];
            this.theProject = _data["theProject"] ? Project.fromJS(_data["theProject"]) : undefined as any;
            this.theSubProject = _data["theSubProject"] ? SubProject.fromJS(_data["theSubProject"]) : undefined as any;
            this.theAssessment = _data["theAssessment"] ? Assessment.fromJS(_data["theAssessment"]) : undefined as any;
            this.theSkillArea = _data["theSkillArea"] ? Screen.fromJS(_data["theSkillArea"]) : undefined as any;
            this.numErrors = _data["numErrors"];
            if (Array.isArray(_data["intermediates"])) {
                this.intermediates = [] as any;
                for (let item of _data["intermediates"])
                    this.intermediates!.push(IntermediateStatus.fromJS(item));
            }
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(Step.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermediateStatusStep {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediateStatusStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["stepName"] = this.stepName;
        data["stepNumber"] = this.stepNumber;
        data["theProject"] = this.theProject ? this.theProject.toJSON() : undefined as any;
        data["theSubProject"] = this.theSubProject ? this.theSubProject.toJSON() : undefined as any;
        data["theAssessment"] = this.theAssessment ? this.theAssessment.toJSON() : undefined as any;
        data["theSkillArea"] = this.theSkillArea ? this.theSkillArea.toJSON() : undefined as any;
        data["numErrors"] = this.numErrors;
        if (Array.isArray(this.intermediates)) {
            data["intermediates"] = [];
            for (let item of this.intermediates)
                data["intermediates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIntermediateStatusStep {
    stepId?: string | undefined;
    stepName?: string | undefined;
    stepNumber?: number | undefined;
    theProject?: Project;
    theSubProject?: SubProject;
    theAssessment?: Assessment;
    theSkillArea?: Screen;
    numErrors?: number;
    intermediates?: IntermediateStatus[] | undefined;
    steps?: Step[] | undefined;
}

export class IntermediateStep implements IIntermediateStep {
    id?: string;
    assessmentId?: string | undefined;
    stepId?: string | undefined;
    intermediateStepId?: string | undefined;
    quantity?: number | undefined;
    unitId?: string | undefined;
    unitOperationId?: string | undefined;
    notes?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    intermediateStepNavigation?: Step;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;

    constructor(data?: IIntermediateStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentId = _data["assessmentId"];
            this.stepId = _data["stepId"];
            this.intermediateStepId = _data["intermediateStepId"];
            this.quantity = _data["quantity"];
            this.unitId = _data["unitId"];
            this.unitOperationId = _data["unitOperationId"];
            this.notes = _data["notes"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.intermediateStepNavigation = _data["intermediateStepNavigation"] ? Step.fromJS(_data["intermediateStepNavigation"]) : undefined as any;
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.unitOperation = _data["unitOperation"] ? UnitOperation.fromJS(_data["unitOperation"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): IntermediateStep {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediateStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentId"] = this.assessmentId;
        data["stepId"] = this.stepId;
        data["intermediateStepId"] = this.intermediateStepId;
        data["quantity"] = this.quantity;
        data["unitId"] = this.unitId;
        data["unitOperationId"] = this.unitOperationId;
        data["notes"] = this.notes;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["intermediateStepNavigation"] = this.intermediateStepNavigation ? this.intermediateStepNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["unitOperation"] = this.unitOperation ? this.unitOperation.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IIntermediateStep {
    id?: string;
    assessmentId?: string | undefined;
    stepId?: string | undefined;
    intermediateStepId?: string | undefined;
    quantity?: number | undefined;
    unitId?: string | undefined;
    unitOperationId?: string | undefined;
    notes?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    intermediateStepNavigation?: Step;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;
}

export class KnowledgeArticle implements IKnowledgeArticle {
    id?: string;
    title?: string | undefined;
    content?: string | undefined;
    knowledgeCategoryId?: string | undefined;
    knowledgeSubcategoryId?: string | undefined;
    status?: string | undefined;
    visibility?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticleFeedback?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleTag?: KnowledgeArticleTag[] | undefined;
    knowledgeAttachment?: KnowledgeAttachment[] | undefined;
    knowledgeCategory?: KnowledgeCategory;
    knowledgeInfoRequest?: KnowledgeInfoRequest[] | undefined;
    knowledgeSubcategory?: KnowledgeSubcategory;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.knowledgeCategoryId = _data["knowledgeCategoryId"];
            this.knowledgeSubcategoryId = _data["knowledgeSubcategoryId"];
            this.status = _data["status"];
            this.visibility = _data["visibility"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["knowledgeArticleFeedback"])) {
                this.knowledgeArticleFeedback = [] as any;
                for (let item of _data["knowledgeArticleFeedback"])
                    this.knowledgeArticleFeedback!.push(KnowledgeArticleFeedback.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticleTag"])) {
                this.knowledgeArticleTag = [] as any;
                for (let item of _data["knowledgeArticleTag"])
                    this.knowledgeArticleTag!.push(KnowledgeArticleTag.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeAttachment"])) {
                this.knowledgeAttachment = [] as any;
                for (let item of _data["knowledgeAttachment"])
                    this.knowledgeAttachment!.push(KnowledgeAttachment.fromJS(item));
            }
            this.knowledgeCategory = _data["knowledgeCategory"] ? KnowledgeCategory.fromJS(_data["knowledgeCategory"]) : undefined as any;
            if (Array.isArray(_data["knowledgeInfoRequest"])) {
                this.knowledgeInfoRequest = [] as any;
                for (let item of _data["knowledgeInfoRequest"])
                    this.knowledgeInfoRequest!.push(KnowledgeInfoRequest.fromJS(item));
            }
            this.knowledgeSubcategory = _data["knowledgeSubcategory"] ? KnowledgeSubcategory.fromJS(_data["knowledgeSubcategory"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeArticle {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["knowledgeCategoryId"] = this.knowledgeCategoryId;
        data["knowledgeSubcategoryId"] = this.knowledgeSubcategoryId;
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.knowledgeArticleFeedback)) {
            data["knowledgeArticleFeedback"] = [];
            for (let item of this.knowledgeArticleFeedback)
                data["knowledgeArticleFeedback"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticleTag)) {
            data["knowledgeArticleTag"] = [];
            for (let item of this.knowledgeArticleTag)
                data["knowledgeArticleTag"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeAttachment)) {
            data["knowledgeAttachment"] = [];
            for (let item of this.knowledgeAttachment)
                data["knowledgeAttachment"].push(item ? item.toJSON() : undefined as any);
        }
        data["knowledgeCategory"] = this.knowledgeCategory ? this.knowledgeCategory.toJSON() : undefined as any;
        if (Array.isArray(this.knowledgeInfoRequest)) {
            data["knowledgeInfoRequest"] = [];
            for (let item of this.knowledgeInfoRequest)
                data["knowledgeInfoRequest"].push(item ? item.toJSON() : undefined as any);
        }
        data["knowledgeSubcategory"] = this.knowledgeSubcategory ? this.knowledgeSubcategory.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeArticle {
    id?: string;
    title?: string | undefined;
    content?: string | undefined;
    knowledgeCategoryId?: string | undefined;
    knowledgeSubcategoryId?: string | undefined;
    status?: string | undefined;
    visibility?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticleFeedback?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleTag?: KnowledgeArticleTag[] | undefined;
    knowledgeAttachment?: KnowledgeAttachment[] | undefined;
    knowledgeCategory?: KnowledgeCategory;
    knowledgeInfoRequest?: KnowledgeInfoRequest[] | undefined;
    knowledgeSubcategory?: KnowledgeSubcategory;
    updatedByPerson?: Person;
}

export class KnowledgeArticleFeedback implements IKnowledgeArticleFeedback {
    id?: string;
    knowledgeArticleId?: string;
    personId?: string;
    isPositive?: boolean;
    feedbackText?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    person?: Person;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeArticleFeedback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.knowledgeArticleId = _data["knowledgeArticleId"];
            this.personId = _data["personId"];
            this.isPositive = _data["isPositive"];
            this.feedbackText = _data["feedbackText"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.knowledgeArticle = _data["knowledgeArticle"] ? KnowledgeArticle.fromJS(_data["knowledgeArticle"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeArticleFeedback {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeArticleFeedback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["knowledgeArticleId"] = this.knowledgeArticleId;
        data["personId"] = this.personId;
        data["isPositive"] = this.isPositive;
        data["feedbackText"] = this.feedbackText;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["knowledgeArticle"] = this.knowledgeArticle ? this.knowledgeArticle.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeArticleFeedback {
    id?: string;
    knowledgeArticleId?: string;
    personId?: string;
    isPositive?: boolean;
    feedbackText?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    person?: Person;
    updatedByPerson?: Person;
}

export class KnowledgeArticleTag implements IKnowledgeArticleTag {
    id?: string;
    knowledgeArticleId?: string;
    knowledgeTagId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    knowledgeTag?: KnowledgeTag;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeArticleTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.knowledgeArticleId = _data["knowledgeArticleId"];
            this.knowledgeTagId = _data["knowledgeTagId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.knowledgeArticle = _data["knowledgeArticle"] ? KnowledgeArticle.fromJS(_data["knowledgeArticle"]) : undefined as any;
            this.knowledgeTag = _data["knowledgeTag"] ? KnowledgeTag.fromJS(_data["knowledgeTag"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeArticleTag {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeArticleTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["knowledgeArticleId"] = this.knowledgeArticleId;
        data["knowledgeTagId"] = this.knowledgeTagId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["knowledgeArticle"] = this.knowledgeArticle ? this.knowledgeArticle.toJSON() : undefined as any;
        data["knowledgeTag"] = this.knowledgeTag ? this.knowledgeTag.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeArticleTag {
    id?: string;
    knowledgeArticleId?: string;
    knowledgeTagId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    knowledgeTag?: KnowledgeTag;
    updatedByPerson?: Person;
}

export class KnowledgeAttachment implements IKnowledgeAttachment {
    id?: string;
    knowledgeArticleId?: string;
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileSize?: number | undefined;
    filePath?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.knowledgeArticleId = _data["knowledgeArticleId"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
            this.filePath = _data["filePath"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.knowledgeArticle = _data["knowledgeArticle"] ? KnowledgeArticle.fromJS(_data["knowledgeArticle"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["knowledgeArticleId"] = this.knowledgeArticleId;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        data["filePath"] = this.filePath;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["knowledgeArticle"] = this.knowledgeArticle ? this.knowledgeArticle.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeAttachment {
    id?: string;
    knowledgeArticleId?: string;
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileSize?: number | undefined;
    filePath?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    updatedByPerson?: Person;
}

export class KnowledgeCategory implements IKnowledgeCategory {
    id?: string;
    categoryName?: string | undefined;
    sortOrder?: number | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle[] | undefined;
    knowledgeSubcategory?: KnowledgeSubcategory[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryName = _data["categoryName"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["knowledgeArticle"])) {
                this.knowledgeArticle = [] as any;
                for (let item of _data["knowledgeArticle"])
                    this.knowledgeArticle!.push(KnowledgeArticle.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeSubcategory"])) {
                this.knowledgeSubcategory = [] as any;
                for (let item of _data["knowledgeSubcategory"])
                    this.knowledgeSubcategory!.push(KnowledgeSubcategory.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeCategory {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryName"] = this.categoryName;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.knowledgeArticle)) {
            data["knowledgeArticle"] = [];
            for (let item of this.knowledgeArticle)
                data["knowledgeArticle"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeSubcategory)) {
            data["knowledgeSubcategory"] = [];
            for (let item of this.knowledgeSubcategory)
                data["knowledgeSubcategory"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeCategory {
    id?: string;
    categoryName?: string | undefined;
    sortOrder?: number | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle[] | undefined;
    knowledgeSubcategory?: KnowledgeSubcategory[] | undefined;
    updatedByPerson?: Person;
}

export class KnowledgeInfoRequest implements IKnowledgeInfoRequest {
    id?: string;
    knowledgeArticleId?: string | undefined;
    personId?: string;
    requestText?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    person?: Person;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.knowledgeArticleId = _data["knowledgeArticleId"];
            this.personId = _data["personId"];
            this.requestText = _data["requestText"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.knowledgeArticle = _data["knowledgeArticle"] ? KnowledgeArticle.fromJS(_data["knowledgeArticle"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["knowledgeArticleId"] = this.knowledgeArticleId;
        data["personId"] = this.personId;
        data["requestText"] = this.requestText;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["knowledgeArticle"] = this.knowledgeArticle ? this.knowledgeArticle.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeInfoRequest {
    id?: string;
    knowledgeArticleId?: string | undefined;
    personId?: string;
    requestText?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle;
    person?: Person;
    updatedByPerson?: Person;
}

export class KnowledgeSubcategory implements IKnowledgeSubcategory {
    id?: string;
    knowledgeCategoryId?: string;
    subcategoryName?: string | undefined;
    sortOrder?: number | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle[] | undefined;
    knowledgeCategory?: KnowledgeCategory;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeSubcategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.knowledgeCategoryId = _data["knowledgeCategoryId"];
            this.subcategoryName = _data["subcategoryName"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["knowledgeArticle"])) {
                this.knowledgeArticle = [] as any;
                for (let item of _data["knowledgeArticle"])
                    this.knowledgeArticle!.push(KnowledgeArticle.fromJS(item));
            }
            this.knowledgeCategory = _data["knowledgeCategory"] ? KnowledgeCategory.fromJS(_data["knowledgeCategory"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeSubcategory {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeSubcategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["knowledgeCategoryId"] = this.knowledgeCategoryId;
        data["subcategoryName"] = this.subcategoryName;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.knowledgeArticle)) {
            data["knowledgeArticle"] = [];
            for (let item of this.knowledgeArticle)
                data["knowledgeArticle"].push(item ? item.toJSON() : undefined as any);
        }
        data["knowledgeCategory"] = this.knowledgeCategory ? this.knowledgeCategory.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeSubcategory {
    id?: string;
    knowledgeCategoryId?: string;
    subcategoryName?: string | undefined;
    sortOrder?: number | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticle?: KnowledgeArticle[] | undefined;
    knowledgeCategory?: KnowledgeCategory;
    updatedByPerson?: Person;
}

export class KnowledgeTag implements IKnowledgeTag {
    id?: string;
    tagName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticleTag?: KnowledgeArticleTag[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IKnowledgeTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagName = _data["tagName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["knowledgeArticleTag"])) {
                this.knowledgeArticleTag = [] as any;
                for (let item of _data["knowledgeArticleTag"])
                    this.knowledgeArticleTag!.push(KnowledgeArticleTag.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): KnowledgeTag {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagName"] = this.tagName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.knowledgeArticleTag)) {
            data["knowledgeArticleTag"] = [];
            for (let item of this.knowledgeArticleTag)
                data["knowledgeArticleTag"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IKnowledgeTag {
    id?: string;
    tagName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    knowledgeArticleTag?: KnowledgeArticleTag[] | undefined;
    updatedByPerson?: Person;
}

export class LifeCycleResult implements ILifeCycleResult {
    stepNumber?: number | undefined;
    name?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;

    constructor(data?: ILifeCycleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepNumber = _data["stepNumber"];
            this.name = _data["name"];
            this.climateChange = _data["climateChange"];
            this.waterConsumption = _data["waterConsumption"];
            this.costofGoods = _data["costofGoods"];
            this.water = _data["water"];
            this.solvent = _data["solvent"];
            this.total = _data["total"];
            this.totalWeightedScore = _data["totalWeightedScore"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
        }
    }

    static fromJS(data: any): LifeCycleResult {
        data = typeof data === 'object' ? data : {};
        let result = new LifeCycleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepNumber"] = this.stepNumber;
        data["name"] = this.name;
        data["climateChange"] = this.climateChange;
        data["waterConsumption"] = this.waterConsumption;
        data["costofGoods"] = this.costofGoods;
        data["water"] = this.water;
        data["solvent"] = this.solvent;
        data["total"] = this.total;
        data["totalWeightedScore"] = this.totalWeightedScore;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        return data;
    }
}

export interface ILifeCycleResult {
    stepNumber?: number | undefined;
    name?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
}

export class LifeCycleResultGraph implements ILifeCycleResultGraph {
    name?: string | undefined;
    rawmaterial?: number | undefined;
    transport?: number | undefined;
    energyconsumptionhvac?: number | undefined;
    energyconsumptionunitprocess?: number | undefined;
    energyconsumptioncoldstorage?: number | undefined;
    endoflife?: number | undefined;

    constructor(data?: ILifeCycleResultGraph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rawmaterial = _data["rawmaterial"];
            this.transport = _data["transport"];
            this.energyconsumptionhvac = _data["energyconsumptionhvac"];
            this.energyconsumptionunitprocess = _data["energyconsumptionunitprocess"];
            this.energyconsumptioncoldstorage = _data["energyconsumptioncoldstorage"];
            this.endoflife = _data["endoflife"];
        }
    }

    static fromJS(data: any): LifeCycleResultGraph {
        data = typeof data === 'object' ? data : {};
        let result = new LifeCycleResultGraph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rawmaterial"] = this.rawmaterial;
        data["transport"] = this.transport;
        data["energyconsumptionhvac"] = this.energyconsumptionhvac;
        data["energyconsumptionunitprocess"] = this.energyconsumptionunitprocess;
        data["energyconsumptioncoldstorage"] = this.energyconsumptioncoldstorage;
        data["endoflife"] = this.endoflife;
        return data;
    }
}

export interface ILifeCycleResultGraph {
    name?: string | undefined;
    rawmaterial?: number | undefined;
    transport?: number | undefined;
    energyconsumptionhvac?: number | undefined;
    energyconsumptionunitprocess?: number | undefined;
    energyconsumptioncoldstorage?: number | undefined;
    endoflife?: number | undefined;
}

export class LifeCycleSummaryResultGraph implements ILifeCycleSummaryResultGraph {
    name?: string | undefined;
    syntheticAPI?: number | undefined;
    biologicsAPI?: number | undefined;
    otherAPI?: number | undefined;
    productProcess?: number | undefined;
    packaging?: number | undefined;
    distribution?: number | undefined;
    packagingEol?: number | undefined;

    constructor(data?: ILifeCycleSummaryResultGraph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.syntheticAPI = _data["syntheticAPI"];
            this.biologicsAPI = _data["biologicsAPI"];
            this.otherAPI = _data["otherAPI"];
            this.productProcess = _data["productProcess"];
            this.packaging = _data["packaging"];
            this.distribution = _data["distribution"];
            this.packagingEol = _data["packagingEol"];
        }
    }

    static fromJS(data: any): LifeCycleSummaryResultGraph {
        data = typeof data === 'object' ? data : {};
        let result = new LifeCycleSummaryResultGraph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["syntheticAPI"] = this.syntheticAPI;
        data["biologicsAPI"] = this.biologicsAPI;
        data["otherAPI"] = this.otherAPI;
        data["productProcess"] = this.productProcess;
        data["packaging"] = this.packaging;
        data["distribution"] = this.distribution;
        data["packagingEol"] = this.packagingEol;
        return data;
    }
}

export interface ILifeCycleSummaryResultGraph {
    name?: string | undefined;
    syntheticAPI?: number | undefined;
    biologicsAPI?: number | undefined;
    otherAPI?: number | undefined;
    productProcess?: number | undefined;
    packaging?: number | undefined;
    distribution?: number | undefined;
    packagingEol?: number | undefined;
}

export class LifeCycleSummaryResultInput implements ILifeCycleSummaryResultInput {
    assessmentId?: string | undefined;
    unitValue?: number;
    unitType?: string | undefined;
    emissionFactorsToUse?: string[] | undefined;
    useWeightedEmissionFactors?: boolean;
    packagingGeneralInformationId?: string | undefined;
    distributionGeneralInformationId?: string | undefined;

    constructor(data?: ILifeCycleSummaryResultInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            if (Array.isArray(_data["emissionFactorsToUse"])) {
                this.emissionFactorsToUse = [] as any;
                for (let item of _data["emissionFactorsToUse"])
                    this.emissionFactorsToUse!.push(item);
            }
            this.useWeightedEmissionFactors = _data["useWeightedEmissionFactors"];
            this.packagingGeneralInformationId = _data["packagingGeneralInformationId"];
            this.distributionGeneralInformationId = _data["distributionGeneralInformationId"];
        }
    }

    static fromJS(data: any): LifeCycleSummaryResultInput {
        data = typeof data === 'object' ? data : {};
        let result = new LifeCycleSummaryResultInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        if (Array.isArray(this.emissionFactorsToUse)) {
            data["emissionFactorsToUse"] = [];
            for (let item of this.emissionFactorsToUse)
                data["emissionFactorsToUse"].push(item);
        }
        data["useWeightedEmissionFactors"] = this.useWeightedEmissionFactors;
        data["packagingGeneralInformationId"] = this.packagingGeneralInformationId;
        data["distributionGeneralInformationId"] = this.distributionGeneralInformationId;
        return data;
    }
}

export interface ILifeCycleSummaryResultInput {
    assessmentId?: string | undefined;
    unitValue?: number;
    unitType?: string | undefined;
    emissionFactorsToUse?: string[] | undefined;
    useWeightedEmissionFactors?: boolean;
    packagingGeneralInformationId?: string | undefined;
    distributionGeneralInformationId?: string | undefined;
}

export class MasterCategory implements IMasterCategory {
    id?: string;
    masterCategoryKey?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    masterDropdown?: MasterDropdown[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IMasterCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.masterCategoryKey = _data["masterCategoryKey"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["masterDropdown"])) {
                this.masterDropdown = [] as any;
                for (let item of _data["masterDropdown"])
                    this.masterDropdown!.push(MasterDropdown.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): MasterCategory {
        data = typeof data === 'object' ? data : {};
        let result = new MasterCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["masterCategoryKey"] = this.masterCategoryKey;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.masterDropdown)) {
            data["masterDropdown"] = [];
            for (let item of this.masterDropdown)
                data["masterDropdown"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IMasterCategory {
    id?: string;
    masterCategoryKey?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    masterDropdown?: MasterDropdown[] | undefined;
    updatedByPerson?: Person;
}

export class MasterDropdown implements IMasterDropdown {
    id?: string;
    masterCategoryId?: string | undefined;
    label?: string | undefined;
    valueTxt?: string | undefined;
    valueNumeric?: number | undefined;
    help?: string | undefined;
    isNumeric?: boolean | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    ordering?: number | undefined;
    assessmentdevelopmentStage?: Assessment[] | undefined;
    assessmentproductName?: Assessment[] | undefined;
    consumerEolMaterialDefault?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    downstream?: Downstream[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    masterCategory?: MasterCategory;
    processWasteeolDestinationMarketNavigation?: ProcessWaste[] | undefined;
    processWasteeolDestinationSettingNavigation?: ProcessWaste[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IMasterDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.masterCategoryId = _data["masterCategoryId"];
            this.label = _data["label"];
            this.valueTxt = _data["valueTxt"];
            this.valueNumeric = _data["valueNumeric"];
            this.help = _data["help"];
            this.isNumeric = _data["isNumeric"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.ordering = _data["ordering"];
            if (Array.isArray(_data["assessmentdevelopmentStage"])) {
                this.assessmentdevelopmentStage = [] as any;
                for (let item of _data["assessmentdevelopmentStage"])
                    this.assessmentdevelopmentStage!.push(Assessment.fromJS(item));
            }
            if (Array.isArray(_data["assessmentproductName"])) {
                this.assessmentproductName = [] as any;
                for (let item of _data["assessmentproductName"])
                    this.assessmentproductName!.push(Assessment.fromJS(item));
            }
            if (Array.isArray(_data["consumerEolMaterialDefault"])) {
                this.consumerEolMaterialDefault = [] as any;
                for (let item of _data["consumerEolMaterialDefault"])
                    this.consumerEolMaterialDefault!.push(ConsumerEolMaterialDefault.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["downstream"])) {
                this.downstream = [] as any;
                for (let item of _data["downstream"])
                    this.downstream!.push(Downstream.fromJS(item));
            }
            if (Array.isArray(_data["generalInformation"])) {
                this.generalInformation = [] as any;
                for (let item of _data["generalInformation"])
                    this.generalInformation!.push(GeneralInformation.fromJS(item));
            }
            this.masterCategory = _data["masterCategory"] ? MasterCategory.fromJS(_data["masterCategory"]) : undefined as any;
            if (Array.isArray(_data["processWasteeolDestinationMarketNavigation"])) {
                this.processWasteeolDestinationMarketNavigation = [] as any;
                for (let item of _data["processWasteeolDestinationMarketNavigation"])
                    this.processWasteeolDestinationMarketNavigation!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["processWasteeolDestinationSettingNavigation"])) {
                this.processWasteeolDestinationSettingNavigation = [] as any;
                for (let item of _data["processWasteeolDestinationSettingNavigation"])
                    this.processWasteeolDestinationSettingNavigation!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntry"])) {
                this.rawMaterialEntry = [] as any;
                for (let item of _data["rawMaterialEntry"])
                    this.rawMaterialEntry!.push(RawMaterialEntry.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): MasterDropdown {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["masterCategoryId"] = this.masterCategoryId;
        data["label"] = this.label;
        data["valueTxt"] = this.valueTxt;
        data["valueNumeric"] = this.valueNumeric;
        data["help"] = this.help;
        data["isNumeric"] = this.isNumeric;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["ordering"] = this.ordering;
        if (Array.isArray(this.assessmentdevelopmentStage)) {
            data["assessmentdevelopmentStage"] = [];
            for (let item of this.assessmentdevelopmentStage)
                data["assessmentdevelopmentStage"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentproductName)) {
            data["assessmentproductName"] = [];
            for (let item of this.assessmentproductName)
                data["assessmentproductName"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.consumerEolMaterialDefault)) {
            data["consumerEolMaterialDefault"] = [];
            for (let item of this.consumerEolMaterialDefault)
                data["consumerEolMaterialDefault"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.downstream)) {
            data["downstream"] = [];
            for (let item of this.downstream)
                data["downstream"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformation)) {
            data["generalInformation"] = [];
            for (let item of this.generalInformation)
                data["generalInformation"].push(item ? item.toJSON() : undefined as any);
        }
        data["masterCategory"] = this.masterCategory ? this.masterCategory.toJSON() : undefined as any;
        if (Array.isArray(this.processWasteeolDestinationMarketNavigation)) {
            data["processWasteeolDestinationMarketNavigation"] = [];
            for (let item of this.processWasteeolDestinationMarketNavigation)
                data["processWasteeolDestinationMarketNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWasteeolDestinationSettingNavigation)) {
            data["processWasteeolDestinationSettingNavigation"] = [];
            for (let item of this.processWasteeolDestinationSettingNavigation)
                data["processWasteeolDestinationSettingNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntry)) {
            data["rawMaterialEntry"] = [];
            for (let item of this.rawMaterialEntry)
                data["rawMaterialEntry"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IMasterDropdown {
    id?: string;
    masterCategoryId?: string | undefined;
    label?: string | undefined;
    valueTxt?: string | undefined;
    valueNumeric?: number | undefined;
    help?: string | undefined;
    isNumeric?: boolean | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    ordering?: number | undefined;
    assessmentdevelopmentStage?: Assessment[] | undefined;
    assessmentproductName?: Assessment[] | undefined;
    consumerEolMaterialDefault?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    downstream?: Downstream[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    masterCategory?: MasterCategory;
    processWasteeolDestinationMarketNavigation?: ProcessWaste[] | undefined;
    processWasteeolDestinationSettingNavigation?: ProcessWaste[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    updatedByPerson?: Person;
}

export class Material implements IMaterial {
    id?: string;
    materialDefaultUnitId?: string | undefined;
    materialTypeId?: string;
    materialName?: string | undefined;
    cas?: string | undefined;
    isActive?: boolean;
    nameSimbol?: string | undefined;
    atomMassMolecularWeight?: number | undefined;
    assay?: number | undefined;
    density?: number | undefined;
    fossilCarbonContent?: number | undefined;
    fossilCarbonContentSource?: string | undefined;
    resultingCO2Emissions?: number | undefined;
    wfiRequired?: number | undefined;
    weightPerPiece?: number | undefined;
    climateChange?: number | undefined;
    waterUseConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityScore?: number | undefined;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    pmiWater?: number | undefined;
    pmiSolvent?: number | undefined;
    materialSubTypeId?: string | undefined;
    isProxy?: boolean | undefined;
    dataSource?: string | undefined;
    dataSourceNotes?: string | undefined;
    consumerEolMaterialDefault?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    materialDefaultUnit?: Unit;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    materialScreen?: MaterialScreen[] | undefined;
    materialSubType?: MaterialSubType;
    materialType?: MaterialType;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialDefaultUnitId = _data["materialDefaultUnitId"];
            this.materialTypeId = _data["materialTypeId"];
            this.materialName = _data["materialName"];
            this.cas = _data["cas"];
            this.isActive = _data["isActive"];
            this.nameSimbol = _data["nameSimbol"];
            this.atomMassMolecularWeight = _data["atomMassMolecularWeight"];
            this.assay = _data["assay"];
            this.density = _data["density"];
            this.fossilCarbonContent = _data["fossilCarbonContent"];
            this.fossilCarbonContentSource = _data["fossilCarbonContentSource"];
            this.resultingCO2Emissions = _data["resultingCO2Emissions"];
            this.wfiRequired = _data["wfiRequired"];
            this.weightPerPiece = _data["weightPerPiece"];
            this.climateChange = _data["climateChange"];
            this.waterUseConsumption = _data["waterUseConsumption"];
            this.goodsCost = _data["goodsCost"];
            this.pmi = _data["pmi"];
            this.dataQualityScore = _data["dataQualityScore"];
            this.comments = _data["comments"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.pmiWater = _data["pmiWater"];
            this.pmiSolvent = _data["pmiSolvent"];
            this.materialSubTypeId = _data["materialSubTypeId"];
            this.isProxy = _data["isProxy"];
            this.dataSource = _data["dataSource"];
            this.dataSourceNotes = _data["dataSourceNotes"];
            if (Array.isArray(_data["consumerEolMaterialDefault"])) {
                this.consumerEolMaterialDefault = [] as any;
                for (let item of _data["consumerEolMaterialDefault"])
                    this.consumerEolMaterialDefault!.push(ConsumerEolMaterialDefault.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.materialDefaultUnit = _data["materialDefaultUnit"] ? Unit.fromJS(_data["materialDefaultUnit"]) : undefined as any;
            if (Array.isArray(_data["materialEmissionFactor"])) {
                this.materialEmissionFactor = [] as any;
                for (let item of _data["materialEmissionFactor"])
                    this.materialEmissionFactor!.push(MaterialEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["materialScreen"])) {
                this.materialScreen = [] as any;
                for (let item of _data["materialScreen"])
                    this.materialScreen!.push(MaterialScreen.fromJS(item));
            }
            this.materialSubType = _data["materialSubType"] ? MaterialSubType.fromJS(_data["materialSubType"]) : undefined as any;
            this.materialType = _data["materialType"] ? MaterialType.fromJS(_data["materialType"]) : undefined as any;
            if (Array.isArray(_data["processWasteDetail"])) {
                this.processWasteDetail = [] as any;
                for (let item of _data["processWasteDetail"])
                    this.processWasteDetail!.push(ProcessWasteDetail.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntry"])) {
                this.rawMaterialEntry = [] as any;
                for (let item of _data["rawMaterialEntry"])
                    this.rawMaterialEntry!.push(RawMaterialEntry.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): Material {
        data = typeof data === 'object' ? data : {};
        let result = new Material();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialDefaultUnitId"] = this.materialDefaultUnitId;
        data["materialTypeId"] = this.materialTypeId;
        data["materialName"] = this.materialName;
        data["cas"] = this.cas;
        data["isActive"] = this.isActive;
        data["nameSimbol"] = this.nameSimbol;
        data["atomMassMolecularWeight"] = this.atomMassMolecularWeight;
        data["assay"] = this.assay;
        data["density"] = this.density;
        data["fossilCarbonContent"] = this.fossilCarbonContent;
        data["fossilCarbonContentSource"] = this.fossilCarbonContentSource;
        data["resultingCO2Emissions"] = this.resultingCO2Emissions;
        data["wfiRequired"] = this.wfiRequired;
        data["weightPerPiece"] = this.weightPerPiece;
        data["climateChange"] = this.climateChange;
        data["waterUseConsumption"] = this.waterUseConsumption;
        data["goodsCost"] = this.goodsCost;
        data["pmi"] = this.pmi;
        data["dataQualityScore"] = this.dataQualityScore;
        data["comments"] = this.comments;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["pmiWater"] = this.pmiWater;
        data["pmiSolvent"] = this.pmiSolvent;
        data["materialSubTypeId"] = this.materialSubTypeId;
        data["isProxy"] = this.isProxy;
        data["dataSource"] = this.dataSource;
        data["dataSourceNotes"] = this.dataSourceNotes;
        if (Array.isArray(this.consumerEolMaterialDefault)) {
            data["consumerEolMaterialDefault"] = [];
            for (let item of this.consumerEolMaterialDefault)
                data["consumerEolMaterialDefault"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["materialDefaultUnit"] = this.materialDefaultUnit ? this.materialDefaultUnit.toJSON() : undefined as any;
        if (Array.isArray(this.materialEmissionFactor)) {
            data["materialEmissionFactor"] = [];
            for (let item of this.materialEmissionFactor)
                data["materialEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialScreen)) {
            data["materialScreen"] = [];
            for (let item of this.materialScreen)
                data["materialScreen"].push(item ? item.toJSON() : undefined as any);
        }
        data["materialSubType"] = this.materialSubType ? this.materialSubType.toJSON() : undefined as any;
        data["materialType"] = this.materialType ? this.materialType.toJSON() : undefined as any;
        if (Array.isArray(this.processWasteDetail)) {
            data["processWasteDetail"] = [];
            for (let item of this.processWasteDetail)
                data["processWasteDetail"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntry)) {
            data["rawMaterialEntry"] = [];
            for (let item of this.rawMaterialEntry)
                data["rawMaterialEntry"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaterial {
    id?: string;
    materialDefaultUnitId?: string | undefined;
    materialTypeId?: string;
    materialName?: string | undefined;
    cas?: string | undefined;
    isActive?: boolean;
    nameSimbol?: string | undefined;
    atomMassMolecularWeight?: number | undefined;
    assay?: number | undefined;
    density?: number | undefined;
    fossilCarbonContent?: number | undefined;
    fossilCarbonContentSource?: string | undefined;
    resultingCO2Emissions?: number | undefined;
    wfiRequired?: number | undefined;
    weightPerPiece?: number | undefined;
    climateChange?: number | undefined;
    waterUseConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityScore?: number | undefined;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    pmiWater?: number | undefined;
    pmiSolvent?: number | undefined;
    materialSubTypeId?: string | undefined;
    isProxy?: boolean | undefined;
    dataSource?: string | undefined;
    dataSourceNotes?: string | undefined;
    consumerEolMaterialDefault?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    materialDefaultUnit?: Unit;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    materialScreen?: MaterialScreen[] | undefined;
    materialSubType?: MaterialSubType;
    materialType?: MaterialType;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    updatedByPerson?: Person;
}

export class MaterialCheckOnSave implements IMaterialCheckOnSave {
    isError?: boolean;
    errorMessage?: string | undefined;
    skillAreaIdsToRestore?: string[] | undefined;

    constructor(data?: IMaterialCheckOnSave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isError = _data["isError"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["skillAreaIdsToRestore"])) {
                this.skillAreaIdsToRestore = [] as any;
                for (let item of _data["skillAreaIdsToRestore"])
                    this.skillAreaIdsToRestore!.push(item);
            }
        }
    }

    static fromJS(data: any): MaterialCheckOnSave {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCheckOnSave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isError"] = this.isError;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.skillAreaIdsToRestore)) {
            data["skillAreaIdsToRestore"] = [];
            for (let item of this.skillAreaIdsToRestore)
                data["skillAreaIdsToRestore"].push(item);
        }
        return data;
    }
}

export interface IMaterialCheckOnSave {
    isError?: boolean;
    errorMessage?: string | undefined;
    skillAreaIdsToRestore?: string[] | undefined;
}

export class MaterialCompositionResult implements IMaterialCompositionResult {
    uid?: string | undefined;
    material?: string | undefined;
    materialSubTypeName?: string | undefined;
    materialType?: string | undefined;
    step?: number | undefined;
    mass?: number | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;

    constructor(data?: IMaterialCompositionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.material = _data["material"];
            this.materialSubTypeName = _data["materialSubTypeName"];
            this.materialType = _data["materialType"];
            this.step = _data["step"];
            this.mass = _data["mass"];
            this.climateChange = _data["climateChange"];
            this.waterConsumption = _data["waterConsumption"];
            this.costofGoods = _data["costofGoods"];
            this.water = _data["water"];
            this.solvent = _data["solvent"];
            this.total = _data["total"];
            this.totalWeightedScore = _data["totalWeightedScore"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
        }
    }

    static fromJS(data: any): MaterialCompositionResult {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCompositionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["material"] = this.material;
        data["materialSubTypeName"] = this.materialSubTypeName;
        data["materialType"] = this.materialType;
        data["step"] = this.step;
        data["mass"] = this.mass;
        data["climateChange"] = this.climateChange;
        data["waterConsumption"] = this.waterConsumption;
        data["costofGoods"] = this.costofGoods;
        data["water"] = this.water;
        data["solvent"] = this.solvent;
        data["total"] = this.total;
        data["totalWeightedScore"] = this.totalWeightedScore;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        return data;
    }
}

export interface IMaterialCompositionResult {
    uid?: string | undefined;
    material?: string | undefined;
    materialSubTypeName?: string | undefined;
    materialType?: string | undefined;
    step?: number | undefined;
    mass?: number | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
}

export class MaterialEmissionFactor implements IMaterialEmissionFactor {
    id?: string;
    materialId?: string;
    emissionFactorId?: string;
    factor?: number;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    wasteDisposalTypeId?: string | undefined;
    emissionFactorTypeId?: string;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    emissionFactorType?: EmissionFactorTypes;
    material?: Material;
    updatedByPerson?: Person;
    wasteDisposalType?: WasteDisposalType;

    constructor(data?: IMaterialEmissionFactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialId = _data["materialId"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.factor = _data["factor"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.wasteDisposalTypeId = _data["wasteDisposalTypeId"];
            this.emissionFactorTypeId = _data["emissionFactorTypeId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.emissionFactor = _data["emissionFactor"] ? EmissionFactors.fromJS(_data["emissionFactor"]) : undefined as any;
            this.emissionFactorType = _data["emissionFactorType"] ? EmissionFactorTypes.fromJS(_data["emissionFactorType"]) : undefined as any;
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.wasteDisposalType = _data["wasteDisposalType"] ? WasteDisposalType.fromJS(_data["wasteDisposalType"]) : undefined as any;
        }
    }

    static fromJS(data: any): MaterialEmissionFactor {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialEmissionFactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["emissionFactorId"] = this.emissionFactorId;
        data["factor"] = this.factor;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["wasteDisposalTypeId"] = this.wasteDisposalTypeId;
        data["emissionFactorTypeId"] = this.emissionFactorTypeId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["emissionFactor"] = this.emissionFactor ? this.emissionFactor.toJSON() : undefined as any;
        data["emissionFactorType"] = this.emissionFactorType ? this.emissionFactorType.toJSON() : undefined as any;
        data["material"] = this.material ? this.material.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["wasteDisposalType"] = this.wasteDisposalType ? this.wasteDisposalType.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaterialEmissionFactor {
    id?: string;
    materialId?: string;
    emissionFactorId?: string;
    factor?: number;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    wasteDisposalTypeId?: string | undefined;
    emissionFactorTypeId?: string;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    emissionFactorType?: EmissionFactorTypes;
    material?: Material;
    updatedByPerson?: Person;
    wasteDisposalType?: WasteDisposalType;
}

export class MaterialInboundTransport implements IMaterialInboundTransport {
    id?: string;
    stepId?: string;
    materialId?: string | undefined;
    transportId?: string;
    unitId?: string;
    distance?: number;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTmeStamp?: Date | undefined;
    rawMaterialId?: string | undefined;
    isActive?: boolean | undefined;
    intermediateStepId?: string | undefined;
    isIntermediate?: boolean | undefined;
    materialEntryId?: string | undefined;
    intermediateEntryId?: string | undefined;
    productProcessProxyId?: string | undefined;
    isAPIProxy?: boolean | undefined;
    productProcessProxyEntryId?: string | undefined;
    createdByPerson?: Person;
    intermediateEntry?: IntermediateStep;
    intermediateStep?: Step;
    material?: Material;
    materialEntry?: RawMaterialEntry;
    productProcessProxy?: ProductProcessProxy;
    productProcessProxyEntry?: ProductProcessProxyEntry;
    rawMaterial?: RawMaterial;
    step?: Step;
    transport?: Transport;
    unit?: Unit;
    updatedByPerson?: Person;

    constructor(data?: IMaterialInboundTransport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.materialId = _data["materialId"];
            this.transportId = _data["transportId"];
            this.unitId = _data["unitId"];
            this.distance = _data["distance"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTmeStamp = _data["updatedTmeStamp"] ? new Date(_data["updatedTmeStamp"].toString()) : undefined as any;
            this.rawMaterialId = _data["rawMaterialId"];
            this.isActive = _data["isActive"];
            this.intermediateStepId = _data["intermediateStepId"];
            this.isIntermediate = _data["isIntermediate"];
            this.materialEntryId = _data["materialEntryId"];
            this.intermediateEntryId = _data["intermediateEntryId"];
            this.productProcessProxyId = _data["productProcessProxyId"];
            this.isAPIProxy = _data["isAPIProxy"];
            this.productProcessProxyEntryId = _data["productProcessProxyEntryId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.intermediateEntry = _data["intermediateEntry"] ? IntermediateStep.fromJS(_data["intermediateEntry"]) : undefined as any;
            this.intermediateStep = _data["intermediateStep"] ? Step.fromJS(_data["intermediateStep"]) : undefined as any;
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : undefined as any;
            this.materialEntry = _data["materialEntry"] ? RawMaterialEntry.fromJS(_data["materialEntry"]) : undefined as any;
            this.productProcessProxy = _data["productProcessProxy"] ? ProductProcessProxy.fromJS(_data["productProcessProxy"]) : undefined as any;
            this.productProcessProxyEntry = _data["productProcessProxyEntry"] ? ProductProcessProxyEntry.fromJS(_data["productProcessProxyEntry"]) : undefined as any;
            this.rawMaterial = _data["rawMaterial"] ? RawMaterial.fromJS(_data["rawMaterial"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.transport = _data["transport"] ? Transport.fromJS(_data["transport"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): MaterialInboundTransport {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialInboundTransport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["materialId"] = this.materialId;
        data["transportId"] = this.transportId;
        data["unitId"] = this.unitId;
        data["distance"] = this.distance;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTmeStamp"] = this.updatedTmeStamp ? this.updatedTmeStamp.toISOString() : undefined as any;
        data["rawMaterialId"] = this.rawMaterialId;
        data["isActive"] = this.isActive;
        data["intermediateStepId"] = this.intermediateStepId;
        data["isIntermediate"] = this.isIntermediate;
        data["materialEntryId"] = this.materialEntryId;
        data["intermediateEntryId"] = this.intermediateEntryId;
        data["productProcessProxyId"] = this.productProcessProxyId;
        data["isAPIProxy"] = this.isAPIProxy;
        data["productProcessProxyEntryId"] = this.productProcessProxyEntryId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["intermediateEntry"] = this.intermediateEntry ? this.intermediateEntry.toJSON() : undefined as any;
        data["intermediateStep"] = this.intermediateStep ? this.intermediateStep.toJSON() : undefined as any;
        data["material"] = this.material ? this.material.toJSON() : undefined as any;
        data["materialEntry"] = this.materialEntry ? this.materialEntry.toJSON() : undefined as any;
        data["productProcessProxy"] = this.productProcessProxy ? this.productProcessProxy.toJSON() : undefined as any;
        data["productProcessProxyEntry"] = this.productProcessProxyEntry ? this.productProcessProxyEntry.toJSON() : undefined as any;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["transport"] = this.transport ? this.transport.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaterialInboundTransport {
    id?: string;
    stepId?: string;
    materialId?: string | undefined;
    transportId?: string;
    unitId?: string;
    distance?: number;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTmeStamp?: Date | undefined;
    rawMaterialId?: string | undefined;
    isActive?: boolean | undefined;
    intermediateStepId?: string | undefined;
    isIntermediate?: boolean | undefined;
    materialEntryId?: string | undefined;
    intermediateEntryId?: string | undefined;
    productProcessProxyId?: string | undefined;
    isAPIProxy?: boolean | undefined;
    productProcessProxyEntryId?: string | undefined;
    createdByPerson?: Person;
    intermediateEntry?: IntermediateStep;
    intermediateStep?: Step;
    material?: Material;
    materialEntry?: RawMaterialEntry;
    productProcessProxy?: ProductProcessProxy;
    productProcessProxyEntry?: ProductProcessProxyEntry;
    rawMaterial?: RawMaterial;
    step?: Step;
    transport?: Transport;
    unit?: Unit;
    updatedByPerson?: Person;
}

export class MaterialListForTable implements IMaterialListForTable {
    id?: string;
    materialName?: string | undefined;
    materialTypeName?: string | undefined;
    materialSubTypeName?: string | undefined;
    cas?: string | undefined;
    climateChange?: number | undefined;
    waterFreshWaterConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityRating?: number | undefined;
    skillArea?: Screen[] | undefined;
    isProxy?: boolean;
    isEOLAvailable?: boolean;
    isEOLEditing?: boolean;

    constructor(data?: IMaterialListForTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialName = _data["materialName"];
            this.materialTypeName = _data["materialTypeName"];
            this.materialSubTypeName = _data["materialSubTypeName"];
            this.cas = _data["cas"];
            this.climateChange = _data["climateChange"];
            this.waterFreshWaterConsumption = _data["waterFreshWaterConsumption"];
            this.goodsCost = _data["goodsCost"];
            this.pmi = _data["pmi"];
            this.dataQualityRating = _data["dataQualityRating"];
            if (Array.isArray(_data["skillArea"])) {
                this.skillArea = [] as any;
                for (let item of _data["skillArea"])
                    this.skillArea!.push(Screen.fromJS(item));
            }
            this.isProxy = _data["isProxy"];
            this.isEOLAvailable = _data["isEOLAvailable"];
            this.isEOLEditing = _data["isEOLEditing"];
        }
    }

    static fromJS(data: any): MaterialListForTable {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialListForTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialName"] = this.materialName;
        data["materialTypeName"] = this.materialTypeName;
        data["materialSubTypeName"] = this.materialSubTypeName;
        data["cas"] = this.cas;
        data["climateChange"] = this.climateChange;
        data["waterFreshWaterConsumption"] = this.waterFreshWaterConsumption;
        data["goodsCost"] = this.goodsCost;
        data["pmi"] = this.pmi;
        data["dataQualityRating"] = this.dataQualityRating;
        if (Array.isArray(this.skillArea)) {
            data["skillArea"] = [];
            for (let item of this.skillArea)
                data["skillArea"].push(item ? item.toJSON() : undefined as any);
        }
        data["isProxy"] = this.isProxy;
        data["isEOLAvailable"] = this.isEOLAvailable;
        data["isEOLEditing"] = this.isEOLEditing;
        return data;
    }
}

export interface IMaterialListForTable {
    id?: string;
    materialName?: string | undefined;
    materialTypeName?: string | undefined;
    materialSubTypeName?: string | undefined;
    cas?: string | undefined;
    climateChange?: number | undefined;
    waterFreshWaterConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityRating?: number | undefined;
    skillArea?: Screen[] | undefined;
    isProxy?: boolean;
    isEOLAvailable?: boolean;
    isEOLEditing?: boolean;
}

export class MaterialRecap implements IMaterialRecap {
    singleRow?: RawMaterialTableRow;
    totalMass?: number;

    constructor(data?: IMaterialRecap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singleRow = _data["singleRow"] ? RawMaterialTableRow.fromJS(_data["singleRow"]) : undefined as any;
            this.totalMass = _data["totalMass"];
        }
    }

    static fromJS(data: any): MaterialRecap {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialRecap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleRow"] = this.singleRow ? this.singleRow.toJSON() : undefined as any;
        data["totalMass"] = this.totalMass;
        return data;
    }
}

export interface IMaterialRecap {
    singleRow?: RawMaterialTableRow;
    totalMass?: number;
}

export class MaterialScreen implements IMaterialScreen {
    id?: string;
    materialId?: string | undefined;
    screenId?: string | undefined;
    isActive?: boolean | undefined;
    material?: Material;
    screen?: Screen;

    constructor(data?: IMaterialScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialId = _data["materialId"];
            this.screenId = _data["screenId"];
            this.isActive = _data["isActive"];
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : undefined as any;
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
        }
    }

    static fromJS(data: any): MaterialScreen {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["screenId"] = this.screenId;
        data["isActive"] = this.isActive;
        data["material"] = this.material ? this.material.toJSON() : undefined as any;
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaterialScreen {
    id?: string;
    materialId?: string | undefined;
    screenId?: string | undefined;
    isActive?: boolean | undefined;
    material?: Material;
    screen?: Screen;
}

export class MaterialSubType implements IMaterialSubType {
    id?: string;
    materialSubTypeName?: string | undefined;
    materialTypeId?: string | undefined;
    isActive?: boolean;
    screenId?: string | undefined;
    material?: Material[] | undefined;
    materialType?: MaterialType;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    screen?: Screen;
    screenNavigation?: Screen[] | undefined;

    constructor(data?: IMaterialSubType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialSubTypeName = _data["materialSubTypeName"];
            this.materialTypeId = _data["materialTypeId"];
            this.isActive = _data["isActive"];
            this.screenId = _data["screenId"];
            if (Array.isArray(_data["material"])) {
                this.material = [] as any;
                for (let item of _data["material"])
                    this.material!.push(Material.fromJS(item));
            }
            this.materialType = _data["materialType"] ? MaterialType.fromJS(_data["materialType"]) : undefined as any;
            if (Array.isArray(_data["productProcessProxy"])) {
                this.productProcessProxy = [] as any;
                for (let item of _data["productProcessProxy"])
                    this.productProcessProxy!.push(ProductProcessProxy.fromJS(item));
            }
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            if (Array.isArray(_data["screenNavigation"])) {
                this.screenNavigation = [] as any;
                for (let item of _data["screenNavigation"])
                    this.screenNavigation!.push(Screen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialSubType {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialSubType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialSubTypeName"] = this.materialSubTypeName;
        data["materialTypeId"] = this.materialTypeId;
        data["isActive"] = this.isActive;
        data["screenId"] = this.screenId;
        if (Array.isArray(this.material)) {
            data["material"] = [];
            for (let item of this.material)
                data["material"].push(item ? item.toJSON() : undefined as any);
        }
        data["materialType"] = this.materialType ? this.materialType.toJSON() : undefined as any;
        if (Array.isArray(this.productProcessProxy)) {
            data["productProcessProxy"] = [];
            for (let item of this.productProcessProxy)
                data["productProcessProxy"].push(item ? item.toJSON() : undefined as any);
        }
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        if (Array.isArray(this.screenNavigation)) {
            data["screenNavigation"] = [];
            for (let item of this.screenNavigation)
                data["screenNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMaterialSubType {
    id?: string;
    materialSubTypeName?: string | undefined;
    materialTypeId?: string | undefined;
    isActive?: boolean;
    screenId?: string | undefined;
    material?: Material[] | undefined;
    materialType?: MaterialType;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    screen?: Screen;
    screenNavigation?: Screen[] | undefined;
}

export class MaterialType implements IMaterialType {
    id?: string;
    materialTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    material?: Material[] | undefined;
    materialSubType?: MaterialSubType[] | undefined;
    materialTypeScreen?: MaterialTypeScreen[] | undefined;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IMaterialType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialTypeName = _data["materialTypeName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["material"])) {
                this.material = [] as any;
                for (let item of _data["material"])
                    this.material!.push(Material.fromJS(item));
            }
            if (Array.isArray(_data["materialSubType"])) {
                this.materialSubType = [] as any;
                for (let item of _data["materialSubType"])
                    this.materialSubType!.push(MaterialSubType.fromJS(item));
            }
            if (Array.isArray(_data["materialTypeScreen"])) {
                this.materialTypeScreen = [] as any;
                for (let item of _data["materialTypeScreen"])
                    this.materialTypeScreen!.push(MaterialTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxy"])) {
                this.productProcessProxy = [] as any;
                for (let item of _data["productProcessProxy"])
                    this.productProcessProxy!.push(ProductProcessProxy.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): MaterialType {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialTypeName"] = this.materialTypeName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.material)) {
            data["material"] = [];
            for (let item of this.material)
                data["material"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialSubType)) {
            data["materialSubType"] = [];
            for (let item of this.materialSubType)
                data["materialSubType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialTypeScreen)) {
            data["materialTypeScreen"] = [];
            for (let item of this.materialTypeScreen)
                data["materialTypeScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxy)) {
            data["productProcessProxy"] = [];
            for (let item of this.productProcessProxy)
                data["productProcessProxy"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaterialType {
    id?: string;
    materialTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    material?: Material[] | undefined;
    materialSubType?: MaterialSubType[] | undefined;
    materialTypeScreen?: MaterialTypeScreen[] | undefined;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    updatedByPerson?: Person;
}

export class MaterialTypeMgm implements IMaterialTypeMgm {
    materialType?: MaterialType;
    materialTypeScreens?: Screen[] | undefined;
    storedSkillAreas?: Screen[] | undefined;

    constructor(data?: IMaterialTypeMgm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialType = _data["materialType"] ? MaterialType.fromJS(_data["materialType"]) : undefined as any;
            if (Array.isArray(_data["materialTypeScreens"])) {
                this.materialTypeScreens = [] as any;
                for (let item of _data["materialTypeScreens"])
                    this.materialTypeScreens!.push(Screen.fromJS(item));
            }
            if (Array.isArray(_data["storedSkillAreas"])) {
                this.storedSkillAreas = [] as any;
                for (let item of _data["storedSkillAreas"])
                    this.storedSkillAreas!.push(Screen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialTypeMgm {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialTypeMgm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialType"] = this.materialType ? this.materialType.toJSON() : undefined as any;
        if (Array.isArray(this.materialTypeScreens)) {
            data["materialTypeScreens"] = [];
            for (let item of this.materialTypeScreens)
                data["materialTypeScreens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.storedSkillAreas)) {
            data["storedSkillAreas"] = [];
            for (let item of this.storedSkillAreas)
                data["storedSkillAreas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMaterialTypeMgm {
    materialType?: MaterialType;
    materialTypeScreens?: Screen[] | undefined;
    storedSkillAreas?: Screen[] | undefined;
}

export class MaterialTypeScreen implements IMaterialTypeScreen {
    id?: string;
    materialTypeId?: string;
    screenId?: string;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    materialType?: MaterialType;
    screen?: Screen;
    updatedByPerson?: Person;

    constructor(data?: IMaterialTypeScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialTypeId = _data["materialTypeId"];
            this.screenId = _data["screenId"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.materialType = _data["materialType"] ? MaterialType.fromJS(_data["materialType"]) : undefined as any;
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): MaterialTypeScreen {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialTypeScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialTypeId"] = this.materialTypeId;
        data["screenId"] = this.screenId;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["materialType"] = this.materialType ? this.materialType.toJSON() : undefined as any;
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaterialTypeScreen {
    id?: string;
    materialTypeId?: string;
    screenId?: string;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    materialType?: MaterialType;
    screen?: Screen;
    updatedByPerson?: Person;
}

export class News implements INews {
    id?: string;
    headline?: string | undefined;
    newsContent?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    releaseDate?: Date | undefined;
    linkURL?: string | undefined;
    linkTitle?: string | undefined;
    icon?: string | undefined;
    image?: string | undefined;
    expirationDate?: Date | undefined;
    categoryId?: string | undefined;
    imageFileUri?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    emailSuperUserChannel?: boolean | undefined;
    emailAdmins?: boolean | undefined;
    emailErmCRISPUsers?: boolean | undefined;
    emailCustomerCRISPUsers?: boolean | undefined;
    emailnewsFeed?: boolean | undefined;
    category?: NewsCategory;
    createdByNavigation?: Person;
    newsPersonLog?: NewsPersonLog[] | undefined;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.headline = _data["headline"];
            this.newsContent = _data["newsContent"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.linkURL = _data["linkURL"];
            this.linkTitle = _data["linkTitle"];
            this.icon = _data["icon"];
            this.image = _data["image"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.categoryId = _data["categoryId"];
            this.imageFileUri = _data["imageFileUri"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.emailSuperUserChannel = _data["emailSuperUserChannel"];
            this.emailAdmins = _data["emailAdmins"];
            this.emailErmCRISPUsers = _data["emailErmCRISPUsers"];
            this.emailCustomerCRISPUsers = _data["emailCustomerCRISPUsers"];
            this.emailnewsFeed = _data["emailnewsFeed"];
            this.category = _data["category"] ? NewsCategory.fromJS(_data["category"]) : undefined as any;
            this.createdByNavigation = _data["createdByNavigation"] ? Person.fromJS(_data["createdByNavigation"]) : undefined as any;
            if (Array.isArray(_data["newsPersonLog"])) {
                this.newsPersonLog = [] as any;
                for (let item of _data["newsPersonLog"])
                    this.newsPersonLog!.push(NewsPersonLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["headline"] = this.headline;
        data["newsContent"] = this.newsContent;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["linkURL"] = this.linkURL;
        data["linkTitle"] = this.linkTitle;
        data["icon"] = this.icon;
        data["image"] = this.image;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["categoryId"] = this.categoryId;
        data["imageFileUri"] = this.imageFileUri;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["emailSuperUserChannel"] = this.emailSuperUserChannel;
        data["emailAdmins"] = this.emailAdmins;
        data["emailErmCRISPUsers"] = this.emailErmCRISPUsers;
        data["emailCustomerCRISPUsers"] = this.emailCustomerCRISPUsers;
        data["emailnewsFeed"] = this.emailnewsFeed;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["createdByNavigation"] = this.createdByNavigation ? this.createdByNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.newsPersonLog)) {
            data["newsPersonLog"] = [];
            for (let item of this.newsPersonLog)
                data["newsPersonLog"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INews {
    id?: string;
    headline?: string | undefined;
    newsContent?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    releaseDate?: Date | undefined;
    linkURL?: string | undefined;
    linkTitle?: string | undefined;
    icon?: string | undefined;
    image?: string | undefined;
    expirationDate?: Date | undefined;
    categoryId?: string | undefined;
    imageFileUri?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    emailSuperUserChannel?: boolean | undefined;
    emailAdmins?: boolean | undefined;
    emailErmCRISPUsers?: boolean | undefined;
    emailCustomerCRISPUsers?: boolean | undefined;
    emailnewsFeed?: boolean | undefined;
    category?: NewsCategory;
    createdByNavigation?: Person;
    newsPersonLog?: NewsPersonLog[] | undefined;
}

export class NewsCategory implements INewsCategory {
    id?: string;
    categoryName?: string | undefined;
    categoryIcon?: string | undefined;
    news?: News[] | undefined;

    constructor(data?: INewsCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryName = _data["categoryName"];
            this.categoryIcon = _data["categoryIcon"];
            if (Array.isArray(_data["news"])) {
                this.news = [] as any;
                for (let item of _data["news"])
                    this.news!.push(News.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsCategory {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryName"] = this.categoryName;
        data["categoryIcon"] = this.categoryIcon;
        if (Array.isArray(this.news)) {
            data["news"] = [];
            for (let item of this.news)
                data["news"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INewsCategory {
    id?: string;
    categoryName?: string | undefined;
    categoryIcon?: string | undefined;
    news?: News[] | undefined;
}

export class NewsPersonLog implements INewsPersonLog {
    id?: string;
    personId?: string | undefined;
    newsId?: string | undefined;
    readTimeStamp?: Date | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    news?: News;
    person?: Person;

    constructor(data?: INewsPersonLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.newsId = _data["newsId"];
            this.readTimeStamp = _data["readTimeStamp"] ? new Date(_data["readTimeStamp"].toString()) : undefined as any;
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.news = _data["news"] ? News.fromJS(_data["news"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
        }
    }

    static fromJS(data: any): NewsPersonLog {
        data = typeof data === 'object' ? data : {};
        let result = new NewsPersonLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["newsId"] = this.newsId;
        data["readTimeStamp"] = this.readTimeStamp ? this.readTimeStamp.toISOString() : undefined as any;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["news"] = this.news ? this.news.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        return data;
    }
}

export interface INewsPersonLog {
    id?: string;
    personId?: string | undefined;
    newsId?: string | undefined;
    readTimeStamp?: Date | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    news?: News;
    person?: Person;
}

export class PackDropdowns implements IPackDropdowns {
    referenceUnits?: MasterDropdown[] | undefined;

    constructor(data?: IPackDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["referenceUnits"])) {
                this.referenceUnits = [] as any;
                for (let item of _data["referenceUnits"])
                    this.referenceUnits!.push(MasterDropdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new PackDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.referenceUnits)) {
            data["referenceUnits"] = [];
            for (let item of this.referenceUnits)
                data["referenceUnits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPackDropdowns {
    referenceUnits?: MasterDropdown[] | undefined;
}

export class Person implements IPerson {
    id?: string;
    firstName?: string | undefined;
    emailId?: string | undefined;
    lastName?: string | undefined;
    userTypeId?: string | undefined;
    lastLogin?: Date | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    inversecreatedByPerson?: Person[] | undefined;
    inverseupdatedByPerson?: Person[] | undefined;
    wfiCleanSteamGenerationcreatedByPerson?: WFICleanSteamGeneration[] | undefined;
    wfiCleanSteamGenerationupdatedByPerson?: WFICleanSteamGeneration[] | undefined;
    wfiSourcecreatedByPerson?: WFISource[] | undefined;
    wfiSourceupdatedByPerson?: WFISource[] | undefined;
    assessmentCollaboratorscreatedByPerson?: AssessmentCollaborators[] | undefined;
    assessmentCollaboratorsperson?: AssessmentCollaborators[] | undefined;
    assessmentCollaboratorsupdatedByPerson?: AssessmentCollaborators[] | undefined;
    assessmentcreatedByPerson?: Assessment[] | undefined;
    assessmentlockedByPerson?: Assessment[] | undefined;
    assessmentupdatedByPerson?: Assessment[] | undefined;
    configurationVariablecreatedByPerson?: ConfigurationVariable[] | undefined;
    configurationVariableupdatedByPerson?: ConfigurationVariable[] | undefined;
    consumerEolMaterialDefaultcreatedByPerson?: ConsumerEolMaterialDefault[] | undefined;
    consumerEolMaterialDefaultupdatedByPerson?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    developmentStagecreatedByPerson?: DevelopmentStage[] | undefined;
    developmentStageupdatedByPerson?: DevelopmentStage[] | undefined;
    downstreamDistributioncreatedByPerson?: DownstreamDistribution[] | undefined;
    downstreamDistributionupdatedByPerson?: DownstreamDistribution[] | undefined;
    downstreamStepcreatedByPerson?: DownstreamStep[] | undefined;
    downstreamStepupdatedByPerson?: DownstreamStep[] | undefined;
    downstreamcreatedByPerson?: Downstream[] | undefined;
    downstreamupdatedByPerson?: Downstream[] | undefined;
    emissionFactorTypescreatedByPerson?: EmissionFactorTypes[] | undefined;
    emissionFactorTypesupdatedByPerson?: EmissionFactorTypes[] | undefined;
    emissionFactorscreatedByPerson?: EmissionFactors[] | undefined;
    emissionFactorsupdatedByPerson?: EmissionFactors[] | undefined;
    energyMultiplierscreatedByPerson?: EnergyMultipliers[] | undefined;
    energyMultipliersupdatedByPerson?: EnergyMultipliers[] | undefined;
    favorites?: Favorites[] | undefined;
    featureFlagcreatedByPerson?: FeatureFlag[] | undefined;
    featureFlagupdatedByPerson?: FeatureFlag[] | undefined;
    generalInformationcreatedByPerson?: GeneralInformation[] | undefined;
    generalInformationupdatedByPerson?: GeneralInformation[] | undefined;
    helpFieldcreatedByPerson?: HelpField[] | undefined;
    helpFieldupdatedByPerson?: HelpField[] | undefined;
    helpPagecreatedByPerson?: HelpPage[] | undefined;
    helpPageupdatedByPerson?: HelpPage[] | undefined;
    history?: History[] | undefined;
    intermediateStepcreatedByPerson?: IntermediateStep[] | undefined;
    intermediateStepupdatedByPerson?: IntermediateStep[] | undefined;
    knowledgeArticleFeedbackcreatedByPerson?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleFeedbackperson?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleFeedbackupdatedByPerson?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleTagcreatedByPerson?: KnowledgeArticleTag[] | undefined;
    knowledgeArticleTagupdatedByPerson?: KnowledgeArticleTag[] | undefined;
    knowledgeArticlecreatedByPerson?: KnowledgeArticle[] | undefined;
    knowledgeArticleupdatedByPerson?: KnowledgeArticle[] | undefined;
    knowledgeAttachmentcreatedByPerson?: KnowledgeAttachment[] | undefined;
    knowledgeAttachmentupdatedByPerson?: KnowledgeAttachment[] | undefined;
    knowledgeCategorycreatedByPerson?: KnowledgeCategory[] | undefined;
    knowledgeCategoryupdatedByPerson?: KnowledgeCategory[] | undefined;
    knowledgeInfoRequestcreatedByPerson?: KnowledgeInfoRequest[] | undefined;
    knowledgeInfoRequestperson?: KnowledgeInfoRequest[] | undefined;
    knowledgeInfoRequestupdatedByPerson?: KnowledgeInfoRequest[] | undefined;
    knowledgeSubcategorycreatedByPerson?: KnowledgeSubcategory[] | undefined;
    knowledgeSubcategoryupdatedByPerson?: KnowledgeSubcategory[] | undefined;
    knowledgeTagcreatedByPerson?: KnowledgeTag[] | undefined;
    knowledgeTagupdatedByPerson?: KnowledgeTag[] | undefined;
    masterCategorycreatedByPerson?: MasterCategory[] | undefined;
    masterCategoryupdatedByPerson?: MasterCategory[] | undefined;
    masterDropdowncreatedByPerson?: MasterDropdown[] | undefined;
    masterDropdownupdatedByPerson?: MasterDropdown[] | undefined;
    materialEmissionFactorcreatedByPerson?: MaterialEmissionFactor[] | undefined;
    materialEmissionFactorupdatedByPerson?: MaterialEmissionFactor[] | undefined;
    materialInboundTransportcreatedByPerson?: MaterialInboundTransport[] | undefined;
    materialInboundTransportupdatedByPerson?: MaterialInboundTransport[] | undefined;
    materialTypeScreencreatedByPerson?: MaterialTypeScreen[] | undefined;
    materialTypeScreenupdatedByPerson?: MaterialTypeScreen[] | undefined;
    materialTypecreatedByPerson?: MaterialType[] | undefined;
    materialTypeupdatedByPerson?: MaterialType[] | undefined;
    materialcreatedByPerson?: Material[] | undefined;
    materialupdatedByPerson?: Material[] | undefined;
    news?: News[] | undefined;
    newsPersonLog?: NewsPersonLog[] | undefined;
    personIdentityStatuscreatedByPerson?: PersonIdentityStatus[] | undefined;
    personIdentityStatusperson?: PersonIdentityStatus[] | undefined;
    personIdentityStatusupdatedByPerson?: PersonIdentityStatus[] | undefined;
    processWasteDetailcreatedByPerson?: ProcessWasteDetail[] | undefined;
    processWasteDetailupdatedByPerson?: ProcessWasteDetail[] | undefined;
    processWastecreatedByPerson?: ProcessWaste[] | undefined;
    processWasteupdatedByPerson?: ProcessWaste[] | undefined;
    productProcessProxyEntrycreatedByPerson?: ProductProcessProxyEntry[] | undefined;
    productProcessProxyEntryupdatedByPerson?: ProductProcessProxyEntry[] | undefined;
    productProcessProxycreatedByPerson?: ProductProcessProxy[] | undefined;
    productProcessProxyupdatedByPerson?: ProductProcessProxy[] | undefined;
    projectCollaborator?: ProjectCollaborator[] | undefined;
    projectcreatedByPerson?: Project[] | undefined;
    projectprojectOwnerNavigation?: Project[] | undefined;
    projectupdatedByPerson?: Project[] | undefined;
    rawMaterialEntrycreatedByPerson?: RawMaterialEntry[] | undefined;
    rawMaterialEntryupdatedByPerson?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperationcreatedByPerson?: RawMaterialUnitOperation[] | undefined;
    rawMaterialUnitOperationupdatedByPerson?: RawMaterialUnitOperation[] | undefined;
    rawMaterialcreatedByPerson?: RawMaterial[] | undefined;
    rawMaterialupdatedByPerson?: RawMaterial[] | undefined;
    referenceTablecreatedByPerson?: ReferenceTable[] | undefined;
    referenceTableupdatedByPerson?: ReferenceTable[] | undefined;
    relatableUnitcreatedByPerson?: RelatableUnit[] | undefined;
    relatableUnitupdatedByPerson?: RelatableUnit[] | undefined;
    reportAlternativecreatedByPerson?: ReportAlternative[] | undefined;
    reportAlternativeupdatedByPerson?: ReportAlternative[] | undefined;
    reportConfigurationcreatedByPerson?: ReportConfiguration[] | undefined;
    reportConfigurationupdatedByPerson?: ReportConfiguration[] | undefined;
    screencreatedByPerson?: Screen[] | undefined;
    screenupdatedByPerson?: Screen[] | undefined;
    stepcreatedByPerson?: Step[] | undefined;
    stepupdatedByPerson?: Step[] | undefined;
    subProjectCollaboratorcreatedByPerson?: SubProjectCollaborator[] | undefined;
    subProjectCollaboratorperson?: SubProjectCollaborator[] | undefined;
    subProjectCollaboratorupdatedByPerson?: SubProjectCollaborator[] | undefined;
    subProjectDefaultScreencreatedByPerson?: SubProjectDefaultScreen[] | undefined;
    subProjectDefaultScreenupdatedByPerson?: SubProjectDefaultScreen[] | undefined;
    subProjectcreatedByPerson?: SubProject[] | undefined;
    subProjectsubProjectOwnerNavigation?: SubProject[] | undefined;
    subProjectupdatedByPerson?: SubProject[] | undefined;
    templateUIcreatedByPerson?: TemplateUI[] | undefined;
    templateUIupdatedByPerson?: TemplateUI[] | undefined;
    transportEmissionFactorcreatedByPerson?: TransportEmissionFactor[] | undefined;
    transportEmissionFactorupdatedByPerson?: TransportEmissionFactor[] | undefined;
    transportModecreatedByPerson?: TransportMode[] | undefined;
    transportModeupdatedByPerson?: TransportMode[] | undefined;
    treeItemscreatedByPerson?: TreeItems[] | undefined;
    treeItemsupdatedByPerson?: TreeItems[] | undefined;
    treecreatedByPerson?: Tree[] | undefined;
    treeupdatedByPerson?: Tree[] | undefined;
    unitOperationStepcreatedByPerson?: UnitOperationStep[] | undefined;
    unitOperationStepupdatedByPerson?: UnitOperationStep[] | undefined;
    unitOperationcreatedByPerson?: UnitOperation[] | undefined;
    unitOperationupdatedByPerson?: UnitOperation[] | undefined;
    unitTypecreatedByPerson?: UnitType[] | undefined;
    unitTypeupdatedByPerson?: UnitType[] | undefined;
    unitcreatedByPerson?: Unit[] | undefined;
    unitupdatedByPerson?: Unit[] | undefined;
    updatedByPerson?: Person;
    userThemeSelectioncreatedByPerson?: UserThemeSelection[] | undefined;
    userThemeSelectionupdatedByPerson?: UserThemeSelection[] | undefined;
    userThemeSelectionuser?: UserThemeSelection;
    userType?: UserType;
    userTypeScreencreatedByPerson?: UserTypeScreen[] | undefined;
    userTypeScreenupdatedByPerson?: UserTypeScreen[] | undefined;
    userTypecreatedByPerson?: UserType[] | undefined;
    userTypeupdatedByPerson?: UserType[] | undefined;
    userUserType?: UserUserType[] | undefined;
    utilitiesEnergyConsumptioncreatedByPerson?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesEnergyConsumptionupdatedByPerson?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesProcessingOperationcreatedByPerson?: UtilitiesProcessingOperation[] | undefined;
    utilitiesProcessingOperationupdatedByPerson?: UtilitiesProcessingOperation[] | undefined;
    utilitiesSteamConsumptioncreatedByPerson?: UtilitiesSteamConsumption[] | undefined;
    utilitiesSteamConsumptionupdatedByPerson?: UtilitiesSteamConsumption[] | undefined;
    utilitiescreatedByPerson?: Utilities[] | undefined;
    utilitiesupdatedByPerson?: Utilities[] | undefined;
    wasteDisposalRoutecreatedByPerson?: WasteDisposalRoute[] | undefined;
    wasteDisposalRouteupdatedByPerson?: WasteDisposalRoute[] | undefined;
    wasteDisposalTypecreatedByPerson?: WasteDisposalType[] | undefined;
    wasteDisposalTypeupdatedByPerson?: WasteDisposalType[] | undefined;
    wasteTypeEmissionFactorcreatedByPerson?: WasteTypeEmissionFactor[] | undefined;
    wasteTypeEmissionFactorupdatedByPerson?: WasteTypeEmissionFactor[] | undefined;
    wasteTypecreatedByPerson?: WasteType[] | undefined;
    wasteTypeupdatedByPerson?: WasteType[] | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.emailId = _data["emailId"];
            this.lastName = _data["lastName"];
            this.userTypeId = _data["userTypeId"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["inversecreatedByPerson"])) {
                this.inversecreatedByPerson = [] as any;
                for (let item of _data["inversecreatedByPerson"])
                    this.inversecreatedByPerson!.push(Person.fromJS(item));
            }
            if (Array.isArray(_data["inverseupdatedByPerson"])) {
                this.inverseupdatedByPerson = [] as any;
                for (let item of _data["inverseupdatedByPerson"])
                    this.inverseupdatedByPerson!.push(Person.fromJS(item));
            }
            if (Array.isArray(_data["wfiCleanSteamGenerationcreatedByPerson"])) {
                this.wfiCleanSteamGenerationcreatedByPerson = [] as any;
                for (let item of _data["wfiCleanSteamGenerationcreatedByPerson"])
                    this.wfiCleanSteamGenerationcreatedByPerson!.push(WFICleanSteamGeneration.fromJS(item));
            }
            if (Array.isArray(_data["wfiCleanSteamGenerationupdatedByPerson"])) {
                this.wfiCleanSteamGenerationupdatedByPerson = [] as any;
                for (let item of _data["wfiCleanSteamGenerationupdatedByPerson"])
                    this.wfiCleanSteamGenerationupdatedByPerson!.push(WFICleanSteamGeneration.fromJS(item));
            }
            if (Array.isArray(_data["wfiSourcecreatedByPerson"])) {
                this.wfiSourcecreatedByPerson = [] as any;
                for (let item of _data["wfiSourcecreatedByPerson"])
                    this.wfiSourcecreatedByPerson!.push(WFISource.fromJS(item));
            }
            if (Array.isArray(_data["wfiSourceupdatedByPerson"])) {
                this.wfiSourceupdatedByPerson = [] as any;
                for (let item of _data["wfiSourceupdatedByPerson"])
                    this.wfiSourceupdatedByPerson!.push(WFISource.fromJS(item));
            }
            if (Array.isArray(_data["assessmentCollaboratorscreatedByPerson"])) {
                this.assessmentCollaboratorscreatedByPerson = [] as any;
                for (let item of _data["assessmentCollaboratorscreatedByPerson"])
                    this.assessmentCollaboratorscreatedByPerson!.push(AssessmentCollaborators.fromJS(item));
            }
            if (Array.isArray(_data["assessmentCollaboratorsperson"])) {
                this.assessmentCollaboratorsperson = [] as any;
                for (let item of _data["assessmentCollaboratorsperson"])
                    this.assessmentCollaboratorsperson!.push(AssessmentCollaborators.fromJS(item));
            }
            if (Array.isArray(_data["assessmentCollaboratorsupdatedByPerson"])) {
                this.assessmentCollaboratorsupdatedByPerson = [] as any;
                for (let item of _data["assessmentCollaboratorsupdatedByPerson"])
                    this.assessmentCollaboratorsupdatedByPerson!.push(AssessmentCollaborators.fromJS(item));
            }
            if (Array.isArray(_data["assessmentcreatedByPerson"])) {
                this.assessmentcreatedByPerson = [] as any;
                for (let item of _data["assessmentcreatedByPerson"])
                    this.assessmentcreatedByPerson!.push(Assessment.fromJS(item));
            }
            if (Array.isArray(_data["assessmentlockedByPerson"])) {
                this.assessmentlockedByPerson = [] as any;
                for (let item of _data["assessmentlockedByPerson"])
                    this.assessmentlockedByPerson!.push(Assessment.fromJS(item));
            }
            if (Array.isArray(_data["assessmentupdatedByPerson"])) {
                this.assessmentupdatedByPerson = [] as any;
                for (let item of _data["assessmentupdatedByPerson"])
                    this.assessmentupdatedByPerson!.push(Assessment.fromJS(item));
            }
            if (Array.isArray(_data["configurationVariablecreatedByPerson"])) {
                this.configurationVariablecreatedByPerson = [] as any;
                for (let item of _data["configurationVariablecreatedByPerson"])
                    this.configurationVariablecreatedByPerson!.push(ConfigurationVariable.fromJS(item));
            }
            if (Array.isArray(_data["configurationVariableupdatedByPerson"])) {
                this.configurationVariableupdatedByPerson = [] as any;
                for (let item of _data["configurationVariableupdatedByPerson"])
                    this.configurationVariableupdatedByPerson!.push(ConfigurationVariable.fromJS(item));
            }
            if (Array.isArray(_data["consumerEolMaterialDefaultcreatedByPerson"])) {
                this.consumerEolMaterialDefaultcreatedByPerson = [] as any;
                for (let item of _data["consumerEolMaterialDefaultcreatedByPerson"])
                    this.consumerEolMaterialDefaultcreatedByPerson!.push(ConsumerEolMaterialDefault.fromJS(item));
            }
            if (Array.isArray(_data["consumerEolMaterialDefaultupdatedByPerson"])) {
                this.consumerEolMaterialDefaultupdatedByPerson = [] as any;
                for (let item of _data["consumerEolMaterialDefaultupdatedByPerson"])
                    this.consumerEolMaterialDefaultupdatedByPerson!.push(ConsumerEolMaterialDefault.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["developmentStagecreatedByPerson"])) {
                this.developmentStagecreatedByPerson = [] as any;
                for (let item of _data["developmentStagecreatedByPerson"])
                    this.developmentStagecreatedByPerson!.push(DevelopmentStage.fromJS(item));
            }
            if (Array.isArray(_data["developmentStageupdatedByPerson"])) {
                this.developmentStageupdatedByPerson = [] as any;
                for (let item of _data["developmentStageupdatedByPerson"])
                    this.developmentStageupdatedByPerson!.push(DevelopmentStage.fromJS(item));
            }
            if (Array.isArray(_data["downstreamDistributioncreatedByPerson"])) {
                this.downstreamDistributioncreatedByPerson = [] as any;
                for (let item of _data["downstreamDistributioncreatedByPerson"])
                    this.downstreamDistributioncreatedByPerson!.push(DownstreamDistribution.fromJS(item));
            }
            if (Array.isArray(_data["downstreamDistributionupdatedByPerson"])) {
                this.downstreamDistributionupdatedByPerson = [] as any;
                for (let item of _data["downstreamDistributionupdatedByPerson"])
                    this.downstreamDistributionupdatedByPerson!.push(DownstreamDistribution.fromJS(item));
            }
            if (Array.isArray(_data["downstreamStepcreatedByPerson"])) {
                this.downstreamStepcreatedByPerson = [] as any;
                for (let item of _data["downstreamStepcreatedByPerson"])
                    this.downstreamStepcreatedByPerson!.push(DownstreamStep.fromJS(item));
            }
            if (Array.isArray(_data["downstreamStepupdatedByPerson"])) {
                this.downstreamStepupdatedByPerson = [] as any;
                for (let item of _data["downstreamStepupdatedByPerson"])
                    this.downstreamStepupdatedByPerson!.push(DownstreamStep.fromJS(item));
            }
            if (Array.isArray(_data["downstreamcreatedByPerson"])) {
                this.downstreamcreatedByPerson = [] as any;
                for (let item of _data["downstreamcreatedByPerson"])
                    this.downstreamcreatedByPerson!.push(Downstream.fromJS(item));
            }
            if (Array.isArray(_data["downstreamupdatedByPerson"])) {
                this.downstreamupdatedByPerson = [] as any;
                for (let item of _data["downstreamupdatedByPerson"])
                    this.downstreamupdatedByPerson!.push(Downstream.fromJS(item));
            }
            if (Array.isArray(_data["emissionFactorTypescreatedByPerson"])) {
                this.emissionFactorTypescreatedByPerson = [] as any;
                for (let item of _data["emissionFactorTypescreatedByPerson"])
                    this.emissionFactorTypescreatedByPerson!.push(EmissionFactorTypes.fromJS(item));
            }
            if (Array.isArray(_data["emissionFactorTypesupdatedByPerson"])) {
                this.emissionFactorTypesupdatedByPerson = [] as any;
                for (let item of _data["emissionFactorTypesupdatedByPerson"])
                    this.emissionFactorTypesupdatedByPerson!.push(EmissionFactorTypes.fromJS(item));
            }
            if (Array.isArray(_data["emissionFactorscreatedByPerson"])) {
                this.emissionFactorscreatedByPerson = [] as any;
                for (let item of _data["emissionFactorscreatedByPerson"])
                    this.emissionFactorscreatedByPerson!.push(EmissionFactors.fromJS(item));
            }
            if (Array.isArray(_data["emissionFactorsupdatedByPerson"])) {
                this.emissionFactorsupdatedByPerson = [] as any;
                for (let item of _data["emissionFactorsupdatedByPerson"])
                    this.emissionFactorsupdatedByPerson!.push(EmissionFactors.fromJS(item));
            }
            if (Array.isArray(_data["energyMultiplierscreatedByPerson"])) {
                this.energyMultiplierscreatedByPerson = [] as any;
                for (let item of _data["energyMultiplierscreatedByPerson"])
                    this.energyMultiplierscreatedByPerson!.push(EnergyMultipliers.fromJS(item));
            }
            if (Array.isArray(_data["energyMultipliersupdatedByPerson"])) {
                this.energyMultipliersupdatedByPerson = [] as any;
                for (let item of _data["energyMultipliersupdatedByPerson"])
                    this.energyMultipliersupdatedByPerson!.push(EnergyMultipliers.fromJS(item));
            }
            if (Array.isArray(_data["favorites"])) {
                this.favorites = [] as any;
                for (let item of _data["favorites"])
                    this.favorites!.push(Favorites.fromJS(item));
            }
            if (Array.isArray(_data["featureFlagcreatedByPerson"])) {
                this.featureFlagcreatedByPerson = [] as any;
                for (let item of _data["featureFlagcreatedByPerson"])
                    this.featureFlagcreatedByPerson!.push(FeatureFlag.fromJS(item));
            }
            if (Array.isArray(_data["featureFlagupdatedByPerson"])) {
                this.featureFlagupdatedByPerson = [] as any;
                for (let item of _data["featureFlagupdatedByPerson"])
                    this.featureFlagupdatedByPerson!.push(FeatureFlag.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationcreatedByPerson"])) {
                this.generalInformationcreatedByPerson = [] as any;
                for (let item of _data["generalInformationcreatedByPerson"])
                    this.generalInformationcreatedByPerson!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationupdatedByPerson"])) {
                this.generalInformationupdatedByPerson = [] as any;
                for (let item of _data["generalInformationupdatedByPerson"])
                    this.generalInformationupdatedByPerson!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["helpFieldcreatedByPerson"])) {
                this.helpFieldcreatedByPerson = [] as any;
                for (let item of _data["helpFieldcreatedByPerson"])
                    this.helpFieldcreatedByPerson!.push(HelpField.fromJS(item));
            }
            if (Array.isArray(_data["helpFieldupdatedByPerson"])) {
                this.helpFieldupdatedByPerson = [] as any;
                for (let item of _data["helpFieldupdatedByPerson"])
                    this.helpFieldupdatedByPerson!.push(HelpField.fromJS(item));
            }
            if (Array.isArray(_data["helpPagecreatedByPerson"])) {
                this.helpPagecreatedByPerson = [] as any;
                for (let item of _data["helpPagecreatedByPerson"])
                    this.helpPagecreatedByPerson!.push(HelpPage.fromJS(item));
            }
            if (Array.isArray(_data["helpPageupdatedByPerson"])) {
                this.helpPageupdatedByPerson = [] as any;
                for (let item of _data["helpPageupdatedByPerson"])
                    this.helpPageupdatedByPerson!.push(HelpPage.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(History.fromJS(item));
            }
            if (Array.isArray(_data["intermediateStepcreatedByPerson"])) {
                this.intermediateStepcreatedByPerson = [] as any;
                for (let item of _data["intermediateStepcreatedByPerson"])
                    this.intermediateStepcreatedByPerson!.push(IntermediateStep.fromJS(item));
            }
            if (Array.isArray(_data["intermediateStepupdatedByPerson"])) {
                this.intermediateStepupdatedByPerson = [] as any;
                for (let item of _data["intermediateStepupdatedByPerson"])
                    this.intermediateStepupdatedByPerson!.push(IntermediateStep.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticleFeedbackcreatedByPerson"])) {
                this.knowledgeArticleFeedbackcreatedByPerson = [] as any;
                for (let item of _data["knowledgeArticleFeedbackcreatedByPerson"])
                    this.knowledgeArticleFeedbackcreatedByPerson!.push(KnowledgeArticleFeedback.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticleFeedbackperson"])) {
                this.knowledgeArticleFeedbackperson = [] as any;
                for (let item of _data["knowledgeArticleFeedbackperson"])
                    this.knowledgeArticleFeedbackperson!.push(KnowledgeArticleFeedback.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticleFeedbackupdatedByPerson"])) {
                this.knowledgeArticleFeedbackupdatedByPerson = [] as any;
                for (let item of _data["knowledgeArticleFeedbackupdatedByPerson"])
                    this.knowledgeArticleFeedbackupdatedByPerson!.push(KnowledgeArticleFeedback.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticleTagcreatedByPerson"])) {
                this.knowledgeArticleTagcreatedByPerson = [] as any;
                for (let item of _data["knowledgeArticleTagcreatedByPerson"])
                    this.knowledgeArticleTagcreatedByPerson!.push(KnowledgeArticleTag.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticleTagupdatedByPerson"])) {
                this.knowledgeArticleTagupdatedByPerson = [] as any;
                for (let item of _data["knowledgeArticleTagupdatedByPerson"])
                    this.knowledgeArticleTagupdatedByPerson!.push(KnowledgeArticleTag.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticlecreatedByPerson"])) {
                this.knowledgeArticlecreatedByPerson = [] as any;
                for (let item of _data["knowledgeArticlecreatedByPerson"])
                    this.knowledgeArticlecreatedByPerson!.push(KnowledgeArticle.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeArticleupdatedByPerson"])) {
                this.knowledgeArticleupdatedByPerson = [] as any;
                for (let item of _data["knowledgeArticleupdatedByPerson"])
                    this.knowledgeArticleupdatedByPerson!.push(KnowledgeArticle.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeAttachmentcreatedByPerson"])) {
                this.knowledgeAttachmentcreatedByPerson = [] as any;
                for (let item of _data["knowledgeAttachmentcreatedByPerson"])
                    this.knowledgeAttachmentcreatedByPerson!.push(KnowledgeAttachment.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeAttachmentupdatedByPerson"])) {
                this.knowledgeAttachmentupdatedByPerson = [] as any;
                for (let item of _data["knowledgeAttachmentupdatedByPerson"])
                    this.knowledgeAttachmentupdatedByPerson!.push(KnowledgeAttachment.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeCategorycreatedByPerson"])) {
                this.knowledgeCategorycreatedByPerson = [] as any;
                for (let item of _data["knowledgeCategorycreatedByPerson"])
                    this.knowledgeCategorycreatedByPerson!.push(KnowledgeCategory.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeCategoryupdatedByPerson"])) {
                this.knowledgeCategoryupdatedByPerson = [] as any;
                for (let item of _data["knowledgeCategoryupdatedByPerson"])
                    this.knowledgeCategoryupdatedByPerson!.push(KnowledgeCategory.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeInfoRequestcreatedByPerson"])) {
                this.knowledgeInfoRequestcreatedByPerson = [] as any;
                for (let item of _data["knowledgeInfoRequestcreatedByPerson"])
                    this.knowledgeInfoRequestcreatedByPerson!.push(KnowledgeInfoRequest.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeInfoRequestperson"])) {
                this.knowledgeInfoRequestperson = [] as any;
                for (let item of _data["knowledgeInfoRequestperson"])
                    this.knowledgeInfoRequestperson!.push(KnowledgeInfoRequest.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeInfoRequestupdatedByPerson"])) {
                this.knowledgeInfoRequestupdatedByPerson = [] as any;
                for (let item of _data["knowledgeInfoRequestupdatedByPerson"])
                    this.knowledgeInfoRequestupdatedByPerson!.push(KnowledgeInfoRequest.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeSubcategorycreatedByPerson"])) {
                this.knowledgeSubcategorycreatedByPerson = [] as any;
                for (let item of _data["knowledgeSubcategorycreatedByPerson"])
                    this.knowledgeSubcategorycreatedByPerson!.push(KnowledgeSubcategory.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeSubcategoryupdatedByPerson"])) {
                this.knowledgeSubcategoryupdatedByPerson = [] as any;
                for (let item of _data["knowledgeSubcategoryupdatedByPerson"])
                    this.knowledgeSubcategoryupdatedByPerson!.push(KnowledgeSubcategory.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeTagcreatedByPerson"])) {
                this.knowledgeTagcreatedByPerson = [] as any;
                for (let item of _data["knowledgeTagcreatedByPerson"])
                    this.knowledgeTagcreatedByPerson!.push(KnowledgeTag.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeTagupdatedByPerson"])) {
                this.knowledgeTagupdatedByPerson = [] as any;
                for (let item of _data["knowledgeTagupdatedByPerson"])
                    this.knowledgeTagupdatedByPerson!.push(KnowledgeTag.fromJS(item));
            }
            if (Array.isArray(_data["masterCategorycreatedByPerson"])) {
                this.masterCategorycreatedByPerson = [] as any;
                for (let item of _data["masterCategorycreatedByPerson"])
                    this.masterCategorycreatedByPerson!.push(MasterCategory.fromJS(item));
            }
            if (Array.isArray(_data["masterCategoryupdatedByPerson"])) {
                this.masterCategoryupdatedByPerson = [] as any;
                for (let item of _data["masterCategoryupdatedByPerson"])
                    this.masterCategoryupdatedByPerson!.push(MasterCategory.fromJS(item));
            }
            if (Array.isArray(_data["masterDropdowncreatedByPerson"])) {
                this.masterDropdowncreatedByPerson = [] as any;
                for (let item of _data["masterDropdowncreatedByPerson"])
                    this.masterDropdowncreatedByPerson!.push(MasterDropdown.fromJS(item));
            }
            if (Array.isArray(_data["masterDropdownupdatedByPerson"])) {
                this.masterDropdownupdatedByPerson = [] as any;
                for (let item of _data["masterDropdownupdatedByPerson"])
                    this.masterDropdownupdatedByPerson!.push(MasterDropdown.fromJS(item));
            }
            if (Array.isArray(_data["materialEmissionFactorcreatedByPerson"])) {
                this.materialEmissionFactorcreatedByPerson = [] as any;
                for (let item of _data["materialEmissionFactorcreatedByPerson"])
                    this.materialEmissionFactorcreatedByPerson!.push(MaterialEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["materialEmissionFactorupdatedByPerson"])) {
                this.materialEmissionFactorupdatedByPerson = [] as any;
                for (let item of _data["materialEmissionFactorupdatedByPerson"])
                    this.materialEmissionFactorupdatedByPerson!.push(MaterialEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["materialInboundTransportcreatedByPerson"])) {
                this.materialInboundTransportcreatedByPerson = [] as any;
                for (let item of _data["materialInboundTransportcreatedByPerson"])
                    this.materialInboundTransportcreatedByPerson!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["materialInboundTransportupdatedByPerson"])) {
                this.materialInboundTransportupdatedByPerson = [] as any;
                for (let item of _data["materialInboundTransportupdatedByPerson"])
                    this.materialInboundTransportupdatedByPerson!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["materialTypeScreencreatedByPerson"])) {
                this.materialTypeScreencreatedByPerson = [] as any;
                for (let item of _data["materialTypeScreencreatedByPerson"])
                    this.materialTypeScreencreatedByPerson!.push(MaterialTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["materialTypeScreenupdatedByPerson"])) {
                this.materialTypeScreenupdatedByPerson = [] as any;
                for (let item of _data["materialTypeScreenupdatedByPerson"])
                    this.materialTypeScreenupdatedByPerson!.push(MaterialTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["materialTypecreatedByPerson"])) {
                this.materialTypecreatedByPerson = [] as any;
                for (let item of _data["materialTypecreatedByPerson"])
                    this.materialTypecreatedByPerson!.push(MaterialType.fromJS(item));
            }
            if (Array.isArray(_data["materialTypeupdatedByPerson"])) {
                this.materialTypeupdatedByPerson = [] as any;
                for (let item of _data["materialTypeupdatedByPerson"])
                    this.materialTypeupdatedByPerson!.push(MaterialType.fromJS(item));
            }
            if (Array.isArray(_data["materialcreatedByPerson"])) {
                this.materialcreatedByPerson = [] as any;
                for (let item of _data["materialcreatedByPerson"])
                    this.materialcreatedByPerson!.push(Material.fromJS(item));
            }
            if (Array.isArray(_data["materialupdatedByPerson"])) {
                this.materialupdatedByPerson = [] as any;
                for (let item of _data["materialupdatedByPerson"])
                    this.materialupdatedByPerson!.push(Material.fromJS(item));
            }
            if (Array.isArray(_data["news"])) {
                this.news = [] as any;
                for (let item of _data["news"])
                    this.news!.push(News.fromJS(item));
            }
            if (Array.isArray(_data["newsPersonLog"])) {
                this.newsPersonLog = [] as any;
                for (let item of _data["newsPersonLog"])
                    this.newsPersonLog!.push(NewsPersonLog.fromJS(item));
            }
            if (Array.isArray(_data["personIdentityStatuscreatedByPerson"])) {
                this.personIdentityStatuscreatedByPerson = [] as any;
                for (let item of _data["personIdentityStatuscreatedByPerson"])
                    this.personIdentityStatuscreatedByPerson!.push(PersonIdentityStatus.fromJS(item));
            }
            if (Array.isArray(_data["personIdentityStatusperson"])) {
                this.personIdentityStatusperson = [] as any;
                for (let item of _data["personIdentityStatusperson"])
                    this.personIdentityStatusperson!.push(PersonIdentityStatus.fromJS(item));
            }
            if (Array.isArray(_data["personIdentityStatusupdatedByPerson"])) {
                this.personIdentityStatusupdatedByPerson = [] as any;
                for (let item of _data["personIdentityStatusupdatedByPerson"])
                    this.personIdentityStatusupdatedByPerson!.push(PersonIdentityStatus.fromJS(item));
            }
            if (Array.isArray(_data["processWasteDetailcreatedByPerson"])) {
                this.processWasteDetailcreatedByPerson = [] as any;
                for (let item of _data["processWasteDetailcreatedByPerson"])
                    this.processWasteDetailcreatedByPerson!.push(ProcessWasteDetail.fromJS(item));
            }
            if (Array.isArray(_data["processWasteDetailupdatedByPerson"])) {
                this.processWasteDetailupdatedByPerson = [] as any;
                for (let item of _data["processWasteDetailupdatedByPerson"])
                    this.processWasteDetailupdatedByPerson!.push(ProcessWasteDetail.fromJS(item));
            }
            if (Array.isArray(_data["processWastecreatedByPerson"])) {
                this.processWastecreatedByPerson = [] as any;
                for (let item of _data["processWastecreatedByPerson"])
                    this.processWastecreatedByPerson!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["processWasteupdatedByPerson"])) {
                this.processWasteupdatedByPerson = [] as any;
                for (let item of _data["processWasteupdatedByPerson"])
                    this.processWasteupdatedByPerson!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEntrycreatedByPerson"])) {
                this.productProcessProxyEntrycreatedByPerson = [] as any;
                for (let item of _data["productProcessProxyEntrycreatedByPerson"])
                    this.productProcessProxyEntrycreatedByPerson!.push(ProductProcessProxyEntry.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEntryupdatedByPerson"])) {
                this.productProcessProxyEntryupdatedByPerson = [] as any;
                for (let item of _data["productProcessProxyEntryupdatedByPerson"])
                    this.productProcessProxyEntryupdatedByPerson!.push(ProductProcessProxyEntry.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxycreatedByPerson"])) {
                this.productProcessProxycreatedByPerson = [] as any;
                for (let item of _data["productProcessProxycreatedByPerson"])
                    this.productProcessProxycreatedByPerson!.push(ProductProcessProxy.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyupdatedByPerson"])) {
                this.productProcessProxyupdatedByPerson = [] as any;
                for (let item of _data["productProcessProxyupdatedByPerson"])
                    this.productProcessProxyupdatedByPerson!.push(ProductProcessProxy.fromJS(item));
            }
            if (Array.isArray(_data["projectCollaborator"])) {
                this.projectCollaborator = [] as any;
                for (let item of _data["projectCollaborator"])
                    this.projectCollaborator!.push(ProjectCollaborator.fromJS(item));
            }
            if (Array.isArray(_data["projectcreatedByPerson"])) {
                this.projectcreatedByPerson = [] as any;
                for (let item of _data["projectcreatedByPerson"])
                    this.projectcreatedByPerson!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["projectprojectOwnerNavigation"])) {
                this.projectprojectOwnerNavigation = [] as any;
                for (let item of _data["projectprojectOwnerNavigation"])
                    this.projectprojectOwnerNavigation!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["projectupdatedByPerson"])) {
                this.projectupdatedByPerson = [] as any;
                for (let item of _data["projectupdatedByPerson"])
                    this.projectupdatedByPerson!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntrycreatedByPerson"])) {
                this.rawMaterialEntrycreatedByPerson = [] as any;
                for (let item of _data["rawMaterialEntrycreatedByPerson"])
                    this.rawMaterialEntrycreatedByPerson!.push(RawMaterialEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntryupdatedByPerson"])) {
                this.rawMaterialEntryupdatedByPerson = [] as any;
                for (let item of _data["rawMaterialEntryupdatedByPerson"])
                    this.rawMaterialEntryupdatedByPerson!.push(RawMaterialEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialUnitOperationcreatedByPerson"])) {
                this.rawMaterialUnitOperationcreatedByPerson = [] as any;
                for (let item of _data["rawMaterialUnitOperationcreatedByPerson"])
                    this.rawMaterialUnitOperationcreatedByPerson!.push(RawMaterialUnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialUnitOperationupdatedByPerson"])) {
                this.rawMaterialUnitOperationupdatedByPerson = [] as any;
                for (let item of _data["rawMaterialUnitOperationupdatedByPerson"])
                    this.rawMaterialUnitOperationupdatedByPerson!.push(RawMaterialUnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialcreatedByPerson"])) {
                this.rawMaterialcreatedByPerson = [] as any;
                for (let item of _data["rawMaterialcreatedByPerson"])
                    this.rawMaterialcreatedByPerson!.push(RawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialupdatedByPerson"])) {
                this.rawMaterialupdatedByPerson = [] as any;
                for (let item of _data["rawMaterialupdatedByPerson"])
                    this.rawMaterialupdatedByPerson!.push(RawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["referenceTablecreatedByPerson"])) {
                this.referenceTablecreatedByPerson = [] as any;
                for (let item of _data["referenceTablecreatedByPerson"])
                    this.referenceTablecreatedByPerson!.push(ReferenceTable.fromJS(item));
            }
            if (Array.isArray(_data["referenceTableupdatedByPerson"])) {
                this.referenceTableupdatedByPerson = [] as any;
                for (let item of _data["referenceTableupdatedByPerson"])
                    this.referenceTableupdatedByPerson!.push(ReferenceTable.fromJS(item));
            }
            if (Array.isArray(_data["relatableUnitcreatedByPerson"])) {
                this.relatableUnitcreatedByPerson = [] as any;
                for (let item of _data["relatableUnitcreatedByPerson"])
                    this.relatableUnitcreatedByPerson!.push(RelatableUnit.fromJS(item));
            }
            if (Array.isArray(_data["relatableUnitupdatedByPerson"])) {
                this.relatableUnitupdatedByPerson = [] as any;
                for (let item of _data["relatableUnitupdatedByPerson"])
                    this.relatableUnitupdatedByPerson!.push(RelatableUnit.fromJS(item));
            }
            if (Array.isArray(_data["reportAlternativecreatedByPerson"])) {
                this.reportAlternativecreatedByPerson = [] as any;
                for (let item of _data["reportAlternativecreatedByPerson"])
                    this.reportAlternativecreatedByPerson!.push(ReportAlternative.fromJS(item));
            }
            if (Array.isArray(_data["reportAlternativeupdatedByPerson"])) {
                this.reportAlternativeupdatedByPerson = [] as any;
                for (let item of _data["reportAlternativeupdatedByPerson"])
                    this.reportAlternativeupdatedByPerson!.push(ReportAlternative.fromJS(item));
            }
            if (Array.isArray(_data["reportConfigurationcreatedByPerson"])) {
                this.reportConfigurationcreatedByPerson = [] as any;
                for (let item of _data["reportConfigurationcreatedByPerson"])
                    this.reportConfigurationcreatedByPerson!.push(ReportConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["reportConfigurationupdatedByPerson"])) {
                this.reportConfigurationupdatedByPerson = [] as any;
                for (let item of _data["reportConfigurationupdatedByPerson"])
                    this.reportConfigurationupdatedByPerson!.push(ReportConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["screencreatedByPerson"])) {
                this.screencreatedByPerson = [] as any;
                for (let item of _data["screencreatedByPerson"])
                    this.screencreatedByPerson!.push(Screen.fromJS(item));
            }
            if (Array.isArray(_data["screenupdatedByPerson"])) {
                this.screenupdatedByPerson = [] as any;
                for (let item of _data["screenupdatedByPerson"])
                    this.screenupdatedByPerson!.push(Screen.fromJS(item));
            }
            if (Array.isArray(_data["stepcreatedByPerson"])) {
                this.stepcreatedByPerson = [] as any;
                for (let item of _data["stepcreatedByPerson"])
                    this.stepcreatedByPerson!.push(Step.fromJS(item));
            }
            if (Array.isArray(_data["stepupdatedByPerson"])) {
                this.stepupdatedByPerson = [] as any;
                for (let item of _data["stepupdatedByPerson"])
                    this.stepupdatedByPerson!.push(Step.fromJS(item));
            }
            if (Array.isArray(_data["subProjectCollaboratorcreatedByPerson"])) {
                this.subProjectCollaboratorcreatedByPerson = [] as any;
                for (let item of _data["subProjectCollaboratorcreatedByPerson"])
                    this.subProjectCollaboratorcreatedByPerson!.push(SubProjectCollaborator.fromJS(item));
            }
            if (Array.isArray(_data["subProjectCollaboratorperson"])) {
                this.subProjectCollaboratorperson = [] as any;
                for (let item of _data["subProjectCollaboratorperson"])
                    this.subProjectCollaboratorperson!.push(SubProjectCollaborator.fromJS(item));
            }
            if (Array.isArray(_data["subProjectCollaboratorupdatedByPerson"])) {
                this.subProjectCollaboratorupdatedByPerson = [] as any;
                for (let item of _data["subProjectCollaboratorupdatedByPerson"])
                    this.subProjectCollaboratorupdatedByPerson!.push(SubProjectCollaborator.fromJS(item));
            }
            if (Array.isArray(_data["subProjectDefaultScreencreatedByPerson"])) {
                this.subProjectDefaultScreencreatedByPerson = [] as any;
                for (let item of _data["subProjectDefaultScreencreatedByPerson"])
                    this.subProjectDefaultScreencreatedByPerson!.push(SubProjectDefaultScreen.fromJS(item));
            }
            if (Array.isArray(_data["subProjectDefaultScreenupdatedByPerson"])) {
                this.subProjectDefaultScreenupdatedByPerson = [] as any;
                for (let item of _data["subProjectDefaultScreenupdatedByPerson"])
                    this.subProjectDefaultScreenupdatedByPerson!.push(SubProjectDefaultScreen.fromJS(item));
            }
            if (Array.isArray(_data["subProjectcreatedByPerson"])) {
                this.subProjectcreatedByPerson = [] as any;
                for (let item of _data["subProjectcreatedByPerson"])
                    this.subProjectcreatedByPerson!.push(SubProject.fromJS(item));
            }
            if (Array.isArray(_data["subProjectsubProjectOwnerNavigation"])) {
                this.subProjectsubProjectOwnerNavigation = [] as any;
                for (let item of _data["subProjectsubProjectOwnerNavigation"])
                    this.subProjectsubProjectOwnerNavigation!.push(SubProject.fromJS(item));
            }
            if (Array.isArray(_data["subProjectupdatedByPerson"])) {
                this.subProjectupdatedByPerson = [] as any;
                for (let item of _data["subProjectupdatedByPerson"])
                    this.subProjectupdatedByPerson!.push(SubProject.fromJS(item));
            }
            if (Array.isArray(_data["templateUIcreatedByPerson"])) {
                this.templateUIcreatedByPerson = [] as any;
                for (let item of _data["templateUIcreatedByPerson"])
                    this.templateUIcreatedByPerson!.push(TemplateUI.fromJS(item));
            }
            if (Array.isArray(_data["templateUIupdatedByPerson"])) {
                this.templateUIupdatedByPerson = [] as any;
                for (let item of _data["templateUIupdatedByPerson"])
                    this.templateUIupdatedByPerson!.push(TemplateUI.fromJS(item));
            }
            if (Array.isArray(_data["transportEmissionFactorcreatedByPerson"])) {
                this.transportEmissionFactorcreatedByPerson = [] as any;
                for (let item of _data["transportEmissionFactorcreatedByPerson"])
                    this.transportEmissionFactorcreatedByPerson!.push(TransportEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["transportEmissionFactorupdatedByPerson"])) {
                this.transportEmissionFactorupdatedByPerson = [] as any;
                for (let item of _data["transportEmissionFactorupdatedByPerson"])
                    this.transportEmissionFactorupdatedByPerson!.push(TransportEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["transportModecreatedByPerson"])) {
                this.transportModecreatedByPerson = [] as any;
                for (let item of _data["transportModecreatedByPerson"])
                    this.transportModecreatedByPerson!.push(TransportMode.fromJS(item));
            }
            if (Array.isArray(_data["transportModeupdatedByPerson"])) {
                this.transportModeupdatedByPerson = [] as any;
                for (let item of _data["transportModeupdatedByPerson"])
                    this.transportModeupdatedByPerson!.push(TransportMode.fromJS(item));
            }
            if (Array.isArray(_data["treeItemscreatedByPerson"])) {
                this.treeItemscreatedByPerson = [] as any;
                for (let item of _data["treeItemscreatedByPerson"])
                    this.treeItemscreatedByPerson!.push(TreeItems.fromJS(item));
            }
            if (Array.isArray(_data["treeItemsupdatedByPerson"])) {
                this.treeItemsupdatedByPerson = [] as any;
                for (let item of _data["treeItemsupdatedByPerson"])
                    this.treeItemsupdatedByPerson!.push(TreeItems.fromJS(item));
            }
            if (Array.isArray(_data["treecreatedByPerson"])) {
                this.treecreatedByPerson = [] as any;
                for (let item of _data["treecreatedByPerson"])
                    this.treecreatedByPerson!.push(Tree.fromJS(item));
            }
            if (Array.isArray(_data["treeupdatedByPerson"])) {
                this.treeupdatedByPerson = [] as any;
                for (let item of _data["treeupdatedByPerson"])
                    this.treeupdatedByPerson!.push(Tree.fromJS(item));
            }
            if (Array.isArray(_data["unitOperationStepcreatedByPerson"])) {
                this.unitOperationStepcreatedByPerson = [] as any;
                for (let item of _data["unitOperationStepcreatedByPerson"])
                    this.unitOperationStepcreatedByPerson!.push(UnitOperationStep.fromJS(item));
            }
            if (Array.isArray(_data["unitOperationStepupdatedByPerson"])) {
                this.unitOperationStepupdatedByPerson = [] as any;
                for (let item of _data["unitOperationStepupdatedByPerson"])
                    this.unitOperationStepupdatedByPerson!.push(UnitOperationStep.fromJS(item));
            }
            if (Array.isArray(_data["unitOperationcreatedByPerson"])) {
                this.unitOperationcreatedByPerson = [] as any;
                for (let item of _data["unitOperationcreatedByPerson"])
                    this.unitOperationcreatedByPerson!.push(UnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["unitOperationupdatedByPerson"])) {
                this.unitOperationupdatedByPerson = [] as any;
                for (let item of _data["unitOperationupdatedByPerson"])
                    this.unitOperationupdatedByPerson!.push(UnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["unitTypecreatedByPerson"])) {
                this.unitTypecreatedByPerson = [] as any;
                for (let item of _data["unitTypecreatedByPerson"])
                    this.unitTypecreatedByPerson!.push(UnitType.fromJS(item));
            }
            if (Array.isArray(_data["unitTypeupdatedByPerson"])) {
                this.unitTypeupdatedByPerson = [] as any;
                for (let item of _data["unitTypeupdatedByPerson"])
                    this.unitTypeupdatedByPerson!.push(UnitType.fromJS(item));
            }
            if (Array.isArray(_data["unitcreatedByPerson"])) {
                this.unitcreatedByPerson = [] as any;
                for (let item of _data["unitcreatedByPerson"])
                    this.unitcreatedByPerson!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["unitupdatedByPerson"])) {
                this.unitupdatedByPerson = [] as any;
                for (let item of _data["unitupdatedByPerson"])
                    this.unitupdatedByPerson!.push(Unit.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["userThemeSelectioncreatedByPerson"])) {
                this.userThemeSelectioncreatedByPerson = [] as any;
                for (let item of _data["userThemeSelectioncreatedByPerson"])
                    this.userThemeSelectioncreatedByPerson!.push(UserThemeSelection.fromJS(item));
            }
            if (Array.isArray(_data["userThemeSelectionupdatedByPerson"])) {
                this.userThemeSelectionupdatedByPerson = [] as any;
                for (let item of _data["userThemeSelectionupdatedByPerson"])
                    this.userThemeSelectionupdatedByPerson!.push(UserThemeSelection.fromJS(item));
            }
            this.userThemeSelectionuser = _data["userThemeSelectionuser"] ? UserThemeSelection.fromJS(_data["userThemeSelectionuser"]) : undefined as any;
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : undefined as any;
            if (Array.isArray(_data["userTypeScreencreatedByPerson"])) {
                this.userTypeScreencreatedByPerson = [] as any;
                for (let item of _data["userTypeScreencreatedByPerson"])
                    this.userTypeScreencreatedByPerson!.push(UserTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["userTypeScreenupdatedByPerson"])) {
                this.userTypeScreenupdatedByPerson = [] as any;
                for (let item of _data["userTypeScreenupdatedByPerson"])
                    this.userTypeScreenupdatedByPerson!.push(UserTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["userTypecreatedByPerson"])) {
                this.userTypecreatedByPerson = [] as any;
                for (let item of _data["userTypecreatedByPerson"])
                    this.userTypecreatedByPerson!.push(UserType.fromJS(item));
            }
            if (Array.isArray(_data["userTypeupdatedByPerson"])) {
                this.userTypeupdatedByPerson = [] as any;
                for (let item of _data["userTypeupdatedByPerson"])
                    this.userTypeupdatedByPerson!.push(UserType.fromJS(item));
            }
            if (Array.isArray(_data["userUserType"])) {
                this.userUserType = [] as any;
                for (let item of _data["userUserType"])
                    this.userUserType!.push(UserUserType.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesEnergyConsumptioncreatedByPerson"])) {
                this.utilitiesEnergyConsumptioncreatedByPerson = [] as any;
                for (let item of _data["utilitiesEnergyConsumptioncreatedByPerson"])
                    this.utilitiesEnergyConsumptioncreatedByPerson!.push(UtilitiesEnergyConsumption.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesEnergyConsumptionupdatedByPerson"])) {
                this.utilitiesEnergyConsumptionupdatedByPerson = [] as any;
                for (let item of _data["utilitiesEnergyConsumptionupdatedByPerson"])
                    this.utilitiesEnergyConsumptionupdatedByPerson!.push(UtilitiesEnergyConsumption.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesProcessingOperationcreatedByPerson"])) {
                this.utilitiesProcessingOperationcreatedByPerson = [] as any;
                for (let item of _data["utilitiesProcessingOperationcreatedByPerson"])
                    this.utilitiesProcessingOperationcreatedByPerson!.push(UtilitiesProcessingOperation.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesProcessingOperationupdatedByPerson"])) {
                this.utilitiesProcessingOperationupdatedByPerson = [] as any;
                for (let item of _data["utilitiesProcessingOperationupdatedByPerson"])
                    this.utilitiesProcessingOperationupdatedByPerson!.push(UtilitiesProcessingOperation.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesSteamConsumptioncreatedByPerson"])) {
                this.utilitiesSteamConsumptioncreatedByPerson = [] as any;
                for (let item of _data["utilitiesSteamConsumptioncreatedByPerson"])
                    this.utilitiesSteamConsumptioncreatedByPerson!.push(UtilitiesSteamConsumption.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesSteamConsumptionupdatedByPerson"])) {
                this.utilitiesSteamConsumptionupdatedByPerson = [] as any;
                for (let item of _data["utilitiesSteamConsumptionupdatedByPerson"])
                    this.utilitiesSteamConsumptionupdatedByPerson!.push(UtilitiesSteamConsumption.fromJS(item));
            }
            if (Array.isArray(_data["utilitiescreatedByPerson"])) {
                this.utilitiescreatedByPerson = [] as any;
                for (let item of _data["utilitiescreatedByPerson"])
                    this.utilitiescreatedByPerson!.push(Utilities.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesupdatedByPerson"])) {
                this.utilitiesupdatedByPerson = [] as any;
                for (let item of _data["utilitiesupdatedByPerson"])
                    this.utilitiesupdatedByPerson!.push(Utilities.fromJS(item));
            }
            if (Array.isArray(_data["wasteDisposalRoutecreatedByPerson"])) {
                this.wasteDisposalRoutecreatedByPerson = [] as any;
                for (let item of _data["wasteDisposalRoutecreatedByPerson"])
                    this.wasteDisposalRoutecreatedByPerson!.push(WasteDisposalRoute.fromJS(item));
            }
            if (Array.isArray(_data["wasteDisposalRouteupdatedByPerson"])) {
                this.wasteDisposalRouteupdatedByPerson = [] as any;
                for (let item of _data["wasteDisposalRouteupdatedByPerson"])
                    this.wasteDisposalRouteupdatedByPerson!.push(WasteDisposalRoute.fromJS(item));
            }
            if (Array.isArray(_data["wasteDisposalTypecreatedByPerson"])) {
                this.wasteDisposalTypecreatedByPerson = [] as any;
                for (let item of _data["wasteDisposalTypecreatedByPerson"])
                    this.wasteDisposalTypecreatedByPerson!.push(WasteDisposalType.fromJS(item));
            }
            if (Array.isArray(_data["wasteDisposalTypeupdatedByPerson"])) {
                this.wasteDisposalTypeupdatedByPerson = [] as any;
                for (let item of _data["wasteDisposalTypeupdatedByPerson"])
                    this.wasteDisposalTypeupdatedByPerson!.push(WasteDisposalType.fromJS(item));
            }
            if (Array.isArray(_data["wasteTypeEmissionFactorcreatedByPerson"])) {
                this.wasteTypeEmissionFactorcreatedByPerson = [] as any;
                for (let item of _data["wasteTypeEmissionFactorcreatedByPerson"])
                    this.wasteTypeEmissionFactorcreatedByPerson!.push(WasteTypeEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["wasteTypeEmissionFactorupdatedByPerson"])) {
                this.wasteTypeEmissionFactorupdatedByPerson = [] as any;
                for (let item of _data["wasteTypeEmissionFactorupdatedByPerson"])
                    this.wasteTypeEmissionFactorupdatedByPerson!.push(WasteTypeEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["wasteTypecreatedByPerson"])) {
                this.wasteTypecreatedByPerson = [] as any;
                for (let item of _data["wasteTypecreatedByPerson"])
                    this.wasteTypecreatedByPerson!.push(WasteType.fromJS(item));
            }
            if (Array.isArray(_data["wasteTypeupdatedByPerson"])) {
                this.wasteTypeupdatedByPerson = [] as any;
                for (let item of _data["wasteTypeupdatedByPerson"])
                    this.wasteTypeupdatedByPerson!.push(WasteType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["emailId"] = this.emailId;
        data["lastName"] = this.lastName;
        data["userTypeId"] = this.userTypeId;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.inversecreatedByPerson)) {
            data["inversecreatedByPerson"] = [];
            for (let item of this.inversecreatedByPerson)
                data["inversecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inverseupdatedByPerson)) {
            data["inverseupdatedByPerson"] = [];
            for (let item of this.inverseupdatedByPerson)
                data["inverseupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wfiCleanSteamGenerationcreatedByPerson)) {
            data["wfiCleanSteamGenerationcreatedByPerson"] = [];
            for (let item of this.wfiCleanSteamGenerationcreatedByPerson)
                data["wfiCleanSteamGenerationcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wfiCleanSteamGenerationupdatedByPerson)) {
            data["wfiCleanSteamGenerationupdatedByPerson"] = [];
            for (let item of this.wfiCleanSteamGenerationupdatedByPerson)
                data["wfiCleanSteamGenerationupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wfiSourcecreatedByPerson)) {
            data["wfiSourcecreatedByPerson"] = [];
            for (let item of this.wfiSourcecreatedByPerson)
                data["wfiSourcecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wfiSourceupdatedByPerson)) {
            data["wfiSourceupdatedByPerson"] = [];
            for (let item of this.wfiSourceupdatedByPerson)
                data["wfiSourceupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentCollaboratorscreatedByPerson)) {
            data["assessmentCollaboratorscreatedByPerson"] = [];
            for (let item of this.assessmentCollaboratorscreatedByPerson)
                data["assessmentCollaboratorscreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentCollaboratorsperson)) {
            data["assessmentCollaboratorsperson"] = [];
            for (let item of this.assessmentCollaboratorsperson)
                data["assessmentCollaboratorsperson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentCollaboratorsupdatedByPerson)) {
            data["assessmentCollaboratorsupdatedByPerson"] = [];
            for (let item of this.assessmentCollaboratorsupdatedByPerson)
                data["assessmentCollaboratorsupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentcreatedByPerson)) {
            data["assessmentcreatedByPerson"] = [];
            for (let item of this.assessmentcreatedByPerson)
                data["assessmentcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentlockedByPerson)) {
            data["assessmentlockedByPerson"] = [];
            for (let item of this.assessmentlockedByPerson)
                data["assessmentlockedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentupdatedByPerson)) {
            data["assessmentupdatedByPerson"] = [];
            for (let item of this.assessmentupdatedByPerson)
                data["assessmentupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.configurationVariablecreatedByPerson)) {
            data["configurationVariablecreatedByPerson"] = [];
            for (let item of this.configurationVariablecreatedByPerson)
                data["configurationVariablecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.configurationVariableupdatedByPerson)) {
            data["configurationVariableupdatedByPerson"] = [];
            for (let item of this.configurationVariableupdatedByPerson)
                data["configurationVariableupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.consumerEolMaterialDefaultcreatedByPerson)) {
            data["consumerEolMaterialDefaultcreatedByPerson"] = [];
            for (let item of this.consumerEolMaterialDefaultcreatedByPerson)
                data["consumerEolMaterialDefaultcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.consumerEolMaterialDefaultupdatedByPerson)) {
            data["consumerEolMaterialDefaultupdatedByPerson"] = [];
            for (let item of this.consumerEolMaterialDefaultupdatedByPerson)
                data["consumerEolMaterialDefaultupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.developmentStagecreatedByPerson)) {
            data["developmentStagecreatedByPerson"] = [];
            for (let item of this.developmentStagecreatedByPerson)
                data["developmentStagecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.developmentStageupdatedByPerson)) {
            data["developmentStageupdatedByPerson"] = [];
            for (let item of this.developmentStageupdatedByPerson)
                data["developmentStageupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamDistributioncreatedByPerson)) {
            data["downstreamDistributioncreatedByPerson"] = [];
            for (let item of this.downstreamDistributioncreatedByPerson)
                data["downstreamDistributioncreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamDistributionupdatedByPerson)) {
            data["downstreamDistributionupdatedByPerson"] = [];
            for (let item of this.downstreamDistributionupdatedByPerson)
                data["downstreamDistributionupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamStepcreatedByPerson)) {
            data["downstreamStepcreatedByPerson"] = [];
            for (let item of this.downstreamStepcreatedByPerson)
                data["downstreamStepcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamStepupdatedByPerson)) {
            data["downstreamStepupdatedByPerson"] = [];
            for (let item of this.downstreamStepupdatedByPerson)
                data["downstreamStepupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamcreatedByPerson)) {
            data["downstreamcreatedByPerson"] = [];
            for (let item of this.downstreamcreatedByPerson)
                data["downstreamcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamupdatedByPerson)) {
            data["downstreamupdatedByPerson"] = [];
            for (let item of this.downstreamupdatedByPerson)
                data["downstreamupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emissionFactorTypescreatedByPerson)) {
            data["emissionFactorTypescreatedByPerson"] = [];
            for (let item of this.emissionFactorTypescreatedByPerson)
                data["emissionFactorTypescreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emissionFactorTypesupdatedByPerson)) {
            data["emissionFactorTypesupdatedByPerson"] = [];
            for (let item of this.emissionFactorTypesupdatedByPerson)
                data["emissionFactorTypesupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emissionFactorscreatedByPerson)) {
            data["emissionFactorscreatedByPerson"] = [];
            for (let item of this.emissionFactorscreatedByPerson)
                data["emissionFactorscreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emissionFactorsupdatedByPerson)) {
            data["emissionFactorsupdatedByPerson"] = [];
            for (let item of this.emissionFactorsupdatedByPerson)
                data["emissionFactorsupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyMultiplierscreatedByPerson)) {
            data["energyMultiplierscreatedByPerson"] = [];
            for (let item of this.energyMultiplierscreatedByPerson)
                data["energyMultiplierscreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyMultipliersupdatedByPerson)) {
            data["energyMultipliersupdatedByPerson"] = [];
            for (let item of this.energyMultipliersupdatedByPerson)
                data["energyMultipliersupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.favorites)) {
            data["favorites"] = [];
            for (let item of this.favorites)
                data["favorites"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.featureFlagcreatedByPerson)) {
            data["featureFlagcreatedByPerson"] = [];
            for (let item of this.featureFlagcreatedByPerson)
                data["featureFlagcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.featureFlagupdatedByPerson)) {
            data["featureFlagupdatedByPerson"] = [];
            for (let item of this.featureFlagupdatedByPerson)
                data["featureFlagupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationcreatedByPerson)) {
            data["generalInformationcreatedByPerson"] = [];
            for (let item of this.generalInformationcreatedByPerson)
                data["generalInformationcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationupdatedByPerson)) {
            data["generalInformationupdatedByPerson"] = [];
            for (let item of this.generalInformationupdatedByPerson)
                data["generalInformationupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.helpFieldcreatedByPerson)) {
            data["helpFieldcreatedByPerson"] = [];
            for (let item of this.helpFieldcreatedByPerson)
                data["helpFieldcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.helpFieldupdatedByPerson)) {
            data["helpFieldupdatedByPerson"] = [];
            for (let item of this.helpFieldupdatedByPerson)
                data["helpFieldupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.helpPagecreatedByPerson)) {
            data["helpPagecreatedByPerson"] = [];
            for (let item of this.helpPagecreatedByPerson)
                data["helpPagecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.helpPageupdatedByPerson)) {
            data["helpPageupdatedByPerson"] = [];
            for (let item of this.helpPageupdatedByPerson)
                data["helpPageupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.intermediateStepcreatedByPerson)) {
            data["intermediateStepcreatedByPerson"] = [];
            for (let item of this.intermediateStepcreatedByPerson)
                data["intermediateStepcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.intermediateStepupdatedByPerson)) {
            data["intermediateStepupdatedByPerson"] = [];
            for (let item of this.intermediateStepupdatedByPerson)
                data["intermediateStepupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticleFeedbackcreatedByPerson)) {
            data["knowledgeArticleFeedbackcreatedByPerson"] = [];
            for (let item of this.knowledgeArticleFeedbackcreatedByPerson)
                data["knowledgeArticleFeedbackcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticleFeedbackperson)) {
            data["knowledgeArticleFeedbackperson"] = [];
            for (let item of this.knowledgeArticleFeedbackperson)
                data["knowledgeArticleFeedbackperson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticleFeedbackupdatedByPerson)) {
            data["knowledgeArticleFeedbackupdatedByPerson"] = [];
            for (let item of this.knowledgeArticleFeedbackupdatedByPerson)
                data["knowledgeArticleFeedbackupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticleTagcreatedByPerson)) {
            data["knowledgeArticleTagcreatedByPerson"] = [];
            for (let item of this.knowledgeArticleTagcreatedByPerson)
                data["knowledgeArticleTagcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticleTagupdatedByPerson)) {
            data["knowledgeArticleTagupdatedByPerson"] = [];
            for (let item of this.knowledgeArticleTagupdatedByPerson)
                data["knowledgeArticleTagupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticlecreatedByPerson)) {
            data["knowledgeArticlecreatedByPerson"] = [];
            for (let item of this.knowledgeArticlecreatedByPerson)
                data["knowledgeArticlecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeArticleupdatedByPerson)) {
            data["knowledgeArticleupdatedByPerson"] = [];
            for (let item of this.knowledgeArticleupdatedByPerson)
                data["knowledgeArticleupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeAttachmentcreatedByPerson)) {
            data["knowledgeAttachmentcreatedByPerson"] = [];
            for (let item of this.knowledgeAttachmentcreatedByPerson)
                data["knowledgeAttachmentcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeAttachmentupdatedByPerson)) {
            data["knowledgeAttachmentupdatedByPerson"] = [];
            for (let item of this.knowledgeAttachmentupdatedByPerson)
                data["knowledgeAttachmentupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeCategorycreatedByPerson)) {
            data["knowledgeCategorycreatedByPerson"] = [];
            for (let item of this.knowledgeCategorycreatedByPerson)
                data["knowledgeCategorycreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeCategoryupdatedByPerson)) {
            data["knowledgeCategoryupdatedByPerson"] = [];
            for (let item of this.knowledgeCategoryupdatedByPerson)
                data["knowledgeCategoryupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeInfoRequestcreatedByPerson)) {
            data["knowledgeInfoRequestcreatedByPerson"] = [];
            for (let item of this.knowledgeInfoRequestcreatedByPerson)
                data["knowledgeInfoRequestcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeInfoRequestperson)) {
            data["knowledgeInfoRequestperson"] = [];
            for (let item of this.knowledgeInfoRequestperson)
                data["knowledgeInfoRequestperson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeInfoRequestupdatedByPerson)) {
            data["knowledgeInfoRequestupdatedByPerson"] = [];
            for (let item of this.knowledgeInfoRequestupdatedByPerson)
                data["knowledgeInfoRequestupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeSubcategorycreatedByPerson)) {
            data["knowledgeSubcategorycreatedByPerson"] = [];
            for (let item of this.knowledgeSubcategorycreatedByPerson)
                data["knowledgeSubcategorycreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeSubcategoryupdatedByPerson)) {
            data["knowledgeSubcategoryupdatedByPerson"] = [];
            for (let item of this.knowledgeSubcategoryupdatedByPerson)
                data["knowledgeSubcategoryupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeTagcreatedByPerson)) {
            data["knowledgeTagcreatedByPerson"] = [];
            for (let item of this.knowledgeTagcreatedByPerson)
                data["knowledgeTagcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeTagupdatedByPerson)) {
            data["knowledgeTagupdatedByPerson"] = [];
            for (let item of this.knowledgeTagupdatedByPerson)
                data["knowledgeTagupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.masterCategorycreatedByPerson)) {
            data["masterCategorycreatedByPerson"] = [];
            for (let item of this.masterCategorycreatedByPerson)
                data["masterCategorycreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.masterCategoryupdatedByPerson)) {
            data["masterCategoryupdatedByPerson"] = [];
            for (let item of this.masterCategoryupdatedByPerson)
                data["masterCategoryupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.masterDropdowncreatedByPerson)) {
            data["masterDropdowncreatedByPerson"] = [];
            for (let item of this.masterDropdowncreatedByPerson)
                data["masterDropdowncreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.masterDropdownupdatedByPerson)) {
            data["masterDropdownupdatedByPerson"] = [];
            for (let item of this.masterDropdownupdatedByPerson)
                data["masterDropdownupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialEmissionFactorcreatedByPerson)) {
            data["materialEmissionFactorcreatedByPerson"] = [];
            for (let item of this.materialEmissionFactorcreatedByPerson)
                data["materialEmissionFactorcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialEmissionFactorupdatedByPerson)) {
            data["materialEmissionFactorupdatedByPerson"] = [];
            for (let item of this.materialEmissionFactorupdatedByPerson)
                data["materialEmissionFactorupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialInboundTransportcreatedByPerson)) {
            data["materialInboundTransportcreatedByPerson"] = [];
            for (let item of this.materialInboundTransportcreatedByPerson)
                data["materialInboundTransportcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialInboundTransportupdatedByPerson)) {
            data["materialInboundTransportupdatedByPerson"] = [];
            for (let item of this.materialInboundTransportupdatedByPerson)
                data["materialInboundTransportupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialTypeScreencreatedByPerson)) {
            data["materialTypeScreencreatedByPerson"] = [];
            for (let item of this.materialTypeScreencreatedByPerson)
                data["materialTypeScreencreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialTypeScreenupdatedByPerson)) {
            data["materialTypeScreenupdatedByPerson"] = [];
            for (let item of this.materialTypeScreenupdatedByPerson)
                data["materialTypeScreenupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialTypecreatedByPerson)) {
            data["materialTypecreatedByPerson"] = [];
            for (let item of this.materialTypecreatedByPerson)
                data["materialTypecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialTypeupdatedByPerson)) {
            data["materialTypeupdatedByPerson"] = [];
            for (let item of this.materialTypeupdatedByPerson)
                data["materialTypeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialcreatedByPerson)) {
            data["materialcreatedByPerson"] = [];
            for (let item of this.materialcreatedByPerson)
                data["materialcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialupdatedByPerson)) {
            data["materialupdatedByPerson"] = [];
            for (let item of this.materialupdatedByPerson)
                data["materialupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.news)) {
            data["news"] = [];
            for (let item of this.news)
                data["news"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newsPersonLog)) {
            data["newsPersonLog"] = [];
            for (let item of this.newsPersonLog)
                data["newsPersonLog"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.personIdentityStatuscreatedByPerson)) {
            data["personIdentityStatuscreatedByPerson"] = [];
            for (let item of this.personIdentityStatuscreatedByPerson)
                data["personIdentityStatuscreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.personIdentityStatusperson)) {
            data["personIdentityStatusperson"] = [];
            for (let item of this.personIdentityStatusperson)
                data["personIdentityStatusperson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.personIdentityStatusupdatedByPerson)) {
            data["personIdentityStatusupdatedByPerson"] = [];
            for (let item of this.personIdentityStatusupdatedByPerson)
                data["personIdentityStatusupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWasteDetailcreatedByPerson)) {
            data["processWasteDetailcreatedByPerson"] = [];
            for (let item of this.processWasteDetailcreatedByPerson)
                data["processWasteDetailcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWasteDetailupdatedByPerson)) {
            data["processWasteDetailupdatedByPerson"] = [];
            for (let item of this.processWasteDetailupdatedByPerson)
                data["processWasteDetailupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWastecreatedByPerson)) {
            data["processWastecreatedByPerson"] = [];
            for (let item of this.processWastecreatedByPerson)
                data["processWastecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWasteupdatedByPerson)) {
            data["processWasteupdatedByPerson"] = [];
            for (let item of this.processWasteupdatedByPerson)
                data["processWasteupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEntrycreatedByPerson)) {
            data["productProcessProxyEntrycreatedByPerson"] = [];
            for (let item of this.productProcessProxyEntrycreatedByPerson)
                data["productProcessProxyEntrycreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEntryupdatedByPerson)) {
            data["productProcessProxyEntryupdatedByPerson"] = [];
            for (let item of this.productProcessProxyEntryupdatedByPerson)
                data["productProcessProxyEntryupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxycreatedByPerson)) {
            data["productProcessProxycreatedByPerson"] = [];
            for (let item of this.productProcessProxycreatedByPerson)
                data["productProcessProxycreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyupdatedByPerson)) {
            data["productProcessProxyupdatedByPerson"] = [];
            for (let item of this.productProcessProxyupdatedByPerson)
                data["productProcessProxyupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectCollaborator)) {
            data["projectCollaborator"] = [];
            for (let item of this.projectCollaborator)
                data["projectCollaborator"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectcreatedByPerson)) {
            data["projectcreatedByPerson"] = [];
            for (let item of this.projectcreatedByPerson)
                data["projectcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectprojectOwnerNavigation)) {
            data["projectprojectOwnerNavigation"] = [];
            for (let item of this.projectprojectOwnerNavigation)
                data["projectprojectOwnerNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectupdatedByPerson)) {
            data["projectupdatedByPerson"] = [];
            for (let item of this.projectupdatedByPerson)
                data["projectupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntrycreatedByPerson)) {
            data["rawMaterialEntrycreatedByPerson"] = [];
            for (let item of this.rawMaterialEntrycreatedByPerson)
                data["rawMaterialEntrycreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntryupdatedByPerson)) {
            data["rawMaterialEntryupdatedByPerson"] = [];
            for (let item of this.rawMaterialEntryupdatedByPerson)
                data["rawMaterialEntryupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialUnitOperationcreatedByPerson)) {
            data["rawMaterialUnitOperationcreatedByPerson"] = [];
            for (let item of this.rawMaterialUnitOperationcreatedByPerson)
                data["rawMaterialUnitOperationcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialUnitOperationupdatedByPerson)) {
            data["rawMaterialUnitOperationupdatedByPerson"] = [];
            for (let item of this.rawMaterialUnitOperationupdatedByPerson)
                data["rawMaterialUnitOperationupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialcreatedByPerson)) {
            data["rawMaterialcreatedByPerson"] = [];
            for (let item of this.rawMaterialcreatedByPerson)
                data["rawMaterialcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialupdatedByPerson)) {
            data["rawMaterialupdatedByPerson"] = [];
            for (let item of this.rawMaterialupdatedByPerson)
                data["rawMaterialupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceTablecreatedByPerson)) {
            data["referenceTablecreatedByPerson"] = [];
            for (let item of this.referenceTablecreatedByPerson)
                data["referenceTablecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceTableupdatedByPerson)) {
            data["referenceTableupdatedByPerson"] = [];
            for (let item of this.referenceTableupdatedByPerson)
                data["referenceTableupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relatableUnitcreatedByPerson)) {
            data["relatableUnitcreatedByPerson"] = [];
            for (let item of this.relatableUnitcreatedByPerson)
                data["relatableUnitcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relatableUnitupdatedByPerson)) {
            data["relatableUnitupdatedByPerson"] = [];
            for (let item of this.relatableUnitupdatedByPerson)
                data["relatableUnitupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportAlternativecreatedByPerson)) {
            data["reportAlternativecreatedByPerson"] = [];
            for (let item of this.reportAlternativecreatedByPerson)
                data["reportAlternativecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportAlternativeupdatedByPerson)) {
            data["reportAlternativeupdatedByPerson"] = [];
            for (let item of this.reportAlternativeupdatedByPerson)
                data["reportAlternativeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportConfigurationcreatedByPerson)) {
            data["reportConfigurationcreatedByPerson"] = [];
            for (let item of this.reportConfigurationcreatedByPerson)
                data["reportConfigurationcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportConfigurationupdatedByPerson)) {
            data["reportConfigurationupdatedByPerson"] = [];
            for (let item of this.reportConfigurationupdatedByPerson)
                data["reportConfigurationupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screencreatedByPerson)) {
            data["screencreatedByPerson"] = [];
            for (let item of this.screencreatedByPerson)
                data["screencreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenupdatedByPerson)) {
            data["screenupdatedByPerson"] = [];
            for (let item of this.screenupdatedByPerson)
                data["screenupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.stepcreatedByPerson)) {
            data["stepcreatedByPerson"] = [];
            for (let item of this.stepcreatedByPerson)
                data["stepcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.stepupdatedByPerson)) {
            data["stepupdatedByPerson"] = [];
            for (let item of this.stepupdatedByPerson)
                data["stepupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectCollaboratorcreatedByPerson)) {
            data["subProjectCollaboratorcreatedByPerson"] = [];
            for (let item of this.subProjectCollaboratorcreatedByPerson)
                data["subProjectCollaboratorcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectCollaboratorperson)) {
            data["subProjectCollaboratorperson"] = [];
            for (let item of this.subProjectCollaboratorperson)
                data["subProjectCollaboratorperson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectCollaboratorupdatedByPerson)) {
            data["subProjectCollaboratorupdatedByPerson"] = [];
            for (let item of this.subProjectCollaboratorupdatedByPerson)
                data["subProjectCollaboratorupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectDefaultScreencreatedByPerson)) {
            data["subProjectDefaultScreencreatedByPerson"] = [];
            for (let item of this.subProjectDefaultScreencreatedByPerson)
                data["subProjectDefaultScreencreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectDefaultScreenupdatedByPerson)) {
            data["subProjectDefaultScreenupdatedByPerson"] = [];
            for (let item of this.subProjectDefaultScreenupdatedByPerson)
                data["subProjectDefaultScreenupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectcreatedByPerson)) {
            data["subProjectcreatedByPerson"] = [];
            for (let item of this.subProjectcreatedByPerson)
                data["subProjectcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectsubProjectOwnerNavigation)) {
            data["subProjectsubProjectOwnerNavigation"] = [];
            for (let item of this.subProjectsubProjectOwnerNavigation)
                data["subProjectsubProjectOwnerNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectupdatedByPerson)) {
            data["subProjectupdatedByPerson"] = [];
            for (let item of this.subProjectupdatedByPerson)
                data["subProjectupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.templateUIcreatedByPerson)) {
            data["templateUIcreatedByPerson"] = [];
            for (let item of this.templateUIcreatedByPerson)
                data["templateUIcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.templateUIupdatedByPerson)) {
            data["templateUIupdatedByPerson"] = [];
            for (let item of this.templateUIupdatedByPerson)
                data["templateUIupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportEmissionFactorcreatedByPerson)) {
            data["transportEmissionFactorcreatedByPerson"] = [];
            for (let item of this.transportEmissionFactorcreatedByPerson)
                data["transportEmissionFactorcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportEmissionFactorupdatedByPerson)) {
            data["transportEmissionFactorupdatedByPerson"] = [];
            for (let item of this.transportEmissionFactorupdatedByPerson)
                data["transportEmissionFactorupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportModecreatedByPerson)) {
            data["transportModecreatedByPerson"] = [];
            for (let item of this.transportModecreatedByPerson)
                data["transportModecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportModeupdatedByPerson)) {
            data["transportModeupdatedByPerson"] = [];
            for (let item of this.transportModeupdatedByPerson)
                data["transportModeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.treeItemscreatedByPerson)) {
            data["treeItemscreatedByPerson"] = [];
            for (let item of this.treeItemscreatedByPerson)
                data["treeItemscreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.treeItemsupdatedByPerson)) {
            data["treeItemsupdatedByPerson"] = [];
            for (let item of this.treeItemsupdatedByPerson)
                data["treeItemsupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.treecreatedByPerson)) {
            data["treecreatedByPerson"] = [];
            for (let item of this.treecreatedByPerson)
                data["treecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.treeupdatedByPerson)) {
            data["treeupdatedByPerson"] = [];
            for (let item of this.treeupdatedByPerson)
                data["treeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperationStepcreatedByPerson)) {
            data["unitOperationStepcreatedByPerson"] = [];
            for (let item of this.unitOperationStepcreatedByPerson)
                data["unitOperationStepcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperationStepupdatedByPerson)) {
            data["unitOperationStepupdatedByPerson"] = [];
            for (let item of this.unitOperationStepupdatedByPerson)
                data["unitOperationStepupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperationcreatedByPerson)) {
            data["unitOperationcreatedByPerson"] = [];
            for (let item of this.unitOperationcreatedByPerson)
                data["unitOperationcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperationupdatedByPerson)) {
            data["unitOperationupdatedByPerson"] = [];
            for (let item of this.unitOperationupdatedByPerson)
                data["unitOperationupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitTypecreatedByPerson)) {
            data["unitTypecreatedByPerson"] = [];
            for (let item of this.unitTypecreatedByPerson)
                data["unitTypecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitTypeupdatedByPerson)) {
            data["unitTypeupdatedByPerson"] = [];
            for (let item of this.unitTypeupdatedByPerson)
                data["unitTypeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitcreatedByPerson)) {
            data["unitcreatedByPerson"] = [];
            for (let item of this.unitcreatedByPerson)
                data["unitcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitupdatedByPerson)) {
            data["unitupdatedByPerson"] = [];
            for (let item of this.unitupdatedByPerson)
                data["unitupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.userThemeSelectioncreatedByPerson)) {
            data["userThemeSelectioncreatedByPerson"] = [];
            for (let item of this.userThemeSelectioncreatedByPerson)
                data["userThemeSelectioncreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userThemeSelectionupdatedByPerson)) {
            data["userThemeSelectionupdatedByPerson"] = [];
            for (let item of this.userThemeSelectionupdatedByPerson)
                data["userThemeSelectionupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        data["userThemeSelectionuser"] = this.userThemeSelectionuser ? this.userThemeSelectionuser.toJSON() : undefined as any;
        data["userType"] = this.userType ? this.userType.toJSON() : undefined as any;
        if (Array.isArray(this.userTypeScreencreatedByPerson)) {
            data["userTypeScreencreatedByPerson"] = [];
            for (let item of this.userTypeScreencreatedByPerson)
                data["userTypeScreencreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userTypeScreenupdatedByPerson)) {
            data["userTypeScreenupdatedByPerson"] = [];
            for (let item of this.userTypeScreenupdatedByPerson)
                data["userTypeScreenupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userTypecreatedByPerson)) {
            data["userTypecreatedByPerson"] = [];
            for (let item of this.userTypecreatedByPerson)
                data["userTypecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userTypeupdatedByPerson)) {
            data["userTypeupdatedByPerson"] = [];
            for (let item of this.userTypeupdatedByPerson)
                data["userTypeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userUserType)) {
            data["userUserType"] = [];
            for (let item of this.userUserType)
                data["userUserType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesEnergyConsumptioncreatedByPerson)) {
            data["utilitiesEnergyConsumptioncreatedByPerson"] = [];
            for (let item of this.utilitiesEnergyConsumptioncreatedByPerson)
                data["utilitiesEnergyConsumptioncreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesEnergyConsumptionupdatedByPerson)) {
            data["utilitiesEnergyConsumptionupdatedByPerson"] = [];
            for (let item of this.utilitiesEnergyConsumptionupdatedByPerson)
                data["utilitiesEnergyConsumptionupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesProcessingOperationcreatedByPerson)) {
            data["utilitiesProcessingOperationcreatedByPerson"] = [];
            for (let item of this.utilitiesProcessingOperationcreatedByPerson)
                data["utilitiesProcessingOperationcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesProcessingOperationupdatedByPerson)) {
            data["utilitiesProcessingOperationupdatedByPerson"] = [];
            for (let item of this.utilitiesProcessingOperationupdatedByPerson)
                data["utilitiesProcessingOperationupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesSteamConsumptioncreatedByPerson)) {
            data["utilitiesSteamConsumptioncreatedByPerson"] = [];
            for (let item of this.utilitiesSteamConsumptioncreatedByPerson)
                data["utilitiesSteamConsumptioncreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesSteamConsumptionupdatedByPerson)) {
            data["utilitiesSteamConsumptionupdatedByPerson"] = [];
            for (let item of this.utilitiesSteamConsumptionupdatedByPerson)
                data["utilitiesSteamConsumptionupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiescreatedByPerson)) {
            data["utilitiescreatedByPerson"] = [];
            for (let item of this.utilitiescreatedByPerson)
                data["utilitiescreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesupdatedByPerson)) {
            data["utilitiesupdatedByPerson"] = [];
            for (let item of this.utilitiesupdatedByPerson)
                data["utilitiesupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteDisposalRoutecreatedByPerson)) {
            data["wasteDisposalRoutecreatedByPerson"] = [];
            for (let item of this.wasteDisposalRoutecreatedByPerson)
                data["wasteDisposalRoutecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteDisposalRouteupdatedByPerson)) {
            data["wasteDisposalRouteupdatedByPerson"] = [];
            for (let item of this.wasteDisposalRouteupdatedByPerson)
                data["wasteDisposalRouteupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteDisposalTypecreatedByPerson)) {
            data["wasteDisposalTypecreatedByPerson"] = [];
            for (let item of this.wasteDisposalTypecreatedByPerson)
                data["wasteDisposalTypecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteDisposalTypeupdatedByPerson)) {
            data["wasteDisposalTypeupdatedByPerson"] = [];
            for (let item of this.wasteDisposalTypeupdatedByPerson)
                data["wasteDisposalTypeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteTypeEmissionFactorcreatedByPerson)) {
            data["wasteTypeEmissionFactorcreatedByPerson"] = [];
            for (let item of this.wasteTypeEmissionFactorcreatedByPerson)
                data["wasteTypeEmissionFactorcreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteTypeEmissionFactorupdatedByPerson)) {
            data["wasteTypeEmissionFactorupdatedByPerson"] = [];
            for (let item of this.wasteTypeEmissionFactorupdatedByPerson)
                data["wasteTypeEmissionFactorupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteTypecreatedByPerson)) {
            data["wasteTypecreatedByPerson"] = [];
            for (let item of this.wasteTypecreatedByPerson)
                data["wasteTypecreatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteTypeupdatedByPerson)) {
            data["wasteTypeupdatedByPerson"] = [];
            for (let item of this.wasteTypeupdatedByPerson)
                data["wasteTypeupdatedByPerson"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPerson {
    id?: string;
    firstName?: string | undefined;
    emailId?: string | undefined;
    lastName?: string | undefined;
    userTypeId?: string | undefined;
    lastLogin?: Date | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    inversecreatedByPerson?: Person[] | undefined;
    inverseupdatedByPerson?: Person[] | undefined;
    wfiCleanSteamGenerationcreatedByPerson?: WFICleanSteamGeneration[] | undefined;
    wfiCleanSteamGenerationupdatedByPerson?: WFICleanSteamGeneration[] | undefined;
    wfiSourcecreatedByPerson?: WFISource[] | undefined;
    wfiSourceupdatedByPerson?: WFISource[] | undefined;
    assessmentCollaboratorscreatedByPerson?: AssessmentCollaborators[] | undefined;
    assessmentCollaboratorsperson?: AssessmentCollaborators[] | undefined;
    assessmentCollaboratorsupdatedByPerson?: AssessmentCollaborators[] | undefined;
    assessmentcreatedByPerson?: Assessment[] | undefined;
    assessmentlockedByPerson?: Assessment[] | undefined;
    assessmentupdatedByPerson?: Assessment[] | undefined;
    configurationVariablecreatedByPerson?: ConfigurationVariable[] | undefined;
    configurationVariableupdatedByPerson?: ConfigurationVariable[] | undefined;
    consumerEolMaterialDefaultcreatedByPerson?: ConsumerEolMaterialDefault[] | undefined;
    consumerEolMaterialDefaultupdatedByPerson?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    developmentStagecreatedByPerson?: DevelopmentStage[] | undefined;
    developmentStageupdatedByPerson?: DevelopmentStage[] | undefined;
    downstreamDistributioncreatedByPerson?: DownstreamDistribution[] | undefined;
    downstreamDistributionupdatedByPerson?: DownstreamDistribution[] | undefined;
    downstreamStepcreatedByPerson?: DownstreamStep[] | undefined;
    downstreamStepupdatedByPerson?: DownstreamStep[] | undefined;
    downstreamcreatedByPerson?: Downstream[] | undefined;
    downstreamupdatedByPerson?: Downstream[] | undefined;
    emissionFactorTypescreatedByPerson?: EmissionFactorTypes[] | undefined;
    emissionFactorTypesupdatedByPerson?: EmissionFactorTypes[] | undefined;
    emissionFactorscreatedByPerson?: EmissionFactors[] | undefined;
    emissionFactorsupdatedByPerson?: EmissionFactors[] | undefined;
    energyMultiplierscreatedByPerson?: EnergyMultipliers[] | undefined;
    energyMultipliersupdatedByPerson?: EnergyMultipliers[] | undefined;
    favorites?: Favorites[] | undefined;
    featureFlagcreatedByPerson?: FeatureFlag[] | undefined;
    featureFlagupdatedByPerson?: FeatureFlag[] | undefined;
    generalInformationcreatedByPerson?: GeneralInformation[] | undefined;
    generalInformationupdatedByPerson?: GeneralInformation[] | undefined;
    helpFieldcreatedByPerson?: HelpField[] | undefined;
    helpFieldupdatedByPerson?: HelpField[] | undefined;
    helpPagecreatedByPerson?: HelpPage[] | undefined;
    helpPageupdatedByPerson?: HelpPage[] | undefined;
    history?: History[] | undefined;
    intermediateStepcreatedByPerson?: IntermediateStep[] | undefined;
    intermediateStepupdatedByPerson?: IntermediateStep[] | undefined;
    knowledgeArticleFeedbackcreatedByPerson?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleFeedbackperson?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleFeedbackupdatedByPerson?: KnowledgeArticleFeedback[] | undefined;
    knowledgeArticleTagcreatedByPerson?: KnowledgeArticleTag[] | undefined;
    knowledgeArticleTagupdatedByPerson?: KnowledgeArticleTag[] | undefined;
    knowledgeArticlecreatedByPerson?: KnowledgeArticle[] | undefined;
    knowledgeArticleupdatedByPerson?: KnowledgeArticle[] | undefined;
    knowledgeAttachmentcreatedByPerson?: KnowledgeAttachment[] | undefined;
    knowledgeAttachmentupdatedByPerson?: KnowledgeAttachment[] | undefined;
    knowledgeCategorycreatedByPerson?: KnowledgeCategory[] | undefined;
    knowledgeCategoryupdatedByPerson?: KnowledgeCategory[] | undefined;
    knowledgeInfoRequestcreatedByPerson?: KnowledgeInfoRequest[] | undefined;
    knowledgeInfoRequestperson?: KnowledgeInfoRequest[] | undefined;
    knowledgeInfoRequestupdatedByPerson?: KnowledgeInfoRequest[] | undefined;
    knowledgeSubcategorycreatedByPerson?: KnowledgeSubcategory[] | undefined;
    knowledgeSubcategoryupdatedByPerson?: KnowledgeSubcategory[] | undefined;
    knowledgeTagcreatedByPerson?: KnowledgeTag[] | undefined;
    knowledgeTagupdatedByPerson?: KnowledgeTag[] | undefined;
    masterCategorycreatedByPerson?: MasterCategory[] | undefined;
    masterCategoryupdatedByPerson?: MasterCategory[] | undefined;
    masterDropdowncreatedByPerson?: MasterDropdown[] | undefined;
    masterDropdownupdatedByPerson?: MasterDropdown[] | undefined;
    materialEmissionFactorcreatedByPerson?: MaterialEmissionFactor[] | undefined;
    materialEmissionFactorupdatedByPerson?: MaterialEmissionFactor[] | undefined;
    materialInboundTransportcreatedByPerson?: MaterialInboundTransport[] | undefined;
    materialInboundTransportupdatedByPerson?: MaterialInboundTransport[] | undefined;
    materialTypeScreencreatedByPerson?: MaterialTypeScreen[] | undefined;
    materialTypeScreenupdatedByPerson?: MaterialTypeScreen[] | undefined;
    materialTypecreatedByPerson?: MaterialType[] | undefined;
    materialTypeupdatedByPerson?: MaterialType[] | undefined;
    materialcreatedByPerson?: Material[] | undefined;
    materialupdatedByPerson?: Material[] | undefined;
    news?: News[] | undefined;
    newsPersonLog?: NewsPersonLog[] | undefined;
    personIdentityStatuscreatedByPerson?: PersonIdentityStatus[] | undefined;
    personIdentityStatusperson?: PersonIdentityStatus[] | undefined;
    personIdentityStatusupdatedByPerson?: PersonIdentityStatus[] | undefined;
    processWasteDetailcreatedByPerson?: ProcessWasteDetail[] | undefined;
    processWasteDetailupdatedByPerson?: ProcessWasteDetail[] | undefined;
    processWastecreatedByPerson?: ProcessWaste[] | undefined;
    processWasteupdatedByPerson?: ProcessWaste[] | undefined;
    productProcessProxyEntrycreatedByPerson?: ProductProcessProxyEntry[] | undefined;
    productProcessProxyEntryupdatedByPerson?: ProductProcessProxyEntry[] | undefined;
    productProcessProxycreatedByPerson?: ProductProcessProxy[] | undefined;
    productProcessProxyupdatedByPerson?: ProductProcessProxy[] | undefined;
    projectCollaborator?: ProjectCollaborator[] | undefined;
    projectcreatedByPerson?: Project[] | undefined;
    projectprojectOwnerNavigation?: Project[] | undefined;
    projectupdatedByPerson?: Project[] | undefined;
    rawMaterialEntrycreatedByPerson?: RawMaterialEntry[] | undefined;
    rawMaterialEntryupdatedByPerson?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperationcreatedByPerson?: RawMaterialUnitOperation[] | undefined;
    rawMaterialUnitOperationupdatedByPerson?: RawMaterialUnitOperation[] | undefined;
    rawMaterialcreatedByPerson?: RawMaterial[] | undefined;
    rawMaterialupdatedByPerson?: RawMaterial[] | undefined;
    referenceTablecreatedByPerson?: ReferenceTable[] | undefined;
    referenceTableupdatedByPerson?: ReferenceTable[] | undefined;
    relatableUnitcreatedByPerson?: RelatableUnit[] | undefined;
    relatableUnitupdatedByPerson?: RelatableUnit[] | undefined;
    reportAlternativecreatedByPerson?: ReportAlternative[] | undefined;
    reportAlternativeupdatedByPerson?: ReportAlternative[] | undefined;
    reportConfigurationcreatedByPerson?: ReportConfiguration[] | undefined;
    reportConfigurationupdatedByPerson?: ReportConfiguration[] | undefined;
    screencreatedByPerson?: Screen[] | undefined;
    screenupdatedByPerson?: Screen[] | undefined;
    stepcreatedByPerson?: Step[] | undefined;
    stepupdatedByPerson?: Step[] | undefined;
    subProjectCollaboratorcreatedByPerson?: SubProjectCollaborator[] | undefined;
    subProjectCollaboratorperson?: SubProjectCollaborator[] | undefined;
    subProjectCollaboratorupdatedByPerson?: SubProjectCollaborator[] | undefined;
    subProjectDefaultScreencreatedByPerson?: SubProjectDefaultScreen[] | undefined;
    subProjectDefaultScreenupdatedByPerson?: SubProjectDefaultScreen[] | undefined;
    subProjectcreatedByPerson?: SubProject[] | undefined;
    subProjectsubProjectOwnerNavigation?: SubProject[] | undefined;
    subProjectupdatedByPerson?: SubProject[] | undefined;
    templateUIcreatedByPerson?: TemplateUI[] | undefined;
    templateUIupdatedByPerson?: TemplateUI[] | undefined;
    transportEmissionFactorcreatedByPerson?: TransportEmissionFactor[] | undefined;
    transportEmissionFactorupdatedByPerson?: TransportEmissionFactor[] | undefined;
    transportModecreatedByPerson?: TransportMode[] | undefined;
    transportModeupdatedByPerson?: TransportMode[] | undefined;
    treeItemscreatedByPerson?: TreeItems[] | undefined;
    treeItemsupdatedByPerson?: TreeItems[] | undefined;
    treecreatedByPerson?: Tree[] | undefined;
    treeupdatedByPerson?: Tree[] | undefined;
    unitOperationStepcreatedByPerson?: UnitOperationStep[] | undefined;
    unitOperationStepupdatedByPerson?: UnitOperationStep[] | undefined;
    unitOperationcreatedByPerson?: UnitOperation[] | undefined;
    unitOperationupdatedByPerson?: UnitOperation[] | undefined;
    unitTypecreatedByPerson?: UnitType[] | undefined;
    unitTypeupdatedByPerson?: UnitType[] | undefined;
    unitcreatedByPerson?: Unit[] | undefined;
    unitupdatedByPerson?: Unit[] | undefined;
    updatedByPerson?: Person;
    userThemeSelectioncreatedByPerson?: UserThemeSelection[] | undefined;
    userThemeSelectionupdatedByPerson?: UserThemeSelection[] | undefined;
    userThemeSelectionuser?: UserThemeSelection;
    userType?: UserType;
    userTypeScreencreatedByPerson?: UserTypeScreen[] | undefined;
    userTypeScreenupdatedByPerson?: UserTypeScreen[] | undefined;
    userTypecreatedByPerson?: UserType[] | undefined;
    userTypeupdatedByPerson?: UserType[] | undefined;
    userUserType?: UserUserType[] | undefined;
    utilitiesEnergyConsumptioncreatedByPerson?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesEnergyConsumptionupdatedByPerson?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesProcessingOperationcreatedByPerson?: UtilitiesProcessingOperation[] | undefined;
    utilitiesProcessingOperationupdatedByPerson?: UtilitiesProcessingOperation[] | undefined;
    utilitiesSteamConsumptioncreatedByPerson?: UtilitiesSteamConsumption[] | undefined;
    utilitiesSteamConsumptionupdatedByPerson?: UtilitiesSteamConsumption[] | undefined;
    utilitiescreatedByPerson?: Utilities[] | undefined;
    utilitiesupdatedByPerson?: Utilities[] | undefined;
    wasteDisposalRoutecreatedByPerson?: WasteDisposalRoute[] | undefined;
    wasteDisposalRouteupdatedByPerson?: WasteDisposalRoute[] | undefined;
    wasteDisposalTypecreatedByPerson?: WasteDisposalType[] | undefined;
    wasteDisposalTypeupdatedByPerson?: WasteDisposalType[] | undefined;
    wasteTypeEmissionFactorcreatedByPerson?: WasteTypeEmissionFactor[] | undefined;
    wasteTypeEmissionFactorupdatedByPerson?: WasteTypeEmissionFactor[] | undefined;
    wasteTypecreatedByPerson?: WasteType[] | undefined;
    wasteTypeupdatedByPerson?: WasteType[] | undefined;
}

export class PersonIdentityStatus implements IPersonIdentityStatus {
    id?: string;
    personId?: string;
    identityProviderUserId?: string | undefined;
    identityStatusId?: string | undefined;
    providerType?: string | undefined;
    lastSyncTimestamp?: Date | undefined;
    invitationSentTimestamp?: Date | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    identityStatus?: IdentityProviderStatus;
    person?: Person;
    updatedByPerson?: Person;

    constructor(data?: IPersonIdentityStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.identityProviderUserId = _data["identityProviderUserId"];
            this.identityStatusId = _data["identityStatusId"];
            this.providerType = _data["providerType"];
            this.lastSyncTimestamp = _data["lastSyncTimestamp"] ? new Date(_data["lastSyncTimestamp"].toString()) : undefined as any;
            this.invitationSentTimestamp = _data["invitationSentTimestamp"] ? new Date(_data["invitationSentTimestamp"].toString()) : undefined as any;
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.identityStatus = _data["identityStatus"] ? IdentityProviderStatus.fromJS(_data["identityStatus"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): PersonIdentityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PersonIdentityStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["identityProviderUserId"] = this.identityProviderUserId;
        data["identityStatusId"] = this.identityStatusId;
        data["providerType"] = this.providerType;
        data["lastSyncTimestamp"] = this.lastSyncTimestamp ? this.lastSyncTimestamp.toISOString() : undefined as any;
        data["invitationSentTimestamp"] = this.invitationSentTimestamp ? this.invitationSentTimestamp.toISOString() : undefined as any;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["identityStatus"] = this.identityStatus ? this.identityStatus.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IPersonIdentityStatus {
    id?: string;
    personId?: string;
    identityProviderUserId?: string | undefined;
    identityStatusId?: string | undefined;
    providerType?: string | undefined;
    lastSyncTimestamp?: Date | undefined;
    invitationSentTimestamp?: Date | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    identityStatus?: IdentityProviderStatus;
    person?: Person;
    updatedByPerson?: Person;
}

export class PersonParticipationCount implements IPersonParticipationCount {
    numOfProjects?: number;
    numOfSubProjects?: number;
    numOfAssessments?: number;

    constructor(data?: IPersonParticipationCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numOfProjects = _data["numOfProjects"];
            this.numOfSubProjects = _data["numOfSubProjects"];
            this.numOfAssessments = _data["numOfAssessments"];
        }
    }

    static fromJS(data: any): PersonParticipationCount {
        data = typeof data === 'object' ? data : {};
        let result = new PersonParticipationCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numOfProjects"] = this.numOfProjects;
        data["numOfSubProjects"] = this.numOfSubProjects;
        data["numOfAssessments"] = this.numOfAssessments;
        return data;
    }
}

export interface IPersonParticipationCount {
    numOfProjects?: number;
    numOfSubProjects?: number;
    numOfAssessments?: number;
}

export class PersonType implements IPersonType {
    id?: string;
    personTypeName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;

    constructor(data?: IPersonType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personTypeName = _data["personTypeName"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PersonType {
        data = typeof data === 'object' ? data : {};
        let result = new PersonType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personTypeName"] = this.personTypeName;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        return data;
    }
}

export interface IPersonType {
    id?: string;
    personTypeName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
}

export class PrimeVueHierarchy implements IPrimeVueHierarchy {
    key?: string | undefined;
    label?: string | undefined;
    data?: string | undefined;
    icons?: string[] | undefined;
    readonly icon?: string | undefined;
    children?: PrimeVueHierarchy[] | undefined;

    constructor(data?: IPrimeVueHierarchy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.data = _data["data"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(item);
            }
            (this as any).icon = _data["icon"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(PrimeVueHierarchy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrimeVueHierarchy {
        data = typeof data === 'object' ? data : {};
        let result = new PrimeVueHierarchy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["data"] = this.data;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item);
        }
        data["icon"] = this.icon;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPrimeVueHierarchy {
    key?: string | undefined;
    label?: string | undefined;
    data?: string | undefined;
    icons?: string[] | undefined;
    icon?: string | undefined;
    children?: PrimeVueHierarchy[] | undefined;
}

export class ProcessWaste implements IProcessWaste {
    id?: string;
    screenId?: string | undefined;
    stepId?: string | undefined;
    notes?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    pmConcentration?: number | undefined;
    pmUnitId?: string | undefined;
    pmOutput?: number | undefined;
    pmOutputUnitId?: string | undefined;
    eolDestinationMarket?: string | undefined;
    eolDestinationSetting?: string | undefined;
    createdByPerson?: Person;
    eolDestinationMarketNavigation?: MasterDropdown;
    eolDestinationSettingNavigation?: MasterDropdown;
    pmOutputUnit?: Unit;
    pmUnit?: Unit;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    screen?: Screen;
    step?: Step;
    updatedByPerson?: Person;

    constructor(data?: IProcessWaste) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.screenId = _data["screenId"];
            this.stepId = _data["stepId"];
            this.notes = _data["notes"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.pmConcentration = _data["pmConcentration"];
            this.pmUnitId = _data["pmUnitId"];
            this.pmOutput = _data["pmOutput"];
            this.pmOutputUnitId = _data["pmOutputUnitId"];
            this.eolDestinationMarket = _data["eolDestinationMarket"];
            this.eolDestinationSetting = _data["eolDestinationSetting"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.eolDestinationMarketNavigation = _data["eolDestinationMarketNavigation"] ? MasterDropdown.fromJS(_data["eolDestinationMarketNavigation"]) : undefined as any;
            this.eolDestinationSettingNavigation = _data["eolDestinationSettingNavigation"] ? MasterDropdown.fromJS(_data["eolDestinationSettingNavigation"]) : undefined as any;
            this.pmOutputUnit = _data["pmOutputUnit"] ? Unit.fromJS(_data["pmOutputUnit"]) : undefined as any;
            this.pmUnit = _data["pmUnit"] ? Unit.fromJS(_data["pmUnit"]) : undefined as any;
            if (Array.isArray(_data["processWasteDetail"])) {
                this.processWasteDetail = [] as any;
                for (let item of _data["processWasteDetail"])
                    this.processWasteDetail!.push(ProcessWasteDetail.fromJS(item));
            }
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessWaste {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWaste();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["screenId"] = this.screenId;
        data["stepId"] = this.stepId;
        data["notes"] = this.notes;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["pmConcentration"] = this.pmConcentration;
        data["pmUnitId"] = this.pmUnitId;
        data["pmOutput"] = this.pmOutput;
        data["pmOutputUnitId"] = this.pmOutputUnitId;
        data["eolDestinationMarket"] = this.eolDestinationMarket;
        data["eolDestinationSetting"] = this.eolDestinationSetting;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["eolDestinationMarketNavigation"] = this.eolDestinationMarketNavigation ? this.eolDestinationMarketNavigation.toJSON() : undefined as any;
        data["eolDestinationSettingNavigation"] = this.eolDestinationSettingNavigation ? this.eolDestinationSettingNavigation.toJSON() : undefined as any;
        data["pmOutputUnit"] = this.pmOutputUnit ? this.pmOutputUnit.toJSON() : undefined as any;
        data["pmUnit"] = this.pmUnit ? this.pmUnit.toJSON() : undefined as any;
        if (Array.isArray(this.processWasteDetail)) {
            data["processWasteDetail"] = [];
            for (let item of this.processWasteDetail)
                data["processWasteDetail"].push(item ? item.toJSON() : undefined as any);
        }
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IProcessWaste {
    id?: string;
    screenId?: string | undefined;
    stepId?: string | undefined;
    notes?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    pmConcentration?: number | undefined;
    pmUnitId?: string | undefined;
    pmOutput?: number | undefined;
    pmOutputUnitId?: string | undefined;
    eolDestinationMarket?: string | undefined;
    eolDestinationSetting?: string | undefined;
    createdByPerson?: Person;
    eolDestinationMarketNavigation?: MasterDropdown;
    eolDestinationSettingNavigation?: MasterDropdown;
    pmOutputUnit?: Unit;
    pmUnit?: Unit;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    screen?: Screen;
    step?: Step;
    updatedByPerson?: Person;
}

export class ProcessWasteDetail implements IProcessWasteDetail {
    id?: string;
    stepId?: string;
    materialId?: string | undefined;
    totalMass?: number | undefined;
    sterilizationBeforeDisposal?: boolean;
    hazardWasteIncineration?: number | undefined;
    landfill?: number | undefined;
    recycling?: number | undefined;
    wasteIncinerationEnergyRecovery?: number | undefined;
    wasteIncinerationNoEnergyRecovery?: number | undefined;
    municipalWaste?: number | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    wasteId?: string | undefined;
    wasteTypeId?: string | undefined;
    total?: number | undefined;
    rawMaterialEntryId?: string | undefined;
    processWasteDetailName?: string | undefined;
    isWasteType?: boolean | undefined;
    createdByPerson?: Person;
    material?: Material;
    rawMaterialEntry?: RawMaterialEntry;
    step?: Step;
    updatedByPerson?: Person;
    waste?: ProcessWaste;
    wasteType?: WasteType;

    constructor(data?: IProcessWasteDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.materialId = _data["materialId"];
            this.totalMass = _data["totalMass"];
            this.sterilizationBeforeDisposal = _data["sterilizationBeforeDisposal"];
            this.hazardWasteIncineration = _data["hazardWasteIncineration"];
            this.landfill = _data["landfill"];
            this.recycling = _data["recycling"];
            this.wasteIncinerationEnergyRecovery = _data["wasteIncinerationEnergyRecovery"];
            this.wasteIncinerationNoEnergyRecovery = _data["wasteIncinerationNoEnergyRecovery"];
            this.municipalWaste = _data["municipalWaste"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.wasteId = _data["wasteId"];
            this.wasteTypeId = _data["wasteTypeId"];
            this.total = _data["total"];
            this.rawMaterialEntryId = _data["rawMaterialEntryId"];
            this.processWasteDetailName = _data["processWasteDetailName"];
            this.isWasteType = _data["isWasteType"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : undefined as any;
            this.rawMaterialEntry = _data["rawMaterialEntry"] ? RawMaterialEntry.fromJS(_data["rawMaterialEntry"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.waste = _data["waste"] ? ProcessWaste.fromJS(_data["waste"]) : undefined as any;
            this.wasteType = _data["wasteType"] ? WasteType.fromJS(_data["wasteType"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessWasteDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWasteDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["materialId"] = this.materialId;
        data["totalMass"] = this.totalMass;
        data["sterilizationBeforeDisposal"] = this.sterilizationBeforeDisposal;
        data["hazardWasteIncineration"] = this.hazardWasteIncineration;
        data["landfill"] = this.landfill;
        data["recycling"] = this.recycling;
        data["wasteIncinerationEnergyRecovery"] = this.wasteIncinerationEnergyRecovery;
        data["wasteIncinerationNoEnergyRecovery"] = this.wasteIncinerationNoEnergyRecovery;
        data["municipalWaste"] = this.municipalWaste;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["wasteId"] = this.wasteId;
        data["wasteTypeId"] = this.wasteTypeId;
        data["total"] = this.total;
        data["rawMaterialEntryId"] = this.rawMaterialEntryId;
        data["processWasteDetailName"] = this.processWasteDetailName;
        data["isWasteType"] = this.isWasteType;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["material"] = this.material ? this.material.toJSON() : undefined as any;
        data["rawMaterialEntry"] = this.rawMaterialEntry ? this.rawMaterialEntry.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["waste"] = this.waste ? this.waste.toJSON() : undefined as any;
        data["wasteType"] = this.wasteType ? this.wasteType.toJSON() : undefined as any;
        return data;
    }
}

export interface IProcessWasteDetail {
    id?: string;
    stepId?: string;
    materialId?: string | undefined;
    totalMass?: number | undefined;
    sterilizationBeforeDisposal?: boolean;
    hazardWasteIncineration?: number | undefined;
    landfill?: number | undefined;
    recycling?: number | undefined;
    wasteIncinerationEnergyRecovery?: number | undefined;
    wasteIncinerationNoEnergyRecovery?: number | undefined;
    municipalWaste?: number | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    wasteId?: string | undefined;
    wasteTypeId?: string | undefined;
    total?: number | undefined;
    rawMaterialEntryId?: string | undefined;
    processWasteDetailName?: string | undefined;
    isWasteType?: boolean | undefined;
    createdByPerson?: Person;
    material?: Material;
    rawMaterialEntry?: RawMaterialEntry;
    step?: Step;
    updatedByPerson?: Person;
    waste?: ProcessWaste;
    wasteType?: WasteType;
}

export class ProcessWasteRowInTable implements IProcessWasteRowInTable {
    id?: string;
    materialTypeName?: string | undefined;
    materialName?: string | undefined;
    totalMass?: number;
    sterilizationDisposal?: boolean;
    hazardWasteIncineration?: number | undefined;
    landfill?: number | undefined;
    recycling?: number | undefined;
    generalWasteIncinerationEnergy?: number | undefined;
    generalWasteIncinerationEnergyNoEnergy?: number | undefined;
    municipalWastewaterTreatment?: number | undefined;
    total?: number;
    materialRowId?: string | undefined;
    materialRowEntryId?: string | undefined;
    wasteTypeId?: string | undefined;
    isWasteType?: boolean;

    constructor(data?: IProcessWasteRowInTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialTypeName = _data["materialTypeName"];
            this.materialName = _data["materialName"];
            this.totalMass = _data["totalMass"];
            this.sterilizationDisposal = _data["sterilizationDisposal"];
            this.hazardWasteIncineration = _data["hazardWasteIncineration"];
            this.landfill = _data["landfill"];
            this.recycling = _data["recycling"];
            this.generalWasteIncinerationEnergy = _data["generalWasteIncinerationEnergy"];
            this.generalWasteIncinerationEnergyNoEnergy = _data["generalWasteIncinerationEnergyNoEnergy"];
            this.municipalWastewaterTreatment = _data["municipalWastewaterTreatment"];
            this.total = _data["total"];
            this.materialRowId = _data["materialRowId"];
            this.materialRowEntryId = _data["materialRowEntryId"];
            this.wasteTypeId = _data["wasteTypeId"];
            this.isWasteType = _data["isWasteType"];
        }
    }

    static fromJS(data: any): ProcessWasteRowInTable {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWasteRowInTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialTypeName"] = this.materialTypeName;
        data["materialName"] = this.materialName;
        data["totalMass"] = this.totalMass;
        data["sterilizationDisposal"] = this.sterilizationDisposal;
        data["hazardWasteIncineration"] = this.hazardWasteIncineration;
        data["landfill"] = this.landfill;
        data["recycling"] = this.recycling;
        data["generalWasteIncinerationEnergy"] = this.generalWasteIncinerationEnergy;
        data["generalWasteIncinerationEnergyNoEnergy"] = this.generalWasteIncinerationEnergyNoEnergy;
        data["municipalWastewaterTreatment"] = this.municipalWastewaterTreatment;
        data["total"] = this.total;
        data["materialRowId"] = this.materialRowId;
        data["materialRowEntryId"] = this.materialRowEntryId;
        data["wasteTypeId"] = this.wasteTypeId;
        data["isWasteType"] = this.isWasteType;
        return data;
    }
}

export interface IProcessWasteRowInTable {
    id?: string;
    materialTypeName?: string | undefined;
    materialName?: string | undefined;
    totalMass?: number;
    sterilizationDisposal?: boolean;
    hazardWasteIncineration?: number | undefined;
    landfill?: number | undefined;
    recycling?: number | undefined;
    generalWasteIncinerationEnergy?: number | undefined;
    generalWasteIncinerationEnergyNoEnergy?: number | undefined;
    municipalWastewaterTreatment?: number | undefined;
    total?: number;
    materialRowId?: string | undefined;
    materialRowEntryId?: string | undefined;
    wasteTypeId?: string | undefined;
    isWasteType?: boolean;
}

export class ProcessWasteStatus implements IProcessWasteStatus {
    isWrong?: boolean;
    processWasteDetail?: ProcessWasteDetail;
    processWaste?: ProcessWaste;

    constructor(data?: IProcessWasteStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isWrong = _data["isWrong"];
            this.processWasteDetail = _data["processWasteDetail"] ? ProcessWasteDetail.fromJS(_data["processWasteDetail"]) : undefined as any;
            this.processWaste = _data["processWaste"] ? ProcessWaste.fromJS(_data["processWaste"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessWasteStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWasteStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isWrong"] = this.isWrong;
        data["processWasteDetail"] = this.processWasteDetail ? this.processWasteDetail.toJSON() : undefined as any;
        data["processWaste"] = this.processWaste ? this.processWaste.toJSON() : undefined as any;
        return data;
    }
}

export interface IProcessWasteStatus {
    isWrong?: boolean;
    processWasteDetail?: ProcessWasteDetail;
    processWaste?: ProcessWaste;
}

export class ProcessWasteStatusStep implements IProcessWasteStatusStep {
    theProject?: Project;
    theSubProject?: SubProject;
    theAssessment?: Assessment;
    theSkillArea?: Screen;
    numErrors?: number;
    processWaste?: ProcessWasteStatus[] | undefined;
    extraComment?: string | undefined;
    step?: Step;

    constructor(data?: IProcessWasteStatusStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theProject = _data["theProject"] ? Project.fromJS(_data["theProject"]) : undefined as any;
            this.theSubProject = _data["theSubProject"] ? SubProject.fromJS(_data["theSubProject"]) : undefined as any;
            this.theAssessment = _data["theAssessment"] ? Assessment.fromJS(_data["theAssessment"]) : undefined as any;
            this.theSkillArea = _data["theSkillArea"] ? Screen.fromJS(_data["theSkillArea"]) : undefined as any;
            this.numErrors = _data["numErrors"];
            if (Array.isArray(_data["processWaste"])) {
                this.processWaste = [] as any;
                for (let item of _data["processWaste"])
                    this.processWaste!.push(ProcessWasteStatus.fromJS(item));
            }
            this.extraComment = _data["extraComment"];
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessWasteStatusStep {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWasteStatusStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theProject"] = this.theProject ? this.theProject.toJSON() : undefined as any;
        data["theSubProject"] = this.theSubProject ? this.theSubProject.toJSON() : undefined as any;
        data["theAssessment"] = this.theAssessment ? this.theAssessment.toJSON() : undefined as any;
        data["theSkillArea"] = this.theSkillArea ? this.theSkillArea.toJSON() : undefined as any;
        data["numErrors"] = this.numErrors;
        if (Array.isArray(this.processWaste)) {
            data["processWaste"] = [];
            for (let item of this.processWaste)
                data["processWaste"].push(item ? item.toJSON() : undefined as any);
        }
        data["extraComment"] = this.extraComment;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        return data;
    }
}

export interface IProcessWasteStatusStep {
    theProject?: Project;
    theSubProject?: SubProject;
    theAssessment?: Assessment;
    theSkillArea?: Screen;
    numErrors?: number;
    processWaste?: ProcessWasteStatus[] | undefined;
    extraComment?: string | undefined;
    step?: Step;
}

export class ProductFormat implements IProductFormat {
    id?: string;
    formatName?: string | undefined;
    screenId?: string;
    isActive?: boolean;
    createdByPersonId?: string;
    updatedByPersonId?: string | undefined;
    createdTimeStamp?: Date;
    updatedTimeStamp?: Date | undefined;
    massQuantityLabelText?: string | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    screen?: Screen;

    constructor(data?: IProductFormat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formatName = _data["formatName"];
            this.screenId = _data["screenId"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.massQuantityLabelText = _data["massQuantityLabelText"];
            if (Array.isArray(_data["generalInformation"])) {
                this.generalInformation = [] as any;
                for (let item of _data["generalInformation"])
                    this.generalInformation!.push(GeneralInformation.fromJS(item));
            }
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductFormat {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFormat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formatName"] = this.formatName;
        data["screenId"] = this.screenId;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["massQuantityLabelText"] = this.massQuantityLabelText;
        if (Array.isArray(this.generalInformation)) {
            data["generalInformation"] = [];
            for (let item of this.generalInformation)
                data["generalInformation"].push(item ? item.toJSON() : undefined as any);
        }
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductFormat {
    id?: string;
    formatName?: string | undefined;
    screenId?: string;
    isActive?: boolean;
    createdByPersonId?: string;
    updatedByPersonId?: string | undefined;
    createdTimeStamp?: Date;
    updatedTimeStamp?: Date | undefined;
    massQuantityLabelText?: string | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    screen?: Screen;
}

export class ProductProcessLifeCycleResult implements IProductProcessLifeCycleResult {
    name?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;

    constructor(data?: IProductProcessLifeCycleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.climateChange = _data["climateChange"];
            this.waterConsumption = _data["waterConsumption"];
            this.costofGoods = _data["costofGoods"];
            this.water = _data["water"];
            this.solvent = _data["solvent"];
            if (_data["emissionFactors"]) {
                this.emissionFactors = {} as any;
                for (let key in _data["emissionFactors"]) {
                    if (_data["emissionFactors"].hasOwnProperty(key))
                        (this.emissionFactors as any)![key] = _data["emissionFactors"][key];
                }
            }
            this.total = _data["total"];
            this.totalWeightedScore = _data["totalWeightedScore"];
        }
    }

    static fromJS(data: any): ProductProcessLifeCycleResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProcessLifeCycleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["climateChange"] = this.climateChange;
        data["waterConsumption"] = this.waterConsumption;
        data["costofGoods"] = this.costofGoods;
        data["water"] = this.water;
        data["solvent"] = this.solvent;
        if (this.emissionFactors) {
            data["emissionFactors"] = {};
            for (let key in this.emissionFactors) {
                if (this.emissionFactors.hasOwnProperty(key))
                    (data["emissionFactors"] as any)[key] = (this.emissionFactors as any)[key];
            }
        }
        data["total"] = this.total;
        data["totalWeightedScore"] = this.totalWeightedScore;
        return data;
    }
}

export interface IProductProcessLifeCycleResult {
    name?: string | undefined;
    climateChange?: number | undefined;
    waterConsumption?: number | undefined;
    costofGoods?: number | undefined;
    water?: number | undefined;
    solvent?: number | undefined;
    emissionFactors?: { [key: string]: number; } | undefined;
    total?: number | undefined;
    totalWeightedScore?: number | undefined;
}

export class ProductProcessProxy implements IProductProcessProxy {
    id?: string;
    materialDefaultUnitId?: string | undefined;
    materialTypeId?: string;
    materialName?: string | undefined;
    cas?: string | undefined;
    isActive?: boolean;
    nameSimbol?: string | undefined;
    atomMassMolecularWeight?: number | undefined;
    assay?: number | undefined;
    density?: number | undefined;
    fossilCarbonContent?: number | undefined;
    fossilCarbonContentSource?: string | undefined;
    resultingCO2Emissions?: number | undefined;
    wfiRequired?: number | undefined;
    weightPerPiece?: number | undefined;
    climateChange?: number | undefined;
    waterUseConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityScore?: number | undefined;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    pmiWater?: number | undefined;
    pmiSolvent?: number | undefined;
    materialSubTypeId?: string | undefined;
    assessmentId?: string | undefined;
    screenId?: string | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    materialDefaultUnit?: Unit;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    materialSubType?: MaterialSubType;
    materialType?: MaterialType;
    productProcessProxyEmissionFactor?: ProductProcessProxyEmissionFactor[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    screen?: Screen;
    updatedByPerson?: Person;

    constructor(data?: IProductProcessProxy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialDefaultUnitId = _data["materialDefaultUnitId"];
            this.materialTypeId = _data["materialTypeId"];
            this.materialName = _data["materialName"];
            this.cas = _data["cas"];
            this.isActive = _data["isActive"];
            this.nameSimbol = _data["nameSimbol"];
            this.atomMassMolecularWeight = _data["atomMassMolecularWeight"];
            this.assay = _data["assay"];
            this.density = _data["density"];
            this.fossilCarbonContent = _data["fossilCarbonContent"];
            this.fossilCarbonContentSource = _data["fossilCarbonContentSource"];
            this.resultingCO2Emissions = _data["resultingCO2Emissions"];
            this.wfiRequired = _data["wfiRequired"];
            this.weightPerPiece = _data["weightPerPiece"];
            this.climateChange = _data["climateChange"];
            this.waterUseConsumption = _data["waterUseConsumption"];
            this.goodsCost = _data["goodsCost"];
            this.pmi = _data["pmi"];
            this.dataQualityScore = _data["dataQualityScore"];
            this.comments = _data["comments"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.pmiWater = _data["pmiWater"];
            this.pmiSolvent = _data["pmiSolvent"];
            this.materialSubTypeId = _data["materialSubTypeId"];
            this.assessmentId = _data["assessmentId"];
            this.screenId = _data["screenId"];
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.materialDefaultUnit = _data["materialDefaultUnit"] ? Unit.fromJS(_data["materialDefaultUnit"]) : undefined as any;
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            this.materialSubType = _data["materialSubType"] ? MaterialSubType.fromJS(_data["materialSubType"]) : undefined as any;
            this.materialType = _data["materialType"] ? MaterialType.fromJS(_data["materialType"]) : undefined as any;
            if (Array.isArray(_data["productProcessProxyEmissionFactor"])) {
                this.productProcessProxyEmissionFactor = [] as any;
                for (let item of _data["productProcessProxyEmissionFactor"])
                    this.productProcessProxyEmissionFactor!.push(ProductProcessProxyEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEntry"])) {
                this.productProcessProxyEntry = [] as any;
                for (let item of _data["productProcessProxyEntry"])
                    this.productProcessProxyEntry!.push(ProductProcessProxyEntry.fromJS(item));
            }
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductProcessProxy {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProcessProxy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialDefaultUnitId"] = this.materialDefaultUnitId;
        data["materialTypeId"] = this.materialTypeId;
        data["materialName"] = this.materialName;
        data["cas"] = this.cas;
        data["isActive"] = this.isActive;
        data["nameSimbol"] = this.nameSimbol;
        data["atomMassMolecularWeight"] = this.atomMassMolecularWeight;
        data["assay"] = this.assay;
        data["density"] = this.density;
        data["fossilCarbonContent"] = this.fossilCarbonContent;
        data["fossilCarbonContentSource"] = this.fossilCarbonContentSource;
        data["resultingCO2Emissions"] = this.resultingCO2Emissions;
        data["wfiRequired"] = this.wfiRequired;
        data["weightPerPiece"] = this.weightPerPiece;
        data["climateChange"] = this.climateChange;
        data["waterUseConsumption"] = this.waterUseConsumption;
        data["goodsCost"] = this.goodsCost;
        data["pmi"] = this.pmi;
        data["dataQualityScore"] = this.dataQualityScore;
        data["comments"] = this.comments;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["pmiWater"] = this.pmiWater;
        data["pmiSolvent"] = this.pmiSolvent;
        data["materialSubTypeId"] = this.materialSubTypeId;
        data["assessmentId"] = this.assessmentId;
        data["screenId"] = this.screenId;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["materialDefaultUnit"] = this.materialDefaultUnit ? this.materialDefaultUnit.toJSON() : undefined as any;
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        data["materialSubType"] = this.materialSubType ? this.materialSubType.toJSON() : undefined as any;
        data["materialType"] = this.materialType ? this.materialType.toJSON() : undefined as any;
        if (Array.isArray(this.productProcessProxyEmissionFactor)) {
            data["productProcessProxyEmissionFactor"] = [];
            for (let item of this.productProcessProxyEmissionFactor)
                data["productProcessProxyEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEntry)) {
            data["productProcessProxyEntry"] = [];
            for (let item of this.productProcessProxyEntry)
                data["productProcessProxyEntry"].push(item ? item.toJSON() : undefined as any);
        }
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductProcessProxy {
    id?: string;
    materialDefaultUnitId?: string | undefined;
    materialTypeId?: string;
    materialName?: string | undefined;
    cas?: string | undefined;
    isActive?: boolean;
    nameSimbol?: string | undefined;
    atomMassMolecularWeight?: number | undefined;
    assay?: number | undefined;
    density?: number | undefined;
    fossilCarbonContent?: number | undefined;
    fossilCarbonContentSource?: string | undefined;
    resultingCO2Emissions?: number | undefined;
    wfiRequired?: number | undefined;
    weightPerPiece?: number | undefined;
    climateChange?: number | undefined;
    waterUseConsumption?: number | undefined;
    goodsCost?: number | undefined;
    pmi?: number | undefined;
    dataQualityScore?: number | undefined;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    pmiWater?: number | undefined;
    pmiSolvent?: number | undefined;
    materialSubTypeId?: string | undefined;
    assessmentId?: string | undefined;
    screenId?: string | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    materialDefaultUnit?: Unit;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    materialSubType?: MaterialSubType;
    materialType?: MaterialType;
    productProcessProxyEmissionFactor?: ProductProcessProxyEmissionFactor[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    screen?: Screen;
    updatedByPerson?: Person;
}

export class ProductProcessProxyEmissionFactor implements IProductProcessProxyEmissionFactor {
    id?: string;
    productProcessProxyId?: string;
    emissionFactorId?: string;
    factor?: number;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    emissionFactor?: EmissionFactors;
    productProcessProxy?: ProductProcessProxy;

    constructor(data?: IProductProcessProxyEmissionFactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productProcessProxyId = _data["productProcessProxyId"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.factor = _data["factor"];
            this.dataQualityScore = _data["dataQualityScore"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.emissionFactor = _data["emissionFactor"] ? EmissionFactors.fromJS(_data["emissionFactor"]) : undefined as any;
            this.productProcessProxy = _data["productProcessProxy"] ? ProductProcessProxy.fromJS(_data["productProcessProxy"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductProcessProxyEmissionFactor {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProcessProxyEmissionFactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productProcessProxyId"] = this.productProcessProxyId;
        data["emissionFactorId"] = this.emissionFactorId;
        data["factor"] = this.factor;
        data["dataQualityScore"] = this.dataQualityScore;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["emissionFactor"] = this.emissionFactor ? this.emissionFactor.toJSON() : undefined as any;
        data["productProcessProxy"] = this.productProcessProxy ? this.productProcessProxy.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductProcessProxyEmissionFactor {
    id?: string;
    productProcessProxyId?: string;
    emissionFactorId?: string;
    factor?: number;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    emissionFactor?: EmissionFactors;
    productProcessProxy?: ProductProcessProxy;
}

export class ProductProcessProxyEntry implements IProductProcessProxyEntry {
    id?: string;
    assessmentId?: string | undefined;
    stepId?: string | undefined;
    productProcessProxyId?: string | undefined;
    quantity?: number | undefined;
    unitId?: string | undefined;
    unitOperationId?: string | undefined;
    notes?: string | undefined;
    supplierName?: string | undefined;
    supplierLocation?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    productProcessProxy?: ProductProcessProxy;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;

    constructor(data?: IProductProcessProxyEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentId = _data["assessmentId"];
            this.stepId = _data["stepId"];
            this.productProcessProxyId = _data["productProcessProxyId"];
            this.quantity = _data["quantity"];
            this.unitId = _data["unitId"];
            this.unitOperationId = _data["unitOperationId"];
            this.notes = _data["notes"];
            this.supplierName = _data["supplierName"];
            this.supplierLocation = _data["supplierLocation"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            this.productProcessProxy = _data["productProcessProxy"] ? ProductProcessProxy.fromJS(_data["productProcessProxy"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.unitOperation = _data["unitOperation"] ? UnitOperation.fromJS(_data["unitOperation"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductProcessProxyEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProcessProxyEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentId"] = this.assessmentId;
        data["stepId"] = this.stepId;
        data["productProcessProxyId"] = this.productProcessProxyId;
        data["quantity"] = this.quantity;
        data["unitId"] = this.unitId;
        data["unitOperationId"] = this.unitOperationId;
        data["notes"] = this.notes;
        data["supplierName"] = this.supplierName;
        data["supplierLocation"] = this.supplierLocation;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        data["productProcessProxy"] = this.productProcessProxy ? this.productProcessProxy.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["unitOperation"] = this.unitOperation ? this.unitOperation.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductProcessProxyEntry {
    id?: string;
    assessmentId?: string | undefined;
    stepId?: string | undefined;
    productProcessProxyId?: string | undefined;
    quantity?: number | undefined;
    unitId?: string | undefined;
    unitOperationId?: string | undefined;
    notes?: string | undefined;
    supplierName?: string | undefined;
    supplierLocation?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedTimeStamp?: Date | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    productProcessProxy?: ProductProcessProxy;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;
}

export class Project implements IProject {
    id?: string;
    projectName?: string | undefined;
    projectOwner?: string;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    isSingleUtilitiesChecked?: boolean;
    isTemplateProject?: boolean;
    createdByPerson?: Person;
    projectCollaborator?: ProjectCollaborator[] | undefined;
    projectOwnerNavigation?: Person;
    subProject?: SubProject[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.projectOwner = _data["projectOwner"];
            this.comments = _data["comments"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.isSingleUtilitiesChecked = _data["isSingleUtilitiesChecked"];
            this.isTemplateProject = _data["isTemplateProject"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["projectCollaborator"])) {
                this.projectCollaborator = [] as any;
                for (let item of _data["projectCollaborator"])
                    this.projectCollaborator!.push(ProjectCollaborator.fromJS(item));
            }
            this.projectOwnerNavigation = _data["projectOwnerNavigation"] ? Person.fromJS(_data["projectOwnerNavigation"]) : undefined as any;
            if (Array.isArray(_data["subProject"])) {
                this.subProject = [] as any;
                for (let item of _data["subProject"])
                    this.subProject!.push(SubProject.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectOwner"] = this.projectOwner;
        data["comments"] = this.comments;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["isSingleUtilitiesChecked"] = this.isSingleUtilitiesChecked;
        data["isTemplateProject"] = this.isTemplateProject;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.projectCollaborator)) {
            data["projectCollaborator"] = [];
            for (let item of this.projectCollaborator)
                data["projectCollaborator"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectOwnerNavigation"] = this.projectOwnerNavigation ? this.projectOwnerNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.subProject)) {
            data["subProject"] = [];
            for (let item of this.subProject)
                data["subProject"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IProject {
    id?: string;
    projectName?: string | undefined;
    projectOwner?: string;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    isSingleUtilitiesChecked?: boolean;
    isTemplateProject?: boolean;
    createdByPerson?: Person;
    projectCollaborator?: ProjectCollaborator[] | undefined;
    projectOwnerNavigation?: Person;
    subProject?: SubProject[] | undefined;
    updatedByPerson?: Person;
}

export class ProjectCollaborator implements IProjectCollaborator {
    id?: string;
    personId?: string;
    projectId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    person?: Person;
    project?: Project;

    constructor(data?: IProjectCollaborator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.projectId = _data["projectId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectCollaborator {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCollaborator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["projectId"] = this.projectId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectCollaborator {
    id?: string;
    personId?: string;
    projectId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    person?: Person;
    project?: Project;
}

export class ProjectCollaboratorPut implements IProjectCollaboratorPut {
    project?: Project;
    collaborators?: Person[] | undefined;
    autoCreateSubProjects?: boolean;

    constructor(data?: IProjectCollaboratorPut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
            if (Array.isArray(_data["collaborators"])) {
                this.collaborators = [] as any;
                for (let item of _data["collaborators"])
                    this.collaborators!.push(Person.fromJS(item));
            }
            this.autoCreateSubProjects = _data["autoCreateSubProjects"];
        }
    }

    static fromJS(data: any): ProjectCollaboratorPut {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCollaboratorPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        if (Array.isArray(this.collaborators)) {
            data["collaborators"] = [];
            for (let item of this.collaborators)
                data["collaborators"].push(item ? item.toJSON() : undefined as any);
        }
        data["autoCreateSubProjects"] = this.autoCreateSubProjects;
        return data;
    }
}

export interface IProjectCollaboratorPut {
    project?: Project;
    collaborators?: Person[] | undefined;
    autoCreateSubProjects?: boolean;
}

export class ProjectForTable implements IProjectForTable {
    id?: string;
    projectName?: string | undefined;
    subProjectsNum?: number;
    projectCollaboratorList?: string | undefined;
    project?: Project;

    constructor(data?: IProjectForTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.subProjectsNum = _data["subProjectsNum"];
            this.projectCollaboratorList = _data["projectCollaboratorList"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectForTable {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectForTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["subProjectsNum"] = this.subProjectsNum;
        data["projectCollaboratorList"] = this.projectCollaboratorList;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectForTable {
    id?: string;
    projectName?: string | undefined;
    subProjectsNum?: number;
    projectCollaboratorList?: string | undefined;
    project?: Project;
}

export class RawMaterial implements IRawMaterial {
    id?: string;
    stepId?: string;
    siteLocationId?: string | undefined;
    unitId?: string | undefined;
    massOfProduct?: number | undefined;
    image?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    generalInformationId?: string | undefined;
    note?: string | undefined;
    bdsConcentration?: number | undefined;
    bdsUnitId?: string | undefined;
    productOutputName?: string | undefined;
    rawMaterialType?: string | undefined;
    bdsUnit?: Unit;
    createdByPerson?: Person;
    generalInformation?: GeneralInformation;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperation?: RawMaterialUnitOperation[] | undefined;
    siteLocation?: SiteLocation;
    step?: Step;
    unit?: Unit;
    updatedByPerson?: Person;

    constructor(data?: IRawMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.siteLocationId = _data["siteLocationId"];
            this.unitId = _data["unitId"];
            this.massOfProduct = _data["massOfProduct"];
            this.image = _data["image"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.generalInformationId = _data["generalInformationId"];
            this.note = _data["note"];
            this.bdsConcentration = _data["bdsConcentration"];
            this.bdsUnitId = _data["bdsUnitId"];
            this.productOutputName = _data["productOutputName"];
            this.rawMaterialType = _data["rawMaterialType"];
            this.bdsUnit = _data["bdsUnit"] ? Unit.fromJS(_data["bdsUnit"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.generalInformation = _data["generalInformation"] ? GeneralInformation.fromJS(_data["generalInformation"]) : undefined as any;
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntry"])) {
                this.rawMaterialEntry = [] as any;
                for (let item of _data["rawMaterialEntry"])
                    this.rawMaterialEntry!.push(RawMaterialEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialUnitOperation"])) {
                this.rawMaterialUnitOperation = [] as any;
                for (let item of _data["rawMaterialUnitOperation"])
                    this.rawMaterialUnitOperation!.push(RawMaterialUnitOperation.fromJS(item));
            }
            this.siteLocation = _data["siteLocation"] ? SiteLocation.fromJS(_data["siteLocation"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): RawMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["siteLocationId"] = this.siteLocationId;
        data["unitId"] = this.unitId;
        data["massOfProduct"] = this.massOfProduct;
        data["image"] = this.image;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["generalInformationId"] = this.generalInformationId;
        data["note"] = this.note;
        data["bdsConcentration"] = this.bdsConcentration;
        data["bdsUnitId"] = this.bdsUnitId;
        data["productOutputName"] = this.productOutputName;
        data["rawMaterialType"] = this.rawMaterialType;
        data["bdsUnit"] = this.bdsUnit ? this.bdsUnit.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : undefined as any;
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntry)) {
            data["rawMaterialEntry"] = [];
            for (let item of this.rawMaterialEntry)
                data["rawMaterialEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialUnitOperation)) {
            data["rawMaterialUnitOperation"] = [];
            for (let item of this.rawMaterialUnitOperation)
                data["rawMaterialUnitOperation"].push(item ? item.toJSON() : undefined as any);
        }
        data["siteLocation"] = this.siteLocation ? this.siteLocation.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IRawMaterial {
    id?: string;
    stepId?: string;
    siteLocationId?: string | undefined;
    unitId?: string | undefined;
    massOfProduct?: number | undefined;
    image?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    generalInformationId?: string | undefined;
    note?: string | undefined;
    bdsConcentration?: number | undefined;
    bdsUnitId?: string | undefined;
    productOutputName?: string | undefined;
    rawMaterialType?: string | undefined;
    bdsUnit?: Unit;
    createdByPerson?: Person;
    generalInformation?: GeneralInformation;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperation?: RawMaterialUnitOperation[] | undefined;
    siteLocation?: SiteLocation;
    step?: Step;
    unit?: Unit;
    updatedByPerson?: Person;
}

export class RawMaterialCompleteData implements IRawMaterialCompleteData {
    rawMaterialTableRows?: RawMaterialTableRow[] | undefined;
    allMaterialInboundTransport?: SingleMaterialInboundTransport[] | undefined;
    totalMass?: number;

    constructor(data?: IRawMaterialCompleteData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rawMaterialTableRows"])) {
                this.rawMaterialTableRows = [] as any;
                for (let item of _data["rawMaterialTableRows"])
                    this.rawMaterialTableRows!.push(RawMaterialTableRow.fromJS(item));
            }
            if (Array.isArray(_data["allMaterialInboundTransport"])) {
                this.allMaterialInboundTransport = [] as any;
                for (let item of _data["allMaterialInboundTransport"])
                    this.allMaterialInboundTransport!.push(SingleMaterialInboundTransport.fromJS(item));
            }
            this.totalMass = _data["totalMass"];
        }
    }

    static fromJS(data: any): RawMaterialCompleteData {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialCompleteData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rawMaterialTableRows)) {
            data["rawMaterialTableRows"] = [];
            for (let item of this.rawMaterialTableRows)
                data["rawMaterialTableRows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allMaterialInboundTransport)) {
            data["allMaterialInboundTransport"] = [];
            for (let item of this.allMaterialInboundTransport)
                data["allMaterialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalMass"] = this.totalMass;
        return data;
    }
}

export interface IRawMaterialCompleteData {
    rawMaterialTableRows?: RawMaterialTableRow[] | undefined;
    allMaterialInboundTransport?: SingleMaterialInboundTransport[] | undefined;
    totalMass?: number;
}

export class RawMaterialEntry implements IRawMaterialEntry {
    id?: string;
    stepId?: string;
    unitId?: string;
    materialId?: string | undefined;
    unitOperationId?: string | undefined;
    dataQualityRatingId?: string | undefined;
    quantity?: number | undefined;
    notes?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTmeStamp?: Date | undefined;
    isActive?: boolean;
    rawMaterialId?: string | undefined;
    cas?: string | undefined;
    carbonFootprint?: number | undefined;
    supplierName?: string | undefined;
    supplierLocation?: string | undefined;
    wasteStream?: string | undefined;
    dataQualityScore?: string | undefined;
    componentName?: string | undefined;
    referenceQuantity?: number | undefined;
    packagingTypeId?: string | undefined;
    createdByPerson?: Person;
    dataQualityRating?: DataQualityRating;
    material?: Material;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    packagingType?: MasterDropdown;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    rawMaterial?: RawMaterial;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;

    constructor(data?: IRawMaterialEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.unitId = _data["unitId"];
            this.materialId = _data["materialId"];
            this.unitOperationId = _data["unitOperationId"];
            this.dataQualityRatingId = _data["dataQualityRatingId"];
            this.quantity = _data["quantity"];
            this.notes = _data["notes"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTmeStamp = _data["updatedTmeStamp"] ? new Date(_data["updatedTmeStamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.rawMaterialId = _data["rawMaterialId"];
            this.cas = _data["cas"];
            this.carbonFootprint = _data["carbonFootprint"];
            this.supplierName = _data["supplierName"];
            this.supplierLocation = _data["supplierLocation"];
            this.wasteStream = _data["wasteStream"];
            this.dataQualityScore = _data["dataQualityScore"];
            this.componentName = _data["componentName"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.packagingTypeId = _data["packagingTypeId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.dataQualityRating = _data["dataQualityRating"] ? DataQualityRating.fromJS(_data["dataQualityRating"]) : undefined as any;
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : undefined as any;
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            this.packagingType = _data["packagingType"] ? MasterDropdown.fromJS(_data["packagingType"]) : undefined as any;
            if (Array.isArray(_data["processWasteDetail"])) {
                this.processWasteDetail = [] as any;
                for (let item of _data["processWasteDetail"])
                    this.processWasteDetail!.push(ProcessWasteDetail.fromJS(item));
            }
            this.rawMaterial = _data["rawMaterial"] ? RawMaterial.fromJS(_data["rawMaterial"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.unitOperation = _data["unitOperation"] ? UnitOperation.fromJS(_data["unitOperation"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): RawMaterialEntry {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["unitId"] = this.unitId;
        data["materialId"] = this.materialId;
        data["unitOperationId"] = this.unitOperationId;
        data["dataQualityRatingId"] = this.dataQualityRatingId;
        data["quantity"] = this.quantity;
        data["notes"] = this.notes;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTmeStamp"] = this.updatedTmeStamp ? this.updatedTmeStamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["rawMaterialId"] = this.rawMaterialId;
        data["cas"] = this.cas;
        data["carbonFootprint"] = this.carbonFootprint;
        data["supplierName"] = this.supplierName;
        data["supplierLocation"] = this.supplierLocation;
        data["wasteStream"] = this.wasteStream;
        data["dataQualityScore"] = this.dataQualityScore;
        data["componentName"] = this.componentName;
        data["referenceQuantity"] = this.referenceQuantity;
        data["packagingTypeId"] = this.packagingTypeId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["dataQualityRating"] = this.dataQualityRating ? this.dataQualityRating.toJSON() : undefined as any;
        data["material"] = this.material ? this.material.toJSON() : undefined as any;
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        data["packagingType"] = this.packagingType ? this.packagingType.toJSON() : undefined as any;
        if (Array.isArray(this.processWasteDetail)) {
            data["processWasteDetail"] = [];
            for (let item of this.processWasteDetail)
                data["processWasteDetail"].push(item ? item.toJSON() : undefined as any);
        }
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["unitOperation"] = this.unitOperation ? this.unitOperation.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IRawMaterialEntry {
    id?: string;
    stepId?: string;
    unitId?: string;
    materialId?: string | undefined;
    unitOperationId?: string | undefined;
    dataQualityRatingId?: string | undefined;
    quantity?: number | undefined;
    notes?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTmeStamp?: Date | undefined;
    isActive?: boolean;
    rawMaterialId?: string | undefined;
    cas?: string | undefined;
    carbonFootprint?: number | undefined;
    supplierName?: string | undefined;
    supplierLocation?: string | undefined;
    wasteStream?: string | undefined;
    dataQualityScore?: string | undefined;
    componentName?: string | undefined;
    referenceQuantity?: number | undefined;
    packagingTypeId?: string | undefined;
    createdByPerson?: Person;
    dataQualityRating?: DataQualityRating;
    material?: Material;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    packagingType?: MasterDropdown;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    rawMaterial?: RawMaterial;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;
}

export class RawMaterialGlobalData implements IRawMaterialGlobalData {
    rawMaterial?: RawMaterial;
    unitOperations?: string[] | undefined;
    image?: string | undefined;
    rawMaterialTableRows?: RawMaterialTableRow[] | undefined;
    inboundTransportForMaterials?: InboundTransportForMaterials[] | undefined;
    globalUnitOperationId?: string | undefined;
    rawMaterialType?: string | undefined;

    constructor(data?: IRawMaterialGlobalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawMaterial = _data["rawMaterial"] ? RawMaterial.fromJS(_data["rawMaterial"]) : undefined as any;
            if (Array.isArray(_data["unitOperations"])) {
                this.unitOperations = [] as any;
                for (let item of _data["unitOperations"])
                    this.unitOperations!.push(item);
            }
            this.image = _data["image"];
            if (Array.isArray(_data["rawMaterialTableRows"])) {
                this.rawMaterialTableRows = [] as any;
                for (let item of _data["rawMaterialTableRows"])
                    this.rawMaterialTableRows!.push(RawMaterialTableRow.fromJS(item));
            }
            if (Array.isArray(_data["inboundTransportForMaterials"])) {
                this.inboundTransportForMaterials = [] as any;
                for (let item of _data["inboundTransportForMaterials"])
                    this.inboundTransportForMaterials!.push(InboundTransportForMaterials.fromJS(item));
            }
            this.globalUnitOperationId = _data["globalUnitOperationId"];
            this.rawMaterialType = _data["rawMaterialType"];
        }
    }

    static fromJS(data: any): RawMaterialGlobalData {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialGlobalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : undefined as any;
        if (Array.isArray(this.unitOperations)) {
            data["unitOperations"] = [];
            for (let item of this.unitOperations)
                data["unitOperations"].push(item);
        }
        data["image"] = this.image;
        if (Array.isArray(this.rawMaterialTableRows)) {
            data["rawMaterialTableRows"] = [];
            for (let item of this.rawMaterialTableRows)
                data["rawMaterialTableRows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inboundTransportForMaterials)) {
            data["inboundTransportForMaterials"] = [];
            for (let item of this.inboundTransportForMaterials)
                data["inboundTransportForMaterials"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalUnitOperationId"] = this.globalUnitOperationId;
        data["rawMaterialType"] = this.rawMaterialType;
        return data;
    }
}

export interface IRawMaterialGlobalData {
    rawMaterial?: RawMaterial;
    unitOperations?: string[] | undefined;
    image?: string | undefined;
    rawMaterialTableRows?: RawMaterialTableRow[] | undefined;
    inboundTransportForMaterials?: InboundTransportForMaterials[] | undefined;
    globalUnitOperationId?: string | undefined;
    rawMaterialType?: string | undefined;
}

export class RawMaterialSelectionRow implements IRawMaterialSelectionRow {
    id?: string;
    categoryName?: string | undefined;
    subCategoryName?: string | undefined;
    materialCategoryId?: string | undefined;
    materialSubCategoryId?: string | undefined;
    materialName?: string | undefined;
    materialId?: string | undefined;
    intermediateId?: string | undefined;
    stepNumber?: number | undefined;
    cas?: string | undefined;
    dataQualityRatingScore?: number | undefined;
    notes?: string | undefined;
    isAPIProxy?: boolean;
    apiProxyDetails?: APIProxyDetails;
    isProxy?: boolean | undefined;
    isActive?: boolean | undefined;
    isIntermediate?: boolean;
    climateChange?: number | undefined;
    weightPerPiece?: number | undefined;
    density?: number | undefined;

    constructor(data?: IRawMaterialSelectionRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryName = _data["categoryName"];
            this.subCategoryName = _data["subCategoryName"];
            this.materialCategoryId = _data["materialCategoryId"];
            this.materialSubCategoryId = _data["materialSubCategoryId"];
            this.materialName = _data["materialName"];
            this.materialId = _data["materialId"];
            this.intermediateId = _data["intermediateId"];
            this.stepNumber = _data["stepNumber"];
            this.cas = _data["cas"];
            this.dataQualityRatingScore = _data["dataQualityRatingScore"];
            this.notes = _data["notes"];
            this.isAPIProxy = _data["isAPIProxy"];
            this.apiProxyDetails = _data["apiProxyDetails"] ? APIProxyDetails.fromJS(_data["apiProxyDetails"]) : undefined as any;
            this.isProxy = _data["isProxy"];
            this.isActive = _data["isActive"];
            this.isIntermediate = _data["isIntermediate"];
            this.climateChange = _data["climateChange"];
            this.weightPerPiece = _data["weightPerPiece"];
            this.density = _data["density"];
        }
    }

    static fromJS(data: any): RawMaterialSelectionRow {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialSelectionRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryName"] = this.categoryName;
        data["subCategoryName"] = this.subCategoryName;
        data["materialCategoryId"] = this.materialCategoryId;
        data["materialSubCategoryId"] = this.materialSubCategoryId;
        data["materialName"] = this.materialName;
        data["materialId"] = this.materialId;
        data["intermediateId"] = this.intermediateId;
        data["stepNumber"] = this.stepNumber;
        data["cas"] = this.cas;
        data["dataQualityRatingScore"] = this.dataQualityRatingScore;
        data["notes"] = this.notes;
        data["isAPIProxy"] = this.isAPIProxy;
        data["apiProxyDetails"] = this.apiProxyDetails ? this.apiProxyDetails.toJSON() : undefined as any;
        data["isProxy"] = this.isProxy;
        data["isActive"] = this.isActive;
        data["isIntermediate"] = this.isIntermediate;
        data["climateChange"] = this.climateChange;
        data["weightPerPiece"] = this.weightPerPiece;
        data["density"] = this.density;
        return data;
    }
}

export interface IRawMaterialSelectionRow {
    id?: string;
    categoryName?: string | undefined;
    subCategoryName?: string | undefined;
    materialCategoryId?: string | undefined;
    materialSubCategoryId?: string | undefined;
    materialName?: string | undefined;
    materialId?: string | undefined;
    intermediateId?: string | undefined;
    stepNumber?: number | undefined;
    cas?: string | undefined;
    dataQualityRatingScore?: number | undefined;
    notes?: string | undefined;
    isAPIProxy?: boolean;
    apiProxyDetails?: APIProxyDetails;
    isProxy?: boolean | undefined;
    isActive?: boolean | undefined;
    isIntermediate?: boolean;
    climateChange?: number | undefined;
    weightPerPiece?: number | undefined;
    density?: number | undefined;
}

export class RawMaterialTableRow implements IRawMaterialTableRow {
    id?: string | undefined;
    rawMaterialId?: string | undefined;
    materialTypeId?: string | undefined;
    materialTypeName?: string | undefined;
    materialSubTypeId?: string | undefined;
    materialSubTypeName?: string | undefined;
    materials?: Material[] | undefined;
    materialId?: string | undefined;
    intermediateId?: string | undefined;
    materialName?: string | undefined;
    cas?: string | undefined;
    quantity?: number | undefined;
    unitId?: string | undefined;
    unitName?: string | undefined;
    unitOperationId?: string | undefined;
    dataQualityScore?: string | undefined;
    unitOperationName?: string | undefined;
    carbonFootprint?: number | undefined;
    dataQualityRatingId?: string | undefined;
    dataQualityRatingName?: string | undefined;
    supplierName?: string | undefined;
    supplierLocation?: string | undefined;
    isNew?: boolean | undefined;
    isIntermediate?: boolean | undefined;
    isAPIProxy?: boolean | undefined;
    apiProxyDetails?: APIProxyDetails;
    isProxy?: boolean | undefined;
    isSourceMaterialActive?: boolean | undefined;
    notes?: string | undefined;
    stepId?: string | undefined;
    assessmentId?: string | undefined;
    screenId?: string | undefined;
    componentName?: string | undefined;
    referenceQuantity?: number | undefined;
    packagingTypeId?: string | undefined;
    productProcessProxyId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    density?: number | undefined;
    generalInformationId?: string | undefined;

    constructor(data?: IRawMaterialTableRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rawMaterialId = _data["rawMaterialId"];
            this.materialTypeId = _data["materialTypeId"];
            this.materialTypeName = _data["materialTypeName"];
            this.materialSubTypeId = _data["materialSubTypeId"];
            this.materialSubTypeName = _data["materialSubTypeName"];
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(Material.fromJS(item));
            }
            this.materialId = _data["materialId"];
            this.intermediateId = _data["intermediateId"];
            this.materialName = _data["materialName"];
            this.cas = _data["cas"];
            this.quantity = _data["quantity"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            this.unitOperationId = _data["unitOperationId"];
            this.dataQualityScore = _data["dataQualityScore"];
            this.unitOperationName = _data["unitOperationName"];
            this.carbonFootprint = _data["carbonFootprint"];
            this.dataQualityRatingId = _data["dataQualityRatingId"];
            this.dataQualityRatingName = _data["dataQualityRatingName"];
            this.supplierName = _data["supplierName"];
            this.supplierLocation = _data["supplierLocation"];
            this.isNew = _data["isNew"];
            this.isIntermediate = _data["isIntermediate"];
            this.isAPIProxy = _data["isAPIProxy"];
            this.apiProxyDetails = _data["apiProxyDetails"] ? APIProxyDetails.fromJS(_data["apiProxyDetails"]) : undefined as any;
            this.isProxy = _data["isProxy"];
            this.isSourceMaterialActive = _data["isSourceMaterialActive"];
            this.notes = _data["notes"];
            this.stepId = _data["stepId"];
            this.assessmentId = _data["assessmentId"];
            this.screenId = _data["screenId"];
            this.componentName = _data["componentName"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.packagingTypeId = _data["packagingTypeId"];
            this.productProcessProxyId = _data["productProcessProxyId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.density = _data["density"];
            this.generalInformationId = _data["generalInformationId"];
        }
    }

    static fromJS(data: any): RawMaterialTableRow {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialTableRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rawMaterialId"] = this.rawMaterialId;
        data["materialTypeId"] = this.materialTypeId;
        data["materialTypeName"] = this.materialTypeName;
        data["materialSubTypeId"] = this.materialSubTypeId;
        data["materialSubTypeName"] = this.materialSubTypeName;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item ? item.toJSON() : undefined as any);
        }
        data["materialId"] = this.materialId;
        data["intermediateId"] = this.intermediateId;
        data["materialName"] = this.materialName;
        data["cas"] = this.cas;
        data["quantity"] = this.quantity;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        data["unitOperationId"] = this.unitOperationId;
        data["dataQualityScore"] = this.dataQualityScore;
        data["unitOperationName"] = this.unitOperationName;
        data["carbonFootprint"] = this.carbonFootprint;
        data["dataQualityRatingId"] = this.dataQualityRatingId;
        data["dataQualityRatingName"] = this.dataQualityRatingName;
        data["supplierName"] = this.supplierName;
        data["supplierLocation"] = this.supplierLocation;
        data["isNew"] = this.isNew;
        data["isIntermediate"] = this.isIntermediate;
        data["isAPIProxy"] = this.isAPIProxy;
        data["apiProxyDetails"] = this.apiProxyDetails ? this.apiProxyDetails.toJSON() : undefined as any;
        data["isProxy"] = this.isProxy;
        data["isSourceMaterialActive"] = this.isSourceMaterialActive;
        data["notes"] = this.notes;
        data["stepId"] = this.stepId;
        data["assessmentId"] = this.assessmentId;
        data["screenId"] = this.screenId;
        data["componentName"] = this.componentName;
        data["referenceQuantity"] = this.referenceQuantity;
        data["packagingTypeId"] = this.packagingTypeId;
        data["productProcessProxyId"] = this.productProcessProxyId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["density"] = this.density;
        data["generalInformationId"] = this.generalInformationId;
        return data;
    }
}

export interface IRawMaterialTableRow {
    id?: string | undefined;
    rawMaterialId?: string | undefined;
    materialTypeId?: string | undefined;
    materialTypeName?: string | undefined;
    materialSubTypeId?: string | undefined;
    materialSubTypeName?: string | undefined;
    materials?: Material[] | undefined;
    materialId?: string | undefined;
    intermediateId?: string | undefined;
    materialName?: string | undefined;
    cas?: string | undefined;
    quantity?: number | undefined;
    unitId?: string | undefined;
    unitName?: string | undefined;
    unitOperationId?: string | undefined;
    dataQualityScore?: string | undefined;
    unitOperationName?: string | undefined;
    carbonFootprint?: number | undefined;
    dataQualityRatingId?: string | undefined;
    dataQualityRatingName?: string | undefined;
    supplierName?: string | undefined;
    supplierLocation?: string | undefined;
    isNew?: boolean | undefined;
    isIntermediate?: boolean | undefined;
    isAPIProxy?: boolean | undefined;
    apiProxyDetails?: APIProxyDetails;
    isProxy?: boolean | undefined;
    isSourceMaterialActive?: boolean | undefined;
    notes?: string | undefined;
    stepId?: string | undefined;
    assessmentId?: string | undefined;
    screenId?: string | undefined;
    componentName?: string | undefined;
    referenceQuantity?: number | undefined;
    packagingTypeId?: string | undefined;
    productProcessProxyId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    density?: number | undefined;
    generalInformationId?: string | undefined;
}

export class RawMaterialUnitOperation implements IRawMaterialUnitOperation {
    id?: string;
    rawMaterialId?: string;
    unitOperationId?: string;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    unitId?: string | undefined;
    duration?: number | undefined;
    carbonFootprint?: number | undefined;
    isActive?: boolean | undefined;
    position?: number | undefined;
    createdByPerson?: Person;
    rawMaterial?: RawMaterial;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;

    constructor(data?: IRawMaterialUnitOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rawMaterialId = _data["rawMaterialId"];
            this.unitOperationId = _data["unitOperationId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.unitId = _data["unitId"];
            this.duration = _data["duration"];
            this.carbonFootprint = _data["carbonFootprint"];
            this.isActive = _data["isActive"];
            this.position = _data["position"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.rawMaterial = _data["rawMaterial"] ? RawMaterial.fromJS(_data["rawMaterial"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.unitOperation = _data["unitOperation"] ? UnitOperation.fromJS(_data["unitOperation"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): RawMaterialUnitOperation {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialUnitOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rawMaterialId"] = this.rawMaterialId;
        data["unitOperationId"] = this.unitOperationId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["unitId"] = this.unitId;
        data["duration"] = this.duration;
        data["carbonFootprint"] = this.carbonFootprint;
        data["isActive"] = this.isActive;
        data["position"] = this.position;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["unitOperation"] = this.unitOperation ? this.unitOperation.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IRawMaterialUnitOperation {
    id?: string;
    rawMaterialId?: string;
    unitOperationId?: string;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    unitId?: string | undefined;
    duration?: number | undefined;
    carbonFootprint?: number | undefined;
    isActive?: boolean | undefined;
    position?: number | undefined;
    createdByPerson?: Person;
    rawMaterial?: RawMaterial;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;
}

export class RawMaterialVersion implements IRawMaterialVersion {
    id?: number;
    rawMaterialVersionName?: string | undefined;
    isActive?: boolean;
    createdDateTime?: Date;
    createdByPerson?: string;

    constructor(data?: IRawMaterialVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rawMaterialVersionName = _data["rawMaterialVersionName"];
            this.isActive = _data["isActive"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"];
        }
    }

    static fromJS(data: any): RawMaterialVersion {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rawMaterialVersionName"] = this.rawMaterialVersionName;
        data["isActive"] = this.isActive;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson;
        return data;
    }
}

export interface IRawMaterialVersion {
    id?: number;
    rawMaterialVersionName?: string | undefined;
    isActive?: boolean;
    createdDateTime?: Date;
    createdByPerson?: string;
}

export class RawMaterialsEolEF implements IRawMaterialsEolEF {
    id?: string;
    isMaterialInEditing?: boolean;
    isEolInEditing?: boolean;
    material?: Material;
    skillAreas?: Screen[] | undefined;
    availableSkillAreas?: Screen[] | undefined;

    constructor(data?: IRawMaterialsEolEF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isMaterialInEditing = _data["isMaterialInEditing"];
            this.isEolInEditing = _data["isEolInEditing"];
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : undefined as any;
            if (Array.isArray(_data["skillAreas"])) {
                this.skillAreas = [] as any;
                for (let item of _data["skillAreas"])
                    this.skillAreas!.push(Screen.fromJS(item));
            }
            if (Array.isArray(_data["availableSkillAreas"])) {
                this.availableSkillAreas = [] as any;
                for (let item of _data["availableSkillAreas"])
                    this.availableSkillAreas!.push(Screen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawMaterialsEolEF {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialsEolEF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isMaterialInEditing"] = this.isMaterialInEditing;
        data["isEolInEditing"] = this.isEolInEditing;
        data["material"] = this.material ? this.material.toJSON() : undefined as any;
        if (Array.isArray(this.skillAreas)) {
            data["skillAreas"] = [];
            for (let item of this.skillAreas)
                data["skillAreas"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.availableSkillAreas)) {
            data["availableSkillAreas"] = [];
            for (let item of this.availableSkillAreas)
                data["availableSkillAreas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRawMaterialsEolEF {
    id?: string;
    isMaterialInEditing?: boolean;
    isEolInEditing?: boolean;
    material?: Material;
    skillAreas?: Screen[] | undefined;
    availableSkillAreas?: Screen[] | undefined;
}

export class RawMaterialsRelatedDropdowns implements IRawMaterialsRelatedDropdowns {
    unitsDistance?: Unit[] | undefined;
    unitsWeight?: Unit[] | undefined;
    unitsConsumable?: Unit[] | undefined;
    unitsVolume?: Unit[] | undefined;
    locations?: SiteLocation[] | undefined;
    unitOperations?: UnitOperation[] | undefined;
    qualityRatings?: DataQualityRating[] | undefined;
    materialTypes?: MaterialType[] | undefined;
    materialSubType?: MaterialSubType[] | undefined;
    materials?: Material[] | undefined;
    transportModes?: TransportMode[] | undefined;
    transports?: Transport[] | undefined;
    packagingTypes?: MasterDropdown[] | undefined;

    constructor(data?: IRawMaterialsRelatedDropdowns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["unitsDistance"])) {
                this.unitsDistance = [] as any;
                for (let item of _data["unitsDistance"])
                    this.unitsDistance!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["unitsWeight"])) {
                this.unitsWeight = [] as any;
                for (let item of _data["unitsWeight"])
                    this.unitsWeight!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["unitsConsumable"])) {
                this.unitsConsumable = [] as any;
                for (let item of _data["unitsConsumable"])
                    this.unitsConsumable!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["unitsVolume"])) {
                this.unitsVolume = [] as any;
                for (let item of _data["unitsVolume"])
                    this.unitsVolume!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(SiteLocation.fromJS(item));
            }
            if (Array.isArray(_data["unitOperations"])) {
                this.unitOperations = [] as any;
                for (let item of _data["unitOperations"])
                    this.unitOperations!.push(UnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["qualityRatings"])) {
                this.qualityRatings = [] as any;
                for (let item of _data["qualityRatings"])
                    this.qualityRatings!.push(DataQualityRating.fromJS(item));
            }
            if (Array.isArray(_data["materialTypes"])) {
                this.materialTypes = [] as any;
                for (let item of _data["materialTypes"])
                    this.materialTypes!.push(MaterialType.fromJS(item));
            }
            if (Array.isArray(_data["materialSubType"])) {
                this.materialSubType = [] as any;
                for (let item of _data["materialSubType"])
                    this.materialSubType!.push(MaterialSubType.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(Material.fromJS(item));
            }
            if (Array.isArray(_data["transportModes"])) {
                this.transportModes = [] as any;
                for (let item of _data["transportModes"])
                    this.transportModes!.push(TransportMode.fromJS(item));
            }
            if (Array.isArray(_data["transports"])) {
                this.transports = [] as any;
                for (let item of _data["transports"])
                    this.transports!.push(Transport.fromJS(item));
            }
            if (Array.isArray(_data["packagingTypes"])) {
                this.packagingTypes = [] as any;
                for (let item of _data["packagingTypes"])
                    this.packagingTypes!.push(MasterDropdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawMaterialsRelatedDropdowns {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialsRelatedDropdowns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unitsDistance)) {
            data["unitsDistance"] = [];
            for (let item of this.unitsDistance)
                data["unitsDistance"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitsWeight)) {
            data["unitsWeight"] = [];
            for (let item of this.unitsWeight)
                data["unitsWeight"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitsConsumable)) {
            data["unitsConsumable"] = [];
            for (let item of this.unitsConsumable)
                data["unitsConsumable"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitsVolume)) {
            data["unitsVolume"] = [];
            for (let item of this.unitsVolume)
                data["unitsVolume"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperations)) {
            data["unitOperations"] = [];
            for (let item of this.unitOperations)
                data["unitOperations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.qualityRatings)) {
            data["qualityRatings"] = [];
            for (let item of this.qualityRatings)
                data["qualityRatings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialTypes)) {
            data["materialTypes"] = [];
            for (let item of this.materialTypes)
                data["materialTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialSubType)) {
            data["materialSubType"] = [];
            for (let item of this.materialSubType)
                data["materialSubType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportModes)) {
            data["transportModes"] = [];
            for (let item of this.transportModes)
                data["transportModes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transports)) {
            data["transports"] = [];
            for (let item of this.transports)
                data["transports"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.packagingTypes)) {
            data["packagingTypes"] = [];
            for (let item of this.packagingTypes)
                data["packagingTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRawMaterialsRelatedDropdowns {
    unitsDistance?: Unit[] | undefined;
    unitsWeight?: Unit[] | undefined;
    unitsConsumable?: Unit[] | undefined;
    unitsVolume?: Unit[] | undefined;
    locations?: SiteLocation[] | undefined;
    unitOperations?: UnitOperation[] | undefined;
    qualityRatings?: DataQualityRating[] | undefined;
    materialTypes?: MaterialType[] | undefined;
    materialSubType?: MaterialSubType[] | undefined;
    materials?: Material[] | undefined;
    transportModes?: TransportMode[] | undefined;
    transports?: Transport[] | undefined;
    packagingTypes?: MasterDropdown[] | undefined;
}

export class RawMaterialsRelatedDropdownsComplete implements IRawMaterialsRelatedDropdownsComplete {
    unitsDistance?: Unit[] | undefined;
    unitsWeight?: Unit[] | undefined;
    unitsConsumable?: Unit[] | undefined;
    unitsVolume?: Unit[] | undefined;
    locations?: SiteLocation[] | undefined;
    unitOperations?: UnitOperation[] | undefined;
    qualityRatings?: DataQualityRating[] | undefined;
    transportModes?: TransportMode[] | undefined;
    transports?: Transport[] | undefined;
    rawMaterialSelectionRow?: RawMaterialSelectionRow[] | undefined;
    packagingTypes?: MasterDropdown[] | undefined;

    constructor(data?: IRawMaterialsRelatedDropdownsComplete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["unitsDistance"])) {
                this.unitsDistance = [] as any;
                for (let item of _data["unitsDistance"])
                    this.unitsDistance!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["unitsWeight"])) {
                this.unitsWeight = [] as any;
                for (let item of _data["unitsWeight"])
                    this.unitsWeight!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["unitsConsumable"])) {
                this.unitsConsumable = [] as any;
                for (let item of _data["unitsConsumable"])
                    this.unitsConsumable!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["unitsVolume"])) {
                this.unitsVolume = [] as any;
                for (let item of _data["unitsVolume"])
                    this.unitsVolume!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(SiteLocation.fromJS(item));
            }
            if (Array.isArray(_data["unitOperations"])) {
                this.unitOperations = [] as any;
                for (let item of _data["unitOperations"])
                    this.unitOperations!.push(UnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["qualityRatings"])) {
                this.qualityRatings = [] as any;
                for (let item of _data["qualityRatings"])
                    this.qualityRatings!.push(DataQualityRating.fromJS(item));
            }
            if (Array.isArray(_data["transportModes"])) {
                this.transportModes = [] as any;
                for (let item of _data["transportModes"])
                    this.transportModes!.push(TransportMode.fromJS(item));
            }
            if (Array.isArray(_data["transports"])) {
                this.transports = [] as any;
                for (let item of _data["transports"])
                    this.transports!.push(Transport.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialSelectionRow"])) {
                this.rawMaterialSelectionRow = [] as any;
                for (let item of _data["rawMaterialSelectionRow"])
                    this.rawMaterialSelectionRow!.push(RawMaterialSelectionRow.fromJS(item));
            }
            if (Array.isArray(_data["packagingTypes"])) {
                this.packagingTypes = [] as any;
                for (let item of _data["packagingTypes"])
                    this.packagingTypes!.push(MasterDropdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawMaterialsRelatedDropdownsComplete {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialsRelatedDropdownsComplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unitsDistance)) {
            data["unitsDistance"] = [];
            for (let item of this.unitsDistance)
                data["unitsDistance"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitsWeight)) {
            data["unitsWeight"] = [];
            for (let item of this.unitsWeight)
                data["unitsWeight"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitsConsumable)) {
            data["unitsConsumable"] = [];
            for (let item of this.unitsConsumable)
                data["unitsConsumable"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitsVolume)) {
            data["unitsVolume"] = [];
            for (let item of this.unitsVolume)
                data["unitsVolume"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperations)) {
            data["unitOperations"] = [];
            for (let item of this.unitOperations)
                data["unitOperations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.qualityRatings)) {
            data["qualityRatings"] = [];
            for (let item of this.qualityRatings)
                data["qualityRatings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportModes)) {
            data["transportModes"] = [];
            for (let item of this.transportModes)
                data["transportModes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transports)) {
            data["transports"] = [];
            for (let item of this.transports)
                data["transports"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialSelectionRow)) {
            data["rawMaterialSelectionRow"] = [];
            for (let item of this.rawMaterialSelectionRow)
                data["rawMaterialSelectionRow"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.packagingTypes)) {
            data["packagingTypes"] = [];
            for (let item of this.packagingTypes)
                data["packagingTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRawMaterialsRelatedDropdownsComplete {
    unitsDistance?: Unit[] | undefined;
    unitsWeight?: Unit[] | undefined;
    unitsConsumable?: Unit[] | undefined;
    unitsVolume?: Unit[] | undefined;
    locations?: SiteLocation[] | undefined;
    unitOperations?: UnitOperation[] | undefined;
    qualityRatings?: DataQualityRating[] | undefined;
    transportModes?: TransportMode[] | undefined;
    transports?: Transport[] | undefined;
    rawMaterialSelectionRow?: RawMaterialSelectionRow[] | undefined;
    packagingTypes?: MasterDropdown[] | undefined;
}

export class ReferenceTable implements IReferenceTable {
    id?: string;
    tableName?: string | undefined;
    displayName?: string | undefined;
    displayColumn?: string | undefined;
    valueColumn?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    configurationVariable?: ConfigurationVariable[] | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;

    constructor(data?: IReferenceTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tableName = _data["tableName"];
            this.displayName = _data["displayName"];
            this.displayColumn = _data["displayColumn"];
            this.valueColumn = _data["valueColumn"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            if (Array.isArray(_data["configurationVariable"])) {
                this.configurationVariable = [] as any;
                for (let item of _data["configurationVariable"])
                    this.configurationVariable!.push(ConfigurationVariable.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReferenceTable {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tableName"] = this.tableName;
        data["displayName"] = this.displayName;
        data["displayColumn"] = this.displayColumn;
        data["valueColumn"] = this.valueColumn;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        if (Array.isArray(this.configurationVariable)) {
            data["configurationVariable"] = [];
            for (let item of this.configurationVariable)
                data["configurationVariable"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IReferenceTable {
    id?: string;
    tableName?: string | undefined;
    displayName?: string | undefined;
    displayColumn?: string | undefined;
    valueColumn?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    configurationVariable?: ConfigurationVariable[] | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;
}

export class RelatableUnit implements IRelatableUnit {
    id?: string;
    emissionFactorId?: string;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    updatedByPerson?: Person;

    constructor(data?: IRelatableUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.referenceActivity = _data["referenceActivity"];
            this.referenceQuantity = _data["referenceQuantity"];
            this.referenceUnitLabel = _data["referenceUnitLabel"];
            this.iconName = _data["iconName"];
            this.thresholdLow = _data["thresholdLow"];
            this.thresholdHigh = _data["thresholdHigh"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.emissionFactor = _data["emissionFactor"] ? EmissionFactors.fromJS(_data["emissionFactor"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): RelatableUnit {
        data = typeof data === 'object' ? data : {};
        let result = new RelatableUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emissionFactorId"] = this.emissionFactorId;
        data["referenceActivity"] = this.referenceActivity;
        data["referenceQuantity"] = this.referenceQuantity;
        data["referenceUnitLabel"] = this.referenceUnitLabel;
        data["iconName"] = this.iconName;
        data["thresholdLow"] = this.thresholdLow;
        data["thresholdHigh"] = this.thresholdHigh;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["emissionFactor"] = this.emissionFactor ? this.emissionFactor.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IRelatableUnit {
    id?: string;
    emissionFactorId?: string;
    referenceActivity?: string | undefined;
    referenceQuantity?: number;
    referenceUnitLabel?: string | undefined;
    iconName?: string | undefined;
    thresholdLow?: number | undefined;
    thresholdHigh?: number | undefined;
    sortOrder?: number;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    updatedByPerson?: Person;
}

export class ReportAlternative implements IReportAlternative {
    id?: string;
    reportConfigurationId?: string;
    packagingGIId?: string | undefined;
    distributionGIId?: string | undefined;
    amount?: number | undefined;
    scaling?: string | undefined;
    sortOrder?: number;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    distributionGI?: GeneralInformation;
    packagingGI?: GeneralInformation;
    reportConfiguration?: ReportConfiguration;
    updatedByPerson?: Person;

    constructor(data?: IReportAlternative) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportConfigurationId = _data["reportConfigurationId"];
            this.packagingGIId = _data["packagingGIId"];
            this.distributionGIId = _data["distributionGIId"];
            this.amount = _data["amount"];
            this.scaling = _data["scaling"];
            this.sortOrder = _data["sortOrder"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.distributionGI = _data["distributionGI"] ? GeneralInformation.fromJS(_data["distributionGI"]) : undefined as any;
            this.packagingGI = _data["packagingGI"] ? GeneralInformation.fromJS(_data["packagingGI"]) : undefined as any;
            this.reportConfiguration = _data["reportConfiguration"] ? ReportConfiguration.fromJS(_data["reportConfiguration"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReportAlternative {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAlternative();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportConfigurationId"] = this.reportConfigurationId;
        data["packagingGIId"] = this.packagingGIId;
        data["distributionGIId"] = this.distributionGIId;
        data["amount"] = this.amount;
        data["scaling"] = this.scaling;
        data["sortOrder"] = this.sortOrder;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["distributionGI"] = this.distributionGI ? this.distributionGI.toJSON() : undefined as any;
        data["packagingGI"] = this.packagingGI ? this.packagingGI.toJSON() : undefined as any;
        data["reportConfiguration"] = this.reportConfiguration ? this.reportConfiguration.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IReportAlternative {
    id?: string;
    reportConfigurationId?: string;
    packagingGIId?: string | undefined;
    distributionGIId?: string | undefined;
    amount?: number | undefined;
    scaling?: string | undefined;
    sortOrder?: number;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    distributionGI?: GeneralInformation;
    packagingGI?: GeneralInformation;
    reportConfiguration?: ReportConfiguration;
    updatedByPerson?: Person;
}

export class ReportConfiguration implements IReportConfiguration {
    id?: string;
    assessmentId?: string;
    description?: string | undefined;
    baselinePackagingGIId?: string | undefined;
    baselineDistributionGIId?: string | undefined;
    baselineAmount?: number | undefined;
    baselineScaling?: string | undefined;
    reductionFocus?: string | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    assessment?: Assessment;
    baselineDistributionGI?: GeneralInformation;
    baselinePackagingGI?: GeneralInformation;
    createdByPerson?: Person;
    reportAlternative?: ReportAlternative[] | undefined;
    reportSelectedIndicator?: ReportSelectedIndicator[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IReportConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentId = _data["assessmentId"];
            this.description = _data["description"];
            this.baselinePackagingGIId = _data["baselinePackagingGIId"];
            this.baselineDistributionGIId = _data["baselineDistributionGIId"];
            this.baselineAmount = _data["baselineAmount"];
            this.baselineScaling = _data["baselineScaling"];
            this.reductionFocus = _data["reductionFocus"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.baselineDistributionGI = _data["baselineDistributionGI"] ? GeneralInformation.fromJS(_data["baselineDistributionGI"]) : undefined as any;
            this.baselinePackagingGI = _data["baselinePackagingGI"] ? GeneralInformation.fromJS(_data["baselinePackagingGI"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["reportAlternative"])) {
                this.reportAlternative = [] as any;
                for (let item of _data["reportAlternative"])
                    this.reportAlternative!.push(ReportAlternative.fromJS(item));
            }
            if (Array.isArray(_data["reportSelectedIndicator"])) {
                this.reportSelectedIndicator = [] as any;
                for (let item of _data["reportSelectedIndicator"])
                    this.reportSelectedIndicator!.push(ReportSelectedIndicator.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReportConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ReportConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentId"] = this.assessmentId;
        data["description"] = this.description;
        data["baselinePackagingGIId"] = this.baselinePackagingGIId;
        data["baselineDistributionGIId"] = this.baselineDistributionGIId;
        data["baselineAmount"] = this.baselineAmount;
        data["baselineScaling"] = this.baselineScaling;
        data["reductionFocus"] = this.reductionFocus;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["baselineDistributionGI"] = this.baselineDistributionGI ? this.baselineDistributionGI.toJSON() : undefined as any;
        data["baselinePackagingGI"] = this.baselinePackagingGI ? this.baselinePackagingGI.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.reportAlternative)) {
            data["reportAlternative"] = [];
            for (let item of this.reportAlternative)
                data["reportAlternative"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportSelectedIndicator)) {
            data["reportSelectedIndicator"] = [];
            for (let item of this.reportSelectedIndicator)
                data["reportSelectedIndicator"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IReportConfiguration {
    id?: string;
    assessmentId?: string;
    description?: string | undefined;
    baselinePackagingGIId?: string | undefined;
    baselineDistributionGIId?: string | undefined;
    baselineAmount?: number | undefined;
    baselineScaling?: string | undefined;
    reductionFocus?: string | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    assessment?: Assessment;
    baselineDistributionGI?: GeneralInformation;
    baselinePackagingGI?: GeneralInformation;
    createdByPerson?: Person;
    reportAlternative?: ReportAlternative[] | undefined;
    reportSelectedIndicator?: ReportSelectedIndicator[] | undefined;
    updatedByPerson?: Person;
}

export class ReportSelectedIndicator implements IReportSelectedIndicator {
    id?: string;
    reportConfigurationId?: string;
    emissionFactorId?: string;
    emissionFactor?: EmissionFactors;
    reportConfiguration?: ReportConfiguration;

    constructor(data?: IReportSelectedIndicator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportConfigurationId = _data["reportConfigurationId"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.emissionFactor = _data["emissionFactor"] ? EmissionFactors.fromJS(_data["emissionFactor"]) : undefined as any;
            this.reportConfiguration = _data["reportConfiguration"] ? ReportConfiguration.fromJS(_data["reportConfiguration"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReportSelectedIndicator {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectedIndicator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportConfigurationId"] = this.reportConfigurationId;
        data["emissionFactorId"] = this.emissionFactorId;
        data["emissionFactor"] = this.emissionFactor ? this.emissionFactor.toJSON() : undefined as any;
        data["reportConfiguration"] = this.reportConfiguration ? this.reportConfiguration.toJSON() : undefined as any;
        return data;
    }
}

export interface IReportSelectedIndicator {
    id?: string;
    reportConfigurationId?: string;
    emissionFactorId?: string;
    emissionFactor?: EmissionFactors;
    reportConfiguration?: ReportConfiguration;
}

export class Screen implements IScreen {
    id?: string;
    screenName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    isClient?: boolean | undefined;
    tabPosition?: number | undefined;
    subTabGroupName?: string | undefined;
    icon?: string | undefined;
    materialSubTypeId?: string | undefined;
    createdByPerson?: Person;
    energyMultipliersmoduleScreen?: EnergyMultipliers[] | undefined;
    energyMultipliersproductFormatSourceScreen?: EnergyMultipliers[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    materialScreen?: MaterialScreen[] | undefined;
    materialSubType?: MaterialSubType[] | undefined;
    materialSubTypeNavigation?: MaterialSubType;
    materialTypeScreen?: MaterialTypeScreen[] | undefined;
    processWaste?: ProcessWaste[] | undefined;
    productFormat?: ProductFormat[] | undefined;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    screenTabs?: ScreenTabs[] | undefined;
    step?: Step[] | undefined;
    subProjectDefaultScreen?: SubProjectDefaultScreen[] | undefined;
    unitOperation?: UnitOperation[] | undefined;
    updatedByPerson?: Person;
    userTypeScreen?: UserTypeScreen[] | undefined;
    wasteDisposalRoute?: WasteDisposalRoute[] | undefined;

    constructor(data?: IScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.screenName = _data["screenName"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.isClient = _data["isClient"];
            this.tabPosition = _data["tabPosition"];
            this.subTabGroupName = _data["subTabGroupName"];
            this.icon = _data["icon"];
            this.materialSubTypeId = _data["materialSubTypeId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["energyMultipliersmoduleScreen"])) {
                this.energyMultipliersmoduleScreen = [] as any;
                for (let item of _data["energyMultipliersmoduleScreen"])
                    this.energyMultipliersmoduleScreen!.push(EnergyMultipliers.fromJS(item));
            }
            if (Array.isArray(_data["energyMultipliersproductFormatSourceScreen"])) {
                this.energyMultipliersproductFormatSourceScreen = [] as any;
                for (let item of _data["energyMultipliersproductFormatSourceScreen"])
                    this.energyMultipliersproductFormatSourceScreen!.push(EnergyMultipliers.fromJS(item));
            }
            if (Array.isArray(_data["generalInformation"])) {
                this.generalInformation = [] as any;
                for (let item of _data["generalInformation"])
                    this.generalInformation!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["materialScreen"])) {
                this.materialScreen = [] as any;
                for (let item of _data["materialScreen"])
                    this.materialScreen!.push(MaterialScreen.fromJS(item));
            }
            if (Array.isArray(_data["materialSubType"])) {
                this.materialSubType = [] as any;
                for (let item of _data["materialSubType"])
                    this.materialSubType!.push(MaterialSubType.fromJS(item));
            }
            this.materialSubTypeNavigation = _data["materialSubTypeNavigation"] ? MaterialSubType.fromJS(_data["materialSubTypeNavigation"]) : undefined as any;
            if (Array.isArray(_data["materialTypeScreen"])) {
                this.materialTypeScreen = [] as any;
                for (let item of _data["materialTypeScreen"])
                    this.materialTypeScreen!.push(MaterialTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["processWaste"])) {
                this.processWaste = [] as any;
                for (let item of _data["processWaste"])
                    this.processWaste!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["productFormat"])) {
                this.productFormat = [] as any;
                for (let item of _data["productFormat"])
                    this.productFormat!.push(ProductFormat.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxy"])) {
                this.productProcessProxy = [] as any;
                for (let item of _data["productProcessProxy"])
                    this.productProcessProxy!.push(ProductProcessProxy.fromJS(item));
            }
            if (Array.isArray(_data["screenTabs"])) {
                this.screenTabs = [] as any;
                for (let item of _data["screenTabs"])
                    this.screenTabs!.push(ScreenTabs.fromJS(item));
            }
            if (Array.isArray(_data["step"])) {
                this.step = [] as any;
                for (let item of _data["step"])
                    this.step!.push(Step.fromJS(item));
            }
            if (Array.isArray(_data["subProjectDefaultScreen"])) {
                this.subProjectDefaultScreen = [] as any;
                for (let item of _data["subProjectDefaultScreen"])
                    this.subProjectDefaultScreen!.push(SubProjectDefaultScreen.fromJS(item));
            }
            if (Array.isArray(_data["unitOperation"])) {
                this.unitOperation = [] as any;
                for (let item of _data["unitOperation"])
                    this.unitOperation!.push(UnitOperation.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["userTypeScreen"])) {
                this.userTypeScreen = [] as any;
                for (let item of _data["userTypeScreen"])
                    this.userTypeScreen!.push(UserTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["wasteDisposalRoute"])) {
                this.wasteDisposalRoute = [] as any;
                for (let item of _data["wasteDisposalRoute"])
                    this.wasteDisposalRoute!.push(WasteDisposalRoute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Screen {
        data = typeof data === 'object' ? data : {};
        let result = new Screen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["screenName"] = this.screenName;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["isClient"] = this.isClient;
        data["tabPosition"] = this.tabPosition;
        data["subTabGroupName"] = this.subTabGroupName;
        data["icon"] = this.icon;
        data["materialSubTypeId"] = this.materialSubTypeId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.energyMultipliersmoduleScreen)) {
            data["energyMultipliersmoduleScreen"] = [];
            for (let item of this.energyMultipliersmoduleScreen)
                data["energyMultipliersmoduleScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyMultipliersproductFormatSourceScreen)) {
            data["energyMultipliersproductFormatSourceScreen"] = [];
            for (let item of this.energyMultipliersproductFormatSourceScreen)
                data["energyMultipliersproductFormatSourceScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformation)) {
            data["generalInformation"] = [];
            for (let item of this.generalInformation)
                data["generalInformation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialScreen)) {
            data["materialScreen"] = [];
            for (let item of this.materialScreen)
                data["materialScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialSubType)) {
            data["materialSubType"] = [];
            for (let item of this.materialSubType)
                data["materialSubType"].push(item ? item.toJSON() : undefined as any);
        }
        data["materialSubTypeNavigation"] = this.materialSubTypeNavigation ? this.materialSubTypeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.materialTypeScreen)) {
            data["materialTypeScreen"] = [];
            for (let item of this.materialTypeScreen)
                data["materialTypeScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWaste)) {
            data["processWaste"] = [];
            for (let item of this.processWaste)
                data["processWaste"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productFormat)) {
            data["productFormat"] = [];
            for (let item of this.productFormat)
                data["productFormat"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxy)) {
            data["productProcessProxy"] = [];
            for (let item of this.productProcessProxy)
                data["productProcessProxy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenTabs)) {
            data["screenTabs"] = [];
            for (let item of this.screenTabs)
                data["screenTabs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.step)) {
            data["step"] = [];
            for (let item of this.step)
                data["step"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectDefaultScreen)) {
            data["subProjectDefaultScreen"] = [];
            for (let item of this.subProjectDefaultScreen)
                data["subProjectDefaultScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperation)) {
            data["unitOperation"] = [];
            for (let item of this.unitOperation)
                data["unitOperation"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.userTypeScreen)) {
            data["userTypeScreen"] = [];
            for (let item of this.userTypeScreen)
                data["userTypeScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wasteDisposalRoute)) {
            data["wasteDisposalRoute"] = [];
            for (let item of this.wasteDisposalRoute)
                data["wasteDisposalRoute"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScreen {
    id?: string;
    screenName?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    isClient?: boolean | undefined;
    tabPosition?: number | undefined;
    subTabGroupName?: string | undefined;
    icon?: string | undefined;
    materialSubTypeId?: string | undefined;
    createdByPerson?: Person;
    energyMultipliersmoduleScreen?: EnergyMultipliers[] | undefined;
    energyMultipliersproductFormatSourceScreen?: EnergyMultipliers[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    materialScreen?: MaterialScreen[] | undefined;
    materialSubType?: MaterialSubType[] | undefined;
    materialSubTypeNavigation?: MaterialSubType;
    materialTypeScreen?: MaterialTypeScreen[] | undefined;
    processWaste?: ProcessWaste[] | undefined;
    productFormat?: ProductFormat[] | undefined;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    screenTabs?: ScreenTabs[] | undefined;
    step?: Step[] | undefined;
    subProjectDefaultScreen?: SubProjectDefaultScreen[] | undefined;
    unitOperation?: UnitOperation[] | undefined;
    updatedByPerson?: Person;
    userTypeScreen?: UserTypeScreen[] | undefined;
    wasteDisposalRoute?: WasteDisposalRoute[] | undefined;
}

export class ScreenTabs implements IScreenTabs {
    id?: string;
    screenId?: string;
    tabPositon?: number;
    subTabGroupName?: string | undefined;
    isActive?: boolean;
    screen?: Screen;

    constructor(data?: IScreenTabs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.screenId = _data["screenId"];
            this.tabPositon = _data["tabPositon"];
            this.subTabGroupName = _data["subTabGroupName"];
            this.isActive = _data["isActive"];
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScreenTabs {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenTabs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["screenId"] = this.screenId;
        data["tabPositon"] = this.tabPositon;
        data["subTabGroupName"] = this.subTabGroupName;
        data["isActive"] = this.isActive;
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        return data;
    }
}

export interface IScreenTabs {
    id?: string;
    screenId?: string;
    tabPositon?: number;
    subTabGroupName?: string | undefined;
    isActive?: boolean;
    screen?: Screen;
}

export class SingleData implements ISingleData {
    assessmentId?: string | undefined;
    projectName?: string | undefined;
    subProjectName?: string | undefined;
    assessmentName?: string | undefined;
    modifiedDate?: Date | undefined;

    constructor(data?: ISingleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.projectName = _data["projectName"];
            this.subProjectName = _data["subProjectName"];
            this.assessmentName = _data["assessmentName"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SingleData {
        data = typeof data === 'object' ? data : {};
        let result = new SingleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["projectName"] = this.projectName;
        data["subProjectName"] = this.subProjectName;
        data["assessmentName"] = this.assessmentName;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISingleData {
    assessmentId?: string | undefined;
    projectName?: string | undefined;
    subProjectName?: string | undefined;
    assessmentName?: string | undefined;
    modifiedDate?: Date | undefined;
}

export class SingleMaterialInboundTransport implements ISingleMaterialInboundTransport {
    materialId?: string | undefined;
    stepId?: string | undefined;
    materialName?: string | undefined;
    isIntermediate?: boolean | undefined;
    isAPIProxy?: boolean | undefined;
    numOfInbound?: number;
    intermediateStepId?: string | undefined;
    productProcessProxyId?: string | undefined;
    materialRowId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    allTransportsForMaterial?: InboundTransportForMaterials[] | undefined;

    constructor(data?: ISingleMaterialInboundTransport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialId = _data["materialId"];
            this.stepId = _data["stepId"];
            this.materialName = _data["materialName"];
            this.isIntermediate = _data["isIntermediate"];
            this.isAPIProxy = _data["isAPIProxy"];
            this.numOfInbound = _data["numOfInbound"];
            this.intermediateStepId = _data["intermediateStepId"];
            this.productProcessProxyId = _data["productProcessProxyId"];
            this.materialRowId = _data["materialRowId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            if (Array.isArray(_data["allTransportsForMaterial"])) {
                this.allTransportsForMaterial = [] as any;
                for (let item of _data["allTransportsForMaterial"])
                    this.allTransportsForMaterial!.push(InboundTransportForMaterials.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SingleMaterialInboundTransport {
        data = typeof data === 'object' ? data : {};
        let result = new SingleMaterialInboundTransport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["stepId"] = this.stepId;
        data["materialName"] = this.materialName;
        data["isIntermediate"] = this.isIntermediate;
        data["isAPIProxy"] = this.isAPIProxy;
        data["numOfInbound"] = this.numOfInbound;
        data["intermediateStepId"] = this.intermediateStepId;
        data["productProcessProxyId"] = this.productProcessProxyId;
        data["materialRowId"] = this.materialRowId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        if (Array.isArray(this.allTransportsForMaterial)) {
            data["allTransportsForMaterial"] = [];
            for (let item of this.allTransportsForMaterial)
                data["allTransportsForMaterial"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISingleMaterialInboundTransport {
    materialId?: string | undefined;
    stepId?: string | undefined;
    materialName?: string | undefined;
    isIntermediate?: boolean | undefined;
    isAPIProxy?: boolean | undefined;
    numOfInbound?: number;
    intermediateStepId?: string | undefined;
    productProcessProxyId?: string | undefined;
    materialRowId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    allTransportsForMaterial?: InboundTransportForMaterials[] | undefined;
}

export class SiteLocation implements ISiteLocation {
    id?: string;
    siteLocationName?: string | undefined;
    onTopList?: boolean;
    isActive?: boolean;
    downstreamDistribution?: DownstreamDistribution[] | undefined;
    energyEF?: EnergyEF[] | undefined;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    rawMaterial?: RawMaterial[] | undefined;
    step?: Step[] | undefined;

    constructor(data?: ISiteLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteLocationName = _data["siteLocationName"];
            this.onTopList = _data["onTopList"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["downstreamDistribution"])) {
                this.downstreamDistribution = [] as any;
                for (let item of _data["downstreamDistribution"])
                    this.downstreamDistribution!.push(DownstreamDistribution.fromJS(item));
            }
            if (Array.isArray(_data["energyEF"])) {
                this.energyEF = [] as any;
                for (let item of _data["energyEF"])
                    this.energyEF!.push(EnergyEF.fromJS(item));
            }
            if (Array.isArray(_data["energyEmissionFactor"])) {
                this.energyEmissionFactor = [] as any;
                for (let item of _data["energyEmissionFactor"])
                    this.energyEmissionFactor!.push(EnergyEmissionFactor.fromJS(item));
            }
            if (Array.isArray(_data["generalInformation"])) {
                this.generalInformation = [] as any;
                for (let item of _data["generalInformation"])
                    this.generalInformation!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterial"])) {
                this.rawMaterial = [] as any;
                for (let item of _data["rawMaterial"])
                    this.rawMaterial!.push(RawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["step"])) {
                this.step = [] as any;
                for (let item of _data["step"])
                    this.step!.push(Step.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SiteLocation {
        data = typeof data === 'object' ? data : {};
        let result = new SiteLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteLocationName"] = this.siteLocationName;
        data["onTopList"] = this.onTopList;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.downstreamDistribution)) {
            data["downstreamDistribution"] = [];
            for (let item of this.downstreamDistribution)
                data["downstreamDistribution"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyEF)) {
            data["energyEF"] = [];
            for (let item of this.energyEF)
                data["energyEF"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.energyEmissionFactor)) {
            data["energyEmissionFactor"] = [];
            for (let item of this.energyEmissionFactor)
                data["energyEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformation)) {
            data["generalInformation"] = [];
            for (let item of this.generalInformation)
                data["generalInformation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterial)) {
            data["rawMaterial"] = [];
            for (let item of this.rawMaterial)
                data["rawMaterial"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.step)) {
            data["step"] = [];
            for (let item of this.step)
                data["step"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISiteLocation {
    id?: string;
    siteLocationName?: string | undefined;
    onTopList?: boolean;
    isActive?: boolean;
    downstreamDistribution?: DownstreamDistribution[] | undefined;
    energyEF?: EnergyEF[] | undefined;
    energyEmissionFactor?: EnergyEmissionFactor[] | undefined;
    generalInformation?: GeneralInformation[] | undefined;
    rawMaterial?: RawMaterial[] | undefined;
    step?: Step[] | undefined;
}

export class SkillAreaStatus implements ISkillAreaStatus {
    skillAreaId?: string;
    isSkillAreaCompiled?: boolean;

    constructor(data?: ISkillAreaStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillAreaId = _data["skillAreaId"];
            this.isSkillAreaCompiled = _data["isSkillAreaCompiled"];
        }
    }

    static fromJS(data: any): SkillAreaStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SkillAreaStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillAreaId"] = this.skillAreaId;
        data["isSkillAreaCompiled"] = this.isSkillAreaCompiled;
        return data;
    }
}

export interface ISkillAreaStatus {
    skillAreaId?: string;
    isSkillAreaCompiled?: boolean;
}

export class SteamConsumptionDefault implements ISteamConsumptionDefault {
    id?: string;
    natualGas?: number;
    coal?: number;
    diesel?: number;
    biomass?: number;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;

    constructor(data?: ISteamConsumptionDefault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.natualGas = _data["natualGas"];
            this.coal = _data["coal"];
            this.diesel = _data["diesel"];
            this.biomass = _data["biomass"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SteamConsumptionDefault {
        data = typeof data === 'object' ? data : {};
        let result = new SteamConsumptionDefault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["natualGas"] = this.natualGas;
        data["coal"] = this.coal;
        data["diesel"] = this.diesel;
        data["biomass"] = this.biomass;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        return data;
    }
}

export interface ISteamConsumptionDefault {
    id?: string;
    natualGas?: number;
    coal?: number;
    diesel?: number;
    biomass?: number;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
}

export class Step implements IStep {
    id?: string;
    stepName?: string | undefined;
    siteLocationId?: string | undefined;
    assessmentId?: string;
    screenId?: string;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    stepNumber?: number;
    generalInformationId?: string | undefined;
    unitOperationId?: string | undefined;
    templateSourceStepId?: string | undefined;
    templateSourceStepName?: string | undefined;
    templateGroupId?: string | undefined;
    templateSourceProjectName?: string | undefined;
    templateSourceSubProjectName?: string | undefined;
    templateSourceAssessmentName?: string | undefined;
    templateSourceGraphJson?: string | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    downstream?: Downstream[] | undefined;
    downstreamStep?: DownstreamStep[] | undefined;
    generalInformation?: GeneralInformation;
    intermediateStepintermediateStepNavigation?: IntermediateStep[] | undefined;
    intermediateStepstep?: IntermediateStep[] | undefined;
    materialInboundTransportintermediateStep?: MaterialInboundTransport[] | undefined;
    materialInboundTransportstep?: MaterialInboundTransport[] | undefined;
    processWaste?: ProcessWaste[] | undefined;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    rawMaterial?: RawMaterial[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    screen?: Screen;
    siteLocation?: SiteLocation;
    stepStatus?: StepStatus[] | undefined;
    unitOperation?: UnitOperation;
    unitOperationNavigation?: UnitOperation[] | undefined;
    unitOperationStep?: UnitOperationStep[] | undefined;
    updatedByPerson?: Person;
    utilities?: Utilities[] | undefined;
    utilitiesEnergyConsumption?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;
    utilitiesSteamConsumption?: UtilitiesSteamConsumption[] | undefined;

    constructor(data?: IStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepName = _data["stepName"];
            this.siteLocationId = _data["siteLocationId"];
            this.assessmentId = _data["assessmentId"];
            this.screenId = _data["screenId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.stepNumber = _data["stepNumber"];
            this.generalInformationId = _data["generalInformationId"];
            this.unitOperationId = _data["unitOperationId"];
            this.templateSourceStepId = _data["templateSourceStepId"];
            this.templateSourceStepName = _data["templateSourceStepName"];
            this.templateGroupId = _data["templateGroupId"];
            this.templateSourceProjectName = _data["templateSourceProjectName"];
            this.templateSourceSubProjectName = _data["templateSourceSubProjectName"];
            this.templateSourceAssessmentName = _data["templateSourceAssessmentName"];
            this.templateSourceGraphJson = _data["templateSourceGraphJson"];
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["downstream"])) {
                this.downstream = [] as any;
                for (let item of _data["downstream"])
                    this.downstream!.push(Downstream.fromJS(item));
            }
            if (Array.isArray(_data["downstreamStep"])) {
                this.downstreamStep = [] as any;
                for (let item of _data["downstreamStep"])
                    this.downstreamStep!.push(DownstreamStep.fromJS(item));
            }
            this.generalInformation = _data["generalInformation"] ? GeneralInformation.fromJS(_data["generalInformation"]) : undefined as any;
            if (Array.isArray(_data["intermediateStepintermediateStepNavigation"])) {
                this.intermediateStepintermediateStepNavigation = [] as any;
                for (let item of _data["intermediateStepintermediateStepNavigation"])
                    this.intermediateStepintermediateStepNavigation!.push(IntermediateStep.fromJS(item));
            }
            if (Array.isArray(_data["intermediateStepstep"])) {
                this.intermediateStepstep = [] as any;
                for (let item of _data["intermediateStepstep"])
                    this.intermediateStepstep!.push(IntermediateStep.fromJS(item));
            }
            if (Array.isArray(_data["materialInboundTransportintermediateStep"])) {
                this.materialInboundTransportintermediateStep = [] as any;
                for (let item of _data["materialInboundTransportintermediateStep"])
                    this.materialInboundTransportintermediateStep!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["materialInboundTransportstep"])) {
                this.materialInboundTransportstep = [] as any;
                for (let item of _data["materialInboundTransportstep"])
                    this.materialInboundTransportstep!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["processWaste"])) {
                this.processWaste = [] as any;
                for (let item of _data["processWaste"])
                    this.processWaste!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["processWasteDetail"])) {
                this.processWasteDetail = [] as any;
                for (let item of _data["processWasteDetail"])
                    this.processWasteDetail!.push(ProcessWasteDetail.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEntry"])) {
                this.productProcessProxyEntry = [] as any;
                for (let item of _data["productProcessProxyEntry"])
                    this.productProcessProxyEntry!.push(ProductProcessProxyEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterial"])) {
                this.rawMaterial = [] as any;
                for (let item of _data["rawMaterial"])
                    this.rawMaterial!.push(RawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntry"])) {
                this.rawMaterialEntry = [] as any;
                for (let item of _data["rawMaterialEntry"])
                    this.rawMaterialEntry!.push(RawMaterialEntry.fromJS(item));
            }
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.siteLocation = _data["siteLocation"] ? SiteLocation.fromJS(_data["siteLocation"]) : undefined as any;
            if (Array.isArray(_data["stepStatus"])) {
                this.stepStatus = [] as any;
                for (let item of _data["stepStatus"])
                    this.stepStatus!.push(StepStatus.fromJS(item));
            }
            this.unitOperation = _data["unitOperation"] ? UnitOperation.fromJS(_data["unitOperation"]) : undefined as any;
            if (Array.isArray(_data["unitOperationNavigation"])) {
                this.unitOperationNavigation = [] as any;
                for (let item of _data["unitOperationNavigation"])
                    this.unitOperationNavigation!.push(UnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["unitOperationStep"])) {
                this.unitOperationStep = [] as any;
                for (let item of _data["unitOperationStep"])
                    this.unitOperationStep!.push(UnitOperationStep.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(Utilities.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesEnergyConsumption"])) {
                this.utilitiesEnergyConsumption = [] as any;
                for (let item of _data["utilitiesEnergyConsumption"])
                    this.utilitiesEnergyConsumption!.push(UtilitiesEnergyConsumption.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesProcessingOperation"])) {
                this.utilitiesProcessingOperation = [] as any;
                for (let item of _data["utilitiesProcessingOperation"])
                    this.utilitiesProcessingOperation!.push(UtilitiesProcessingOperation.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesSteamConsumption"])) {
                this.utilitiesSteamConsumption = [] as any;
                for (let item of _data["utilitiesSteamConsumption"])
                    this.utilitiesSteamConsumption!.push(UtilitiesSteamConsumption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Step {
        data = typeof data === 'object' ? data : {};
        let result = new Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepName"] = this.stepName;
        data["siteLocationId"] = this.siteLocationId;
        data["assessmentId"] = this.assessmentId;
        data["screenId"] = this.screenId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["stepNumber"] = this.stepNumber;
        data["generalInformationId"] = this.generalInformationId;
        data["unitOperationId"] = this.unitOperationId;
        data["templateSourceStepId"] = this.templateSourceStepId;
        data["templateSourceStepName"] = this.templateSourceStepName;
        data["templateGroupId"] = this.templateGroupId;
        data["templateSourceProjectName"] = this.templateSourceProjectName;
        data["templateSourceSubProjectName"] = this.templateSourceSubProjectName;
        data["templateSourceAssessmentName"] = this.templateSourceAssessmentName;
        data["templateSourceGraphJson"] = this.templateSourceGraphJson;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.downstream)) {
            data["downstream"] = [];
            for (let item of this.downstream)
                data["downstream"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamStep)) {
            data["downstreamStep"] = [];
            for (let item of this.downstreamStep)
                data["downstreamStep"].push(item ? item.toJSON() : undefined as any);
        }
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : undefined as any;
        if (Array.isArray(this.intermediateStepintermediateStepNavigation)) {
            data["intermediateStepintermediateStepNavigation"] = [];
            for (let item of this.intermediateStepintermediateStepNavigation)
                data["intermediateStepintermediateStepNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.intermediateStepstep)) {
            data["intermediateStepstep"] = [];
            for (let item of this.intermediateStepstep)
                data["intermediateStepstep"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialInboundTransportintermediateStep)) {
            data["materialInboundTransportintermediateStep"] = [];
            for (let item of this.materialInboundTransportintermediateStep)
                data["materialInboundTransportintermediateStep"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialInboundTransportstep)) {
            data["materialInboundTransportstep"] = [];
            for (let item of this.materialInboundTransportstep)
                data["materialInboundTransportstep"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWaste)) {
            data["processWaste"] = [];
            for (let item of this.processWaste)
                data["processWaste"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWasteDetail)) {
            data["processWasteDetail"] = [];
            for (let item of this.processWasteDetail)
                data["processWasteDetail"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEntry)) {
            data["productProcessProxyEntry"] = [];
            for (let item of this.productProcessProxyEntry)
                data["productProcessProxyEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterial)) {
            data["rawMaterial"] = [];
            for (let item of this.rawMaterial)
                data["rawMaterial"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntry)) {
            data["rawMaterialEntry"] = [];
            for (let item of this.rawMaterialEntry)
                data["rawMaterialEntry"].push(item ? item.toJSON() : undefined as any);
        }
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["siteLocation"] = this.siteLocation ? this.siteLocation.toJSON() : undefined as any;
        if (Array.isArray(this.stepStatus)) {
            data["stepStatus"] = [];
            for (let item of this.stepStatus)
                data["stepStatus"].push(item ? item.toJSON() : undefined as any);
        }
        data["unitOperation"] = this.unitOperation ? this.unitOperation.toJSON() : undefined as any;
        if (Array.isArray(this.unitOperationNavigation)) {
            data["unitOperationNavigation"] = [];
            for (let item of this.unitOperationNavigation)
                data["unitOperationNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperationStep)) {
            data["unitOperationStep"] = [];
            for (let item of this.unitOperationStep)
                data["unitOperationStep"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesEnergyConsumption)) {
            data["utilitiesEnergyConsumption"] = [];
            for (let item of this.utilitiesEnergyConsumption)
                data["utilitiesEnergyConsumption"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesProcessingOperation)) {
            data["utilitiesProcessingOperation"] = [];
            for (let item of this.utilitiesProcessingOperation)
                data["utilitiesProcessingOperation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesSteamConsumption)) {
            data["utilitiesSteamConsumption"] = [];
            for (let item of this.utilitiesSteamConsumption)
                data["utilitiesSteamConsumption"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStep {
    id?: string;
    stepName?: string | undefined;
    siteLocationId?: string | undefined;
    assessmentId?: string;
    screenId?: string;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    isActive?: boolean;
    stepNumber?: number;
    generalInformationId?: string | undefined;
    unitOperationId?: string | undefined;
    templateSourceStepId?: string | undefined;
    templateSourceStepName?: string | undefined;
    templateGroupId?: string | undefined;
    templateSourceProjectName?: string | undefined;
    templateSourceSubProjectName?: string | undefined;
    templateSourceAssessmentName?: string | undefined;
    templateSourceGraphJson?: string | undefined;
    assessment?: Assessment;
    createdByPerson?: Person;
    downstream?: Downstream[] | undefined;
    downstreamStep?: DownstreamStep[] | undefined;
    generalInformation?: GeneralInformation;
    intermediateStepintermediateStepNavigation?: IntermediateStep[] | undefined;
    intermediateStepstep?: IntermediateStep[] | undefined;
    materialInboundTransportintermediateStep?: MaterialInboundTransport[] | undefined;
    materialInboundTransportstep?: MaterialInboundTransport[] | undefined;
    processWaste?: ProcessWaste[] | undefined;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    rawMaterial?: RawMaterial[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    screen?: Screen;
    siteLocation?: SiteLocation;
    stepStatus?: StepStatus[] | undefined;
    unitOperation?: UnitOperation;
    unitOperationNavigation?: UnitOperation[] | undefined;
    unitOperationStep?: UnitOperationStep[] | undefined;
    updatedByPerson?: Person;
    utilities?: Utilities[] | undefined;
    utilitiesEnergyConsumption?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;
    utilitiesSteamConsumption?: UtilitiesSteamConsumption[] | undefined;
}

export class StepStatus implements IStepStatus {
    id?: string;
    stepId?: string | undefined;
    subTab1Name?: string | undefined;
    subTab1Status?: boolean | undefined;
    subTab2Name?: string | undefined;
    subTab2Status?: boolean | undefined;
    subTab3Name?: string | undefined;
    subTab3Status?: boolean | undefined;
    isCompleted?: boolean | undefined;
    step?: Step;

    constructor(data?: IStepStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.subTab1Name = _data["subTab1Name"];
            this.subTab1Status = _data["subTab1Status"];
            this.subTab2Name = _data["subTab2Name"];
            this.subTab2Status = _data["subTab2Status"];
            this.subTab3Name = _data["subTab3Name"];
            this.subTab3Status = _data["subTab3Status"];
            this.isCompleted = _data["isCompleted"];
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
        }
    }

    static fromJS(data: any): StepStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StepStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["subTab1Name"] = this.subTab1Name;
        data["subTab1Status"] = this.subTab1Status;
        data["subTab2Name"] = this.subTab2Name;
        data["subTab2Status"] = this.subTab2Status;
        data["subTab3Name"] = this.subTab3Name;
        data["subTab3Status"] = this.subTab3Status;
        data["isCompleted"] = this.isCompleted;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        return data;
    }
}

export interface IStepStatus {
    id?: string;
    stepId?: string | undefined;
    subTab1Name?: string | undefined;
    subTab1Status?: boolean | undefined;
    subTab2Name?: string | undefined;
    subTab2Status?: boolean | undefined;
    subTab3Name?: string | undefined;
    subTab3Status?: boolean | undefined;
    isCompleted?: boolean | undefined;
    step?: Step;
}

export class SubProject implements ISubProject {
    id?: string;
    projectId?: string;
    subProjectName?: string | undefined;
    subProjectOwner?: string;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    assessment?: Assessment[] | undefined;
    createdByPerson?: Person;
    project?: Project;
    subProjectCollaborator?: SubProjectCollaborator[] | undefined;
    subProjectDefaultScreen?: SubProjectDefaultScreen[] | undefined;
    subProjectOwnerNavigation?: Person;
    updatedByPerson?: Person;

    constructor(data?: ISubProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.subProjectName = _data["subProjectName"];
            this.subProjectOwner = _data["subProjectOwner"];
            this.comments = _data["comments"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["assessment"])) {
                this.assessment = [] as any;
                for (let item of _data["assessment"])
                    this.assessment!.push(Assessment.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
            if (Array.isArray(_data["subProjectCollaborator"])) {
                this.subProjectCollaborator = [] as any;
                for (let item of _data["subProjectCollaborator"])
                    this.subProjectCollaborator!.push(SubProjectCollaborator.fromJS(item));
            }
            if (Array.isArray(_data["subProjectDefaultScreen"])) {
                this.subProjectDefaultScreen = [] as any;
                for (let item of _data["subProjectDefaultScreen"])
                    this.subProjectDefaultScreen!.push(SubProjectDefaultScreen.fromJS(item));
            }
            this.subProjectOwnerNavigation = _data["subProjectOwnerNavigation"] ? Person.fromJS(_data["subProjectOwnerNavigation"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): SubProject {
        data = typeof data === 'object' ? data : {};
        let result = new SubProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["subProjectName"] = this.subProjectName;
        data["subProjectOwner"] = this.subProjectOwner;
        data["comments"] = this.comments;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.assessment)) {
            data["assessment"] = [];
            for (let item of this.assessment)
                data["assessment"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        if (Array.isArray(this.subProjectCollaborator)) {
            data["subProjectCollaborator"] = [];
            for (let item of this.subProjectCollaborator)
                data["subProjectCollaborator"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectDefaultScreen)) {
            data["subProjectDefaultScreen"] = [];
            for (let item of this.subProjectDefaultScreen)
                data["subProjectDefaultScreen"].push(item ? item.toJSON() : undefined as any);
        }
        data["subProjectOwnerNavigation"] = this.subProjectOwnerNavigation ? this.subProjectOwnerNavigation.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface ISubProject {
    id?: string;
    projectId?: string;
    subProjectName?: string | undefined;
    subProjectOwner?: string;
    comments?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    assessment?: Assessment[] | undefined;
    createdByPerson?: Person;
    project?: Project;
    subProjectCollaborator?: SubProjectCollaborator[] | undefined;
    subProjectDefaultScreen?: SubProjectDefaultScreen[] | undefined;
    subProjectOwnerNavigation?: Person;
    updatedByPerson?: Person;
}

export class SubProjectCollaborator implements ISubProjectCollaborator {
    id?: string;
    personId?: string;
    subProjectId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    person?: Person;
    subProject?: SubProject;
    updatedByPerson?: Person;

    constructor(data?: ISubProjectCollaborator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.subProjectId = _data["subProjectId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.subProject = _data["subProject"] ? SubProject.fromJS(_data["subProject"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): SubProjectCollaborator {
        data = typeof data === 'object' ? data : {};
        let result = new SubProjectCollaborator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["subProjectId"] = this.subProjectId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["subProject"] = this.subProject ? this.subProject.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface ISubProjectCollaborator {
    id?: string;
    personId?: string;
    subProjectId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    person?: Person;
    subProject?: SubProject;
    updatedByPerson?: Person;
}

export class SubProjectCollaboratorPut implements ISubProjectCollaboratorPut {
    subProject?: SubProject;
    collaborators?: Person[] | undefined;
    subProjectDefaultScreens?: Screen[] | undefined;

    constructor(data?: ISubProjectCollaboratorPut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subProject = _data["subProject"] ? SubProject.fromJS(_data["subProject"]) : undefined as any;
            if (Array.isArray(_data["collaborators"])) {
                this.collaborators = [] as any;
                for (let item of _data["collaborators"])
                    this.collaborators!.push(Person.fromJS(item));
            }
            if (Array.isArray(_data["subProjectDefaultScreens"])) {
                this.subProjectDefaultScreens = [] as any;
                for (let item of _data["subProjectDefaultScreens"])
                    this.subProjectDefaultScreens!.push(Screen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubProjectCollaboratorPut {
        data = typeof data === 'object' ? data : {};
        let result = new SubProjectCollaboratorPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subProject"] = this.subProject ? this.subProject.toJSON() : undefined as any;
        if (Array.isArray(this.collaborators)) {
            data["collaborators"] = [];
            for (let item of this.collaborators)
                data["collaborators"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subProjectDefaultScreens)) {
            data["subProjectDefaultScreens"] = [];
            for (let item of this.subProjectDefaultScreens)
                data["subProjectDefaultScreens"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubProjectCollaboratorPut {
    subProject?: SubProject;
    collaborators?: Person[] | undefined;
    subProjectDefaultScreens?: Screen[] | undefined;
}

export class SubProjectDefaultScreen implements ISubProjectDefaultScreen {
    id?: string;
    subProjectId?: string;
    screenId?: string;
    numericalOrder?: number | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    screen?: Screen;
    subProject?: SubProject;
    updatedByPerson?: Person;

    constructor(data?: ISubProjectDefaultScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subProjectId = _data["subProjectId"];
            this.screenId = _data["screenId"];
            this.numericalOrder = _data["numericalOrder"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.subProject = _data["subProject"] ? SubProject.fromJS(_data["subProject"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): SubProjectDefaultScreen {
        data = typeof data === 'object' ? data : {};
        let result = new SubProjectDefaultScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subProjectId"] = this.subProjectId;
        data["screenId"] = this.screenId;
        data["numericalOrder"] = this.numericalOrder;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["subProject"] = this.subProject ? this.subProject.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface ISubProjectDefaultScreen {
    id?: string;
    subProjectId?: string;
    screenId?: string;
    numericalOrder?: number | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    screen?: Screen;
    subProject?: SubProject;
    updatedByPerson?: Person;
}

export class SubProjectForTable implements ISubProjectForTable {
    id?: string;
    subProjectName?: string | undefined;
    defaultScreens?: string | undefined;
    subProjectCollaboratorList?: string | undefined;
    subProject?: SubProject;

    constructor(data?: ISubProjectForTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subProjectName = _data["subProjectName"];
            this.defaultScreens = _data["defaultScreens"];
            this.subProjectCollaboratorList = _data["subProjectCollaboratorList"];
            this.subProject = _data["subProject"] ? SubProject.fromJS(_data["subProject"]) : undefined as any;
        }
    }

    static fromJS(data: any): SubProjectForTable {
        data = typeof data === 'object' ? data : {};
        let result = new SubProjectForTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subProjectName"] = this.subProjectName;
        data["defaultScreens"] = this.defaultScreens;
        data["subProjectCollaboratorList"] = this.subProjectCollaboratorList;
        data["subProject"] = this.subProject ? this.subProject.toJSON() : undefined as any;
        return data;
    }
}

export interface ISubProjectForTable {
    id?: string;
    subProjectName?: string | undefined;
    defaultScreens?: string | undefined;
    subProjectCollaboratorList?: string | undefined;
    subProject?: SubProject;
}

export class TemplateUI implements ITemplateUI {
    id?: string;
    templateName?: string | undefined;
    themeSettings?: string | undefined;
    isDefaultTemplate?: boolean;
    logoImageBinary?: string | undefined;
    loginImageBinary?: string | undefined;
    menulogoImageBinary?: string | undefined;
    logoImageContentType?: string | undefined;
    logoImageFileName?: string | undefined;
    logoImageSize?: number | undefined;
    loginImageContentType?: string | undefined;
    loginImageFileName?: string | undefined;
    loginImageSize?: number | undefined;
    menulogoImageContentType?: string | undefined;
    menulogoImageFileName?: string | undefined;
    menulogoImageSize?: number | undefined;
    isDiscaimerVisible?: boolean;
    disclaimerContent?: string | undefined;
    isStandardTheme?: boolean;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    svgImageBinary?: string | undefined;
    svgImageContentType?: string | undefined;
    svgImageFileName?: string | undefined;
    svgImageSize?: number | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;
    userThemeSelection?: UserThemeSelection[] | undefined;

    constructor(data?: ITemplateUI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.themeSettings = _data["themeSettings"];
            this.isDefaultTemplate = _data["isDefaultTemplate"];
            this.logoImageBinary = _data["logoImageBinary"];
            this.loginImageBinary = _data["loginImageBinary"];
            this.menulogoImageBinary = _data["menulogoImageBinary"];
            this.logoImageContentType = _data["logoImageContentType"];
            this.logoImageFileName = _data["logoImageFileName"];
            this.logoImageSize = _data["logoImageSize"];
            this.loginImageContentType = _data["loginImageContentType"];
            this.loginImageFileName = _data["loginImageFileName"];
            this.loginImageSize = _data["loginImageSize"];
            this.menulogoImageContentType = _data["menulogoImageContentType"];
            this.menulogoImageFileName = _data["menulogoImageFileName"];
            this.menulogoImageSize = _data["menulogoImageSize"];
            this.isDiscaimerVisible = _data["isDiscaimerVisible"];
            this.disclaimerContent = _data["disclaimerContent"];
            this.isStandardTheme = _data["isStandardTheme"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.svgImageBinary = _data["svgImageBinary"];
            this.svgImageContentType = _data["svgImageContentType"];
            this.svgImageFileName = _data["svgImageFileName"];
            this.svgImageSize = _data["svgImageSize"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["userThemeSelection"])) {
                this.userThemeSelection = [] as any;
                for (let item of _data["userThemeSelection"])
                    this.userThemeSelection!.push(UserThemeSelection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateUI {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["themeSettings"] = this.themeSettings;
        data["isDefaultTemplate"] = this.isDefaultTemplate;
        data["logoImageBinary"] = this.logoImageBinary;
        data["loginImageBinary"] = this.loginImageBinary;
        data["menulogoImageBinary"] = this.menulogoImageBinary;
        data["logoImageContentType"] = this.logoImageContentType;
        data["logoImageFileName"] = this.logoImageFileName;
        data["logoImageSize"] = this.logoImageSize;
        data["loginImageContentType"] = this.loginImageContentType;
        data["loginImageFileName"] = this.loginImageFileName;
        data["loginImageSize"] = this.loginImageSize;
        data["menulogoImageContentType"] = this.menulogoImageContentType;
        data["menulogoImageFileName"] = this.menulogoImageFileName;
        data["menulogoImageSize"] = this.menulogoImageSize;
        data["isDiscaimerVisible"] = this.isDiscaimerVisible;
        data["disclaimerContent"] = this.disclaimerContent;
        data["isStandardTheme"] = this.isStandardTheme;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["svgImageBinary"] = this.svgImageBinary;
        data["svgImageContentType"] = this.svgImageContentType;
        data["svgImageFileName"] = this.svgImageFileName;
        data["svgImageSize"] = this.svgImageSize;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.userThemeSelection)) {
            data["userThemeSelection"] = [];
            for (let item of this.userThemeSelection)
                data["userThemeSelection"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITemplateUI {
    id?: string;
    templateName?: string | undefined;
    themeSettings?: string | undefined;
    isDefaultTemplate?: boolean;
    logoImageBinary?: string | undefined;
    loginImageBinary?: string | undefined;
    menulogoImageBinary?: string | undefined;
    logoImageContentType?: string | undefined;
    logoImageFileName?: string | undefined;
    logoImageSize?: number | undefined;
    loginImageContentType?: string | undefined;
    loginImageFileName?: string | undefined;
    loginImageSize?: number | undefined;
    menulogoImageContentType?: string | undefined;
    menulogoImageFileName?: string | undefined;
    menulogoImageSize?: number | undefined;
    isDiscaimerVisible?: boolean;
    disclaimerContent?: string | undefined;
    isStandardTheme?: boolean;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    svgImageBinary?: string | undefined;
    svgImageContentType?: string | undefined;
    svgImageFileName?: string | undefined;
    svgImageSize?: number | undefined;
    createdByPerson?: Person;
    updatedByPerson?: Person;
    userThemeSelection?: UserThemeSelection[] | undefined;
}

export class ThemeState implements IThemeState {
    id?: string;
    selectedTheme?: ThemeTemplate;
    templateUI?: TemplateUI;

    constructor(data?: IThemeState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selectedTheme = _data["selectedTheme"] ? ThemeTemplate.fromJS(_data["selectedTheme"]) : undefined as any;
            this.templateUI = _data["templateUI"] ? TemplateUI.fromJS(_data["templateUI"]) : undefined as any;
        }
    }

    static fromJS(data: any): ThemeState {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selectedTheme"] = this.selectedTheme ? this.selectedTheme.toJSON() : undefined as any;
        data["templateUI"] = this.templateUI ? this.templateUI.toJSON() : undefined as any;
        return data;
    }
}

export interface IThemeState {
    id?: string;
    selectedTheme?: ThemeTemplate;
    templateUI?: TemplateUI;
}

export class ThemeTemplate implements IThemeTemplate {
    semantic?: Semantic;
    components?: Components;
    fontSettings?: SimpleFontSettings;

    constructor(data?: IThemeTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.semantic = _data["semantic"] ? Semantic.fromJS(_data["semantic"]) : undefined as any;
            this.components = _data["components"] ? Components.fromJS(_data["components"]) : undefined as any;
            this.fontSettings = _data["fontSettings"] ? SimpleFontSettings.fromJS(_data["fontSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): ThemeTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["semantic"] = this.semantic ? this.semantic.toJSON() : undefined as any;
        data["components"] = this.components ? this.components.toJSON() : undefined as any;
        data["fontSettings"] = this.fontSettings ? this.fontSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IThemeTemplate {
    semantic?: Semantic;
    components?: Components;
    fontSettings?: SimpleFontSettings;
}

export class Transport implements ITransport {
    id?: string;
    transportModeId?: string;
    distance?: number;
    unitId?: string;
    transportName?: string | undefined;
    isDefault?: boolean | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    dataSource?: string | undefined;
    dataSourceNotes?: string | undefined;
    downstreamDistribution?: DownstreamDistribution[] | undefined;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    transportEmissionFactor?: TransportEmissionFactor[] | undefined;
    transportMode?: TransportMode;
    unit?: Unit;

    constructor(data?: ITransport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transportModeId = _data["transportModeId"];
            this.distance = _data["distance"];
            this.unitId = _data["unitId"];
            this.transportName = _data["transportName"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.dataSource = _data["dataSource"];
            this.dataSourceNotes = _data["dataSourceNotes"];
            if (Array.isArray(_data["downstreamDistribution"])) {
                this.downstreamDistribution = [] as any;
                for (let item of _data["downstreamDistribution"])
                    this.downstreamDistribution!.push(DownstreamDistribution.fromJS(item));
            }
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["transportEmissionFactor"])) {
                this.transportEmissionFactor = [] as any;
                for (let item of _data["transportEmissionFactor"])
                    this.transportEmissionFactor!.push(TransportEmissionFactor.fromJS(item));
            }
            this.transportMode = _data["transportMode"] ? TransportMode.fromJS(_data["transportMode"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
        }
    }

    static fromJS(data: any): Transport {
        data = typeof data === 'object' ? data : {};
        let result = new Transport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transportModeId"] = this.transportModeId;
        data["distance"] = this.distance;
        data["unitId"] = this.unitId;
        data["transportName"] = this.transportName;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["dataSource"] = this.dataSource;
        data["dataSourceNotes"] = this.dataSourceNotes;
        if (Array.isArray(this.downstreamDistribution)) {
            data["downstreamDistribution"] = [];
            for (let item of this.downstreamDistribution)
                data["downstreamDistribution"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transportEmissionFactor)) {
            data["transportEmissionFactor"] = [];
            for (let item of this.transportEmissionFactor)
                data["transportEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        data["transportMode"] = this.transportMode ? this.transportMode.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        return data;
    }
}

export interface ITransport {
    id?: string;
    transportModeId?: string;
    distance?: number;
    unitId?: string;
    transportName?: string | undefined;
    isDefault?: boolean | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    dataSource?: string | undefined;
    dataSourceNotes?: string | undefined;
    downstreamDistribution?: DownstreamDistribution[] | undefined;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    transportEmissionFactor?: TransportEmissionFactor[] | undefined;
    transportMode?: TransportMode;
    unit?: Unit;
}

export class TransportEmissionFactor implements ITransportEmissionFactor {
    id?: string;
    transportId?: string;
    emissionFactorId?: string;
    factor?: number;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    transport?: Transport;
    updatedByPerson?: Person;

    constructor(data?: ITransportEmissionFactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transportId = _data["transportId"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.factor = _data["factor"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.dataQualityScore = _data["dataQualityScore"];
            this.isActive = _data["isActive"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.emissionFactor = _data["emissionFactor"] ? EmissionFactors.fromJS(_data["emissionFactor"]) : undefined as any;
            this.transport = _data["transport"] ? Transport.fromJS(_data["transport"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): TransportEmissionFactor {
        data = typeof data === 'object' ? data : {};
        let result = new TransportEmissionFactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transportId"] = this.transportId;
        data["emissionFactorId"] = this.emissionFactorId;
        data["factor"] = this.factor;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["dataQualityScore"] = this.dataQualityScore;
        data["isActive"] = this.isActive;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["emissionFactor"] = this.emissionFactor ? this.emissionFactor.toJSON() : undefined as any;
        data["transport"] = this.transport ? this.transport.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface ITransportEmissionFactor {
    id?: string;
    transportId?: string;
    emissionFactorId?: string;
    factor?: number;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    transport?: Transport;
    updatedByPerson?: Person;
}

export class TransportMode implements ITransportMode {
    id?: string;
    transportModeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    transport?: Transport[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: ITransportMode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transportModeName = _data["transportModeName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["transport"])) {
                this.transport = [] as any;
                for (let item of _data["transport"])
                    this.transport!.push(Transport.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): TransportMode {
        data = typeof data === 'object' ? data : {};
        let result = new TransportMode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transportModeName"] = this.transportModeName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.transport)) {
            data["transport"] = [];
            for (let item of this.transport)
                data["transport"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface ITransportMode {
    id?: string;
    transportModeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    transport?: Transport[] | undefined;
    updatedByPerson?: Person;
}

export class Tree implements ITree {
    id?: string;
    treeName?: string | undefined;
    description?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    treeItems?: TreeItems[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: ITree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeName = _data["treeName"];
            this.description = _data["description"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["treeItems"])) {
                this.treeItems = [] as any;
                for (let item of _data["treeItems"])
                    this.treeItems!.push(TreeItems.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): Tree {
        data = typeof data === 'object' ? data : {};
        let result = new Tree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeName"] = this.treeName;
        data["description"] = this.description;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.treeItems)) {
            data["treeItems"] = [];
            for (let item of this.treeItems)
                data["treeItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface ITree {
    id?: string;
    treeName?: string | undefined;
    description?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    treeItems?: TreeItems[] | undefined;
    updatedByPerson?: Person;
}

export class TreeForMaterialMgm implements ITreeForMaterialMgm {
    key!: string | undefined;
    label?: string | undefined;
    data?: string | undefined;
    materialData?: Material;
    materialTypeData?: MaterialType;
    children?: TreeForMaterialMgm[] | undefined;
    icon?: string | undefined;
    type?: string | undefined;
    selectable?: boolean | undefined;
    expandable?: boolean | undefined;
    expanded?: boolean | undefined;

    constructor(data?: ITreeForMaterialMgm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.data = _data["data"];
            this.materialData = _data["materialData"] ? Material.fromJS(_data["materialData"]) : undefined as any;
            this.materialTypeData = _data["materialTypeData"] ? MaterialType.fromJS(_data["materialTypeData"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(TreeForMaterialMgm.fromJS(item));
            }
            this.icon = _data["icon"];
            this.type = _data["type"];
            this.selectable = _data["selectable"];
            this.expandable = _data["expandable"];
            this.expanded = _data["expanded"];
        }
    }

    static fromJS(data: any): TreeForMaterialMgm {
        data = typeof data === 'object' ? data : {};
        let result = new TreeForMaterialMgm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["data"] = this.data;
        data["materialData"] = this.materialData ? this.materialData.toJSON() : undefined as any;
        data["materialTypeData"] = this.materialTypeData ? this.materialTypeData.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["icon"] = this.icon;
        data["type"] = this.type;
        data["selectable"] = this.selectable;
        data["expandable"] = this.expandable;
        data["expanded"] = this.expanded;
        return data;
    }
}

export interface ITreeForMaterialMgm {
    key: string | undefined;
    label?: string | undefined;
    data?: string | undefined;
    materialData?: Material;
    materialTypeData?: MaterialType;
    children?: TreeForMaterialMgm[] | undefined;
    icon?: string | undefined;
    type?: string | undefined;
    selectable?: boolean | undefined;
    expandable?: boolean | undefined;
    expanded?: boolean | undefined;
}

export class TreeItem implements ITreeItem {
    key?: string | undefined;
    data?: SingleData;
    label?: string | undefined;
    children?: TreeItem[] | undefined;

    constructor(data?: ITreeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.data = _data["data"] ? SingleData.fromJS(_data["data"]) : undefined as any;
            this.label = _data["label"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(TreeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["label"] = this.label;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITreeItem {
    key?: string | undefined;
    data?: SingleData;
    label?: string | undefined;
    children?: TreeItem[] | undefined;
}

export class TreeItemVM implements ITreeItemVM {
    id?: string;
    treeid?: string;
    treeItemName?: string | undefined;
    description?: string | undefined;
    treePathString?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;

    constructor(data?: ITreeItemVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeid = _data["treeid"];
            this.treeItemName = _data["treeItemName"];
            this.description = _data["description"];
            this.treePathString = _data["treePathString"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TreeItemVM {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItemVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeid"] = this.treeid;
        data["treeItemName"] = this.treeItemName;
        data["description"] = this.description;
        data["treePathString"] = this.treePathString;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        return data;
    }
}

export interface ITreeItemVM {
    id?: string;
    treeid?: string;
    treeItemName?: string | undefined;
    description?: string | undefined;
    treePathString?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
}

export class TreeItems implements ITreeItems {
    treePathString?: string | undefined;
    id?: string;
    treeid?: string;
    treeItemName?: string | undefined;
    description?: string | undefined;
    treePath?: HierarchyId;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    tree?: Tree;
    updatedByPerson?: Person;

    constructor(data?: ITreeItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treePathString = _data["treePathString"];
            this.id = _data["id"];
            this.treeid = _data["treeid"];
            this.treeItemName = _data["treeItemName"];
            this.description = _data["description"];
            this.treePath = _data["treePath"] ? HierarchyId.fromJS(_data["treePath"]) : undefined as any;
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.tree = _data["tree"] ? Tree.fromJS(_data["tree"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreeItems {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treePathString"] = this.treePathString;
        data["id"] = this.id;
        data["treeid"] = this.treeid;
        data["treeItemName"] = this.treeItemName;
        data["description"] = this.description;
        data["treePath"] = this.treePath ? this.treePath.toJSON() : undefined as any;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["tree"] = this.tree ? this.tree.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface ITreeItems {
    treePathString?: string | undefined;
    id?: string;
    treeid?: string;
    treeItemName?: string | undefined;
    description?: string | undefined;
    treePath?: HierarchyId;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    tree?: Tree;
    updatedByPerson?: Person;
}

export class Unit implements IUnit {
    id?: string;
    unitName?: string | undefined;
    unitTypeId?: string;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    measureType?: string | undefined;
    unitOfMeasure?: string | undefined;
    isBaseUnit?: boolean | undefined;
    convertToStandardMultiplier?: number | undefined;
    convertToStandardAddend?: number | undefined;
    wfiCleanSteamGeneration?: WFICleanSteamGeneration[] | undefined;
    wfiSourceenergyUnit?: WFISource[] | undefined;
    wfiSourcesteamUnit?: WFISource[] | undefined;
    wfiSourcewaterUnit?: WFISource[] | undefined;
    createdByPerson?: Person;
    downstreamDistributionmodeOfTransportUnitNavigation?: DownstreamDistribution[] | undefined;
    downstreamDistributiontempStorageTimeUnit?: DownstreamDistribution[] | undefined;
    emissionFactors?: EmissionFactors[] | undefined;
    generalInformationconcentrationUnit?: GeneralInformation[] | undefined;
    generalInformationdistDosesPerPalletUnit?: GeneralInformation[] | undefined;
    generalInformationdistDrugProductMassUnit?: GeneralInformation[] | undefined;
    generalInformationdistTotalMassOfPalletUnit?: GeneralInformation[] | undefined;
    generalInformationdoseUnit?: GeneralInformation[] | undefined;
    generalInformationmassPerProductFormatUnit?: GeneralInformation[] | undefined;
    generalInformationproteinMOUnit?: GeneralInformation[] | undefined;
    intermediateStep?: IntermediateStep[] | undefined;
    material?: Material[] | undefined;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    processWastepmOutputUnit?: ProcessWaste[] | undefined;
    processWastepmUnit?: ProcessWaste[] | undefined;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperation?: RawMaterialUnitOperation[] | undefined;
    rawMaterialbdsUnit?: RawMaterial[] | undefined;
    rawMaterialunit?: RawMaterial[] | undefined;
    transport?: Transport[] | undefined;
    unitOperationStep?: UnitOperationStep[] | undefined;
    unitType?: UnitType;
    updatedByPerson?: Person;
    utilities?: Utilities[] | undefined;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitName = _data["unitName"];
            this.unitTypeId = _data["unitTypeId"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.measureType = _data["measureType"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.isBaseUnit = _data["isBaseUnit"];
            this.convertToStandardMultiplier = _data["convertToStandardMultiplier"];
            this.convertToStandardAddend = _data["convertToStandardAddend"];
            if (Array.isArray(_data["wfiCleanSteamGeneration"])) {
                this.wfiCleanSteamGeneration = [] as any;
                for (let item of _data["wfiCleanSteamGeneration"])
                    this.wfiCleanSteamGeneration!.push(WFICleanSteamGeneration.fromJS(item));
            }
            if (Array.isArray(_data["wfiSourceenergyUnit"])) {
                this.wfiSourceenergyUnit = [] as any;
                for (let item of _data["wfiSourceenergyUnit"])
                    this.wfiSourceenergyUnit!.push(WFISource.fromJS(item));
            }
            if (Array.isArray(_data["wfiSourcesteamUnit"])) {
                this.wfiSourcesteamUnit = [] as any;
                for (let item of _data["wfiSourcesteamUnit"])
                    this.wfiSourcesteamUnit!.push(WFISource.fromJS(item));
            }
            if (Array.isArray(_data["wfiSourcewaterUnit"])) {
                this.wfiSourcewaterUnit = [] as any;
                for (let item of _data["wfiSourcewaterUnit"])
                    this.wfiSourcewaterUnit!.push(WFISource.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["downstreamDistributionmodeOfTransportUnitNavigation"])) {
                this.downstreamDistributionmodeOfTransportUnitNavigation = [] as any;
                for (let item of _data["downstreamDistributionmodeOfTransportUnitNavigation"])
                    this.downstreamDistributionmodeOfTransportUnitNavigation!.push(DownstreamDistribution.fromJS(item));
            }
            if (Array.isArray(_data["downstreamDistributiontempStorageTimeUnit"])) {
                this.downstreamDistributiontempStorageTimeUnit = [] as any;
                for (let item of _data["downstreamDistributiontempStorageTimeUnit"])
                    this.downstreamDistributiontempStorageTimeUnit!.push(DownstreamDistribution.fromJS(item));
            }
            if (Array.isArray(_data["emissionFactors"])) {
                this.emissionFactors = [] as any;
                for (let item of _data["emissionFactors"])
                    this.emissionFactors!.push(EmissionFactors.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationconcentrationUnit"])) {
                this.generalInformationconcentrationUnit = [] as any;
                for (let item of _data["generalInformationconcentrationUnit"])
                    this.generalInformationconcentrationUnit!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationdistDosesPerPalletUnit"])) {
                this.generalInformationdistDosesPerPalletUnit = [] as any;
                for (let item of _data["generalInformationdistDosesPerPalletUnit"])
                    this.generalInformationdistDosesPerPalletUnit!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationdistDrugProductMassUnit"])) {
                this.generalInformationdistDrugProductMassUnit = [] as any;
                for (let item of _data["generalInformationdistDrugProductMassUnit"])
                    this.generalInformationdistDrugProductMassUnit!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationdistTotalMassOfPalletUnit"])) {
                this.generalInformationdistTotalMassOfPalletUnit = [] as any;
                for (let item of _data["generalInformationdistTotalMassOfPalletUnit"])
                    this.generalInformationdistTotalMassOfPalletUnit!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationdoseUnit"])) {
                this.generalInformationdoseUnit = [] as any;
                for (let item of _data["generalInformationdoseUnit"])
                    this.generalInformationdoseUnit!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationmassPerProductFormatUnit"])) {
                this.generalInformationmassPerProductFormatUnit = [] as any;
                for (let item of _data["generalInformationmassPerProductFormatUnit"])
                    this.generalInformationmassPerProductFormatUnit!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["generalInformationproteinMOUnit"])) {
                this.generalInformationproteinMOUnit = [] as any;
                for (let item of _data["generalInformationproteinMOUnit"])
                    this.generalInformationproteinMOUnit!.push(GeneralInformation.fromJS(item));
            }
            if (Array.isArray(_data["intermediateStep"])) {
                this.intermediateStep = [] as any;
                for (let item of _data["intermediateStep"])
                    this.intermediateStep!.push(IntermediateStep.fromJS(item));
            }
            if (Array.isArray(_data["material"])) {
                this.material = [] as any;
                for (let item of _data["material"])
                    this.material!.push(Material.fromJS(item));
            }
            if (Array.isArray(_data["materialInboundTransport"])) {
                this.materialInboundTransport = [] as any;
                for (let item of _data["materialInboundTransport"])
                    this.materialInboundTransport!.push(MaterialInboundTransport.fromJS(item));
            }
            if (Array.isArray(_data["processWastepmOutputUnit"])) {
                this.processWastepmOutputUnit = [] as any;
                for (let item of _data["processWastepmOutputUnit"])
                    this.processWastepmOutputUnit!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["processWastepmUnit"])) {
                this.processWastepmUnit = [] as any;
                for (let item of _data["processWastepmUnit"])
                    this.processWastepmUnit!.push(ProcessWaste.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxy"])) {
                this.productProcessProxy = [] as any;
                for (let item of _data["productProcessProxy"])
                    this.productProcessProxy!.push(ProductProcessProxy.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEntry"])) {
                this.productProcessProxyEntry = [] as any;
                for (let item of _data["productProcessProxyEntry"])
                    this.productProcessProxyEntry!.push(ProductProcessProxyEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntry"])) {
                this.rawMaterialEntry = [] as any;
                for (let item of _data["rawMaterialEntry"])
                    this.rawMaterialEntry!.push(RawMaterialEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialUnitOperation"])) {
                this.rawMaterialUnitOperation = [] as any;
                for (let item of _data["rawMaterialUnitOperation"])
                    this.rawMaterialUnitOperation!.push(RawMaterialUnitOperation.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialbdsUnit"])) {
                this.rawMaterialbdsUnit = [] as any;
                for (let item of _data["rawMaterialbdsUnit"])
                    this.rawMaterialbdsUnit!.push(RawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialunit"])) {
                this.rawMaterialunit = [] as any;
                for (let item of _data["rawMaterialunit"])
                    this.rawMaterialunit!.push(RawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["transport"])) {
                this.transport = [] as any;
                for (let item of _data["transport"])
                    this.transport!.push(Transport.fromJS(item));
            }
            if (Array.isArray(_data["unitOperationStep"])) {
                this.unitOperationStep = [] as any;
                for (let item of _data["unitOperationStep"])
                    this.unitOperationStep!.push(UnitOperationStep.fromJS(item));
            }
            this.unitType = _data["unitType"] ? UnitType.fromJS(_data["unitType"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(Utilities.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesProcessingOperation"])) {
                this.utilitiesProcessingOperation = [] as any;
                for (let item of _data["utilitiesProcessingOperation"])
                    this.utilitiesProcessingOperation!.push(UtilitiesProcessingOperation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitName"] = this.unitName;
        data["unitTypeId"] = this.unitTypeId;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["measureType"] = this.measureType;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["isBaseUnit"] = this.isBaseUnit;
        data["convertToStandardMultiplier"] = this.convertToStandardMultiplier;
        data["convertToStandardAddend"] = this.convertToStandardAddend;
        if (Array.isArray(this.wfiCleanSteamGeneration)) {
            data["wfiCleanSteamGeneration"] = [];
            for (let item of this.wfiCleanSteamGeneration)
                data["wfiCleanSteamGeneration"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wfiSourceenergyUnit)) {
            data["wfiSourceenergyUnit"] = [];
            for (let item of this.wfiSourceenergyUnit)
                data["wfiSourceenergyUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wfiSourcesteamUnit)) {
            data["wfiSourcesteamUnit"] = [];
            for (let item of this.wfiSourcesteamUnit)
                data["wfiSourcesteamUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wfiSourcewaterUnit)) {
            data["wfiSourcewaterUnit"] = [];
            for (let item of this.wfiSourcewaterUnit)
                data["wfiSourcewaterUnit"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.downstreamDistributionmodeOfTransportUnitNavigation)) {
            data["downstreamDistributionmodeOfTransportUnitNavigation"] = [];
            for (let item of this.downstreamDistributionmodeOfTransportUnitNavigation)
                data["downstreamDistributionmodeOfTransportUnitNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.downstreamDistributiontempStorageTimeUnit)) {
            data["downstreamDistributiontempStorageTimeUnit"] = [];
            for (let item of this.downstreamDistributiontempStorageTimeUnit)
                data["downstreamDistributiontempStorageTimeUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emissionFactors)) {
            data["emissionFactors"] = [];
            for (let item of this.emissionFactors)
                data["emissionFactors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationconcentrationUnit)) {
            data["generalInformationconcentrationUnit"] = [];
            for (let item of this.generalInformationconcentrationUnit)
                data["generalInformationconcentrationUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationdistDosesPerPalletUnit)) {
            data["generalInformationdistDosesPerPalletUnit"] = [];
            for (let item of this.generalInformationdistDosesPerPalletUnit)
                data["generalInformationdistDosesPerPalletUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationdistDrugProductMassUnit)) {
            data["generalInformationdistDrugProductMassUnit"] = [];
            for (let item of this.generalInformationdistDrugProductMassUnit)
                data["generalInformationdistDrugProductMassUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationdistTotalMassOfPalletUnit)) {
            data["generalInformationdistTotalMassOfPalletUnit"] = [];
            for (let item of this.generalInformationdistTotalMassOfPalletUnit)
                data["generalInformationdistTotalMassOfPalletUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationdoseUnit)) {
            data["generalInformationdoseUnit"] = [];
            for (let item of this.generalInformationdoseUnit)
                data["generalInformationdoseUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationmassPerProductFormatUnit)) {
            data["generalInformationmassPerProductFormatUnit"] = [];
            for (let item of this.generalInformationmassPerProductFormatUnit)
                data["generalInformationmassPerProductFormatUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalInformationproteinMOUnit)) {
            data["generalInformationproteinMOUnit"] = [];
            for (let item of this.generalInformationproteinMOUnit)
                data["generalInformationproteinMOUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.intermediateStep)) {
            data["intermediateStep"] = [];
            for (let item of this.intermediateStep)
                data["intermediateStep"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.material)) {
            data["material"] = [];
            for (let item of this.material)
                data["material"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materialInboundTransport)) {
            data["materialInboundTransport"] = [];
            for (let item of this.materialInboundTransport)
                data["materialInboundTransport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWastepmOutputUnit)) {
            data["processWastepmOutputUnit"] = [];
            for (let item of this.processWastepmOutputUnit)
                data["processWastepmOutputUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processWastepmUnit)) {
            data["processWastepmUnit"] = [];
            for (let item of this.processWastepmUnit)
                data["processWastepmUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxy)) {
            data["productProcessProxy"] = [];
            for (let item of this.productProcessProxy)
                data["productProcessProxy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEntry)) {
            data["productProcessProxyEntry"] = [];
            for (let item of this.productProcessProxyEntry)
                data["productProcessProxyEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntry)) {
            data["rawMaterialEntry"] = [];
            for (let item of this.rawMaterialEntry)
                data["rawMaterialEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialUnitOperation)) {
            data["rawMaterialUnitOperation"] = [];
            for (let item of this.rawMaterialUnitOperation)
                data["rawMaterialUnitOperation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialbdsUnit)) {
            data["rawMaterialbdsUnit"] = [];
            for (let item of this.rawMaterialbdsUnit)
                data["rawMaterialbdsUnit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialunit)) {
            data["rawMaterialunit"] = [];
            for (let item of this.rawMaterialunit)
                data["rawMaterialunit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transport)) {
            data["transport"] = [];
            for (let item of this.transport)
                data["transport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperationStep)) {
            data["unitOperationStep"] = [];
            for (let item of this.unitOperationStep)
                data["unitOperationStep"].push(item ? item.toJSON() : undefined as any);
        }
        data["unitType"] = this.unitType ? this.unitType.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesProcessingOperation)) {
            data["utilitiesProcessingOperation"] = [];
            for (let item of this.utilitiesProcessingOperation)
                data["utilitiesProcessingOperation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUnit {
    id?: string;
    unitName?: string | undefined;
    unitTypeId?: string;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    measureType?: string | undefined;
    unitOfMeasure?: string | undefined;
    isBaseUnit?: boolean | undefined;
    convertToStandardMultiplier?: number | undefined;
    convertToStandardAddend?: number | undefined;
    wfiCleanSteamGeneration?: WFICleanSteamGeneration[] | undefined;
    wfiSourceenergyUnit?: WFISource[] | undefined;
    wfiSourcesteamUnit?: WFISource[] | undefined;
    wfiSourcewaterUnit?: WFISource[] | undefined;
    createdByPerson?: Person;
    downstreamDistributionmodeOfTransportUnitNavigation?: DownstreamDistribution[] | undefined;
    downstreamDistributiontempStorageTimeUnit?: DownstreamDistribution[] | undefined;
    emissionFactors?: EmissionFactors[] | undefined;
    generalInformationconcentrationUnit?: GeneralInformation[] | undefined;
    generalInformationdistDosesPerPalletUnit?: GeneralInformation[] | undefined;
    generalInformationdistDrugProductMassUnit?: GeneralInformation[] | undefined;
    generalInformationdistTotalMassOfPalletUnit?: GeneralInformation[] | undefined;
    generalInformationdoseUnit?: GeneralInformation[] | undefined;
    generalInformationmassPerProductFormatUnit?: GeneralInformation[] | undefined;
    generalInformationproteinMOUnit?: GeneralInformation[] | undefined;
    intermediateStep?: IntermediateStep[] | undefined;
    material?: Material[] | undefined;
    materialInboundTransport?: MaterialInboundTransport[] | undefined;
    processWastepmOutputUnit?: ProcessWaste[] | undefined;
    processWastepmUnit?: ProcessWaste[] | undefined;
    productProcessProxy?: ProductProcessProxy[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperation?: RawMaterialUnitOperation[] | undefined;
    rawMaterialbdsUnit?: RawMaterial[] | undefined;
    rawMaterialunit?: RawMaterial[] | undefined;
    transport?: Transport[] | undefined;
    unitOperationStep?: UnitOperationStep[] | undefined;
    unitType?: UnitType;
    updatedByPerson?: Person;
    utilities?: Utilities[] | undefined;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;
}

export class UnitOperation implements IUnitOperation {
    id?: string;
    unitOperationName?: string | undefined;
    isActive?: boolean;
    electricity?: number | undefined;
    steam?: number | undefined;
    loss?: number | undefined;
    comment?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    waterConsumption?: number | undefined;
    screenId?: string | undefined;
    cleanSteam?: number | undefined;
    isNew?: boolean | undefined;
    assessmentId?: string | undefined;
    compOptionId?: string | undefined;
    assessment?: Step;
    compOption?: CompOption;
    createdByPerson?: Person;
    intermediateStep?: IntermediateStep[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperation?: RawMaterialUnitOperation[] | undefined;
    screen?: Screen;
    step?: Step[] | undefined;
    unitOperationStep?: UnitOperationStep[] | undefined;
    updatedByPerson?: Person;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;

    constructor(data?: IUnitOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitOperationName = _data["unitOperationName"];
            this.isActive = _data["isActive"];
            this.electricity = _data["electricity"];
            this.steam = _data["steam"];
            this.loss = _data["loss"];
            this.comment = _data["comment"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.waterConsumption = _data["waterConsumption"];
            this.screenId = _data["screenId"];
            this.cleanSteam = _data["cleanSteam"];
            this.isNew = _data["isNew"];
            this.assessmentId = _data["assessmentId"];
            this.compOptionId = _data["compOptionId"];
            this.assessment = _data["assessment"] ? Step.fromJS(_data["assessment"]) : undefined as any;
            this.compOption = _data["compOption"] ? CompOption.fromJS(_data["compOption"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["intermediateStep"])) {
                this.intermediateStep = [] as any;
                for (let item of _data["intermediateStep"])
                    this.intermediateStep!.push(IntermediateStep.fromJS(item));
            }
            if (Array.isArray(_data["productProcessProxyEntry"])) {
                this.productProcessProxyEntry = [] as any;
                for (let item of _data["productProcessProxyEntry"])
                    this.productProcessProxyEntry!.push(ProductProcessProxyEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialEntry"])) {
                this.rawMaterialEntry = [] as any;
                for (let item of _data["rawMaterialEntry"])
                    this.rawMaterialEntry!.push(RawMaterialEntry.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterialUnitOperation"])) {
                this.rawMaterialUnitOperation = [] as any;
                for (let item of _data["rawMaterialUnitOperation"])
                    this.rawMaterialUnitOperation!.push(RawMaterialUnitOperation.fromJS(item));
            }
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            if (Array.isArray(_data["step"])) {
                this.step = [] as any;
                for (let item of _data["step"])
                    this.step!.push(Step.fromJS(item));
            }
            if (Array.isArray(_data["unitOperationStep"])) {
                this.unitOperationStep = [] as any;
                for (let item of _data["unitOperationStep"])
                    this.unitOperationStep!.push(UnitOperationStep.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["utilitiesProcessingOperation"])) {
                this.utilitiesProcessingOperation = [] as any;
                for (let item of _data["utilitiesProcessingOperation"])
                    this.utilitiesProcessingOperation!.push(UtilitiesProcessingOperation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitOperation {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitOperationName"] = this.unitOperationName;
        data["isActive"] = this.isActive;
        data["electricity"] = this.electricity;
        data["steam"] = this.steam;
        data["loss"] = this.loss;
        data["comment"] = this.comment;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["waterConsumption"] = this.waterConsumption;
        data["screenId"] = this.screenId;
        data["cleanSteam"] = this.cleanSteam;
        data["isNew"] = this.isNew;
        data["assessmentId"] = this.assessmentId;
        data["compOptionId"] = this.compOptionId;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : undefined as any;
        data["compOption"] = this.compOption ? this.compOption.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.intermediateStep)) {
            data["intermediateStep"] = [];
            for (let item of this.intermediateStep)
                data["intermediateStep"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productProcessProxyEntry)) {
            data["productProcessProxyEntry"] = [];
            for (let item of this.productProcessProxyEntry)
                data["productProcessProxyEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialEntry)) {
            data["rawMaterialEntry"] = [];
            for (let item of this.rawMaterialEntry)
                data["rawMaterialEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rawMaterialUnitOperation)) {
            data["rawMaterialUnitOperation"] = [];
            for (let item of this.rawMaterialUnitOperation)
                data["rawMaterialUnitOperation"].push(item ? item.toJSON() : undefined as any);
        }
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        if (Array.isArray(this.step)) {
            data["step"] = [];
            for (let item of this.step)
                data["step"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unitOperationStep)) {
            data["unitOperationStep"] = [];
            for (let item of this.unitOperationStep)
                data["unitOperationStep"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.utilitiesProcessingOperation)) {
            data["utilitiesProcessingOperation"] = [];
            for (let item of this.utilitiesProcessingOperation)
                data["utilitiesProcessingOperation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUnitOperation {
    id?: string;
    unitOperationName?: string | undefined;
    isActive?: boolean;
    electricity?: number | undefined;
    steam?: number | undefined;
    loss?: number | undefined;
    comment?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    waterConsumption?: number | undefined;
    screenId?: string | undefined;
    cleanSteam?: number | undefined;
    isNew?: boolean | undefined;
    assessmentId?: string | undefined;
    compOptionId?: string | undefined;
    assessment?: Step;
    compOption?: CompOption;
    createdByPerson?: Person;
    intermediateStep?: IntermediateStep[] | undefined;
    productProcessProxyEntry?: ProductProcessProxyEntry[] | undefined;
    rawMaterialEntry?: RawMaterialEntry[] | undefined;
    rawMaterialUnitOperation?: RawMaterialUnitOperation[] | undefined;
    screen?: Screen;
    step?: Step[] | undefined;
    unitOperationStep?: UnitOperationStep[] | undefined;
    updatedByPerson?: Person;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;
}

export class UnitOperationStep implements IUnitOperationStep {
    id?: string;
    stepId?: string | undefined;
    unitOperationId?: string | undefined;
    unitId?: string | undefined;
    duration?: number | undefined;
    carbonFootprint?: number | undefined;
    isActive?: boolean | undefined;
    position?: number | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    roomSize?: number | undefined;
    createdByPerson?: Person;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;

    constructor(data?: IUnitOperationStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.unitOperationId = _data["unitOperationId"];
            this.unitId = _data["unitId"];
            this.duration = _data["duration"];
            this.carbonFootprint = _data["carbonFootprint"];
            this.isActive = _data["isActive"];
            this.position = _data["position"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.roomSize = _data["roomSize"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.unitOperation = _data["unitOperation"] ? UnitOperation.fromJS(_data["unitOperation"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): UnitOperationStep {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOperationStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["unitOperationId"] = this.unitOperationId;
        data["unitId"] = this.unitId;
        data["duration"] = this.duration;
        data["carbonFootprint"] = this.carbonFootprint;
        data["isActive"] = this.isActive;
        data["position"] = this.position;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["roomSize"] = this.roomSize;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["unitOperation"] = this.unitOperation ? this.unitOperation.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IUnitOperationStep {
    id?: string;
    stepId?: string | undefined;
    unitOperationId?: string | undefined;
    unitId?: string | undefined;
    duration?: number | undefined;
    carbonFootprint?: number | undefined;
    isActive?: boolean | undefined;
    position?: number | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    roomSize?: number | undefined;
    createdByPerson?: Person;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;
}

export class UnitType implements IUnitType {
    id?: string;
    unitTypeName?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    emissionFactors?: EmissionFactors[] | undefined;
    unit?: Unit[] | undefined;
    updatedByPerson?: Person;

    constructor(data?: IUnitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitTypeName = _data["unitTypeName"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["emissionFactors"])) {
                this.emissionFactors = [] as any;
                for (let item of _data["emissionFactors"])
                    this.emissionFactors!.push(EmissionFactors.fromJS(item));
            }
            if (Array.isArray(_data["unit"])) {
                this.unit = [] as any;
                for (let item of _data["unit"])
                    this.unit!.push(Unit.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): UnitType {
        data = typeof data === 'object' ? data : {};
        let result = new UnitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitTypeName"] = this.unitTypeName;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.emissionFactors)) {
            data["emissionFactors"] = [];
            for (let item of this.emissionFactors)
                data["emissionFactors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unit)) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IUnitType {
    id?: string;
    unitTypeName?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    emissionFactors?: EmissionFactors[] | undefined;
    unit?: Unit[] | undefined;
    updatedByPerson?: Person;
}

export class UserClientEntity implements IUserClientEntity {
    id?: string;
    personId?: string;
    clientId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    client?: Client;
    createdByPerson?: Person;
    person?: Person;
    updatedByPerson?: Person;

    constructor(data?: IUserClientEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.clientId = _data["clientId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserClientEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserClientEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["clientId"] = this.clientId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserClientEntity {
    id?: string;
    personId?: string;
    clientId?: string;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    client?: Client;
    createdByPerson?: Person;
    person?: Person;
    updatedByPerson?: Person;
}

export class UserThemeSelection implements IUserThemeSelection {
    id?: string;
    userId?: string;
    themeId?: string;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    theme?: TemplateUI;
    updatedByPerson?: Person;
    user?: Person;

    constructor(data?: IUserThemeSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.themeId = _data["themeId"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.theme = _data["theme"] ? TemplateUI.fromJS(_data["theme"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.user = _data["user"] ? Person.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserThemeSelection {
        data = typeof data === 'object' ? data : {};
        let result = new UserThemeSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["themeId"] = this.themeId;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserThemeSelection {
    id?: string;
    userId?: string;
    themeId?: string;
    isActive?: boolean;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedTimestamp?: Date | undefined;
    createdByPerson?: Person;
    theme?: TemplateUI;
    updatedByPerson?: Person;
    user?: Person;
}

export class UserType implements IUserType {
    id?: string;
    userTypeName?: string | undefined;
    definition?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    person?: Person[] | undefined;
    updatedByPerson?: Person;
    userTypeScreen?: UserTypeScreen[] | undefined;
    userUserType?: UserUserType[] | undefined;

    constructor(data?: IUserType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userTypeName = _data["userTypeName"];
            this.definition = _data["definition"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["person"])) {
                this.person = [] as any;
                for (let item of _data["person"])
                    this.person!.push(Person.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["userTypeScreen"])) {
                this.userTypeScreen = [] as any;
                for (let item of _data["userTypeScreen"])
                    this.userTypeScreen!.push(UserTypeScreen.fromJS(item));
            }
            if (Array.isArray(_data["userUserType"])) {
                this.userUserType = [] as any;
                for (let item of _data["userUserType"])
                    this.userUserType!.push(UserUserType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserType {
        data = typeof data === 'object' ? data : {};
        let result = new UserType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userTypeName"] = this.userTypeName;
        data["definition"] = this.definition;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.person)) {
            data["person"] = [];
            for (let item of this.person)
                data["person"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.userTypeScreen)) {
            data["userTypeScreen"] = [];
            for (let item of this.userTypeScreen)
                data["userTypeScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userUserType)) {
            data["userUserType"] = [];
            for (let item of this.userUserType)
                data["userUserType"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserType {
    id?: string;
    userTypeName?: string | undefined;
    definition?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    person?: Person[] | undefined;
    updatedByPerson?: Person;
    userTypeScreen?: UserTypeScreen[] | undefined;
    userUserType?: UserUserType[] | undefined;
}

export class UserTypeScreen implements IUserTypeScreen {
    id?: string;
    userTypeId?: string | undefined;
    screenId?: string | undefined;
    accessType?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    screen?: Screen;
    updatedByPerson?: Person;
    userType?: UserType;

    constructor(data?: IUserTypeScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userTypeId = _data["userTypeId"];
            this.screenId = _data["screenId"];
            this.accessType = _data["accessType"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserTypeScreen {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userTypeId"] = this.userTypeId;
        data["screenId"] = this.screenId;
        data["accessType"] = this.accessType;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["userType"] = this.userType ? this.userType.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserTypeScreen {
    id?: string;
    userTypeId?: string | undefined;
    screenId?: string | undefined;
    accessType?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimestamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimestamp?: Date | undefined;
    isActive?: boolean | undefined;
    createdByPerson?: Person;
    screen?: Screen;
    updatedByPerson?: Person;
    userType?: UserType;
}

export class UserUserType implements IUserUserType {
    id?: string;
    userId?: string;
    userTypeId?: string;
    user?: Person;
    userType?: UserType;

    constructor(data?: IUserUserType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userTypeId = _data["userTypeId"];
            this.user = _data["user"] ? Person.fromJS(_data["user"]) : undefined as any;
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserUserType {
        data = typeof data === 'object' ? data : {};
        let result = new UserUserType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userTypeId"] = this.userTypeId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["userType"] = this.userType ? this.userType.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserUserType {
    id?: string;
    userId?: string;
    userTypeId?: string;
    user?: Person;
    userType?: UserType;
}

export class Utilities implements IUtilities {
    id?: string;
    stepId?: string;
    cleanRoomId?: string | undefined;
    roomArea?: number | undefined;
    totalStepDuration?: number | undefined;
    notes?: string | undefined;
    hvacRequired?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    wfiId?: string | undefined;
    isColdStorage?: boolean | undefined;
    facilityTypeId?: string | undefined;
    coldStorageId?: string | undefined;
    storageTime?: number | undefined;
    unitId?: string | undefined;
    locationId?: string | undefined;
    generalInformationId?: string | undefined;
    cleanRoom?: HVACClass;
    createdByPerson?: Person;
    facilityType?: ISOClassFacilityType;
    generalInformation?: GeneralInformation;
    step?: Step;
    unit?: Unit;
    updatedByPerson?: Person;
    utilitiesEnergyConsumption?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;
    utilitiesSteamConsumption?: UtilitiesSteamConsumption[] | undefined;

    constructor(data?: IUtilities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.cleanRoomId = _data["cleanRoomId"];
            this.roomArea = _data["roomArea"];
            this.totalStepDuration = _data["totalStepDuration"];
            this.notes = _data["notes"];
            this.hvacRequired = _data["hvacRequired"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.wfiId = _data["wfiId"];
            this.isColdStorage = _data["isColdStorage"];
            this.facilityTypeId = _data["facilityTypeId"];
            this.coldStorageId = _data["coldStorageId"];
            this.storageTime = _data["storageTime"];
            this.unitId = _data["unitId"];
            this.locationId = _data["locationId"];
            this.generalInformationId = _data["generalInformationId"];
            this.cleanRoom = _data["cleanRoom"] ? HVACClass.fromJS(_data["cleanRoom"]) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.facilityType = _data["facilityType"] ? ISOClassFacilityType.fromJS(_data["facilityType"]) : undefined as any;
            this.generalInformation = _data["generalInformation"] ? GeneralInformation.fromJS(_data["generalInformation"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["utilitiesEnergyConsumption"])) {
                this.utilitiesEnergyConsumption = [] as any;
                for (let item of _data["utilitiesEnergyConsumption"])
                    this.utilitiesEnergyConsumption!.push(UtilitiesEnergyConsumption.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesProcessingOperation"])) {
                this.utilitiesProcessingOperation = [] as any;
                for (let item of _data["utilitiesProcessingOperation"])
                    this.utilitiesProcessingOperation!.push(UtilitiesProcessingOperation.fromJS(item));
            }
            if (Array.isArray(_data["utilitiesSteamConsumption"])) {
                this.utilitiesSteamConsumption = [] as any;
                for (let item of _data["utilitiesSteamConsumption"])
                    this.utilitiesSteamConsumption!.push(UtilitiesSteamConsumption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Utilities {
        data = typeof data === 'object' ? data : {};
        let result = new Utilities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["cleanRoomId"] = this.cleanRoomId;
        data["roomArea"] = this.roomArea;
        data["totalStepDuration"] = this.totalStepDuration;
        data["notes"] = this.notes;
        data["hvacRequired"] = this.hvacRequired;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["wfiId"] = this.wfiId;
        data["isColdStorage"] = this.isColdStorage;
        data["facilityTypeId"] = this.facilityTypeId;
        data["coldStorageId"] = this.coldStorageId;
        data["storageTime"] = this.storageTime;
        data["unitId"] = this.unitId;
        data["locationId"] = this.locationId;
        data["generalInformationId"] = this.generalInformationId;
        data["cleanRoom"] = this.cleanRoom ? this.cleanRoom.toJSON() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["facilityType"] = this.facilityType ? this.facilityType.toJSON() : undefined as any;
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.utilitiesEnergyConsumption)) {
            data["utilitiesEnergyConsumption"] = [];
            for (let item of this.utilitiesEnergyConsumption)
                data["utilitiesEnergyConsumption"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesProcessingOperation)) {
            data["utilitiesProcessingOperation"] = [];
            for (let item of this.utilitiesProcessingOperation)
                data["utilitiesProcessingOperation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.utilitiesSteamConsumption)) {
            data["utilitiesSteamConsumption"] = [];
            for (let item of this.utilitiesSteamConsumption)
                data["utilitiesSteamConsumption"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUtilities {
    id?: string;
    stepId?: string;
    cleanRoomId?: string | undefined;
    roomArea?: number | undefined;
    totalStepDuration?: number | undefined;
    notes?: string | undefined;
    hvacRequired?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    wfiId?: string | undefined;
    isColdStorage?: boolean | undefined;
    facilityTypeId?: string | undefined;
    coldStorageId?: string | undefined;
    storageTime?: number | undefined;
    unitId?: string | undefined;
    locationId?: string | undefined;
    generalInformationId?: string | undefined;
    cleanRoom?: HVACClass;
    createdByPerson?: Person;
    facilityType?: ISOClassFacilityType;
    generalInformation?: GeneralInformation;
    step?: Step;
    unit?: Unit;
    updatedByPerson?: Person;
    utilitiesEnergyConsumption?: UtilitiesEnergyConsumption[] | undefined;
    utilitiesProcessingOperation?: UtilitiesProcessingOperation[] | undefined;
    utilitiesSteamConsumption?: UtilitiesSteamConsumption[] | undefined;
}

export class UtilitiesEnergyConsumption implements IUtilitiesEnergyConsumption {
    id?: string;
    stepId?: string;
    gridAverageMix?: number | undefined;
    gridGreenTariff?: number | undefined;
    solar?: number | undefined;
    wind?: number | undefined;
    onSiteHydro?: number | undefined;
    onSiteBiomass?: number | undefined;
    utilitiesId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    renewable?: number | undefined;
    createdByPerson?: Person;
    step?: Step;
    updatedByPerson?: Person;
    utilities?: Utilities;

    constructor(data?: IUtilitiesEnergyConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.gridAverageMix = _data["gridAverageMix"];
            this.gridGreenTariff = _data["gridGreenTariff"];
            this.solar = _data["solar"];
            this.wind = _data["wind"];
            this.onSiteHydro = _data["onSiteHydro"];
            this.onSiteBiomass = _data["onSiteBiomass"];
            this.utilitiesId = _data["utilitiesId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.renewable = _data["renewable"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.utilities = _data["utilities"] ? Utilities.fromJS(_data["utilities"]) : undefined as any;
        }
    }

    static fromJS(data: any): UtilitiesEnergyConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new UtilitiesEnergyConsumption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["gridAverageMix"] = this.gridAverageMix;
        data["gridGreenTariff"] = this.gridGreenTariff;
        data["solar"] = this.solar;
        data["wind"] = this.wind;
        data["onSiteHydro"] = this.onSiteHydro;
        data["onSiteBiomass"] = this.onSiteBiomass;
        data["utilitiesId"] = this.utilitiesId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["renewable"] = this.renewable;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["utilities"] = this.utilities ? this.utilities.toJSON() : undefined as any;
        return data;
    }
}

export interface IUtilitiesEnergyConsumption {
    id?: string;
    stepId?: string;
    gridAverageMix?: number | undefined;
    gridGreenTariff?: number | undefined;
    solar?: number | undefined;
    wind?: number | undefined;
    onSiteHydro?: number | undefined;
    onSiteBiomass?: number | undefined;
    utilitiesId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    renewable?: number | undefined;
    createdByPerson?: Person;
    step?: Step;
    updatedByPerson?: Person;
    utilities?: Utilities;
}

export class UtilitiesProcessingOperation implements IUtilitiesProcessingOperation {
    id?: string;
    stepId?: string;
    unitOperationId?: string | undefined;
    unitId?: string | undefined;
    duration?: number | undefined;
    utilitiesId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    carbonFootprint?: number | undefined;
    createdByPerson?: Person;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;
    utilities?: Utilities;

    constructor(data?: IUtilitiesProcessingOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.unitOperationId = _data["unitOperationId"];
            this.unitId = _data["unitId"];
            this.duration = _data["duration"];
            this.utilitiesId = _data["utilitiesId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.carbonFootprint = _data["carbonFootprint"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
            this.unitOperation = _data["unitOperation"] ? UnitOperation.fromJS(_data["unitOperation"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.utilities = _data["utilities"] ? Utilities.fromJS(_data["utilities"]) : undefined as any;
        }
    }

    static fromJS(data: any): UtilitiesProcessingOperation {
        data = typeof data === 'object' ? data : {};
        let result = new UtilitiesProcessingOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["unitOperationId"] = this.unitOperationId;
        data["unitId"] = this.unitId;
        data["duration"] = this.duration;
        data["utilitiesId"] = this.utilitiesId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["carbonFootprint"] = this.carbonFootprint;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["unitOperation"] = this.unitOperation ? this.unitOperation.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["utilities"] = this.utilities ? this.utilities.toJSON() : undefined as any;
        return data;
    }
}

export interface IUtilitiesProcessingOperation {
    id?: string;
    stepId?: string;
    unitOperationId?: string | undefined;
    unitId?: string | undefined;
    duration?: number | undefined;
    utilitiesId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    carbonFootprint?: number | undefined;
    createdByPerson?: Person;
    step?: Step;
    unit?: Unit;
    unitOperation?: UnitOperation;
    updatedByPerson?: Person;
    utilities?: Utilities;
}

export class UtilitiesSteamConsumption implements IUtilitiesSteamConsumption {
    id?: string;
    stepId?: string;
    naturalGas?: number | undefined;
    coal?: number | undefined;
    diesel?: number | undefined;
    biomass?: number | undefined;
    utilitiesId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    step?: Step;
    updatedByPerson?: Person;
    utilities?: Utilities;

    constructor(data?: IUtilitiesSteamConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepId = _data["stepId"];
            this.naturalGas = _data["naturalGas"];
            this.coal = _data["coal"];
            this.diesel = _data["diesel"];
            this.biomass = _data["biomass"];
            this.utilitiesId = _data["utilitiesId"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.step = _data["step"] ? Step.fromJS(_data["step"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.utilities = _data["utilities"] ? Utilities.fromJS(_data["utilities"]) : undefined as any;
        }
    }

    static fromJS(data: any): UtilitiesSteamConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new UtilitiesSteamConsumption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepId"] = this.stepId;
        data["naturalGas"] = this.naturalGas;
        data["coal"] = this.coal;
        data["diesel"] = this.diesel;
        data["biomass"] = this.biomass;
        data["utilitiesId"] = this.utilitiesId;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["step"] = this.step ? this.step.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["utilities"] = this.utilities ? this.utilities.toJSON() : undefined as any;
        return data;
    }
}

export interface IUtilitiesSteamConsumption {
    id?: string;
    stepId?: string;
    naturalGas?: number | undefined;
    coal?: number | undefined;
    diesel?: number | undefined;
    biomass?: number | undefined;
    utilitiesId?: string | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    createdByPerson?: Person;
    step?: Step;
    updatedByPerson?: Person;
    utilities?: Utilities;
}

export class WasteDisposalRoute implements IWasteDisposalRoute {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    screenId?: string | undefined;
    createdByPerson?: Person;
    screen?: Screen;
    updatedByPerson?: Person;

    constructor(data?: IWasteDisposalRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wasteTypeName = _data["wasteTypeName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.screenId = _data["screenId"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.screen = _data["screen"] ? Screen.fromJS(_data["screen"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
        }
    }

    static fromJS(data: any): WasteDisposalRoute {
        data = typeof data === 'object' ? data : {};
        let result = new WasteDisposalRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wasteTypeName"] = this.wasteTypeName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["screenId"] = this.screenId;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        return data;
    }
}

export interface IWasteDisposalRoute {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    screenId?: string | undefined;
    createdByPerson?: Person;
    screen?: Screen;
    updatedByPerson?: Person;
}

export class WasteDisposalType implements IWasteDisposalType {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    createdByPerson?: Person;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    updatedByPerson?: Person;
    wasteTypeEmissionFactor?: WasteTypeEmissionFactor[] | undefined;

    constructor(data?: IWasteDisposalType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wasteTypeName = _data["wasteTypeName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["materialEmissionFactor"])) {
                this.materialEmissionFactor = [] as any;
                for (let item of _data["materialEmissionFactor"])
                    this.materialEmissionFactor!.push(MaterialEmissionFactor.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["wasteTypeEmissionFactor"])) {
                this.wasteTypeEmissionFactor = [] as any;
                for (let item of _data["wasteTypeEmissionFactor"])
                    this.wasteTypeEmissionFactor!.push(WasteTypeEmissionFactor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WasteDisposalType {
        data = typeof data === 'object' ? data : {};
        let result = new WasteDisposalType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wasteTypeName"] = this.wasteTypeName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.materialEmissionFactor)) {
            data["materialEmissionFactor"] = [];
            for (let item of this.materialEmissionFactor)
                data["materialEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.wasteTypeEmissionFactor)) {
            data["wasteTypeEmissionFactor"] = [];
            for (let item of this.wasteTypeEmissionFactor)
                data["wasteTypeEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWasteDisposalType {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    createdByPerson?: Person;
    materialEmissionFactor?: MaterialEmissionFactor[] | undefined;
    updatedByPerson?: Person;
    wasteTypeEmissionFactor?: WasteTypeEmissionFactor[] | undefined;
}

export class WasteType implements IWasteType {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    orderBy?: number | undefined;
    screenId?: string | undefined;
    consumerEolMaterialDefault?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    updatedByPerson?: Person;
    wasteTypeEmissionFactor?: WasteTypeEmissionFactor[] | undefined;

    constructor(data?: IWasteType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wasteTypeName = _data["wasteTypeName"];
            this.isActive = _data["isActive"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.createdTimeStamp = _data["createdTimeStamp"] ? new Date(_data["createdTimeStamp"].toString()) : undefined as any;
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.updatedTimeStamp = _data["updatedTimeStamp"] ? new Date(_data["updatedTimeStamp"].toString()) : undefined as any;
            this.orderBy = _data["orderBy"];
            this.screenId = _data["screenId"];
            if (Array.isArray(_data["consumerEolMaterialDefault"])) {
                this.consumerEolMaterialDefault = [] as any;
                for (let item of _data["consumerEolMaterialDefault"])
                    this.consumerEolMaterialDefault!.push(ConsumerEolMaterialDefault.fromJS(item));
            }
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            if (Array.isArray(_data["processWasteDetail"])) {
                this.processWasteDetail = [] as any;
                for (let item of _data["processWasteDetail"])
                    this.processWasteDetail!.push(ProcessWasteDetail.fromJS(item));
            }
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            if (Array.isArray(_data["wasteTypeEmissionFactor"])) {
                this.wasteTypeEmissionFactor = [] as any;
                for (let item of _data["wasteTypeEmissionFactor"])
                    this.wasteTypeEmissionFactor!.push(WasteTypeEmissionFactor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WasteType {
        data = typeof data === 'object' ? data : {};
        let result = new WasteType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wasteTypeName"] = this.wasteTypeName;
        data["isActive"] = this.isActive;
        data["createdByPersonId"] = this.createdByPersonId;
        data["createdTimeStamp"] = this.createdTimeStamp ? this.createdTimeStamp.toISOString() : undefined as any;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["updatedTimeStamp"] = this.updatedTimeStamp ? this.updatedTimeStamp.toISOString() : undefined as any;
        data["orderBy"] = this.orderBy;
        data["screenId"] = this.screenId;
        if (Array.isArray(this.consumerEolMaterialDefault)) {
            data["consumerEolMaterialDefault"] = [];
            for (let item of this.consumerEolMaterialDefault)
                data["consumerEolMaterialDefault"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.processWasteDetail)) {
            data["processWasteDetail"] = [];
            for (let item of this.processWasteDetail)
                data["processWasteDetail"].push(item ? item.toJSON() : undefined as any);
        }
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        if (Array.isArray(this.wasteTypeEmissionFactor)) {
            data["wasteTypeEmissionFactor"] = [];
            for (let item of this.wasteTypeEmissionFactor)
                data["wasteTypeEmissionFactor"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWasteType {
    id?: string;
    wasteTypeName?: string | undefined;
    isActive?: boolean | undefined;
    createdByPersonId?: string | undefined;
    createdTimeStamp?: Date | undefined;
    updatedByPersonId?: string | undefined;
    updatedTimeStamp?: Date | undefined;
    orderBy?: number | undefined;
    screenId?: string | undefined;
    consumerEolMaterialDefault?: ConsumerEolMaterialDefault[] | undefined;
    createdByPerson?: Person;
    processWasteDetail?: ProcessWasteDetail[] | undefined;
    updatedByPerson?: Person;
    wasteTypeEmissionFactor?: WasteTypeEmissionFactor[] | undefined;
}

export class WasteTypeEmissionFactor implements IWasteTypeEmissionFactor {
    id?: string;
    wasteTypeId?: string;
    wasteDisposalTypeId?: string;
    emissionFactorId?: string;
    factor?: number;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    updatedByPerson?: Person;
    wasteDisposalType?: WasteDisposalType;
    wasteType?: WasteType;

    constructor(data?: IWasteTypeEmissionFactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wasteTypeId = _data["wasteTypeId"];
            this.wasteDisposalTypeId = _data["wasteDisposalTypeId"];
            this.emissionFactorId = _data["emissionFactorId"];
            this.factor = _data["factor"];
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : undefined as any;
            this.updatedTimestamp = _data["updatedTimestamp"] ? new Date(_data["updatedTimestamp"].toString()) : undefined as any;
            this.dataQualityScore = _data["dataQualityScore"];
            this.isActive = _data["isActive"];
            this.createdByPerson = _data["createdByPerson"] ? Person.fromJS(_data["createdByPerson"]) : undefined as any;
            this.emissionFactor = _data["emissionFactor"] ? EmissionFactors.fromJS(_data["emissionFactor"]) : undefined as any;
            this.updatedByPerson = _data["updatedByPerson"] ? Person.fromJS(_data["updatedByPerson"]) : undefined as any;
            this.wasteDisposalType = _data["wasteDisposalType"] ? WasteDisposalType.fromJS(_data["wasteDisposalType"]) : undefined as any;
            this.wasteType = _data["wasteType"] ? WasteType.fromJS(_data["wasteType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WasteTypeEmissionFactor {
        data = typeof data === 'object' ? data : {};
        let result = new WasteTypeEmissionFactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wasteTypeId"] = this.wasteTypeId;
        data["wasteDisposalTypeId"] = this.wasteDisposalTypeId;
        data["emissionFactorId"] = this.emissionFactorId;
        data["factor"] = this.factor;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : undefined as any;
        data["updatedTimestamp"] = this.updatedTimestamp ? this.updatedTimestamp.toISOString() : undefined as any;
        data["dataQualityScore"] = this.dataQualityScore;
        data["isActive"] = this.isActive;
        data["createdByPerson"] = this.createdByPerson ? this.createdByPerson.toJSON() : undefined as any;
        data["emissionFactor"] = this.emissionFactor ? this.emissionFactor.toJSON() : undefined as any;
        data["updatedByPerson"] = this.updatedByPerson ? this.updatedByPerson.toJSON() : undefined as any;
        data["wasteDisposalType"] = this.wasteDisposalType ? this.wasteDisposalType.toJSON() : undefined as any;
        data["wasteType"] = this.wasteType ? this.wasteType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWasteTypeEmissionFactor {
    id?: string;
    wasteTypeId?: string;
    wasteDisposalTypeId?: string;
    emissionFactorId?: string;
    factor?: number;
    createdByPersonId?: string;
    updatedByPersonId?: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    dataQualityScore?: number | undefined;
    isActive?: boolean;
    createdByPerson?: Person;
    emissionFactor?: EmissionFactors;
    updatedByPerson?: Person;
    wasteDisposalType?: WasteDisposalType;
    wasteType?: WasteType;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class APIException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isAPIException = true;

    static isAPIException(obj: any): obj is APIException {
        return obj.isAPIException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new APIException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

//prettier-ignore
//prettier-ignore
//prettier-ignore
//prettier-ignore
//prettier-ignore
//need a semi-colon here to prevent nswag generator from inserting other code and breaking the build
//without this ignore, prettier removes the semi-colon on save
//prettier-ignore

// auth0Client: Auth0Client